(function() {
    'use strict';

    angular
        .module('gatewayApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'as.sortable',
            'ds.clock',
            'camera',
            'chart.js',
            'angularMoment',
            'ngImgCrop'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TimecardManagementDetailController', TimecardManagementDetailController);

    TimecardManagementDetailController.$inject = ['$scope','$stateParams', 'Timecard', 'User' , 'Group' , 'moment','AlertService', '$filter','TimezoneService','GroupOption'];

    function TimecardManagementDetailController($scope,$stateParams, Timecard, User, Group, moment,AlertService, $filter,TimezoneService,GroupOption) {
        var vm = this;
        var regex = /^([01]\d|2[0-3]):?([0-5]\d)$/;
        var regex2 = /^([01]\d|2[0-3])([0-5]\d)$/;
        //add round function to momentjs
        moment.fn.round = function(precision, key, direction) {
            if(typeof direction === 'undefined') {
                direction = 'round';
            }

            var keys = ['Hours', 'Minutes', 'Seconds', 'Milliseconds'];
            var maxValues = [24, 60, 60, 1000];

            // Capitalize first letter
            key = key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();

            // make sure key is plural
            if (key.indexOf('s', key.length - 1) === -1) {
                key += 's';
            }
            var value = 0;
            var rounded = false;
            var subRatio = 1;
            var maxValue ;
            for (var i in keys) {
                var k = keys[i];
                if (k === key) {
                    value = this._d['get' + key]();
                    maxValue = maxValues[i];
                    rounded = true;
                } else if(rounded) {
                    subRatio *= maxValues[i];
                    value += this._d['get' + k]() / subRatio;
                    this._d['set' + k](0);
                }
            };

            value = Math[direction](value / precision) * precision;
            value = Math.min(value, maxValue);
            this._d['set' + key](value);

            return this;
        }

        moment.fn.ceil = function(precision, key) {
            return this.round(precision, key, 'ceil');
        }

        moment.fn.floor = function(precision, key) {
            return this.round(precision, key, 'floor');
        }
        //グループID
        vm.groupId = $stateParams.groupId;
        //ユーザーID
        vm.userId = $stateParams.userId;
        //ユーザー名
        vm.userName = $stateParams.userName;
        //当前用户是否已经被删除
        vm.deletedFlg = $stateParams.deletedFlg === 'true';
        //上一个页面的退職済checkbox的值
        vm.retiredFlg = $stateParams.retiredFlg === 'true';
        //年
        vm.currentYear = Number($stateParams.currentYear);
        //月
        vm.currentMonth = Number($stateParams.currentMonth);
        //月間勤務データ
        vm.data = [];
        //給与計算データを維持する
        vm.salary = {};
        vm.chartData = [];
        vm.chartLabel = [];
        vm.userTimecardList = [];
        vm.parentGroup = [];
        vm.groupOption = {};
        vm.loadParentGroup = loadParentGroup;
        //Group切换时，自动取得Staff
        vm.changeGroup = changeGroup;
        //页面加载后取得所有Group信息
        vm.loadParentGroup();
        vm.changeUser = changeUser;
        //月間勤務データを取得する
        vm.loadData = loadData;
        vm.loadUserTimecardData = loadUserTimecardData;
        //年月をレセット
        vm.rest = rest;
        //次月のデータを取得
        vm.nextMonth = nextMonth;
        //前月のデータを取得
        vm.beforeMonth = beforeMonth;
        //日間勤務時間を計算
        vm.workTimeCal = workTimeCal;
        //勤務実績を承認して、履歴として残す
        vm.saveHistory = saveHistory;
        //moment.durationをフォマットする
        vm.format = format;
        vm.durationHours = durationHours;
        //初期データのフォマット
        vm.initStartTime = initStartTime;
        //初期データのフォマット
        vm.initEndTime = initEndTime;
        //初期データのフォマット
        vm.initRestTime = initRestTime;
        //入力された開始時間をmommentに変換
        vm.StartTimeUpdate = StartTimeUpdate;
        //入力された終了時間をmommentに変換
        vm.EndTimeUpdate = EndTimeUpdate;
        vm.RestimeUpdate = RestimeUpdate;
        //vm.StartTimeCheck = StartTimeCheck;
        //vm.EndTimeCheck = EndTimeCheck;
        vm.reCalculate = reCalculate;
        vm.timezone = "+0900";

        //打刻データを最初表示する時点で丸め処理を行います
        function initStartTime(detail){
            var data =  moment(detail.startTime);
            if (data.isValid()){
                if (vm.groupOption.timeRound > 0) {
                    detail.startTime = data.ceil(vm.groupOption.timeRound,'minutes');
                } else {
                    detail.startTime = data;
                }
                detail.startTimeStr = $filter('date')(detail.startTime.toDate(),'HH:mm',vm.timezone);
                detail.startTimeError = false;
                detail.isDirty = false;
            }
            vm.reCalculate();
        }
        //打刻データを最初表示する時点で丸め処理を行います
        function initEndTime(detail){
            var data =  moment(detail.endTime);
            if (data.isValid()){
                if (vm.groupOption.timeRound > 0) {
                    detail.endTime = data.floor(vm.groupOption.timeRound,'minutes');
                } else {
                    detail.endTime = data;
                }
                //detail.endTime = data.floor(30,'minutes');
                detail.endTimeStr = $filter('date')(detail.endTime.toDate(),'HH:mm',vm.timezone);
                detail.endTimeError = false;
                detail.isDirty = false;
            }
            vm.reCalculate();
        }
        function initRestTime(detail) {
            var data = moment.duration(detail.restTime);
            if (data.isValid()) {
                detail.restTime = vm.format(data);
                detail.restTimeError = false;
            } else {
                detail.restTime = "";
                detail.restTimeError = false;
            }
            detail.isDirty = false;
        }
        //入力された打刻時刻をMomentに変換する
        function StartTimeUpdate(day,detail, index){
            detail.startTimeStr = $("#startTime"+index).val();
            if (detail.startTimeStr == null || detail.startTimeStr == "") {
                detail.startTimeError = false;
                detail.startTime = null;
            } else if (regex.test(detail.startTimeStr)) {
                if (regex2.test(detail.startTimeStr)) {
                    detail.startTimeStr = detail.startTimeStr.substr(0,2)+":"+detail.startTimeStr.substr(2,2);
                }
                var start = moment(day + " " + detail.startTimeStr);
                if (start.isValid()) {
                    if (vm.groupOption.timeRound > 0) {
                        detail.startTime = start.ceil(vm.groupOption.timeRound,'minutes');
                    } else {
                        detail.startTime = start;
                    }
                    //detail.startTime = start.ceil(30,'minutes');
                    detail.startTimeStr = detail.startTime.format("HH:mm");
                    detail.startTimeError = false;
                    //開始時間を変更しました
                    detail.isDirty = true;
                }  else {
                    detail.startTime = null;
                    detail.startTimeError = true;
                }
            } else {
                detail.startTimeStr = "";
                detail.startTime = null;
            }
            vm.reCalculate();
        }
        //入力された打刻時刻をMomentに変換する
        function EndTimeUpdate(day,detail, index) {
            detail.endTimeStr = $("#endTime"+index).val();
            if (detail.endTimeStr == null || detail.endTimeStr == "") {
                detail.endTime = null;
                detail.endTimeError = false;
            } else if (regex.test(detail.endTimeStr)) {
                if (regex2.test(detail.endTimeStr)) {
                    detail.endTimeStr = detail.endTimeStr.substr(0,2)+":"+detail.endTimeStr.substr(2,2);
                }
                var end = moment(day + " "+ detail.endTimeStr);
                var start = moment(detail.startTime);
                if (end.isBefore(start)) {
                    if (confirm("退勤時間は出勤時間より前に設定しましたが、日付をまたいで打刻しますか？")) {
                        detail.nextDay = true;
                        end = end.add(1,'days');
                    } else {
                        detail.endTimeStr = "";
                        detail.endTime = null;
                        detail.endTimeError = false;
                        return;
                    }
                }
                if (end.isValid()) {
                    if (vm.groupOption.timeRound > 0) {
                        detail.endTime = end.floor(vm.groupOption.timeRound,'minutes');
                    } else {
                        detail.endTime = end;
                    }
                    //detail.endTime = end.floor(30,'minutes');
                    detail.endTimeStr = detail.endTime.format("HH:mm");
                    detail.endTimeError = false;
                    //終了時間を変更しました
                    detail.isDirty = true;
                } else {
                    detail.endTime = null;
                    detail.endTimeError = true;
                }
            } else {
                detail.endTimeStr = "";
                detail.endTime = null;
            }
            vm.reCalculate();
        }

        function RestimeUpdate(day,detail, index){
            detail.restTime = $("#restTime"+index).val();
            if (detail.restTime == null || detail.restTime == "") {
                detail.restTimeError = false;
            } else if (regex.test(detail.restTime)) {
                if (regex2.test(detail.restTime)) {
                    detail.restTime = detail.restTime.substr(0,2)+":"+detail.restTime.substr(2,2);
                }
                var rest = moment.duration(detail.restTime);
                if (rest.isValid()) {
                    detail.restTimeError = false;
                    detail.isDirty = true;
                } else {
                    detail.restTimeError = true;
                }
            } else {
                detail.restTime = "";
            }
            vm.reCalculate();
        }

        /**
         * 期間を”HH:ss”ように変更する
         * @param duration
         * @returns {string}
         */
        function format(duration){
            if (angular.isDefined(duration) && duration.isValid() && duration.as('milliseconds') > 0) {
                var day = duration.days();
                var hours = duration.hours();
                var minutes = duration.minutes();
                return ((day * 24+hours) > 9 ?(day * 24+hours): "0" + (day * 24+hours) )+":"+(minutes > 9 ? minutes : "0"+minutes);
            }
            return "";
        }

        /**
         * 期間を34.5時間のように変更する
         * @param duration
         * @returns {*}
         */
        function durationHours(duration) {
            if (angular.isDefined(duration) && duration.isValid() && duration.as('milliseconds') > 0) {
                var day = duration.days();
                var hours = duration.hours();
                var minutes = duration.minutes();
                return day * 24 + hours + minutes / 60;
            }
            return 0;
        }

        /**
         * グループ情報をロードします
         */
        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                vm.loadData();
            });
        }

        /**
         * グループ情報を切り替えるとデータを再ロードします
         */
        function changeGroup() {
            vm.userId = null;
            vm.loadData();
        }

        /**
         * ユーザを切り替えると該当ユーザのタイムカードデータを再取得
         * @param userId
         * @param userName
         */
        function changeUser(userId,userName,deleted){
            //ユーザーID
            vm.userId = userId;
            //ユーザー名
            vm.userName = userName;

            vm.deletedFlg = deleted;

            vm.loadUserTimecardData();
        }

        /**
         * 月間勤務データを取得する
         */
        function loadData() {
            angular.forEach(vm.parentGroup,function(data,index,array){
                if (data.id === vm.groupId) {
                    vm.group = data;
                    vm.timezone = TimezoneService.getOffset(vm.group.timezone);
                    GroupOption.get({groupId:vm.groupId}, function(result){
                         vm.groupOption = result;
                         //console.log(vm.groupOption);
                    });
                }
            });

            const data = {'year': vm.currentYear, 'month': vm.currentMonth, 'groupId': vm.groupId, 'pageNumber': null, 'pageSize': null, 'deletedFlg': vm.retiredFlg};
            Timecard.queryMonth(data,function(result){
                vm.userTimecardList = result.users;
                if (vm.userId === null && result.users.length > 0) {
                    vm.userId = result.users[0].id;
                    vm.userName = result.users[0].userName;
                    vm.deletedFlg = result.users[0].deleted;
                }
                if(vm.userId != null){
                    vm.loadUserTimecardData();
                }

            },function(error){
                AlertService.error(error.data.message);
            });
        }

        /**
         * 指定されたユーザーの月間勤務データを取得する
         */
        function loadUserTimecardData() {
            var data = {'groupId':vm.groupId, 'userId':vm.userId, 'year':vm.currentYear, 'month':vm.currentMonth};
            Timecard.query(data, function(result) {
                vm.data = result;
                vm.salary = result.salaryDTO;
                vm.salary.workHourStr = moment.utc(moment.duration(vm.salary.workTime).as('milliseconds')).format("HH:mm");
            },function(error){
                AlertService.error(error.data.message);
            });
        }

        /**
         * 年月をレセット
         */
        function rest() {
            vm.currentYear = new Date().getFullYear();
            vm.currentMonth = new Date().getMonth()+1;
            vm.loadUserTimecardData();
        }

        /**
         * 次月のデータを取得
         */
        function nextMonth() {
            if (vm.currentMonth === 12) {
                vm.currentMonth = 1;
                vm.currentYear = vm.currentYear + 1;
            } else {
                vm.currentMonth += 1;
            }
            vm.loadData();
        }

        /**
         * 前月のデータを取得
         */
        function beforeMonth() {
            if (vm.currentMonth === 1) {
                vm.currentMonth = 12;
                vm.currentYear -= 1;
            } else {
                vm.currentMonth -= 1;
            }
            vm.loadData();
        }

        /**
         * 日間勤務期間を計算
         * 1.出勤時間、退勤時間と休憩時間を取得
         * 2.夜勤かどうかを判別する、夜勤の場合は、退勤時間は１日Plus
         * 3.夜勤の場合は深夜作業時間を計算
         * 4.勤務時間を計算
         * ★お客さん要望
         * 法定通り（６時間以下休憩不要、６時間越え８時間以下、45分以上、８時間越え６０分以上）ですが、
         * 本人が６時間でも１時間の休憩をとることがあるため、申告制でお願いしたいです。
         * 深夜勤務時間は、22時から翌5時までです。
         * detail.startTime 出勤時間
         * detail.endTime 　退勤時間
         * detail.restTime  休憩時間
         * detail.nextDay  日付をまたいで打刻
         * detail.midNight 深夜作業あるフラグ
         * detail.midNightTime 22:00から05:00までの作業時間
         * detail.overtime 　普通残業時間
         * detail.overtimeNight 深夜残業時間
         * @param detail 勤務データ
         * @returns {*}
         */
        function workTimeCal(day,detail) {
            if (detail.startTime === null || detail.endTime === null) {
                detail.nextDay = false;
                detail.midNight = false;
                detail.midNightTime = moment.duration(0);
                detail.workTime = moment.duration(0);
                detail.overtime = Number(0);
                detail.overtimeNight = Number(0);
                return;
            }
            var start = moment(detail.startTime);
            var end = moment(detail.endTime);
            var rest = moment.duration(detail.restTime);
            if (!start.isValid() || !end.isValid()) {
                detail.nextDay = false;
                detail.midNight = false;
                detail.midNightTime = moment.duration(0);
                detail.workTime = moment.duration(0);
                detail.overtime = Number(0);
                detail.overtimeNight = Number(0);
                return;
            }
            //本日の22:00から次の日の05:00まで深夜時間帯です
            var nightStart = moment(day + " 22:00");
            var nightEnd = moment(day + " 05:00").add(1,'days');
            if (end.isAfter(nightStart)) {
                if (start.isAfter(nightStart)) {
                    nightStart = start;
                }
                if (end.isAfter(nightStart) && end.isBefore(nightEnd)){
                    nightEnd = end;
                }
                //22:00〜5:00　作業時間を計算
                var diff =  moment.duration(nightEnd.diff(nightStart));
                if (diff.asMilliseconds() > 0) {
                    detail.midNight = true;
                    detail.midNightTime = diff;
                    if (detail.restTimeCalculate === 1) {
                        //六時間超えと一時間休憩になります
                        var hours = detail.midNightTime.asHours();
                        if (hours >= 6) {
                            detail.midNightTime = detail.midNightTime.add(-1,"hours");
                        }
                    } else if (detail.restTimeCalculate === 2) {
                        //var restData = detail.
                        if (angular.isDefined(detail.restTimeInMiddleNight) && detail.restTimeInMiddleNight !== null && detail.isDirty === false) {
                            console.log("外出・再入時間から休憩時間へ反映する");
                            detail.midNightTime = moment.duration(detail.restTimeInMiddleNight);
                        } else {
                            console.log("["+ day + "] "+detail.startTimeStr + "-" + detail.endTimeStr + ":入力した時間から休憩時間を算出する、６時間以上であれば１時間休憩になります");
                            //六時間超えと一時間休憩になります
                            var hours = detail.midNightTime.asHours();
                            if (hours >= 6) {
                                detail.midNightTime = detail.midNightTime.add(-1,"hours");
                            }
                        }
                    }
                } else {
                    detail.midNight = false;
                    detail.midNightTime = moment.duration(0);
                }
            }
            //勤務時間を計算
            var span = moment.duration(end.diff(start)).subtract(rest);
            if (span.isValid()) {
                detail.workTime = span;
                //console.log("勤務時間計算終了："+detail.workTime);
                //普通残業と深夜残業を計算
                var overtime = span.asMilliseconds() - 8 * 3600000;
                if (overtime > 0) {//８時間以上超えたら
                    var start2 = start.add(8,'hours');
                    var nightStart2 = moment(day + " 22:00");
                    var nightEnd2 = moment(day + " 05:00").add(1,'days');
                    if (start2.isBefore(nightStart2) && end.isBefore(nightStart2)) {
                        detail.overtime = vm.durationHours(moment.duration(overtime));
                        detail.overtimeNight = Number(0);
                    } else if (start2.isBefore(nightStart2) && end.isAfter(nightStart2) && end.isBefore(nightEnd2)) {
                        var diff2 = moment.duration(nightStart2.diff(start2));
                        detail.overtime = vm.durationHours(diff2);
                        var diff3 = moment.duration(end.diff(nightStart2));
                        detail.overtimeNight = vm.durationHours(diff3);
                    } else if (start2.isBefore(nightStart2) && end.isAfter(nightEnd2)) {
                        var diff4 = moment.duration(nightEnd2.diff(nightStart2));
                        detail.overtimeNight = vm.durationHours(diff4);
                        var diff7 = moment.duration(overtime - diff4.asMilliseconds());
                        detail.overtime = vm.durationHours(diff7);
                    } else if ((start2.isAfter(nightStart2) || start2.isSame(nightStart2)) && start2.isBefore(nightEnd2) && end.isBefore(nightEnd2)) {
                        var diff5 = moment.duration(end.diff(start2));
                        detail.overtimeNight = vm.durationHours(diff5);
                        detail.overtime = Number(0);
                    } else if ((start2.isAfter(nightStart2) || start2.isSame(nightStart2)) && start2.isBefore(nightEnd2) && end.isAfter(nightEnd2)) {
                        var diff5 = moment.duration(nightEnd2.diff(start2));
                        detail.overtimeNight = vm.durationHours(diff5);
                        var diff6 = moment.duration(end.diff(nightEnd2));
                        detail.overtime = vm.durationHours(diff6);
                    } else if (start2.isAfter(nightEnd2)) {
                        detail.overtime = vm.durationHours(moment.duration(overtime));
                        detail.overtimeNight = Number(0);
                    }
                } else {
                    detail.overtime = Number(0);
                    detail.overtimeNight = Number(0);
                }
                return;
            } else {
                detail.workTime = moment.duration(0);
                detail.overtime = Number(0);
                detail.overtimeNight = Number(0);
                return;
            }
        }

        /**
         * 給与関連計算を再実行する
         */
        function reCalculate() {
            vm.salary.days = Number(0);
            vm.salary.workTime = moment.duration(0);
            vm.salary.nightTime = moment.duration(0);
            vm.salary.midNightTimeHours = Number(0);
            vm.salary.busFee = Number(0);
            vm.salary.overtime = Number(0);
            vm.salary.overtimeNight = Number(0);
            if (angular.isDefined(vm.data.detail)) {
                vm.data.detail.forEach(function(item){
                    vm.workTimeCal(item.day,item.workTimeDetail);
                    if (angular.isDefined(item.workTimeDetail.workTime) && item.workTimeDetail.workTime.isValid() && item.workTimeDetail.workTime.as('milliseconds') > 0) {
                        vm.salary.days += 1;
                        vm.salary.workTime = moment.duration(vm.salary.workTime.as('milliseconds') + item.workTimeDetail.workTime.as('milliseconds'),'milliseconds');
                        if (angular.isDefined(item.workTimeDetail.busFee)) {
                            vm.salary.busFee += Number(item.workTimeDetail.busFee);
                        }
                        if (angular.isDefined(item.workTimeDetail.midNightTime)) {
                            vm.salary.nightTime =  moment.duration(vm.salary.nightTime.as('milliseconds') + item.workTimeDetail.midNightTime.as('milliseconds'),'milliseconds');
                        }
                        if (angular.isDefined(item.workTimeDetail.overtime)) {
                            vm.salary.overtime += Number(item.workTimeDetail.overtime);
                        }
                        if (angular.isDefined(item.workTimeDetail.overtimeNight)) {
                            vm.salary.overtimeNight += Number(item.workTimeDetail.overtimeNight);
                        }
                    }
                });
            }
            vm.salary.workHours = vm.durationHours(vm.salary.workTime);
            vm.salary.workHourStr = vm.format(vm.salary.workTime);
            vm.salary.midNightTimeHours = vm.durationHours(vm.salary.nightTime);
            vm.salary.midNightTimeHourStr = vm.format(vm.salary.nightTime);
            vm.salary.overtime = Math.round(vm.salary.overtime * 100) /100;
            vm.salary.overtimeNight = Math.round(vm.salary.overtimeNight * 100)/100;
            /**
             * 基本給を計算
             * 基本給＝時給額＊勤務時間
             */
            vm.salary.hourSalary = Math.round(vm.data.salary * vm.salary.workHours);
            /**
             * 深夜勤務手当を計算
             * 深夜勤務時間＊時給金額＊0.25
             * 0.25は基本的に固定です。
             */
            vm.salary.nightSalary = Math.round(vm.salary.midNightTimeHours  * vm.data.salary * 0.25);
            /**
             * 勤務手当を計算
             * 深夜勤務時間＊勤務手当＊0.25
             */
            vm.salary.extraSalary = Math.round(vm.salary.workHours * vm.data.extraPay + vm.salary.midNightTimeHours * vm.data.extraPay * 0.25);
            /**
             * 支払い合計を計算
             * 給与額＝基本給＋時間外金額合計＋交通費
             */
            vm.salary.totalSalary = vm.salary.hourSalary + vm.salary.busFee + vm.salary.extraSalary + vm.salary.nightSalary;
        }

        /**
         * 勤務実績を承認して、履歴として残す
         */
        function saveHistory() {
            var saveFlag = true;
            vm.data.detail.forEach(function(detail){
                //同一条数据，出勤時間或者退社時間有一个为空的时候提示
                if((detail.workTimeDetail.startTime == null && detail.workTimeDetail.endTime != null) ||
                    (detail.workTimeDetail.startTime != null && detail.workTimeDetail.endTime == null)){
                    detail.workTimeDetail.startTime == null ? detail.workTimeDetail.startTimeEmptyError = true : detail.workTimeDetail.startTimeEmptyError = false;
                    detail.workTimeDetail.endTime == null ? detail.workTimeDetail.endTimeEmptyError = true : detail.workTimeDetail.endTimeEmptyError = false;
                    saveFlag = false;
                }
            });
            if(saveFlag){
                save();
            }else {
                if (confirm("出勤時間や退勤時間を未入力のまま、保存しても大丈夫でしょうか？")) {
                    save();
                }else {
                    return false;
                }
            }
        }

        function save() {
            var params = {
                "groupId":vm.groupId,
                "userId":vm.userId,
                "userName":vm.userName,
                "year":vm.currentYear,
                "month":vm.currentMonth,
                "hourSalary":vm.data.salary,
                "extraPay":vm.data.extraPay,
                "history":[],
                "salary":{}
            };
            vm.data.detail.forEach(function(detail){
                var start = moment(detail.workTimeDetail.startTime);
                var end = moment(detail.workTimeDetail.endTime);
                var rest = moment.duration(detail.workTimeDetail.restTime);
                if (start.isAfter(end)) {
                    end = end.add(1,'days');
                }
                var sub = {
                    "id":detail.workTimeDetail.id,
                    "day":detail.day,
                    "startTime":start,
                    "endTime":end,
                    "restTime":rest,
                    "workTime":detail.workTimeDetail.workTime,
                    "nightTime":detail.workTimeDetail.midNightTime,
                    "busFee":detail.workTimeDetail.busFee
                };
                params.history.push(sub);
                params.salary.workTime = vm.salary.workTime;
                params.salary.nightTime = vm.salary.nightTime;
                params.salary.overtime = vm.salary.overtime;
                params.salary.overtimeNight = vm.salary.overtimeNight;
                params.salary.busFee = vm.salary.busFee;
                params.salary.hourSalary = vm.salary.hourSalary;
                params.salary.nightSalary = vm.salary.nightSalary;
                params.salary.extraSalary = vm.salary.extraSalary;
                params.salary.totalSalary = vm.salary.totalSalary;
            });
            //console.log(params);
            Timecard.saveHistory(params,function(result){
                vm.data = result;
                vm.salary = result.salaryDTO;
                vm.reCalculate();
            },function (error) {
                AlertService.error(error.data.message);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('timecard-management', {
            parent: 'app',
            url: '/timecard/attendance/:currentYear/:currentMonth/',
            data: {
                pageTitle: 'global.menu.timecard.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/timecard-management/timecard-management.html',
                    controller: 'TimecardManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                groupId:null,
                retiredFlg:null,
                currentYear:null,
                currentMonth:null,
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timecard');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                        var gtc_caretree2_timecard_allfunction_fullaccess = false;
                        var isAdmin = false;
                        var isDeveloper = false;
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_TimeCard_AllFunction_FullAccess"}, function(result){
                        	if (!result.flag) {
                        		$state.go('accessdenied');
                        	} else {
                        		plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                        	}
                        });
                	} else {
                		LoginService.open();
                	}
                });
            }]
        }).state('timecard-management-detail', {
            parent: 'timecard-management',
            url: '/timecard-management/:currentYear/:currentMonth/:groupId/:userId/:userName/:retiredFlg/:deletedFlg',
            data: {
                pageTitle: 'timecard-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/timecard-management/timecard-management-detail.html',
                    controller: 'TimecardManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timecard');
                    return $translate.refresh();
                }]
            }
        });
    }
    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_TimeCard_AllFunction_FullAccess') {
                    gtc_caretree2_timecard_allfunction_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_timecard_allfunction_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TimecardManagementController', TimecardManagementController);

    TimecardManagementController.$inject = ['$scope', '$state', 'AlertService', '$stateParams', 'User', 'Group', 'Timecard','TimezoneService', 'ParseLinks', 'pagingParams', 'paginationConstants'];

    function TimecardManagementController ($scope, $state, AlertService, $stateParams, User, Group, Timecard,TimezoneService,ParseLinks, pagingParams, paginationConstants) {
        var vm = this;

        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.userTimecardList = [];
        vm.parentGroup = [];
        vm.groupId = $stateParams.groupId;
        vm.currentYear = $stateParams.currentYear;
        vm.currentMonth = $stateParams.currentMonth;
        vm.group = null;
        vm.timezone = null;
        vm.calendar = null;
        vm.reportFlag = false;
        vm.retiredFlg = $stateParams.retiredFlg;

        if (!angular.isDefined(vm.currentYear) || vm.currentYear == "") {
            vm.currentYear = new Date().getFullYear();
        }
        if (!angular.isDefined(vm.currentMonth) || vm.currentMonth == "") {
            vm.currentMonth = new Date().getMonth()+1;
        }

        //页面加载时，取得所有的Group
        vm.loadParentGroup = loadParentGroup;
        //Group切换时，自动取得Staff
        vm.changeGroup = changeGroup;
        //取得该Group的所有Staff信息
        vm.loadTimecards = loadTimecards;
        vm.loadCalendar = loadCalendar;
        vm.rest = rest;
        vm.nextMonth = nextMonth;
        vm.beforeMonth = beforeMonth;
        vm.popover = popover;
        vm.retired = retired;

        //页面加载后取得所有Group信息
        vm.loadParentGroup();
        vm.loadCalendar();

        function rest() {
            vm.currentYear = new Date().getFullYear();
            vm.currentMonth = new Date().getMonth()+1;
            vm.loadCalendar();
            vm.loadTimecards(vm.group);
        }

        function nextMonth() {
            if (Number(vm.currentMonth) === 12) {
                vm.currentMonth = 1;
                vm.currentYear = Number(vm.currentYear) + 1;
            } else {
                vm.currentMonth = Number(vm.currentMonth) + 1;
            }
            vm.loadCalendar();
            vm.loadTimecards(vm.group);
        }

        function retired() {
            vm.page = 1;
            vm.loadCalendar();
            vm.loadTimecards(vm.group);
        }

        function beforeMonth() {
            if (Number(vm.currentMonth) === 1) {
                vm.currentMonth = 12;
                vm.currentYear = Number(vm.currentYear) - 1;
            } else {
                vm.currentMonth = Number(vm.currentMonth) - 1;
            }
            vm.loadCalendar();
            vm.loadTimecards(vm.group);
        }

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                result.forEach(function(item) {
                   if (vm.groupId != null && vm.groupId == item.id) {
                       vm.group = item;
                       vm.timezone = TimezoneService.getOffset(vm.group.timezone);
                   }
                });
                if (vm.group == null) {
                    vm.group = vm.parentGroup[0];
                    vm.groupId = vm.parentGroup[0]['id'];
                    vm.timezone = TimezoneService.getOffset(vm.group.timezone);
                }
                vm.loadTimecards();
            });
        }

        function loadCalendar() {
            vm.calendar = Timecard.calendar({'year':vm.currentYear,'month':vm.currentMonth});
        }

        function changeGroup() {
        	pagingParams.page = 1;
            angular.forEach(vm.parentGroup,function(data,index,array){
                if (data.id === vm.groupId) {
                    vm.group = data;
                    vm.timezone = TimezoneService.getOffset(vm.group.timezone);
                }
            });
            vm.loadTimecards();
        }

        function loadTimecards() {
            const data = {'year': vm.currentYear, 'month': vm.currentMonth, 'groupId': vm.groupId, 'pageNumber': vm.page - 1, 'pageSize': vm.itemsPerPage, 'deletedFlg': vm.retiredFlg};
            Timecard.queryMonth(data,function(result,headers){
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.userTimecardList = result.users;
                vm.reportFlag = result.reportFlag;
            },function(error){
                AlertService.error(error.data.message);
            });
        }

        function popover(timecard) {
            var rawData = timecard.rawData;
            if (rawData.length === 0) return '<span>データがありません。</span>';
            var message = "";
            for (var i = 0; i < rawData.length; i++) {
                message+='<span>' + rawData[i]["inTime"] + '〜' + rawData[i]["outTime"] + '</span><br/>';
            }
            return message;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            vm.loadTimecards()
        }

        function sort () {
            // var result = [vm.predicate + ' ' + (vm.reverse ? 'asc' : 'desc')];
            // if (vm.predicate !== 'id') {
            //     result.push('id asc');
            // }
            return ['id asc'];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('timecard', {
            parent: 'app',
            url: '/timecard/timecard',
            data: {
                pageTitle: 'global.menu.timecard.main'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
            	Principal.identity().then(function(account) {
            		if (account != null) {
                        var gtc_caretree2_timecard_allfunction_fullaccess = false;
                        var isAdmin = false;
                        var isDeveloper = false;
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_TimeCard_AllFunction_FullAccess"}, function(result){
                        	if (!result.flag) {
                        		$state.go('accessdenied');
                        	} else {
                        		plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                        	}
                        });
            		} else {
            			LoginService.open();
            		}
                });
            }]
        })
        .state('timecard.dutyselect', {
            parent: 'timecard',
            url: '/dutyselect',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', '$uibModalStack', '$rootScope', function($stateParams, $state, $uibModal, $uibModalStack, $rootScope) {
                $uibModal.open({
                    templateUrl: 'app/timecard/select-duty-occupation.html',
                    controller: 'SelectDutyOccupationController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        param: {code: $stateParams.code}
                    }
                }).result.then(function() {
                    $state.go('timecard', null, { reload: false });
                }, function() {
                    $state.go('timecard');
                });
            }]
        });
    }
    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_TimeCard_AllFunction_FullAccess') {
                    gtc_caretree2_timecard_allfunction_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_timecard_allfunction_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }else{
            $uibModal.open({
                templateUrl: 'app/timecard/timecard.html',
                controller: 'TimecardController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'full-screen',
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('timecard');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function() {
                $state.go('home');
            }, function() {
                $state.go('home');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Timecard', Timecard);

    Timecard.$inject = ['$resource'];

    function Timecard ($resource) {
        var service = $resource('timecard/api/timecards', {}, {
            'query': {
                method: 'GET'
            },
            'calendar': {//指定年月的日历信息取得
                method: 'GET',
                url: 'timecard/api/timecards/calendar'
            },
            'queryDay': {//指定天的所有打卡信息取得
                method: 'POST',
                url: 'timecard/api/timecards/day',
            },
            'queryMonth': {//指定月的所有打卡信息取得
                method: 'POST',
                url: 'timecard/api/timecards/month'
            },
            'queryHistory':{
                method: 'GET',
                url: 'timecard/api/timecards/history',
                isArray:true
            },
            'queryChart':{
                method: 'GET',
                url: 'timecard/api/timecards/chart',
            },
            'save': {
                method: 'POST'
            },
            "saveHistory": {
                method: 'POST',
                url: 'timecard/api/timecards/history'
            },
            'update': {
                method:'PUT'
            },
            'yesterday': {
                method: 'POST',
                url: 'timecard/api/timecards/yesterday'
            },
            'beOut': {
                method: 'POST',
                url: 'timecard/api/timecards/out'
            },
            'reEntry': {
                method:'PUT',
                url: 'timecard/api/timecards/out'
            },
            'delete': {
                method:'DELETE'
            },
            'deleteTimeCard': {
                method:'PUT',
                url: 'timecard/api/timecards/deleteTimeCard'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TimecardController', TimecardController);

    TimecardController.$inject = ['$scope', '$rootScope', '$state','filterFilter', '$uibModalInstance', 'AlertService',
        '$stateParams', 'User', 'SelectedGroup', 'Timecard','TimezoneService', 'ShiftTime', 'Auth', 'StaffOccupation', 'ShiftMonth',
        'ParseLinks', 'pagingParams', 'paginationConstants', '$interval'];

    function TimecardController ($scope, $rootScope, $state, filterFilter, $uibModalInstance,  AlertService, $stateParams,
                                 User, SelectedGroup, Timecard,TimezoneService,ShiftTime, Auth, StaffOccupation, ShiftMonth,
                                 ParseLinks, pagingParams, paginationConstants, $interval) {
        var vm = this;
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.timeZoneList = [];
        vm.showTimeZoneFlag = false;

        //複数ユーザーのタイムカードデータを維持する
        vm.gyou50On = false;
        vm.userList = [];
        vm.groups = [];
        vm.user = null;
        vm.password = null;
        //特定ユーザのタイムカードデータを維持する
        vm.timecardData = null;
        vm.listUpData = [];
        vm.group = null;
        vm.currentTime = new Date();
        vm.groupTimezone = "+0900";
        vm.timeZone = { id: null };
        vm.message = "";
        vm.isSaving = false;

        vm.clear = clear;
        //页面加载时，取得所有的Group
        vm.loadAllGroups = loadAllGroups;
        //Group切换时，自动取得Staff
        vm.changeGroup = changeGroup;
        vm.groupTitle = groupTitle;
        //Staff切换时，自动更新Staff页面信息
        vm.changeUser = changeUser;
        //取得该Group的所有Staff信息
        vm.loadUsers = loadUsers;
        vm.checkIn = checkIn;
        vm.doCheckIn = doCheckIn;
        vm.checkOut = checkOut;
        vm.doCheckOut = doCheckOut;
        vm.goOut = goOut;
        vm.doGoOut = doGoOut;
        vm.reEntry = reEntry;
        vm.doReEntry = doReEntry;
        vm.refresh = refresh;
        vm.isUserSelected = isUserSelected;
        vm.haveUserPhoto = haveUserPhoto;
        //チェックインボタン有効かどうかを判別する
        vm.isCheckInEnabled = isCheckInEnabled;
        //チェックアウトボタン有効かどうかを判別する
        vm.isCheckOutEnabled = isCheckOutEnabled;
        //外出ボタン有効かどうかを判別する
        vm.isBeOutEnabled = isBeOutEnabled;
        //再入ボタン有効かどうかを判別する
        vm.isReEntryEnabled = isReEntryEnabled;
        //五十音表示するため
        vm.startsWith = starsWith;
        //打刻履歴を表示する
        vm.listup = listup;
        vm.currentDay = currentDay;
        vm.timeZoneClick = timeZoneClick;

        vm.currentClock = "";
        vm.currentCalendar = "";
        vm.callAtTimeout = callAtTimeout;
        vm.stopInterval = stopInterval;

        vm.afterCheck = afterCheck

        callAtTimeout();
        vm.promise = $interval(function() {
            vm.callAtTimeout()
        }, 1000);

        $scope.$on('$destroy', function() {
            vm.stopInterval();
        });

        function stopInterval() {
            $interval.cancel(vm.promise);
        }

        function callAtTimeout() {
            var now = new Date()
            var h = now.getHours();
            if (h < 10) {
                h = "0" + h;
            }
            var m = now.getMinutes();
            if (m < 10) {
                m = "0" + m;
            }
            var s = now.getSeconds();
            if (s < 10) {
                s = "0" + s;
            }
            vm.currentCalendar = now;
            vm.currentClock = h + ":" + m + ":" + s;

            var year = now.getFullYear();
            var month = now.getMonth() + 1;
            var day = now.getDate()

            var dayOfWeek = now.getDay() ; // 曜日(数値)
            var dayOfWeekStr = [ "日", "月", "火", "水", "木", "金", "土" ][dayOfWeek] ; // 曜日(日本語表記)

            vm.currentCalendar = month+"月"+day+"日("+dayOfWeekStr+")";
        }

        function currentDay() {
            var now = new Date();
            var year = now.getFullYear();
            var month = now.getMonth()+1;
            if (month < 10) {
                month = "0"+month;
            }
            var day = now.getDate();
            if (day < 10) {
                day = "0"+day;
            }
            return year+"-"+month+"-"+day;

        }

        function timeZoneClick () {
            vm.showTimeZoneFlag = false;
        }
        setInterval(function () {
            var now = new Date();
            if (vm.currentTime.getDate() !== now.getDate()) {
                console.log("日付が変わりました、画面リフレッシュします。");
                vm.currentTime = new Date();
                $state.reload();
            }
        }, 1000);

        //页面加载后取得所有Group信息
        vm.loadAllGroups();

        //Dialogを閉じます
        function clear () {
            $uibModalInstance.dismiss('cancel');
            Auth.logout();
            $state.go('home');
        }
        //グループ一覧を取得
        function loadAllGroups() {
            vm.groups = SelectedGroup.groupList();
            if (vm.group == null) {
                vm.group = vm.groups[0];
            }
            vm.loadUsers(vm.group);
        }
        //グループ切り替え
        function changeGroup(group) {
            vm.group = group;
            vm.page = 1;
            vm.loadUsers(vm.group);
            vm.user = null;
            vm.password = null;
            vm.timecardData = [];
            vm.listUpData = [];
        }
        function groupTitle() {
            var title = "";
            if (angular.isDefined(vm.group)) {
                if(vm.group.parentId == "0") {
                    title = vm.group.name;
                } else {
                    vm.groups.forEach(function(item){
                        if (item.id == vm.group.parentId) {
                            title = item.name.replace(/-/g, '').replace(/|/g,'') + title;
                        }
                    });
                    title += vm.group.name.replace(/-/g,'').replace(/|/g,'');
                }
            }
            return title;

        }
        //ユーザ切り替え
        function changeUser(user) {
            vm.user = user;
            vm.password = null;
            //1日なので、timecardsの配列には１レコードしかない、
            //vm.timecardDataはTimecardDTO　と同じ構造です
            vm.timecardData = vm.user.timecards[0];
            vm.listUpData = vm.listup();
        }
        //該当グループのユーザー一覧を取得
        function loadUsers(group) {
            vm.showTimeZoneFlag = false;
            vm.groupTimezone = TimezoneService.getOffset(group.timezone);
            User.query({
                groupId:group.id,
                pageNumber: vm.page - 1,
                pageSize: vm.itemsPerPage
            },function(result,headers){
                //vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                var userList = result;
                var currentYear = vm.currentTime.getFullYear();
                var currentMonth = vm.currentTime.getMonth()+1;
                var currentDay = vm.currentTime.getDate();
                var data = {'groupId':group.id,'users':userList,'year':currentYear,'month':currentMonth,'day':currentDay};
                Timecard.queryDay(data,function(result){
                    vm.userList = result.users;
                },function(error){
                    AlertService.error(error.data.message);
                });
                ShiftTime.getMonthStateAll({"groupId":vm.group.id, 'year':currentYear,'month':currentMonth}, function(result){
                    vm.timeZoneList = result;
                });

            },function(error){
                AlertService.error(error.data.message);
            });
        }

        function save () {
            if(vm.timeZoneList.length > 0){
                if(vm.timeZone.id != null){
                    var data = {'groupId':vm.group.id, 'userId':vm.user.id, 'year': vm.currentTime.getFullYear(), 'month': vm.currentTime.getMonth()+1};
                    StaffOccupation.queryStaffOccupation(data,function(result){
                        if(result.length == 0){
                            alert("職種や勤務形態が設定されていませんので、先に設定してください。");
                        }else if(result.length == 1){
                            $rootScope.staffOccupationId = result[0].id;
                            $rootScope.occupationId = result[0].occupationId;
                            $rootScope.dutyId = result[0].dutyId;
                            saveShiftMonth();
                        }else if(result.length > 1){
                            $rootScope.dutyOccupationList = result;
                            var nullList = [];
                            var notNullList = [];
                            var index = 0;
                            result.forEach(function(staff){
                                ShiftMonth.queryYotei({staffOccupationId:staff.id}, function(entity){
                                    var yotei = {};
                                    var day = new Date().getDate();
                                    yotei.staffOccupationId = entity.staffOccupationId;
                                    yotei.occupationId = entity.occupationId;
                                    yotei.dutyId = entity.dutyId;
                                    yotei.dayNumber = entity['day'+day];
                                    //如果打卡的当天有预定的值
                                    if(entity['day'+day] != null){
                                        ShiftTime.getOneById({id:entity['day'+day]}, function(timeZone){
                                            yotei.nameAndTime = timeZone.nameAndTime;
                                            notNullList.push(yotei);
                                            index += 1;
                                            if(index >= result.length){
                                                //同职种同勤务形态且预定有值的超过一条以上，则弹出选择对话框
                                                if(notNullList.length>1){
                                                    $rootScope.yoteiList = notNullList;
                                                    $state.go('timecard.dutyselect');
                                                    //同职种同勤务形态且预定有值只有一条，则直接保存
                                                } else if(notNullList.length==1){
                                                    $rootScope.staffOccupationId = notNullList[0].staffOccupationId;
                                                    $rootScope.occupationId = notNullList[0].occupationId;
                                                    $rootScope.dutyId = notNullList[0].dutyId;
                                                    saveShiftMonth();
                                                    //同职种同勤务形态且 预定没有值时，给第一个打卡
                                                } else {
                                                    $rootScope.staffOccupationId = $rootScope.dutyOccupationList[0].id;
                                                    $rootScope.occupationId = $rootScope.dutyOccupationList[0].occupationId;
                                                    $rootScope.dutyId = $rootScope.dutyOccupationList[0].dutyId;
                                                    saveShiftMonth();
                                                }
                                            }
                                        });
                                    }else {
                                        nullList.push(yotei);
                                        index += 1;
                                        if(index >= result.length){
                                            //同职种同勤务形态且预定有值的超过一条以上，则弹出选择对话框
                                            if(notNullList.length>1){
                                                $rootScope.yoteiList = notNullList;
                                                $state.go('timecard.dutyselect');
                                                //同职种同勤务形态且预定有值只有一条，则直接保存
                                            } else if(notNullList.length==1){
                                                $rootScope.staffOccupationId = notNullList[0].staffOccupationId;
                                                $rootScope.occupationId = notNullList[0].occupationId;
                                                $rootScope.dutyId = notNullList[0].dutyId;
                                                saveShiftMonth();
                                                //同职种同勤务形态且 预定没有值时，给第一个打卡
                                            } else {
                                                $rootScope.staffOccupationId = $rootScope.dutyOccupationList[0].id;
                                                $rootScope.occupationId = $rootScope.dutyOccupationList[0].occupationId;
                                                $rootScope.dutyId = $rootScope.dutyOccupationList[0].dutyId;
                                                saveShiftMonth();
                                            }
                                        }
                                    }
                                });
                            });
                        }
                    });
                    vm.showTimeZoneFlag = false;
                }else {
                    vm.showTimeZoneFlag = true;
                }
            }else {
                //1:出勤,2:退勤,3:外出,4:再入
                if($scope.type == 1){
                    onSaveCheckInSuccess();
                } else if($scope.type == 2) {
                    onSaveCheckOutSuccess();
                } else if($scope.type == 3) {
                    onSavegoOutSuccess();
                } else if($scope.type == 4) {
                    onSaveReEntrySuccess();
                }
            }
        }

        $scope.$on('duty', function() {
            saveShiftMonth();
         });

        function saveShiftMonth() {
            var monthStaff = {};
            var monthShiftJisseki = {};
            monthStaff.userId = vm.user.id;
            monthStaff.occupationId = $rootScope.occupationId;
            monthStaff.dutyId = $rootScope.dutyId;
            monthStaff.staffOccupationId = $rootScope.staffOccupationId;
            monthShiftJisseki.id = null;
            monthShiftJisseki.userId = vm.user.id;
            monthShiftJisseki.staffOccupationId = $rootScope.staffOccupationId;
            monthShiftJisseki.occupationId = $rootScope.occupationId;
            monthShiftJisseki.dutyId = $rootScope.dutyId;
            monthShiftJisseki.total = 8;
            monthShiftJisseki.avgTime = 0.05;
            monthShiftJisseki.timeZoneCountDTO = [];
            for(var a = 0; a < vm.timeZoneList.length; a++ ) {
                var dto = {};
                dto.id = vm.timeZoneList[a].id;
                dto.name = vm.timeZoneList[a].name;
                if(vm.timeZoneList[a].id == vm.timeZone.id){
                    dto.timeZoneCount = 1;
                }else {
                    dto.timeZoneCount = 0;
                }
                monthShiftJisseki.timeZoneCountDTO.push(dto);
            }

            for(var i = 1; i< 31;i++){
                if(i==vm.currentTime.getDate()) {
                    monthShiftJisseki['day'+i] = vm.timeZone.id;
                }else {
                    monthShiftJisseki['day'+i] = null;
                }
            }
            monthStaff.monthShiftJisseki = monthShiftJisseki;
            //1:出勤,2:退勤,3:外出,4:再入
            ShiftMonth.saveShiftMonthByTimeCard({groupId:vm.group.id, year:vm.currentTime.getFullYear(), month:vm.currentTime.getMonth()+1, type:3, monthStaff: monthStaff});
        }

        function onSaveCheckInSuccess () {
            if (vm.user.passwordRequired) {
                if (vm.user.passwordRequired && vm.password === null) {
                    AlertService.error("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doCheckIn();
                });
            } else {
                vm.doCheckIn();
            }
        }

        function onSaveCheckOutSuccess () {
            if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    AlertService.error("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doCheckOut();
                });
            } else {
                vm.doCheckOut();
            }
        }

        function onSavegoOutSuccess () {
            if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    AlertService.error("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doGoOut();
                });
            } else {
                vm.doGoOut();
            }
        }

        function onSaveReEntrySuccess () {
            if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    AlertService.error("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doReEntry();
                });
            } else {
                vm.doReEntry();
            }
        }

        //出勤処理
        function checkIn() {
            if (vm.user.passwordRequired) {
                if (vm.user.passwordRequired && vm.password === null) {
                    AlertService.error("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doCheckIn();
                });
            } else {
                vm.doCheckIn();
            }
        }
        //実出勤登録処理
        function doCheckIn(){
            vm.isSaving = true;
            var timecard = {"id":null,"groupId":vm.group.id, "day": vm.currentDay(),
                "userId":vm.user.id,"password":vm.password,"origin":vm.user.password,
                "userName":vm.user.lastName+" "+ vm.user.firstName, "type":1, "inTime":new Date(),
                "year": vm.currentTime.getFullYear(), "month": vm.currentTime.getMonth() + 1,
                "timeZoneId": vm.timeZone.id, "timecardShiftFlag": vm.group.timecardShiftFlag };

            Timecard.save(timecard, function (result) {
                vm.isSaving = false;
                vm.refresh(result);
                vm.afterCheck(result);
                AlertService.success("timecard.management.checkin",{"param":vm.user.lastName + " " + vm.user.firstName});
            }, function (error) {
                vm.isSaving = false;
                AlertService.error(error.data.message);
            });
        }
        //退勤処理
        function checkOut() {
            if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    AlertService.error("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doCheckOut();
                });
            } else {
                vm.doCheckOut();
            }
        }
        //実退勤登録処理
        function doCheckOut(){
            vm.isSaving = true;
            if (vm.timecardData.haveUnFinishedTimecard === true) {
                console.log("昨日の出勤ですが、今日退勤します。");
                var timecard = {};
                timecard["groupId"] = vm.group.id;
                timecard["userId"] = vm.user.id;
                timecard["day"] = vm.currentDay();
                timecard["outTime"] = new Date();
                timecard["password"] = vm.password;
                timecard["origin"] = vm.user.password;
                timecard["userName"] = vm.user.lastName+" "+ vm.user.firstName;
                timecard["year"] = vm.currentTime.getFullYear();
                timecard["month"] = vm.currentTime.getMonth() + 1;
                timecard["timeZoneId"] = vm.timeZone.id;
                timecard["timecardShiftFlag"] = vm.group.timecardShiftFlag
                Timecard.yesterday(timecard, function (result) {
                    vm.isSaving = false;
                    vm.refresh(result);
                    vm.afterCheck(result);
                    AlertService.success("timecard.management.checkout",{"param":vm.user.lastName + " " + vm.user.firstName});
                }, function (error) {
                    vm.isSaving = false;
                    AlertService.error(error.data.message);
                });

            } else {
                var checkInData = filterFilter(vm.timecardData.rawData,{type: 1});
                var timecard = checkInData[checkInData.length -1];
                timecard["groupId"] = vm.group.id;
                timecard["outTime"] = new Date();
                timecard["password"] = vm.password;
                timecard["origin"] = vm.user.password;
                timecard["userName"] = vm.user.lastName+" "+ vm.user.firstName;
                timecard["year"] = vm.currentTime.getFullYear();
                timecard["month"] = vm.currentTime.getMonth() + 1;
                timecard["timeZoneId"] = vm.timeZone.id;
                timecard["timecardShiftFlag"] = vm.group.timecardShiftFlag
                Timecard.update(timecard, function (result) {
                    vm.isSaving = false;
                    vm.refresh(result);
                    vm.afterCheck(result);
                    AlertService.success("timecard.management.checkout",{"param":vm.user.lastName + " " + vm.user.firstName});
                }, function (error) {
                    vm.isSaving = false;
                    AlertService.error(error.data.message);
                });
            }
        }
        //外出処理
        function goOut() {
            if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    AlertService.error("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doGoOut();
                });
            } else {
                vm.doGoOut();
            }
        }
        //実外出登録処理
        function doGoOut(){
            vm.isSaving = true;
            var timecard = {"id":null,"groupId":vm.group.id, "day": vm.currentDay(),
                "userId":vm.user.id,"password":vm.password, "origin":vm.user.password,
                "userName":vm.user.lastName+" "+ vm.user.firstName, "type":2, "inTime":new Date(),
                "year": vm.currentTime.getFullYear(), "month": vm.currentTime.getMonth() + 1,
                "timeZoneId": vm.timeZone.id, "timecardShiftFlag": vm.group.timecardShiftFlag};
            Timecard.beOut(timecard, function (result) {
                vm.isSaving = false;
                vm.refresh(result);
                vm.afterCheck(result);
                AlertService.success("timecard.management.beout",{"param":vm.user.lastName + " " + vm.user.firstName});
            }, function (error) {
                vm.isSaving = false;
                AlertService.error(error.data.message);
            });
        }
        //再入処理
        function reEntry() {
            if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    AlertService.error("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doReEntry();
                });
            } else {
                vm.doReEntry();
            }
        }
        //実再入登録処理
        function doReEntry() {
            vm.isSaving = true;

            var beOutData = filterFilter(vm.timecardData.rawData,{type: 2});
            var timecard = beOutData[beOutData.length -1];
            timecard["groupId"] = vm.group.id;
            timecard["outTime"] = new Date();
            timecard["password"] = vm.password;
            timecard["origin"] = vm.user.password;
            timecard["userName"] = vm.user.lastName+" "+ vm.user.firstName;
            timecard["year"] = vm.currentTime.getFullYear();
            timecard["month"] = vm.currentTime.getMonth() + 1;
            timecard["timeZoneId"] = vm.timeZone.id;
            timecard["timecardShiftFlag"] = vm.group.timecardShiftFlag

            Timecard.reEntry(timecard, function (result) {
                vm.isSaving = false;
                vm.refresh(result);
                vm.afterCheck(result);
                AlertService.success("timecard.management.reentry",{"param":vm.user.lastName + " " + vm.user.firstName});
            }, function (error) {
                vm.isSaving = false;
                AlertService.error(error.data.message);
            });
        }

        /**
         * 打刻データを保存したら、ロカルデータを再更新します
         * @param result
         */
        function refresh(result) {
            vm.password = null;
            vm.user.timecards[0].workTimeDetail.startTime = result.workTimeDetail.startTime;
            vm.user.timecards[0].workTimeDetail.endTime = result.workTimeDetail.endTime;
            vm.user.timecards[0].workTimeDetail.status = result.workTimeDetail.status;
            vm.user.timecards[0].workTimeDetail.nextDay = result.workTimeDetail.nextDay;
            vm.user.timecards[0].workTimeDetail.checkinEnabled = result.workTimeDetail.checkinEnabled;
            vm.user.timecards[0].workTimeDetail.checkoutEnabled = result.workTimeDetail.checkoutEnabled;
            vm.user.timecards[0].workTimeDetail.beoutEnabled = result.workTimeDetail.beoutEnabled;
            vm.user.timecards[0].workTimeDetail.reentryEnabled = result.workTimeDetail.reentryEnabled;
            vm.user.timecards[0].haveUnFinishedTimecard = result.haveUnFinishedTimecard;
            vm.user.timecards[0].rawData = result.rawData;

            vm.timecardData = vm.user.timecards[0];
            vm.listUpData = vm.listup();
        }

        /**
         * 打刻画面にユーザを選らんだかどうかを判断する
         * @returns {boolean}
         */
        function isUserSelected() {
            if (vm.user === undefined || vm.user === null) {
                return false;
            }
            if (vm.user.id === undefined) {
                return false;
            }
            return true;
        }

        /**
         * 打刻画面で利用者は写真を表示するかどうかを判断する
         * @returns {boolean}
         */
        function haveUserPhoto() {
            if (vm.user === null) {
                return false;
            }
            if (vm.user.imageUrl === null) {
                return false;
            }
            if (vm.user.imageUrl.length > 0) {
                return true;
            }
            return false;
        }
        //チェックインボタンは有効かどうかを判別する
        function isCheckInEnabled() {
            if (vm.timecardData === null){
                return false;
            } else if (!angular.isDefined(vm.timecardData.workTimeDetail)){
                return false;
            } else {
                return vm.timecardData.workTimeDetail.checkinEnabled;
            }
        }
        //チェックアウトは有効かどうかを判別する
        function isCheckOutEnabled() {
            if (vm.timecardData === null) {
                return false;
            } else if(!angular.isDefined(vm.timecardData.workTimeDetail)){
                return false;
            } else {
                return vm.timecardData.workTimeDetail.checkoutEnabled;
            }
        }
        //外出ボタンは有効かどうかを判別する
        function isBeOutEnabled() {
            if (vm.timecardData === null) {
                return false;
            } else if(!angular.isDefined(vm.timecardData.workTimeDetail)){
                return false;
            } else {
                return vm.timecardData.workTimeDetail.beoutEnabled;
            }
        }
        //再入ボタンは有効かどうかを判別する
        function isReEntryEnabled () {
            if (vm.timecardData === null) {
                return false;
            } else if (!angular.isDefined(vm.timecardData.workTimeDetail)){
                return false;
            } else {
                return vm.timecardData.workTimeDetail.reentryEnabled;
            }
        }

        function starsWith(actual, expected) {
            var lowerStr = (actual + "").toLowerCase();
            return lowerStr.indexOf(expected.toLowerCase()) === 0;
        }

        function listup() {
            var result = [];
            if (vm.timecardData === null) {
                return result;
            } else if (angular.isUndefined(vm.timecardData) || vm.timecardData.length === 0) {
                return result;
            }
            var data = vm.timecardData.rawData;
            if (angular.isDefined(data) && data.length > 0) {
                var index = 0;
                angular.forEach(data, function(value, key){
                    if (value !== null && angular.isDefined(value)) {
                        if(value.type === 1) {
                            if (angular.isDefined(value.inTime) && value.inTime !== null) {
                                if(vm.timecardData.workTimeDetail.nextDay === true) {
                                    result.push({"name":"出勤(昨日)","time":value.inTime});
                                } else {
                                    result.push({"name":"出勤","time":value.inTime});
                                }

                                index += 1;
                            }
                            if (angular.isDefined(value.outTime) && value.outTime !== null) {
                                result.push({"name":"退勤","time":value.outTime});
                            }
                        }
                        if(value.type === 2) {
                            if (angular.isDefined(value.inTime) && value.inTime !== null) {
                                result.splice(index, 0, {"name":"外出","time":value.inTime});
                                index += 1;
                            }
                            if (angular.isDefined(value.outTime) && value.outTime !== null) {
                                result.splice(index, 0,  {"name":"再入","time":value.outTime});
                                index += 1;
                            }
                        }
                    }
                });
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            vm.loadUsers(vm.group);
        }

        function afterCheck(result) {
            vm.showTimeZoneFlag = false;
            if (result.type == 3) {
                vm.showTimeZoneFlag = true;
            } else if (result.type == 4) {
                alert("職種や勤務形態が設定されていませんので、先に設定してください。");
            } else if (result.type == 5) {
                $rootScope.yoteiList = result.yoteiList;
                $state.go('timecard.dutyselect');
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StaffSingleAddController',StaffSingleAddController);
    StaffSingleAddController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService','Group', 'MessageService', '$rootScope'];
    function StaffSingleAddController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService, Group, MessageService, $rootScope) {
        var vm = this;
        vm.userlist = [];

        vm.clear = clear;
        vm.loadUser = loadUser;
        vm.addUser = addUser;
        vm.staffOccupationList = $rootScope.userList;
        loadUser();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function loadUser() {
            User.queryAllByGroupId({groupId:$rootScope.groupId},function(result){
                vm.userlist = result;
            });
        }

        function addUser(user) {
            $rootScope.addFlag = false;
            for(var i=0; i<vm.staffOccupationList.length; i++){
                if(user.id == vm.staffOccupationList[i].userId){
                    $rootScope.addFlag = true;
                    alert("スタッフはすでにシフト職員管理リストに存在します");
                    break;
                }
            }
            if(!$rootScope.addFlag){
                $rootScope.user = user;
                $uibModalInstance.dismiss('cancel');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StaffOccupationDetailController', StaffOccupationDetailController);

    StaffOccupationDetailController.$inject = ['$scope', '$uibModal', '$state', 'AlertService', '$timeout', '$stateParams', '$rootScope' , 'User', 'Timecard', 'StaffOccupation', 'ShiftDuty', 'ShiftOccupation', 'ShiftMonth', 'Group', 'pagingParams','paginationConstants','ParseLinks'];

    function StaffOccupationDetailController ($scope, $uibModal, $state, AlertService, $timeout,$stateParams,$rootScope, User, Timecard, StaffOccupation, ShiftDuty, ShiftOccupation, ShiftMonth, Group, pagingParams,paginationConstants,ParseLinks) {
        var vm = this;
        vm.selectFlag = false;
        vm.page = $stateParams.page;
        vm.page1 = $stateParams.page;
        vm.totalItems = null;
        vm.parentGroup = [];
        vm.dutyList = [];
        vm.occupationList = [];
        vm.resultList = [];
        vm.userList = [];
        vm.currentYear = $stateParams.currentYear;
        vm.currentMonth = $stateParams.currentMonth;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.userType = true;
        vm.pageNumber = 20;
        vm.startNumber = 0;
        vm.selectGroupFlag = false;
        vm.groupAllList = [];
        //页面加载时，取得所有的Group
        vm.loadParentGroup = loadParentGroup;
        //Group切换
        vm.changeGroup = changeGroup;
        vm.loadStaffOccupation = loadStaffOccupation;
        vm.transition = transition;
        vm.loadPage = loadPage;
        vm.loadDuty = loadDuty;
        vm.loadOccupation = loadOccupation;
        vm.goEdit = goEdit;
        vm.goCancel = goCancel;
        vm.goAdd = goAdd;
        vm.goDel = goDel;
        vm.save = save;
        vm.changeSelect = changeSelect;
        vm.rest = rest;
        vm.beforeMonth = beforeMonth;
        vm.nextMonth = nextMonth;
        vm.loadCalendar = loadCalendar;
        vm.reloadStaff = reloadStaff;
        vm.staffSingeAdd = staffSingeAdd;
        vm.nextMonthFlag = false;
        vm.staffIsNullFlag = false;

        if (!angular.isDefined(vm.currentYear) || vm.currentYear == "") {
            vm.currentYear = new Date().getFullYear();
        }
        if (!angular.isDefined(vm.currentMonth) || vm.currentMonth == "") {
            vm.currentMonth = new Date().getMonth()+1;
        }

        //页面加载后取得所有Group信息
        vm.loadParentGroup();
        vm.loadCalendar();

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                if ($stateParams.groupId !== null) {
                    result.forEach(function(item){
                        if (item.id == $stateParams.groupId) {
                            vm.group = item;
                        }
                    });
                } else {
                    vm.group = vm.parentGroup[0];
                }
                vm.groupId = vm.group.id;
                vm.loadStaffOccupation();
            });
        }

        function changeGroup() {
            //vm.selectFlag = false;
            pagingParams.page = 1;
            /*if(vm.houjinFlag){
                vm.groupAllList.forEach(function (item) {
                    if(vm.groupId != item.id){
                        vm.selectGroupFlag = true;
                    }else {
                        vm.selectGroupFlag = false;
                    }
                });
            }*/
            vm.parentGroup.forEach(function(e){
                if (e.id == vm.groupId) {
                    vm.group = e;
                    vm.groupId = vm.group.id;
                    loadStaffOccupation();
                }
            });
        }

        function loadDuty() {
            Group.queryParentGroupId({"groupId":vm.group.id}, function (group) {
                //当前用户的父groupId
                var groupId = "gid" + group.groupId;
                ShiftDuty.getAllByGroupId({"groupId":groupId}, function(result){
                    vm.dutyList = result;
                });
            });
            /*//判断登录账号是不是法人
            Group.groupList({"depth": 0}, function(groupList){
                vm.groupAllList = groupList;
                for(var i=0; i<groupList.length; i++){
                    if(!vm.houjinFlag){
                        for(var x=0; x<groupList[i].flags.length; x++){
                            if(groupList[i].flags[x].id == 2){
                                vm.houjinFlag = true;
                                break;
                            }
                        }
                    }
                }
                //如果是法人，直接根据groupId查询
                if(vm.houjinFlag && !vm.selectGroupFlag){
                    ShiftDuty.getAllByGroupId({"groupId":vm.group.id}, function(result){
                        vm.dutyList = result;
                    });
                    //普通用户则查找他父节点的所有的数据
                }else {
                    Group.queryParentGroupId({"groupId":vm.group.id}, function (group) {
                        //当前用户的父groupId
                        var groupId = "gid" + group.groupId;
                        ShiftDuty.getAllByGroupId({"groupId":groupId}, function(result){
                            vm.dutyList = result;
                        });
                    });
                }
            });*/
        }

        function loadOccupation() {
            Group.queryParentGroupId({"groupId":vm.group.id}, function (group) {
                //当前用户的父groupId
                var groupId = "gid" + group.groupId;
                ShiftOccupation.getAllByGroupId({"groupId":groupId}, function(result){
                    vm.occupationList = result;
                });
            });
            /*//判断登录账号是不是法人
            Group.groupList({"depth": 0}, function(groupList){
                for(var i=0; i<groupList.length; i++){
                    if(!vm.houjinFlag){
                        for(var x=0; x<groupList[i].flags.length; x++){
                            if(groupList[i].flags[x].id == 2){
                                vm.houjinFlag = true;
                                break;
                            }
                        }
                    }
                }
                //如果是法人，直接根据groupId查询
                if(vm.houjinFlag && !vm.selectGroupFlag){
                    ShiftOccupation.getAllByGroupId({"groupId":vm.group.id}, function(result){
                        vm.occupationList = result;
                    });
                    //普通用户则查找他父节点的所有的数据
                }else {
                    Group.queryParentGroupId({"groupId":vm.group.id}, function (group) {
                        //当前用户的父groupId
                        var groupId = "gid" + group.groupId;
                        ShiftOccupation.getAllByGroupId({"groupId":groupId}, function(result){
                            vm.occupationList = result;
                        });
                    });
                }
            });*/
        }

        function loadStaffOccupation() {
            //查询シフト職員管理表中是否保存了数据
            vm.nextMonthFlag = false;
            vm.userType = false;
            StaffOccupation.queryUserByGroupId({
                groupId:vm.groupId,
                year: vm.currentYear,
                month: vm.currentMonth,
                nextMonthFlag: vm.nextMonthFlag,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage
            },function (result,headers) {
                if(result.length > 0){
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    vm.page1 = pagingParams.page;
                    var data = {'userList':result, 'groupId':vm.groupId, 'year': vm.currentYear, 'month': vm.currentMonth, 'nextMonthFlag': vm.nextMonthFlag};
                    StaffOccupation.queryDutyOccupation(data,function(result){
                        vm.userList = result;
                        vm.resultList = angular.copy(result);
                        vm.loadDuty();
                        vm.loadOccupation();
                        if(vm.nextMonthFlag){
                            angular.forEach(vm.userList, function(data){
                                data.showFlag = true;
                                data.id = null;
                            });
                        }
                    },function(error){
                        AlertService.error(error.data.message);
                    });
                }else {
                    //如果当前月没数据,则取该group下的所有user
                    vm.userType = true;
                    User.queryAllByGroupId({groupId:vm.groupId},function(result){
                        vm.totalItems = result.length;
                        vm.queryCount = vm.totalItems;
                        vm.page = pagingParams.page;
                        vm.page1 = pagingParams.page;
                        vm.startNumber = ((vm.page - 1) * vm.itemsPerPage) === 0 ? 0 : ((vm.page - 1) * vm.itemsPerPage);
                        var data = {'users':result, 'groupId':vm.groupId, 'year': vm.currentYear, 'month': vm.currentMonth};
                        StaffOccupation.queryDuty(data,function(result){
                            vm.userList = result;
                            vm.resultList = angular.copy(result);
                            vm.loadDuty();
                            vm.loadOccupation();
                        },function(error){
                            AlertService.error(error.data.message);
                        });
                    });
                }
            });
        }

        function reloadStaff () {
            //删除之前登录的数据
            if(confirm("シフト職員管理と月次シフト表の設定をクリアしますが、再読み込みしてもよろしいでしょうか")){
                var data = {'groupId':vm.groupId, 'year': vm.currentYear, 'month': vm.currentMonth};
                StaffOccupation.deletedStaffOccupation(data,function(result){
                    if(result){
                        vm.userType = true;
                        User.queryAllByGroupId({groupId:vm.groupId},function(result){
                            vm.totalItems = result.length;
                            vm.queryCount = vm.totalItems;
                            vm.page = pagingParams.page;
                            vm.page1 = pagingParams.page;
                            vm.startNumber = ((vm.page - 1) * vm.itemsPerPage) === 0 ? 0 : ((vm.page - 1) * vm.itemsPerPage);
                            var data = {'users':result, 'groupId':vm.groupId, 'year': vm.currentYear, 'month': vm.currentMonth};
                            StaffOccupation.queryDuty(data,function(result){
                                vm.userList = result;
                                vm.resultList = angular.copy(result);
                                vm.loadDuty();
                                vm.loadOccupation();
                            },function(error){
                                AlertService.error(error.data.message);
                            });
                        });
                    }
                },function(error){
                    AlertService.error(error.data.message);
                });
            }
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            if(vm.selectFlag == true){
                alert("保存してないデータがありまして、先に保存してください。")
                vm.page = vm.page1;
                return false;
            }
            /*if(vm.houjinFlag){
                vm.groupAllList.forEach(function (item) {
                    if(vm.groupId != item.id){
                        vm.selectGroupFlag = true;
                    }else {
                        vm.selectGroupFlag = false;
                    }
                });
            }*/
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                groupId: vm.groupId == null ? "" : vm.groupId,
                currentYear:vm.currentYear,
                currentMonth:vm.currentMonth
            });
        }

        function goEdit(user){
            user.showFlag = true;
            vm.selectFlag = true;
        }

        function goCancel(user){
            user.showFlag = false;
            vm.resultList.forEach(function (result){
                if(result.id === user.id){
                    user.occupationId = result.occupationId;
                    user.dutyId = result.dutyId;
                }
            });
        }

        function goAdd(index, user){
            vm.pageNumber += 1;
            vm.selectFlag = true;
            var u = {};
            u.id = null;
            u.userId = user.userId;
            u.userName = user.userName;
            u.occupationId = '';
            u.dutyId = '';
            u.showFlag = true;
            u.firstFlag = false;
            u.deleteFlag = false;
            u.rowspan = user.rowspan;
            vm.userList.splice(((vm.page-1)*20)+index+1,0,u);
            vm.userList.forEach(function(result){
                if(user.userId == result.userId){
                    result.rowspan += 1;
                }
            });
        }

        function goDel(index, user){
            if(confirm('該当スタッフをシフト管理から外してもよろしいでしょうか？')){
                if(!user.showFlag){
                    ShiftMonth.queryJisseki({staffOccupationId:user.staffOccupationId}, function(result){
                        if(result.length > 0) {
                            if(confirm('シフト職員データを削除するとともに関連シフトデータも削除してよろしいでしょうか？')){
                                doDeleted(user);
                            }
                        }else {
                            doDeleted(user);
                        }
                    });
                }else {
                    doDeleted(user);
                }
            }
        }

        function doDeleted(user) {
            vm.userList.forEach(function(result, i){
                if(user.userId == result.userId){
                    user.deleteFlag = true;
                    //if(result.rowspan > 1){
                    result.rowspan -= 1;
                    //}
                    if(result.firstFlag && result.deleteFlag){
                        if(vm.userList.length>1){
                            vm.userList[i+1].firstFlag = true;
                        }
                    }
                }
            });
        }

        function save(){
            if(confirm("一括保存してよろしいでしょうか")){
                //当前用户的父groupId
                Group.queryParentGroupId({"groupId":vm.group.id}, function (group) {
                    var pGroupId = "gid" + group.groupId;
                    StaffOccupation.save({groupId:vm.group.id,userList:vm.userList, year: vm.currentYear, month: vm.currentMonth, parentGroupId: pGroupId}, onSaveSuccess, onSaveError);
                });
            }
        }

        function onSaveSuccess (result) {
            vm.selectFlag = false;
            vm.staffIsNullFlag = false;
            loadStaffOccupation();
        }

        function onSaveError (result) {
            vm.userList = result.data.userList;
        }

        function changeSelect(){
            vm.selectFlag = true;
        }

        function rest(){
            vm.selectFlag = false;
            pagingParams.page = 1;
            vm.currentYear = new Date().getFullYear();
            vm.currentMonth = new Date().getMonth()+1;
            vm.loadStaffOccupation();
            loadCalendar();
        }

        function beforeMonth(){
            vm.selectFlag = false;
            pagingParams.page = 1;
            if (Number(vm.currentMonth) === 1) {
                vm.currentMonth = 12;
                vm.currentYear = Number(vm.currentYear) - 1;
            } else {
                vm.currentMonth = Number(vm.currentMonth) - 1;
            }
            vm.loadStaffOccupation();
            loadCalendar();
        }

        function nextMonth(){
            vm.selectFlag = false;
            pagingParams.page = 1;
            if (Number(vm.currentMonth) === 12) {
                vm.currentMonth = 1;
                vm.currentYear = Number(vm.currentYear) + 1;
            } else {
                vm.currentMonth = Number(vm.currentMonth) + 1;
            }
            vm.loadStaffOccupation();
            loadCalendar();
        }

        function loadCalendar() {
            vm.calendar = Timecard.calendar({'year':vm.currentYear,'month':vm.currentMonth});
        }

        function staffSingeAdd() {
            $rootScope.userList = vm.userList;
            $rootScope.groupId = vm.groupId;
            var modalInstance = $uibModal.open({
                templateUrl: 'app/timecard/staff-occupation/staff-single-add.html',
                controller: 'StaffSingleAddController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: {}
                }
            });

            modalInstance.result.then(function(result) {
                $state.go('staff-occupation', null, { reload: true });
            },function(){
                if(!$rootScope.addFlag){
                    $state.go('staff-occupation');
                    var user = $rootScope.user;
                    if(user.lastName == null) {
                        user.lastName = '';
                    }
                    if(user.firstName == null) {
                        user.firstName = '';
                    }
                    vm.selectFlag = true;
                    var u = {};
                    u.id = null;
                    u.userId = user.id;
                    u.groupId = vm.groupId;
                    u.userName = user.lastName + ' ' + user.firstName;
                    u.occupationId = '';
                    u.dutyId = '';
                    u.showFlag = true;
                    u.firstFlag = true;
                    u.deleteFlag = false;
                    u.rowspan = 1;
                    vm.userList.splice(0,0,u);
                }

            })
            vm.staffIsNullFlag = true;
            //$state.go('staff-occupation.selectuser');
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('staff-occupation', {
            parent: 'app',
            url: '/timecard/staff-occupation/:currentYear/:currentMonth',
            data: {
                pageTitle: 'global.menu.timecard.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/staff-occupation/staff-occupation-detail.html',
                    controller: 'StaffOccupationDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                groupId: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),

                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('staff-occupation');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService',  'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            var gtc_caretree2_timecard_allfunction_fullaccess = false;
                            var isAdmin = false;
                            var isDeveloper = false;
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Shift_AllFunction_FullAccess"}, function(result){
                                if (!result.flag) {
                                    $state.go('accessdenied');
                                } else {
                                    //plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                                }
                            });
                        } else {
                            LoginService.open();
                        }

                    });
                }]
        })
        .state('staff-occupation.selectuser', {
            parent: 'staff-occupation',
            url: '/selectuser',
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                Principal.identity().then(function(account) {
                    $uibModal.open({
                        templateUrl: 'app/timecard/staff-occupation/staff-single-add.html',
                        controller: 'StaffSingleAddController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: {}
                        }
                    }).result.then(function() {
                        $state.go('staff-occupation', null, { reload: true });
                    }, function() {
                        $state.go('staff-occupation');
                    });
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('StaffOccupation', StaffOccupation);

    StaffOccupation.$inject = ['$resource'];

    function StaffOccupation ($resource) {
        var service = $resource('timecard/api/staffOccupation', {}, {
            'queryDuty': {
                method: 'POST',
                url: 'timecard/api/staffOccupation/getDutyByUserId',
                isArray: true
            },
            'queryDutyOccupation': {
                method: 'POST',
                url: 'timecard/api/staffOccupation/getDutyOccupationByUserId',
                isArray: true
            },
            'deletedStaffOccupation': {
                method: 'POST',
                url: 'timecard/api/staffOccupation/deletedStaffOccupation'
            },
            'queryStaffOccupation': {
                method: 'POST',
                url: 'timecard/api/staffOccupation/getStaffOccupation',
                isArray: true
            },
            'queryStaffOccupationByGroupId': {
                method: 'GET',
                url: 'timecard/api/staffOccupation/getStaffOccupationByGroupId',
                isArray: true
            },
            'queryUserByGroupId': {
                method: 'GET',
                url: 'timecard/api/staffOccupation/getUserByGroupId',
                isArray: true
            },
            'queryCount': {
                method: 'GET',
                url: 'timecard/api/staffOccupation/getCount'
            },
            'queryStaffDuty': {
                method: 'GET',
                url: 'timecard/api/staffOccupation/getStaffDuty',
                isArray: true
            },
            'save': {
                method: 'POST',
                url:'timecard/api/staffOccupation/save'
            },
            'delete': {
                method: 'DELETE',
                url:'timecard/api/staffOccupation/delete/:id'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Shokushu', Shokushu);

    Shokushu.$inject = ['$resource'];

    function Shokushu ($resource) {
        var service = $resource('timecard/api/shokushus', {}, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get':{
                method: 'GET',
                url: 'timecard/api/shokushus/:id'
            },
            'load': {
                method: 'POST',
                url: 'timecard/api/shokushus/caretree',
                isArray: true
            },
            'import': {
                method: 'POST',
                url: 'timecard/api/shokushus/import',
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method:'PUT'
            },
            'enum':{
                url: 'timecard/api/enum/:name',
                method: 'GET',
                isArray: true
            },
            'delete': {
                method:'DELETE',
                url:'timecard/api/shokushus/:id'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('shokushu-management', {
                parent: 'app',
                url: '/timeca/Jobtype',
                data: {
                    pageTitle: 'shokushuManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/timecard/shokushu-management/shokushu-management.html',
                        controller: 'ShokushuManagementController',
                        controllerAs: 'vm'
                    }
            	},
            	params: {
            		groupId: null,
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shokushu-management');
                        return $translate.refresh();
                    }]

                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',
                    function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                	var top = $uibModalStack.getTop();
                	if (top) {
                	    $uibModalStack.dismiss(top.key);
                	}
                    Principal.identity().then(function(account) {
                    	if (account != null) {
                            var gtc_caretree2_timecard_allfunction_fullaccess = false;
                            var isAdmin = false;
                            var isDeveloper = false;
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_TimeCard_AllFunction_FullAccess"}, function(result){
                            	if (!result.flag) {
                            		$state.go('accessdenied');
                            	} else {
                            		plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                            	}
                            });
                    	} else {
                    		LoginService.open();
                    	}
                    	
                    });
                }]
            })
            .state('shokushu-management-detail', {
                parent: 'shokushu-management',
                url: '/shokushu/:id',
                data: {
                    pageTitle: 'shokushu-management.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/timecard/shokushu-management/shokushu-management-detail.html',
                        controller: 'ShokushuManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shokushu-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('shokushu-management.new', {
                parent: 'shokushu-management',
                url: '/new',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
                	$uibModal.open({
                        templateUrl: 'app/timecard/shokushu-management/shokushu-management-dialog.html',
                        controller: 'ShokushuManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null, groupId: null, shokushuCd: null, shokushuName: null, type: null,
                                    createdBy: null, createdDate: null,
                                    lastModifiedBy: null, lastModifiedDate: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('shokushu-management', null, { reload: true });
                    }, function() {
                        $state.go('shokushu-management');
                    });
                }]
            })
            .state('shokushu-management.import', {
	            parent: 'shokushu-management',
	            url: '/import/{id}',
	            data: {
	            },
	            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
	            	$uibModal.open({
                        templateUrl: 'app/timecard/shokushu-management/shokushu-management-import.html',
                        controller: 'ShokushuManagementImportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function() {
                        $state.go('shokushu-management', null, { reload: true });
                    }, function() {
                        $state.go('shokushu-management');
                    });
	            }]
	        })
            .state('shokushu-management.edit', {
                parent: 'shokushu-management',
                url: '/edit/{id}',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
                	$uibModal.open({
                        templateUrl: 'app/timecard/shokushu-management/shokushu-management-dialog.html',
                        controller: 'ShokushuManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Shokushu', function(Shokushu) {
                                return Shokushu.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('shokushu-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('shokushu-management.delete', {
                parent: 'shokushu-management',
                url: '/{id}/delete',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
                	$uibModal.open({
                        templateUrl: 'app/timecard/shokushu-management/shokushu-management-delete-dialog.html',
                        controller: 'ShokushuManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Shokushu', function(Shokushu) {
                                return Shokushu.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('shokushu-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_TimeCard_AllFunction_FullAccess') {
                    gtc_caretree2_timecard_allfunction_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_timecard_allfunction_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShokushuManagementImportController',ShokushuManagementImportController);

    ShokushuManagementImportController.$inject = ['$state','$stateParams', '$uibModalInstance','Shokushu','Group'];

    function ShokushuManagementImportController ($state, $stateParams, $uibModalInstance, Shokushu, Group) {
        var vm = this;

        vm.groupId = $stateParams.id;
        vm.shokushuList = [];
        vm.clear = clear;
        vm.save = save;

        Group.caretree({groupId:vm.groupId},function(result){
            Shokushu.load(result,function(data){
                vm.shokushuList = data;
            },function(error){

            });
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            var data = {'groupId':vm.groupId,'shokushuList':vm.shokushuList};
            Shokushu.import(data,function (result) {
                vm.clear();
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShokushuManagementDialogController',ShokushuManagementDialogController);

    ShokushuManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'Shokushu', 'JhiLanguageService','Group', 'MessageService', '$timeout', '$rootScope'];

    function ShokushuManagementDialogController ($stateParams, $uibModalInstance, entity, Shokushu, JhiLanguageService, Group, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.groups = [];
        vm.clear = clear;
        vm.loadAllGroups = loadAllGroups;
        vm.save = save;
        vm.shokushu = entity;
        vm.enumShokushuType = Shokushu.enum({"name":"ShokushuType"},function(result){
            console.log(result);
        });

        vm.loadAllGroups();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            MessageService.success("global.messages.info.save");
            $uibModalInstance.close(result);
            $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
        }

        function onSaveError () {
            vm.isSaving = false;
            MessageService.error("global.messages.error.save");
        }

        function save () {
            vm.isSaving = true;
            if (vm.shokushu.id !== null) {
                Shokushu.update(vm.shokushu, onSaveSuccess, onSaveError);
            } else {
                Shokushu.save(vm.shokushu, onSaveSuccess, onSaveError);
            }
        }

        function loadAllGroups() {
            Group.query({}, function(result){
                vm.groups = result;
            });
        }
        // function loadAllGroups() {
        //     Group.parentGroup({}, function(result){
        //         vm.groups = result;
        //     });
        // }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShokushuManagementDetailController', ShokushuManagementDetailController);

    ShokushuManagementDetailController.$inject = ['$stateParams', 'Shokushu','Group'];

    function ShokushuManagementDetailController($stateParams, Shokushu, Group) {
        var vm = this;

        vm.load = load;
        vm.shokushu = {};
        vm.groups = [];
        vm.load($stateParams.id);

        function load(id) {
            Shokushu.get({id: id}, function(result) {
                vm.shokushu = result;
                Group.get({"id":vm.shokushu.groupId}, function(result){
                    vm.groups = result;
                    console.log(vm.groups);
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShokushuManagementDeleteController', ShokushuManagementDeleteController);

    ShokushuManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Shokushu', 'MessageService', '$timeout', '$rootScope'];

    function ShokushuManagementDeleteController ($uibModalInstance, entity, Shokushu, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.shokushu = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            Shokushu.delete({id: vm.shokushu.id},
                function () {
                    MessageService.success("global.messages.info.delete");
                    $uibModalInstance.close(true);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShokushuManagementController', ShokushuManagementController);

    ShokushuManagementController.$inject = ['Shokushu', 'Group','ParseLinks', 'MessageService', '$state', 'pagingParams', 'paginationConstants', '$stateParams'];

    function ShokushuManagementController(Shokushu, Group, ParseLinks, MessageService, $state, pagingParams, paginationConstants, $stateParams) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.shokushus = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.selectGroup = $stateParams.groupId;
        vm.parentGroup = [];
        vm.loadParentGroup = loadParentGroup;
        vm.changeGroup = changeGroup;
        vm.loadParentGroup();

        function loadAll () {
            Shokushu.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                groupId: vm.selectGroup == null ? "" : vm.selectGroup
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.shokushus = data;
        }

        function onError(error) {
            MessageService.error(error.data.message);
        }

        function clear () {
            vm.shokushu = {
                id: null, shokushuCd: null, shokushuName: null, salary: null,
                createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                groupId: vm.selectGroup == null ? "" : vm.selectGroup
            });
        }

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                if (vm.selectGroup == null || vm.selectGroup == "") {
                	vm.selectGroup = vm.parentGroup[0]["id"];
                }
                loadAll ();
            });
        }

        function changeGroup() {
            Shokushu.query({
                page: 0,
                size: vm.itemsPerPage,
                sort: sort(),
                groupId: vm.selectGroup == null ? "" : vm.selectGroup
            }, onSuccess, onError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShiftTimeDetailController', ShiftTimeDetailController);

    ShiftTimeDetailController.$inject = ['$scope', '$state', 'AlertService', '$timeout', '$stateParams', '$rootScope' , 'User', 'Group', 'ShiftTime','pagingParams','paginationConstants','ParseLinks'];

    function ShiftTimeDetailController ($scope, $state, AlertService, $timeout,$stateParams,$rootScope, User, Group, ShiftTime,pagingParams,paginationConstants,ParseLinks) {
        var vm = this;
        var regex = /^([01]\d|2[0-3]):?([0-5]\d)$/;
        var regex2 = /^([01]\d|2[0-3])([0-5]\d)$/;
        var regex3 = /^[0-9]{1,7}$/;

        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.state = 1;
        vm.houjinFlag = false;
        vm.selectGroupFlag = false;
        vm.reloadHoujinTimeZoneFlag = false;
        vm.timeZoneIsNullFlag = false;
        vm.codeSaveFlag = false;
        vm.nameSaveFlag = false;
        vm.parentFlag = false;
        vm.timeType = false;

        vm.parentGroup = [];
        vm.resultList = [];
        vm.shiftTimeList = [];
        vm.groupAllList = [];
        vm.goEdit = goEdit;
        vm.goAdd = goAdd;
        vm.goCancel = goCancel;
        vm.changeState = changeState;
        vm.codeUniqueCheck = codeUniqueCheck;
        vm.nameUniqueCheck = nameUniqueCheck;

        //页面加载时，取得所有的Group
        vm.loadParentGroup = loadParentGroup;
        //Group切换
        vm.changeGroup = changeGroup;
        vm.save = save;
        vm.loadShiftTime = loadShiftTime;
        vm.goDel = goDel;
        vm.startTimeUpdate = startTimeUpdate;
        vm.endTimeUpdate = endTimeUpdate;
        vm.restTimeUpdate = restTimeUpdate;
        vm.reloadHoujinTimeZone = reloadHoujinTimeZone;

        //页面加载后取得所有Group信息
        vm.loadParentGroup();

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                if ($stateParams.groupId !== null) {
                    result.forEach(function(item){
                        if (item.id == $stateParams.groupId) {
                            vm.group = item;
                        }
                    });
                } else {
                    vm.group = vm.parentGroup[0];
                }
                vm.groupId = vm.group.id;
                vm.loadShiftTime();
            });
        }

        function loadShiftTime () {
            //当前group为parentId==0的group
            if(vm.group.parentId == ''){
                vm.parentFlag = true;
            }
            ShiftTime.getAll({"groupId":vm.groupId, "state":vm.state}, function(result, headers){
                vm.resultList = result;
                vm.shiftTimeList = angular.copy(result);
                vm.timeZoneIsNullFlag = false;
                //自己没有，则找父
                if(vm.resultList.length == 0){
                    Group.parentGroupList({"groupId":vm.groupId}, function(result){
                        var gid = "";
                        for(var i=0; i<result.length; i++) {
                            if(i == 0){
                                gid += "gid" + result[i].id;
                            }else {
                                gid += ",gid" + result[i].id;
                            }
                        }
                        ShiftTime.getParentAll({"groupId":gid, "state":vm.state}, function(result, headers){
                            if(result.length==0){
                                vm.timeZoneIsNullFlag = false;
                                var shift = {};
                                shift.id = null;
                                shift.code = "";
                                shift.name = "";
                                shift.startTime = "";
                                shift.endTime = "";
                                shift.state = 1;
                                shift.showFlag = false;
                                vm.resultList.push(shift);
                            }else {
                                vm.resultList = result;
                                vm.timeZoneIsNullFlag = true;
                            }
                        })
                    });
                }
            });
        }

        function changeState() {
            loadShiftTime();
        }

        function goEdit(shiftTime){
            shiftTime.showFlag = false;
        }

        function goCancel(shiftTime, index){
            vm.timeType = false;
            shiftTime.startTimeError = false;
            shiftTime.endTimeError = false;
            vm.shiftTimeList.forEach(function (shift) {
                if(shift.id == shiftTime.id){
                    shiftTime.showFlag = true;
                    shiftTime.code = shift.code;
                    shiftTime.name = shift.name;
                    shiftTime.startTime = shift.startTime;
                    shiftTime.endTime = shift.endTime;
                    shiftTime.state = shift.state;
                    shiftTime.restTime = shift.restTime;
                    codeUniqueCheck (shiftTime, index);
                    nameUniqueCheck (shiftTime, index);
                }
            });
        }

        function goAdd(index) {
            var shift = {};
            shift.id = null;
            shift.code = "";
            shift.name = "";
            shift.startTime = "";
            shift.endTime = "";
            shift.state = 1;
            shift.showFlag = false;
            shift.restTime = "";
            vm.resultList.splice(index+1,0,shift);
        }

        function goDel(index) {
            if(vm.resultList[index].id == null){
                vm.resultList.splice(index, 1);
            }else{
                ShiftTime.delete({id:vm.resultList[index].id}, onSaveSuccess, onSaveError);
            }
        }

        function changeGroup() {
            loadShiftTime();
        }

        function save(){
            if(confirm("一括保存してもよろしいでしょうか")){
                if(vm.reloadHoujinTimeZoneFlag){
                    if(confirm("シフト時間帯を再設定すると既存データを削除してもよろしいでしょうか")){
                        ShiftTime.save({groupId:vm.groupId,shiftList:vm.resultList, reloadHoujinTimeZoneFlag:vm.reloadHoujinTimeZoneFlag}, onSaveSuccess, onSaveError);
                    }
                }else {
                    ShiftTime.save({groupId:vm.groupId,shiftList:vm.resultList, reloadHoujinTimeZoneFlag:vm.reloadHoujinTimeZoneFlag}, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess (result) {
            vm.reloadHoujinTimeZoneFlag = false;
            loadShiftTime();
        }

        function onSaveError (result) {
            vm.resultList = result.data.shiftList;
        }

        function startTimeUpdate(shiftTimeZone, index, shiftTimeZoneList){
            var startTime = $("#startTime"+index).val();
            if (shiftTimeZone.startTime == null || shiftTimeZone.startTime == "") {
                shiftTimeZone.startTimeError = false;
            } else if (regex.test(startTime)) {
                shiftTimeZone.startTimeError = false;
            } else {
                shiftTimeZone.startTimeError = true;
            }
            saveFlag(shiftTimeZoneList);
        }

        function endTimeUpdate(shiftTimeZone, index, shiftTimeZoneList) {
            var endTime = $("#endTime"+index).val();
            if (shiftTimeZone.endTime == null || shiftTimeZone.endTime == "") {
                shiftTimeZone.endTimeError = false;
            } else if (regex.test(endTime)) {
                shiftTimeZone.endTimeError = false;
            } else {
                shiftTimeZone.endTimeError = true;
            }
            saveFlag(shiftTimeZoneList);
        }
        
        function restTimeUpdate(shiftTimeZone, index, shiftTimeZoneList) {
            shiftTimeZone.restTime = $("#restTime"+index).val();
            if (shiftTimeZone.restTime == null || shiftTimeZone.restTime == "") {
                shiftTimeZone.restTimeError = false;
            } else if (regex3.test(shiftTimeZone.restTime)) {
                shiftTimeZone.restTimeError = false;
            } else {
                shiftTimeZone.restTimeError = true;
            }
            saveFlag(shiftTimeZoneList);
        }

        function saveFlag(shiftTimeZoneList) {
            //跳出循环用
            var breakFlag = true;
            angular.forEach(shiftTimeZoneList, function(data){
                if(breakFlag) {
                    vm.timeType = false;
                    if(data.endTimeError == true || data.startTimeError == true || data.restTimeError == true) {
                        vm.timeType = true;
                        breakFlag = false;
                    }
                }
            });
        }

        function reloadHoujinTimeZone () {
            vm.reloadHoujinTimeZoneFlag = true;
            /*Group.queryParentGroupId({"groupId":vm.groupId}, function (group) {
                //当前用户的父groupId
                var groupId = "gid" + group.groupId;
                ShiftTime.getAll({"groupId":groupId, "state":vm.state}, function(result, headers){
                    result.forEach(function(item) {
                        item.id = null;
                    });
                    vm.resultList = result;
                    vm.shiftTimeList = angular.copy(result);
                });
            });*/
            //找自己的父类的值
            Group.parentGroupList({"groupId":vm.groupId}, function(result){
                var gid = "";
                var group = vm.groupId.substring()
                for(var i=0; i<result.length; i++) {
                    //除过自己
                    var tmp = "gid" + result[i].id;
                    if(tmp != vm.groupId){
                        if(gid == ""){
                            gid += "gid" + result[i].id;
                        }else {
                            gid += ",gid" + result[i].id;
                        }
                    }
                }
                ShiftTime.getParentAll({"groupId":gid, "state":vm.state}, function(result, headers){
                    result.forEach(function(item) {
                        item.id = null;
                        item.showFlag = false;
                    });
                    vm.resultList = result;
                    vm.shiftTimeList = angular.copy(result);
                })
            });
        }

        function codeUniqueCheck (shiftTimeZone, index) {
            if(shiftTimeZone.code != null && shiftTimeZone.code != "") {
                shiftTimeZone.codeRequiredFlag = false;
            }
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].code == shiftTimeZone.code && index != i){
                    shiftTimeZone.codeSingleFlag = true;
                    vm.codeSaveFlag = true;
                    break;
                }else {
                    shiftTimeZone.codeSingleFlag = false;
                    vm.codeSaveFlag = false;
                }
            }
        }

        function nameUniqueCheck (shiftTimeZone, index) {
            if(shiftTimeZone.name != null && shiftTimeZone.name != "") {
                shiftTimeZone.nameRequiredFlag = false;
            }
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].name == shiftTimeZone.name && index != i){
                    shiftTimeZone.nameSingleFlag = true;
                    vm.nameSaveFlag = true;
                    break;
                }else {
                    shiftTimeZone.nameSingleFlag = false;
                    vm.nameSaveFlag = false;
                }
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('shift-time', {
            parent: 'app',
            url: '/timecard/shift-time',
            data: {
                pageTitle: 'global.menu.timecard.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/shift-time/shift-time-detail.html',
                    controller: 'ShiftTimeDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                groupId: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('shift-time');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService',  'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            var gtc_caretree2_timecard_allfunction_fullaccess = false;
                            var isAdmin = false;
                            var isDeveloper = false;
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Shift_AllFunction_FullAccess"}, function(result){
                                if (!result.flag) {
                                    $state.go('accessdenied');
                                } else {
                                    //plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                                }
                            });
                        } else {
                            LoginService.open();
                        }

                    });
                }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ShiftTime', ShiftTime);

    ShiftTime.$inject = ['$resource'];

    function ShiftTime ($resource) {
        var service = $resource('timecard/api/shift', {}, {
            'getAll': {
                method: 'GET',
                url:'timecard/api/shiftTime/all',
                isArray: true
            },
            'getParentAll': {
                method: 'GET',
                url:'timecard/api/shiftTimeParent/all',
                isArray: true
            },
            'getOneById': {
                method: 'GET',
                url:'timecard/api/shiftTime/getOneById'
            },
            'getStateAll': {
                method: 'GET',
                url:'timecard/api/shiftTime/allByState',
                isArray: true
            },
            'getMonthStateAll': {
                method: 'GET',
                url:'timecard/api/shiftTime/monthAllByState',
                isArray: true
            },
            'getMontTimeZoneAll': {
                method: 'GET',
                url:'timecard/api/shiftTime/getMontTimeZoneAll',
                isArray: true
            },
            'getStateAlreadySave': {
                method: 'GET',
                url:'timecard/api/shiftTime/getStateAlreadySave',
                isArray: true
            },
            'getMonthStateAlreadySave': {
                method: 'GET',
                url:'timecard/api/shiftTime/getMonthStateAlreadySave',
                isArray: true
            },
            'save': {
                method: 'POST',
                url:'timecard/api/shiftTime/save'
            }
            ,
            'delete': {
                method: 'DELETE',
                url:'timecard/api/shiftTime/delete/:id'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShiftOccupationDetailController', ShiftOccupationDetailController);

    ShiftOccupationDetailController.$inject = ['$scope', '$state', 'AlertService', '$timeout', '$stateParams', '$rootScope' , 'Shokushu', 'User', 'Group', 'ShiftOccupation','pagingParams','paginationConstants','ParseLinks'];

    function ShiftOccupationDetailController ($scope, $state, AlertService, $timeout,$stateParams,$rootScope, Shokushu, User, Group, ShiftOccupation,pagingParams,paginationConstants,ParseLinks) {
        var vm = this;

        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.parentGroup = [];
        vm.resultList = [];
        vm.shiftOccupationList= [];
        vm.state = 1;
        vm.houjinFlag = false;
        vm.selectGroupFlag = false;
        vm.groupAllList = [];
        vm.codeSaveFlag = false;
        vm.nameSaveFlag = false;
        vm.parentFlag = false;

        vm.goEdit = goEdit;
        vm.goAdd = goAdd;
        vm.goCancel = goCancel;
        vm.codeUniqueCheck = codeUniqueCheck;
        vm.nameUniqueCheck = nameUniqueCheck;

        //页面加载时，取得所有的Group
        vm.loadParentGroup = loadParentGroup;
        //Group切换
        vm.changeGroup = changeGroup;
        vm.save = save;
        vm.loadShiftOccupation = loadShiftOccupation;
        vm.goDel = goDel;
        vm.changeState = changeState;

        //页面加载后取得所有Group信息
        vm.loadParentGroup();

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                if ($stateParams.groupId !== null) {
                    result.forEach(function(item){
                        if (item.id == $stateParams.groupId) {
                            vm.group = item;
                        }
                    });
                } else {
                    vm.group = vm.parentGroup[0];
                }
                vm.groupId = vm.group.id;
                vm.loadShiftOccupation();
            });
        }

        function loadShiftOccupation () {
            //如果父groupId = 0,则可以编辑，否则不可以编辑
            vm.parentGroup.forEach(function (item) {
                if(vm.groupId == item.id){
                    if(item.parentId == ''){
                        vm.parentFlag = true;
                    }else {
                        vm.parentFlag = false;
                    }
                }
            });
            //如果group为parentId==0的group则直接查询
            if(vm.parentFlag) {
                ShiftOccupation.getAll({"groupId":vm.groupId, "state":vm.state}, function(result, headers){
                    vm.resultList = result;
                    vm.shiftOccupationList = angular.copy(result);
                    if(vm.resultList.length==0){
                        var shift = {};
                        shift.id = null;
                        shift.code = "";
                        shift.name = "";
                        shift.state = 1;
                        shift.showFlag = false;
                        vm.resultList.push(shift);
                    }
                });
            //否则查父group的
            }else {
                Group.queryParentGroupId({"groupId":vm.groupId}, function (group) {
                    //当前用户的父groupId
                    var groupId = "gid" + group.groupId;
                    ShiftOccupation.getAll({"groupId":groupId, "state":vm.state}, function(result, headers){
                        vm.resultList = result;
                    });
                });
            }
            /*Group.groupList({"depth": 0}, function(groupList){
                vm.groupAllList = groupList;
                for(var i=0; i<groupList.length; i++){
                    if(!vm.houjinFlag){
                        for(var x=0; x<groupList[i].flags.length; x++){
                            if(groupList[i].flags[x].id == 2){
                                vm.houjinFlag = true;
                                break;
                            }
                        }
                    }
                }
                //如果是法人，直接根据groupId查询
                if(vm.houjinFlag){
                    ShiftOccupation.getAll({"groupId":vm.group.id, "state":vm.state}, function(result, headers){
                        vm.resultList = result;
                        vm.shiftOccupationList = angular.copy(result);
                        if(vm.resultList.length==0){
                            var shift = {};
                            shift.id = null;
                            shift.code = "";
                            shift.name = "";
                            shift.state = 1;
                            shift.showFlag = false;
                            vm.resultList.push(shift);
                        }
                    });
                 //普通用户则查找他父节点的所有的数据
                }else {
                    Group.queryParentGroupId({"groupId":vm.group.id}, function (group) {
                        //当前用户的父groupId
                        var groupId = "gid" + group.groupId;
                        ShiftOccupation.getAll({"groupId":groupId, "state":vm.state}, function(result, headers){
                            vm.resultList = result;
                            vm.shiftOccupationList = angular.copy(result);
                            if(vm.resultList.length==0){
                                var shift = {};
                                shift.id = null;
                                shift.code = "";
                                shift.name = "";
                                shift.state = 1;
                                shift.showFlag = false;
                                vm.resultList.push(shift);
                            }
                        });
                    });
                }
            });*/
        }

        function goEdit(shiftOccupation){
            shiftOccupation.showFlag = false;
        }

        function goCancel(shiftOccupation, index){
            vm.shiftOccupationList.forEach(function (shift){
                if(shift.id == shiftOccupation.id){
                    shiftOccupation.showFlag = true;
                    shiftOccupation.code = shift.code;
                    shiftOccupation.name = shift.name;
                    shiftOccupation.state = shift.state;
                    codeUniqueCheck (shiftOccupation, index);
                    nameUniqueCheck (shiftOccupation, index);
                }
            });
        }

        function goAdd(index) {
            var shift = {};
            shift.id = null;
            shift.code = "";
            shift.name = "";
            shift.state = 1;
            shift.showFlag = false;
            vm.resultList.splice(index+1,0,shift);
        }

        function goDel(index) {
            if(vm.resultList[index].id == null){
                vm.resultList.splice(index, 1);
            }else{
                ShiftOccupation.delete({id:vm.resultList[index].id}, onSaveSuccess, onSaveError);
            }
        }

        function changeGroup() {
            vm.loadShiftOccupation();
        }

        function save(){
            if(confirm("一括保存してもよろしいでしょうか")){
                ShiftOccupation.save({groupId:vm.group.id,shiftList:vm.resultList}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            loadShiftOccupation();
        }

        function onSaveError (result) {
            vm.resultList = result.data.shiftList;
        }

        function changeState() {
            loadShiftOccupation();
        }

        function codeUniqueCheck (shiftOccupation, index) {
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].code == shiftOccupation.code && index != i){
                    shiftOccupation.codeSingleFlag = true;
                    vm.codeSaveFlag = true;
                    break;
                }else {
                    shiftOccupation.codeSingleFlag = false;
                    vm.codeSaveFlag = false;
                }
            }
        }

        function nameUniqueCheck (shiftOccupation, index) {
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].name == shiftOccupation.name && index != i){
                    shiftOccupation.nameSingleFlag = true;
                    vm.nameSaveFlag = true;
                    break;
                }else {
                    shiftOccupation.nameSingleFlag = false;
                    vm.nameSaveFlag = false;
                }
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('shift-occupation', {
            parent: 'app',
            url: '/timecard/shift-occupation',
            data: {
                pageTitle: 'global.menu.timecard.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/shift-occupation/shift-occupation-detail.html',
                    controller: 'ShiftOccupationDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                groupId: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('shift-occupation');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService',  'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            var gtc_caretree2_timecard_allfunction_fullaccess = false;
                            var isAdmin = false;
                            var isDeveloper = false;
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Shift_AllFunction_FullAccess"}, function(result){
                                if (!result.flag) {
                                    $state.go('accessdenied');
                                } else {
                                    //plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                                }
                            });
                        } else {
                            LoginService.open();
                        }

                    });
                }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ShiftOccupation', ShiftOccupation);

    ShiftOccupation.$inject = ['$resource'];

    function ShiftOccupation ($resource) {
        var service = $resource('timecard/api/shift', {}, {
            'getAll': {
                method: 'GET',
                url:'timecard/api/shiftOccupation/all',
                isArray: true
            },
            'getAllByGroupId': {
                method: 'GET',
                url:'timecard/api/shiftOccupation/getAllByGroupId',
                isArray: true
            },
            'save': {
                method: 'POST',
                url:'timecard/api/shiftOccupation/save'
            }
            ,
            'delete': {
                method: 'DELETE',
                url:'timecard/api/shiftOccupation/delete/:id'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShiftMonthDetailController', ShiftMonthDetailController);

    ShiftMonthDetailController.$inject = ['$scope', '$state', 'AlertService', '$timeout', '$stateParams', '$rootScope' , 'Timecard', 'Shokushu', 'User', 'Group', 'ShiftMonth', 'ShiftTime','pagingParams','paginationConstants','ParseLinks', 'Principal', 'ShiftOccupation'];

    function ShiftMonthDetailController ($scope, $state, AlertService, $timeout,$stateParams,$rootScope, Timecard, Shokushu, User, Group, ShiftMonth, ShiftTime,pagingParams,paginationConstants,ParseLinks,Principal, ShiftOccupation) {
        var vm = this;
        vm.page = 1;
        vm.totalItems = null;
        vm.currentYear = $stateParams.currentYear;
        vm.currentMonth = $stateParams.currentMonth;
        vm.timeZoneList = [];
        vm.weekdays = [{"week":'第１週'},{"week":'第２週'},{"week":'第３週'},{"week":'第４週'},{"week":'第５週'}];
        vm.weekCount = 5;
        vm.surplusDays = 0;
        vm.userStaffOccupation = [];
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.timeZone = {};
        vm.type = 0;
        //vm.monthWidth = 1000;
        vm.day29ShowFlag = false;
        vm.day30ShowFlag = false;
        vm.day31ShowFlag = false;
        vm.calendar = null;
        vm.row = 0;
        vm.column = 0;
        vm.yoteiTimeZoneCountList = [];
        vm.jissekiTimeZoneCountList = [];
        vm.yoteiWeekCountList = [];
        vm.jissekiWeekCountList = [];
        vm.days = 0;
        vm.confirmShowFlag = 0;
        vm.changeFlag = false;
        vm.tableHeight = 0;
        vm.messageWidth = 0;
        vm.tableWidth = 2285;
        vm.divWidth = 3082;
        vm.commentHeight = 0;
        vm.comment = "";
        vm.houjinFlag = false;
        vm.groupAllList = [];
        vm.selectGroupFlag = false;
        vm.exportHoujinFlag = false;
        vm.childrenGroupList = "";
        vm.adminFlg = false;
        vm.occupationList = [];
        vm.occupationId = '0';

        vm.changeGroup = changeGroup;
        vm.changeOccupation = changeOccupation;
        vm.rest = rest;
        vm.beforeMonth = beforeMonth;
        vm.nextMonth = nextMonth;
        vm.colorChange = colorChange;
        vm.columnClick = columnClick;
        vm.yoteiRowClick = yoteiRowClick;
        vm.jissekiRowClick = jissekiRowClick;
        vm.yoteiDayClick = yoteiDayClick;
        vm.jissekiDayClick = jissekiDayClick;
        vm.weekClick = weekClick;
        vm.yoteiMousemove = yoteiMousemove;
        vm.jissekiMousemove = jissekiMousemove;
        vm.confirmClick = confirmClick;
        vm.cancelClick = cancelClick;
        vm.save = save;
        vm.transition = transition;
        vm.loadOccupation = loadOccupation;

        if (!angular.isDefined(vm.currentYear) || vm.currentYear == "") {
            vm.currentYear = new Date().getFullYear();
        }
        if (!angular.isDefined(vm.currentMonth) || vm.currentMonth == "") {
            vm.currentMonth = new Date().getMonth()+1;
        }

        vm.loadParentGroup = loadParentGroup;
        vm.loadCalendar = loadCalendar;
        vm.loadShiftMonth = loadShiftMonth;
        vm.yoteiMousedown = yoteiMousedown;
        vm.jissekiMousedown = jissekiMousedown;
        vm.yoteiDisabledFlag = false;
        vm.jissekiDisabledFlag = true;
        vm.updateDate = updateDate;

        //页面加载后取得所有Group信息
        vm.loadParentGroup();
        vm.loadCalendar();

        function loadOccupation() {
            Group.queryParentGroupId({"groupId":vm.groupId}, function (group) {
                //当前用户的父groupId
                var groupId = "gid" + group.groupId;
                ShiftOccupation.getAllByGroupId({"groupId":groupId}, function(result){
                    vm.occupationList = result;
                });
            });
        }
        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                if ($stateParams.groupId !== null) {
                    result.forEach(function(item){
                        if (item.id == $stateParams.groupId) {
                            vm.group = item;
                        }
                    });
                } else {
                    vm.group = vm.parentGroup[0];
                }
                vm.groupId = vm.group.id;
                vm.groupName = vm.group.name;
                vm.loadOccupation();
                vm.loadShiftMonth();
            });
            //vm.monthWidth = $("#div").width() - 350;
        }

        function rest(){
            vm.comment = "";
            vm.confirmShowFlag = 0;
            vm.currentYear = new Date().getFullYear();
            vm.currentMonth = new Date().getMonth()+1;
            vm.loadCalendar();
            vm.loadShiftMonth();
        }

        function beforeMonth(){
            vm.comment = "";
            vm.confirmShowFlag = 0;
            if (Number(vm.currentMonth) === 1) {
                vm.currentMonth = 12;
                vm.currentYear = Number(vm.currentYear) - 1;
            } else {
                vm.currentMonth = Number(vm.currentMonth) - 1;
            }
            vm.loadCalendar();
            vm.loadShiftMonth();
        }

        function nextMonth(){
            vm.comment = "";
            vm.confirmShowFlag = 0;
            if (Number(vm.currentMonth) === 12) {
                vm.currentMonth = 1;
                vm.currentYear = Number(vm.currentYear) + 1;
            } else {
                vm.currentMonth = Number(vm.currentMonth) + 1;
            }
            vm.loadCalendar();
            vm.loadShiftMonth();
        }

        function loadTimeZone(){
            ShiftTime.getMontTimeZoneAll({"groupId":vm.groupId, "year":vm.currentYear,"month":vm.currentMonth}, function(result){
                vm.timeZoneList = result;
                vm.timeZone = result[0];
                count();
                weekCount();
                changeJissekiColor();
                resetColor();
                if(vm.selectGroupFlag){
                    resetHoujinColor();
                }
                angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                    var rowHright = $("#yoteiRowHeight"+r).height() + $("#jissekiRowHeight"+r).height();
                    entity.rowHeight = rowHright/2;
                    //计算每个子group的时间带
                    //预定
                    var yoteiSingleTimeZoneList = [];
                    vm.timeZoneList.forEach(function (timezome){
                        var yoteiSingleTime = {};
                        yoteiSingleTime.name = timezome.name;
                        entity.monthShiftYotei.timeZoneCountDTO.forEach(function (yoteiTime){
                            if(timezome.name == yoteiTime.name){
                                yoteiSingleTime.id = yoteiTime.id
                                yoteiSingleTime.timeZoneCount = yoteiTime.timeZoneCount;
                            }
                        });
                        if (isNaN(yoteiSingleTime.id)){
                            yoteiSingleTime.id = timezome.id
                            yoteiSingleTime.timeZoneCount = 0;
                        }
                        yoteiSingleTimeZoneList.push(yoteiSingleTime);
                    });
                    entity.monthShiftYotei.timeZoneCountDTO = yoteiSingleTimeZoneList;
                    //实际
                    var jissekiSingleTimeZoneList = [];
                    vm.timeZoneList.forEach(function (timezome){
                        var jissekiSingleTime = {};
                        jissekiSingleTime.name = timezome.name;
                        entity.monthShiftJisseki.timeZoneCountDTO.forEach(function (jissekiTime){
                            if(timezome.name == jissekiTime.name){
                                jissekiSingleTime.id = jissekiTime.id
                                jissekiSingleTime.timeZoneCount = jissekiTime.timeZoneCount;
                            }
                        });
                        if (isNaN(jissekiSingleTime.id)){
                            jissekiSingleTime.id = timezome.id
                            jissekiSingleTime.timeZoneCount = 0;
                        }
                        jissekiSingleTimeZoneList.push(jissekiSingleTime);
                    });
                    entity.monthShiftJisseki.timeZoneCountDTO = jissekiSingleTimeZoneList;
                });
                //获取table真实宽度
                vm.tableWidth = 360+vm.days*45+125+vm.timeZoneList.length * 45;
                vm.divWidth = vm.tableWidth+ 20;
                setTimeout(function() {
                    changeHeight();
                },100);
            });
        }

        function getStateAlreadySave(timeZoneTotal){
            ShiftTime.getMonthStateAlreadySave({"timeZoneTotal":timeZoneTotal,"groupId": vm.groupId,
                    "year":vm.currentYear,"month":vm.currentMonth}, function(result){
                vm.timeZoneList = result;
                vm.timeZone = result[0];
                count();
                weekCount();
                changeJissekiColor();
                resetColor();
                if(vm.selectGroupFlag){
                    resetHoujinColor();
                }
                angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                    var rowHright = $("#yoteiRowHeight"+r).height() + $("#jissekiRowHeight"+r).height();
                    entity.rowHeight = rowHright/2;
                });
                //获取table真实宽度
                vm.tableWidth = 360+vm.days*45+125+vm.timeZoneList.length * 45;
                vm.divWidth = vm.tableWidth+ 20;
                setTimeout(function() {
                    changeHeight();
                },100);
            });
        }

        function loadCalendar() {
            vm.calendar = Timecard.calendar({'year':vm.currentYear,'month':vm.currentMonth},function () {
                vm.days = vm.calendar.days.length;
                vm.surplusDays = vm.calendar.days.length%7;
                if(vm.weekdays.length == 5){
                    if(vm.calendar.days.length<29){
                        vm.weekdays.splice(4,1);
                        vm.weekCount = 4;
                    }
                }
                if(vm.weekdays.length == 4){
                    if(vm.calendar.days.length>29){
                        vm.weekdays.splice(5,0,{"week":'第５週'});
                        vm.weekCount = 5;
                    }
                }
                if(vm.surplusDays == 0) {
                    vm.day29ShowFlag = false;
                    vm.day30ShowFlag = false;
                    vm.day31ShowFlag = false;
                }else if(vm.surplusDays == 1) {
                    vm.day29ShowFlag = true;
                    vm.day30ShowFlag = false;
                    vm.day31ShowFlag = false;
                }else if(vm.surplusDays == 2) {
                    vm.day29ShowFlag = true;
                    vm.day30ShowFlag = true;
                    vm.day31ShowFlag = false;
                }else if(vm.surplusDays == 3) {
                    vm.day29ShowFlag = true;
                    vm.day30ShowFlag = true;
                    vm.day31ShowFlag = true;
                }
            });
        }

        function loadShiftMonth() {
            Principal.hasGroupAuth(["admin"])
                .then(function (result) {
                    if (result) {
                        vm.adminFlg = true;
                    }
                });
            vm.childrenGroupList = "test";
            vm.exportHoujinFlag = false;
            getShiftMonth(vm.groupId, vm.occupationId, false);

            vm.changeFlag = false;
        }

        function getShiftMonth(groupId, occupationId, houjinFlag) {
            ShiftMonth.queryList({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                groupId: groupId,
                occupationId: occupationId,
                year: vm.currentYear,
                month: vm.currentMonth,
                houjinFlag: houjinFlag
            },function (result,headers) {
                vm.userStaffOccupation = result;
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                angular.forEach(vm.userStaffOccupation, function(data,index,array){
                    /*User.queryUserOne({id: data.userId}, function(result){
                        data.userName = result.lastName + " " + result.firstName;
                    });*/
                    if(data.monthShiftJisseki.comment != "" && data.monthShiftJisseki.comment != null){
                        vm.comment = data.monthShiftJisseki.comment;
                    }
                });
                loadTimeZone();
            });
        }
        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function colorChange () {
            if(vm.confirmShowFlag != 1) {
                if(vm.changeFlag){
                    alert("記録に変更があります。先に保存してください。");
                    if(vm.type == 0){
                        vm.type = 1
                    }else if(vm.type == 1) {
                        vm.type = 0
                    }
                }else{
                    angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                        if(vm.type == 0){
                            for(var i=1; i<=31; i++){
                                entity.monthShiftYotei['color'+i] = "white";
                                entity.monthShiftJisseki['color' + i] = "#EEEEEE";
                            }
                            vm.yoteiDisabledFlag = false;
                            vm.jissekiDisabledFlag = true;
                        }else if(vm.type == 1) {
                            for(var i=1; i<=31; i++){
                                entity.monthShiftYotei['color'+i] = "#EEEEEE";
                                entity.monthShiftJisseki['color' + i] = "white";
                            }
                            vm.yoteiDisabledFlag = true;
                            vm.jissekiDisabledFlag = false;
                        }
                    });
                }
            }
        }

        //双击天单元格触发整列选中
        function columnClick(value){
            if(vm.type == 0){
                if(confirm("該当日の予定設定をクリアしても大丈夫でしょうか")){
                    yoteiColumnClick(value);
                }
            } else if(vm.type == 1){
                if(confirm("該当日の実績設定をクリアしても大丈夫でしょうか")){
                    jissekiColumnClick(value);
                }
            }
        }
        function yoteiColumnClick(value){
            if(!vm.yoteiDisabledFlag){
                vm.changeFlag = true;
                angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                    entity.monthShiftYotei.yoteiChangeFlag = true;
                    entity.monthShiftYotei['day'+value] = "";
                    entity.monthShiftYotei['timeZoneName' + value] = "";
                });
                count();
                weekCount();
                changeJissekiColor();
            }
        }
        function jissekiColumnClick(value){
            if(!vm.jissekiDisabledFlag){
                vm.changeFlag = true;
                angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                    entity.monthShiftJisseki.jissekiChangeFlag = true;
                    entity.monthShiftJisseki['day'+value] = "";
                    entity.monthShiftJisseki['timeZoneName' + value] = "";

                });
                count();
                weekCount();
                changeJissekiColor();
            }
        }

        //双击预定单元格整行取消
        function yoteiRowClick(monthShift){
            if(!vm.yoteiDisabledFlag){
                if(confirm("該当スタッフの予定設定をクリアしても大丈夫でしょうか")){
                    vm.changeFlag = true;
                    monthShift.monthShiftYotei.yoteiChangeFlag = true;
                    for (var i = 1; i<=vm.days; i++) {
                        monthShift.monthShiftYotei['day'+i] = "";
                        monthShift.monthShiftYotei['timeZoneName'+i] = "";
                    }
                    count();
                    weekCount();
                    changeJissekiColor();
                }
            }
        }
        function jissekiRowClick(monthShift){
            if(!vm.jissekiDisabledFlag){
                if(confirm("該当スタッフの実績設定をクリアしても大丈夫でしょうか")){
                    if(vm.type == 1){
                        vm.changeFlag = true;
                        monthShift.monthShiftJisseki.jissekiChangeFlag = true;
                        for (var i = 1; i<=vm.days; i++) {
                            monthShift.monthShiftJisseki['day'+i] = "";
                            monthShift.monthShiftJisseki['timeZoneName'+i] = "";
                        }
                        count();
                        weekCount();
                        changeJissekiColor();
                    }
                }
            }
        }

        //单击单个单元格
        function yoteiDayClick (monthShift, value) {
            if(!vm.yoteiDisabledFlag){
                vm.changeFlag = true;
                monthShift.monthShiftYotei.yoteiChangeFlag = true;
                if(monthShift.monthShiftYotei['day'+value] == vm.timeZone.id){
                    monthShift.monthShiftYotei['day'+value] = "";
                    monthShift.monthShiftYotei['timeZoneName'+value] = "";
                }else {
                    var result = false;
                    angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                        //同一个staff 且不是自己
                        if(entity.userId == monthShift.userId && entity.monthShiftYotei.id != monthShift.monthShiftYotei.id){
                            //同一个预定值 且不是休
                            if(vm.timeZone.id == entity.monthShiftYotei['day'+value] && vm.timeZone.name != "休"){
                                result = true;
                            }
                        }
                    });
                    if(result) {
                        if(confirm("該当スタッフの勤務時間帯が重複しています、確認してください。")) {
                            monthShift.monthShiftYotei['day'+value] = vm.timeZone.id;
                            monthShift.monthShiftYotei['timeZoneName'+value] = vm.timeZone.name;
                        }
                    }else {
                        monthShift.monthShiftYotei['day'+value] = vm.timeZone.id;
                        monthShift.monthShiftYotei['timeZoneName'+value] = vm.timeZone.name;
                    }
                }
                count();
                weekCount();
                changeJissekiColor();
            }
        }
        function jissekiDayClick (monthShift, value) {
            if(!vm.jissekiDisabledFlag){
                vm.changeFlag = true;
                monthShift.monthShiftJisseki.jissekiChangeFlag = true;
                if(monthShift.monthShiftJisseki['day'+value] == vm.timeZone.id){
                    monthShift.monthShiftJisseki['day'+value] = "";
                    monthShift.monthShiftJisseki['timeZoneName'+value] = "";
                }else {
                    var result = false;
                    angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                        //同一个staff 且不是自己
                        if(entity.userId == monthShift.userId && entity.monthShiftJisseki.id != monthShift.monthShiftJisseki.id){
                            //同一个预定值 且不是休
                            if(vm.timeZone.id == entity.monthShiftJisseki['day'+value] && vm.timeZone.name != "休"){
                                result = true;
                            }
                        }
                    });
                    if(result) {
                        if(confirm("該当スタッフの勤務時間帯が重複しています、確認してください。")) {
                            monthShift.monthShiftJisseki['day'+value] = vm.timeZone.id;
                            monthShift.monthShiftJisseki['timeZoneName'+value] = vm.timeZone.name;
                        }
                    }else {
                        monthShift.monthShiftJisseki['day'+value] = vm.timeZone.id;
                        monthShift.monthShiftJisseki['timeZoneName'+value] = vm.timeZone.name;
                    }
                }
                count();
                weekCount();
                changeJissekiColor();
            }
        }

        //双击周单元格触发
        function weekClick (week) {
            if(vm.type == 0){
                if(confirm(" 該当週の予定設定をクリアしても大丈夫でしょうか")){
                    yoteiWeekClick(week);
                }
            } else if(vm.type == 1 ){
                if(confirm(" 該当週の実績設定をクリアしても大丈夫でしょうか")){
                    jissekiWeekClick(week);
                }
            }
        }
        function yoteiWeekClick (week) {
            if(!vm.yoteiDisabledFlag){
                vm.changeFlag = true;
                var firstDay = 0;
                var days = 0;
                if(week == 0){
                    firstDay=1;
                    days = 7;
                } else if(week == 1){
                    firstDay=8;
                    days = 14;
                } if(week == 2){
                    firstDay=15;
                    days = 21;
                } if(week == 3){
                    firstDay=22;
                    days = 28;
                } if(week == 4){
                    firstDay=29;
                    if(vm.surplusDays == 1) {
                        days = 29
                    } else if(vm.surplusDays == 2) {
                        days = 30
                    } else if(vm.surplusDays == 3) {
                        days = 31
                    }
                }

                angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                    for (var i = firstDay; i<=days; i++) {
                        entity.monthShiftYotei.yoteiChangeFlag = true;
                        entity.monthShiftYotei['day'+i] = "";
                        entity.monthShiftYotei['timeZoneName' + i] = "";
                    }
                });
                count();
                weekCount();
                changeJissekiColor();
            }
        }
        function jissekiWeekClick (week) {
            if(!vm.jissekiDisabledFlag){
                vm.changeFlag = true;
                var firstDay = 0;
                var days = 0;
                if(week == 0){
                    firstDay=1;
                    days = 7;
                } else if(week == 1){
                    firstDay=8;
                    days = 14;
                } if(week == 2){
                    firstDay=15;
                    days = 21;
                } if(week == 3){
                    firstDay=22;
                    days = 28;
                } if(week == 4){
                    firstDay=29;
                    if(vm.surplusDays == 1) {
                        days = 29
                    } else if(vm.surplusDays == 2) {
                        days = 30
                    } else if(vm.surplusDays == 3) {
                        days = 31
                    }
                }
                angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                    for (var i = firstDay; i<=days; i++) {
                        entity.monthShiftJisseki.jissekiChangeFlag = true;
                        entity.monthShiftJisseki['day'+i] = "";
                        entity.monthShiftJisseki['timeZoneName' + i] = "";
                    }
                });
                count();
                weekCount();
                changeJissekiColor();
            }
        }

        //鼠标移动到单元格触发
        function yoteiMousemove (monthShift, yy, xx) {
            if(vm.type == 0){
                document.onkeydown = function(e){
                    if(e.keyCode == 17 && vm.row != 0 && vm.column != 0){
                        //横向选中的
                        var r = Math.abs(vm.column-xx);
                        //纵向选中的
                        var y = Math.abs(vm.row - yy);
                        for (var i=0; i<=y; i++){
                            var index = vm.row+i-1;
                            for (var a=0; a<=r; a++) {
                                var dayNumber = vm.column + a;
                                vm.userStaffOccupation[index].monthShiftYotei['color' + dayNumber] = "yellow";
                            }
                        }
                    }
                }
            }
        }
        function jissekiMousemove (monthShift, yy, xx) {
            if(vm.type == 1) {
                document.onkeydown = function(e){
                    if(e.keyCode == 17 && vm.row != 0 && vm.column != 0){
                        //横向选中的
                        var r = Math.abs(vm.column-xx);
                        //纵向选中的
                        var y = Math.abs(vm.row - yy);
                        for (var i=0; i<=y; i++){
                            var index = vm.row+i-1;
                            for (var a=0; a<=r; a++) {
                                var dayNumber = vm.column + a;
                                vm.userStaffOccupation[index].monthShiftJisseki['color' + dayNumber] = "yellow";
                            }
                        }
                    }
                }
            }
        }

        //按下Ctrl键，鼠标在单元格按下之后出发
        function yoteiMousedown (y, x, e ) {
            stopDefault(e);
            if(vm.type == 0){
                document.onkeydown = function(e){
                    if(e.keyCode == 17){
                        vm.row = y;
                        vm.column = x;
                    }
                }
            }
        }
        function jissekiMousedown (y, x, e ) {
            stopDefault(e);
            if(vm.type == 1){
                document.onkeydown = function(e){
                    if(e.keyCode == 17){
                        vm.row = y;
                        vm.column = x;
                    }
                }
            }
        }

        //ctrl键弹起之后清空选中的单元格
        document.onkeyup = function (e){
            if(!vm.yoteiDisabledFlag){
                if(e.keyCode == 17){
                    vm.row = 0;
                    vm.column = 0;
                    angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                        for(var i = 1;i<=31;i++){
                            if(entity.monthShiftYotei['color'+i] == "yellow"){
                                entity.monthShiftYotei['color'+i] = "white";
                                entity.monthShiftYotei['day'+i] = vm.timeZone.id;
                                entity.monthShiftYotei['timeZoneName' + i] = vm.timeZone.name;
                            }
                        }
                    });
                    count();
                    weekCount();
                    changeJissekiColor();
                }
            }
            if(!vm.jissekiDisabledFlag){
                if(e.keyCode == 17){
                    vm.row = 0;
                    vm.column = 0;
                    angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                        for(var i = 1;i<=31;i++){
                            if(entity.monthShiftJisseki['color'+i] == "yellow"){
                                entity.monthShiftJisseki['color'+i] = "white";
                                entity.monthShiftJisseki['day'+i] = vm.timeZone.id;
                                entity.monthShiftJisseki['timeZoneName' + i] = vm.timeZone.name;
                            }
                        }
                    });
                    count();
                    weekCount();
                    changeJissekiColor();
                }
            }
        }

        //阻止浏览器自己选中
        function stopDefault(e){
            if(e && e.preventDefault){
                e.preventDefault();
            }
            else{
                window.event.returnValue=false;
                return false;
            }
        }

        //计算每个时间带的合计
        function count(){
            angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                angular.forEach(vm.timeZoneList, function(timeZone,t){
                    var yoteiC = 0;
                    var jissekiC = 0;
                    for(var i = 1; i<=vm.days;i++){
                        if(timeZone.id == entity.monthShiftYotei['day'+i]){
                            yoteiC+=1;
                        }
                        if(timeZone.id == entity.monthShiftJisseki['day'+i]){
                            jissekiC+=1;
                        }
                    }
                    angular.forEach(entity.monthShiftYotei.timeZoneCountDTO, function(dtoYotei){
                        if(dtoYotei.id == timeZone.id){
                            dtoYotei.timeZoneCount = yoteiC;
                        }
                    });
                    angular.forEach(entity.monthShiftJisseki.timeZoneCountDTO, function(dtoJisseki){
                        if(dtoJisseki.id == timeZone.id){
                            dtoJisseki.timeZoneCount = jissekiC;
                            if(yoteiC != jissekiC){
                                dtoJisseki.fontColor = "red";
                            }else {
                                dtoJisseki.fontColor = "";
                            }
                        }
                    });
                });
            });
        }

        //5週の合計 と　週平均の勤務時間
        function weekCount() {
            angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                var yoteiW = 0;
                var jissekiW = 0;
                var yoteiTotalTime = 0;
                var jissekiTotalTime = 0;
                //循环单个人这个月选中的时间带
                angular.forEach(entity.monthShiftYotei.timeZoneCountDTO, function(timeZone,t){
                    //间隔的时间（分钟）
                    var betweenTime = 0;
                    if(timeZone.name != "休" && timeZone.timeZoneCount > 0){
                        angular.forEach(vm.timeZoneList, function(time){
                            if(timeZone.id == time.id) {
                                //开始时间总共的分钟数
                                var startTime = 0;
                                if(time.startTime != '') {
                                    startTime = Number(time.startTime.split(":")[0]) * 60 + Number(time.startTime.split(":")[1]);
                                }
                                //结束时间总共的分钟数
                                var endTime = 0;
                                if(time.endTime != '') {
                                    endTime = Number(time.endTime.split(":")[0]) * 60 + Number(time.endTime.split(":")[1]);
                                }
                                //休息时间
                                var restTime = 0;
                                if(time.restTime != null){
                                    restTime = time.restTime;
                                }
                                //正常班
                                if(startTime <= endTime){
                                    betweenTime = Number(endTime) - Number(startTime) - Number(restTime);
                                //夜间
                                }else {
                                    betweenTime = 1440 + Number(endTime) - Number(startTime) - Number(restTime);
                                }
                            }
                        });
                        yoteiTotalTime += Number(betweenTime * timeZone.timeZoneCount);
                        //yoteiW += timeZone.timeZoneCount;
                    }
                });
                angular.forEach(entity.monthShiftJisseki.timeZoneCountDTO, function(timeZone,t){
                    //间隔的时间（分钟）
                    var betweenTime = 0;
                    if(timeZone.name != "休"  && timeZone.timeZoneCount > 0){
                        angular.forEach(vm.timeZoneList, function(time){
                            if(timeZone.id == time.id) {
                                //开始时间总共的分钟数
                                var startTime = 0;
                                if(time.startTime != '') {
                                    startTime = Number(time.startTime.split(":")[0]) * 60 + Number(time.startTime.split(":")[1]);
                                }
                                //结束时间总共的分钟数
                                var endTime = 0;
                                if(time.endTime != '') {
                                    endTime = Number(time.endTime.split(":")[0]) * 60 + Number(time.endTime.split(":")[1]);
                                }
                                //休息时间
                                var restTime = 0;
                                if(time.restTime != null){
                                    restTime = time.restTime;
                                }
                                //正常班
                                if(startTime <= endTime){
                                    betweenTime = Number(endTime) - Number(startTime) - Number(restTime);
                                //夜间
                                }else {
                                    betweenTime = 1440 + Number(endTime) - Number(startTime) - Number(restTime);
                                }
                            }
                        });
                        jissekiTotalTime += Number(betweenTime * timeZone.timeZoneCount);
                        //jissekiW += timeZone.timeZoneCount;
                    }
                });

                //entity.monthShiftYotei.total = yoteiW * 8;
                //5週の合計
                entity.monthShiftYotei.total = (yoteiTotalTime/60).toFixed(0);
                //entity.monthShiftYotei.avgTime = yoteiW * 8/160;
                //5週平均の勤務時間
                if(entity.monthShiftYotei.total != ''){
                    entity.monthShiftYotei.avgTime = (entity.monthShiftYotei.total/160).toFixed(2);
                }
                //entity.monthShiftJisseki.total = jissekiW * 8;
                entity.monthShiftJisseki.total = (jissekiTotalTime/60).toFixed(0);
                //entity.monthShiftJisseki.avgTime = jissekiW * 8/160;
                if(entity.monthShiftJisseki.total != ''){
                    entity.monthShiftJisseki.avgTime = (entity.monthShiftJisseki.total/160).toFixed(2);
                }

                if(yoteiW * 8 != jissekiW * 8){
                    entity.monthShiftJisseki.countColor = "red";
                }else {
                    entity.monthShiftJisseki.countColor = "";
                }
                if(yoteiW * 8/160 != jissekiW * 8/160){
                    entity.monthShiftJisseki.averageColor = "red";
                }else {
                    entity.monthShiftJisseki.averageColor = "";
                }
            });
        }

        //实际和预定不相同时，实际变红色
        function changeJissekiColor() {
            angular.forEach(vm.userStaffOccupation, function (entity,r) {
                for(var i = 0; i<= vm.days; i++){
                    if(entity.monthShiftYotei['day'+i] != entity.monthShiftJisseki['day'+i]){
                        entity.monthShiftJisseki['fontColor'+i] = "red";
                    }else {
                        entity.monthShiftJisseki['fontColor'+i] = "";
                    }
                }
            });
        }

        //点击確定処理按钮
        function confirmClick () {
            vm.confirmShowFlag = 1;
            ShiftMonth.saveShiftMonth({groupId:vm.groupId, year:vm.currentYear, month:vm.currentMonth, type:vm.confirmShowFlag,
                                       comment:vm.comment, monthStaffDTOList: vm.userStaffOccupation}, confirmSuccess);
        }

        //点击確定解除
        function cancelClick () {
            vm.confirmShowFlag = 2;
            ShiftMonth.saveShiftMonth({groupId:vm.groupId, year:vm.currentYear, month:vm.currentMonth, type:vm.confirmShowFlag, monthStaffDTOList: vm.userStaffOccupation}, cancelSuccess);
        }

        function save () {
            vm.confirmShowFlag = 0;
            ShiftMonth.saveShiftMonth({groupId:vm.groupId, year:vm.currentYear, month:vm.currentMonth, type:vm.confirmShowFlag,
                                       comment:vm.comment, monthStaffDTOList: vm.userStaffOccupation}, onSaveSuccess);
        }

        function updateDate () {
            ShiftMonth.updateShiftMonthDate({groupId:vm.groupId, year:vm.currentYear, month:vm.currentMonth},
                function() {
                    alert("数据更新成功！")
                });
        }

        function onSaveSuccess (result) {
            if(result.userName != ""){
                alert("【"+ result.userName + "】対象データは他のユーザーに先に更新されたか、または他のデータと重複するため更新することができませんでした。");
                loadShiftMonth();
            }else {
                loadShiftMonth();
            }
        }

        function confirmSuccess () {
            loadShiftMonth();
        }

        function cancelSuccess () {
            loadShiftMonth();
        }

        function resetColor () {
            angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                if(entity.monthShiftJisseki.type == 1){
                    vm.confirmShowFlag = 1;
                    for(var i=1; i<=31; i++){
                        entity.monthShiftYotei['color'+i] = "#EEEEEE";
                        entity.monthShiftJisseki['color' + i] = "#EEEEEE";
                    }
                    vm.yoteiDisabledFlag = true;
                    vm.jissekiDisabledFlag = true;
                }else if(entity.monthShiftJisseki.type == 0) {
                    if(vm.type == 0){
                        for(var i=1; i<=31; i++){
                            entity.monthShiftYotei['color'+i] = "white";
                            entity.monthShiftJisseki['color' + i] = "#EEEEEE";
                        }
                        vm.yoteiDisabledFlag = false;
                        vm.jissekiDisabledFlag = true;
                    }else if (vm.type == 1) {
                        for(var i=1; i<=31; i++){
                            entity.monthShiftYotei['color'+i] = "#EEEEEE";
                            entity.monthShiftJisseki['color' + i] = "white";
                        }
                        vm.yoteiDisabledFlag = true;
                        vm.jissekiDisabledFlag = false;
                    }
                }
                if(entity.monthShiftJisseki.id == null){
                    for(var i=1; i<=31; i++){
                        entity.monthShiftYotei['color'+i] = "white";
                        entity.monthShiftJisseki['color' + i] = "#EEEEEE";
                    }
                    vm.yoteiDisabledFlag = false;
                    vm.jissekiDisabledFlag = true;
                }
            });
        }

        function resetHoujinColor () {
            angular.forEach(vm.userStaffOccupation, function(entity,r,s){
                for(var i=1; i<=31; i++){
                    entity.monthShiftYotei['color'+i] = "#EEEEEE";
                    entity.monthShiftJisseki['color' + i] = "#EEEEEE";
                }
                vm.yoteiDisabledFlag = true;
                vm.jissekiDisabledFlag = true;
            });
        }

        function changeGroup () {
            vm.occupationId = '0';
            vm.parentGroup.forEach(function(e){
                if (e.id == vm.groupId) {
                    vm.group = e;
                    vm.groupName = vm.group.name;
                    vm.groupId = vm.group.id;
                    vm.comment = "";
                    loadOccupation();
                    loadShiftMonth();
                }
            });
        }

        function changeOccupation() {
            vm.parentGroup.forEach(function(e){
                if (e.id == vm.groupId) {
                    vm.group = e;
                    vm.groupName = vm.group.name;
                    vm.groupId = vm.group.id;
                    vm.comment = "";
                    loadOccupation();
                    loadShiftMonth();
                }
            });
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                groupId: vm.groupId == null ? "" : vm.groupId,
                currentYear:vm.currentYear,
                currentMonth:vm.currentMonth
            });
        }

        function changeHeight() {
            //最上边导航部分的高度
            var navbarHeight = $(".navbar").height();
            vm.messageWidth = ($(".navbar").width() - 400)/2;
            //上边表头固定部分的高度
            var titleHeight = $("#titleDiv").height();
            //下边固定部分的高度
            var bottomHeight = $("#bottomDiv").height();
            //copyRight部分的高度
            var copyRightHright = $("#copyRight").height();
            //浏览器可见区域的高度
            var height = document.documentElement.clientHeight;
            if(bottomHeight == 0){
                vm.tableHeight = height - navbarHeight - titleHeight - bottomHeight - copyRightHright -250;
            }else {
                vm.tableHeight = height - navbarHeight - titleHeight - bottomHeight - copyRightHright -205;
            }
            if(vm.tableHeight < 280){
                vm.tableHeight = 280;
            }
            //备注栏的高度
            vm.commentHeight = $("#timeZoneHeight").height();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('shift-month', {
            parent: 'app',
            url: '/timecard/shift-month/:currentYear/:currentMonth/',
            data: {
                pageTitle: 'global.menu.timecard.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/shift-month/shift-month-detail.html',
                    controller: 'ShiftMonthDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                groupId: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('shift-month');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService',  'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            var gtc_caretree2_timecard_allfunction_fullaccess = false;
                            var isAdmin = false;
                            var isDeveloper = false;
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Shift_AllFunction_FullAccess"}, function(result){
                                if (!result.flag) {
                                    $state.go('accessdenied');
                                } else {
                                    //plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                                }
                            });
                        } else {
                            LoginService.open();
                        }

                    });
                }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ShiftMonth', ShiftMonth);

    ShiftMonth.$inject = ['$resource'];

    function ShiftMonth ($resource) {
        var service = $resource('timecard/api/shiftmonth', {}, {
            'queryList': {
                method: 'GET',
                url: 'timecard/api/shiftmonth/getShiftMonthList',
                isArray: true
            },
            'saveShiftMonth': {
                method: 'POST',
                url: 'timecard/api/shiftmonth/saveShiftMonthList',
                isArray: false
            },
            'saveShiftMonthByTimeCard': {
                method: 'POST',
                url: 'timecard/api/shiftmonth/saveShiftMonthByTimeCard',
                isArray: true
            },
            'queryJisseki': {
                method: 'GET',
                url: 'timecard/api/shiftmonth/getJisseki',
                isArray: true
            },
            'queryYotei': {
                method: 'GET',
                url: 'timecard/api/shiftmonth/getYotei'
            },
            'updateShiftMonthDate': {
                method: 'POST',
                url: 'timecard/api/shiftmonth/updateShiftMonthDate',
                isArray: true
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShiftDutyDetailController', ShiftDutyDetailController);

    ShiftDutyDetailController.$inject = ['$scope', '$state', 'AlertService', '$timeout', '$stateParams', '$rootScope' , 'Shokushu', 'User', 'Group', 'ShiftDuty','pagingParams','paginationConstants','ParseLinks'];

    function ShiftDutyDetailController ($scope, $state, AlertService, $timeout,$stateParams,$rootScope, Shokushu, User, Group, ShiftDuty,pagingParams,paginationConstants,ParseLinks) {
        var vm = this;

        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.houjinFlag = false;
        vm.selectGroupFlag = false;
        vm.groupAllList = [];
        vm.parentGroup = [];
        vm.resultList = [];
        vm.shiftDutyList= [];
        vm.state = 1;
        vm.codeSaveFlag = false;
        vm.nameSaveFlag = false;
        vm.parentFlag = false;

        vm.goEdit = goEdit;
        vm.goAdd = goAdd;
        vm.goCancel = goCancel;
        vm.codeUniqueCheck = codeUniqueCheck;
        vm.nameUniqueCheck = nameUniqueCheck;

        //页面加载时，取得所有的Group
        vm.loadParentGroup = loadParentGroup;
        //Group切换
        vm.changeGroup = changeGroup;
        vm.save = save;
        vm.loadShiftDuty = loadShiftDuty;
        vm.goDel = goDel;
        vm.changeState = changeState;

        //页面加载后取得所有Group信息
        vm.loadParentGroup();

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                if ($stateParams.groupId !== null) {
                    result.forEach(function(item){
                        if (item.id == $stateParams.groupId) {
                            vm.group = item;
                        }
                    });
                } else {
                    vm.group = vm.parentGroup[0];
                }
                vm.groupId = vm.group.id;
                vm.loadShiftDuty();
            });
        }

        function loadShiftDuty () {
            //如果父groupId = 0,则可以编辑，否则不可以编辑
            vm.parentGroup.forEach(function (item) {
                if(vm.groupId == item.id){
                    if(item.parentId == ''){
                        vm.parentFlag = true;
                    }else {
                        vm.parentFlag = false;
                    }
                }
            });
            //如果group为parentId==0的group则直接查询
            if(vm.parentFlag) {
                ShiftDuty.getAll({"groupId":vm.groupId, "state":vm.state}, function(result, headers){
                    vm.resultList = result;
                    vm.shiftDutyList = angular.copy(result);
                    if(vm.resultList.length==0){
                        var shift = {};
                        shift.id = null;
                        shift.code = "";
                        shift.name = "";
                        shift.state = 1;
                        shift.showFlag = false;
                        vm.resultList.push(shift);
                    }
                });
            //否则查父group的
            }else {
                Group.queryParentGroupId({"groupId":vm.groupId}, function (group) {
                    //当前用户的父groupId
                    var groupId = "gid" + group.groupId;
                    ShiftDuty.getAll({"groupId":groupId, "state":vm.state}, function(result, headers){
                        vm.resultList = result;
                    });
                });
            }

            //判断登录账号是不是法人
            /*Group.groupList({"depth": 0}, function(groupList){
                vm.groupAllList = groupList;
                for(var i=0; i<groupList.length; i++){
                    if(!vm.houjinFlag){
                        for(var x=0; x<groupList[i].flags.length; x++){
                            if(groupList[i].flags[x].id == 2){
                                vm.houjinFlag = true;
                                break;
                            }
                        }
                    }
                }
                //如果是法人，直接根据groupId查询
                if(vm.houjinFlag){
                    ShiftDuty.getAll({"groupId":vm.group.id, "state":vm.state}, function(result, headers){
                        vm.resultList = result;
                        vm.shiftDutyList = angular.copy(result);
                        if(vm.resultList.length==0){
                            var shift = {};
                            shift.id = null;
                            shift.code = "";
                            shift.name = "";
                            shift.state = 1;
                            shift.showFlag = false;
                            vm.resultList.push(shift);
                        }
                    });
                //普通用户则查找他父节点的所有的数据
                }else {
                    Group.queryParentGroupId({"groupId":vm.group.id}, function (group) {
                        //当前用户的父groupId
                        var groupId = "gid" + group.groupId;
                        ShiftDuty.getAll({"groupId":groupId, "state":vm.state}, function(result, headers){
                            vm.resultList = result;
                            vm.shiftDutyList = angular.copy(result);
                            if(vm.resultList.length==0){
                                var shift = {};
                                shift.id = null;
                                shift.code = "";
                                shift.name = "";
                                shift.state = 1;
                                shift.showFlag = false;
                                vm.resultList.push(shift);
                            }
                        });
                    });
                }
            });*/
        }

        function changeState() {
            loadShiftDuty();
        }

        function goEdit(shiftDuty){
            shiftDuty.showFlag = false;
        }

        function goCancel(shiftDuty, index){
            vm.shiftDutyList.forEach(function (shift){
                if(shift.id == shiftDuty.id){
                    shiftDuty.showFlag = true;
                    shiftDuty.code = shift.code;
                    shiftDuty.name = shift.name;
                    shiftDuty.state = shift.state;
                    codeUniqueCheck (shiftDuty, index);
                    nameUniqueCheck (shiftDuty, index);
                }
            });
        }

        function goAdd(index) {
            var shift = {};
            shift.id = null;
            shift.code = "";
            shift.name = "";
            shift.state = 1;
            shift.showFlag = false;
            vm.resultList.splice(index+1,0,shift);
        }

        function goDel(index) {
            if(vm.resultList[index].id == null){
                vm.resultList.splice(index, 1);
            }else{
                ShiftDuty.delete({id:vm.resultList[index].id}, onSaveSuccess, onSaveError);
            }
        }

        function changeGroup(group) {
            vm.loadShiftDuty();
        }

        function save(){
            if(confirm("一括保存してもよろしいでしょうか")){
                ShiftDuty.save({groupId:vm.group.id,shiftList:vm.resultList}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            loadShiftDuty();
        }

        function onSaveError (result) {
            vm.resultList = result.data.shiftList;
        }

        function codeUniqueCheck (shiftDuty, index) {
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].code == shiftDuty.code && index != i){
                    shiftDuty.codeSingleFlag = true;
                    vm.codeSaveFlag = true;
                    break;
                }else {
                    shiftDuty.codeSingleFlag = false;
                    vm.codeSaveFlag = false;
                }
            }
        }

        function nameUniqueCheck (shiftDuty, index) {
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].name == shiftDuty.name && index != i){
                    shiftDuty.nameSingleFlag = true;
                    vm.nameSaveFlag = true;
                    break;
                }else {
                    shiftDuty.nameSingleFlag = false;
                    vm.nameSaveFlag = false;
                }
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('shift-duty', {
            parent: 'app',
            url: '/timecard/shift-duty',
            data: {
                pageTitle: 'global.menu.timecard.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/shift-duty/shift-duty-detail.html',
                    controller: 'ShiftDutyDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                groupId: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('shift-duty');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService',  'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            var gtc_caretree2_timecard_allfunction_fullaccess = false;
                            var isAdmin = false;
                            var isDeveloper = false;
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Shift_AllFunction_FullAccess"}, function(result){
                                if (!result.flag) {
                                    $state.go('accessdenied');
                                } else {
                                    //plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                                }
                            });
                        } else {
                            LoginService.open();
                        }

                    });
                }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ShiftDuty', ShiftDuty);

    ShiftDuty.$inject = ['$resource'];

    function ShiftDuty ($resource) {
        var service = $resource('timecard/api/shift', {}, {
            'getAll': {
                method: 'GET',
                url:'timecard/api/shift/all',
                isArray: true
            },
            'getAllByGroupId': {
                method: 'GET',
                url:'timecard/api/shift/getAllByGroupId',
                isArray: true
            },
            'save': {
                method: 'POST',
                url:'timecard/api/shift/save'
            },
            'delete': {
                method: 'DELETE',
                url:'timecard/api/shift/delete/:id'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SelectDutyOccupationController',SelectDutyOccupationController);

    SelectDutyOccupationController.$inject = ['$stateParams', 'param', 'AlertService', '$uibModalInstance', 'JhiLanguageService','MessageService', '$timeout', '$rootScope','Principal', 'Outlets'];

    function SelectDutyOccupationController ($stateParams, param, AlertService, $uibModalInstance, JhiLanguageService, MessageService, $timeout, $rootScope, Principal, Outlets) {
        var vm = this;
        vm.dutyOccupationList;
        vm.occupation;
        vm.loadData = loadData;
        vm.clear = clear;
        vm.save = save;
        vm.yoteiList;
        vm.yotei;

        loadData();
        function loadData() {
            vm.dutyOccupationList = $rootScope.dutyOccupationList;
            vm.yoteiList = $rootScope.yoteiList;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function save () {
            $rootScope.dutyId = vm.yotei.dutyId;
            $rootScope.occupationId = vm.yotei.occupationId;
            $rootScope.staffOccupationId = vm.yotei.staffOccupationId;
            $rootScope.$broadcast('duty');
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('OptionUserDetailController', OptionUserDetailController);

    OptionUserDetailController.$inject = ['$scope', '$state', 'AlertService', '$timeout', '$stateParams', '$rootScope' , 'Shokushu', 'User', 'Group', 'OptionUser','pagingParams','paginationConstants','ParseLinks'];

    function OptionUserDetailController ($scope, $state, AlertService, $timeout,$stateParams,$rootScope, Shokushu, User, Group, OptionUser,pagingParams,paginationConstants,ParseLinks) {
        var vm = this;

        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.parentGroup = [];
        vm.resultList = [];
        vm.group = null;
        vm.groupId = null;
        vm.shokushuList = [];
        vm.salaryTypeList = [{id:1,name:"時給"},{id:2,name:"日給月給"}];

        //页面加载时，取得所有的Group
        vm.loadParentGroup = loadParentGroup;
        //Group切换时，自动取得Staff
        vm.changeGroup = changeGroup;
        //取得该Group的所有Staff信息
        vm.loadUserOptions = loadUserOptions;
        vm.loadShokushu = loadShokushu;
        vm.save = save;

        //页面加载后取得所有Group信息
        vm.loadParentGroup();

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                if ($stateParams.groupId !== null) {
                    result.forEach(function(item){
                        if (item.id == $stateParams.groupId) {
                            vm.group = item;
                        }
                    });
                } else {
                    vm.group = vm.parentGroup[0];
                }
                vm.groupId = vm.group.id;
                vm.loadUserOptions();
                vm.loadShokushu();
            });
        }

        function loadShokushu() {
            Shokushu.query({"groupId":vm.group.id},function(result){
                vm.shokushuList = result;
                if (vm.shokushuList.length == 0 && vm.group.parentId > 0) {
                    Shokushu.query({"groupId":vm.group.parentId},function(result){
                        vm.shokushuList = result;
                    });
                }
            });
        }

        function changeGroup() {
        	pagingParams.page = 1;
            vm.parentGroup.forEach(function(e){
                if (e.id == vm.groupId) {
                    vm.group = e;
                    vm.loadUserOptions();
                    vm.loadShokushu();
                }
            });

        }

        function loadUserOptions() {
            User.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort(),
                    groupId:vm.groupId
                }, function (data, headers) {
                    //vm.links = ParseLinks.parse(headers('link'));
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.page = pagingParams.page;
                    OptionUser.query({groupId:vm.group.id,userList:data},function (result2) {
                        vm.resultList = result2;
                    });
            });
        }


        function onSaveSuccess (result) {
            vm.isSaving = false;
            //AlertService.success("timecardOption.saved");
        }

        function onSaveError () {
            AlertService.error("timecardOption.errors.save_error");
            vm.isSaving = false;
        }

        function save () {
            OptionUser.save({groupId:vm.group.id,userList:vm.resultList}, onSaveSuccess, onSaveError);
        }



        function sort () {
            var result = [vm.predicate + ' ' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id asc');
            }
            return result;
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ' ' + (vm.reverse ? 'asc' : 'desc'),
                groupId: vm.group.id == null ? "" : vm.group.id,
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('option-user', {
            parent: 'app',
            url: '/timecard/option-user',
            data: {
                pageTitle: 'global.menu.timecard.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/option-user/option-user-detail.html',
                    controller: 'OptionUserDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                groupId: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timecardOption');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService',  'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                        var gtc_caretree2_timecard_allfunction_fullaccess = false;
                        var isAdmin = false;
                        var isDeveloper = false;
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_TimeCard_AllFunction_FullAccess"}, function(result){
                        	if (!result.flag) {
                        		$state.go('accessdenied');
                        	} else {
                        		plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                        	}
                        });
                	} else {
                		LoginService.open();
                	}
                	
                });
            }]
        });
    }
    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_TimeCard_AllFunction_FullAccess') {
                    gtc_caretree2_timecard_allfunction_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_timecard_allfunction_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('OptionUser', OptionUser);

    OptionUser.$inject = ['$resource'];

    function OptionUser ($resource) {
        var service = $resource('timecard/api/options/user', {}, {
            'get': {
                method: 'GET',
                url: 'timecard/api/options/user',
                isArray: false
            },
            'query': {
                method: 'POST',
                url:'timecard/api/options/user/query',
                isArray: true
            },
            'save': {
                method: 'POST',
                url:'timecard/api/options/user'
            },
            'saveHourSalary': {
                method: 'POST',
                url:'timecard/api/options/user/hoursalary'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('MonthShiftTimeDetailController', MonthShiftTimeDetailController);

    MonthShiftTimeDetailController.$inject = ['$scope', '$state', 'AlertService', '$timeout', '$stateParams', '$rootScope' , 'User', 'Group', 'MonthShiftTime', 'ShiftTime', 'pagingParams', 'paginationConstants', 'ParseLinks'];

    function MonthShiftTimeDetailController ($scope, $state, AlertService, $timeout,$stateParams,$rootScope, User, Group, MonthShiftTime, ShiftTime, pagingParams, paginationConstants, ParseLinks) {
        var vm = this;
        var regex = /^([01]\d|2[0-3]):?([0-5]\d)$/;
        var regex2 = /^([01]\d|2[0-3])([0-5]\d)$/;
        var regex3 = /^[0-9]{1,7}$/;

        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.state = 1;
        vm.houjinFlag = false;
        vm.selectGroupFlag = false;
        vm.reloadHoujinTimeZoneFlag = false;
        vm.timeZoneIsNullFlag = false;
        vm.codeSaveFlag = false;
        vm.nameSaveFlag = false;
        vm.parentFlag = false;
        vm.currentYear = $stateParams.currentYear;
        vm.currentMonth = $stateParams.currentMonth;
        vm.timeType = false;

        vm.parentGroup = [];
        vm.resultList = [];
        vm.shiftTimeList = [];
        vm.groupAllList = [];

        if (!angular.isDefined(vm.currentYear) || vm.currentYear == "") {
            vm.currentYear = new Date().getFullYear();
        }
        if (!angular.isDefined(vm.currentMonth) || vm.currentMonth == "") {
            vm.currentMonth = new Date().getMonth()+1;
        }

        vm.goEdit = goEdit;
        vm.goAdd = goAdd;
        vm.goCancel = goCancel;
        vm.changeState = changeState;
        vm.codeUniqueCheck = codeUniqueCheck;
        vm.nameUniqueCheck = nameUniqueCheck;

        //页面加载时，取得所有的Group
        vm.loadParentGroup = loadParentGroup;
        //Group切换
        vm.changeGroup = changeGroup;
        vm.save = save;
        vm.loadShiftTime = loadShiftTime;
        vm.goDel = goDel;
        vm.startTimeUpdate = startTimeUpdate;
        vm.endTimeUpdate = endTimeUpdate;
        vm.restTimeUpdate = restTimeUpdate;
        vm.reloadHoujinTimeZone = reloadHoujinTimeZone;
        vm.rest = rest;
        vm.beforeMonth = beforeMonth;
        vm.nextMonth = nextMonth;

        //页面加载后取得所有Group信息
        vm.loadParentGroup();

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
                if ($stateParams.groupId !== null) {
                    result.forEach(function(item){
                        if (item.id == $stateParams.groupId) {
                            vm.group = item;
                        }
                    });
                } else {
                    vm.group = vm.parentGroup[0];
                }
                vm.groupId = vm.group.id;
                vm.loadShiftTime();
            });
        }

        function loadShiftTime () {
            //当前group为parentId==0的group
            if(vm.group.parentId == ''){
                vm.parentFlag = true;
            }
            MonthShiftTime.getMonthAll({"groupId":vm.groupId, "state":vm.state, year: vm.currentYear,
                month: vm.currentMonth}, function(result, headers){
                vm.resultList = result;
                vm.shiftTimeList = angular.copy(result);
                vm.timeZoneIsNullFlag = false;
                //自己没有，则到总公司同group下找，还没有则找父
                if(vm.resultList.length == 0){
                    Group.parentGroupList({"groupId":vm.groupId}, function(result){
                        var gid = "";
                        for(var i=0; i<result.length; i++) {
                            if(i == 0){
                                gid += "gid" + result[i].id;
                            }else {
                                gid += ",gid" + result[i].id;
                            }
                        }
                        MonthShiftTime.getMonthParentAll({"groupId":gid, "state":vm.state, year: vm.currentYear,
                            month: vm.currentMonth}, function(result, headers){
                            vm.timeZoneIsNullFlag = true;
                            vm.resultList = result;
                        })
                    });
                }
            });
        }

        function rest(){
            vm.currentYear = new Date().getFullYear();
            vm.currentMonth = new Date().getMonth()+1;
            vm.loadShiftTime();
        }

        function beforeMonth(){
            if (Number(vm.currentMonth) === 1) {
                vm.currentMonth = 12;
                vm.currentYear = Number(vm.currentYear) - 1;
            } else {
                vm.currentMonth = Number(vm.currentMonth) - 1;
            }
            vm.loadShiftTime();
        }

        function nextMonth(){
            if (Number(vm.currentMonth) === 12) {
                vm.currentMonth = 1;
                vm.currentYear = Number(vm.currentYear) + 1;
            } else {
                vm.currentMonth = Number(vm.currentMonth) + 1;
            }
            vm.loadShiftTime();
        }

        function changeState() {
            loadShiftTime();
        }

        function goEdit(shiftTime){
            shiftTime.showFlag = false;
        }

        function goCancel(shiftTime, index){
            vm.timeType = false;
            shiftTime.startTimeError = false;
            shiftTime.endTimeError = false;
            vm.shiftTimeList.forEach(function (shift) {
                if(shift.id == shiftTime.id){
                    shiftTime.showFlag = true;
                    shiftTime.code = shift.code;
                    shiftTime.name = shift.name;
                    shiftTime.startTime = shift.startTime;
                    shiftTime.endTime = shift.endTime;
                    shiftTime.state = shift.state;
                    shiftTime.restTime = shift.restTime;
                    codeUniqueCheck (shiftTime, index);
                    nameUniqueCheck (shiftTime, index);
                }
            });
        }

        function goAdd(index) {
            var shift = {};
            shift.id = null;
            shift.code = "";
            shift.name = "";
            shift.startTime = "";
            shift.endTime = "";
            shift.restTime = "";
            shift.state = 1;
            shift.showFlag = false;
            vm.resultList.splice(index+1,0,shift);
        }

        function goDel(index) {
            if(vm.resultList[index].id == null){
                vm.resultList.splice(index, 1);
            }else{
                ShiftTime.delete({id:vm.resultList[index].id}, onSaveSuccess, onSaveError);
            }
        }

        function changeGroup() {
            loadShiftTime();
        }

        function save(){
            if(confirm("一括保存してもよろしいでしょうか")){
                if(vm.reloadHoujinTimeZoneFlag){
                    if(confirm("シフト時間帯を再設定すると既存データを削除してもよろしいでしょうか")){
                        MonthShiftTime.save({groupId:vm.groupId,shiftList:vm.resultList, reloadHoujinTimeZoneFlag:vm.reloadHoujinTimeZoneFlag,year:vm.currentYear, month:vm.currentMonth},onSaveSuccess, onSaveError);
                    }
                }else {
                    MonthShiftTime.save({groupId:vm.groupId,shiftList:vm.resultList, reloadHoujinTimeZoneFlag:vm.reloadHoujinTimeZoneFlag,year:vm.currentYear, month:vm.currentMonth},onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess (result) {
            vm.reloadHoujinTimeZoneFlag = false;
            loadShiftTime();
        }

        function onSaveError (result) {
            vm.resultList = result.data.shiftList;
        }

        function startTimeUpdate(shiftTimeZone, index, shiftTimeZoneList){
            var startTime = $("#startTime"+index).val();
            if (shiftTimeZone.startTime == null || shiftTimeZone.startTime == "") {
                shiftTimeZone.startTimeError = false;
            } else if (regex.test(startTime)) {
                shiftTimeZone.startTimeError = false;
            } else {
                shiftTimeZone.startTimeError = true;
            }
            saveFlag(shiftTimeZoneList);
        }

        function endTimeUpdate(shiftTimeZone, index, shiftTimeZoneList) {
            var endTime = $("#endTime"+index).val();
            if (shiftTimeZone.endTime == null || shiftTimeZone.endTime == "") {
                shiftTimeZone.endTimeError = false;
            } else if (regex.test(endTime)) {
                shiftTimeZone.endTimeError = false;
            } else {
                shiftTimeZone.endTimeError = true;
            }
            saveFlag(shiftTimeZoneList);
        }

        function restTimeUpdate(shiftTimeZone, index, shiftTimeZoneList) {
            shiftTimeZone.restTime = $("#restTime"+index).val();
            if (shiftTimeZone.restTime == null || shiftTimeZone.restTime == "") {
                shiftTimeZone.restTimeError = false;
            } else if (regex3.test(shiftTimeZone.restTime)) {
                shiftTimeZone.restTimeError = false;
            } else {
                shiftTimeZone.restTimeError = true;
            }
            saveFlag(shiftTimeZoneList);
        }

        function saveFlag(shiftTimeZoneList) {
            //跳出循环用
            var breakFlag = true;
            angular.forEach(shiftTimeZoneList, function(data){
                if(breakFlag) {
                    vm.timeType = false;
                    if(data.endTimeError == true || data.startTimeError == true || data.restTimeError == true) {
                        vm.timeType = true;
                        breakFlag = false;
                    }
                }
            });
        }

        function reloadHoujinTimeZone () {
            vm.reloadHoujinTimeZoneFlag = true;
            /*Group.queryParentGroupId({"groupId":vm.groupId}, function (group) {
                //当前用户的父groupId
                var groupId = "gid" + group.groupId;
                MonthShiftTime.getMonthAll({"groupId":groupId, "state":vm.state, year: vm.currentYear,
                    month: vm.currentMonth}, function(result, headers){
                    result.forEach(function(item) {
                        item.id = null;
                    });
                    vm.resultList = result;
                    vm.shiftTimeList = angular.copy(result);
                });
            });*/
            Group.parentGroupList({"groupId":vm.groupId}, function(result){
                var gid = "";
                for(var i=0; i<result.length; i++) {
                    if(i == 0){
                        gid += "gid" + result[i].id;
                    }else {
                        gid += ",gid" + result[i].id;
                    }
                }
                MonthShiftTime.getMonthParentAll({"groupId":gid, "state":vm.state, year: vm.currentYear,
                    month: vm.currentMonth}, function(result, headers){
                    result.forEach(function(item) {
                        item.id = null;
                        item.showFlag = false;
                    });
                    vm.resultList = result;
                    vm.shiftTimeList = angular.copy(result);
                })
            });
        }

        function codeUniqueCheck (shiftTimeZone, index) {
            if(shiftTimeZone.code != null && shiftTimeZone.code != "") {
                shiftTimeZone.codeRequiredFlag = false;
            }
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].code == shiftTimeZone.code && index != i){
                    shiftTimeZone.codeSingleFlag = true;
                    vm.codeSaveFlag = true;
                    break;
                }else {
                    shiftTimeZone.codeSingleFlag = false;
                    vm.codeSaveFlag = false;
                }
            }
        }

        function nameUniqueCheck (shiftTimeZone, index) {
            if(shiftTimeZone.name != null && shiftTimeZone.name != "") {
                shiftTimeZone.nameRequiredFlag = false;
            }
            for(var i=0; i<vm.resultList.length; i++) {
                if(vm.resultList[i].name == shiftTimeZone.name && index != i){
                    shiftTimeZone.nameSingleFlag = true;
                    vm.nameSaveFlag = true;
                    break;
                }else {
                    shiftTimeZone.nameSingleFlag = false;
                    vm.nameSaveFlag = false;
                }
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider.state('monthshift-time', {
            parent: 'app',
            url: '/timecard/monthshift-time',
            data: {
                pageTitle: 'global.menu.timecard.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/monthshift-time/monthshift-time-detail.html',
                    controller: 'MonthShiftTimeDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                groupId: null,
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('shift-time');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService',  'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            var gtc_caretree2_timecard_allfunction_fullaccess = false;
                            var isAdmin = false;
                            var isDeveloper = false;
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Shift_AllFunction_FullAccess"}, function(result){
                                if (!result.flag) {
                                    $state.go('accessdenied');
                                } else {
                                    //plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                                }
                            });
                        } else {
                            LoginService.open();
                        }

                    });
                }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('MonthShiftTime', MonthShiftTime);

    MonthShiftTime.$inject = ['$resource'];

    function MonthShiftTime ($resource) {
        var service = $resource('timecard/api/shift', {}, {
            'getMonthAll': {
                method: 'GET',
                url:'timecard/api/monthshiftTime/all',
                isArray: true
            },
            'getMonthParentAll': {
                method: 'GET',
                url:'timecard/api/monthshiftTimeParent/all',
                isArray: true
            },
            'save': {
                method: 'POST',
                url:'timecard/api/monthshiftTime/save'
            },
            'delete': {
                method: 'DELETE',
                url:'timecard/api/shiftTime/delete/:id'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('houmonTimecard', {
            parent: 'app',
            url: '/timecard/houmonTimecard',
            data: {
                pageTitle: 'global.menu.timecard.main'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            var gtc_caretree2_timecard_allfunction_fullaccess = false;
                            var isAdmin = false;
                            var isDeveloper = false;
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_TimeCard_AllFunction_FullAccess"}, function(result){
                                if (!result.flag) {
                                    $state.go('accessdenied');
                                } else {
                                    plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                                }
                            });
                        } else {
                            LoginService.open();
                        }
                    });
                }]
        })
    }
    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_TimeCard_AllFunction_FullAccess') {
                    gtc_caretree2_timecard_allfunction_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_timecard_allfunction_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }else{
            $uibModal.open({
                templateUrl: 'app/timecard/houmonTimecard.html',
                controller: 'HoumonTimecardController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'full-screen',
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('timecard');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function() {
                $state.go('home');
            }, function() {
                $state.go('home');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('HoumonTimecard', HoumonTimecard);

    HoumonTimecard.$inject = ['$resource'];

    function HoumonTimecard ($resource) {
        var service = $resource('timecard/api/timecards', {}, {
            'query': {
                method: 'GET'
            },
            'calendar': {//指定年月的日历信息取得
                method: 'GET',
                url: 'timecard/api/timecards/calendar'
            },
            'queryDay': {//指定天的所有打卡信息取得
                method: 'POST',
                url: 'timecard/api/timecards/day',
            },
            'queryMonth': {//指定月的所有打卡信息取得
                method: 'POST',
                url: 'timecard/api/timecards/month'
            },
            'queryHistory':{
                method: 'GET',
                url: 'timecard/api/timecards/history',
                isArray:true
            },
            'queryChart':{
                method: 'GET',
                url: 'timecard/api/timecards/chart',
            },
            'save': {
                method: 'POST'
            },
            "saveHistory": {
                method: 'POST',
                url: 'timecard/api/timecards/history'
            },
            'update': {
                method:'PUT'
            },
            'yesterday': {
                method: 'POST',
                url: 'timecard/api/timecards/yesterday'
            },
            'beOut': {
                method: 'POST',
                url: 'timecard/api/timecards/out'
            },
            'reEntry': {
                method:'PUT',
                url: 'timecard/api/timecards/out'
            },
            'delete': {
                method:'DELETE'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HoumonTimecardController', HoumonTimecardController);

    HoumonTimecardController.$inject = ['$scope', '$rootScope', '$state','filterFilter', '$uibModalInstance', 'AlertService',
        '$stateParams', 'User', 'SelectedGroup', 'HoumonTimecard','TimezoneService', 'ShiftTime', 'Auth', 'StaffOccupation', 'ShiftMonth',
        'ParseLinks', 'pagingParams', 'paginationConstants', '$interval', 'Principal'];

    function HoumonTimecardController ($scope, $rootScope, $state, filterFilter, $uibModalInstance,  AlertService, $stateParams,
                                 User, SelectedGroup, HoumonTimecard,TimezoneService,ShiftTime, Auth, StaffOccupation, ShiftMonth,
                                 ParseLinks, pagingParams, paginationConstants, $interval, Principal) {
        var vm = this;
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.timeZoneList = [];
        vm.showTimeZoneFlag = false;

        //複数ユーザーのタイムカードデータを維持する
        vm.gyou50On = false;
        vm.userList = [];
        vm.groups = [];
        vm.user = null;
        vm.password = null;
        //特定ユーザのタイムカードデータを維持する
        vm.timecardData = null;
        vm.listUpData = [];
        vm.group = null;
        vm.currentTime = new Date();
        vm.groupTimezone = "+0900";
        vm.timeZone = { id: null };
        vm.message = "";
        vm.isSaving = false;

        vm.clear = clear;
        //页面加载时，取得所有的Group
        vm.loadAllGroups = loadAllGroups;
        //Group切换时，自动取得Staff
        vm.changeGroup = changeGroup;
        vm.groupTitle = groupTitle;
        //Staff切换时，自动更新Staff页面信息
        //取得该Group的所有Staff信息
        vm.loadUsers = loadUsers;
        vm.checkIn = checkIn;
        vm.doCheckIn = doCheckIn;
        vm.checkOut = checkOut;
        vm.doCheckOut = doCheckOut;
        vm.goOut = goOut;
        vm.doGoOut = doGoOut;
        vm.reEntry = reEntry;
        vm.doReEntry = doReEntry;
        vm.refresh = refresh;
        vm.isUserSelected = isUserSelected;
        vm.haveUserPhoto = haveUserPhoto;
        //チェックインボタン有効かどうかを判別する
        vm.isCheckInEnabled = isCheckInEnabled;
        //チェックアウトボタン有効かどうかを判別する
        vm.isCheckOutEnabled = isCheckOutEnabled;
        //外出ボタン有効かどうかを判別する
        vm.isBeOutEnabled = isBeOutEnabled;
        //再入ボタン有効かどうかを判別する
        vm.isReEntryEnabled = isReEntryEnabled;
        //五十音表示するため
        vm.startsWith = starsWith;
        //打刻履歴を表示する
        vm.listup = listup;
        vm.currentDay = currentDay;
        vm.timeZoneClick = timeZoneClick;

        vm.currentClock = "";
        vm.currentCalendar = "";
        vm.callAtTimeout = callAtTimeout;
        vm.stopInterval = stopInterval;

        vm.afterCheck = afterCheck

        callAtTimeout();
        vm.promise = $interval(function() {
            vm.callAtTimeout()
        }, 1000);

        $scope.$on('$destroy', function() {
            vm.stopInterval();
        });

        function stopInterval() {
            $interval.cancel(vm.promise);
        }

        function callAtTimeout() {
            var now = new Date()
            var h = now.getHours();
            if (h < 10) {
                h = "0" + h;
            }
            var m = now.getMinutes();
            if (m < 10) {
                m = "0" + m;
            }
            var s = now.getSeconds();
            if (s < 10) {
                s = "0" + s;
            }
            vm.currentCalendar = now;
            vm.currentClock = h + ":" + m + ":" + s;

            var year = now.getFullYear();
            var month = now.getMonth() + 1;
            var day = now.getDate()

            var dayOfWeek = now.getDay() ; // 曜日(数値)
            var dayOfWeekStr = [ "日", "月", "火", "水", "木", "金", "土" ][dayOfWeek] ; // 曜日(日本語表記)

            vm.currentCalendar = month+"月"+day+"日("+dayOfWeekStr+")";
        }

        function currentDay() {
            var now = new Date();
            var year = now.getFullYear();
            var month = now.getMonth()+1;
            if (month < 10) {
                month = "0"+month;
            }
            var day = now.getDate();
            if (day < 10) {
                day = "0"+day;
            }
            return year+"-"+month+"-"+day;

        }

        function timeZoneClick () {
            vm.showTimeZoneFlag = false;
        }
        setInterval(function () {
            var now = new Date();
            if (vm.currentTime.getDate() !== now.getDate()) {
                console.log("日付が変わりました、画面リフレッシュします。");
                vm.currentTime = new Date();
                $state.reload();
            }
        }, 1000);

        //页面加载后取得所有Group信息
        vm.loadAllGroups();

        //Dialogを閉じます
        function clear () {
            $uibModalInstance.dismiss('cancel');
            Auth.logout();
            $state.go('home');
        }
        //グループ一覧を取得
        function loadAllGroups() {
            vm.groups = SelectedGroup.groupList();
            if (vm.group == null) {
                vm.group = vm.groups[0];
            }
            vm.loadUsers(vm.group);
        }
        //グループ切り替え
        function changeGroup(group) {
            vm.group = group;
            vm.loadUsers(vm.group);
            vm.user = null;
            vm.password = null;
            vm.timecardData = [];
            vm.listUpData = [];
        }
        function groupTitle() {
            var title = "";
            if (angular.isDefined(vm.group)) {
                if(vm.group.parentId == "0") {
                    title = vm.group.name;
                } else {
                    vm.groups.forEach(function(item){
                        if (item.id == vm.group.parentId) {
                            title = item.name.replace(/-/g, '').replace(/|/g,'') + title;
                        }
                    });
                    title += vm.group.name.replace(/-/g,'').replace(/|/g,'');
                }
            }
            return title;

        }
        //該当グループのユーザー一覧を取得
        function loadUsers(group) {
            vm.showTimeZoneFlag = false;
            vm.groupTimezone = TimezoneService.getOffset(group.timezone);
            User.query({
                groupId:group.id,
                page: vm.page - 1,
                size: vm.itemsPerPage
            },function(result,headers){
                //vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                var userList = result;
                var currentYear = vm.currentTime.getFullYear();
                var currentMonth = vm.currentTime.getMonth()+1;
                var currentDay = vm.currentTime.getDate();
                var data = {'groupId':group.id,'users':userList,'year':currentYear,'month':currentMonth,'day':currentDay};
                HoumonTimecard.queryDay(data,function(result){
                    vm.userList = result.users;
                    if (result.users.length > 0){
                        vm.login = '';
                        Principal.identity().then(function(account) {
                            vm.login = account.login;
                            for(var i=0; i<result.users.length; i++){
                                if(result.users[i].login == vm.login){
                                    vm.user = result.users[i];
                                    vm.timecardData = vm.user.timecards[0];
                                }
                            }
                        });
                    }
                },function(error){
                    AlertService.error(error.data.message);
                });
                ShiftTime.getMonthStateAll({"groupId":vm.group.id, 'year':currentYear,'month':currentMonth}, function(result){
                    vm.timeZoneList = result;
                });

            },function(error){
                AlertService.error(error.data.message);
            });
        }

        function save () {
            if(vm.timeZoneList.length > 0){
                if(vm.timeZone.id != null){
                    var data = {'groupId':vm.group.id, 'userId':vm.user.id, 'year': vm.currentTime.getFullYear(), 'month': vm.currentTime.getMonth()+1};
                    StaffOccupation.queryStaffOccupation(data,function(result){
                        if(result.length == 0){
                            alert("職種や勤務形態が設定されていませんので、先に設定してください。");
                        }else if(result.length == 1){
                            $rootScope.staffOccupationId = result[0].id;
                            $rootScope.occupationId = result[0].occupationId;
                            $rootScope.dutyId = result[0].dutyId;
                            saveShiftMonth();
                        }else if(result.length > 1){
                            $rootScope.dutyOccupationList = result;
                            var nullList = [];
                            var notNullList = [];
                            var index = 0;
                            result.forEach(function(staff){
                                ShiftMonth.queryYotei({staffOccupationId:staff.id}, function(entity){
                                    var yotei = {};
                                    var day = new Date().getDate();
                                    yotei.staffOccupationId = entity.staffOccupationId;
                                    yotei.occupationId = entity.occupationId;
                                    yotei.dutyId = entity.dutyId;
                                    yotei.dayNumber = entity['day'+day];
                                    //如果打卡的当天有预定的值
                                    if(entity['day'+day] != null){
                                        ShiftTime.getOneById({id:entity['day'+day]}, function(timeZone){
                                            yotei.nameAndTime = timeZone.nameAndTime;
                                            notNullList.push(yotei);
                                            index += 1;
                                            if(index >= result.length){
                                                //同职种同勤务形态且预定有值的超过一条以上，则弹出选择对话框
                                                if(notNullList.length>1){
                                                    $rootScope.yoteiList = notNullList;
                                                    $state.go('timecard.dutyselect');
                                                    //同职种同勤务形态且预定有值只有一条，则直接保存
                                                } else if(notNullList.length==1){
                                                    $rootScope.staffOccupationId = notNullList[0].staffOccupationId;
                                                    $rootScope.occupationId = notNullList[0].occupationId;
                                                    $rootScope.dutyId = notNullList[0].dutyId;
                                                    saveShiftMonth();
                                                    //同职种同勤务形态且 预定没有值时，给第一个打卡
                                                } else {
                                                    $rootScope.staffOccupationId = $rootScope.dutyOccupationList[0].id;
                                                    $rootScope.occupationId = $rootScope.dutyOccupationList[0].occupationId;
                                                    $rootScope.dutyId = $rootScope.dutyOccupationList[0].dutyId;
                                                    saveShiftMonth();
                                                }
                                            }
                                        });
                                    }else {
                                        nullList.push(yotei);
                                        index += 1;
                                        if(index >= result.length){
                                            //同职种同勤务形态且预定有值的超过一条以上，则弹出选择对话框
                                            if(notNullList.length>1){
                                                $rootScope.yoteiList = notNullList;
                                                $state.go('timecard.dutyselect');
                                                //同职种同勤务形态且预定有值只有一条，则直接保存
                                            } else if(notNullList.length==1){
                                                $rootScope.staffOccupationId = notNullList[0].staffOccupationId;
                                                $rootScope.occupationId = notNullList[0].occupationId;
                                                $rootScope.dutyId = notNullList[0].dutyId;
                                                saveShiftMonth();
                                                //同职种同勤务形态且 预定没有值时，给第一个打卡
                                            } else {
                                                $rootScope.staffOccupationId = $rootScope.dutyOccupationList[0].id;
                                                $rootScope.occupationId = $rootScope.dutyOccupationList[0].occupationId;
                                                $rootScope.dutyId = $rootScope.dutyOccupationList[0].dutyId;
                                                saveShiftMonth();
                                            }
                                        }
                                    }
                                });
                            });
                        }
                    });
                    vm.showTimeZoneFlag = false;
                }else {
                    vm.showTimeZoneFlag = true;
                    alert("シフト時間帯を選択してください");
                }
            }else {
                //1:出勤,2:退勤,3:外出,4:再入
                if($scope.type == 1){
                    onSaveCheckInSuccess();
                } else if($scope.type == 2) {
                    onSaveCheckOutSuccess();
                } else if($scope.type == 3) {
                    onSavegoOutSuccess();
                } else if($scope.type == 4) {
                    onSaveReEntrySuccess();
                }
            }
        }

        $scope.$on('duty', function() {
            saveShiftMonth();
         });

        function saveShiftMonth() {
            var monthStaff = {};
            var monthShiftJisseki = {};
            monthStaff.userId = vm.user.id;
            monthStaff.occupationId = $rootScope.occupationId;
            monthStaff.dutyId = $rootScope.dutyId;
            monthStaff.staffOccupationId = $rootScope.staffOccupationId;
            monthShiftJisseki.id = null;
            monthShiftJisseki.userId = vm.user.id;
            monthShiftJisseki.staffOccupationId = $rootScope.staffOccupationId;
            monthShiftJisseki.occupationId = $rootScope.occupationId;
            monthShiftJisseki.dutyId = $rootScope.dutyId;
            monthShiftJisseki.total = 8;
            monthShiftJisseki.avgTime = 0.05;
            monthShiftJisseki.timeZoneCountDTO = [];
            for(var a = 0; a < vm.timeZoneList.length; a++ ) {
                var dto = {};
                dto.id = vm.timeZoneList[a].id;
                dto.name = vm.timeZoneList[a].name;
                if(vm.timeZoneList[a].id == vm.timeZone.id){
                    dto.timeZoneCount = 1;
                }else {
                    dto.timeZoneCount = 0;
                }
                monthShiftJisseki.timeZoneCountDTO.push(dto);
            }

            for(var i = 1; i< 31;i++){
                if(i==vm.currentTime.getDate()) {
                    monthShiftJisseki['day'+i] = vm.timeZone.id;
                }else {
                    monthShiftJisseki['day'+i] = null;
                }
            }
            monthStaff.monthShiftJisseki = monthShiftJisseki;
            //1:出勤,2:退勤,3:外出,4:再入
            ShiftMonth.saveShiftMonthByTimeCard({groupId:vm.group.id, year:vm.currentTime.getFullYear(), month:vm.currentTime.getMonth()+1, type:3, monthStaff: monthStaff});
        }

        function onSaveCheckInSuccess () {
            vm.doCheckIn();
        }

        function onSaveCheckOutSuccess () {
            /*if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    alert("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doCheckOut();
                });
            } else {
                vm.doCheckOut();
            }*/
            vm.doCheckOut();
        }

        function onSavegoOutSuccess () {
            /*if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    alert("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doGoOut();
                });
            } else {
                vm.doGoOut();
            }*/
            vm.doGoOut();
        }

        function onSaveReEntrySuccess () {
            /*if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    alert("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doReEntry();
                });
            } else {
                vm.doReEntry();
            }*/
            vm.doReEntry();
        }

        //出勤処理
        function checkIn() {
            //判断是否有时间带
            if(vm.timeZoneList.length > 0){
                if(vm.timeZone.id == null){
                    alert("シフト時間帯を選択してください");
                }else {
                    checkCheckIn();
                }
            }else {
                checkCheckIn();
            }
        }

        function checkCheckIn(){
            /*if (vm.user.passwordRequired) {
                if (vm.user.passwordRequired && vm.password === null) {
                    alert("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doCheckIn();
                },function() {
                    alert("パスワードを再確認してください。");
                });
            } else {
                vm.doCheckIn();
            }*/
            vm.doCheckIn();
        }
        //実出勤登録処理
        function doCheckIn(){
            vm.isSaving = true;
            var timecard = {"id":null,"groupId":vm.group.id, "day": vm.currentDay(),
                "userId":vm.user.id,"password":vm.password,"origin":vm.user.password,
                "userName":vm.user.lastName+" "+ vm.user.firstName, "type":1, "inTime":new Date(),
                "year": vm.currentTime.getFullYear(), "month": vm.currentTime.getMonth() + 1,
                "timeZoneId": vm.timeZone.id, "timecardShiftFlag": vm.group.timecardShiftFlag};

            HoumonTimecard.save(timecard, function (result) {
                vm.isSaving = false;
                vm.refresh(result);
                vm.afterCheck(result);
                alert("打刻成功しました");
                AlertService.success("timecard.management.checkin",{"param":vm.user.lastName + " " + vm.user.firstName});
            }, function (error) {
                vm.isSaving = false;
                alert("打卡失敗しました");
                AlertService.error(error.data.message);
            });
        }
        //退勤処理
        function checkOut() {
            //判断是否有时间带
            if(vm.timeZoneList.length > 0){
                if(vm.timeZone.id == null){
                    alert("シフト時間帯を選択してください");
                }else {
                    checkCheckOut();
                }
            }else {
                checkCheckOut();
            }
        }

        function checkCheckOut() {
            /*if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    alert("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doCheckOut();
                },function() {
                    alert("パスワードを再確認してください。");
                });
            } else {
                vm.doCheckOut();
            }*/
            vm.doCheckOut();
        }
        //実退勤登録処理
        function doCheckOut(){
            vm.isSaving = true;
            if (vm.timecardData.haveUnFinishedTimecard === true) {
                console.log("昨日の出勤ですが、今日退勤します。");
                var timecard = {};
                timecard["groupId"] = vm.group.id;
                timecard["userId"] = vm.user.id;
                timecard["day"] = vm.currentDay();
                timecard["outTime"] = new Date();
                timecard["password"] = vm.password;
                timecard["origin"] = vm.user.password;
                timecard["userName"] = vm.user.lastName+" "+ vm.user.firstName;
                timecard["year"] = vm.currentTime.getFullYear();
                timecard["month"] = vm.currentTime.getMonth() + 1;
                timecard["timeZoneId"] = vm.timeZone.id;
                timecard["timecardShiftFlag"] = vm.group.timecardShiftFlag
                HoumonTimecard.yesterday(timecard, function (result) {
                    vm.isSaving = false;
                    vm.refresh(result);
                    vm.afterCheck(result);
                    alert("打刻成功しました");
                    AlertService.success("timecard.management.checkout",{"param":vm.user.lastName + " " + vm.user.firstName});
                }, function (error) {
                    vm.isSaving = false;
                    alert("打卡失敗しました");
                    AlertService.error(error.data.message);
                });

            } else {
                var checkInData = filterFilter(vm.timecardData.rawData,{type: 1});
                var timecard = checkInData[checkInData.length -1];
                timecard["groupId"] = vm.group.id;
                timecard["outTime"] = new Date();
                timecard["password"] = vm.password;
                timecard["origin"] = vm.user.password;
                timecard["userName"] = vm.user.lastName+" "+ vm.user.firstName;
                timecard["year"] = vm.currentTime.getFullYear();
                timecard["month"] = vm.currentTime.getMonth() + 1;
                timecard["timeZoneId"] = vm.timeZone.id;
                timecard["timecardShiftFlag"] = vm.group.timecardShiftFlag
                HoumonTimecard.update(timecard, function (result) {
                    vm.isSaving = false;
                    vm.refresh(result);
                    vm.afterCheck(result);
                    alert("打刻成功しました");
                    AlertService.success("timecard.management.checkout",{"param":vm.user.lastName + " " + vm.user.firstName});
                }, function (error) {
                    vm.isSaving = false;
                    alert("打卡失敗しました");
                    AlertService.error(error.data.message);
                });
            }
        }
        //外出処理
        function goOut() {
            //判断是否有时间带
            if(vm.timeZoneList.length > 0){
                if(vm.timeZone.id == null){
                    alert("シフト時間帯を選択してください");
                }else {
                    checkGoOut();
                }
            }else {
                checkGoOut();
            }
        }

        function checkGoOut() {
            /*if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    alert("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doGoOut();
                },function() {
                    alert("パスワードを再確認してください。");
                });
            } else {
                vm.doGoOut();
            }*/
            vm.doGoOut();
        }
        //実外出登録処理
        function doGoOut(){
            vm.isSaving = true;
            var timecard = {"id":null,"groupId":vm.group.id, "day": vm.currentDay(),
                "userId":vm.user.id,"password":vm.password, "origin":vm.user.password,
                "userName":vm.user.lastName+" "+ vm.user.firstName, "type":2, "inTime":new Date(),
                "year": vm.currentTime.getFullYear(), "month": vm.currentTime.getMonth() + 1,
                "timeZoneId": vm.timeZone.id, "timecardShiftFlag": vm.group.timecardShiftFlag};
            HoumonTimecard.beOut(timecard, function (result) {
                vm.isSaving = false;
                vm.refresh(result);
                vm.afterCheck(result);
                alert("打刻成功しました");
                AlertService.success("timecard.management.beout",{"param":vm.user.lastName + " " + vm.user.firstName});
            }, function (error) {
                vm.isSaving = false;
                alert("打卡失敗しました");
                AlertService.error(error.data.message);
            });
        }
        //再入処理
        function reEntry() {
            //判断是否有时间带
            if(vm.timeZoneList.length > 0){
                if(vm.timeZone.id == null){
                    alert("シフト時間帯を選択してください");
                }else {
                    checkReEntry();
                }
            }else {
                checkReEntry();
            }
        }
        
        function checkReEntry() {
            /*if (vm.user.passwordRequired) {
                if (vm.password == null) {
                    alert("パスワードを入力してください。");
                    return;
                }
                User.check({'userName':vm.user.login,'password':vm.password},function(result){
                    vm.doReEntry();
                },function() {
                    alert("パスワードを再確認してください。");
                });
            } else {
                vm.doReEntry();
            }*/
            vm.doReEntry();
        }
        //実再入登録処理
        function doReEntry() {
            vm.isSaving = true;

            var beOutData = filterFilter(vm.timecardData.rawData,{type: 2});
            var timecard = beOutData[beOutData.length -1];
            timecard["groupId"] = vm.group.id;
            timecard["outTime"] = new Date();
            timecard["password"] = vm.password;
            timecard["origin"] = vm.user.password;
            timecard["userName"] = vm.user.lastName+" "+ vm.user.firstName;
            timecard["year"] = vm.currentTime.getFullYear();
            timecard["month"] = vm.currentTime.getMonth() + 1;
            timecard["timeZoneId"] = vm.timeZone.id;
            timecard["timecardShiftFlag"] = vm.group.timecardShiftFlag

            HoumonTimecard.reEntry(timecard, function (result) {
                vm.isSaving = false;
                vm.refresh(result);
                vm.afterCheck(result);
                alert("打刻成功しました");
                AlertService.success("timecard.management.reentry",{"param":vm.user.lastName + " " + vm.user.firstName});
            }, function (error) {
                vm.isSaving = false;
                alert("打卡失敗しました");
                AlertService.error(error.data.message);
            });
        }

        /**
         * 打刻データを保存したら、ロカルデータを再更新します
         * @param result
         */
        function refresh(result) {
            vm.password = null;
            vm.user.timecards[0].workTimeDetail.startTime = result.workTimeDetail.startTime;
            vm.user.timecards[0].workTimeDetail.endTime = result.workTimeDetail.endTime;
            vm.user.timecards[0].workTimeDetail.status = result.workTimeDetail.status;
            vm.user.timecards[0].workTimeDetail.nextDay = result.workTimeDetail.nextDay;
            vm.user.timecards[0].workTimeDetail.checkinEnabled = result.workTimeDetail.checkinEnabled;
            vm.user.timecards[0].workTimeDetail.checkoutEnabled = result.workTimeDetail.checkoutEnabled;
            vm.user.timecards[0].workTimeDetail.beoutEnabled = result.workTimeDetail.beoutEnabled;
            vm.user.timecards[0].workTimeDetail.reentryEnabled = result.workTimeDetail.reentryEnabled;
            vm.user.timecards[0].haveUnFinishedTimecard = result.haveUnFinishedTimecard;
            vm.user.timecards[0].rawData = result.rawData;

            vm.timecardData = vm.user.timecards[0];
            vm.listUpData = vm.listup();
        }

        /**
         * 打刻画面にユーザを選らんだかどうかを判断する
         * @returns {boolean}
         */
        function isUserSelected() {
            if (vm.user === undefined || vm.user === null) {
                return false;
            }
            if (vm.user.id === undefined) {
                return false;
            }
            return true;
        }

        /**
         * 打刻画面で利用者は写真を表示するかどうかを判断する
         * @returns {boolean}
         */
        function haveUserPhoto() {
            if (vm.user === null) {
                return false;
            }
            if (vm.user.imageUrl === null) {
                return false;
            }
            if (vm.user.imageUrl.length > 0) {
                return true;
            }
            return false;
        }
        //チェックインボタンは有効かどうかを判別する
        function isCheckInEnabled() {
            if (vm.timecardData === null){
                return false;
            } else if (!angular.isDefined(vm.timecardData.workTimeDetail)){
                return false;
            } else {
                return vm.timecardData.workTimeDetail.checkinEnabled;
            }
        }
        //チェックアウトは有効かどうかを判別する
        function isCheckOutEnabled() {
            if (vm.timecardData === null) {
                return false;
            } else if(!angular.isDefined(vm.timecardData.workTimeDetail)){
                return false;
            } else {
                return vm.timecardData.workTimeDetail.checkoutEnabled;
            }
        }
        //外出ボタンは有効かどうかを判別する
        function isBeOutEnabled() {
            if (vm.timecardData === null) {
                return false;
            } else if(!angular.isDefined(vm.timecardData.workTimeDetail)){
                return false;
            } else {
                return vm.timecardData.workTimeDetail.beoutEnabled;
            }
        }
        //再入ボタンは有効かどうかを判別する
        function isReEntryEnabled () {
            if (vm.timecardData === null) {
                return false;
            } else if (!angular.isDefined(vm.timecardData.workTimeDetail)){
                return false;
            } else {
                return vm.timecardData.workTimeDetail.reentryEnabled;
            }
        }

        function starsWith(actual, expected) {
            var lowerStr = (actual + "").toLowerCase();
            return lowerStr.indexOf(expected.toLowerCase()) === 0;
        }

        function listup() {
            var result = [];
            if (vm.timecardData === null) {
                return result;
            } else if (angular.isUndefined(vm.timecardData) || vm.timecardData.length === 0) {
                return result;
            }
            var data = vm.timecardData.rawData;
            if (angular.isDefined(data) && data.length > 0) {
                var index = 0;
                angular.forEach(data, function(value, key){
                    if (value !== null && angular.isDefined(value)) {
                        if(value.type === 1) {
                            if (angular.isDefined(value.inTime) && value.inTime !== null) {
                                if(vm.timecardData.workTimeDetail.nextDay === true) {
                                    result.push({"name":"出勤(昨日)","time":value.inTime});
                                } else {
                                    result.push({"name":"出勤","time":value.inTime});
                                }

                                index += 1;
                            }
                            if (angular.isDefined(value.outTime) && value.outTime !== null) {
                                result.push({"name":"退勤","time":value.outTime});
                            }
                        }
                        if(value.type === 2) {
                            if (angular.isDefined(value.inTime) && value.inTime !== null) {
                                result.splice(index, 0, {"name":"外出","time":value.inTime});
                                index += 1;
                            }
                            if (angular.isDefined(value.outTime) && value.outTime !== null) {
                                result.splice(index, 0,  {"name":"再入","time":value.outTime});
                                index += 1;
                            }
                        }
                    }
                });
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            vm.loadUsers(vm.group);
        }

        function afterCheck(result) {
            vm.showTimeZoneFlag = false;
            if (result.type == 3) {
                vm.showTimeZoneFlag = true;
            } else if (result.type == 4) {
                alert("職種や勤務形態が設定されていませんので、先に設定してください。");
            } else if (result.type == 5) {
                $rootScope.yoteiList = result.yoteiList;
                $state.go('timecard.dutyselect');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('group-option', {
            parent: 'app',
            url: '/timeca/rdgroup-option',
            data: {
                pageTitle: 'global.menu.timecard.management'
            },
            views: {
                'content@': {
                    templateUrl: 'app/timecard/group-option/group-option.html',
                    controller: 'GroupOptionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timecardOption');
                    return $translate.refresh();
                }]

            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                        var gtc_caretree2_timecard_allfunction_fullaccess = false;
                        var isAdmin = false;
                        var isDeveloper = false;
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_TimeCard_AllFunction_FullAccess"}, function(result){
                        	if (!result.flag) {
                        		$state.go('accessdenied');
                        	} else {
                        		plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess);
                        	}
                        });
                	} else {
                		LoginService.open();
                	}
                	
                });
            }]
        });
    }
    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_timecard_allfunction_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_TimeCard_AllFunction_FullAccess') {
                    gtc_caretree2_timecard_allfunction_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_timecard_allfunction_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('GroupOption', GroupOption);

    GroupOption.$inject = ['$resource'];

    function GroupOption ($resource) {
        var service = $resource('timecard/api/options/group', {}, {
            'get': {
                method: 'GET',
                url:'timecard/api/options/group'
            },
            'getAll': {
                method: 'POST',
                url:'timecard/api/options/group/all'
            },
            'save': {
                method: 'POST',
                url:'timecard/api/options/group'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';
//TimecardOption
    angular
        .module('gatewayApp')
        .controller('GroupOptionController', GroupOptionController);

    GroupOptionController.$inject = ['MessageService', '$state', 'Group', 'GroupOption'];

    function GroupOptionController(MessageService, $state, Group, GroupOption) {
        var vm = this;

        vm.group = [];
        vm.loadGroupOption = loadGroupOption;
        vm.groupOptions = [];
        //页面加载时，取得所有的Group
        vm.loadParentGroup = loadParentGroup;

        vm.save = save;

        vm.loadParentGroup();

        function loadGroupOption () {
            GroupOption.getAll({"groups":vm.group}, function(result, headers){
                vm.groupOptions = result.groups;
            });
        }

        function loadParentGroup() {
            var ids = new Array();
            Group.parentGroup({}, function(result){
                result.forEach(function(value,index){
                    ids.push({groupId:value.id,groupName:value.name});
                });
                vm.group = ids;
                vm.loadGroupOption();
            });
        }

        function save(){
            GroupOption.save({"groups":vm.groupOptions},function(result){

            },function(error){

            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('variable', {
            parent: 'system',
            url: '/robot/variable',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.setting.variable'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/variable/variable.html',
                    controller: 'VariableController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('variable');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                		var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess == false) {
                    		$state.go('home');
                        	$uibModal.open({
                                templateUrl: 'app/home/dialog/license.html',
                                controller: 'HomeLicenseController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg'
                            }).result.then(function() {
                                $state.go('home', null, { reload: true });
                            }, function() {
                                $state.go('home');
                            });
                        }
                	} else {
                		LoginService.open();
                	}
                	
                });
            }]
        }).state('variable.new', {
            parent: 'variable',
            url: '/{itemType}/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
            	Principal.identity().then(function(account) {
            		if (account != null) {
            			var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                        	$uibModal.open({
                                templateUrl: 'app/system/variable/detail/variable-edit-dialog.html',
                                controller: 'VariableEditDialogController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg',
                                resolve: {
                                    entity: function () {
                                        return {id: null, itemType: $stateParams.itemType, itemCode: null, itemValue: null};
                                    }
                                }
                            }).result.then(function() {
                                $state.go('variable', null, { reload: true });
                            }, function() {
                                $state.go('variable');
                            });
                        }
            		} else {
            			LoginService.open();
            		}
                	
                });
            }]
        }).state('variable.edit', {
            parent: 'variable',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
            	Principal.identity().then(function(account) {
            		if (account != null) {
            			var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                        	$uibModal.open({
                                templateUrl: 'app/system/variable/detail/variable-edit-dialog.html',
                                controller: 'VariableEditDialogController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg',
                                resolve: {
                                    entity: ['Variable', function(Variable) {
                                        return Variable.get({id : $stateParams.id});
                                    }]
                                }
                            }).result.then(function() {
                                $state.go('variable', null, { reload: true });
                            }, function() {
                                $state.go('variable');
                            });
                        }
            		} else {
            			LoginService.open();
            		}
                	
                });
            }]
        }).state('variable.delete', {
            parent: 'variable',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
            	Principal.identity().then(function(account) {
            		if (account != null) {
            			var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                        	$uibModal.open({
                                templateUrl: 'app/system/variable/detail/variable-delete-dialog.html',
                                controller: 'VariableDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: ['Variable', function(Variable) {
                                        return Variable.get({id: $stateParams.id});
                                    }]
                                }
                            }).result.then(function() {
                                $state.go('variable', null, { reload: true });
                            }, function() {
                                $state.go('^');
                            });
                        }
            		} else {
            			LoginService.open();
            		}
                	
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Variable', Variable);

    Variable.$inject = ['$resource'];

    function Variable ($resource) {
        var service = $resource('robot/api/variable', {}, {
            "query": {
                method: 'GET',
                isArray: true,
                url:'robot/api/variables/type/:type'
            },
            "save": {
                method: "POST"
            },
            "delete": {
                method: "DELETE",
                url: 'robot/api/variable/:id'
            },
            "get": {
                method: "GET",
                url: 'robot/api/variable/:id'
            },
            "list": {
                method: "GET",
                isArray: true,
                url:'robot/api/variables'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('VariableController', VariableController);

    VariableController.$inject = ['ParseLinks', 'paginationConstants', 'Variable', 'Enum', '$rootScope', 'Library'];

    function VariableController (ParseLinks, paginationConstants, Variable, Enum, $rootScope, Library) {
        var vm = this;

        vm.itemType = {};
        vm.variables = [];
        vm.variableList = [];
        vm.url = null;

        vm.loadAll = loadAll;
        vm.loadVariableType = loadVariableType;
        vm.loadVariableList = loadVariableList;
        vm.changeType = changeType;

        vm.loadAll();

        function loadAll() {
            loadVariableType();
            loadUrl();
        }

        function loadVariableType() {
            Enum.get({name: 'VariableType'}, function (result) {
                vm.variables = result;
                if (vm.variables.length > 0) {
                    if ($rootScope.variableType && $rootScope.variableType != "" && $rootScope.variableType != null) {
                        for (var i = 0; i < vm.variables.length; i ++) {
                            if ($rootScope.variableType == vm.variables[i].code) {
                                vm.itemType = vm.variables[i];
                                loadVariableList();
                            }
                        }
                    } else {
                        vm.itemType = vm.variables[0];
                        loadVariableList();
                    }
                }
            });
        }

        function loadVariableList() {
            Variable.query({page: vm.page - 1, size: paginationConstants.itemsPerPage, type: vm.itemType.code}, function(result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.variableList = result;
            });
        }

        function changeType(code) {
            for (var i = 0; i < vm.variables.length; i ++) {
                if (code == vm.variables[i].code) {
                    vm.itemType = vm.variables[i];
                    loadVariableList();
                }
            }
        }

        function loadUrl() {
            Library.url(function(result){
                vm.url = result.url;
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('VariableEditDialogController', VariableEditDialogController);

    VariableEditDialogController.$inject = ['$uibModalInstance', 'entity', 'Variable', '$rootScope', 'Upload', 'MessageService', 'Library', 'Uploader', '$timeout'];

    function VariableEditDialogController ($uibModalInstance, entity, Variable, $rootScope, Upload, MessageService, Library, Uploader, $timeout) {

        var vm = this;

        vm.picFile = null;
        vm.url = null;
        vm.delFlg = false;

        vm.clear = clear;
        vm.save = save;
        vm.del = del;

        vm.variable = entity;

        loadUrl();

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $rootScope.variableType = vm.variable.itemType;
            // upload
            if (vm.picFile != null) {
                uploadPic(result);
            } else {
                saveSuccess();
            }
        }

        function onSaveError() {
            MessageService.error("variable.edit.saveError")
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            Variable.save(vm.variable, onSaveSuccess, onSaveError);
        }

        function uploadPic(result) {
            Upload.upload({
                url: 'library/api/upload/movement',
                data: {fileName: result.id, file: vm.picFile}
            }).success(function () {
                saveSuccess();
            }).error(function () {
                MessageService.error("variable.edit.photo.saveError");
            });
        }

        function saveSuccess() {
            MessageService.success("variable.edit.saveSuccess");
            $uibModalInstance.close();
            $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
        }

        function loadUrl() {
            Library.url(function(result){
                vm.url = result.url;
            })
        }

        function del() {
            Uploader.delByName({name: vm.variable.id}, function(){
                vm.delFlg = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('VariableDeleteController', VariableDeleteController);

    VariableDeleteController.$inject = ['$uibModalInstance', 'entity', 'Variable', '$rootScope', 'Uploader'];

    function VariableDeleteController ($uibModalInstance, entity, Variable, $rootScope, Uploader) {

        var vm = this;

        vm.variable = entity;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            del();
            Variable.delete({id: id}, function () {
                $rootScope.variableType = vm.variable.itemType;
                $uibModalInstance.close(true);
            });
        }

        function del() {
            Uploader.delByName({name: vm.variable.id}, function(){
                vm.delFlg = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementUpdateAllController',UserManagementUpdateAllController);

    UserManagementUpdateAllController.$inject = ['User', '$stateParams', 'AlertService', '$http'];

    function UserManagementUpdateAllController (User, $stateParams, AlertService,$http) {
        var vm = this;
        vm.selected = $stateParams.selected;

        vm.loadData = loadData;
        vm.save = save;
        vm.saved = false;
        vm.print = print;
        vm.changePw = changePw;

        vm.loadData();
        vm.saveFlag = true;
        function changePw(user){
            if(user.password.length<6 && user.password.length>0){
                user.errorFlag = true;
                user.minFlag = true;
                user.maxFlag = false;
                user.requiredFlag = false;
            }else if(user.password.length<=50 && user.password.length>=6){
                user.errorFlag = false;
                user.minFlag = false;
                user.maxFlag = false;
                user.requiredFlag = false;
            }else if(user.password.length > 50){
                user.errorFlag = true;
                user.maxFlag = true;
                user.minFlag = false;
                user.requiredFlag = false;
            }
            if(user.password.length == 0){
                user.errorFlag = true;
                user.requiredFlag = true;
                user.minFlag = false;
                user.maxFlag = false;
            }else if(user.password.length > 0){
                user.requiredFlag = false;
            }
            vm.resultFlag = false;
            angular.forEach(vm.users,function(data,index,array){
                if(data.requiredFlag == true || data.errorFlag == true || data.maxFlag == true || data.minFlag == true){
                    vm.saveFlag = true;
                    vm.resultFlag = true;
                }
                vm.saveFlag = vm.resultFlag;

            });
        }

        function loadData() {
            User.queryAll({selected:vm.selected},function(result){
                vm.users = result;
                angular.forEach(vm.users,function(data,index,array){
                    data.requiredFlag = true;
                    data.errorFlag = true;
                    data.maxFlag = false;
                    data.minFlag = false;
                });
            });
        }

        function save() {
            var result = [];
            angular.forEach(vm.users,function(data,index,array){
                result.push({id:data.id,name:data.lastName + " " + data.firstName,password:data.password});
            });
            User.updateAll({users:result},function(data){
                vm.saved = true;
                vm.printData = result;
            });
        }

        function print() {
            $http({
                url: "/export/password",
                method: 'post',
                data: {users:vm.printData},
                responseType: 'arraybuffer'
            }).success(function (data, status, headers) {
                var type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                if (!type) throw '无效类型';
                saveAs(new Blob([data], { type: type }), decodeURI(headers()["content-disposition"]).replace("attachment;filename=",""));  // 中文乱码
            }).error(function (data, status) {
                AlertService.error("エクスポート失敗しました。");
            });

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'User', 'JhiLanguageService','Group', 'MessageService', '$timeout', '$rootScope','OptionUser','Principal', 'Outlets'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, User, JhiLanguageService, Group, MessageService, $timeout, $rootScope, OptionUser, Principal, Outlets) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_PARTNER'];
        vm.auths = ['admin', 'member', 'follower'];
        vm.groups = [];
        vm.clear = clear;
        vm.loadAllGroups = loadAllGroups;
        vm.languages = null;
        vm.save = save;
        vm.user = {};
        vm.password = "";
        vm.selectAuth = "";
        // 是否展示贩卖店内容信息
        vm.showShop = false;
        // 贩卖店基本信息
        vm.outlets = {"userId": "", "name": "", "tel": "", "fax": "", "branch": "", "person": ""};

        vm.groupAuth = [];
        vm.repeatFlg = false;
        // 所选节点不能在一棵树枝上
        vm.parentErrorFlg = false;

        vm.tempAuthorities = null;
        vm.changeGroup = changeGroup;
        vm.addGroup = addGroup;
        vm.delGroup = delGroup;
        vm.checkRepeat = checkRepeat;
        vm.loadHourSalary = loadHourSalary;
        vm.getGroupShow = getGroupShow;
        vm.loadAuthorities = loadAuthorities;
        // 改变用户角色时候触发
        vm.authorityChange = authorityChange;
        vm.changeAu = changeAu;
        vm.exist = false;
        vm.existButton = false;
        vm.existEmail = false;
        vm.existEmailButton = false;
        vm.loginMouseleave = loginMouseleave;
        vm.emailMouseleave = emailMouseleave;
        vm.isAdminRoleFlag = false;

        vm.loadUser = loadUser()

        function changeAu(au,checked, $event) {
            /*if (vm.user.authorities == au) {
                $event.preventDefault();
            } else {
                vm.user.authorities = au;
            }*/
            authorityChange(au,checked);
        }

        vm.loadAllGroups();

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        function loadUser() {
            if ($stateParams.login) {
                User.get({login : $stateParams.login}, function(user) {
                    vm.user = user;
                    vm.user.authorities = [];
                    vm.user.roleList = [];
                    loadAuthorities()
                })
            } else {
                vm.user = {
                    id: null, login: null, firstName: null, lastName: null, email: null,
                    activated: true, created: false, langKey: null, createdBy: null, createdDate: null,
                    lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                    resetKey: null, authorities: null, groupAuthes: []
                }
                vm.user.authorities = [];
                vm.user.roleList = [];
                loadAuthorities()
            }
        }

        function loadAuthorities() {
            Principal.identity().then(function(account) {
                for (var i = 0; i < account.authorities.length; i++) {
                    if (account.authorities[i] == "ROLE_ADMIN") {
                        vm.isAdminRoleFlag = true;
                    }
                }
                //是admin
                if(vm.isAdminRoleFlag){
                    User.getRole(function(r){
                        vm.user.roleList = r;
                        for(var i=0; i < vm.user.roleList.length; i++){
                            if(vm.user.roleList[i].name == 'ROLE_USER'){
                                vm.user.roleList[i].disabled = true;
                                vm.user.roleList[i].checked = true;
                            }else {
                                vm.user.roleList[i].disabled = false;
                            }
                        }
                        if ($stateParams.login != undefined) {
                            User.get({login: $stateParams.login}, function (result) {
                                var hasAdmin = false;
                                vm.hasAdmin = hasAdmin;
                                vm.user = result;
                                vm.user.roleList = r;
                                for(var j=0; j < vm.user.roleList.length; j++){
                                    for (var i = 0; i < result.authorities.length; i++) {
                                        if (result.authorities[i] == vm.user.roleList[j].name) {
                                            vm.user.roleList[j].checked = true;
                                        }
                                        if (result.authorities[i] == "ROLE_ADMIN") {
                                            hasAdmin = true;
                                        }
                                        if (result.authorities[i] == "ROLE_PARTNER") {
                                            vm.showShop = true;
                                        }
                                    }
                                }
                                if (vm.user.authorities.indexOf('ROLE_PARTNER') != -1) {
                                    Outlets.getByUserId({userId: vm.user.id}, function(outletsResult){
                                        vm.outlets = outletsResult;
                                    });
                                }
                            });
                        }
                    });
                }else {
                    //新增
                    if($stateParams.login == undefined){
                        //查当前登录账号绑定的Role
                        User.getSelectRole({login: account.login}, function (role) {
                            for(var a=0; a < role.length; a++){
                                role[a].checked = true;
                                vm.user.roleList.push(role[a]);
                                if(role[a].name == 'ROLE_USER'){
                                    role[a].disabled = true;
                                }else {
                                    role[a].disabled = false;
                                }
                            }
                        });
                        //编辑
                    }else {
                        //查出所有的Role
                        User.getRole(function(r){
                            vm.roleList = r;
                            if ($stateParams.login != undefined) {
                                //查当前登录账号绑定的Role
                                User.get({login: account.login}, function (result) {
                                    var hasAdmin = false;
                                    vm.hasAdmin = hasAdmin;
                                    vm.user.roleList = [];
                                    for(var j=0; j < vm.roleList.length; j++){
                                        for (var i = 0; i < result.authorities.length; i++) {
                                            if (result.authorities[i] == vm.roleList[j].name) {
                                                if(vm.roleList[j].name == 'ROLE_USER'){
                                                    vm.roleList[j].disabled = true;
                                                }
                                                vm.user.roleList.push(vm.roleList[j]);
                                            }
                                            if (result.authorities[i] == "ROLE_ADMIN") {
                                                hasAdmin = true;
                                            }
                                            if (result.authorities[i] == "ROLE_PARTNER") {
                                                vm.showShop = true;
                                            }
                                        }
                                    }
                                    if (vm.user.authorities.indexOf('ROLE_PARTNER') != -1) {
                                        Outlets.getByUserId({userId: vm.user.id}, function(outletsResult){
                                            vm.outlets = outletsResult;
                                        });
                                    }
                                    //查询选中的账号的Role;
                                    User.getSelectRole({login: $stateParams.login}, function (selectRole) {
                                        for(var a=0; a < vm.user.roleList.length; a++){
                                            var number = 0;
                                            for (var b = 0; b < selectRole.length; b++) {
                                                if (selectRole[b].name == vm.user.roleList[a].name) {
                                                    vm.user.roleList[a].checked = true;
                                                    number = 1;
                                                }
                                            }
                                        }
                                        //判断之前选中的在现在的父的里边有没有
                                        for (var c = 0; c < selectRole.length; c++) {
                                            var number = 0;
                                            for(var d = 0; d < vm.user.roleList.length; d++){
                                                if (selectRole[c].name == vm.user.roleList[d].name) {
                                                    number = 1;
                                                }
                                            }
                                            if(number == 0){
                                                selectRole[c].checked = true;
                                                vm.user.roleList.push(selectRole[c]);
                                            }
                                        }
                                    });
                                });
                            }
                        });
                    }
                }
            });
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            // 保存用户信息成功之后，获取得到用户的ID，进行贩卖店信息的处理
            saveOutlets(result.id);
            if (angular.isDefined(vm.user.option) &&  vm.user.option.hourSalary !== null) {
                OptionUser.saveHourSalary(vm.user,function () {
                    vm.isSaving = false;
                    MessageService.success("global.messages.info.save");
                    $uibModalInstance.close(result);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                });
            } else {
                vm.isSaving = false;
                MessageService.success("global.messages.info.save");
                $uibModalInstance.close(result);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            }
        }

        function onSaveError () {
            vm.user.authorities = angular.copy(vm.tempAuthorities);
            vm.isSaving = false;
            MessageService.error("global.messages.error.save");
        }

        function save () {
            vm.user.authorities = [];
            vm.isSaving = true;
            for (var i = vm.user.groupAuthes.length - 1; i >= 0; i --) {
                if (vm.user.groupAuthes[i].groupId == undefined || vm.user.groupAuthes[i].groupId == "") {
                    vm.user.groupAuthes.splice(i, 1);
                }
            }

            for (var i = 0; i < vm.user.roleList.length; i++) {
                if(vm.user.roleList[i].checked){
                    vm.user.authorities.push(vm.user.roleList[i].name);
                }
            }
            vm.tempAuthorities = angular.copy(vm.user.authorities);
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.password = vm.password;
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function loadAllGroups() {
            Group.manageGroup({}, function(result){
                vm.groups = result;
                vm.loadHourSalary(vm.user.id);
            });
        }

        function loadHourSalary(userId) {
            if (angular.isDefined(userId) && userId !== null) {
                OptionUser.get({userId:userId}, function (result) {
                    vm.user.option = result;
                });
            }
        }

        function changeGroup(index) {
            vm.checkRepeat();
            if (vm.user.groupAuthes[index].groupAuth == null || vm.user.groupAuthes[index].groupAuth == "") {
                vm.user.groupAuthes[index].groupAuth = angular.copy(vm.auths[0]);
            }
        }

        function addGroup() {
            vm.user.groupAuthes.push({});
        }

        function delGroup(index) {;
            vm.user.groupAuthes.splice(index, 1);
            vm.checkRepeat();
        }

        function checkRepeat() {
            vm.repeatFlg = false;
            for (var i = 0; i < vm.user.groupAuthes.length; i ++) {
                for (var j = i + 1; j < vm.user.groupAuthes.length; j ++) {
                    if (vm.user.groupAuthes[i].groupId == vm.user.groupAuthes[j].groupId) {
                        vm.repeatFlg = true;
                    }
                }
            }
            vm.parentErrorFlg = false;
            if (!vm.repeatFlg) {
                // 判断他的父节点是否在选择的节点里
                // 找到所选节点的所有的父节点
                // 循环所选的节点

                for (var i = 0; i < vm.user.groupAuthes.length; i ++) {
                    // 找到他所有的父节点
                    var allParentIds = []
                    getAllParentGroup(allParentIds, vm.user.groupAuthes[i].groupId);
                    for (var j = 0; j < vm.user.groupAuthes.length; j ++) {
                        if (j != i && allParentIds.indexOf(vm.user.groupAuthes[j].groupId) != -1) {
                            vm.parentErrorFlg = true;
                        }
                    }
                }
            }
        }

        function getAllParentGroup(result, groupId) {
            for (var i = 0; i < vm.groups.length; i ++) {
                if (vm.groups[i].parentId != '') {
                    if (vm.groups[i].id == groupId) {
                        result.push(vm.groups[i].parentId)
                        result = getAllParentGroup(result, vm.groups[i].parentId)
                    }
                }
            }
        }

        function getGroupShow(groupId) {
            var result = false;
            if (groupId == undefined) {
                result = true;
            }
            for (var i = 0; i < vm.groups.length; i ++) {
                if (groupId == vm.groups[i].id) {
                    result = true;
                }
            }
            return result;
        }

        /**
         * 如果选中的角色是贩卖店，那么显示贩卖店的额外信息表格
         */
        function authorityChange(name,checked) {
            if (name == "ROLE_PARTNER") {
                if(checked){
                    vm.showShop = true;
                }else{
                    vm.showShop = false;
                }
            }else{
                if(vm.showShop){
                    return false;
                }
            }
        }

        /**
         * 保存贩卖店的信息
         */
        function saveOutlets(id) {
            if (vm.showShop) {
                vm.outlets.userId = id;
                Outlets.save(vm.outlets);
            } else {
                Outlets.delete({userId: id});
            }
        }

        function loginMouseleave(){
            if(vm.user.login != ''){
                User.queryLogin({login: vm.user.login}, function (result) {
                    if (result.id == undefined) {
                        vm.exist = false;
                        vm.existButton = false;
                    } else {
                        if(vm.user.id != null){
                            if(vm.user.id != result.id){
                                vm.exist = true;
                                vm.existButton = true;
                            }else{
                                vm.exist = false;
                                vm.existButton = false;
                            }
                        }else{
                            vm.exist = true;
                            vm.existButton = true;
                        }
                    }
                });
            }else {
                vm.exist = false;
                vm.existButton = false;
            }
        }

        function emailMouseleave(){
            if(vm.user.email != ''){
                User.queryEmail({email: vm.user.email}, function (result) {
                    if (result.id == undefined) {
                        vm.existEmail = false;
                        vm.existEmailButton = false;
                    } else {
                        if(vm.user.id != null){
                            if(vm.user.id != result.id){
                                vm.existEmail = true;
                                vm.existEmailButton = true;
                            }else{
                                vm.existEmail = false;
                                vm.existEmailButton = false;
                            }
                        }else{
                            vm.existEmail = true;
                            vm.existEmailButton = true;
                        }
                    }
                });
            }else {
                vm.existEmail = false;
                vm.existEmailButton = false;
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$uibModalInstance','$stateParams', 'User', 'Outlets'];

    function UserManagementDetailController($uibModalInstance,$stateParams, User, Outlets) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.outlets = {};
        vm.outletsShow = false;
        vm.close = close;

        vm.loadAuthorities = loadAuthorities;
        
        vm.authorities = [];
        vm.loadAuthorities();
        
        function loadAuthorities() {
        	User.getRole(function(result){
        		vm.authorities = result;
        		vm.load($stateParams.login);
        	});
        }

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
                if (vm.user.authorities.indexOf("ROLE_PARTNER") != -1) {
                    Outlets.getByUserId({userId: vm.user.id}, function (outletsResult) {
                        vm.outletsShow = true;
                        vm.outlets = outletsResult;
                    });
                }
                for (var j in vm.user.authorities) {
                	for (var k in vm.authorities) {
                    	if (vm.authorities[k].name == vm.user.authorities[j]) {
                    		vm.user.authorities[j] = vm.authorities[k];
                    		break;
                    	}
                    }
                }
            });
        }

        function close () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'Principal', 'entity', 'User', 'Timecard', 'MessageService', '$timeout', '$rootScope'];

    function UserManagementDeleteController ($uibModalInstance, Principal, entity, User, Timecard, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    MessageService.success("global.messages.info.delete");
                    $uibModalInstance.close(true);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                    //当前登录用户的权限包含打卡时,则将timeCare表和history表和salary表中的所有打卡信息的deleted设成1
                    Principal.identity().then(function(account) {
                        if(account.authorities.indexOf('ROLE_TIMECARD') !== -1 ||
                            account.authorities.indexOf('ROLE_ADMIN') !== -1) {
                            Timecard.deleteTimeCard({userId: vm.user.id}, function (){
                            });
                        }
                    });
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserMmanagementCreatetokenController', UserMmanagementCreatetokenController);

    UserMmanagementCreatetokenController.$inject = ['$uibModalInstance','$stateParams', 'UserToken', 'Outlets', '$uibModal', 'TokenService', 'MessageService'];

    function UserMmanagementCreatetokenController($uibModalInstance,$stateParams, UserToken, Outlets, $uibModal, TokenService, MessageService) {
        var vm = this;

        vm.load = load;
        vm.user = {};
        vm.outlets = {};
        vm.outletsShow = false;
        vm.close = close;
        vm.save = save;
        vm.update = update;
        vm.copyToken = copyToken;
        vm.deleteToken = deleteToken;
        vm.token = "";

        vm.load($stateParams.jigyoushoCd, $stateParams.login);

        function load(jigyoushoCd, login) {
            UserToken.query({jigyoushoCd: jigyoushoCd, login: login}, function(result) {
                vm.token = result.token;
            });
        }

        function close () {
            $uibModalInstance.dismiss('cancel');
        }

        function save (){
            var entity = {jigyoushoCd: $stateParams.jigyoushoCd, loginId: $stateParams.login};
            TokenService.createToken(entity, function(result){
                MessageService.success("userManagement.token.tokenSaved");
                vm.token = result.token;
            });
        }

        function update(){
            var entity = {jigyoushoCd: $stateParams.jigyoushoCd, loginId: $stateParams.login};
            TokenService.updateToken(entity, function(result){
                MessageService.success("userManagement.token.tokenUpdated");
                vm.token = result.token;
            });
        }

        function copyToken(token) {
            $('#copyText').val(token).show().focus().select();
            document.execCommand("copy");
            $('#copyText').hide();
        }

        function deleteToken(token){
            var modalInstance = $uibModal.open({
                templateUrl : 'app/system/user-management/dialog/delete-token-dialog.html',
                controller : 'DeleteTokenDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'md',
                resolve: {
                    entity: ['TokenService', function(TokenService) {
                        return token ;
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                vm.token = null;
            },function(){
                //MessageService.error("global.error.internalServerError");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementAddAllDialogController',UserManagementAddAllDialogController);

    UserManagementAddAllDialogController.$inject = ['staffList', 'User', '$stateParams', '$uibModalInstance', 'MessageService', '$timeout', '$rootScope'];

    function UserManagementAddAllDialogController (staffList, User, $stateParams, $uibModalInstance, MessageService, $timeout, $rootScope) {
        var vm = this;
        vm.noChecked = false;
        vm.checkAll = true;
        vm.staffList = staffList;
        vm.errorList = [];
        vm.errorShow = false;

        vm.cancel = cancel;
        vm.save = save;
        vm.check = check;
        vm.checkAllFun = checkAllFun;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            var selectList = [];
            for (var i = 0; i < vm.staffList.length; i ++) {
                if (vm.staffList[i].checked) {
                    selectList.push(vm.staffList[i]);
                }
            }
            User.saveAll({groupId: $stateParams.groupId, staffList: selectList}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            if (result != null && result.length > 0) {
                vm.errorList = result;
                vm.errorShow = true;
            } else {
                MessageService.success("global.messages.info.save");
                $uibModalInstance.close(result);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            }
        }

        function onSaveError () {
            MessageService.error("global.messages.error.save");
        }

        function check() {
            var allChecked = true;
            vm.noChecked = true;
            for (var i = 0; i < vm.staffList.length; i ++) {
                if (!vm.staffList[i].checked) {
                    allChecked = false;
                } else {
                    vm.noChecked = false;
                }
            }
            if (allChecked) {
                vm.checkAll = true;
            } else {
                vm.checkAll = false;
            }
        }

        function checkAllFun() {
            if (vm.checkAll) {
                for (var i = 0; i < vm.staffList.length; i ++) {
                    vm.staffList[i].checked = true;
                }
                vm.noChecked = false;
            } else {
                for (var i = 0; i < vm.staffList.length; i ++) {
                    vm.staffList[i].checked = false;
                }
                vm.noChecked = true;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'app',
            url: '/settings/account?page&sort',
            data: {
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                Principal.identity().then(function(account) {
                	if (account != null) {
                		var isGroupAdmin = false;

                        if (account.authorities
                            && (account.authorities.indexOf("ROLE_ADMIN") !== -1
                                || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                            isGroupAdmin = true;
                        } else {
                            account.groupAuthes.forEach(function (element) {
                                if (element.groupAuth === 'admin') {
                                    isGroupAdmin = true;
                                }
                            });
                        }
                        if (!isGroupAdmin) {
                            $state.go('accessdenied');
                        }
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Authentication_access_FullAccess"}, function(result){
                        	if (!result.flag) {
                        		$state.go('accessdenied');
                        	}
                        });
                	} else {
                		LoginService.open();
                	}

                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/:login',
            data: {
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                Principal.identity().then(function(account) {
                	if (account != null) {
                		var isGroupAdmin = false;
                        if (account.authorities
                            && (account.authorities.indexOf("ROLE_ADMIN") !== -1
                                || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                            isGroupAdmin = true;
                        } else {
                            account.groupAuthes.forEach(function (element) {
                                if (element.groupAuth === 'admin') {
                                    isGroupAdmin = true;
                                }
                            });
                        }
                        if (isGroupAdmin) {
                            $uibModal.open({
                                templateUrl: 'app/system/user-management/user-management-dialog.html',
                                controller: 'UserManagementDialogController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg',
                                resolve: {
                                    entity: function () {
                                        return {
                                            id: null, login: null, firstName: null, lastName: null, email: null,
                                            activated: true, created: false, langKey: null, createdBy: null, createdDate: null,
                                            lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                            resetKey: null, authorities: null, groupAuthes: []
                                        };
                                    }
                                }
                            }).result.then(function() {
                                $state.go('user-management', null, { reload: true });
                            }, function() {
                                $state.go('user-management');
                            });
                        }
                	} else {
                		LoginService.open();
                	}

                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/edit/{login}',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                Principal.identity().then(function(account) {
                	if (account != null) {
                		var isGroupAdmin = false;
                        if (account.authorities
                            && (account.authorities.indexOf("ROLE_ADMIN") !== -1
                                || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                            isGroupAdmin = true;
                        } else {
                            account.groupAuthes.forEach(function (element) {
                                if (element.groupAuth === 'admin') {
                                    isGroupAdmin = true;
                                }
                            });
                        }
                        if (isGroupAdmin) {
                            $uibModal.open({
                                templateUrl: 'app/system/user-management/user-management-dialog.html',
                                controller: 'UserManagementDialogController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg'
                            }).result.then(function() {
                                $state.go('user-management', null, { reload: true });
                            }, function() {
                                $state.go('^');
                            });
                        }
                	} else {
                		LoginService.open();
                	}

                });
            }]
        })
        .state('user-management.show', {
                parent: 'user-management',
                url: '/show/{login}',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                    Principal.identity().then(function(account) {
                    	if (account != null) {
                    		var isGroupAdmin = false;
                            if (account.authorities
                                && (account.authorities.indexOf("ROLE_ADMIN") !== -1
                                    || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                                isGroupAdmin = true;
                            } else {
                                account.groupAuthes.forEach(function (element) {
                                    if (element.groupAuth === 'admin') {
                                        isGroupAdmin = true;
                                    }
                                });
                            }
                            if (isGroupAdmin) {
                                $uibModal.open({
                                    templateUrl: 'app/system/user-management/user-management-detail.html',
                                    controller: 'UserManagementDetailController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'md',
                                    resolve: {
                                        entity: ['User', function(User) {
                                            return User.get({login : $stateParams.login});
                                        }]
                                    }
                                }).result.then(function() {
                                    $state.go('user-management', null, { reload: true });
                                }, function() {
                                    $state.go('^');
                                });
                            }
                    	} else {
                    		LoginService.open();
                    	}

                    });
                }]
            })
        .state('user-management.createToken', {
                parent: 'user-management',
                url: '/usersToken/{jigyoushoCd}/{login}',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                    Principal.identity().then(function(account) {
                    	if (account != null) {
                    		var isGroupAdmin = false;
                            if (account.authorities
                                && (account.authorities.indexOf("ROLE_ADMIN") !== -1
                                    || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                                isGroupAdmin = true;
                            } else {
                                account.groupAuthes.forEach(function (element) {
                                    if (element.groupAuth === 'admin') {
                                        isGroupAdmin = true;
                                    }
                                });
                            }
                            if (isGroupAdmin) {
                                $uibModal.open({
                                    templateUrl: 'app/system/user-management/user-management-createtoken.html',
                                    controller: 'UserMmanagementCreatetokenController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg',
                                    resolve: {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('user-management');
                                            return $translate.refresh();
                                        }]
                                    }
                                }).result.then(function() {
                                    /*$state.go('user-management', null, { reload: true });*/
                                }, function() {
                                    $state.go('^');
                                });
                            }
                    	} else {
                    		LoginService.open();
                    	}

                    });
                }]
            })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                Principal.identity().then(function(account) {
                	if (account != null) {
                		var isGroupAdmin = false;
                        if (account.authorities
                            && (account.authorities.indexOf("ROLE_ADMIN") !== -1
                                || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                            isGroupAdmin = true;
                        } else {
                            account.groupAuthes.forEach(function (element) {
                                if (element.groupAuth === 'admin') {
                                    isGroupAdmin = true;
                                }
                            });
                        }
                        if (isGroupAdmin) {
                            $uibModal.open({
                                templateUrl: 'app/system/user-management/user-management-delete-dialog.html',
                                controller: 'UserManagementDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: ['User', function(User) {
                                        return User.get({login : $stateParams.login});
                                    }]
                                }
                            }).result.then(function() {
                                $state.go('user-management', null, { reload: true });
                            }, function() {
                                $state.go('^');
                            });
                        }
                	} else {
                		LoginService.open();
                	}

                });
            }]
        })
        .state('user-management.addAll', {
            parent: 'user-management',
            url: '/addAll/{groupId}',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                Principal.identity().then(function(account) {
                	if (account != null) {
                		var isGroupAdmin = false;
                        if (account.authorities
                            && (account.authorities.indexOf("ROLE_ADMIN") !== -1
                                || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                            isGroupAdmin = true;
                        } else {
                            account.groupAuthes.forEach(function (element) {
                                if (element.groupAuth === 'admin') {
                                    isGroupAdmin = true;
                                }
                            });
                        }
                        if (isGroupAdmin) {
                            $uibModal.open({
                                templateUrl: 'app/system/user-management/user-management-add-all-dialog.html',
                                controller: 'UserManagementAddAllDialogController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg',
                                resolve: {
                                    staffList: ['User', function(User) {
                                        return User.getStaffs({groupId : $stateParams.groupId}, function(result) {
                                            for (var i = 0; i < result.length; i ++) {
                                                result[i].checked = true;
                                            }

                                        });
                                    }]
                                }
                            }).result.then(function() {
                                $state.go('user-management', null, { reload: true });
                            }, function() {
                                $state.go('user-management');
                            });
                        }
                	} else {
                		LoginService.open();
                	}

                });
            }]
        })
        .state('user-management.updateAll', {
            parent: 'user-management',
            url: '/updateAll/{:selected}',
            data: {
                pageTitle: 'user-management.updateAll.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/user-management/user-management-update-all.html',
                    controller: 'UserManagementUpdateAllController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'Enum', 'User', 'ParseLinks', 'MessageService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'Group', '$filter', 'SelectedGroup', '$scope', '$rootScope', '$stateParams', 'StaffService'];

    function UserManagementController(Principal, Enum, User, ParseLinks, MessageService, $state, pagingParams, paginationConstants, JhiLanguageService, Group, $filter, SelectedGroup, $scope, $rootScope, $stateParams, StaffService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.searchData = {loginId: "", name: "", mailAddress: "", selectGroup: "", activat: "", authorities: 0};
        vm.defaultSearchData = {loginId: "", name: "", mailAddress: "", selectGroup: "", activat: "", authorities: 0};
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = $stateParams.page;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        //vm.searchData.selectGroup = SelectedGroup.current() != null ? SelectedGroup.current().id : null;
        vm.parentGroup = [];
        vm.selectedUser = [];
        vm.selectedUserId = selectedUserId;
        vm.select = select;
        vm.isChecked = isChecked;
        vm.loadParentGroup = loadParentGroup;
        vm.changeGroup = changeGroup;
        vm.research = research;

        vm.gotoUpdateAll = gotoUpdateAll;
        vm.changeactivat = changeactivat;
        vm.changeactivatText = changeactivatText;
        vm.changeauthorities = changeauthorities;
        vm.changeauthoritiesText = changeauthoritiesText;

        vm.loadParentGroup();
        vm.search = search;

        vm.goEdit = goEdit;
        vm.goDel = goDel;
        vm.goNew = goNew;

        vm.clickGroupListClick = clickGroupListClick;
        vm.inputGroupNm = inputGroupNm;

        vm.version = 2;
        vm.changeVersion = changeVersion;
        vm.searchData.staff = {name: "", id: "", login: "", houjinNm: "", jigyoushoNm: ""};
        vm.clearStaff = clearStaff;
        vm.changePage = changePage;

        vm.clickGroupListClick = clickGroupListClick;
        vm.inputGroupNm = inputGroupNm;

        vm.systemAuthorities = {};

        vm.authorities = [];
        vm.loadAuthorities = loadAuthorities;
        vm.loadUsers = loadUsers;

        vm.loadAll();

        function loadAll () {
            if(vm.searchData.authorities == 0){
                vm.searchData.authorities = "";
            }
            if($rootScope.page != undefined){
                vm.page = $rootScope.page;
                $rootScope.page = undefined;
            }
            if ($rootScope.searchData != undefined) {
            	vm.searchData = $rootScope.searchData;
            	$rootScope.searchData = undefined;
            }
            loadTypes();
            loadAuthorities();
        }

        function loadAuthorities() {
        	User.getRole(function(result){
        		vm.authorities = result;
        		loadUsers();
        	});
        }

        function loadUsers() {
        	User.query({
                pageNumber: vm.page - 1,
                pageSize: vm.itemsPerPage,
                sort: sort(),
                groupId: vm.searchData.selectGroup == null ? "" : vm.searchData.selectGroup,
                login: vm.searchData.loginId,
                userName: vm.searchData.name,
                mailAddress: vm.searchData.mailAddress,
                activat: vm.searchData.activat == null ? "" : vm.searchData.activat,
                authorities: vm.searchData.authorities
            }, onSuccess, onError);
        }

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function search(){
            vm.page = 1;
            loadAll();
        }

        function changeactivat(){
            search();
        }

        function changeauthorities(){
            search();
        }

        function changeauthoritiesText(vlaue){
            vm.searchData.authorities = vlaue;
            search();
        }

        function changeactivatText(value){
            vm.searchData.activat = value;
            search();
        }

        function onSuccess(data, headers) {
            for (var i = 0; i < data.length; i ++) {
                var adminFlg = false;
                for (var j in data[i].authorities) {
                    if (data[i].authorities[j] == 'ROLE_ADMIN') {
                        adminFlg = true;
                    }
                    for (var k in vm.authorities) {
                    	if (vm.authorities[k].name == data[i].authorities[j]) {
                    		data[i].authorities[j] = vm.authorities[k];
                    		break;
                    	}
                    }
                }
                data[i].hasAdmin = adminFlg;
            }
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.users = data;
            setTimeout(function() {
                //屏幕高度
                var height = document.documentElement.clientHeight;
                //导航部分的高度
                var navbarHeight = $("#navbarHeight").height();//20
                //检索部分的高度
                var searchHeight = $("#searchHeight").height();//15
                //表头高度
                var headerHeight1 = $("#headerHeight1").height();
                var headerHeight2 = $("#headerHeight2").height();
                //分页部分高度
                var pageHeight = $("#pageHeight").height();
                //copyRight
                var copyRight = $("#copyRight").height();

                if(vm.version == 2){
                    var tableDivHeight2 = height-navbarHeight-20-searchHeight-headerHeight2-20-pageHeight-10-copyRight-10-40;
                    $("#tableDiv2").css("max-height",tableDivHeight2);
                }
                if(vm.version == 1){
                    var tableDivHeight1 = height-navbarHeight-20-searchHeight-headerHeight1-20-pageHeight-10-copyRight-10-40;
                    $("#tableDiv1").css("max-height",tableDivHeight1);
                }
            }, 20);
        }

        function onError(error) {
            MessageService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null, groupAuthes: null
            };
            vm.searchData = angular.copy(vm.defaultSearchData);
            search();
        }

        function sort () {
            var result = [vm.predicate + ' ' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ' ' + (vm.reverse ? 'asc' : 'desc'),
                groupId: vm.selectGroup == null ? "" : vm.selectGroup,
                search: vm.currentSearch

            });
        }

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
            });
        }

        function changeGroup() {

            var selected = null;
            vm.selectedUser = [];
            for (var i = 0; i < vm.parentGroup.length; i ++) {
                if (vm.parentGroup[i].id == vm.searchData.selectGroup) {
                    selected = vm.parentGroup[i];
                }
            }
            SelectedGroup.setCurrent(selected);
            $rootScope.$broadcast('groupChanged');
            search();
            //research();
        }

        function research() {
            User.query({
                page: 0,
                size: vm.itemsPerPage,
                sort: sort(),
                groupId: vm.selectGroup == null ? "" : vm.selectGroup
            }, onSuccess, onError);
        }

        function select(user){
           if (vm.isChecked(user)) {
               angular.forEach(vm.selectedUser, function (u){
                   if(user.id == u.userId){
                       var index = vm.selectedUser.indexOf(u);
                       vm.selectedUser.splice(index,1);
                   }
               });
           } else {
               var userName = "";
               if (user.lastName != null && user.lastName != "") {
                   userName += user.lastName;
               }
               if (user.firstName != null && user.firstName != "" && user.lastName != null && user.lastName != "") {
                   userName += " ";
               }
               if (user.firstName != null && user.firstName != "") {
                   userName += user.firstName;
               }
               vm.selectedUser.push({userId:user.id,userName:userName});
           }
        }

        function isChecked(user) {
            //var selected = $filter('filter')(vm.selectedUser, {userId: user.id})[0];
            var result = false;
            angular.forEach(vm.selectedUser, function (u){
                if(user.id == u.userId){
                    result = true;
                }
            });
            if (result){
                return true;
            }

            angular.forEach(this.groups, function(group) {
                if (group !== openGroup) {
                    group.isOpen = false;
                }
            });
            return false;
        }

        function selectedUserId(){
            var ids = [];
            angular.forEach(vm.selectedUser,function(data,index,array){
                ids.push(data.userId);
            });
            return ids;
        }

        $scope.$on('groupChanged', function() {
            vm.searchData.selectGroup = SelectedGroup.current() != null ? SelectedGroup.current().id : null;
            search();
        })

        function gotoUpdateAll() {
            if (vm.selectedUserId().length > 0) {
                $state.go("user-management.updateAll", {selected:vm.selectedUserId()});
            } else {
                MessageService.error("userManagement.error.noSelected");
                return false;
            }

        }

        function loadTypes() {
            /*Enum.getGateWay({name: "SystemAuthorities"}, function(result) {
                vm.systemAuthorities = result;
            });*/
            User.getRole(function(r) {
                var role = {name: "", nameDetail: "すべて", checked : true};
                r.unshift(role);
                vm.systemAuthorities = r;
            });
        }

        function goEdit(login) {
            $rootScope.page = vm.page;
            $rootScope.searchData = vm.searchData;
            $state.go('user-management.edit', {login: login});
        }

        function goDel(login) {
            $rootScope.page = vm.page;
            $rootScope.searchData = vm.searchData;
            $state.go('user-management.delete', {login: login});
        }

        function goNew() {
            $rootScope.page = vm.page;
            $rootScope.searchData = vm.searchData;
            $state.go('user-management.new');
        }

        function changeVersion(version) {
            vm.page = 1;
            if (version == 1) {
            	loadOneData();
            } else {
            	search();
            }

        }

        function loadOneData() {
            StaffService.query({page: vm.page - 1, size: vm.itemsPerPage,
            	name: vm.searchData.staff.name,
            	id: vm.searchData.staff.id,
            	login: vm.searchData.staff.login,
            	houjinNm: vm.searchData.staff.houjinNm,
            	jigyoushoNm: vm.searchData.staff.jigyoushoNm}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.staffList = result;
                setTimeout(function() {
                    //屏幕高度
                    var height = document.documentElement.clientHeight;
                    //导航部分的高度
                    var navbarHeight = $("#navbarHeight").height();//20
                    //检索部分的高度
                    var searchHeight = $("#searchHeight").height();//15
                    //表头高度
                    var headerHeight1 = $("#headerHeight1").height();
                    var headerHeight2 = $("#headerHeight2").height();
                    //分页部分高度
                    var pageHeight = $("#pageHeight").height();
                    //copyRight
                    var copyRight = $("#copyRight").height();

                    if(vm.version == 2){
                        var tableDivHeight2 = height-navbarHeight-20-searchHeight-headerHeight2-20-pageHeight-10-copyRight-10-40;
                        $("#tableDiv2").css("max-height",tableDivHeight2);
                    }
                    if(vm.version == 1){
                        var tableDivHeight1 = height-navbarHeight-20-searchHeight-headerHeight1-20-pageHeight-10-copyRight-10-40;
                        $("#tableDiv1").css("max-height",tableDivHeight1);
                    }
                }, 20);
            });
        }

        function clearStaff() {
        	vm.searchData.staff = {name: "", id: "", login: "", houjinNm: "", jigyoushoNm: ""};
        	changeVersion(1);
        }

        function changePage() {
        	if (vm.version == 1) {
        		loadOneData();
        	} else {
        		loadAll();
        	}
        }

        function clickGroupListClick(gp) {
        	vm.searchData.selectGroup = gp.id;
        	vm.searchData.selectGroupNm = gp.name + gp.serviceTypeName;
        	vm.groupSelectListShowFlg = false;
        }

        function inputGroupNm() {
        	vm.groupSelectListShowFlg = false;
        	if (vm.searchData.selectGroupNm != undefined && vm.searchData.selectGroupNm != "") {
        		vm.searchData.selectGroup = "gid0";
        	} else {
        		vm.searchData.selectGroup = "";
        	}

        	for (var i = 0; i < vm.parentGroup.length; i ++) {
        		if (vm.searchData.selectGroupNm != undefined && vm.searchData.selectGroupNm != "") {
        			if ((vm.parentGroup[i].name + vm.parentGroup[i].serviceTypeName).indexOf(vm.searchData.selectGroupNm) != -1) {
        				vm.parentGroup[i].showFlg = true;
        				vm.groupSelectListShowFlg = true;
        			} else {
        				vm.parentGroup[i].showFlg = false;
        			}
        		} else {
        			vm.parentGroup[i].showFlg = true;
        		}
        	}
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('DeleteTokenDialogController', DeleteTokenDialogController);

    DeleteTokenDialogController.$inject = ['$uibModalInstance', 'entity', 'TokenService', 'MessageService', '$timeout', '$rootScope'];

    function DeleteTokenDialogController ($uibModalInstance, entity, TokenService, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            TokenService.deleteToken({token: entity}, function () {
                    MessageService.success("global.messages.info.delete");
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TokenShopController', TokenShopController);

    TokenShopController.$inject = ['TokenService', 'paginationConstants'];

    function TokenShopController (TokenService, paginationConstants) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 查询条件
        vm.searchData = {shopNm: "", tel: ""};
        vm.defaultSearchData = {shopNm: "", tel: ""};

        // 贩卖店列表
        vm.shopList = [];

        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;

        loadData();

        function loadData() {
            TokenService.shopList(vm.searchData, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.shopList = result;
                vm.queryCount = vm.totalItems;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('token-shop', {
            parent: 'app',
            url: '/settings/outlet',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/token-management/token-shop.html',
                    controller: 'TokenShopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('token');
                    return $translate.refresh();
                }]
            }
        }).state('token-shop.edit', {
            parent: 'token-shop',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('token');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/system/token-management/dialog/token-dialog.html',
                    controller: 'TokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        param: {id: $stateParams.id}
                    }
                }).result.then(function() {
                    $state.go('token-shop', null, { reload: true });
                }, function() {
                    $state.go('token-shop');
                });
            }]
        }).state('token-edit', {
            parent: 'app',
            url: '/settings/outlet/token',
            data: {
                //authorities: ['ROLE_PARTNER']
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/token-management/token-edit.html',
                    controller: 'TokenEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('token');
                    return $translate.refresh();
                }]
            }
        }).state('token-delete', {
            parent: 'token-edit',
            url: '/delete/{id}',
            data: {
                //authorities: ['ROLE_ADMIN', 'ROLE_PARTNER']
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/system/token-management/dialog/token-delete-dialog.html',
                    controller: 'TokenDeleteDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TokenService', function(TokenService) {
                            return TokenService.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('token-edit', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TokenEditController', TokenEditController);

    TokenEditController.$inject = ['MessageService', 'TokenService', '$uibModal'];

    function TokenEditController (MessageService, TokenService, $uibModal) {

        var vm = this;

        // Token
        vm.token = {clientId: "", appName: "", endDate: ""};
        vm.tokenList = [];
        vm.copyTextShow = false;
        // 日期选择控件显示控制
        vm.isOpen = false;

        // 初始加载数据
        vm.loadData = loadData;
        // 清除选择的token
        vm.del = del;
        // 保存数据
        vm.save = save;
        // 复制到剪贴板
        vm.copy = copy;
        // 编辑日期
        vm.edit = edit;
        // 显示日期控件
        vm.openCalendar = openCalendar;

        loadData();

        function loadData() {
            // 获取信息
            TokenService.loginShop(function(result){
                vm.token.clientId = result.id;
                loadTokenList(result.id);
            });
        }

        function loadTokenList(shopId) {
            TokenService.tokenList({shopId: shopId}, function(result){
                vm.tokenList = result;
            });
        }

        function del(id) {
            if(confirm('削除してもよろしいですか?')) {
                TokenService.del({id: id}, function(){
                    MessageService.success("token.message.deleted");
                    loadData();
                });
            }
        }

        function save() {
            var entity = angular.copy(vm.token);
            entity.endDate = $('#endDate').val() == '' ? null : $('#endDate').val();
            TokenService.save(entity, function(result){
                MessageService.success("token.message.saved");
                loadData();
                vm.token.appName = "";
                vm.token.endDate = "";
            });
        }

        function copy(text) {
            $('#copyText').val(text).show().focus().select();
            document.execCommand("copy");
            $('#copyText').hide();
        }

        function openCalendar(){
            vm.isOpen = true;
        }

        function edit(index) {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/system/token-management/dialog/token-edit-dialog.html',
                controller : 'TokenEditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'md',
                resolve : {
                    param: {token: vm.tokenList[index]},
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('token');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                vm.tokenList[index] = result;
            },function(){
                //MessageService.error("global.error.internalServerError");
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TokenEditDialogController', TokenEditDialogController);

    TokenEditDialogController.$inject = ['param', '$uibModalInstance', 'TokenService', 'MessageService'];

    function TokenEditDialogController (param, $uibModalInstance, TokenService, MessageService) {

        var vm = this;

        vm.token = angular.copy(param.token);
        vm.isOpen = false;

        vm.close = close;
        vm.save = save;
        vm.openCalendar = openCalendar;

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.token.endDate = $('#endEditDate').val() == '' ? null : $('#endEditDate').val();
            TokenService.save(vm.token, function() {
                MessageService.success("token.message.saved");
                $uibModalInstance.close(vm.token);
            });
        }

        function openCalendar(){
            vm.isOpen = true;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TokenDialogController', TokenDialogController);

    TokenDialogController.$inject = ['$uibModalInstance', 'MessageService', 'TokenService', 'param', '$timeout', '$rootScope', '$uibModal'];

    function TokenDialogController ($uibModalInstance, MessageService, TokenService, param, $timeout, $rootScope, $uibModal) {

        var vm = this;

        // Token
        vm.token = {clientId: "", appName: "", endDate: ""};
        vm.tokenList = [];
        vm.copyTextShow = false;
        // 日期选择控件显示控制
        vm.isOpen = false;

        // 初始加载数据
        vm.loadData = loadData;
        // 关闭dialog
        vm.close = close;
        // 清除选择的token
        vm.del = del;
        // 保存数据
        vm.save = save;
        // 复制到剪贴板
        vm.copy = copy;
        vm.edit = edit;
        // 显示日期控件
        vm.openCalendar = openCalendar;

        loadData();

        function loadData() {
            // 获取信息
            if (param.id != null && param.id != '') {
                vm.token.clientId = param.id;
                loadTokenList(param.id);
            } else {
                TokenService.loginShop(function(result){
                    vm.token.clientId = result.id;
                    loadTokenList(result.id);
                })
            }
        }

        function loadTokenList(shopId) {
            TokenService.tokenList({shopId: shopId}, function(result){
                vm.tokenList = result;
            });
        }

        function close () {
            $uibModalInstance.dismiss('cancel');
        }

        function del(index) {

            var modalInstance = $uibModal.open({
                templateUrl : 'app/system/token-management/dialog/token-delete-dialog.html',
                controller : 'TokenDeleteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'md',
                resolve: {
                    entity: ['TokenService', function(TokenService) {
                        return TokenService.get({id : vm.tokenList[index].id});
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                loadData();
            },function(){
                //MessageService.error("global.error.internalServerError");
            })


            // if(confirm('削除してもよろしいですか?')) {
            //     TokenService.del({id: id}, function(){
            //         MessageService.success("token.message.deleted");
            //         loadData();
            //     });
            // }
        }

        function save() {
            var entity = angular.copy(vm.token);
            entity.endDate = $('#endDate').val() == '' ? null : $('#endDate').val();
            TokenService.save(entity, function(result){
                MessageService.success("token.message.saved");
                loadData();
                vm.token.appName = "";
                vm.token.endDate = "";
            });
        }

        function copy(text) {
            $('#copyText').val(text).show().focus().select();
            document.execCommand("copy");
            $('#copyText').hide();
        }

        function openCalendar(){
            vm.isOpen = true;
        }

        function edit(index) {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/system/token-management/dialog/token-edit-dialog.html',
                controller : 'TokenEditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'md',
                resolve : {
                    param: {token: vm.tokenList[index]},
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('token');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                vm.tokenList[index] = result;
            },function(){
                //MessageService.error("global.error.internalServerError");
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('TokenDeleteDialogController', TokenDeleteDialogController);

    TokenDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'TokenService', 'MessageService', '$timeout', '$rootScope'];

    function TokenDeleteDialogController ($uibModalInstance, entity, TokenService, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.token = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.error = false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TokenService.del({id: id}, function() {
                MessageService.success("token.message.deleted");
                $uibModalInstance.close(true);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            }, function () {
                vm.error = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('system', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StorageManagementRuleController', StorageManagementRuleController);

    StorageManagementRuleController.$inject = ['$uibModalInstance', 'entity', '$state', 'StroageService', 'MessageService', '$timeout', '$rootScope'];

    function StorageManagementRuleController ($uibModalInstance, entity, $state, StroageService, MessageService, $timeout, $rootScope) {
        var vm = this;
        vm.goConfirm = goConfirm;
        vm.clear = clear;
        vm.checked = false;
        vm.houjinId = entity.houjinId;
        vm.oldTotalSize = entity.totalSize;
        vm.totalSize = 0;
        vm.oldPlanType = 0;

        function clear(){
            $uibModalInstance.close('cancel');
        }

        function goConfirm(){
            $uibModalInstance.close('cancel');
            if(entity.planType == 0){
                vm.totalSize = 500;
            }
            if(entity.planType == 1){
                vm.totalSize = 5000;
            }
            if(entity.planType == 2){
                vm.totalSize = 25000;
            }
            if(entity.planType == 3){
                vm.totalSize = 125000;
            }
            if(entity.planType == 4){
                vm.totalSize = 625000;
            }
            if(vm.oldTotalSize == 0.5){
                vm.oldPlanType = 0;
            }
            if(vm.oldTotalSize == 5){
                vm.oldPlanType = 1;
            }
            if(vm.oldTotalSize == 25){
                vm.oldPlanType = 2;
            }
            if(vm.oldTotalSize == 125){
                vm.oldPlanType = 3;
            }
            if(vm.oldTotalSize == 625){
                vm.oldPlanType = 4;
            }
            StroageService.updateStorageTotalSize({houjinId: vm.houjinId, totalSize: vm.totalSize},function(){
                StroageService.sendMail({ planType:entity.planType,houjinId:vm.houjinId,oldPlanType:vm.oldPlanType},
                    function () {
                        $state.go('storage-management.confirmStorage');
                    }, function () {
                        MessageService.error("storageManagement.home.occurredError");
                        $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                    });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StorageManagementPlanSameController', StorageManagementPlanSameController);

    StorageManagementPlanSameController.$inject = ['$uibModalInstance', 'StroageService', 'MessageService', '$timeout', '$rootScope'];

    function StorageManagementPlanSameController ($uibModalInstance, StroageService, MessageService, $timeout, $rootScope) {
        var vm = this;
        vm.clear = clear;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StorageManagementPlanController', StorageManagementPlanController);

    StorageManagementPlanController.$inject = ['$uibModalInstance', 'StroageService', 'MessageService', '$timeout', '$rootScope'];

    function StorageManagementPlanController ($uibModalInstance, StroageService, MessageService, $timeout, $rootScope) {
        var vm = this;
        vm.clear = clear;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StorageManagementMailController', StorageManagementMailController);

    StorageManagementMailController.$inject = ['$uibModalInstance', 'entity', 'StroageService', 'MessageService', '$timeout', '$rootScope'];

    function StorageManagementMailController ($uibModalInstance, entity, StroageService, MessageService, $timeout, $rootScope) {
        var vm = this;
        vm.clear = clear;
        vm.confirmExecute = confirmExecute;
        vm.error = false;
        vm.houjinId = entity.houjinId;
        vm.alertMailFlg = entity.alertMailFlg;
        function clear () {
            $uibModalInstance.close(true);
        }

        function confirmExecute() {
            StroageService.mailStop({
                    houjinId:vm.houjinId,
                    alertMailFlg: vm.alertMailFlg
                },
                function(){
                    if(vm.alertMailFlg){
                        MessageService.success("storageManagement.home.mailStop");
                    }else{
                        MessageService.success("storageManagement.home.mail");
                    }

                    $uibModalInstance.close(true);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                }, function () {
                    vm.error = true;
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StorageManagementDeleteController', StorageManagementDeleteController);

    StorageManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'StroageService', 'MessageService', '$timeout', '$rootScope'];

    function StorageManagementDeleteController ($uibModalInstance, entity, StroageService, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.year = entity.id;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.error = false;
        vm.houjinId = entity.houjinId;
        vm.date = "";
        getLastYearYestdy(new Date());
        function getLastYearYestdy(date){
            var strYear = date.getFullYear() - vm.year;
            var strDay = date.getDate();
            var strMonth = date.getMonth()+1;
            if(strMonth<10)
            {
                strMonth="0"+strMonth;
            }
            if(strDay<10)
            {
                strDay="0"+strDay;
            }
            vm.date = strYear+"/"+strMonth+"/"+strDay;
        }
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            StroageService.deletePicture({houjinId:vm.houjinId,duration: vm.year},
                function () {
                    MessageService.success("storageManagement.home.deletedSuccessMessage");
                    $uibModalInstance.close(true);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                }, function () {
                    vm.error = true;
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StorageManagementConfirmController', StorageManagementConfirmController);

    StorageManagementConfirmController.$inject = ['$uibModalInstance', 'StroageService', 'MessageService', '$timeout', '$rootScope'];

    function StorageManagementConfirmController ($uibModalInstance, StroageService, MessageService, $timeout, $rootScope) {
        var vm = this;
        vm.clear = clear;

        function clear(){
            $uibModalInstance.close('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('storage-management', {
                parent: 'app',
                url: '/settings/storage',
                data: {
                    pageTitle: 'storageManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/system/storage-management/storage-management.html',
                        controller: 'StorageManagementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('storage-management');
                        return $translate.refresh();
                    }]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService','Role', 'Kinou',
                    function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Role, Kinou) {
                        Principal.identity().then(function(account) {
                            if (account != null) {
                                var caretreeFlag = false;
                                var adminFlag = false;
                                var userFlag = false;
                                var partnerFlag = false;
                                var developerFlag = false;
                                if (account.authorities.indexOf("ROLE_CARETREE") != -1) {
                                    Kinou.getAuthorityFunction({roleName:"ROLE_CARETREE", functionCd:"GTC_CareTree2_License_Storage_FullAccess"}, function(result){
                                        if(result.flag){
                                            caretreeFlag = true;
                                        }
                                        if (!caretreeFlag) {
                                            $state.go('accessdenied');
                                        }
                                    });
                                }
                                if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
                                    Kinou.getAuthorityFunction({roleName:"ROLE_ADMIN", functionCd:"GTC_CareTree2_License_Storage_FullAccess"}, function(result){
                                        if(result.flag){
                                            adminFlag = true;
                                        }
                                        if (!adminFlag) {
                                            $state.go('accessdenied');
                                        }
                                    });
                                }
                                if (account.authorities.indexOf("ROLE_USER") != -1) {
                                    Kinou.getAuthorityFunction({roleName:"ROLE_USER", functionCd:"GTC_CareTree2_License_Storage_FullAccess"}, function(result){
                                        if(result.flag){
                                            userFlag = true;
                                        }
                                        if (!userFlag) {
                                            $state.go('accessdenied');
                                        }
                                    });
                                }
                                if (account.authorities.indexOf("ROLE_PARTNER") != -1) {
                                    Kinou.getAuthorityFunction({roleName:"ROLE_PARTNER", functionCd:"GTC_CareTree2_License_Storage_FullAccess"}, function(result){
                                        if(result.flag){
                                            partnerFlag = true;
                                        }
                                        if (!partnerFlag) {
                                            $state.go('accessdenied');
                                        }
                                    });
                                }
                                if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
                                    Kinou.getAuthorityFunction({roleName:"ROLE_DEVELOPER", functionCd:"GTC_CareTree2_License_Storage_FullAccess"}, function(result){
                                        if(result.flag){
                                            developerFlag = true;
                                        }
                                        if (!developerFlag) {
                                            $state.go('accessdenied');
                                        }
                                    });
                                }
                            } else {
                                LoginService.open();
                            }
                        });
                }]
            })
            .state('storage-management.delete', {
                parent: 'storage-management',
                url: '/{id}/{houjinId}/delete',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', function($stateParams, $state, $uibModal, Principal, $uibModalStack) {
                    $uibModal.open({
                        templateUrl: 'app/system/storage-management/storage-management-delete-dialog.html',
                        controller: 'StorageManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: {id: $stateParams.id, houjinId: $stateParams.houjinId}
                        }
                    }).result.then(function() {
                        $state.go('storage-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('storage-management.sendMail', {
                parent: 'storage-management',
                url: '{houjinId}/{alertMailFlg}/sendMail',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', function($stateParams, $state, $uibModal, Principal, $uibModalStack) {
                    $uibModal.open({
                        templateUrl: 'app/system/storage-management/storage-management-mail-dialog.html',
                        controller: 'StorageManagementMailController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: {houjinId: $stateParams.houjinId, alertMailFlg: $stateParams.alertMailFlg}
                        }
                    }).result.then(function() {
                        $state.go('storage-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('storage-management.rule', {
                parent: 'storage-management',
                url: '/{houjinId}/{planType}/{totalSize}/rule',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', function($stateParams, $state, $uibModal, Principal, $uibModalStack) {
                    $uibModal.open({
                        templateUrl: 'app/system/storage-management/storage-management-rule-dialog.html',
                        controller: 'StorageManagementRuleController',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            entity: {houjinId: $stateParams.houjinId, planType: $stateParams.planType, totalSize:$stateParams.totalSize}
                        }
                    }).result.then(function() {
                        $state.go('storage-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('storage-management.confirmStorage', {
                parent: 'storage-management',
                url: '/confirm',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', function($stateParams, $state, $uibModal, Principal, $uibModalStack) {
                    $uibModal.open({
                        templateUrl: 'app/system/storage-management/storage-management-confirm-dialog.html',
                        controller: 'StorageManagementConfirmController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {

                        }
                    }).result.then(function() {
                        $state.go('storage-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('storage-management.plan', {
                parent: 'storage-management',
                url: '/plan',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', function($stateParams, $state, $uibModal, Principal, $uibModalStack) {
                    $uibModal.open({
                        templateUrl: 'app/system/storage-management/storage-management-plan-dialog.html',
                        controller: 'StorageManagementPlanController',
                        controllerAs: 'vm',
                        size: 'lg'
                    }).result.then(function() {
                        $state.go('storage-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            }).state('storage-management.same', {
                parent: 'storage-management',
                url: '/same',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', function($stateParams, $state, $uibModal, Principal, $uibModalStack) {
                    $uibModal.open({
                        templateUrl: 'app/system/storage-management/storage-management-plan-same-dialog.html',
                        controller: 'StorageManagementPlanSameController',
                        controllerAs: 'vm',
                        size: 'lg'
                    }).result.then(function() {
                        $state.go('storage-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StorageManagementController', StorageManagementController);

    StorageManagementController.$inject = ['ParseLinks', 'paginationConstants','StroageService','$rootScope', '$state', 'Houjin'];

    function StorageManagementController(ParseLinks, paginationConstants,StroageService, $rootScope, $state, Houjin) {
        var vm = this;
        vm.houjinId = '';
        vm.jigyoushoStorageList=[];
        vm.totalSize;//总容量
        vm.used = 0;//使用容量
        vm.surplus = 0;//剩余容量
        vm.percent;//使用百分比
        vm.alertMailFlg = false;
        vm.doDeleteOneYear = doDeleteOneYear;
        vm.storageCheck = storageCheck;
        vm.goRule = goRule;
        vm.getHoujin = getHoujin;
        vm.getStroage = getStroage;
        vm.serviceTerms = serviceTerms;
        getHoujin();
        function getHoujin() {
        	Houjin.getList({},function(result){
        		vm.houjinList = result;
        		if (vm.houjinList.length > 0) {
        			vm.houjinId = vm.houjinList[0].id;
        			getStroage();
        		}
        	});
        }
        function getStroage() {
        	StroageService.houjinList({id:vm.houjinId},function(result){
                vm.jigyoushoStorageList = result.jigyoushoStorageList;
                vm.totalSize = result.houjinStorage.totalSize;
                vm.used = result.houjinStorage.used;
                vm.surplus = result.houjinStorage.leaved;
                vm.percent = result.houjinStorage.percent;
                vm.alertMailFlg = result.houjinStorage.alertMailFlg;
                var storageChart = echarts.init(document.getElementById('storage'));
                var storageOption = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    series: [{
                        color :['#DDDDDD','#337ab7'],
                        data: [
                            {value:vm.surplus,name:'使用可能'},
                            {value:vm.used,name:'使用済'}
                        ],
                        type: 'pie',
                        center:['70%', '50%']
                    }]
                }
                storageChart.setOption(storageOption);
                window.onresize = function (){
                    storageChart.resize();
                }
            });
        }

        function doDeleteOneYear(id){
            $state.go('storage-management.delete', {houjinId: vm.houjinId, id: id});
        }
        function storageCheck(){
            $state.go('storage-management.sendMail', {houjinId: vm.houjinId, alertMailFlg: vm.alertMailFlg});
        }
        function goRule(planType){
        	if ((vm.totalSize == 0.5 && planType == 0) 
        			|| (vm.totalSize == 5 && planType == 1) 
        			|| (vm.totalSize == 25 && planType == 2) 
        			|| (vm.totalSize == 125 && planType == 3) 
        			|| (vm.totalSize == 625 && planType == 4)) {
        		$state.go('storage-management.same');
        	} else {
        		StroageService.storageUpdateTime({id:vm.houjinId},
                    function (result){
                        if(result.flag){
                            $state.go('storage-management.plan');
                        }else{
                            $state.go('storage-management.rule',{houjinId: vm.houjinId, planType: planType, totalSize: vm.totalSize});
                        }
                    }
                )
        	}
        }
        function serviceTerms(){
            window.open('https://caretree.jp/mobile/wp-content/uploads/2019/10/caretree_licence_20191024.pdf');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('script', {
            parent: 'app',
            url: '/robot/contents',
            data: {
                pageTitle: 'global.menu.system.script'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/script.html',
                    controller: 'ScriptController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'lastModifiedDate,desc',
                    squash: true
                },
                scriptSelectType: {
                    value: 2,
                    squash: true
                },
                scriptSelectCategory: {
                    value: 1,
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        scriptSelectType: $stateParams.selectedType,
                        scriptSelectCategory: $stateParams.selectedCategory
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('script');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                        var gtc_caretree2_robot_allfunction_fullaccess = false;
                        var isAdmin = false;
                        var isDeveloper = false;
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Robot_AllFunction_FullAccess"}, function(result){
                        	if (!result.flag) {
                        		$state.go('accessdenied');
                        	} else {
                        		plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_robot_allfunction_fullaccess);
                        	}
                        });
                	} else {
                		LoginService.open();
                	}
                });
            }]
        }).state('conversation', {
            parent: 'script',
            url: '/{id}/{type}/conversation',
            data: {
                pageTitle: 'global.menu.system.conversation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/conversation/conversation.html',
                    controller: 'ConversationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('script');
                    return $translate.refresh();
                }]
            }
        }).state('showConversation', {
            parent: 'script',
            url: '/{id}/{type}/showConversation',
            data: {
                pageTitle: 'global.menu.system.conversation'
            },
            views: {
                'content@': {
                        templateUrl: 'app/system/script/conversation/showConversation.html',
                    controller: 'ShowConversationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('script');
                    return $translate.refresh();
                }]
            }
        }).state('media', {
            parent: 'script',
            url: '/{id}/{type}/media',
            data: {
                pageTitle: 'global.menu.system.music'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/media/media.html',
                    controller: 'MediaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('script');
                    return $translate.refresh();
                }]
            }
        }).state('showMedia', {
            parent: 'script',
            url: '/{id}/{type}/showMedia',
            data: {
                pageTitle: 'global.menu.system.music'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/media/showMedia.html',
                    controller: 'ShowMediaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('script');
                    return $translate.refresh();
                }]
            }
        });
    }
    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_robot_allfunction_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                    gtc_caretree2_robot_allfunction_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_robot_allfunction_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Script', Script);

    Script.$inject = ['$resource'];

    function Script ($resource) {
        var service = $resource('robot/api/script', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'robot/api/scripts/type/:type/category/:category'
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                },
                url: 'robot/api/script/:id'
            },
            'copy': {
                method: 'POST',
                url: 'robot/api/script/copy'
            },
            'del': {
                method: 'POST',
                url: 'robot/api/script/del'
            },
            "save": {
                method: "POST"
            },
            "make": {
                method: 'POST',
                isArray: false,
                url: 'robot/api/script/make'
            },
            "sort": {
                method: 'PUT',
                url: 'robot/api/updateSort'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ScriptController', ScriptController);

    ScriptController.$inject = ['$scope','Principal','ParseLinks', 'pagingParams', 'paginationConstants','Category','Enum','Script','Collection', 'Pepper', 'SelectedPepper', '$state', 'MessageService', '$stateParams', 'User', '$translate','$rootScope'];

    function ScriptController ($scope, Principal, ParseLinks, pagingParams, paginationConstants, Category, Enum, Script, Collection, Pepper, SelectedPepper, $state, MessageService, $stateParams, User, $translate,$rootScope) {
        var vm = this;
        vm.scriptTypes = [];
        vm.categories = [];
        vm.scriptList = [];
        vm.collections = [];
        vm.links = null;
        vm.totalItems = null;
        vm.page = $stateParams.page;

        vm.pepper = SelectedPepper.current();
        vm.selectedType = $stateParams.scriptSelectType;
        vm.selectedCategory = $stateParams.scriptSelectCategory;
        vm.selectedScriptId = [];
        vm.copyData = {};
        vm.isSaving = false;
        vm.userList = [];
        vm.pepperList = [];
        vm.pepper = {};

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;

        vm.loadAll = loadAll;
        vm.loadScriptList = loadScriptList;
        vm.loadAllCategory = loadAllCategory;
        vm.loadScriptTypes  = loadFavoriteTypes;
        vm.loadPage = loadPage;
        vm.loadAllCollections = loadAllCollections;
        vm.loadUsers = loadUsers;
        vm.addFavorite = addFavorite;
        vm.delFavorite = delFavorite;
        vm.changeType = changeType;
        vm.changeCategory = changeCategory;
        vm.selectScript = selectScript;
        vm.edit = edit;
        vm.goEdit = goEdit;
        vm.goShow = goShow;
        vm.copy = copy;
        vm.del = del;
        vm.changeSort = changeSort;
        vm.number;
        vm.CountList = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];
        vm.transition = transition;
        vm.changePepper = changePepper;
        vm.loadPepperList = loadPepperList;

        function checkPepper() {
            var result = false;
            for (var i = 0; i < vm.pepperList; i ++) {
                if (vm.pepperList[i].id === vm.pepper.id) {
                    result = true;
                }
            }
            return result;
        }

        function loadPepperList() {
            //console.log("get pepper list of current login user");
            vm.pepperList = SelectedPepper.pepperList();
            if(vm.selectPepper == undefined && vm.pepperList.length > 0){
               vm.selectPepper = vm.pepperList[0].id;
            }
            vm.pepper = SelectedPepper.current();
        }
        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        vm.loadAllCategory();
        vm.loadScriptTypes();
        vm.loadAll();

        $scope.$on('pepperChanged', function() {
            vm.page = 1;
            vm.pepper = SelectedPepper.current();
            loadAll();
        });

        function loadAll() {
            vm.pepperList = SelectedPepper.pepperList();
            if($rootScope.page != undefined){
                vm.page = $rootScope.page;
                $rootScope.page = undefined;
            }
            if($rootScope.selectedCategory != undefined){
                vm.selectedCategory = $rootScope.selectedCategory;
            }
            if($rootScope.selectedType != undefined){
                vm.selectedType = $rootScope.selectedType;
            }
            loadUsers();
            loadScriptList();
            loadAllCollections();
            Pepper.query(function(result){
                SelectedPepper.setPepperList(result);
                loadPepperList();
                if (result.length === 0) {
                    SelectedPepper.setCurrent(null);
                } else {
                    if (!checkPepper()) {
                        SelectedPepper.setCurrent(result[0]);
                    }
                }
            });

            // clear selected script
            vm.selectedScriptId = [];
        }

        function loadScriptList() {
            Script.query({page: vm.page - 1, size: paginationConstants.itemsPerPage, type: vm.selectedType, category: vm.selectedCategory, sort: sort()},function(result,headers){
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.scriptList = result;
                for (var i=0;i<vm.scriptList.length;i++){
                    vm.scriptList[i].sort = String(vm.scriptList[i].sort);
                    if(vm.scriptList[i].sort == "null"){
                        vm.scriptList[i].sort = "";
                    }
                }
            });
        }

        function loadAllCategory() {
            Category.allList(function(result){
                vm.categories = result;
            });
        }

        function loadFavoriteTypes() {
            Enum.get({name: "FavoriteType"},function(result){
                vm.scriptTypes = result;
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function loadAllCollections() {
            if (vm.pepper == null || vm.pepperList.length == 0) {
                return false;
            }
            if(vm.pepper.id == undefined){
                vm.pepper.id = vm.pepperList[0].id
            }
            Collection.query({pepperId: vm.pepper.id}, function(result){
                vm.collections = result;
            });
        }

        function addFavorite(collection) {
            vm.isSaving = true;
            Collection.save({pepperId: vm.pepper.id, scriptId: collection.scriptId},onSaveSuccess,onSaveError);
        }

        function delFavorite(collection) {
            vm.isSaving = true;
            Collection.delete({pepperId: vm.pepper.id, scriptId: collection.scriptId},onSaveSuccess,onSaveError);
        }


        function onSaveSuccess () {
            vm.isSaving = false;
            MessageService.success("script.message.collectionChange");
            vm.loadAllCollections();
        }

        function onSaveError () {
            MessageService.error("global.messages.error.save");
            vm.isSaving = false;
        }

        function changeType(selectedType) {
            vm.selectedType = selectedType;
            $rootScope.selectedType = selectedType;
            vm.page = 1;
            loadAll();
        }

        function changeCategory(selectedCategory) {
            vm.selectedCategory = selectedCategory;
            vm.page = 1;
            $rootScope.selectedCategory = selectedCategory;
            loadAll();
        }

        function selectScript(id) {
            var exitIndex = null;
            for (var i = 0; i < vm.selectedScriptId.length; i ++) {
                if (vm.selectedScriptId[i] == id) {
                    exitIndex = i;
                }
            }
            if (exitIndex == null) {
                vm.selectedScriptId.push(id);
            } else {
                vm.selectedScriptId.splice(exitIndex, 1);
            }
        }

        function edit(id, type) {
            $state.go('media', {id: id, type: type});
        }

        function show(id, type) {
            $state.go('showMedia', {id: id, type: type});
        }

        function goShow(id,type){
            $rootScope.page = vm.page;
            if (type == 2 || type == 3) {
                show(id, type);
            } else {
                $state.go('showConversation', {id: id, type: type});
            }
        }
        function goEdit() {
            $rootScope.page = vm.page;
            var id = vm.selectedScriptId[0];
            var type = 1;
            for (var i = 0; i < vm.scriptList.length; i ++) {
                var script = vm.scriptList[i];
                if (script.id == id) {
                    type = script.scriptType;
                }
            }
            if (type == 2 || type == 3) {
                edit(id, type);
            } else {
                $state.go('conversation', {id: id, type: type});
            }
        }

        function copy() {
            vm.copyData.ids = vm.selectedScriptId;
            Script.copy(vm.copyData, onCopySuccess, onCopyError);
        }

        function onCopySuccess() {
            vm.copySuccess = true;
            MessageService.success("script.message.copySuccess");
            loadAll();
        }

        function onCopyError() {
            vm.copySuccess = false;
            MessageService.error("script.message.copyError");
            loadAll();
        }

        function del() {
            if (confirm($translate.instant("script.message.delConfirm"))) {
                vm.copyData.ids = vm.selectedScriptId;
                Script.del(vm.copyData, onDelSuccess, onDelError);
            }
        }

        function onDelSuccess() {
            MessageService.success("global.messages.info.del");
            loadAll();
        }

        function onDelError() {
            MessageService.error("global.messages.error.del");
            loadAll();
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate != 'id') {
                result.push('id');
            }
            return result;
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: 1,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                scriptSelectType: vm.selectedType,
                scriptSelectCategory: vm.selectedCategory,
                search: vm.loadScriptList
            });
        }

        function loadUsers() {
            User.all(function(result){
                vm.userList = result;
            });
        }

        function changeSort(sort,id){
            var data = {};
            data.id = id;
            data.sort = sort;
            Script.sort(data, onChangeSuccess, onChangeError);
        }

        function onChangeSuccess() {
            MessageService.success("script.sort.changesuccess");
        }
        function onChangeError() {
            MessageService.error("script.sort.changeerror");
        }

        function changePepper(pepperList) {
            var pepper =  pepperList.find(function (obj){
                return obj.id = vm.selectPepper;
            });
            if (pepper.id > 0) {
                SelectedPepper.setCurrent(pepper);
                vm.pepper = pepper;
                $rootScope.$broadcast('pepperChanged');
                MessageService.success("global.messages.info.pepperchanged");
            } else {
                MessageService.error("global.error.pepperchangerror");
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('schedule', {
            parent: 'script',
            url: '/schedule',
            data: {
                pageTitle: 'global.menu.system.schedule'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/schedule/schedule.html',
                    controller: 'ScheduleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('schedule');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Schedule', Schedule);

    Schedule.$inject = ['$resource'];

    function Schedule ($resource) {
        var service = $resource('robot/api/schedule', {}, {
            "query": {
                method: 'GET',
                isArray: true,
                url: 'robot/api/schedules/pepperId/:pepperId'
            },
            "save": {
                method: "POST"
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ScheduleController', ScheduleController);

    ScheduleController.$inject = ['Schedule', '$scope', 'Collection', 'Enum', 'SelectedPepper', 'MessageService', '$state'];

    function ScheduleController (Schedule, $scope, Collection, Enum, SelectedPepper, MessageService, $state) {
        var vm = this;

        vm.datas = {pepperId: null, scheduleList: []};
        vm.repeats = [{code: 1, value: ""}, {code: 2, value: "毎月"}, {code: 3, value: "毎週"}];
        vm.itemTypes = [];
        vm.collections = null;
        vm.pepper = SelectedPepper.current();
        vm.index = null;
        vm.defaultScriptId = null;
        vm.dayTitle = null;

        vm.loadAll = loadAll;
        vm.loadItemTypes = loadItemTypes;
        vm.loadContents = loadContents;
        vm.loadSchedule = loadSchedule;
        vm.add = add;
        vm.del = del;
        vm.save = save;
        vm.selectSchedule = selectSchedule;

        vm.loadAll();
        vm.loadSchedule();

        $scope.$on('pepperChanged', function() {
            vm.pepper = SelectedPepper.current();
            loadSchedule();
            loadContents();
        });

        function loadAll() {
            vm.loadItemTypes();
            vm.loadContents();
            vm.loadSchedule();
        }

        function loadItemTypes() {
            Enum.get({name: "ScheduleItemType"}, function(result) {
                vm.itemTypes = result;
            });
        }

        function loadContents() {
            Collection.query({pepperId: vm.pepper.id}, function(result) {
                vm.collections = result;
                if (vm.collections.length > 0) {
                    vm.defaultScriptId = vm.collections[0].scriptId;
                }
            });
        }

        function loadSchedule() {
            Schedule.query({pepperId: vm.pepper.id}, function(result) {
                for (var i = 0; i < result.length; i ++) {
                    result[i].exeTime = result[i].exeTime.split(":")[0] + ":" + result[i].exeTime.split(":")[1];
                }
                vm.datas.scheduleList = result;
            });
        }

        function add() {
            var schedule = {id: null, pepperId: vm.pepperId, exeTime: null, itemType: 1, scriptId: vm.defaultScriptId, sort: null, repeatType: 1, comment: null,
                pepperScheduleMonthly: {id: null, day1: null, day2: null, day3: null, day4: null, day5: null, day6: null, day7: null,
                    day8: null, day9: null, day10: null, day11: null, day12: null, day13: null, day14: null,
                    day15: null, day16: null, day17: null, day18: null, day19: null, day20: null, day21: null,
                    day22: null, day23: null, day24: null, day25: null, day26: null, day27: null, day28: null,
                    day29: null, day30: null, day31: null},
                pepperScheduleWeekly: {id: null, day1: null, day2: null, day3: null, day4: null, day5: null, day6: null, day7: null}
            }
            vm.datas.scheduleList.push(schedule);
        }

        function del(index) {
            vm.datas.scheduleList.splice(index, 1);
            vm.index = null;
        }

        function save() {
            vm.isSaving = true;
            vm.datas.pepperId = vm.pepper.id;
            Schedule.save(vm.datas, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            MessageService.success("schedule.home.success");
            $state.go('script');
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("schedule.home.error");
        }

        function selectSchedule(index) {
            vm.index = index;
            for (var i = 0; i < vm.itemTypes.length; i ++) {
                if (vm.datas.scheduleList[index].itemType == vm.itemTypes[i].code) {
                    vm.dayTitle = vm.itemTypes[i].name;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('PhotoShowDialogController', PhotoShowDialogController);

    PhotoShowDialogController.$inject = ['entity', '$uibModalInstance'];

    function PhotoShowDialogController(entity, $uibModalInstance) {

        var vm = this;

        vm.library = entity;

        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('photo', {
            parent: 'script',
            url: '/photo',
            data: {
                pageTitle: 'global.menu.system.photo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/photo/photo.html',
                    controller: 'PhotoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('photo');
                    return $translate.refresh();
                }]
            }
        }).state('photo.show', {
            parent: 'photo',
            url: '/photo/{id}/show',
            data: {
                pageTitle: 'global.menu.system.photo'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
        		Principal.identity().then(function(account) {
        			if (account != null) {
        				var gtc_caretree2_robot_allfunction_fullaccess = false;
                      	if (account.functions != null) {
                          	for (var i in account.functions) {
                          		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                          			gtc_caretree2_robot_allfunction_fullaccess = true;
                          		}
                          	}
                      	}
                      	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                        	  $uibModal.open({
                                  templateUrl: 'app/system/script/photo/photo-show-dialog.html',
                                  controller: 'PhotoShowDialogController',
                                  controllerAs: 'vm',
                                  backdrop: 'static',
                                  size: 'lg',
                                  resolve: {
                                      entity: ['Uploader', function(Uploader) {
                                          return Uploader.get({id : $stateParams.id});
                                      }]
                                  }
                              }).result.then(function() {
                                  $state.go('photo', null, { reload: true });
                              }, function() {
                                  $state.go('^');
                              });
                          }
        			} else {
        				LoginService.open();
        			}
                  	
        		});
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('PhotoController', PhotoController);

    PhotoController.$inject = ['paginationConstants', 'Upload', 'MessageService', 'Uploader', 'ParseLinks', 'Group'];

    function PhotoController(paginationConstants, Upload, MessageService, Uploader, ParseLinks, Group) {

        var vm = this;

        vm.links = null;
        vm.totalItems = null;
        vm.page = 1;

        vm.picFile = null;
        vm.photoList = [];

        vm.groupId = null;

        vm.uploadPic = uploadPic;
        vm.loadPhotos = loadPhotos;
        vm.changePublishType = changePublishType;
        vm.del = del;
        vm.loadAllGroups = loadAllGroups;

        vm.loadPhotos();
        vm.loadAllGroups();

        function uploadPic() {
            Upload.upload({
                url: 'library/api/upload',
                data: {fileName: vm.picFile.name, file: vm.picFile, photoFlg: 1, adminFlg: false, groupId: vm.groupId}
            }).success(function () {
                MessageService.success("photo.message.upload.success");
                vm.picFile = null;
                vm.loadPhotos();
            }).error(function () {
                MessageService.error("photo.message.upload.error");
            });
        }

        function loadPhotos() {
            Uploader.query({page: vm.page - 1, size: paginationConstants.itemsPerPage}, function(result, headers){
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.photoList = result;
            });
        }

        function changePublishType(id, type) {
            var data = {};
            data.id = id;
            data.type = type;
            Uploader.changePublishType(data, onChangeSuccess, onChangeError);
        }

        function onChangeSuccess() {
            MessageService.success("photo.message.change.success");
        }

        function onChangeError() {
            MessageService.error("photo.message.change.error");
        }

        function del(id) {
            Uploader.del({id: id}, onDeleteSuccess, onDeleteError);
        }

        function onDeleteSuccess() {
            MessageService.success("photo.message.del.success");
            vm.loadPhotos();
        }

        function onDeleteError() {
            MessageService.error("photo.message.del.error");
        }

        function loadAllGroups() {
            Group.queryUserGroups(function(result){
                vm.groups = result;
                if (result.length > 0) {
                    vm.groupId = result[0].id;
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShowMediaController', ShowMediaController);

    ShowMediaController.$inject = ['$stateParams', '$scope', 'Category', 'Script', '$state', 'Enum', 'Library', 'Variable', '$uibModal', 'MessageService', '$sce', '$translate', 'Principal'];

    function ShowMediaController ($stateParams, $scope, Category, Script, $state, Enum, Library, Variable, $uibModal, MessageService, $sce, $translate, Principal) {

        var vm = this;

        $scope.sce = $sce.trustAsResourceUrl;

        vm.categories = [];
        vm.script = {id: null, pepperId: null, scriptType: null, scriptName: null, title: null,
            libraryId: null, libraryUrl: null, library: {},
            rhythm: null, rhythmValue: null, rhythmObj: {},
            publishType: true, plainScript: null, comment: null,
            scriptItems: [],
            categories: []};
        vm.detailTypes = [];
        vm.scriptDetailType = [];
        vm.libraries = [];
        vm.variables = [];
        vm.type = $stateParams.type;
        vm.url = null;
        vm.movieLit = [];
        vm.libraryUrl = null;
        vm.loadCount = 0;

        var audio = document.getElementById('audio');
        var video = document.getElementById('video');

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        vm.loadAll = loadAll;
        vm.loadCategories = loadCategories;
        vm.loadScript = loadScript;
        vm.loadScriptDetailType = loadScriptDetailType;
        vm.loadLibraries = loadLibraries;
        vm.loadVariables = loadVariables;
        vm.loadUrl = loadUrl;
        vm.addLabel = addLabel;
        vm.save = save;
        vm.delLabel = delLabel;
        vm.addDetail = addDetail;
        vm.delDetail = delDetail;
        vm.back = back;
        vm.choose = choose;

        vm.setMedia = setMedia;
        vm.record = record;
        vm.transformSecondToMinute = transformSecondToMinute;
        vm.transformMinuteToSecond = transformMinuteToSecond;

        vm.checkLibrary = checkLibrary;

        vm.preViewShow = preViewShow;

        vm.loadAll();

        function loadAll() {
            vm.loadCategories();
            vm.loadScriptDetailType();
            vm.loadLibraries();
            vm.loadVariables();
            vm.loadUrl();
            //vm.loadScript();
        }

        function loadCategories() {
            Category.list(function(result) {
                for (var i = 0; i < result.length; i ++) {
                    if (vm.isAdmin || (!vm.isAdmin && result[i].categoryType < 9)) {
                        vm.categories.push(result[i]);
                    }
                }
                vm.loadScript();
            });
        }

        function loadScript() {
            vm.loadCount ++;

            if (vm.loadCount != 5) {
                return false;
            }
            if ($stateParams.id != 0) {
                Script.get({id: $stateParams.id}, function(result) {
                    vm.script = result;

                    var categories = vm.script.categories;
                    vm.script.categories = [];
                    vm.script.rhythmObj = {};

                    for (var j = 0; j < vm.categories.length; j ++) {
                        for (var i = 0; i < categories.length; i ++) {
                            if (categories[i].id == vm.categories[j].id) {
                                vm.script.categories.push(vm.categories[j]);
                            }
                        }
                    }

                    for (var i = 0; i < vm.script.scriptItems.length; i ++) {
                        var scriptItemDetails = vm.script.scriptItems[i].scriptItemDetails;
                        for (var j = 0; j < scriptItemDetails.length; j ++) {
                            scriptItemDetails[j].detailType = scriptItemDetails[j].detailType.toString();
                            preViewShow(i, j, scriptItemDetails[j].detailType);
                        }
                    }

                    for (var i = 0; i < vm.variables.length; i ++) {
                        if (vm.variables[i].id == vm.script.rhythm) {
                            vm.script.rhythmObj = vm.variables[i];
                        }
                    }

                    for (var i = 0; i < vm.libraries.length; i ++) {
                        if (vm.script.libraryId == vm.libraries[i].id) {
                            vm.script.library = vm.libraries[i];
                        }
                    }

                    vm.setMedia();

                    vm.script.publishType = vm.script.publishType == 1 ? true : false;

                    vm.labelCount = vm.script.scriptItems.length;

                });
                vm.media = 1;
            } else {
                vm.labelCount = 0;
            }
        }

        function loadScriptDetailType() {
            Enum.get({name: 'ScriptMediaDetailType'}, function(result) {
                vm.scriptDetailType = result;
                vm.loadScript();
            });
        }

        function loadLibraries() {
            Library.list({}, function(result) {
                vm.libraries = result;
                for (var i = 0; i < vm.libraries.length; i ++) {
                    if (vm.libraries[i].fileType == '4' || vm.libraries[i].fileType == '5')
                    vm.movieLit.push(vm.libraries[i]);
                }
                vm.loadScript();
            });
        }

        function loadVariables() {
            Variable.list({}, function(result) {
                vm.variables = result;
                vm.loadScript();
            });
        }

        // ラベルを追加
        function addLabel(labelName) {
            vm.script.scriptItems.push({label: labelName, labelType: 3, scriptItemDetails: []});
            vm.script.scriptItems[vm.script.scriptItems.length - 1].scriptItemDetails.push({detailType: '5', contentId: ""});
        }

        function save(saveDirect) {

            preData(saveDirect);

            if (saveDirect) {
                Script.make(vm.script, function(result) {
                    vm.script.plainScript = result.plainScript;
                });
            } else {
                Script.save(vm.script, onSaveSuccess, onSaveError);
            }
        }

        function preData(saveDirect) {
            vm.success = null;
            vm.isSaving = true;
            vm.script.scriptType = vm.type;
            vm.script.saveDirect = saveDirect;

            if (vm.script.library.id != undefined) {
                vm.script.libraryId = vm.script.library.id;
                vm.script.libraryUrl = vm.script.library.url;
                if (vm.script.library.uploadFlg) {
                    vm.script.libraryUrl = vm.url + "/library/api/library/file/" + vm.script.library.id;
                } else {
                    vm.script.libraryUrl = vm.script.library.url;
                }
            }
            if (vm.script.rhythmObj != null && vm.script.rhythmObj.id != undefined) {
                vm.script.rhythm = vm.script.rhythmObj.id;
                vm.script.rhythmValue = vm.script.rhythmObj.itemCode;
            } else {
                vm.script.rhythm = "";
                vm.script.rhythmValue = "";
            }

            // contentValue
            for (var i = 0; i < vm.script.scriptItems.length; i ++) {
                var item = vm.script.scriptItems[i];

                if (item.label && item.label != '') {
                    item.labelShow = transformMinuteToSecond(item.label);
                } else {
                    item.label = 0;
                    item.labelShow = 0;
                }

                var delDetailArr = [];
                for (var j = 0; j < item.scriptItemDetails.length; j ++) {
                    var detail = item.scriptItemDetails[j];
                    if (detail.detailType == '10') {
                        for (var k = 0; k < vm.libraries.length; k ++) {
                            var o = vm.libraries[k];
                            if (detail.contentId != undefined && detail.contentId == o.id) {
                                var li = checkLibrary(detail.contentId);
                                if (li.uploadFlg) {
                                    if (detail.detailType == '10') {
                                        detail.contentValue = vm.url + "/library/api/library/image/" + o.id;
                                    } else {
                                        detail.contentValue = vm.url + "/library/api/library/file/" + o.id;
                                    }
                                } else {
                                    detail.contentValue = o.url
                                }
                            }
                        }
                    } else if (detail.detailType == '15') {
                        for (var k = 0; k < vm.variables.length; k ++) {
                            var o = vm.variables[k];
                            if (detail.contentId != undefined && detail.contentId == o.id) {
                                detail.contentValue = o.itemCode;
                            }
                        }
                    } else if (detail.detailType == '') {
                        delDetailArr.push(j);
                    }
                }
                for (var l = delDetailArr.length;l > 0; l --) {
                    delDetail(i, l);
                }
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            vm.success = true;
            //loadScript();
            $state.go('script');
            MessageService.success("global.messages.info.save");
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("global.messages.error.save");
            vm.success = null;
        }

        // ラベルを削除
        function delLabel(index) {
            vm.script.scriptItems.splice(index, 1);
        }

        function addDetail(parentIndex, type) {
            vm.script.scriptItems[parentIndex].scriptItemDetails.push({detailType: type});
        }

        function delDetail(parentIndex, index) {
            if (vm.script.scriptItems[parentIndex].scriptItemDetails[index].detailType == '10') {
                vm.script.scriptItems[parentIndex].background = "";
            }
            vm.script.scriptItems[parentIndex].scriptItemDetails.splice(index, 1);
        }

        function back() {
            $state.go('script');
        }

        // media
        function setMedia() {
            if (vm.script.library != null) {
                if (vm.script.library.uploadFlg == 0) {
                    vm.libraryUrl = vm.script.library.url;
                } else {
                    vm.libraryUrl = "/library/api/library/file/" + vm.script.library.id;
                }
                vm.media = 1;
            } else {
                vm.media = null;
                vm.libraryUrl = null;
            }
        }

        function record() {
            var currentTime = 0;
            if (vm.type == 2) {
                var audio = document.getElementById('audio');
                currentTime = parseInt(audio.currentTime, 10);
            } else if(vm.type == 3 && vm.script.library.fileType == 4) {
                var video = document.getElementById('video');
                currentTime = parseInt(video.currentTime, 10);
            } else if(vm.type == 3 && vm.script.library.fileType == 5) {
                return false;
            }
            var labelName = transformSecondToMinute(currentTime);
            addLabel(labelName);
        }

        function transformSecondToMinute(second) {
            var minuteTime = parseInt(second / 60, 10);
            var secondTime = parseInt(second % 60, 10) > 9 ? parseInt(second % 60, 10) : "0" + parseInt(second % 60, 10);
            var result = minuteTime + ":" + secondTime;
            return result;
        }

        function transformMinuteToSecond(minute) {
            var minuteArr = minute.split(":");
            return parseInt(minuteArr[0], 10) * 60 + parseInt(minuteArr[1], 10);
        }

        function preViewShow(parent, index, type) {
            if (type == '10') {
                if (vm.script.scriptItems[parent].scriptItemDetails[index].contentId != null
                    && vm.script.scriptItems[parent].scriptItemDetails[index].contentId != "") {
                    var li = checkLibrary(vm.script.scriptItems[parent].scriptItemDetails[index].contentId);
                    if (li != null) {
                        if (li.uploadFlg) {
                            vm.script.scriptItems[parent].background = "/library/api/library/image/"+ vm.script.scriptItems[parent].scriptItemDetails[index].contentId;
                        } else {
                            vm.script.scriptItems[parent].background = li.url;
                        }
                    } else {
                        vm.script.scriptItems[parent].background = null;
                    }
                } else {
                    vm.script.scriptItems[parent].background = vm.script.scriptItems[parent].scriptItemDetails[index].text;
                }
            } else if (type == '15') {
                vm.script.scriptItems[parent].scriptItemDetails[index].contentValue = getVariableDetail(vm.script.scriptItems[parent].scriptItemDetails[index].contentId, 15)
            }
        }

        function checkLibrary(id) {
            var result = null;
            for (var i = 0; i < vm.libraries.length; i ++) {
                if (vm.libraries[i].id == id) {
                    result = angular.copy(vm.libraries[i]);
                }
            }
            return result;
        }

        function getVariableDetail(id, type) {
            var result = "";
            if (type == '15') {
                for (var k = 0; k < vm.variables.length; k ++) {
                    var o = vm.variables[k];
                    if (id == o.id) {
                        result = o.itemCode;
                    }
                }
            }
            return result;
        }

        function choose(item, detail, fileType, type) {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/system/script/library/choose/choose.html',
                controller : 'ChooseController',
                controllerAs: 'vm',
                size : 'lg',
                resolve : {
                    params : {fileType: fileType},
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('library');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.script.scriptItems[item].scriptItemDetails[detail].contentId = "";
                    vm.script.scriptItems[item].scriptItemDetails[detail].text = "";
                    if (result.type == 1) {
                        vm.script.scriptItems[item].scriptItemDetails[detail].contentId = result.value;
                    } else {
                        vm.script.scriptItems[item].scriptItemDetails[detail].text = result.value;
                    }
                    preViewShow(item, detail, type);
                }
            },function(){
                MessageService.error("global.error.internalServerError");
            })
        }

        function loadUrl() {
            Library.url(function(result){
                vm.url = result.url;
                vm.loadScript();
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('MediaController', MediaController);

    MediaController.$inject = ['$stateParams', '$scope', 'Category', 'Script', '$state', 'Enum', 'Library', 'Variable', '$uibModal', 'MessageService', '$sce', '$translate', 'Principal'];

    function MediaController ($stateParams, $scope, Category, Script, $state, Enum, Library, Variable, $uibModal, MessageService, $sce, $translate, Principal) {

        var vm = this;

        $scope.sce = $sce.trustAsResourceUrl;

        vm.categories = [];
        vm.script = {id: null, pepperId: null, scriptType: null, scriptName: null, title: null,
            libraryId: null, libraryUrl: null, library: {},
            rhythm: null, rhythmValue: null, rhythmObj: {},
            publishType: true, plainScript: null, comment: null,
            scriptItems: [],
            categories: []};
        vm.detailTypes = [];
        vm.scriptDetailType = [];
        vm.libraries = [];
        vm.variables = [];
        vm.type = $stateParams.type;
        vm.url = null;
        vm.movieLit = [];
        vm.libraryUrl = null;
        vm.loadCount = 0;

        var audio = document.getElementById('audio');
        var video = document.getElementById('video');

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        vm.loadAll = loadAll;
        vm.loadCategories = loadCategories;
        vm.loadScript = loadScript;
        vm.loadScriptDetailType = loadScriptDetailType;
        vm.loadLibraries = loadLibraries;
        vm.loadVariables = loadVariables;
        vm.loadUrl = loadUrl;
        vm.addLabel = addLabel;
        vm.save = save;
        vm.delLabel = delLabel;
        vm.addDetail = addDetail;
        vm.delDetail = delDetail;
        vm.back = back;
        vm.choose = choose;

        vm.setMedia = setMedia;
        vm.record = record;
        vm.transformSecondToMinute = transformSecondToMinute;
        vm.transformMinuteToSecond = transformMinuteToSecond;

        vm.checkLibrary = checkLibrary;

        vm.preViewShow = preViewShow;

        vm.loadAll();

        function loadAll() {
            vm.loadCategories();
            vm.loadScriptDetailType();
            vm.loadLibraries();
            vm.loadVariables();
            vm.loadUrl();
            //vm.loadScript();
        }

        function loadCategories() {
            Category.list(function(result) {
                for (var i = 0; i < result.length; i ++) {
                    if (vm.isAdmin || (!vm.isAdmin && result[i].categoryType < 9)) {
                        vm.categories.push(result[i]);
                    }
                }
                vm.loadScript();
            });
        }

        function loadScript() {
            vm.loadCount ++;

            if (vm.loadCount != 5) {
                return false;
            }
            if ($stateParams.id != 0) {
                Script.get({id: $stateParams.id}, function(result) {
                    vm.script = result;

                    var categories = vm.script.categories;
                    vm.script.categories = [];
                    vm.script.rhythmObj = {};

                    for (var j = 0; j < vm.categories.length; j ++) {
                        for (var i = 0; i < categories.length; i ++) {
                            if (categories[i].id == vm.categories[j].id) {
                                vm.script.categories.push(vm.categories[j]);
                            }
                        }
                    }

                    for (var i = 0; i < vm.script.scriptItems.length; i ++) {
                        var scriptItemDetails = vm.script.scriptItems[i].scriptItemDetails;
                        for (var j = 0; j < scriptItemDetails.length; j ++) {
                            scriptItemDetails[j].detailType = scriptItemDetails[j].detailType.toString();
                            preViewShow(i, j, scriptItemDetails[j].detailType);
                        }
                    }

                    for (var i = 0; i < vm.variables.length; i ++) {
                        if (vm.variables[i].id == vm.script.rhythm) {
                            vm.script.rhythmObj = vm.variables[i];
                        }
                    }

                    for (var i = 0; i < vm.libraries.length; i ++) {
                        if (vm.script.libraryId == vm.libraries[i].id) {
                            vm.script.library = vm.libraries[i];
                        }
                    }

                    vm.setMedia();

                    vm.script.publishType = vm.script.publishType == 1 ? true : false;

                    vm.labelCount = vm.script.scriptItems.length;

                });
                vm.media = 1;
            } else {
                vm.labelCount = 0;
            }
        }

        function loadScriptDetailType() {
            Enum.get({name: 'ScriptMediaDetailType'}, function(result) {
                vm.scriptDetailType = result;
                vm.loadScript();
            });
        }

        function loadLibraries() {
            Library.list({}, function(result) {
                vm.libraries = result;
                for (var i = 0; i < vm.libraries.length; i ++) {
                    if (vm.libraries[i].fileType == '4' || vm.libraries[i].fileType == '5')
                    vm.movieLit.push(vm.libraries[i]);
                }
                vm.loadScript();
            });
        }

        function loadVariables() {
            Variable.list({}, function(result) {
                vm.variables = result;
                vm.loadScript();
            });
        }

        // ラベルを追加
        function addLabel(labelName) {
            vm.script.scriptItems.push({label: labelName, labelType: 3, scriptItemDetails: []});
            vm.script.scriptItems[vm.script.scriptItems.length - 1].scriptItemDetails.push({detailType: '5', contentId: ""});
        }

        function save(saveDirect) {

            preData(saveDirect);

            if (saveDirect) {
                Script.make(vm.script, function(result) {
                    vm.script.plainScript = result.plainScript;
                });
            } else {
                Script.save(vm.script, onSaveSuccess, onSaveError);
            }
        }

        function preData(saveDirect) {
            vm.success = null;
            vm.isSaving = true;
            vm.script.scriptType = vm.type;
            vm.script.saveDirect = saveDirect;

            if (vm.script.library.id != undefined) {
                vm.script.libraryId = vm.script.library.id;
                vm.script.libraryUrl = vm.script.library.url;
                if (vm.script.library.uploadFlg) {
                    vm.script.libraryUrl = vm.url + "/library/api/library/file/" + vm.script.library.id;
                } else {
                    vm.script.libraryUrl = vm.script.library.url;
                }
            }
            if (vm.script.rhythmObj != null && vm.script.rhythmObj.id != undefined) {
                vm.script.rhythm = vm.script.rhythmObj.id;
                vm.script.rhythmValue = vm.script.rhythmObj.itemCode;
            } else {
                vm.script.rhythm = "";
                vm.script.rhythmValue = "";
            }

            // contentValue
            for (var i = 0; i < vm.script.scriptItems.length; i ++) {
                var item = vm.script.scriptItems[i];

                if (item.label && item.label != '') {
                    item.labelShow = transformMinuteToSecond(item.label);
                } else {
                    item.label = 0;
                    item.labelShow = 0;
                }

                var delDetailArr = [];
                for (var j = 0; j < item.scriptItemDetails.length; j ++) {
                    var detail = item.scriptItemDetails[j];
                    if (detail.detailType == '10') {
                        for (var k = 0; k < vm.libraries.length; k ++) {
                            var o = vm.libraries[k];
                            if (detail.contentId != undefined && detail.contentId == o.id) {
                                var li = checkLibrary(detail.contentId);
                                if (li.uploadFlg) {
                                    if (detail.detailType == '10') {
                                        detail.contentValue = vm.url + "/library/api/library/image/" + o.id;
                                    } else {
                                        detail.contentValue = vm.url + "/library/api/library/file/" + o.id;
                                    }
                                } else {
                                    detail.contentValue = o.url
                                }
                            }
                        }
                    } else if (detail.detailType == '15') {
                        for (var k = 0; k < vm.variables.length; k ++) {
                            var o = vm.variables[k];
                            if (detail.contentId != undefined && detail.contentId == o.id) {
                                detail.contentValue = o.itemCode;
                            }
                        }
                    } else if (detail.detailType == '') {
                        delDetailArr.push(j);
                    }
                }
                for (var l = delDetailArr.length;l > 0; l --) {
                    delDetail(i, l);
                }
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            vm.success = true;
            //loadScript();
            $state.go('script');
            MessageService.success("global.messages.info.save");
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("global.messages.error.save");
            vm.success = null;
        }

        // ラベルを削除
        function delLabel(index) {
            vm.script.scriptItems.splice(index, 1);
        }

        function addDetail(parentIndex, type) {
            vm.script.scriptItems[parentIndex].scriptItemDetails.push({detailType: type});
        }

        function delDetail(parentIndex, index) {
            if (vm.script.scriptItems[parentIndex].scriptItemDetails[index].detailType == '10') {
                vm.script.scriptItems[parentIndex].background = "";
            }
            vm.script.scriptItems[parentIndex].scriptItemDetails.splice(index, 1);
        }

        function back() {
            if (confirm($translate.instant("script.message.backConfirm"))) {
                $state.go('script');
            }
        }

        // media
        function setMedia() {
            if (vm.script.library != null) {
                if (vm.script.library.uploadFlg == 0) {
                    vm.libraryUrl = vm.script.library.url;
                } else {
                    vm.libraryUrl = "/library/api/library/file/" + vm.script.library.id;
                }
                vm.media = 1;
            } else {
                vm.media = null;
                vm.libraryUrl = null;
            }
        }

        function record() {
            var currentTime = 0;
            if (vm.type == 2) {
                var audio = document.getElementById('audio');
                currentTime = parseInt(audio.currentTime, 10);
            } else if(vm.type == 3 && vm.script.library.fileType == 4) {
                var video = document.getElementById('video');
                currentTime = parseInt(video.currentTime, 10);
            } else if(vm.type == 3 && vm.script.library.fileType == 5) {
                return false;
            }
            var labelName = transformSecondToMinute(currentTime);
            addLabel(labelName);
        }

        function transformSecondToMinute(second) {
            var minuteTime = parseInt(second / 60, 10);
            var secondTime = parseInt(second % 60, 10) > 9 ? parseInt(second % 60, 10) : "0" + parseInt(second % 60, 10);
            var result = minuteTime + ":" + secondTime;
            return result;
        }

        function transformMinuteToSecond(minute) {
            var minuteArr = minute.split(":");
            return parseInt(minuteArr[0], 10) * 60 + parseInt(minuteArr[1], 10);
        }

        function preViewShow(parent, index, type) {
            if (type == '10') {
                if (vm.script.scriptItems[parent].scriptItemDetails[index].contentId != null
                    && vm.script.scriptItems[parent].scriptItemDetails[index].contentId != "") {
                    var li = checkLibrary(vm.script.scriptItems[parent].scriptItemDetails[index].contentId);
                    if (li != null) {
                        if (li.uploadFlg) {
                            vm.script.scriptItems[parent].background = "/library/api/library/image/"+ vm.script.scriptItems[parent].scriptItemDetails[index].contentId;
                        } else {
                            vm.script.scriptItems[parent].background = li.url;
                        }
                    } else {
                        vm.script.scriptItems[parent].background = null;
                    }
                } else {
                    vm.script.scriptItems[parent].background = vm.script.scriptItems[parent].scriptItemDetails[index].text;
                }
            } else if (type == '15') {
                vm.script.scriptItems[parent].scriptItemDetails[index].contentValue = getVariableDetail(vm.script.scriptItems[parent].scriptItemDetails[index].contentId, 15)
            }
        }

        function checkLibrary(id) {
            var result = null;
            for (var i = 0; i < vm.libraries.length; i ++) {
                if (vm.libraries[i].id == id) {
                    result = angular.copy(vm.libraries[i]);
                }
            }
            return result;
        }

        function getVariableDetail(id, type) {
            var result = "";
            if (type == '15') {
                for (var k = 0; k < vm.variables.length; k ++) {
                    var o = vm.variables[k];
                    if (id == o.id) {
                        result = o.itemCode;
                    }
                }
            }
            return result;
        }

        function choose(item, detail, fileType, type) {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/system/script/library/choose/choose.html',
                controller : 'ChooseController',
                controllerAs: 'vm',
                size : 'lg',
                resolve : {
                    params : {fileType: fileType},
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('library');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.script.scriptItems[item].scriptItemDetails[detail].contentId = "";
                    vm.script.scriptItems[item].scriptItemDetails[detail].text = "";
                    if (result.type == 1) {
                        vm.script.scriptItems[item].scriptItemDetails[detail].contentId = result.value;
                    } else {
                        vm.script.scriptItems[item].scriptItemDetails[detail].text = result.value;
                    }
                    preViewShow(item, detail, type);
                }
            },function(){
                MessageService.error("global.error.internalServerError");
            })
        }

        function loadUrl() {
            Library.url(function(result){
                vm.url = result.url;
                vm.loadScript();
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LibraryUrlController', LibraryUrlController);

    LibraryUrlController.$inject = ['entity', '$uibModalInstance', 'Library', 'MessageService', 'Principal', 'Group', '$timeout', '$rootScope'];

    function LibraryUrlController(entity, $uibModalInstance, Library, MessageService, Principal, Group, $timeout, $rootScope) {
        var vm = this;

        vm.library = entity;
        vm.groupId = null;

        vm.close = close;
        vm.save = save;
        vm.loadAllGroups = loadAllGroups;

        vm.loadAllGroups();

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.library.uploadFlg = 0;
            vm.library.systemFlg = vm.isAdmin;
            Library.save(vm.library, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            MessageService.success("library.message.saveSuccess");
            $uibModalInstance.close(result);
            $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
        }

        function onSaveError() {
            MessageService.error("library.message.saveError");
        }

        function loadAllGroups() {
            Group.queryUserGroups(function(result){
                vm.groups = result;
                if (result.length > 0) {
                    vm.groupId = result[0].id;
                }
            });

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LibraryUploadController', LibraryUploadController);

    LibraryUploadController.$inject = ['$uibModalInstance', '$scope', 'Upload', 'Principal', 'Group', 'MessageService'];

    function LibraryUploadController($uibModalInstance, $scope, Upload, Principal, Group, MessageService) {

        var vm = this;

        vm.files = [];

        vm.totalFiles = [];
        vm.index = 0;

        vm.groupId = null;

        vm.close = close;
        vm.loadAllGroups = loadAllGroups;

        vm.loadAllGroups();

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        function close() {
            $uibModalInstance.close();
        }

        function upload(files) {
            if (files && files.length) {
                for (var i = 0; i < files.length; i ++) {
                    vm.totalFiles.push({fileName: files[i].name, progress: 0, file: files[i]});
                }
                startUpload();
            }
        }

        function startUpload() {
            var file = vm.totalFiles[vm.index].file;
            var data = vm.totalFiles[vm.index];
            data.photoFlg = 0;
            data.adminFlg = vm.isAdmin;
            data.groupId = vm.groupId;
            if (!file.$error) {
                Upload.upload({
                    url: 'library/api/upload',
                    data: data
                }).progress(function (evt) {
                    if (vm.index < vm.totalFiles.length) {
                        vm.totalFiles[vm.index].progress = isNaN(parseInt(100.0 * evt.loaded / evt.total)) ? 0 : parseInt(100.0 * evt.loaded / evt.total);
                    }
                }).success(function (result) {
                    uploadFinish();
                    onUploadSuccess();
                }).error(function (result) {
                    //alert("上限が50M、アップロードできませんでした。");
                    MessageService.error("library.message.uploadError");
                    uploadFinish();
                });
            } else {
                uploadFinish();
                //alert("ファイルエラーが発生しました。");
                MessageService.error("library.message.uploadError");
            }
        }

        function uploadFinish() {
            vm.index = vm.index + 1;
            if (vm.totalFiles.length > vm.index) {
                startUpload();
            }
        }

        function onUploadSuccess() {
            //console.log("success");
        }

        function onUploadError(error) {
            //console.log("error");
        }

        $scope.$watch('vm.files', function () {
            upload(vm.files);
        });

        function loadAllGroups() {
            Group.queryUserGroups(function(result){
                vm.groups = result;
                if (result.length > 0) {
                    vm.groupId = result[0].id;
                }
            });

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('library', {
            parent: 'script',
            url: '/library',
            data: {
                pageTitle: 'global.menu.system.library'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/library/library.html',
                    controller: 'LibraryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('library');
                    return $translate.refresh();
                }]
            }
        }).state('library-url', {
            parent: 'library',
            url: '/{id}/library-url',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
            	Principal.identity().then(function(account) {
            		if (account != null) {
            			var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                        	$uibModal.open({
                                templateUrl: 'app/system/script/library/url/library-url.html',
                                controller: 'LibraryUrlController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'md',
                                resolve: {
                                    entity: ['Library', function (Library) {
                                        if ($stateParams.id != 0) {
                                            return Library.get({id: $stateParams.id});
                                        } else {
                                            return {id: null, fileName: '', url: '', comment: '', publishType: 3};
                                        }

                                    }]
                                }
                            }).result.then(function() {
                                $state.go('library', null, { reload: true });
                            }, function() {
                                $state.go('library');
                            });
                        }
            		} else {
            			LoginService.open();
            		}
                	
                });
            }]
        }).state('library-upload', {
            parent: 'library',
            url: '/library-upload',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal','LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
            	Principal.identity().then(function(account) {
            		if (account != null) {
            			var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                        	$uibModal.open({
                                templateUrl: 'app/system/script/library/upload/library-upload.html',
                                controller: 'LibraryUploadController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'md'
                            }).result.then(function() {
                                $state.go('library', null, { reload: true });
                            }, function() {
                                $state.go('library');
                            });
                        }
            		} else {
            			LoginService.open();
            		}
                	
                });
            }]
        }).state('library-edit', {
            parent: 'library',
            url: '/{id}/library-edit',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
            	Principal.identity().then(function(account) {
            		if (account != null) {
            			var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                        	$uibModal.open({
                                templateUrl: 'app/system/script/library/edit/library-edit.html',
                                controller: 'LibraryEditController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'md',
                                resolve: {
                                    entity: ['Library', function (Library) {
                                        return Library.get({id: $stateParams.id});
                                    }]
                                }
                            }).result.then(function() {
                                $state.go('library', null, { reload: true });
                            }, function() {
                                $state.go('library');
                            });
                        }
            		} else {
            			LoginService.open();
            		}
                	
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Library', Library);

    Library.$inject = ['$resource'];

    function Library ($resource) {
        var service = $resource('library/api/library', {}, {
            "list": {
                method: 'GET',
                isArray: true,
                url: 'library/api/libraries'
            },
            "query": {
                method: 'GET',
                isArray: true,
                url: 'library/api/libraries/belong/:belong/type/:type'
            },
            "save": {
                method: 'POST'
            },
            "del": {
                method: 'POST',
                url: 'library/api/library/del'
            },
            "get": {
                method: 'GET',
                url: 'library/api/library/:id'
            },
            "queryPublic": {
                method: 'GET',
                isArray: true,
                url: 'library/api/libraries/public/belong/:belong/type/:type'
            },
            "update": {
                method: 'PUT'
            },
            "url": {
                method: 'GET'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LibraryController', LibraryController);

    LibraryController.$inject = ['paginationConstants', 'Enum', 'Principal', 'Library', 'ParseLinks', '$state', 'MessageService'];

    function LibraryController(paginationConstants, Enum, Principal, Library, ParseLinks, $state, MessageService) {

        var vm = this;

        vm.belong = {};
        vm.types = {};
        vm.publishTypes = {};
        vm.selectedBelong = 2;
        vm.selectedType = 1;
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.libraryList = [];
        vm.selected = {ids: []};

        vm.loadAll = loadAll;
        vm.loadBelong = loadBelong;
        vm.loadTypes = loadTypes;
        vm.loadLibraries = loadLibraries;
        vm.loadPublishTypes = loadPublishTypes;

        vm.changeBelong = changeBelong;
        vm.changeType = changeType;
        vm.copyToClipboard = copyToClipboard;
        vm.selectLibrary = selectLibrary;
        vm.changePublishType = changePublishType;
        vm.delLibraries = delLibraries;

        vm.jump = jump;
        vm.edit = edit;

        vm.goEdit = goEdit;

        loadAll();

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        function loadAll() {
            loadBelong();
            loadTypes();
            loadLibraries();
            loadPublishTypes();
        }

        function loadBelong() {
            Enum.getLibrary({name: "LibraryBelongType"}, function(result) {
                vm.belong = result;
            });
        }

        function loadTypes() {
            Enum.getLibrary({name: "FileType"}, function(result) {
                vm.types = result;
            });
        }

        function loadPublishTypes() {
            Enum.getLibrary({name: "PublishType"}, function(result) {
                vm.publishTypes = result;
            });
        }

        function loadLibraries() {
            vm.selected.ids = [];
            Library.query({page: vm.page - 1, size: paginationConstants.itemsPerPage, belong: vm.selectedBelong, type: vm.selectedType}, function(result, headers){
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.libraryList = result;
            });
        }

        function changeBelong(selectedBelong) {
            vm.selectedBelong = selectedBelong;
            vm.page = 1;
            loadLibraries();
        }

        function changeType(selectedType) {
            vm.selectedType = selectedType;
            vm.page = 1;
            loadLibraries();
        }

        function copyToClipboard(url) {

            document.getElementById('copyUrl').value = url;
            document.getElementById('copyUrl').focus();
            document.getElementById('copyUrl').style.display = '';
            document.getElementById('copyUrl').select();
            setTimeout(function() {
                document.execCommand('copy');
                document.getElementById('copyUrl').style.display = 'none';
            }, 20);
        }

        function selectLibrary(id) {
            var checkbox = document.getElementById('checkbox' + id);
            checkbox.checked = !checkbox.checked;
            if (checkbox.checked) {
                vm.selected.ids.push(id);
            } else {
                for (var i = vm.selected.ids.length - 1; i >= 0; i --) {
                    if (vm.selected.ids[i] == id) {
                        vm.selected.ids.splice(i, 1);
                    }
                }
            }
        }

        function changePublishType(index) {
            Library.update(vm.libraryList[index], onChangeSuccess, onChangeError);
        }

        function onChangeSuccess() {
            MessageService.success("library.message.changeSuccess");
        }

        function onChangeError() {
            MessageService.error("library.message.changeError");
        }

        function delLibraries() {
            Library.del(vm.selected, onDelSuccess, onDelError);
        }

        function onDelSuccess() {
            MessageService.success("library.message.delSuccess");
            loadLibraries();
        }

        function onDelError() {
            MessageService.error("library.message.delError");
            loadLibraries();
        }

        function jump(type, id) {
            if (type == 1) {
                $state.go('library-upload');
            } else if (type == 2) {
                $state.go('library-url', {id: id});
            }
        }

        function edit() {
            if (vm.selected.ids.length != 1) {
                MessageService.error("library.message.selected");
                return false;
            } else {
                var id = vm.selected.ids[0];
                goEdit(id);
            }
        }

        function goEdit(id) {
            $state.go('library-edit', {id: id});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LibraryEditController', LibraryEditController);

    LibraryEditController.$inject = ['entity', '$uibModalInstance', '$scope', '$sce', 'Library', 'MessageService', 'Group', '$rootScope', '$timeout'];

    function LibraryEditController(entity, $uibModalInstance, $scope, $sce, Library, MessageService, Group, $rootScope, $timeout) {

        var vm = this;

        $scope.sce = $sce.trustAsResourceUrl;

        vm.library = entity;
        vm.groups = [];

        vm.close = close;
        vm.save = save;
        vm.loadAllGroups = loadAllGroups;

        vm.loadAllGroups();

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            Library.save(vm.library, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            MessageService.success("library.message.saveSuccess");
            $uibModalInstance.close(result);
            $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
        }

        function onSaveError() {
            MessageService.error("library.message.saveError");
        }

        function loadAllGroups() {
            Group.queryUserGroups(function(result){
                vm.groups = result;
                // for (var i = 0; i < vm.groups.length; i ++) {
                //     vm.groups[i].groupId = parseInt(vm.groups[i].groupId, 10);
                // }
            });

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ChooseController', ChooseController);

    ChooseController.$inject = ['params', '$uibModalInstance', 'Principal', 'Enum', 'Library', 'ParseLinks', 'paginationConstants', '$scope', '$sce'];

    function ChooseController(params, $uibModalInstance, Principal, Enum, Library, ParseLinks, paginationConstants, $scope, $sce) {

        var vm = this;

        $scope.sce = $sce.trustAsResourceUrl;

        vm.belong = {};
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.libraryList = [];
        vm.selectedBelong = 2;
        vm.selectedType = params.fileType;
        vm.formUrlFlg = false;
        vm.url = "";

        vm.close = close;
        vm.loadAll = loadAll;
        vm.loadBelong = loadBelong;
        vm.loadLibraries = loadLibraries;

        vm.changeBelong = changeBelong;
        vm.selectedLibrary = selectedLibrary;
        vm.setFromUrl = setFromUrl;

        loadAll();

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        function close() {
            $uibModalInstance.close("");
        }

        function loadAll() {
            loadBelong();
            loadLibraries();
        }

        function loadBelong() {
            Enum.getLibrary({name: "LibraryBelongType"}, function(result) {
                vm.belong = result;
            });
        }

        function loadLibraries() {
            Library.queryPublic({page: vm.page - 1, size: paginationConstants.itemsPerPage, belong: vm.selectedBelong, type: vm.selectedType}, function(result, headers){
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.libraryList = result;
            });
        }

        function changeBelong(selectedBelong) {
            vm.formUrlFlg = false;
            vm.selectedBelong = selectedBelong;
            vm.page = 1;
            loadLibraries();
        }

        function selectedLibrary(value) {
            $uibModalInstance.close(value);
        }

        function setFromUrl() {
            vm.formUrlFlg = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('daily', {
            parent: 'script',
            url: '/daily',
            data: {
                pageTitle: 'global.menu.system.daily'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/daily/daily.html',
                    controller: 'DailyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('daily');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('DailyController', DailyController);

    DailyController.$inject = ['Setting', '$scope', 'SelectedPepper', '$state', 'MessageService'];

    function DailyController (Setting, $scope, SelectedPepper, $state, MessageService) {
        var vm = this;

        vm.datas = {pepperId: null, pepperSettingList: []};
        vm.repeats = [{code: 1, value: "毎年"}, {code: 2, value: "毎月"}, {code: 3, value: "毎週"}];
        vm.index = null;
        vm.pepper = SelectedPepper.current();

        vm.loadPepperSettings = loadPepperSettings;
        vm.add = add;
        vm.del = del;
        vm.save = save;
        vm.cancel = cancel;
        vm.changeDays = changeDays;
        vm.copy = copy;
        vm.loadSystemPepperSettings = loadSystemPepperSettings;

        vm.loadPepperSettings();
        vm.loadSystemPepperSettings();

        $scope.$on('pepperChanged', function() {
            vm.pepper = SelectedPepper.current();
            loadPepperSettings();
        });

        function loadPepperSettings() {
            Setting.query({pepperId: vm.pepper.id, type: 2}, function(result) {
                vm.datas.pepperSettingList = result;
            });
        }

        function add() {
            var pepperSetting = {id: null, pepperId: null, variableType: 4, itemName: null, variableName: null, variableValue: null, repeatType: 1, sampleText: null,
                pepperSettingMonthly: {id: null, day1: null, day2: null, day3: null, day4: null, day5: null, day6: null, day7: null,
                    day8: null, day9: null, day10: null, day11: null, day12: null, day13: null, day14: null,
                    day15: null, day16: null, day17: null, day18: null, day19: null, day20: null, day21: null,
                    day22: null, day23: null, day24: null, day25: null, day26: null, day27: null, day28: null,
                    day29: null, day30: null, day31: null},
                pepperSettingWeekly: {id: null, day1: null, day2: null, day3: null, day4: null, day5: null, day6: null, day7: null},
                selected: false};
            vm.datas.pepperSettingList.push(pepperSetting);
            changeDays(vm.datas.pepperSettingList.length - 1);
        }

        function del(index) {
            vm.datas.pepperSettingList.splice(index, 1);
        }

        function save() {
            vm.isSaving = true;
            vm.datas.pepperId = vm.pepper.id;
            vm.datas.type = 2;
            Setting.save(vm.datas, onSaveSuccess, onSaveError);
        }

        function cancel() {
            vm.loadPepperSettings();
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            vm.loadPepperSettings();
            //AlertService.success("daily.home.success");
            MessageService.success("daily.home.success", "message_success");
            $state.go('script');
        }

        function onSaveError() {
            vm.isSaving = false;
            //AlertService.error("daily.home.error");
            MessageService.error("daily.home.error", "message_error");
        }

        function changeDays(index) {
            vm.index = index;
        }

        function copy(index) {
            if (confirm("既にデフォルト項目が上書きしますか。")) {
                for (var i = vm.datas.pepperSettingList.length - 1; i >= 0; i --) {
                    if (vm.datas.pepperSettingList[i].variableType == 3) {
                        vm.datas.pepperSettingList.splice(i, 1);
                    }
                }
                for (var i = 0; i < vm.systemSetting[index].pepperSettingList.length; i ++) {
                    var setting = angular.copy(vm.systemSetting[index].pepperSettingList[i]);
                    setting.id = null;
                    setting.variableType = 3;
                    setting.pepperSettingMonthly != null ? setting.pepperSettingMonthly.id = null : null;
                    setting.pepperSettingWeekly != null ? setting.pepperSettingWeekly.id = null : null;
                    vm.datas.pepperSettingList.push(setting);
                }
            }
        }

        function loadSystemPepperSettings() {
            Setting.system({type: 6}, function(result) {
                vm.systemSetting = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShowConversationController', ShowConversationController);

    ShowConversationController.$inject = ['$stateParams', '$scope', 'Category', 'Script', '$state', 'Enum', 'Library', 'Variable', '$sce', '$uibModal', 'MessageService', '$translate', 'Principal'];

    function ShowConversationController ($stateParams, $scope, Category, Script, $state, Enum, Library, Variable, $sce, $uibModal, MessageService, $translate, Principal) {
        var vm = this;

        vm.categories = [];
        vm.script = {id: null, scriptType: null, scriptName: null, title: null,
            libraryId: null, publishType: true, plainScript: null, comment: null,
            scriptItems: [],
            categories: []};
        vm.detailTypes = [];
        vm.scriptDetailType = [];
        vm.libraries = [];
        vm.variables = [];
        vm.labelCount = 1;
        vm.url = null;
        vm.type = $stateParams.type;
        vm.loadCount = 0;

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        vm.loadAll = loadAll;
        vm.loadCategories = loadCategories;
        vm.loadScript = loadScript;
        vm.loadScriptDetailType = loadScriptDetailType;
        vm.loadLibraries = loadLibraries;
        vm.loadVariables = loadVariables;
        vm.loadUrl = loadUrl;
        vm.addLabel = addLabel;
        vm.save = save;
        vm.delLabel = delLabel;
        vm.addDetail = addDetail;
        vm.delDetail = delDetail;
        vm.back = back;
        vm.choose = choose;
        vm.checkLibrary = checkLibrary;

        vm.preViewShow = preViewShow;

        vm.loadAll();

        $scope.sce = $sce.trustAsResourceUrl;

        function loadAll() {
            vm.loadCategories();
            vm.loadScriptDetailType();
            vm.loadLibraries();
            vm.loadVariables();
            vm.loadUrl();
        }

        function loadCategories() {
            Category.list(function(result) {
                for (var i = 0; i < result.length; i ++) {
                    if (vm.isAdmin || (!vm.isAdmin && result[i].categoryType < 9)) {
                        vm.categories.push(result[i]);
                    }
                }
                vm.loadScript();
            });
        }

        function loadScript() {
            vm.loadCount ++;
            if (vm.loadCount != 5) {
                return false;
            }
            if ($stateParams.id != 0) {
                Script.get({id: $stateParams.id}, function(result) {
                    vm.script = result;

                    var categories = vm.script.categories;
                    vm.script.categories = [];

                    for (var i = 0; i < categories.length; i ++) {
                        for (var j = 0; j < vm.categories.length; j ++) {
                            if (categories[i].id == vm.categories[j].id) {
                                vm.script.categories.push(vm.categories[j]);
                            }
                        }
                    }

                    for (var i = 0; i < vm.script.scriptItems.length; i ++) {
                        var scriptItemDetails = vm.script.scriptItems[i].scriptItemDetails;
                        for (var j = 0; j < scriptItemDetails.length; j ++) {
                            scriptItemDetails[j].detailType = scriptItemDetails[j].detailType.toString();
                            preViewShow(i, j, scriptItemDetails[j].detailType);
                        }
                    }

                    vm.script.publishType = vm.script.publishType == 1 ? true : false;

                    if (vm.script.scriptItems.length > 0) {
                        vm.labelCount = parseInt(vm.script.scriptItems[vm.script.scriptItems.length - 1].label.substring(1), 10)
                    } else {
                        vm.labelCount = 0;
                    }
                });
            } else {
                vm.labelCount = 0;
            }
        }

        function loadScriptDetailType() {
            Enum.get({name: 'ScriptConversationDetailType'}, function(result) {
                vm.scriptDetailType = result;
                vm.loadScript();
            });
        }

        function loadLibraries() {
            Library.list({}, function(result) {
                vm.libraries = result;
                vm.loadScript();
            });
        }

        function loadVariables() {
            Variable.list({}, function(result) {
                vm.variables = result;
                vm.loadScript();
            });
        }

        // ラベルを追加
        function addLabel(labelType) {
            vm.labelCount ++;
            var labelName = vm.labelCount;
            if (labelType == 1) {
                labelName = "s" + vm.labelCount;
            } else {
                labelName = "q" + vm.labelCount;
            }
            vm.script.scriptItems.push({label: labelName, labelType: labelType, scriptItemDetails: []});
            vm.script.scriptItems[vm.script.scriptItems.length - 1].scriptItemDetails.push({detailType: '1', contentId: ""});
        }

        function save(saveDirect) {

            preData(saveDirect);

            if (saveDirect) {
                Script.make(vm.script, function(result) {
                    vm.script.plainScript = result.plainScript;
                });
            } else {
                Script.save(vm.script, onSaveSuccess, onSaveError);
            }
        }

        function preData(saveDirect) {

            vm.success = null;
            vm.isSaving = true;
            vm.script.scriptType = $stateParams.type;
            vm.script.saveDirect = saveDirect;

            // contentValue
            for (var i = 0; i < vm.script.scriptItems.length; i ++) {
                var item = vm.script.scriptItems[i];
                var delDetailArr = [];
                for (var j = 0; j < item.scriptItemDetails.length; j ++) {
                    var detail = item.scriptItemDetails[j];
                    if (detail.detailType == '10' || detail.detailType == '20') {
                        for (var k = 0; k < vm.libraries.length; k ++) {
                            var o = vm.libraries[k];
                            if (detail.contentId != undefined && detail.contentId == o.id) {
                                var li = checkLibrary(detail.contentId);
                                if (li.uploadFlg) {
                                    if (detail.detailType == '10') {
                                        detail.contentValue = vm.url + "/library/api/library/image/" + o.id;
                                    } else {
                                        detail.contentValue = vm.url + "/library/api/library/file/" + o.id;
                                    }
                                } else {
                                    detail.contentValue = o.url
                                }
                            }
                        }
                    } else if (detail.detailType == '15' || detail.detailType == '25') {
                        for (var k = 0; k < vm.variables.length; k ++) {
                            var o = vm.variables[k];
                            if (detail.contentId != undefined && detail.contentId == o.id) {
                                detail.contentValue = o.itemCode;
                            }
                        }
                    } else if (detail.detailType == '') {
                        delDetailArr.push(j);
                    }
                }
                for (var l = delDetailArr.length;l > 0; l --) {
                    delDetail(i, l);
                }
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            vm.success = true;
            //loadScript();
            $state.go('script');
            MessageService.success("global.messages.info.save");
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("global.messages.error.save");
            vm.success = null;
        }

        // ラベルを削除
        function delLabel(index) {
            vm.script.scriptItems.splice(index, 1);
        }

        function addDetail(parentIndex, type) {
            vm.script.scriptItems[parentIndex].scriptItemDetails.push({detailType: type});
        }

        function delDetail(parentIndex, index) {
            if (vm.script.scriptItems[parentIndex].scriptItemDetails[index].detailType == '10') {
                vm.script.scriptItems[parentIndex].background = "";
            } else if (vm.script.scriptItems[parentIndex].scriptItemDetails[index].detailType == '20') {
                vm.script.scriptItems[parentIndex].music = "";
            }
            vm.script.scriptItems[parentIndex].scriptItemDetails.splice(index, 1);
        }

        function back() {
            $state.go('script');
        }

        function preViewShow(parent, index, type) {
            if (type == '10') {
                if (vm.script.scriptItems[parent].scriptItemDetails[index].contentId != null
                    && vm.script.scriptItems[parent].scriptItemDetails[index].contentId != "") {
                    var li = checkLibrary(vm.script.scriptItems[parent].scriptItemDetails[index].contentId);
                    if (li != null) {
                        if (li.uploadFlg) {
                            vm.script.scriptItems[parent].background = "/library/api/library/image/"+ vm.script.scriptItems[parent].scriptItemDetails[index].contentId;
                        } else {
                            vm.script.scriptItems[parent].background = li.url;
                        }
                    } else {
                        vm.script.scriptItems[parent].background = null;
                    }
                } else {
                    vm.script.scriptItems[parent].background = vm.script.scriptItems[parent].scriptItemDetails[index].text;
                }
            } else if (type == '15') {
                vm.script.scriptItems[parent].scriptItemDetails[index].contentValue = getVariableDetail(vm.script.scriptItems[parent].scriptItemDetails[index].contentId, 15)
            } else if (type == '20') {
                if (vm.script.scriptItems[parent].scriptItemDetails[index].contentId != null
                    && vm.script.scriptItems[parent].scriptItemDetails[index].contentId != "") {
                    var li = checkLibrary(vm.script.scriptItems[parent].scriptItemDetails[index].contentId);
                    if (li != null) {
                        if (li.uploadFlg) {
                            vm.script.scriptItems[parent].music = "/library/api/library/file/" + vm.script.scriptItems[parent].scriptItemDetails[index].contentId;
                        } else {
                            vm.script.scriptItems[parent].music = li.url;
                        }
                    } else {
                        vm.script.scriptItems[parent].music = null;
                    }
                } else {
                    vm.script.scriptItems[parent].music = vm.script.scriptItems[parent].scriptItemDetails[index].text;
                }
            }
        }

        function checkLibrary(id) {
            var result = null;
            for (var i = 0; i < vm.libraries.length; i ++) {
                if (vm.libraries[i].id == id) {
                    result = angular.copy(vm.libraries[i]);
                }
            }
            return result;
        }

        function getVariableDetail(id, type) {
            var result = "";
            if (type == '15') {
                for (var k = 0; k < vm.variables.length; k ++) {
                    var o = vm.variables[k];
                    if (id == o.id) {
                        result = o.itemCode;
                    }
                }
            }
            return result;
        }

        function choose(item, detail, fileType, type) {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/system/script/library/choose/choose.html',
                controller : 'ChooseController',
                controllerAs: 'vm',
                size : 'lg',
                resolve : {
                    params : {fileType: fileType},
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('library');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.script.scriptItems[item].scriptItemDetails[detail].contentId = "";
                    vm.script.scriptItems[item].scriptItemDetails[detail].text = "";
                    if (result.type == 1) {
                        vm.script.scriptItems[item].scriptItemDetails[detail].contentId = result.value;
                    } else {
                        vm.script.scriptItems[item].scriptItemDetails[detail].text = result.value;
                    }
                    preViewShow(item, detail, type);
                }
            },function(){
                MessageService.error("global.error.internalServerError");
            })
        }

        function loadUrl() {
            Library.url(function(result){
                vm.url = result.url;
                vm.loadScript();
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ConversationController', ConversationController);

    ConversationController.$inject = ['$stateParams', '$scope', 'Category', 'Script', '$state', 'Enum', 'Library', 'Variable', '$sce', '$uibModal', 'MessageService', '$translate', 'Principal'];

    function ConversationController ($stateParams, $scope, Category, Script, $state, Enum, Library, Variable, $sce, $uibModal, MessageService, $translate, Principal) {
        var vm = this;

        vm.categories = [];
        vm.script = {id: null, scriptType: null, scriptName: null, title: null,
            libraryId: null, publishType: true, plainScript: null, comment: null,
            scriptItems: [],
            categories: []};
        vm.detailTypes = [];
        vm.scriptDetailType = [];
        vm.libraries = [];
        vm.variables = [];
        vm.labelCount = 1;
        vm.url = null;
        vm.type = $stateParams.type;
        vm.loadCount = 0;

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        vm.loadAll = loadAll;
        vm.loadCategories = loadCategories;
        vm.loadScript = loadScript;
        vm.loadScriptDetailType = loadScriptDetailType;
        vm.loadLibraries = loadLibraries;
        vm.loadVariables = loadVariables;
        vm.loadUrl = loadUrl;
        vm.addLabel = addLabel;
        vm.save = save;
        vm.delLabel = delLabel;
        vm.addDetail = addDetail;
        vm.delDetail = delDetail;
        vm.back = back;
        vm.choose = choose;
        vm.checkLibrary = checkLibrary;

        vm.preViewShow = preViewShow;

        vm.loadAll();

        $scope.sce = $sce.trustAsResourceUrl;

        function loadAll() {
            vm.loadCategories();
            vm.loadScriptDetailType();
            vm.loadLibraries();
            vm.loadVariables();
            vm.loadUrl();
        }

        function loadCategories() {
            Category.list(function(result) {
                for (var i = 0; i < result.length; i ++) {
                    if (vm.isAdmin || (!vm.isAdmin && result[i].categoryType < 9)) {
                        vm.categories.push(result[i]);
                    }
                }
                vm.loadScript();
            });
        }

        function loadScript() {
            vm.loadCount ++;
            if (vm.loadCount != 5) {
                return false;
            }
            if ($stateParams.id != 0) {
                Script.get({id: $stateParams.id}, function(result) {
                    vm.script = result;

                    var categories = vm.script.categories;
                    vm.script.categories = [];

                    for (var i = 0; i < categories.length; i ++) {
                        for (var j = 0; j < vm.categories.length; j ++) {
                            if (categories[i].id == vm.categories[j].id) {
                                vm.script.categories.push(vm.categories[j]);
                            }
                        }
                    }

                    for (var i = 0; i < vm.script.scriptItems.length; i ++) {
                        var scriptItemDetails = vm.script.scriptItems[i].scriptItemDetails;
                        for (var j = 0; j < scriptItemDetails.length; j ++) {
                            scriptItemDetails[j].detailType = scriptItemDetails[j].detailType.toString();
                            preViewShow(i, j, scriptItemDetails[j].detailType);
                        }
                    }

                    vm.script.publishType = vm.script.publishType == 1 ? true : false;

                    if (vm.script.scriptItems.length > 0) {
                        vm.labelCount = parseInt(vm.script.scriptItems[vm.script.scriptItems.length - 1].label.substring(1), 10)
                    } else {
                        vm.labelCount = 0;
                    }
                });
            } else {
                vm.labelCount = 0;
            }
        }

        function loadScriptDetailType() {
            Enum.get({name: 'ScriptConversationDetailType'}, function(result) {
                vm.scriptDetailType = result;
                vm.loadScript();
            });
        }

        function loadLibraries() {
            Library.list({}, function(result) {
                vm.libraries = result;
                vm.loadScript();
            });
        }

        function loadVariables() {
            Variable.list({}, function(result) {
                vm.variables = result;
                vm.loadScript();
            });
        }

        // ラベルを追加
        function addLabel(labelType) {
            vm.labelCount ++;
            var labelName = vm.labelCount;
            if (labelType == 1) {
                labelName = "s" + vm.labelCount;
            } else {
                labelName = "q" + vm.labelCount;
            }
            vm.script.scriptItems.push({label: labelName, labelType: labelType, scriptItemDetails: []});
            vm.script.scriptItems[vm.script.scriptItems.length - 1].scriptItemDetails.push({detailType: '1', contentId: ""});
        }

        function save(saveDirect) {

            preData(saveDirect);

            if (saveDirect) {
                Script.make(vm.script, function(result) {
                    vm.script.plainScript = result.plainScript;
                });
            } else {
                Script.save(vm.script, onSaveSuccess, onSaveError);
            }
        }

        function preData(saveDirect) {

            vm.success = null;
            vm.isSaving = true;
            vm.script.scriptType = $stateParams.type;
            vm.script.saveDirect = saveDirect;

            // contentValue
            for (var i = 0; i < vm.script.scriptItems.length; i ++) {
                var item = vm.script.scriptItems[i];
                var delDetailArr = [];
                for (var j = 0; j < item.scriptItemDetails.length; j ++) {
                    var detail = item.scriptItemDetails[j];
                    if (detail.detailType == '10' || detail.detailType == '20') {
                        for (var k = 0; k < vm.libraries.length; k ++) {
                            var o = vm.libraries[k];
                            if (detail.contentId != undefined && detail.contentId == o.id) {
                                var li = checkLibrary(detail.contentId);
                                if (li.uploadFlg) {
                                    if (detail.detailType == '10') {
                                        detail.contentValue = vm.url + "/library/api/library/image/" + o.id;
                                    } else {
                                        detail.contentValue = vm.url + "/library/api/library/file/" + o.id;
                                    }
                                } else {
                                    detail.contentValue = o.url
                                }
                            }
                        }
                    } else if (detail.detailType == '15' || detail.detailType == '25') {
                        for (var k = 0; k < vm.variables.length; k ++) {
                            var o = vm.variables[k];
                            if (detail.contentId != undefined && detail.contentId == o.id) {
                                detail.contentValue = o.itemCode;
                            }
                        }
                    } else if (detail.detailType == '') {
                        delDetailArr.push(j);
                    }
                }
                for (var l = delDetailArr.length;l > 0; l --) {
                    delDetail(i, l);
                }
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            vm.success = true;
            //loadScript();
            $state.go('script');
            MessageService.success("global.messages.info.save");
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("global.messages.error.save");
            vm.success = null;
        }

        // ラベルを削除
        function delLabel(index) {
            vm.script.scriptItems.splice(index, 1);
        }

        function addDetail(parentIndex, type) {
            vm.script.scriptItems[parentIndex].scriptItemDetails.push({detailType: type});
        }

        function delDetail(parentIndex, index) {
            if (vm.script.scriptItems[parentIndex].scriptItemDetails[index].detailType == '10') {
                vm.script.scriptItems[parentIndex].background = "";
            } else if (vm.script.scriptItems[parentIndex].scriptItemDetails[index].detailType == '20') {
                vm.script.scriptItems[parentIndex].music = "";
            }
            vm.script.scriptItems[parentIndex].scriptItemDetails.splice(index, 1);
        }

        function back() {
            if (confirm($translate.instant("script.message.backConfirm"))) {
                $state.go('script');
            }
        }

        function preViewShow(parent, index, type) {
            if (type == '10') {
                if (vm.script.scriptItems[parent].scriptItemDetails[index].contentId != null
                    && vm.script.scriptItems[parent].scriptItemDetails[index].contentId != "") {
                    var li = checkLibrary(vm.script.scriptItems[parent].scriptItemDetails[index].contentId);
                    if (li != null) {
                        if (li.uploadFlg) {
                            vm.script.scriptItems[parent].background = "/library/api/library/image/"+ vm.script.scriptItems[parent].scriptItemDetails[index].contentId;
                        } else {
                            vm.script.scriptItems[parent].background = li.url;
                        }
                    } else {
                        vm.script.scriptItems[parent].background = null;
                    }
                } else {
                    vm.script.scriptItems[parent].background = vm.script.scriptItems[parent].scriptItemDetails[index].text;
                }
            } else if (type == '15') {
                vm.script.scriptItems[parent].scriptItemDetails[index].contentValue = getVariableDetail(vm.script.scriptItems[parent].scriptItemDetails[index].contentId, 15)
            } else if (type == '20') {
                if (vm.script.scriptItems[parent].scriptItemDetails[index].contentId != null
                    && vm.script.scriptItems[parent].scriptItemDetails[index].contentId != "") {
                    var li = checkLibrary(vm.script.scriptItems[parent].scriptItemDetails[index].contentId);
                    if (li != null) {
                        if (li.uploadFlg) {
                            vm.script.scriptItems[parent].music = "/library/api/library/file/" + vm.script.scriptItems[parent].scriptItemDetails[index].contentId;
                        } else {
                            vm.script.scriptItems[parent].music = li.url;
                        }
                    } else {
                        vm.script.scriptItems[parent].music = null;
                    }
                } else {
                    vm.script.scriptItems[parent].music = vm.script.scriptItems[parent].scriptItemDetails[index].text;
                }
            }
        }

        function checkLibrary(id) {
            var result = null;
            for (var i = 0; i < vm.libraries.length; i ++) {
                if (vm.libraries[i].id == id) {
                    result = angular.copy(vm.libraries[i]);
                }
            }
            return result;
        }

        function getVariableDetail(id, type) {
            var result = "";
            if (type == '15') {
                for (var k = 0; k < vm.variables.length; k ++) {
                    var o = vm.variables[k];
                    if (id == o.id) {
                        result = o.itemCode;
                    }
                }
            }
            return result;
        }

        function choose(item, detail, fileType, type) {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/system/script/library/choose/choose.html',
                controller : 'ChooseController',
                controllerAs: 'vm',
                size : 'lg',
                resolve : {
                    params : {fileType: fileType},
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('library');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.script.scriptItems[item].scriptItemDetails[detail].contentId = "";
                    vm.script.scriptItems[item].scriptItemDetails[detail].text = "";
                    if (result.type == 1) {
                        vm.script.scriptItems[item].scriptItemDetails[detail].contentId = result.value;
                    } else {
                        vm.script.scriptItems[item].scriptItemDetails[detail].text = result.value;
                    }
                    preViewShow(item, detail, type);
                }
            },function(){
                MessageService.error("global.error.internalServerError");
            })
        }

        function loadUrl() {
            Library.url(function(result){
                vm.url = result.url;
                vm.loadScript();
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('base', {
            parent: 'script',
            url: '/base',
            data: {
                pageTitle: 'global.menu.system.base'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/script/base/base.html',
                    controller: 'BaseController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('base');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('BaseController', BaseController);

    BaseController.$inject = ['Setting', '$scope','SelectedPepper', '$state', 'MessageService'];

    function BaseController (Setting, $scope, SelectedPepper, $state, MessageService) {
        var vm = this;

        vm.datas = {pepperId: null, pepperSettingList: []};

        vm.success = null;
        vm.pepper = SelectedPepper.current();
        vm.systemSetting = [];

        vm.loadPepperSettings = loadPepperSettings;
        vm.loadSystemPepperSettings = loadSystemPepperSettings;
        vm.add = add;
        vm.del = del;
        vm.save = save;
        vm.cancel = cancel;
        vm.copy = copy;


        vm.loadPepperSettings();
        vm.loadSystemPepperSettings();

        $scope.$on('pepperChanged', function() {
            vm.pepper = SelectedPepper.current();
            loadPepperSettings();
        });


        function loadPepperSettings() {
            Setting.query({pepperId: vm.pepper.id, type: 1}, function(result) {
                vm.datas.pepperSettingList = result;
                // if (vm.datas.pepperSettingList.length == 0) {
                //     vm.add();
                // }
            });
        }

        function add() {
            var pepperSetting = {id: null, pepperId: null, variableType: 2, itemName: null, variableName: null, variableValue: null, repeatType: 1, sampleText: null};
            vm.datas.pepperSettingList.push(pepperSetting);
        }

        function del(index) {
            vm.datas.pepperSettingList.splice(index, 1);
            // if (vm.datas.pepperSettingList.length == 0) {
            //     vm.add();
            // }
        }

        function save() {
            vm.isSaving = true;
            vm.datas.pepperId = vm.pepper.id;
            vm.datas.type = 1;
            Setting.save(vm.datas, onSaveSuccess, onSaveError);
        }

        function cancel() {
            vm.loadPepperSettings();
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            MessageService.success("base.home.success");
            $state.go('script');
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("base.home.error");
        }

        function copy(index) {
            if (confirm("既にデフォルト項目が上書きしますか。")) {
                for (var i = vm.datas.pepperSettingList.length - 1; i >= 0; i --) {
                    if (vm.datas.pepperSettingList[i].variableType == 1) {
                        vm.datas.pepperSettingList.splice(i, 1);
                    }
                }
                for (var i = 0; i < vm.systemSetting[index].pepperSettingList.length; i ++) {
                    var setting = angular.copy(vm.systemSetting[index].pepperSettingList[i]);
                    setting.id = null;
                    setting.variableType = 1;
                    vm.datas.pepperSettingList.push(setting);
                }
            }
        }

        function loadSystemPepperSettings() {
            Setting.system({type: 5}, function(result) {
                vm.systemSetting = result;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RoleManagementShowController',RoleManagementShowController);

    RoleManagementShowController.$inject = ['$stateParams', 'param', '$uibModalInstance', 'Role', 'JhiLanguageService','Group', 'MessageService', '$timeout', '$rootScope','OptionUser','Principal', 'Outlets'];

    function RoleManagementShowController ($stateParams, param, $uibModalInstance, Role, JhiLanguageService, Group, MessageService, $timeout, $rootScope, OptionUser, Principal, Outlets) {
        var vm = this;
        vm.clear = clear;
        vm.loadData = loadData;
        vm.role = {code: "", name: "", kinouList: []};
        loadData();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function loadData() {
            if (param.code != null && param.code != '') {
                Role.getRole({code: param.code}, function (result) {
                    vm.role.code = result.code;
                    vm.role.name = result.name;
                    for(var i=0; i<result.kinouList.length;i++){
                        if(result.kinouList[i].checked){
                            vm.role.kinouList.push(result.kinouList[i]);
                        }
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RoleManagementDeleteController',RoleManagementDeleteController);

        RoleManagementDeleteController.$inject = ['$stateParams', 'entity', '$uibModalInstance', 'Role', 'JhiLanguageService','Group', 'MessageService', '$timeout', '$rootScope','OptionUser','Principal', 'Outlets'];

    function RoleManagementDeleteController ($stateParams, entity, $uibModalInstance, Role, JhiLanguageService, Group, MessageService, $timeout, $rootScope, OptionUser, Principal, Outlets) {
        var vm = this;
        vm.clear = clear;
        vm.delete = deleteRole;
        vm.role = entity;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function deleteRole (code){
            Role.deleteRole({code: code}, function(){
                MessageService.success("roleManagement.role.roleDelete");
                $uibModalInstance.close(true);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RoleManagementCreateController',RoleManagementCreateController);

    RoleManagementCreateController.$inject = ['$stateParams', 'param', 'AlertService', '$uibModalInstance', 'Role', 'JhiLanguageService','Group', 'MessageService', '$timeout', '$rootScope','OptionUser','Principal', 'Outlets'];

    function RoleManagementCreateController ($stateParams, param, AlertService, $uibModalInstance, Role, JhiLanguageService, Group, MessageService, $timeout, $rootScope, OptionUser, Principal, Outlets) {
        var vm = this;
        vm.clear = clear;
        vm.authority;
        vm.searchAuthority = searchAuthority;
        vm.role = {code: "", name: "", kinouList: "", resultList: ""};
        vm.getFunction = getFunction;
        vm.functionCheck = functionCheck;
        vm.save = save;
        vm.loadData = loadData;
        //vm.getFunction();
        loadData();
        vm.oldCode = "";

        function loadData() {
            if (param.code != null && param.code != '') {
                Role.getRole({code: param.code}, function (result) {
                    vm.role.code = result.code;
                    vm.oldCode = result.code;
                    vm.role.name = result.name;
                    vm.role.kinouList = result.kinouList;
                    vm.role.resultList = result.kinouList;
                    //functionCheck();
                });
            }else {
                getFunction();
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function searchAuthority(){
            /*var container = $('#aDiv');
            var scrollTo = $("input[name='" + vm.authority+ "']");
            if(vm.authority == ""){
                container.animate({
                    scrollTop: 0
                });
            }else{
                container.animate({
                    scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()- 10
                });
            }*/
            vm.role.kinouList = vm.role.resultList;
            if(vm.authority != "" && vm.authority != null){
                angular.forEach(vm.role.kinouList,function(data,index,array){
                    if(!data.name.match(vm.authority)){
                        data.showFlag = false;
                    }else{
                        data.showFlag = true;
                    }
                });
            }else{
                angular.forEach(vm.role.kinouList,function(data,index,array){
                    data.showFlag = true;
                });
            }
        }

        function getFunction() {
            Role.getFunction({}, function (data){
                vm.role.kinouList = data;
                vm.role.resultList = data;
            });
        }

        function functionCheck (){
            vm.role.kinouList.sort(function (a,b){
                if(b.checked == a.checked){
                    return a.id - b.id;
                }
                return b.checked - a.checked;
            });
            var container = $('#aDiv');
            var scrollTo = $("input[name='" + vm.authority+ "']");
            container.animate({
                scrollTop: 0
            });
        }

        function save(){
            var entity = angular.copy(vm.role);
            if(vm.oldCode == ''){
                Role.createRole(entity, function(result){
                    MessageService.success("roleManagement.role.roleSaved");
                    $uibModalInstance.close(result);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                },function(error){
                    AlertService.error(error.data.message);
                });
            }else{
                entity.originalCode = vm.oldCode;
                Role.updateRole(entity, function(result){
                    MessageService.success("roleManagement.role.roleSaved");
                    $uibModalInstance.close(result);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                },function(error){
                    MessageService.error("global.messages.error.save");
                });
            }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('role-management', {
                parent: 'app',
                url: '/settings/role?page&sort',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER'],
                    pageTitle: 'roleManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/system/role-management/role-management.html',
                        controller: 'RoleManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('role-management');
                        return $translate.refresh();
                    }]

                }
            })
            .state('role-management.new', {
                parent: 'role-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/system/role-management/role-management-create.html',
                        controller: 'RoleManagementCreateController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            param: {code: $stateParams.code}
                        }
                    }).result.then(function() {
                        $state.go('role-management', null, { reload: true });
                    }, function() {
                        $state.go('role-management');
                    });
                }]
            })
            .state('role-management.edit', {
                parent: 'role-management',
                url: '/edit/{code}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/system/role-management/role-management-create.html',
                        controller: 'RoleManagementCreateController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            param: {code: $stateParams.code}
                        }
                    }).result.then(function() {
                        $state.go('role-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('role-management.show', {
                parent: 'role-management',
                url: '/show/{code}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/system/role-management/role-management-show.html',
                        controller: 'RoleManagementShowController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            param: {code: $stateParams.code}
                        }
                    }).result.then(function() {
                        $state.go('role-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('role-management.delete', {
                parent: 'role-management',
                url: '/delete/{code}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/system/role-management/role-management-delete.html',
                        controller: 'RoleManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Role', function(Role) {
                                return Role.getRole({code : $stateParams.code});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('role-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RoleManagementController', RoleManagementController);

    RoleManagementController.$inject = ['Principal', 'Enum', 'Role', 'ParseLinks', 'MessageService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'Group', '$filter', 'SelectedGroup', '$scope', '$rootScope'];

    function RoleManagementController(Principal, Enum, Role, ParseLinks, MessageService, $state, pagingParams, paginationConstants, JhiLanguageService, Group, $filter, SelectedGroup, $scope, $rootScope) {
        var vm = this;
        vm.searchData = {roleName: "", roleCode: ""};
        vm.defaultSearchData = {roleName: "", roleCode: ""};
        vm.role = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.loadAll();
        vm.goEdit = goEdit;
        vm.goDel = goDel;
        vm.goNew = goNew;

        function loadAll () {

            if($rootScope.page != undefined){
                vm.page = $rootScope.page;
                $rootScope.page = undefined;
            }
            if($rootScope.roleCode != undefined){
                vm.searchData.roleCode = $rootScope.roleCode;
                $rootScope.roleCode = undefined;
            }
            if($rootScope.roleName != undefined){
                vm.searchData.roleName = $rootScope.roleName;
                $rootScope.roleName = undefined;
            }
            Role.query({
                page: vm.page - 1,
                size: vm.itemsPerPage,
                name: vm.searchData.roleName,
                code: vm.searchData.roleCode,
                sort: sort()
            }, onSuccess, onError);
        }

        function search(){
            vm.page = 1;
            loadAll();
        }

        function onSuccess(data, headers) {
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.role = data;
            setTimeout(function() {
                //屏幕高度
                var height = document.documentElement.clientHeight;
                //导航部分的高度
                var navbarHeight = $("#navbarHeight").height();//20
                //检索部分的高度
                var searchHeight = $("#searchHeight").height();//15
                //表头高度
                var headerHeight = $("#headerHeight").height();//
                //分页部分高度
                var pageHeight = $("#pageHeight").height();
                //copyRight
                var copyRight = $("#copyRight").height();
                var tableDivHeight = height-navbarHeight-19-searchHeight-headerHeight-20-pageHeight-10-copyRight-10-40;
                $("#tableDiv").css("max-height",tableDivHeight);
            }, 20);
        }

        function onError(){
        }

        function clear () {
            vm.searchData = angular.copy(vm.defaultSearchData);
            search();
        }

        function loadPage (page) {
            vm.page = page;
            //vm.transition();
        }

        function transition () {

        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }

        function goEdit(code) {
            $rootScope.roleCode = vm.searchData.roleCode;
            $rootScope.roleName = vm.searchData.roleName;
            $rootScope.page = vm.page;
            $state.go('role-management.edit', {code: code});
        }

        function goDel(code, name) {
            $rootScope.roleCode = vm.searchData.roleCode;
            $rootScope.roleName = vm.searchData.roleName;
            $rootScope.page = vm.page;
            $state.go('role-management.delete', {code: code, name: name});
        }

        function goNew() {
            $rootScope.roleCode = vm.searchData.roleCode;
            $rootScope.roleName = vm.searchData.roleName;
            $rootScope.page = vm.page;
            $state.go('role-management.new');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RobotManagementDialogController',RobotManagementDialogController);

    RobotManagementDialogController.$inject = ['$uibModalInstance', 'Pepper', 'MessageService', 'Group', '$timeout', '$rootScope', '$stateParams'];

    function RobotManagementDialogController ($uibModalInstance, Pepper, MessageService, Group, $timeout, $rootScope, $stateParams) {
        var vm = this;

        vm.pepper = {id: null, userId:0, caretreeId: null, caretreePw: null, jigyoushoCd: null, serviceType: null, pepperName: null};
        vm.goups = [];

        vm.clear = clear;
        vm.save = save;
        vm.loadAllGroupsByGroupNm = loadAllGroupsByGroupNm;

        vm.loadAllGroups = loadAllGroups();
        vm.clearGroups = clearGroups;

        vm.groupNm = "";
        
        vm.clickGroupListClick = clickGroupListClick;
        vm.inputGroupNm = inputGroupNm;
        
        vm.loadPepperInfo = loadPepperInfo;

        function loadAllGroups() {
            Group.parentGroup(function(result){
                vm.groups = result;
                if ($stateParams.id != null && $stateParams.id != '') {
                	loadPepperInfo();
                }
            });
        }
        
        function loadPepperInfo() {
        	Pepper.get({id : $stateParams.id}, function(result) {
                if (result != null) {
                    vm.pepper = result;
                    if (vm.pepper.groupId != null && vm.pepper.groupId != '') {
                        vm.pepper.groupId = vm.pepper.groupId.toString();
                    }
                    for (var i = 0; i < vm.groups.length; i++) {
                    	if (vm.pepper.groupId == vm.groups[i].id) {
                    		vm.groupNm = vm.groups[i].name + vm.groups[i].serviceTypeName;
                    	}
                    }
                }
            });
        }

        function loadAllGroupsByGroupNm() {
            Group.parentGroupByGroupNm({groupNm: vm.groupName},function(result){
                vm.groups = result;
                vm.pepper.groupId = result[0].id;
            });
        }

        function clearGroups(){
            vm.groupName = "";
            loadAllGroupsByGroupNm();
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            MessageService.success("robotManagement.message.saveSuccess");
            $uibModalInstance.close(result);
            $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
        }

        function onSaveError () {
            MessageService.error("robotManagement.message.saveError");
            vm.isSaving = false;
        }

        function save () {
            Pepper.check({pepperName : vm.pepper.pepperName, groupId: vm.pepper.groupId},
            function(result){
                if(result.length > 0){
                    if(vm.pepper.id == null){
                        alert("違うなロボート名を登録するください！");
                        return false;
                    } else {
                        if(vm.pepper.id == result[0].id){
                            vm.isSaving = true;
                            if (vm.pepper.id !== null) {
                                Pepper.update(vm.pepper, onSaveSuccess, onSaveError);
                            } else {
                                Pepper.save(vm.pepper, onSaveSuccess, onSaveError);
                            }
                        }else {
                            alert("違うなロボート名を登録するください！");
                            return false;
                        }
                    }

                }else{
                    vm.isSaving = true;
                    if (vm.pepper.id !== null) {
                        Pepper.update(vm.pepper, onSaveSuccess, onSaveError);
                    } else {
                        Pepper.save(vm.pepper, onSaveSuccess, onSaveError);
                    }
                }
            });
        }
        
        function clickGroupListClick(gp) {
        	vm.pepper.groupId = gp.id;
        	vm.groupNm = gp.name + gp.serviceTypeName;
        	vm.groupSelectListShowFlg = false;
        }
        
        function inputGroupNm() {
        	vm.groupSelectListShowFlg = false;
    		vm.pepper.groupId = "";
        	
        	for (var i = 0; i < vm.groups.length; i ++) {
        		if (vm.groupNm != undefined && vm.groupNm != "") {
        			if ((vm.groups[i].name + vm.groups[i].serviceTypeName).indexOf(vm.groupNm) != -1) {
        				vm.groups[i].showFlg = true;
        				vm.groupSelectListShowFlg = true;
        			} else {
        				vm.groups[i].showFlg = false;
        			}
        		} else {
        			vm.parentGroup[i].showFlg = true;
        		}
        	}
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RobotManagementDeleteController', RobotManagementDeleteController);

    RobotManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'group', 'Pepper', 'MessageService', '$timeout', '$rootScope'];

    function RobotManagementDeleteController ($uibModalInstance, entity, group, Pepper, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.pepper = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.groupName = group.groupName;
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (pepperId) {
            Pepper.delete({id: pepperId}, onDelSuccess, onDelError);
        }

        function onDelSuccess() {
            MessageService.success("robotManagement.message.delSuccess");
            $uibModalInstance.close(true);
            $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
        }

        function onDelError() {
            MessageService.error("robotManagement.message.delError");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('robot-management', {
                parent: 'app',
                url: '/robot/robot',
                data: {
                    pageTitle: 'robot-management.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/system/robot-management/robot-management.html',
                        controller: 'RobotManagementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('robot-management');
                        return $translate.refresh();
                    }]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                	var top = $uibModalStack.getTop();
                	if (top) {
                	    $uibModalStack.dismiss(top.key);
                	}
                    Principal.identity().then(function(account) {
                    	if (account != null) {
                    		var gtc_caretree2_robot_allfunction_fullaccess = false;
                        	if (account.functions != null) {
                            	for (var i in account.functions) {
                            		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                            			gtc_caretree2_robot_allfunction_fullaccess = true;
                            		}
                            	}
                            }
                        	if (gtc_caretree2_robot_allfunction_fullaccess == false) {
                        		$state.go('home');
                            	$uibModal.open({
                                    templateUrl: 'app/home/dialog/license.html',
                                    controller: 'HomeLicenseController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg'
                                }).result.then(function() {
                                    $state.go('home', null, { reload: true });
                                }, function() {
                                    $state.go('home');
                                });
                            }
                    	} else {
                    		LoginService.open();
                    	}
                    	
                    });
                }]
            })
            .state('robot-management.new', {
                parent: 'robot-management',
                url: '/new',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
                	Principal.identity().then(function(account) {
                		if (account != null) {
                			var gtc_caretree2_robot_allfunction_fullaccess = false;
                        	if (account.functions != null) {
                            	for (var i in account.functions) {
                            		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                            			gtc_caretree2_robot_allfunction_fullaccess = true;
                            		}
                            	}
                            }
                        	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                            	$uibModal.open({
                                    templateUrl: 'app/system/robot-management/robot-management-dialog.html',
                                    controller: 'RobotManagementDialogController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'md'
                                }).result.then(function() {
                                    $state.go('robot-management', null, { reload: true });
                                }, function() {
                                    $state.go('robot-management');
                                });
                            }
                		} else {
                			LoginService.open();
                		}
                    	
                    });
                }]
            })
            .state('robot-management.edit', {
                parent: 'robot-management',
                url: '/{id}/edit',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
                	Principal.identity().then(function(account) {
                		if (account != null) {
                			var gtc_caretree2_robot_allfunction_fullaccess = false;
                        	if (account.functions != null) {
                            	for (var i in account.functions) {
                            		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                            			gtc_caretree2_robot_allfunction_fullaccess = true;
                            		}
                            	}
                            }
                        	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                            	$uibModal.open({
                                    templateUrl: 'app/system/robot-management/robot-management-dialog.html',
                                    controller: 'RobotManagementDialogController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'md'
                                }).result.then(function() {
                                    $state.go('robot-management', null, { reload: true });
                                }, function() {
                                    $state.go('^');
                                });
                            }
                		} else {
                			LoginService.open();
                		}
                    	
                    });
                }]
            })
            .state('robot-management.delete', {
                parent: 'robot-management',
                url: '/{id}/delete/{groupNm}',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
                	Principal.identity().then(function(account) {
                		if (account != null) {
                			var gtc_caretree2_robot_allfunction_fullaccess = false;
                        	if (account.functions != null) {
                            	for (var i in account.functions) {
                            		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                            			gtc_caretree2_robot_allfunction_fullaccess = true;
                            		}
                            	}
                            }
                        	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                            	$uibModal.open({
                                    templateUrl: 'app/system/robot-management/robot-management-delete-dialog.html',
                                    controller: 'RobotManagementDeleteController',
                                    controllerAs: 'vm',
                                    size: 'md',
                                    resolve: {
                                        entity: ['Pepper', function(Pepper) {
                                            return Pepper.get({id : $stateParams.id});
                                        }],
                                        group: {groupName:$stateParams.groupNm}
                                    }
                                }).result.then(function() {
                                    $state.go('robot-management', null, { reload: true });
                                }, function() {
                                    $state.go('^');
                                });
                            }
                		} else {
                			LoginService.open();
                		}
                    	
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RobotManagementController', RobotManagementController);

    RobotManagementController.$inject = ['Pepper','$rootScope','Group','paginationConstants'];

    function RobotManagementController(Pepper, $rootScope,Group, paginationConstants) {
        var vm = this;

        vm.serviceTypeList = [];
        vm.parentGroup = [];
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.loadAllGroups = loadAllGroups;
        vm.peppers = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.searchData = {pepperName: "", selectGroup: ""};
        vm.defaultSearchData = {pepperName: "", selectGroup: ""};
        vm.loadAll();
        vm.loadParentGroup = loadParentGroup;
        vm.loadParentGroup();
        vm.search = search;
        vm.changeGroup = changeGroup;
        
        vm.clickGroupListClick = clickGroupListClick;
        vm.inputGroupNm = inputGroupNm;

        function loadAllGroups() {
            Group.parentGroup(function(result){
                vm.groups = result;
                for (var j = 0; j < vm.peppers.length; j ++) {
                    for (var i = 0; i < vm.groups.length; i ++) {
                        if (vm.groups[i].id != null && vm.groups[i].id != '' && vm.peppers[j].groupId != null && vm.peppers[j].groupId != '') {
                            if (vm.groups[i].id.toString() == vm.peppers[j].groupId.toString()) {
                                vm.peppers[j].groupName = vm.groups[i].name;
                            }
                        }
                    }
                }
            });
        }

        function loadAll () {
            //获取pepperd的值
            Pepper.query({page: vm.page - 1, size: vm.itemsPerPage, pepperName : vm.searchData.pepperName, groupId : vm.searchData.selectGroup},
                function (result, headers){
                vm.peppers = result;
                vm.totalItems = headers('X-Total-Count');
                vm.groups = result;
                vm.queryCount = vm.totalItems;
                //获取group的值
                vm.loadAllGroups();
            });
            $rootScope.$broadcast('pepperUpdate');
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function changeGroup() {
            search();
        }
        function clear() {
            vm.pepper = {
                id: null, pepperName: null, groupId: null
            };
            vm.searchData = angular.copy(vm.defaultSearchData);
            search();
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }

        function loadParentGroup() {
            Group.parentGroup({}, function(result){
                vm.parentGroup = result;
            });
        }
        
        function clickGroupListClick(gp) {
        	vm.searchData.selectGroup = gp.id;
        	vm.searchData.selectGroupNm = gp.name + gp.serviceTypeName;
        	vm.groupSelectListShowFlg = false;
        }
        
        function inputGroupNm() {
        	vm.groupSelectListShowFlg = false;
        	if (vm.searchData.selectGroupNm != undefined && vm.searchData.selectGroupNm != "") {
        		vm.searchData.selectGroup = "gid0";
        	} else {
        		vm.searchData.selectGroup = "";
        	}
        	
        	for (var i = 0; i < vm.parentGroup.length; i ++) {
        		if (vm.searchData.selectGroupNm != undefined && vm.searchData.selectGroupNm != "") {
        			if ((vm.parentGroup[i].name + vm.parentGroup[i].serviceTypeName).indexOf(vm.searchData.selectGroupNm) != -1) {
        				vm.parentGroup[i].showFlg = true;
        				vm.groupSelectListShowFlg = true;
        			} else {
        				vm.parentGroup[i].showFlg = false;
        			}
        		} else {
        			vm.parentGroup[i].showFlg = true;
        		}
        	}
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('riyousha', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('QrCodeDetailController', QrCodeDetailController);

    QrCodeDetailController.$inject = ['$stateParams', 'QrCode','paginationConstants'];

    function QrCodeDetailController ($stateParams, QrCode,paginationConstants) {

        var vm = this;
        vm.pageCount = 1;
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.libraryList = [];
        vm.before = false;
        vm.load = load;
        vm.riyoushaList = {};
        vm.riyoushaAllList = {};
        vm.load();
        vm.printpage = printpage;
        vm.reload = reload;
        vm.showButtonFlag = false;
        vm.printAll = printAll;
        vm.beforeClick = beforeClick;

        function printAll(){
            var bdhtml=window.document.body.innerHTML;
            document.body.innerHTML=document.getElementById('allRiyousha').innerHTML;
            window.print();
            window.document.body.innerHTML=bdhtml;
        }

        function beforeClick(){
            if(vm.before){
                vm.before = false;
            }else{
                vm.before = true;
            }
            vm.reload();
        }
        function load() {
            QrCode.query({groupId: $stateParams.groupId, page: vm.page - 1, size: paginationConstants.itemsPerPage, beforeFlag: vm.before, qrCodeFlag: true, webFlg: true}, function(result){
                if (result.count != null) {
                    vm.totalItems = result.count;
                    var remainder = vm.totalItems % 20;
                    if(remainder == 0){
                        vm.pageCount = vm.totalItems/20;
                    }else{
                        vm.pageCount = Math.floor(vm.totalItems/20) + 1;
                    }
                    vm.riyoushaList = result.riyousha;
                    vm.riyoushaAllList = result.riyoushaAll;vm.showButtonFlag = true;
                } else {
                    vm.totalItems = 0;
                    vm.riyoushaList = [];
                }
            });
        }

        function printpage(myDiv){
            //var newstr = document.all.item(myDiv).innerHTML;
            var newstr = document.getElementById(myDiv).innerHTML;
            var oldstr = document.body.innerHTML;
            document.body.innerHTML = newstr;
            window.print();//好像这个方法不能执行
            document.body.innerHTML = oldstr;
            return false;
        }

        function reload() {
            load();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('qrcode', {
                parent: 'riyousha',
                url: '/robot/qrcode',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_TIMECARD'],
                    pageTitle: 'riyousha.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/system/riyousha/qrcode/qrcode.html',
                        controller: 'QrCodeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('riyousha');
                        return $translate.refresh();
                    }]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                	var top = $uibModalStack.getTop();
                	if (top) {
                	    $uibModalStack.dismiss(top.key);
                	}
                    Principal.identity().then(function(account) {
                    	if (account != null) {
                    		var gtc_caretree2_robot_allfunction_fullaccess = false;
                        	if (account.functions != null) {
                            	for (var i in account.functions) {
                            		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                            			gtc_caretree2_robot_allfunction_fullaccess = true;
                            		}
                            	}
                            }
                        	if (gtc_caretree2_robot_allfunction_fullaccess == false) {
                        		$state.go('home');
                            	$uibModal.open({
                                    templateUrl: 'app/home/dialog/license.html',
                                    controller: 'HomeLicenseController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg'
                                }).result.then(function() {
                                    $state.go('home', null, { reload: true });
                                }, function() {
                                    $state.go('home');
                                });
                            }
                    	} else {
                    		LoginService.open();
                    	}
                    	
                    });
                }]
            })
            .state('qrcode-detail', {
                parent: 'qrcode',
                url: '/{groupId}/qrcode-detail',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_TIMECARD'],
                    pageTitle: 'riyousha.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/system/riyousha/qrcode/qrcode-detail.html',
                        controller: 'QrCodeDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('riyousha');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('QrCode', QrCode);

    QrCode.$inject = ['$resource'];

    function QrCode ($resource) {
        var service = $resource('api/groups', {}, {
            "query": {
                url: 'api/groups/:groupId/riyousha',
                method: 'GET'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('QrCodeController', QrCodeController);

    QrCodeController.$inject = ['Group', 'Enum', 'paginationConstants', 'ParseLinks', '$rootScope','$state'];

    function QrCodeController(Group, Enum, paginationConstants, ParseLinks, $rootScope,$state) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadJigyoushoServiceTypeList = loadJigyoushoServiceTypeList;
        vm.groups = [];
        vm.serviceTypeList = [];

        vm.totalItems = null;
        vm.page = 1;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.qrCodeShow = qrCodeShow;
        vm.loadAll();
        vm.loadJigyoushoServiceTypeList();

        function loadAll () {
            if($rootScope.groupPage != undefined){
                vm.page = $rootScope.groupPage;
                $rootScope.groupPage = undefined;
            }
            Group.query({page: vm.page - 1, size: vm.itemsPerPage, all: false}, function(result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.groups = result;
                vm.queryCount = vm.totalItems;
            });
        }

        function loadJigyoushoServiceTypeList() {
            Enum.get({name: "JigyoushoServiceTypeFull"},function(result){
                vm.serviceTypeList = result;
            });
        }

        function qrCodeShow(groupId){
            $rootScope.groupPage = vm.page;
            $state.go('qrcode-detail', {groupId: groupId});
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('KeiyakuplanManagementPlansetController',KeiyakuplanManagementPlansetController);

    KeiyakuplanManagementPlansetController.$inject = ['$stateParams', 'param', 'AlertService', '$uibModalInstance', 'Kinou', 'Enum', 'JhiLanguageService','Group', 'MessageService', '$timeout', '$rootScope','OptionUser','Principal', 'Outlets'];

    function KeiyakuplanManagementPlansetController ($stateParams, param, AlertService, $uibModalInstance, Kinou, Enum, JhiLanguageService, Group, MessageService, $timeout, $rootScope, OptionUser, Principal, Outlets) {
        var vm = this;
        vm.clear = clear;
        vm.authority;
        vm.searchAuthority = searchAuthority;
        vm.keiyakuplanList = [];
        vm.permissionList = [];
        vm.save = save;
        vm.loadData = loadData;
        loadData();

        function loadData() {
            Enum.getGateWayTwo({name: 'Permission'}, function(result) {
                vm.permissionList = result;
            });
            Kinou.getKeiyakuplan({kinouId: param.kinouId}, function (result) {
                vm.keiyakuplanList = result;
            });

        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function searchAuthority(){

        }

        function save(){
            var entity = angular.copy(vm.keiyakuplanList);
            Kinou.svaeKeiyakuplan({kinouId: param.kinouId}, entity, function(result){
                MessageService.success("keiyakuplanManagement.home.keiyakuplanSaved");
                $uibModalInstance.close(result);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            },function(error){
                AlertService.error(error.data.message);
                MessageService.error("global.messages.error.save");
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('keiyakuplan-management', {
                parent: 'app',
                url: '/settings/keiyakuplan?page&sort',
                data: {
                	authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER'],
                    pageTitle: 'keiyakuplanManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/system/keiyakuplan-management/keiyakuplan-management.html',
                        controller: 'KeiyakuplanManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('keiyakuplan-management');
                        return $translate.refresh();
                    }]

                }
            })
        .state('keiyakuplan-management.keiyakuplan', {
            parent: 'keiyakuplan-management',
            url: '/keiyakuplan/{kinouId}',
            data: {
            	authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/system/keiyakuplan-management/keiyakuplan-management-planset.html',
                    controller: 'KeiyakuplanManagementPlansetController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        param: {kinouId: $stateParams.kinouId}
                    }
                }).result.then(function() {
                    $state.go('keiyakuplan-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('KeiyakuplanManagementController', KeiyakuplanManagementController);

    KeiyakuplanManagementController.$inject = ['Principal', 'AlertService', '$timeout', 'Enum', 'Kinou', 'ParseLinks', 'MessageService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'Group', '$filter', 'SelectedGroup', '$scope', '$rootScope'];

    function KeiyakuplanManagementController(Principal, AlertService, $timeout, Enum, Kinou, ParseLinks, MessageService, $state, pagingParams, paginationConstants, JhiLanguageService, Group, $filter, SelectedGroup, $scope, $rootScope) {
        var vm = this;
        vm.searchData = {keiyakuplanName: "", keiyakuplanCode: ""};
        vm.defaultSearchData = {keiyakuplanName: "", keiyakuplanCode: ""};
        vm.kinouList = [];
        vm.permissionList = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        //vm.transition = transition;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.loadAll();
        vm.goKeiyakuplan = goKeiyakuplan;

        vm.permission1;
        vm.permission2;
        vm.permission3;
        vm.permission4;
        vm.permission5;
        vm.permission6;
        vm.permission7;
        vm.permission8;
        vm.permission9;

        vm.showFlag1 = false;
        vm.showFlag2 = false;
        vm.showFlag3 = false;
        vm.showFlag4 = false;
        vm.showFlag5 = false;
        vm.showFlag6 = false;
        vm.showFlag7 = false;
        vm.showFlag8 = false;
        vm.showFlag9 = false;

        vm.yikuoShow11 = false;
        vm.yikuoShow12 = false;
        vm.yikuoShow13 = false;
        vm.yikuoShow14 = false;
        vm.yikuoShow21 = false;
        vm.yikuoShow22 = false;
        vm.yikuoShow23 = false;
        vm.yikuoShow24 = false;
        vm.yikuoShow31 = false;
        vm.yikuoShow32 = false;
        vm.yikuoShow33 = false;
        vm.yikuoShow34 = false;
        vm.yikuoShow41 = false;
        vm.yikuoShow42 = false;
        vm.yikuoShow43 = false;
        vm.yikuoShow44 = false;
        vm.yikuoShow51 = false;
        vm.yikuoShow52 = false;
        vm.yikuoShow53 = false;
        vm.yikuoShow54 = false;
        vm.yikuoShow61 = false;
        vm.yikuoShow62 = false;
        vm.yikuoShow63 = false;
        vm.yikuoShow64 = false;
        vm.yikuoShow71 = false;
        vm.yikuoShow72 = false;
        vm.yikuoShow73 = false;
        vm.yikuoShow74 = false;
        vm.yikuoShow81 = false;
        vm.yikuoShow82 = false;
        vm.yikuoShow83 = false;
        vm.yikuoShow84 = false;
        vm.yikuoShow91 = false;
        vm.yikuoShow92 = false;
        vm.yikuoShow93 = false;
        vm.yikuoShow94 = false;
        vm.aClick1 = aClick1;
        vm.aClick2 = aClick2;
        vm.aClick3 = aClick3;
        vm.aClick4 = aClick4;
        vm.aClick5 = aClick5;
        vm.aClick6 = aClick6;
        vm.aClick7 = aClick7;
        vm.aClick8 = aClick8;
        vm.aClick9 = aClick9;

        vm.yikuoaClick1 = yikuoaClick1;
        vm.yikuoaClick2 = yikuoaClick2;
        vm.yikuoaClick3 = yikuoaClick3;
        vm.yikuoaClick4 = yikuoaClick4;
        vm.yikuoaClick5 = yikuoaClick5;
        vm.yikuoaClick6 = yikuoaClick6;
        vm.yikuoaClick7 = yikuoaClick7;
        vm.yikuoaClick8 = yikuoaClick8;
        vm.yikuoaClick9 = yikuoaClick9;

        function aClick1(kinou, value){
            if(value == 1){
                kinou.show11 = true;
                kinou.show12 = false;
                kinou.show13 = false;
                kinou.show14 = false;
            }
            if(value == 2){
                kinou.show11 = false;
                kinou.show12 = true;
                kinou.show13 = false;
                kinou.show14 = false;
            }
            if(value == 3){
                kinou.show11 = false;
                kinou.show12 = false;
                kinou.show13 = true;
                kinou.show14 = false;
            }
            if(value == 4){
                kinou.show11 = false;
                kinou.show12 = false;
                kinou.show13 = false;
                kinou.show14 = true;
            }
            saveSingle(1,kinou);
        }
        function aClick2(kinou, value){
            if(value == 1){
                kinou.show21 = true;
                kinou.show22 = false;
                kinou.show23 = false;
                kinou.show24 = false;
            }
            if(value == 2){
                kinou.show21 = false;
                kinou.show22 = true;
                kinou.show23 = false;
                kinou.show24 = false;
            }
            if(value == 3){
                kinou.show21 = false;
                kinou.show22 = false;
                kinou.show23 = true;
                kinou.show24 = false;
            }
            if(value == 4){
                kinou.show21 = false;
                kinou.show22 = false;
                kinou.show23 = false;
                kinou.show24 = true;
            }
            saveSingle(2,kinou);
        }
        function aClick3(kinou, value){
            if(value == 1){
                kinou.show31 = true;
                kinou.show32 = false;
                kinou.show33 = false;
                kinou.show34 = false;
            }
            if(value == 2){
                kinou.show31 = false;
                kinou.show32 = true;
                kinou.show33 = false;
                kinou.show34 = false;
            }
            if(value == 3){
                kinou.show31 = false;
                kinou.show32 = false;
                kinou.show33 = true;
                kinou.show34 = false;
            }
            if(value == 4){
                kinou.show31 = false;
                kinou.show32 = false;
                kinou.show33 = false;
                kinou.show34 = true;
            }
            saveSingle(3,kinou);
        }
        function aClick4(kinou, value){
            if(value == 1){
                kinou.show41 = true;
                kinou.show42 = false;
                kinou.show43 = false;
                kinou.show44 = false;
            }
            if(value == 2){
                kinou.show41 = false;
                kinou.show42 = true;
                kinou.show43 = false;
                kinou.show44 = false;
            }
            if(value == 3){
                kinou.show41 = false;
                kinou.show42 = false;
                kinou.show43 = true;
                kinou.show44 = false;
            }
            if(value == 4){
                kinou.show41 = false;
                kinou.show42 = false;
                kinou.show43 = false;
                kinou.show44 = true;
            }
            saveSingle(4,kinou);
        }
        function aClick5(kinou, value){
            if(value == 1){
                kinou.show51 = true;
                kinou.show52 = false;
                kinou.show53 = false;
                kinou.show54 = false;
            }
            if(value == 2){
                kinou.show51 = false;
                kinou.show52 = true;
                kinou.show53 = false;
                kinou.show54 = false;
            }
            if(value == 3){
                kinou.show51 = false;
                kinou.show52 = false;
                kinou.show53 = true;
                kinou.show54 = false;
            }
            if(value == 4){
                kinou.show51 = false;
                kinou.show52 = false;
                kinou.show53 = false;
                kinou.show54 = true;
            }
            saveSingle(5,kinou);
        }
        function aClick6(kinou, value){
            if(value == 1){
                kinou.show61 = true;
                kinou.show62 = false;
                kinou.show63 = false;
                kinou.show64 = false;
            }
            if(value == 2){
                kinou.show61 = false;
                kinou.show62 = true;
                kinou.show63 = false;
                kinou.show64 = false;
            }
            if(value == 3){
                kinou.show61 = false;
                kinou.show62 = false;
                kinou.show63 = true;
                kinou.show64 = false;
            }
            if(value == 4){
                kinou.show61 = false;
                kinou.show62 = false;
                kinou.show63 = false;
                kinou.show64 = true;
            }
            saveSingle(6,kinou);
        }
        function aClick7(kinou, value){
            if(value == 1){
                kinou.show71 = true;
                kinou.show72 = false;
                kinou.show73 = false;
                kinou.show74 = false;
            }
            if(value == 2){
                kinou.show71 = false;
                kinou.show72 = true;
                kinou.show73 = false;
                kinou.show74 = false;
            }
            if(value == 3){
                kinou.show71 = false;
                kinou.show72 = false;
                kinou.show73 = true;
                kinou.show74 = false;
            }
            if(value == 4){
                kinou.show71 = false;
                kinou.show72 = false;
                kinou.show73 = false;
                kinou.show74 = true;
            }
            saveSingle(7,kinou);
        }
        function aClick8(kinou, value){
            if(value == 1){
                kinou.show81 = true;
                kinou.show82 = false;
                kinou.show83 = false;
                kinou.show84 = false;
            }
            if(value == 2){
                kinou.show81 = false;
                kinou.show82 = true;
                kinou.show83 = false;
                kinou.show84 = false;
            }
            if(value == 3){
                kinou.show81 = false;
                kinou.show82 = false;
                kinou.show83 = true;
                kinou.show84 = false;
            }
            if(value == 4){
                kinou.show81 = false;
                kinou.show82 = false;
                kinou.show83 = false;
                kinou.show84 = true;
            }
            saveSingle(8,kinou);
        }
        function aClick9(kinou, value){
            if(value == 1){
                kinou.show91 = true;
                kinou.show92 = false;
                kinou.show93 = false;
                kinou.show94 = false;
            }
            if(value == 2){
                kinou.show91 = false;
                kinou.show92 = true;
                kinou.show93 = false;
                kinou.show94 = false;
            }
            if(value == 3){
                kinou.show91 = false;
                kinou.show92 = false;
                kinou.show93 = true;
                kinou.show94 = false;
            }
            if(value == 4){
                kinou.show91 = false;
                kinou.show92 = false;
                kinou.show93 = false;
                kinou.show94 = true;
            }
            saveSingle(9,kinou);
        }

        function yikuoaClick1(value){
            if(value == 1){
                vm.yikuoShow11 = true;
                vm.yikuoShow12 = false;
                vm.yikuoShow13 = false;
                vm.yikuoShow14 = false;
            }
            if(value == 2){
                vm.yikuoShow11 = false;
                vm.yikuoShow12 = true;
                vm.yikuoShow13 = false;
                vm.yikuoShow14 = false;
            }
            if(value == 3){
                vm.yikuoShow11 = false;
                vm.yikuoShow12 = false;
                vm.yikuoShow13 = true;
                vm.yikuoShow14 = false;
            }
            if(value == 4){
                vm.yikuoShow11 = false;
                vm.yikuoShow12 = false;
                vm.yikuoShow13 = false;
                vm.yikuoShow14 = true;
            }

            $.each(vm.kinouList,function(n,kinou) {
                if(value == 1){
                    kinou.show11 = true;
                    kinou.show12 = false;
                    kinou.show13 = false;
                    kinou.show14 = false;
                }
                if(value == 2){
                    kinou.show11 = false;
                    kinou.show12 = true;
                    kinou.show13 = false;
                    kinou.show14 = false;
                }
                if(value == 3){
                    kinou.show11 = false;
                    kinou.show12 = false;
                    kinou.show13 = true;
                    kinou.show14 = false;
                }
                if(value == 4){
                    kinou.show11 = false;
                    kinou.show12 = false;
                    kinou.show13 = false;
                    kinou.show14 = true;
                }
            });
            save(1);
        }
        function yikuoaClick2(value){
            if(value == 1){
                vm.yikuoShow21 = true;
                vm.yikuoShow22 = false;
                vm.yikuoShow23 = false;
                vm.yikuoShow24 = false;
            }
            if(value == 2){
                vm.yikuoShow21 = false;
                vm.yikuoShow22 = true;
                vm.yikuoShow23 = false;
                vm.yikuoShow24 = false;
            }
            if(value == 3){
                vm.yikuoShow21 = false;
                vm.yikuoShow22 = false;
                vm.yikuoShow23 = true;
                vm.yikuoShow24 = false;
            }
            if(value == 4){
                vm.yikuoShow21 = false;
                vm.yikuoShow22 = false;
                vm.yikuoShow23 = false;
                vm.yikuoShow24 = true;
            }

            $.each(vm.kinouList,function(n,kinou) {
                if(value == 1){
                    kinou.show21 = true;
                    kinou.show22 = false;
                    kinou.show23 = false;
                    kinou.show24 = false;
                }
                if(value == 2){
                    kinou.show21 = false;
                    kinou.show22 = true;
                    kinou.show23 = false;
                    kinou.show24 = false;
                }
                if(value == 3){
                    kinou.show21 = false;
                    kinou.show22 = false;
                    kinou.show23 = true;
                    kinou.show24 = false;
                }
                if(value == 4){
                    kinou.show21 = false;
                    kinou.show22 = false;
                    kinou.show23 = false;
                    kinou.show24 = true;
                }
            });
            save(2);
        }
        function yikuoaClick3(value){
            if(value == 1){
                vm.yikuoShow31 = true;
                vm.yikuoShow32 = false;
                vm.yikuoShow33 = false;
                vm.yikuoShow34 = false;
            }
            if(value == 2){
                vm.yikuoShow31 = false;
                vm.yikuoShow32 = true;
                vm.yikuoShow33 = false;
                vm.yikuoShow34 = false;
            }
            if(value == 3){
                vm.yikuoShow31 = false;
                vm.yikuoShow32 = false;
                vm.yikuoShow33 = true;
                vm.yikuoShow34 = false;
            }
            if(value == 4){
                vm.yikuoShow31 = false;
                vm.yikuoShow32 = false;
                vm.yikuoShow33 = false;
                vm.yikuoShow34 = true;
            }

            $.each(vm.kinouList,function(n,kinou) {
                if(value == 1){
                    kinou.show31 = true;
                    kinou.show32 = false;
                    kinou.show33 = false;
                    kinou.show34 = false;
                }
                if(value == 2){
                    kinou.show31 = false;
                    kinou.show32 = true;
                    kinou.show33 = false;
                    kinou.show34 = false;
                }
                if(value == 3){
                    kinou.show31 = false;
                    kinou.show32 = false;
                    kinou.show33 = true;
                    kinou.show34 = false;
                }
                if(value == 4){
                    kinou.show31 = false;
                    kinou.show32 = false;
                    kinou.show33 = false;
                    kinou.show34 = true;
                }
            });
            save(3);
        }
        function yikuoaClick4(value){
            if(value == 1){
                vm.yikuoShow41 = true;
                vm.yikuoShow42 = false;
                vm.yikuoShow43 = false;
                vm.yikuoShow44 = false;
            }
            if(value == 2){
                vm.yikuoShow41 = false;
                vm.yikuoShow42 = true;
                vm.yikuoShow43 = false;
                vm.yikuoShow44 = false;
            }
            if(value == 3){
                vm.yikuoShow41 = false;
                vm.yikuoShow42 = false;
                vm.yikuoShow43 = true;
                vm.yikuoShow44 = false;
            }
            if(value == 4){
                vm.yikuoShow41 = false;
                vm.yikuoShow42 = false;
                vm.yikuoShow43 = false;
                vm.yikuoShow44 = true;
            }

            $.each(vm.kinouList,function(n,kinou) {
                if(value == 1){
                    kinou.show41 = true;
                    kinou.show42 = false;
                    kinou.show43 = false;
                    kinou.show44 = false;
                }
                if(value == 2){
                    kinou.show41 = false;
                    kinou.show42 = true;
                    kinou.show43 = false;
                    kinou.show44 = false;
                }
                if(value == 3){
                    kinou.show41 = false;
                    kinou.show42 = false;
                    kinou.show43 = true;
                    kinou.show44 = false;
                }
                if(value == 4){
                    kinou.show41 = false;
                    kinou.show42 = false;
                    kinou.show43 = false;
                    kinou.show44 = true;
                }
            });
            save(4);
        }
        function yikuoaClick5(value){
            if(value == 1){
                vm.yikuoShow51 = true;
                vm.yikuoShow52 = false;
                vm.yikuoShow53 = false;
                vm.yikuoShow54 = false;
            }
            if(value == 2){
                vm.yikuoShow51 = false;
                vm.yikuoShow52 = true;
                vm.yikuoShow53 = false;
                vm.yikuoShow54 = false;
            }
            if(value == 3){
                vm.yikuoShow51 = false;
                vm.yikuoShow52 = false;
                vm.yikuoShow53 = true;
                vm.yikuoShow54 = false;
            }
            if(value == 4){
                vm.yikuoShow51 = false;
                vm.yikuoShow52 = false;
                vm.yikuoShow53 = false;
                vm.yikuoShow54 = true;
            }

            $.each(vm.kinouList,function(n,kinou) {
                if(value == 1){
                    kinou.show51 = true;
                    kinou.show52 = false;
                    kinou.show53 = false;
                    kinou.show54 = false;
                }
                if(value == 2){
                    kinou.show51 = false;
                    kinou.show52 = true;
                    kinou.show53 = false;
                    kinou.show54 = false;
                }
                if(value == 3){
                    kinou.show51 = false;
                    kinou.show52 = false;
                    kinou.show53 = true;
                    kinou.show54 = false;
                }
                if(value == 4){
                    kinou.show51 = false;
                    kinou.show52 = false;
                    kinou.show53 = false;
                    kinou.show54 = true;
                }
            });
            save(5);
        }
        function yikuoaClick6(value){
            if(value == 1){
                vm.yikuoShow61 = true;
                vm.yikuoShow62 = false;
                vm.yikuoShow63 = false;
                vm.yikuoShow64 = false;
            }
            if(value == 2){
                vm.yikuoShow61 = false;
                vm.yikuoShow62 = true;
                vm.yikuoShow63 = false;
                vm.yikuoShow64 = false;
            }
            if(value == 3){
                vm.yikuoShow61 = false;
                vm.yikuoShow62 = false;
                vm.yikuoShow63 = true;
                vm.yikuoShow64 = false;
            }
            if(value == 4){
                vm.yikuoShow61 = false;
                vm.yikuoShow62 = false;
                vm.yikuoShow63 = false;
                vm.yikuoShow64 = true;
            }

            $.each(vm.kinouList,function(n,kinou) {
                if(value == 1){
                    kinou.show61 = true;
                    kinou.show62 = false;
                    kinou.show63 = false;
                    kinou.show64 = false;
                }
                if(value == 2){
                    kinou.show61 = false;
                    kinou.show62 = true;
                    kinou.show63 = false;
                    kinou.show64 = false;
                }
                if(value == 3){
                    kinou.show61 = false;
                    kinou.show62 = false;
                    kinou.show63 = true;
                    kinou.show64 = false;
                }
                if(value == 4){
                    kinou.show61 = false;
                    kinou.show62 = false;
                    kinou.show63 = false;
                    kinou.show64 = true;
                }
            });
            save(6);
        }
        function yikuoaClick7(value){
            if(value == 1){
                vm.yikuoShow71 = true;
                vm.yikuoShow72 = false;
                vm.yikuoShow73 = false;
                vm.yikuoShow74 = false;
            }
            if(value == 2){
                vm.yikuoShow71 = false;
                vm.yikuoShow72 = true;
                vm.yikuoShow73 = false;
                vm.yikuoShow74 = false;
            }
            if(value == 3){
                vm.yikuoShow71 = false;
                vm.yikuoShow72 = false;
                vm.yikuoShow73 = true;
                vm.yikuoShow74 = false;
            }
            if(value == 4){
                vm.yikuoShow71 = false;
                vm.yikuoShow72 = false;
                vm.yikuoShow73 = false;
                vm.yikuoShow74 = true;
            }

            $.each(vm.kinouList,function(n,kinou) {
                if(value == 1){
                    kinou.show71 = true;
                    kinou.show72 = false;
                    kinou.show73 = false;
                    kinou.show74 = false;
                }
                if(value == 2){
                    kinou.show71 = false;
                    kinou.show72 = true;
                    kinou.show73 = false;
                    kinou.show74 = false;
                }
                if(value == 3){
                    kinou.show71 = false;
                    kinou.show72 = false;
                    kinou.show73 = true;
                    kinou.show74 = false;
                }
                if(value == 4){
                    kinou.show71 = false;
                    kinou.show72 = false;
                    kinou.show73 = false;
                    kinou.show74 = true;
                }
            });
            save(7);
        }
        function yikuoaClick8(value){
            if(value == 1){
                vm.yikuoShow81 = true;
                vm.yikuoShow82 = false;
                vm.yikuoShow83 = false;
                vm.yikuoShow84 = false;
            }
            if(value == 2){
                vm.yikuoShow81 = false;
                vm.yikuoShow82 = true;
                vm.yikuoShow83 = false;
                vm.yikuoShow84 = false;
            }
            if(value == 3){
                vm.yikuoShow81 = false;
                vm.yikuoShow82 = false;
                vm.yikuoShow83 = true;
                vm.yikuoShow84 = false;
            }
            if(value == 4){
                vm.yikuoShow81 = false;
                vm.yikuoShow82 = false;
                vm.yikuoShow83 = false;
                vm.yikuoShow84 = true;
            }

            $.each(vm.kinouList,function(n,kinou) {
                if(value == 1){
                    kinou.show81 = true;
                    kinou.show82 = false;
                    kinou.show83 = false;
                    kinou.show84 = false;
                }
                if(value == 2){
                    kinou.show81 = false;
                    kinou.show82 = true;
                    kinou.show83 = false;
                    kinou.show84 = false;
                }
                if(value == 3){
                    kinou.show81 = false;
                    kinou.show82 = false;
                    kinou.show83 = true;
                    kinou.show84 = false;
                }
                if(value == 4){
                    kinou.show81 = false;
                    kinou.show82 = false;
                    kinou.show83 = false;
                    kinou.show84 = true;
                }
            });
            save(8);
        }
        function yikuoaClick9(value){
            if(value == 1){
                vm.yikuoShow91 = true;
                vm.yikuoShow92 = false;
                vm.yikuoShow93 = false;
                vm.yikuoShow94 = false;
            }
            if(value == 2){
                vm.yikuoShow91 = false;
                vm.yikuoShow92 = true;
                vm.yikuoShow93 = false;
                vm.yikuoShow94 = false;
            }
            if(value == 3){
                vm.yikuoShow91 = false;
                vm.yikuoShow92 = false;
                vm.yikuoShow93 = true;
                vm.yikuoShow94 = false;
            }
            if(value == 4){
                vm.yikuoShow91 = false;
                vm.yikuoShow92 = false;
                vm.yikuoShow93 = false;
                vm.yikuoShow94 = true;
            }

            $.each(vm.kinouList,function(n,kinou) {
                if(value == 1){
                    kinou.show91 = true;
                    kinou.show92 = false;
                    kinou.show93 = false;
                    kinou.show94 = false;
                }
                if(value == 2){
                    kinou.show91 = false;
                    kinou.show92 = true;
                    kinou.show93 = false;
                    kinou.show94 = false;
                }
                if(value == 3){
                    kinou.show91 = false;
                    kinou.show92 = false;
                    kinou.show93 = true;
                    kinou.show94 = false;
                }
                if(value == 4){
                    kinou.show91 = false;
                    kinou.show92 = false;
                    kinou.show93 = false;
                    kinou.show94 = true;
                }
            });
            save(9);
        }
        function loadAll () {
            if($rootScope.page != undefined){
                vm.page = $rootScope.page;
                $rootScope.page = undefined;
            }
            if($rootScope.keiyakuplanName != undefined){
                vm.searchData.keiyakuplanName = $rootScope.keiyakuplanName;
                $rootScope.keiyakuplanName = undefined;
            }
            if($rootScope.keiyakuplanCode != undefined){
                vm.searchData.keiyakuplanCode = $rootScope.keiyakuplanCode;
                $rootScope.keiyakuplanCode = undefined;
            }
            Enum.getGateWayTwo({name: 'Permission'}, function(result) {
                vm.permissionList = result;
            });
            Kinou.queryPlan({
                page: vm.page - 1,
                size: vm.itemsPerPage,
                name: vm.searchData.keiyakuplanName,
                code: vm.searchData.keiyakuplanCode,
                sort: sort()
            }, onSuccess, onError);
        }

        function search(){
            vm.page = 1;
            loadAll();
        }

        function onSuccess(data, headers) {
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.kinouList = data;
            $.each(vm.kinouList,function(n,value) {
                if(value.permission1 == 1){
                    value.show11 = true;
                } else if(value.permission1 == 2){
                    value.show12 = true;
                } else if(value.permission1 == 3){
                    value.show13 = true;
                } else if(value.permission1 == 4){
                    value.show14 = true;
                }

                if(value.permission2 == 1){
                    value.show21 = true;
                } else if(value.permission2 == 2){
                    value.show22 = true;
                } else if(value.permission2 == 3){
                    value.show23 = true;
                } else if(value.permission2 == 4){
                    value.show24 = true;
                }

                if(value.permission3 == 1){
                    value.show31 = true;
                } else if(value.permission3 == 2){
                    value.show32 = true;
                } else if(value.permission3 == 3){
                    value.show33 = true;
                } else if(value.permission3 == 4){
                    value.show34 = true;
                }

                if(value.permission4 == 1){
                    value.show41 = true;
                } else if(value.permission4 == 2){
                    value.show42 = true;
                } else if(value.permission4 == 3){
                    value.show43 = true;
                } else if(value.permission4 == 4){
                    value.show44 = true;
                }

                if(value.permission5 == 1){
                    value.show51 = true;
                } else if(value.permission5 == 2){
                    value.show52 = true;
                } else if(value.permission5 == 3){
                    value.show53 = true;
                } else if(value.permission5 == 4){
                    value.show54 = true;
                }

                if(value.permission6 == 1){
                    value.show61 = true;
                } else if(value.permission6 == 2){
                    value.show62 = true;
                } else if(value.permission6 == 3){
                    value.show63 = true;
                } else if(value.permission6 == 4){
                    value.show64 = true;
                }

                if(value.permission7 == 1){
                    value.show71 = true;
                } else if(value.permission7 == 2){
                    value.show72 = true;
                } else if(value.permission7 == 3){
                    value.show73 = true;
                } else if(value.permission7 == 4){
                    value.show74 = true;
                }

                if(value.permission8 == 1){
                    value.show81 = true;
                } else if(value.permission8 == 2){
                    value.show82 = true;
                } else if(value.permission8 == 3){
                    value.show83 = true;;
                } else if(value.permission8 == 4){
                    value.show84 = true;
                }

                if(value.permission9 == 1){
                    value.show91 = true;
                } else if(value.permission9 == 2){
                    value.show92 = true;
                } else if(value.permission9 == 3){
                    value.show93 = true;
                } else if(value.permission9 == 4){
                    value.show94 = true;
                }
            });
            setTimeout(function() {
                //屏幕高度
                var height = document.documentElement.clientHeight;
                //导航部分的高度
                var navbarHeight = $("#navbarHeight").height();//20
                //检索部分的高度
                var searchHeight = $("#searchHeight").height();//15
                //表头高度
                var headerHeight = $("#headerHeight").height();//
                //分页部分高度
                var pageHeight = $("#pageHeight").height();
                //copyRight
                var copyRight = $("#copyRight").height();
                var tableDivHeight = height-navbarHeight-20-searchHeight-headerHeight-20-pageHeight-10-copyRight-10-40;
                $("#tableDiv").css("max-height",tableDivHeight);
            }, 20);
        }

        function onError(){
        }

        function clear () {
            vm.searchData = angular.copy(vm.defaultSearchData);
            search();
        }

        function loadPage (page) {
            vm.page = page;
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }

        function goKeiyakuplan(kinouId){
            $rootScope.keiyakuplanName = vm.searchData.keiyakuplanName;
            $rootScope.keiyakuplanCode = vm.searchData.keiyakuplanCode;
            $rootScope.page = vm.page;
            $state.go('keiyakuplan-management.keiyakuplan', {kinouId: kinouId});
        }

        function save(planId){
            var entity = angular.copy(vm.kinouList);
            Kinou.svaeKeiyakuplanList({planId: planId}, entity, function(result){
                MessageService.success("keiyakuplanManagement.home.keiyakuplanSaved");
            },function(error){
                AlertService.error(error.data.message);
            });
        }

        function saveSingle(planId, kinou){
            var entity = angular.copy(kinou);
            Kinou.svaeKeiyakuplanSingle({planId: planId}, entity, function(result){
                MessageService.success("keiyakuplanManagement.home.keiyakuplanSaved");
            },function(error){
                AlertService.error(error.data.message);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GroupManagementDialogController',GroupManagementDialogController);

    GroupManagementDialogController.$inject = ['$uibModalInstance', 'entity', 'Group', 'MessageService','Jigyousho', '$timeout', '$rootScope', 'Principal'];

    function GroupManagementDialogController ($uibModalInstance, entity, Group, MessageService, Jigyousho, $timeout, $rootScope, Principal) {
        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.loadAllServiceTypes = loadAllServiceTypes;//新規登録する時に該当スタッフが利用できるサービス一覧を取得
        vm.serviceTypeChanged = serviceTypeChanged;
        vm.loadParentGroup = loadParentGroup;
        vm.group = null;
        vm.parentGroup = [];
        vm.entity = entity;
        vm.allGroupFlags = [];
        vm.groupNameExist = true;

        vm.loadGroup = loadGroup();
        vm.groupNameCheck = groupNameCheck;
        groupNameCheck();

        Principal.hasAuthority('ROLE_ADMIN').then(function(result){
            if(result) {
                vm.isAdmin = true;
            } else {
                vm.isAdmin = false;
            }
        });

        function loadGroup() {
            Group.getAllGroupFlags(function (allGroupFlags) {
                vm.allGroupFlags = allGroupFlags;
                if (entity.id != "" && entity.id != null) {
                    Group.get({id : entity.id}, function(result){
                        vm.group = result;
                        if (vm.group.parentId != null && vm.group.parentId != "") {
                            vm.group.parentId = vm.group.parentId.toString();
                        }
                        vm.loadParentGroup();
                        if (vm.group.jigyoushoId != "" && vm.group.jigyoushoId != null) {
                            vm.loadAllServiceTypes();
                        }
                        for (var i = 0; i < vm.allGroupFlags.length; i ++) {
                            for (var j = 0; j < vm.group.flags.length; j ++) {
                                if (vm.group.flags[j].id == vm.allGroupFlags[i].id) {
                                    vm.allGroupFlags[i].checked = true;
                                }
                            }
                        }
                    });
                } else {
                    vm.group = entity;
                    vm.loadParentGroup();
                    return false;
                }
            });
        }

        function loadAllServiceTypes() {
            Group.selectService(
                {jigyoushoCd:vm.group.jigyoushoCd, caretreeId: vm.group.caretreeId, caretreePw: vm.group.caretreePw},
                function(result){
                    vm.group.serviceList = result;
                    if (vm.group.serviceType != null) {
                        vm.group.serviceType = vm.group.serviceType.toString();
                    }
                });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            MessageService.success("groupManagement.saved");
            $uibModalInstance.close(result);
            $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
        }

        function onSaveError (res) {
            if (res.data) {
                MessageService.error(res.data.message);
            } else {
                MessageService.error("groupManagement.errors.save_error");
            }
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            // 整理flags
            vm.group.flags = [];
            for (var i = 0; i < vm.allGroupFlags.length; i ++) {
                if (vm.allGroupFlags[i].checked) {
                    var flag = {};
                    flag.id = vm.allGroupFlags[i].id;
                    flag.name = vm.allGroupFlags[i].name;
                    vm.group.flags.push(flag);
                }
            }
            vm.group.timecardShiftFlag = vm.group.timecardShiftFlag == 0 ? false : true
            if (vm.group.id != null && vm.group.id != "") {
                vm.group.groupUsers = [];
                Group.update(vm.group, onSaveSuccess, onSaveError);
            } else {
                Group.save(vm.group, onSaveSuccess, onSaveError);
            }
        }

        function serviceTypeChanged() {
            if (vm.group.serviceType != "" && vm.group.serviceType != null) {
                Jigyousho.getJigyousho({jigyoushoCd:vm.group.jigyoushoCd,
                    serviceType:vm.group.serviceType,
                    caretreeId:vm.group.caretreeId,
                    caretreePw:vm.group.caretreePw},function(result){
                    if (result.jigyousho){
                        vm.group.jigyoushoId = result.jigyousho.id;
                        vm.group.caretreeStaffId = result.common.staffId;
                    }
                },function(){
                    $uibModalInstance.close();
                    MessageService.error("groupManagement.message.getNone");
                });
            } else {
                vm.group.jigyoushoId = "";
                vm.group.caretreeStaffId = "";
            }

        }

        function loadParentGroup() {
            if (entity.id === "" || entity.id == null) {
                // 新規
                // 自分管理できるグループを取得
                Group.manageGroup({}, function(result) {
                    setParentGroupList(result)
                });
            } else {
                // 編集
                // 自分管理できるグループを取得、編集するグループをこのグループの子を排除
                Group.parentGroupExceptMyself({groupId: entity.id}, function(result) {
                    setParentGroupList(result)
                })
            }

        }

        function setParentGroupList(result) {
            vm.parentGroup = result;
            if (!vm.isAdmin) {
                if (entity.id === "" || entity.id == null) {
                    if (vm.parentGroup.length > 0) {
                        // デフォルトは第一位のごループ
                        vm.group.parentId = vm.parentGroup[0].id;
                    }
                } else {
                    // 自存の親グループを存在判断、存在する場合、そのままリストを表示、存在しない場合、自存親グループを追加
                    if (vm.group.parentId !== null && vm.group.parentId !== '') {
                        var exist = false
                        vm.parentGroup.forEach(function(item) {
                            if (item.id === vm.group.parentId) {
                                exist = true
                            }
                        })
                        if (!exist) {
                            Group.get({id : vm.group.parentId}, function(parentRes){
                                // 親子関係表示
                                vm.parentGroup.forEach(function(item) {
                                    if (item.name.startsWith("|")) {
                                        item.name = "　　" + item.name
                                    } else {
                                        item.name = "|----" + item.name
                                    }
                                })
                                // 第一位で、自存親グループを追加
                                vm.parentGroup.unshift(parentRes)
                            })
                        }
                    }
                }
            }
        }

        // 查询group名是否存在
        function groupNameCheck() {
            vm.groupNameExist = false
            if (vm.group != null && vm.group.name != undefined && vm.group.name != '') {
                Group.queryGroupName({id: vm.group.id, name: vm.group.name}, function (result) {
                    if (result.length == 0) {
                    	vm.groupNameExist = false;
                    } else {
                        for (var i = 0; i < result.length; i ++) {
                            if ("gid" + result[i].parentId == (vm.group.parentId ? vm.group.parentId : 'gid0')) {
                                vm.groupNameExist = true;
                            }
                        }
                    }
                });
            } else {
            	vm.groupNameExist = false;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GroupManagementDeleteController', GroupManagementDeleteController);

    GroupManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Group', 'MessageService', '$timeout', '$rootScope'];

    function GroupManagementDeleteController ($uibModalInstance, entity, Group, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.group = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.error = false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (groupId) {
            Group.delete({id: groupId},
                function () {
                    MessageService.success("groupManagement.deleted");
                    $uibModalInstance.close(true);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                }, function () {
                    vm.error = true;
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('group-management', {
                parent: 'app',
                url: '/settings/group',
                data: {
                    pageTitle: 'group-management.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/system/group-management/group-management.html',
                        controller: 'GroupManagementController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('group-management');
                        return $translate.refresh();
                    }]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
                    Principal.identity().then(function(account) {
                    	if (account != null) {
	                        var isGroupAdmin = false;

	                        if (account.authorities
	                            && (account.authorities.indexOf("ROLE_ADMIN") !== -1
	                                || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
	                            isGroupAdmin = true;
	                        } else {
	                            account.groupAuthes.forEach(function (element) {
	                                if (element.groupAuth === 'admin') {
	                                    isGroupAdmin = true;
	                                }
	                            });
	                        }
	                        if (!isGroupAdmin) {
	                            $state.go('accessdenied');
	                        }
	                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Authentication_Group_FullAccess"}, function(result){
	                        	if (!result.flag) {
	                        		$state.go('accessdenied');
	                        	}
	                        });
                    	} else {
                            LoginService.open();
                    	}
                    });
                }]
            })
            .state('group-management.new', {
                parent: 'group-management',
                url: '/new',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                    Principal.identity().then(function(account) {
                    	if (account != null) {
	                        var isGroupAdmin = false;
	                        if (account.authorities
	                            && (account.authorities.indexOf("ROLE_ADMIN") !== -1
	                                || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
	                            isGroupAdmin = true;
	                        } else {
	                            account.groupAuthes.forEach(function (element) {
	                                if (element.groupAuth === 'admin') {
	                                    isGroupAdmin = true;
	                                }
	                            });
	                        }
	                        if (isGroupAdmin) {
	                            $uibModal.open({
	                                templateUrl: 'app/system/group-management/group-management-dialog.html',
	                                controller: 'GroupManagementDialogController',
	                                controllerAs: 'vm',
	                                backdrop: 'static',
	                                size: 'lg',
	                                resolve: {
	                                    entity: function () {
	                                        return {
	                                            id: null, userId:0, caretreeId: null, caretreePw: null, jigyoushoCd: null, serviceType: null,
	                                            groupName: null, parentId: ""
	                                        };
	                                    }
	                                }
	                            }).result.then(function() {
	                                $state.go('group-management', null, { reload: true });
	                            }, function() {
	                                $state.go('group-management');
	                            });
	                        }
                    	} else {
                            LoginService.open();
                    	}
                    });
                }]
            })
            .state('group-management.edit', {
                parent: 'group-management',
                url: '/{id}/edit',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                    Principal.identity().then(function(account) {
                    	if (account != null) {
                    		var isGroupAdmin = false;
                            if (account.authorities
                                && (account.authorities.indexOf("ROLE_ADMIN") !== -1
                                    || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                                isGroupAdmin = true;
                            } else {
                                account.groupAuthes.forEach(function (element) {
                                    if (element.groupAuth === 'admin') {
                                        isGroupAdmin = true;
                                    }
                                });
                            }
                            if (isGroupAdmin) {
                                $uibModal.open({
                                    templateUrl: 'app/system/group-management/group-management-dialog.html',
                                    controller: 'GroupManagementDialogController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg',
                                    resolve: {
                                        entity: {id: $stateParams.id}
                                    }
                                }).result.then(function() {
                                    $state.go('group-management', null, { reload: true });
                                }, function() {
                                    $state.go('^');
                                });
                            }
                    	} else {
                    		LoginService.open();
                    	}
                        
                    });
                }]
            })
            .state('group-management.delete', {
                parent: 'group-management',
                url: '/{id}/delete',
                data: {
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                    Principal.identity().then(function(account) {
                    	if (account != null) {
                    		var isGroupAdmin = false;
                            if (account.authorities
                                && (account.authorities.indexOf("ROLE_ADMIN") !== -1
                                    || account.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                                isGroupAdmin = true;
                            } else {
                                account.groupAuthes.forEach(function (element) {
                                    if (element.groupAuth === 'admin') {
                                        isGroupAdmin = true;
                                    }
                                });
                            }
                            if (isGroupAdmin) {
                                $uibModal.open({
                                    templateUrl: 'app/system/group-management/group-management-delete-dialog.html',
                                    controller: 'GroupManagementDeleteController',
                                    controllerAs: 'vm',
                                    size: 'md',
                                    resolve: {
                                        entity: ['Group', function(Group) {
                                            return Group.get({id : $stateParams.id});
                                        }]
                                    }
                                }).result.then(function() {
                                    $state.go('group-management', null, { reload: true });
                                }, function() {
                                    $state.go('^');
                                });
                            }
                    	} else {
                    		LoginService.open();
                    	}
                        
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GroupManagementController', GroupManagementController);

    GroupManagementController.$inject = ['ParseLinks', 'paginationConstants','Group','$rootScope', '$state'];

    function GroupManagementController(ParseLinks, paginationConstants,Group, $rootScope, $state) {
        var vm = this;

        vm.serviceTypeList = [];
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;

        vm.groups = [];

        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.goEdit = goEdit;
        vm.goDel = goDel;
        vm.goNew = goNew;
        
        vm.searchData = {name: "", jigyoushoCd: "", serviceType: ""};
        vm.defaultSearchData = {name: "", jigyoushoCd: "", serviceType: ""};
        vm.search = search	;
        
        vm.loadAll();
        
        function search(){
            vm.page = 1;
            loadAll();
        }

        function loadAll () {
            if($rootScope.page != undefined){
                vm.page = $rootScope.page;
                $rootScope.page = undefined;
            }
            if ($rootScope.searchData != undefined) {
            	vm.searchData = $rootScope.searchData;
            	$rootScope.searchData = undefined;
            }
            Group.query({page: vm.page - 1, size: vm.itemsPerPage, all: false, name: vm.searchData.name, jigyoushoCd: vm.searchData.jigyoushoCd, serviceType: vm.searchData.serviceType},
                onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.groups = data;
            vm.queryCount = vm.totalItems;
            setTimeout(function() {
                //屏幕高度
                var height = document.documentElement.clientHeight;
                //导航部分的高度
                var navbarHeight = $("#navbarHeight").height();//20
                //检索部分的高度
                var searchHeight = $("#searchHeight").height();//15
                //表头高度
                var headerHeight = $("#headerHeight").height();//
                //分页部分高度
                var pageHeight = $("#pageHeight").height();
                //copyRight
                var copyRight = $("#copyRight").height();
                var tableDivHeight = height-navbarHeight-19-searchHeight-headerHeight-20-pageHeight-10-copyRight-10-40;
                $("#tableDiv").css("max-height",tableDivHeight);
            }, 20);
        }

        function onError(){
        }

        function clear () {
        	vm.searchData = angular.copy(vm.defaultSearchData);
            search();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function goEdit(id) {
            $rootScope.page = vm.page;
            $rootScope.searchData = vm.searchData;
            $state.go('group-management.edit', {id: id});
        }

        function goDel(id) {
            $rootScope.page = vm.page;
            $rootScope.searchData = vm.searchData;
            $state.go('group-management.delete', {id: id});
        }

        function goNew() {
            $rootScope.page = vm.page;
            $rootScope.searchData = vm.searchData;
            $state.go('group-management.new');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FunctionManagementDeleteController',FunctionManagementDeleteController);

    FunctionManagementDeleteController.$inject = ['$stateParams', 'entity', '$uibModalInstance', 'Kinou', 'JhiLanguageService','Group', 'MessageService', '$timeout', '$rootScope','OptionUser','Principal', 'Outlets'];

    function FunctionManagementDeleteController ($stateParams, entity, $uibModalInstance, Kinou, JhiLanguageService, Group, MessageService, $timeout, $rootScope, OptionUser, Principal, Outlets) {
        var vm = this;
        vm.clear = clear;
        vm.delete = deleteKinou;
        vm.kinou = entity;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function deleteKinou (id){
            Kinou.deleteKinou({kinouId: id}, function(){
                MessageService.success("functionManagement.kinou.kinouDelete");
                $uibModalInstance.close(true);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FunctionManagementCreateController',FunctionManagementCreateController);

    FunctionManagementCreateController.$inject = ['$stateParams', 'param', 'AlertService', '$uibModalInstance', 'Kinou', 'JhiLanguageService','Group', 'MessageService', '$timeout', '$rootScope','OptionUser','Principal', 'Outlets'];

    function FunctionManagementCreateController ($stateParams, param, AlertService, $uibModalInstance, Kinou, JhiLanguageService, Group, MessageService, $timeout, $rootScope, OptionUser, Principal, Outlets) {
        var vm = this;
        vm.clear = clear;
        vm.authority;
        vm.searchAuthority = searchAuthority;
        vm.kinou = {id: "", code: "", name: ""};
        vm.save = save;
        vm.loadData = loadData;
        loadData();

        function loadData() {
            if (param.kinouId != null && param.kinouId != '') {
                Kinou.getKinou({kinouId: param.kinouId}, function (result) {
                    vm.kinou.id = result.id;
                    vm.kinou.code = result.code;
                    vm.kinou.name = result.name;
                });
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function searchAuthority(){
            var container = $('#aDiv');
            var scrollTo = $("input[name='" + vm.authority+ "']");
            container.animate({
                scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()
            });
        }

        function save(){
            var entity = angular.copy(vm.kinou);
            if(entity.id == ''){
                Kinou.createKinou(entity, function(result){
                    MessageService.success("functionManagement.kinou.kinouSaved");
                    $uibModalInstance.close(result);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                },function(error){
                    AlertService.error(error.data.message);
                    MessageService.error("global.messages.error.save");
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                });
            }else{
                Kinou.updateKinou(entity, function(result){
                    MessageService.success("functionManagement.kinou.kinouSaved");
                    $uibModalInstance.close(result);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                },function(error){
                    AlertService.error(error.data.message);
                    MessageService.error("global.messages.error.save");
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('function-management', {
                parent: 'app',
                url: '/settings/function?page&sort',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER'],
                    pageTitle: 'functionManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/system/function-management/function-management.html',
                        controller: 'FunctionManagementController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('function-management');
                        return $translate.refresh();
                    }]

                }
            })
            .state('function-management.new', {
                parent: 'function-management',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/system/function-management/function-management-create.html',
                        controller: 'FunctionManagementCreateController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            param: {code: $stateParams.code}
                        }
                    }).result.then(function() {
                        $state.go('function-management', null, { reload: true });
                    }, function() {
                        $state.go('function-management');
                    });
                }]
            })
            .state('function-management.edit', {
                parent: 'function-management',
                url: '/edit/{kinouId}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/system/function-management/function-management-create.html',
                        controller: 'FunctionManagementCreateController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            param: {kinouId: $stateParams.kinouId}
                        }
                    }).result.then(function() {
                        $state.go('function-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('function-management.delete', {
                parent: 'function-management',
                url: '/delete/{kinouId}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_DEVELOPER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/system/function-management/function-management-delete.html',
                        controller: 'FunctionManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Kinou', function(Kinou) {
                                return Kinou.getDelete({kinouId : $stateParams.kinouId});
                            }]
                        }
                    }).result.then(function() {
                        $state.go('function-management', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('FunctionManagementController', FunctionManagementController);

    FunctionManagementController.$inject = ['Principal', 'Enum', 'Kinou', 'ParseLinks', 'MessageService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'Group', '$filter', 'SelectedGroup', '$scope', '$rootScope'];

    function FunctionManagementController(Principal, Enum, Kinou, ParseLinks, MessageService, $state, pagingParams, paginationConstants, JhiLanguageService, Group, $filter, SelectedGroup, $scope, $rootScope) {
        var vm = this;
        vm.searchData = {kinouName: "", kinouCode: ""};
        vm.defaultSearchData = {kinouName: "", kinouCode: ""};
        vm.kinouList = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.loadAll();
        vm.goEdit = goEdit;
        vm.goDel = goDel;
        vm.goNew = goNew;

        function loadAll () {
            if($rootScope.page != undefined){
                vm.page = $rootScope.page;
                $rootScope.page = undefined;
            }
            if($rootScope.kinouName != undefined){
                vm.searchData.kinouName = $rootScope.kinouName;
                $rootScope.kinouName = undefined;
            }
            if($rootScope.kinouCode != undefined){
                vm.searchData.kinouCode = $rootScope.kinouCode;
                $rootScope.kinouCode = undefined;
            }
            Kinou.query({
                page: vm.page - 1,
                size: vm.itemsPerPage,
                name: vm.searchData.kinouName,
                code: vm.searchData.kinouCode,
                sort: sort()
            }, onSuccess, onError);
        }

        function search(){
            vm.page = 1;
            loadAll();
        }

        function onSuccess(data, headers) {
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.kinouList = data;
            setTimeout(function() {
                //屏幕高度
                var height = document.documentElement.clientHeight;
                //导航部分的高度
                var navbarHeight = $("#navbarHeight").height();//20
                //检索部分的高度
                var searchHeight = $("#searchHeight").height();//15
                //表头高度
                var headerHeight = $("#headerHeight").height();//
                //分页部分高度
                var pageHeight = $("#pageHeight").height();
                //copyRight
                var copyRight = $("#copyRight").height();
                var tableDivHeight = height-navbarHeight-19-searchHeight-headerHeight-20-pageHeight-10-copyRight-10-40;
                $("#tableDiv").css("max-height",tableDivHeight);
            }, 20);
        }

        function onError(){
        }

        function clear () {
            vm.searchData = angular.copy(vm.defaultSearchData);
            search();
        }

        function loadPage (page) {
            vm.page = page;
            //vm.transition();
        }

        function transition () {

        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            return result;
        }

        function goEdit(kinouId) {
            $rootScope.kinouName = vm.searchData.kinouName;
            $rootScope.kinouCode = vm.searchData.kinouCode;
            $rootScope.page = vm.page;
            $state.go('function-management.edit', {kinouId: kinouId});
        }

        function goDel(kinouId) {
            $rootScope.kinouName = vm.searchData.kinouName;
            $rootScope.kinouCode = vm.searchData.kinouCode;
            $rootScope.page = vm.page;
            $state.go('function-management.delete', {kinouId: kinouId});
        }

        function goNew() {
            $rootScope.kinouName = vm.searchData.kinouName;
            $rootScope.kinouCode = vm.searchData.kinouCode;
            $rootScope.page = vm.page;
            $state.go('function-management.new');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CategoryEditDialogController', CategoryEditDialogController);

    CategoryEditDialogController.$inject = ['$uibModalInstance', 'entity', 'Category', 'JhiLanguageService', 'Enum', 'MessageService', '$timeout', '$rootScope'];

    function CategoryEditDialogController ($uibModalInstance, entity, Category, JhiLanguageService, Enum, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.clear = clear;
        vm.save = save;

        vm.languages = null;
        vm.category = entity;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            MessageService.success("global.messages.info.save");
            $uibModalInstance.close(result);
            $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
        }

        function onSaveError() {
            MessageService.error("global.messages.error.save");
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (vm.category.id !== null) {
                Category.update(vm.category, onSaveSuccess, onSaveError);
            } else {
                Category.save(vm.category, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CategoryDeleteController', CategoryDeleteController);

    CategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Category', 'MessageService', '$timeout', '$rootScope'];

    function CategoryDeleteController ($uibModalInstance, entity, Category, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.category = entity;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete(id) {
            Category.delete({id: id}, function () {
                MessageService.success("global.messages.info.delete");
                $uibModalInstance.close(true);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('category', {
            parent: 'system',
            url: '/robot/category',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.category'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/category/category.html',
                    controller: 'CategoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('category');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                		var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess == false) {
                    		$state.go('home');
                        	$uibModal.open({
                                templateUrl: 'app/home/dialog/license.html',
                                controller: 'HomeLicenseController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg'
                            }).result.then(function() {
                                $state.go('home', null, { reload: true });
                            }, function() {
                                $state.go('home');
                            });
                        }
                	} else {
                		LoginService.open();
                	}
                	
                });
            }]
        })
            .state('new', {
                parent: 'category',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
                	Principal.identity().then(function(account) {
                		if (account != null) {
                			var gtc_caretree2_robot_allfunction_fullaccess = false;
                        	if (account.functions != null) {
                            	for (var i in account.functions) {
                            		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                            			gtc_caretree2_robot_allfunction_fullaccess = true;
                            		}
                            	}
                            }
                        	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                            	$uibModal.open({
                                    templateUrl: 'app/system/category/category-edit-dialog.html',
                                    controller: 'CategoryEditDialogController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg',
                                    resolve: {
                                        entity: function () {
                                            return {id: null, categoryType: null, categoryValue: null};
                                        }
                                    }
                                }).result.then(function() {
                                    $state.go('category', null, { reload: true });
                                }, function() {
                                    $state.go('category');
                                });
                            }
                		} else {
                			LoginService.open();
                		}
                    	
                    });
                }]
            })
            .state('edit', {
                parent: 'category',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
                	Principal.identity().then(function(account) {
                		if (account != null) {
                			var gtc_caretree2_robot_allfunction_fullaccess = false;
                        	if (account.functions != null) {
                            	for (var i in account.functions) {
                            		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                            			gtc_caretree2_robot_allfunction_fullaccess = true;
                            		}
                            	}
                            }
                        	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                            	$uibModal.open({
                                    templateUrl: 'app/system/category/category-edit-dialog.html',
                                    controller: 'CategoryEditDialogController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg',
                                    resolve: {
                                        entity: ['Category', function(Category) {
                                            return Category.get({id: $stateParams.id});
                                        }]
                                    }
                                }).result.then(function() {
                                    $state.go('category', null, {reload: true});
                                }, function() {
                                    $state.go('category');
                                });
                            }
                		} else {
                			LoginService.open();
                		}
                    	
                    });
                }]
            })
            .state('delete', {
                parent: 'category',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', 'LoginService', function($stateParams, $state, $uibModal, Principal, LoginService) {
                	Principal.identity().then(function(account) {
                		if (account != null) {
                			var gtc_caretree2_robot_allfunction_fullaccess = false;
                        	if (account.functions != null) {
                            	for (var i in account.functions) {
                            		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                            			gtc_caretree2_robot_allfunction_fullaccess = true;
                            		}
                            	}
                            }
                        	if (gtc_caretree2_robot_allfunction_fullaccess != false) {
                            	$uibModal.open({
                                    templateUrl: 'app/system/category/category-delete-dialog.html',
                                    controller: 'CategoryDeleteController',
                                    controllerAs: 'vm',
                                    size: 'md',
                                    resolve: {
                                        entity: ['Category', function(Category) {
                                            return Category.get({id: $stateParams.id});
                                        }]
                                    }
                                }).result.then(function() {
                                    $state.go('category', null, { reload: true });
                                }, function() {
                                    $state.go('^');
                                });
                            }
                		} else {
                			LoginService.open();
                		}
                    	
                    });
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Category', Category);

    Category.$inject = ['$resource'];

    function Category ($resource) {
        var service = $resource('robot/api/category', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'robot/api/categories/page'
            },
            'save': {
                method: 'POST'
            },
            'get': {
                method: 'GET',
                url: 'robot/api/category/:id'
            },
            'update': {
                method: 'PUT'
            },
            'delete': {
                method: 'DELETE',
                url: 'robot/api/category/:id'
            },
            'list': {
                method: 'GET',
                isArray: true,
                url: 'robot/api/categories'
            },
            'allList': {
                method: 'GET',
                isArray: true,
                url: 'robot/api/categories/all'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CategoryController', CategoryController);

    CategoryController.$inject = ['ParseLinks', 'paginationConstants', 'Category', 'Enum'];

    function CategoryController (ParseLinks, paginationConstants, Category, Enum) {
        var vm = this;

        vm.loadAllCategory = loadAllCategory;

        vm.categories = [];
        vm.categoryTypes = [];

        vm.loadAllCategory();

        function loadAllCategory() {
            Category.query({page: vm.page - 1, size: paginationConstants.itemsPerPage}, function(result, headers){
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.categories = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin-daily', {
            parent: 'system',
            url: '/robot/admin-daily',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.daily'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/admin-daily/admin-daily.html',
                    controller: 'AdminDailyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('daily');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                		var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess == false) {
                    		$state.go('home');
                        	$uibModal.open({
                                templateUrl: 'app/home/dialog/license.html',
                                controller: 'HomeLicenseController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg'
                            }).result.then(function() {
                                $state.go('home', null, { reload: true });
                            }, function() {
                                $state.go('home');
                            });
                        }
                	} else {
                		LoginService.open();
                	}
                	
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AdminDailyController', AdminDailyController);

    AdminDailyController.$inject = ['Setting', '$scope', 'SelectedPepper', 'MessageService'];

    function AdminDailyController (Setting, $scope, SelectedPepper, MessageService) {
        var vm = this;

        vm.datas = {pepperId: null, pepperSettingList: []};
        vm.repeats = [{code: 1, value: "毎年"}, {code: 2, value: "毎月"}, {code: 3, value: "毎週"}];
        vm.index = null;
        vm.pepper = SelectedPepper.current();

        vm.loadPepperSettings = loadPepperSettings;
        vm.add = add;
        vm.del = del;
        vm.save = save;
        vm.cancel = cancel;
        vm.changeDays = changeDays;

        vm.loadPepperSettings();

        $scope.$on('pepperChanged', function() {
            vm.pepper = SelectedPepper.current();
            loadPepperSettings();
        });

        function loadPepperSettings() {
            Setting.query({pepperId: vm.pepper.id, type: 4}, function(result) {
                vm.datas.pepperSettingList = result;
            });
        }

        function add() {
            var pepperSetting = {id: null, pepperId: null, variableType: 6, itemName: null, variableName: null, variableValue: null, repeatType: 1, sampleText: null,
                pepperSettingMonthly: {id: null, day1: null, day2: null, day3: null, day4: null, day5: null, day6: null, day7: null,
                    day8: null, day9: null, day10: null, day11: null, day12: null, day13: null, day14: null,
                    day15: null, day16: null, day17: null, day18: null, day19: null, day20: null, day21: null,
                    day22: null, day23: null, day24: null, day25: null, day26: null, day27: null, day28: null,
                    day29: null, day30: null, day31: null},
                pepperSettingWeekly: {id: null, day1: null, day2: null, day3: null, day4: null, day5: null, day6: null, day7: null},
                selected: false};
            vm.datas.pepperSettingList.push(pepperSetting);
            vm.changeDays(vm.datas.pepperSettingList.length - 1);
        }

        function del(index) {
            vm.datas.pepperSettingList.splice(index, 1);
        }

        function save() {
            vm.isSaving = true;
            vm.datas.pepperId = vm.pepper.id;
            vm.datas.type = 4;
            Setting.save(vm.datas, onSaveSuccess, onSaveError);
        }

        function cancel() {
            vm.loadPepperSettings();
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            vm.loadPepperSettings();
            MessageService.success("daily.home.success");
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("daily.home.error");
        }

        function changeDays(index) {
            vm.index = index;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin-base', {
            parent: 'system',
            url: '/robot/admin-base',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.setting.base'
            },
            views: {
                'content@': {
                    templateUrl: 'app/system/admin-base/admin-base.html',
                    controller: 'AdminBaseController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('base');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                		var gtc_caretree2_robot_allfunction_fullaccess = false;
                    	if (account.functions != null) {
                        	for (var i in account.functions) {
                        		if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                        			gtc_caretree2_robot_allfunction_fullaccess = true;
                        		}
                        	}
                        }
                    	if (gtc_caretree2_robot_allfunction_fullaccess == false) {
                    		$state.go('home');
                        	$uibModal.open({
                                templateUrl: 'app/home/dialog/license.html',
                                controller: 'HomeLicenseController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg'
                            }).result.then(function() {
                                $state.go('home', null, { reload: true });
                            }, function() {
                                $state.go('home');
                            });
                        }
                	} else {
                		LoginService.open();
                	}
                	
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AdminBaseController', AdminBaseController);

    AdminBaseController.$inject = ['Setting', '$scope', 'SelectedPepper', 'MessageService'];

    function AdminBaseController (Setting, $scope, SelectedPepper, MessageService) {
        var vm = this;

        vm.datas = {pepperId: null, pepperSettingList: []};

        vm.pepper = SelectedPepper.current();
        vm.success = null;

        vm.loadPepperSettings = loadPepperSettings;
        vm.add = add;
        vm.del = del;
        vm.save = save;
        vm.cancel = cancel;

        vm.loadPepperSettings();

        $scope.$on('pepperChanged', function() {
            vm.pepper = SelectedPepper.current();
            loadPepperSettings();
        });

        function loadPepperSettings() {
            Setting.query({pepperId: vm.pepper.id, type: 3}, function(result) {
                vm.datas.pepperSettingList = result;
                // if (vm.datas.pepperSettingList.length == 0) {
                //     vm.add();
                // }
            });
        }

        function add() {
            var pepperSetting = {id: null, pepperId: null, variableType: 5, itemName: null, variableName: null, variableValue: null, repeatType: 1, sampleText: null};
            vm.datas.pepperSettingList.push(pepperSetting);
        }

        function del(index) {
            vm.datas.pepperSettingList.splice(index, 1);
            // if (vm.datas.pepperSettingList.length == 0) {
            //     vm.add();
            // }
        }

        function save() {
            vm.isSaving = true;
            vm.datas.pepperId = vm.pepper.id;
            vm.datas.type = 3;
            Setting.save(vm.datas, onSaveSuccess, onSaveError);
        }

        function cancel() {
            vm.loadPepperSettings();
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            vm.loadPepperSettings();
            MessageService.success("base.home.success");
        }

        function onSaveError() {
            vm.isSaving = false;
            MessageService.error("base.home.error");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('UserToken', UserToken);

    UserToken.$inject = ['$resource'];

    function UserToken ($resource) {
        var service = $resource('api/userToken/:login', {}, {
            'query': {
                method: 'GET',
                url: 'api/usersToken'
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', url: 'api/users', isArray: true},
            'queryAllByGroupId': {method: 'GET', url: 'api/usersAllByGroupId', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'uploadPhoto': {
                method:'PUT',
                url: 'api/users/photo'
            },
            'delete':{ method:'DELETE'},
            'all': {
                method: 'GET',
                url: 'api/users/all',
                isArray: true
            },
            'check': {
                method: 'POST',
                url: 'api/users/check'
            },
            'auth': {
                method: 'GET',
                url: 'api/users/auth',
                isArray: true
            },
            'getStaffs': {
                method: 'GET',
                url: 'api/users/staffs',
                isArray: true
            },
            'saveAll': {
                method: 'POST',
                url: 'api/users/saveAll',
                isArray: true
            },
            'getPhoto': {
                method:'GET',
                url: 'api/users/photo',
                isArray: true
            },
            'queryAll':{
                method:'GET',
                url: 'api/users/updateAll',
                isArray: true
            },
            'updateAll':{
                method: 'POST',
                url: 'api/users/updateAll'
            },
            'printAll': {
                method: 'POST',
                url: 'api/users/printAll'
            },
            'getRole': {
                method: 'GET',
                url: 'api/users/roleList',
                isArray: true
            },
            'getSelectRole': {
                method: 'GET',
                url: 'api/users/selectRoleList',
                isArray: true
            },
            'queryLogin': {method: 'GET', url: 'api/:login/existLogin'},
            'queryEmail': {method: 'GET', url: 'api/:email/existEmail'},
            'queryUserOne': {method: 'GET', url: 'api/:id/queryUser'},
            'queryUserGroup': {
                method: 'GET',
                url: 'api/users/:userId/userGroup'
            },
            'queryUserOption': {
                method: 'GET',
                url: 'timecard/api/userOption/:userId/houmonTimeCard'
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Uploader', Uploader);

    Uploader.$inject = ['$resource'];

    function Uploader ($resource) {
        var service = $resource('library/api/upload', {}, {
            "query": {
                method: 'GET',
                isArray: true
            },
            "upload":{
                method: 'POST',
                url: "library/api/upload/photo"
            },
            "changePublishType": {
                method: "PUT"
            },
            "del": {
                method: "DELETE",
                url: "library/api/upload/id/:id"
            },
            "get": {
                method: "GET",
                url: "library/api/upload/id/:id"
            },
            "delByName": {
                method: "DELETE",
                url: "library/api/upload/movementDel/:name"
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('TokenService', TokenService);

    TokenService.$inject = ['$resource'];

    function TokenService ($resource) {
        var service = $resource('api/apitoken', {}, {
            'shopList': {
                method: 'GET',
                isArray: true,
                url: 'api/apitoken/shopList'
            },
            'loginShop': {
                method: 'GET',
                url: 'api/apitoken/loginShop'
            },
            'tokenList': {
                method: 'GET',
                isArray: true,
                url: 'api/apitoken/tokenList'
            },
            'save': {
                method: 'POST'
            },
            'del': {
                method: 'DELETE'
            },
            'get': {
                method: 'GET'
            },
            'createToken': {
                method: 'POST',
                url: 'api/token'
            },
            'updateToken': {
                method: 'PUT',
                url: 'api/token'
            },
            'deleteToken': {
                method: 'DELETE',
                url: 'api/deleteToken'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('StroageService', StorageService);

    StorageService.$inject = ['$resource'];

    function StorageService ($resource) {
        var service = $resource('caretree/api/storages', {}, {
            'query': {
                method: 'GET',
                url: 'caretree/api/storage/list',
                isArray: true
            },
            'houjinList': {
                method: 'GET',
                url: 'caretree/api/storages/houjin/:id'
            },
            'deletePicture': {
                method: 'POST',
                url: 'caretree/api/storages/houjin'
            },
            'mailStop': {
                method: 'PUT',
                url: 'caretree/api/storages/houjin'
            },
            'sendMail': {
                method: 'PUT',
                url: 'caretree/api/storages/sendMail'
            },
            'storageByHoujinId':{
                method: 'GET',
                url: 'caretree/api/storages/storage/:id'
            },
            'storageUpdateTime':{
                method: 'GET',
                url: 'caretree/api/storages/storageUpdateTime/:id'
            },
            'insertStorage': {
                method: 'PUT',
                url: 'caretree/api/storages/insertStorage'
            },
            'updateStorageTotalSize': {
                method: 'PUT',
                url: 'caretree/api/storages/updateStorageTotalSize'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('StaffService', StaffService);

    StaffService.$inject = ['$resource'];

    function StaffService ($resource) {
        var service = $resource('api/staff', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/staff'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Setting', Setting);

    Setting.$inject = ['$resource'];

    function Setting ($resource) {
        var service = $resource('robot/api/setting', {}, {
            "query": {
                method: 'GET',
                isArray: true,
                url: 'robot/api/settings/pepperId/:pepperId/type/:type'
            },
            "save": {
                method: "POST"
            },
            "system": {
                method: 'GET',
                isArray: true,
                url: 'robot/api/settings/type/:type'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ScriptCategory', ScriptCategory);

    ScriptCategory.$inject = ['$resource'];

    function ScriptCategory ($resource) {
        var service = $resource('robot/api/variable/:scriptId', {}, {
            "query": {
                method: 'GET',
                isArray: true,
                url:'robot/api/variableList/:itemType'
            },
            "save": {
                method: "POST"
            },
            "delete": {
                method: "DELETE"
            },
            "get": {
                method: "GET"
            }
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Role', Role);

    Role.$inject = ['$resource'];

    function Role ($resource) {
        var service = $resource('api/role', {}, {
            'query': {method: 'GET', url: 'api/role', isArray: true},
            'getFunction': {method: 'GET', url: 'api/role/kinou', isArray: true},
            'createRole': {method: 'POST',url: 'api/role'},
            'updateRole': {method: 'PUT',url: 'api/role'},
            'getRole': {method: 'GET', url: 'api/:code/role'},
            'deleteRole': {method: 'DELETE', url: 'api/:code/role'},
            'getFunctionByRole': {method: 'GET', url: 'api/:functionCode/getFunctionByRole'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ProductType', ProductType);

    ProductType.$inject = ['$resource'];

    function ProductType ($resource) {
        var service = $resource('api/productType', {}, {
            'query': {
                method: 'GET',
                url: 'api/productType/list',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'delete': {
                method: 'DELETE'
            },
            'checkRepeat': {
                method: 'GET',
                url: 'api/productType/repeat'
            },
            'list': {
                method: 'GET',
                url: 'api/productType/all',
                isArray: true
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Product', Product);

    Product.$inject = ['$resource'];

    function Product ($resource) {
        var service = $resource('api/product', {}, {
            'query': {
                method: 'GET',
                url: 'api/product/list',
                isArray: true
            },
            'queryDialog': {
                method: 'GET',
                url: 'api/product/listDialog',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'delete': {
                method: 'DELETE'
            },
            'getProductType': {
                method: 'GET',
                url: 'api/product/productType'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Price', Price);

    Price.$inject = ['$resource'];

    function Price ($resource) {
        var service = $resource('api/price', {}, {
            'query': {
                method: 'GET',
                url: 'api/price/list',
                isArray: true
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'delete': {
                method: 'DELETE'
            },
            'getByProductId': {
                method: 'GET',
                url: 'api/price/productId/:productId'
            }
        });

        return service;
    }

})();

(function (){
    'use strict';
    angular.module('gatewayApp')
        .directive('formatPrice', formatPrice);
    formatPrice.$inject = ['$parse'];

    function formatPrice($parse){
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return linkFunc;

        function linkFunc(scope, element, attrs){
            function limit(){
                var limitV=element[0].value;
                limitV=limitV.replace(/[^0-9.]/g,"");
                element[0].value=limitV;
                $parse(attrs['ngModel']).assign(scope, limitV);
                format();
            }

            //对输入数字的整数部分插入千位分隔符
            function format(){
                var formatV=element[0].value;
                var array=new Array();
                array=formatV.split(".");
                var re=/(-?\d+)(\d{3})/;
                while(re.test(array[0])){
                    array[0]=array[0].replace(re,"$1,$2")
                }
                var returnV=array[0];
                for(var i=1;i<array.length;i++){
                    returnV+="."+array[i];
                }
                element[0].value=returnV;
                $parse(attrs['ngModel']).assign(scope, formatV);
            }

            scope.$watch(attrs.ngModel,function(){
                limit();
            })

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('PepperSetting', PepperSetting);

    PepperSetting.$inject = ['$resource'];

    function PepperSetting ($resource) {
        var service = $resource('robot/api/pepper-settings', {}, {
            "query": {
                method: 'GET',
                isArray: true,
                url: 'robot/api/pepper-settings/pepperId/:pepperId/type/:type'
            },
            "copy": {
                method: 'POST',
                url: 'robot/api/pepper-settings/copy/dto',
            },
            "save": {
                method: "POST",
                url: 'robot/api/pepper-settings/dto'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('SelectedPepper', SelectedPepper);

    SelectedPepper.$inject = ['$localStorage','Principal'];

    function SelectedPepper ($localStorage, Principal) {

        var service = {
            setCurrent: setCurrent,
            setPepperList: setPepperList,
            current: current,
            pepperList: pepperList

        };

        return service;

        function setCurrent(pepper) {
            $localStorage.pepper = pepper;
        }

        function setPepperList(list) {
            $localStorage.pepperList = list;
        }

        function current() {
            if (Principal.isAuthenticated()) {
                return $localStorage.pepper;
            }
        }

        function pepperList() {
            if (Principal.isAuthenticated()) {
                return $localStorage.pepperList;
            }
            return [];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('SelectedGroup', SelectedGroup);

    SelectedGroup.$inject = ['$localStorage','Principal'];

    function SelectedGroup ($localStorage, Principal) {

        var service = {
            setCurrent: setCurrent,
            setGroupList: setGroupList,
            current: current,
            groupList: groupList

        };

        return service;

        function setCurrent(group) {
            $localStorage.group = group;
        }

        function setGroupList(list) {
            $localStorage.groupList = list;
        }

        function current() {
            if (Principal.isAuthenticated()) {
                return $localStorage.group;
            }
        }

        function groupList() {
            if (Principal.isAuthenticated()) {
                return $localStorage.groupList;
            }
            return [];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Pepper', Pepper);

    Pepper.$inject = ['$resource'];

    function Pepper ($resource) {
        var service = $resource('robot/api/pepper', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'robot/api/peppers'
            },
            'check': {
                method: 'GET',
                isArray: true,
                url: 'robot/api/checkPeppers'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method:'PUT'
            },
            'get': {
                method: 'GET',
                url: 'robot/api/pepper/:id'
            },
            'selectService': {
                method: 'POST',
                isArray: true,
                url:'robot/api/pepper/services'
            },
            'delete': {
                method:'DELETE',
                url: 'robot/api/pepper/:id'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Jigyousho', Jigyousho);

    Jigyousho.$inject = ['$resource'];

    function Jigyousho ($resource) {
        var service = $resource('api/groups/jigyousho', {}, {
            'getJigyousho':{
                method: 'POST'
            },
            'idList': {
                method: 'GET',
                isArray: true
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Outlets', Outlets);

    Outlets.$inject = ['$resource'];

    function Outlets ($resource) {
        var service = $resource('api/outlets', {}, {
            'save': {
                method: 'POST'
            },
            'delete': {
                method: 'DELETE'
            },
            'getByUserId': {
                method: 'GET',
                url: 'api/outlets/getByUserId'
            },
            'query': {
                method: 'GET',
                url: 'api/outlets/list',
                isArray: true
            },
            'get': {
                method: 'GET'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('LicenseService', LicenseService);

    LicenseService.$inject = ['$resource'];

    function LicenseService ($resource) {
        var service = $resource('api/license', {}, {
            'query': {
                method: 'GET',
                url: 'api/license/list',
                isArray: true
            },
            'save': {
                method: 'POST'
            },
            'get': {
                method: 'GET'
            },
            'delete': {
                method: 'DELETE'
            },
            'queryUser': {
                method: 'GET',
                url: 'api/license/userList',
                isArray: true
            },
            'getUserLicense': {
                method: 'GET',
                url: 'api/license/userLicense',
                isArray: true
            },
            'getUserInfo': {
                method: 'GET',
                url: 'api/license/userInfo'
            },
            'setUserLicense': {
                method: 'POST',
                url: 'api/license/userLicense'
            },
            'userLicenseSum': {
                method: 'GET',
                url: 'api/license/userLicenseSum',
                isArray: true
            },
            "queryStaff": {
                method: 'GET',
                url: 'api/license/staffList',
                isArray: true
            },
            'queryStaffManager': {
                method: 'GET',
                url: 'api/license/staffManagerList',
                isArray: true
            },
            'houjinLicenseSum': {
                method: 'GET',
                url: 'api/license/houjinLicenseSum',
                isArray: true
            },
            'houjinLicenseSumByJigyousho': {
                method: 'GET',
                url: 'api/license/houjinLicenseSumByJigyousho',
                isArray: true
            },
            'getStaffInfo': {
                method: 'GET',
                url: 'api/license/staffInfo'
            },
            'getStaffLicense': {
                method: 'GET',
                url: 'api/license/staffLicense',
                isArray: true
            },
            'queryShopLicense': {
                method: 'GET',
                url: 'api/license/shopLicense',
                isArray: true
            },
            'caretreeLink': {
                method: 'GET',
                url: 'api/license/caretreeLink'
            },
            'checkLicense': {
                method: 'GET',
                url: 'api/license/checkLicense'
            }
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Kinou', Kinou);

    Kinou.$inject = ['$resource'];

    function Kinou($resource) {
        var service = $resource('api/kinou', {}, {
            'query': {method: 'GET', url: 'api/kinou', isArray: true},
            'queryPlan': {method: 'GET', url: 'api/kinouPlan', isArray: true},
            'createKinou': {method: 'POST',url: 'api/kinou'},
            'getKinou': {method: 'GET', url: 'api/kinou/:kinouId'},
            'getDelete': {method: 'GET', url: 'api/kinou/:kinouId',
                    transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }},
            'updateKinou': {method: 'PUT',url: 'api/kinou'},
            'deleteKinou': {method: 'DELETE', url: 'api/kinou/:kinouId'},
            'getKeiyakuplan': {method: 'GET', url: 'api/kinou/keiyakuplan/:kinouId', isArray: true},
            'getKeiyakuplanByLicense': {method: 'GET', url: 'api/kinou/keiyakuplanlicense', isArray: true},
            'svaeKeiyakuplan': {method: 'POST',url: 'api/kinou/keiyakuplan/:kinouId', isArray: true},
            'svaeKeiyakuplanList': {method: 'POST',url: 'api/kinou/keiyakuplanList/:planId', isArray: true},
            'svaeKeiyakuplanSingle': {method: 'POST',url: 'api/kinou/keiyakuplanSingle/:planId', isArray: true},
            'getAuthorityFunction': {method: 'GET',url: 'api/kinou/:roleName/:functionCd/getAuthorityFunction'},
            'isLoginRoleHasFunctions': {
            	method: 'GET',
            	url: 'api/kinou/isLoginRoleHasFunctions'
            },
            'isLoginRole': {
                method: 'GET',
                url: 'api/kinou/isLoginRole'
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('JigyoushoResourceService', JigyoushoResourceService);

    JigyoushoResourceService.$inject = ['$resource'];

    function JigyoushoResourceService ($resource) {
        var service = $resource('api/jigyousho', {}, {
            'jigyoushoList': {
                method: 'GET',
                url: 'api/jigyousho/jigyoushoList',
                isArray: true
            },
            'serviceTypeList': {
                method: 'GET',
                url: 'api/jigyousho/serviceTypeList',
                isArray: true
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Houjin', Houjin);

    Houjin.$inject = ['$resource'];

    function Houjin ($resource) {

        var service = $resource('api/houjin', {}, {
            'query': {
                method: 'GET',
                url: 'api/houjin/list',
                isArray: true
            },
            'get': {
                method: 'GET',
                url: 'api/houjin/one'
            },
            'getList': {
            	method: 'GET',
            	isArray: true
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Group', Group);

    Group.$inject = ['$resource'];

    function Group ($resource) {
        var service = $resource('api/groups', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/groups/private'
            },
            'queryUserGroups': {
                method: 'GET',
                isArray: true,
                url: 'api/groups/user/private',
                params: {"api" : "false"}
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method:'PUT'
            },
            'get': {
                method: 'GET',
                url: 'api/groups/edit/:id'
            },
            'caretree': {
                method:'GET',
                url: 'api/groups/caretreeInfo/:groupId'
            },
            'selectService': {
                method: 'POST',
                isArray: true,
                url:'api/groups/services'
            },
            'delete': {
                method:'DELETE',
                url: 'api/groups/:id'
            },
            'parentGroup': {
                method: 'GET',
                isArray: true,
                url: 'api/groups/parentGroup'
            },
            'manageGroup': {
                method: 'GET',
                isArray: true,
                url: 'api/groups/manageGroup'
            },
            'parentGroupExceptMyself': {
                method: 'GET',
                isArray: true,
                url: 'api/groups/parentGroupExceptMyself'
            },
            'parentGroupByGroupNm': {
                method: 'GET',
                isArray: true,
                url: 'api/groups/parentGroupByGroupNm'
            },
            'groupList': {
                method: 'GET',
                isArray: true,
                url: 'api/groups/user'
            },
            'riyoushaList': {
                method: 'GET',
                isArray: true,
                url:'caretree/api/groups/:groupId/customers'
            },
            'subGroupIdList': {
                method: 'GET',
                isArray: true,
                url: 'api/groups/subgroup'
            },
            'queryDialog': {
                method: 'GET',
                url: 'api/groups/selectList',
                isArray: true
            },
            'getAllGroupFlags': {
                method: 'GET',
                url: 'api/groups/allGroupFlags',
                isArray: true
            },
            'queryGroupName': {
            	method: 'GET',
            	url: 'api/groups/queryGroupName',
            	isArray: true
            },
            'queryParentGroupId': {
                method: 'GET',
                url: 'api/groups/queryParentGroupId'
            },
            'queryChildrenList': {
                method: 'GET',
                url: 'api/groups/queryChildrenList'
            },
            'parentGroupList': {
                method: 'GET',
                isArray: true,
                url: 'api/groups/parentGroupList'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Enum', Enum);

    Enum.$inject = ['$resource'];

    function Enum ($resource) {
        var service = $resource('robot/api/enum', {}, {
            'get': {
                method: 'GET',
                isArray: true,
                url: 'robot/api/enum/name/:name'
            },
            'getGateWay': {
                method: 'GET',
                isArray: true,
                url: 'api/enum/name/:name'
            },
            'getGateWayTwo': {
                method: 'GET',
                isArray: true,
                url: 'api/enum/twoName/:name'
            },
            'getLibrary': {
                method: 'GET',
                isArray: true,
                url: 'library/api/enum/name/:name'
            },
            'getTimeCard': {
                method: 'GET',
                isArray: true,
                url: 'timecard/api/enum/:name'
            },
            'getTimeCard2': {
                method: 'GET',
                isArray: true,
                url: 'timecard/api/enum2/:name'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Comment', Comment);

    Comment.$inject = ['$resource'];

    function Comment ($resource) {
        var service = $resource('api/comment', {}, {
           'save': {
                method: 'POST',
                isArray: true,
            },
            'commentList': {
                method: 'GET',
                isArray: true,
                url: 'api/commentlist/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore'
            },
            'commentlistShow': {
                method: 'GET',
                isArray: true,
                url: 'api/commentlistShow/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore'
            },
            'user': {
                method: 'GET',
                url: 'api/user'
            },
            "del": {
                method: "DELETE",
                url: "library/api/upload/id/:id"
            },
            "getPhotoList": {
                method: 'GET',
                isArray: true,
                url: 'library/api/getPhotoList/:riyoushaId/:startDt/:endDt/:groupId'
            },
            "getFileList": {
                method: 'GET',
                isArray: true,
                url: 'library/api/getFileList/:riyoushaId/:startDt/:endDt/:groupId'
            },
            "getFileListPublic": {
                method: 'GET',
                isArray: true,
                url: 'library/api/getFileListPublic/:riyoushaId/:startDt/:endDt/:groupId'
            },
            "getPhotoListPublic": {
                method: 'GET',
                isArray: true,
                url: 'library/api/getPhotoListPublic/:riyoushaId/:startDt/:endDt/:groupId'
            },
            "photoList": {
                method: 'GET',
                isArray: true,
                url: 'library/api/photoList/:riyoushaId/:uploadDate/:jisshiDtBefore'
            },
            'delete': {
                method:'DELETE',
                url: 'api/deletecomment/:id'
            },
            'get': {
                method: 'GET',
                url: 'api/editcomment/:id'
            },
            'update': {
                method:'PUT'
            },
            'updatePublishType': {
                method:'PUT',
                url: 'api/publiccomment'
            }
        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Collection', Collection);

    Collection.$inject = ['$resource'];

    function Collection ($resource) {
        var service = $resource('robot/api/collection', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'robot/api/collections/pepperId/:pepperId'
            },
            'save': {
                method:'POST'
            },
            'delete':{
                method:'DELETE',
                url:'robot/api/collection/pepperId/:pepperId/scriptId/:scriptId'
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('AuthResource', AuthResource);

    AuthResource.$inject = ['$resource'];

    function AuthResource ($resource) {
        var service = $resource('api/auth', {}, {
            'hasCaretreeAccount': {
                method: 'GET',
                url: 'api/auth/hasCaretreeAccount'
            }
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {
            'query': {method: 'GET', url: 'api/:loginId/register'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _staffIdentity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            hasFunction: hasFunction,
            hasGroupAuth: hasGroupAuth,
            hasEditAuth: hasEditAuth,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            isStaffManager: isStaffManager,
            staffIdentity: staffIdentity
        };

        return service;

        function authenticate (identity, staffIdentity) {
            _identity = identity;
            _staffIdentity = staffIdentity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        // 用户是否包含指定机能权限
        function hasFunction(func) {

        	if (!_authenticated) {
                return $q.when(false);
            }
            return this.identity().then(function(_id) {
                return _id.functions && _id.functions.indexOf(func) !== -1;
            }, function(){
                return false;
            });
        }

        //用户所属组权限判定
        function hasGroupAuth (auth) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                if (!_id.groupAuthes) return false;

                if (_id.authorities
                    && (_id.authorities.indexOf("ROLE_ADMIN") !== -1
                    || _id.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                    return true;
                }
                var result = false;
                _id.groupAuthes.forEach(function (element) {
                    auth.forEach(function (au) {
                        if (element.groupAuth === au) {
                            result = true;
                            return result;
                        }
                    });
                });
                return result;
            }, function(){
                return false;
            });
        }
        
        // 用户是否有查看设定管理的权限判定
        function hasEditAuth () {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                

                if (_id.authorities
                    && (_id.authorities.indexOf("ROLE_ADMIN") !== -1
                    || _id.authorities.indexOf("ROLE_DEVELOPER") !== -1)) {
                    return true;
                }
                if (!_id.groupAuthes) return false;
                var result = false;
                _id.groupAuthes.forEach(function (element) {
                    if (element.groupAuth === 'admin') {
                        result = true;
                        return result;
                    }
                });
                return result;
            }, function(){
                return false;
            });
        }

        function identity (force) {

            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }

        // 用户是否有staff管理权限
        function isStaffManager() {
            if (!_authenticated) {
                return $q.when(false);
            }
            return this.staffIdentity().then(function(_id){
                return _id.staffManager;
            }, function(){
                return false;
            });
        }

        function staffIdentity(force) {

            var deferred = $q.defer();

            if (force === true) {
                _staffIdentity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_staffIdentity)) {
                deferred.resolve(_staffIdentity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.staffManager().$promise
                .then(getStaffThen)
                .catch(getStaffCatch);

            return deferred.promise;

            function getStaffThen (staff) {
                _staffIdentity = staff;
                _authenticated = true;
                deferred.resolve(_staffIdentity);
            }

            function getStaffCatch () {
                _staffIdentity = null;
                _authenticated = false;
                deferred.resolve(_staffIdentity);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('isStaffManager', isStaffManager);

    isStaffManager.$inject = ['Principal'];

    function isStaffManager(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.isStaffManager()
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            defineVisibility(true);

            scope.$watch(function() {
                return Principal.isAuthenticated();
            }, function() {
                defineVisibility(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('hasGroupAuth', hasGroupAuth);

    hasGroupAuth.$inject = ['Principal'];

    function hasGroupAuth(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasGroupAuth.replace(/\s+/g, '').split(",");

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasGroupAuth(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('hasFunction', hasFunction);

    hasFunction.$inject = ['Principal'];

    function hasFunction(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
        	
            var func = attrs.hasFunction.replace(/\s+/g, '');
            
            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                	
                    if (reset) {
                        setVisible();
                    }
                    
                    Principal.hasFunction(func)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (func.length > 0) {
            	
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('hasEditAuth', hasEditAuth);

    hasEditAuth.$inject = ['Principal'];

    function hasEditAuth(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }
                    
                    Principal.hasEditAuth()
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            defineVisibility(true);

            scope.$watch(function() {
                return Principal.isAuthenticated();
            }, function() {
                defineVisibility(true);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('downloadFile', downloadFile);

    downloadFile.$inject = ['$http'];

    function downloadFile($http) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attr) {
            var ele = $(element);
            ele.on('click', function (e) {
                ele.prop('disabled', true);
                e.preventDefault();
                $http({
                    url: attr.downloadFile,
                    method: 'get',
                    responseType: 'arraybuffer'
                }).success(function (data, status, headers) {
                    ele.prop('disabled', false);
                    var type;
                    switch (attr.downFileType) {
                        case 'xlsx':
                            type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                            break;
                    }
                    if (!type) throw '无效类型';
                    saveAs(new Blob([data], { type: type }), decodeURI(headers()["content-disposition"]).replace("attachment;filename=",""));  // 中文乱码
                }).error(function (data, status) {
                    alert(data);
                    ele.prop('disabled', false);
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    //登录完成后转到子系统选择页面
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        if (account.langKey == undefined || account.langKey == null || account.langKey == '') {
                            account.langKey = 'ja';
                        }
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            },
            'staffManager': {
                method: 'GET',
                url: 'api/account/recognize_staff_manager',
                isArray: false
            }
        });

        return service;
    }
})();

(function(){
    'use strict';
    angular
        .module('gatewayApp')
        .factory('Analyze', Analyze);
    Analyze.$inject = ['$resource'];
    function Analyze($resource) {
        var service = $resource('api/analyze', {}, {
                'getTemperature':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/temperatureList/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore'
                },
                'getActiveState':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/activeStateList/:riyoushaId/:jigyoushoId/:jisshiDt'
                },
                'getPulse':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/pulseList/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore'
                },
                'getActivity':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/activityList/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore'
                },
                'getBloodPressure':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/bloodPressureList/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore'
                },
                'getGetUp':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/getUpList/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore/:type'
                },
                'getSleep':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/sleepList/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore/:type'
                },
                'getSpo2':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/spo2List/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore/:type'
                },
                'getDiet':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/dietList/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore'
                },
                'getWeight':{
                    method: 'GET',
                    isArray: true,
                    url: 'caretree/api/weightList/:riyoushaId/:jigyoushoId/:jisshiDt/:jisshiDtBefore'
                },
                'getRiyoushaNameAndJigyoushoName':{
                    method: 'GET',
                    url: 'caretree/api/getRiyoushaNameAndJigyoushoName/:riyoushaId'
                },
                'getGroups': {
                    method: 'GET',
                    isArray: true,
                    url: 'api//analyze/groups'
                }
        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('license-shop', {
            parent: 'app',
            url: '/settings/outlet/license',
            data: {
                authorities: ['ROLE_PARTNER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/partner/license/license-shop.html',
                    controller: 'LicenseShopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('license');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseShopController', LicenseShopController);

    LicenseShopController.$inject = ['paginationConstants', 'LicenseService'];

    function LicenseShopController (paginationConstants, LicenseService) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 结果列表
        vm.licenseList = [];
        // 统计列表（待完善，计划用来统计贩卖店自己商品的贩卖情况，但是目前贩卖店和商品的信息没有绑定）
        vm.licenseCountList = [];
        // 查询条件
        vm.searchData = {productName: ""};
        vm.defaultSearchData = {productName: ""};

        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;

        // 加载完成之后自动执行
        loadData();

        function loadData() {
            LicenseService.queryShopLicense({
                page: vm.page - 1,
                productName: vm.searchData.productName
            }, function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.licenseList = result;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('NoLicenseController', NoLicenseController);

    NoLicenseController.$inject = ['$translate', 'LicenseService'];

    function NoLicenseController($translate, LicenseService) {
        var vm = this;
        //$translate.instant();
        // 主页地址
        vm.caretreeLink = "";
        // 获取主页地址
        LicenseService.caretreeLink(function(result){
            vm.caretreeLink = result.homePage;
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('noLicense', {
            parent: 'app',
            url: '/no-license',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/message/no-license.html',
                    controller: 'NoLicenseController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //$translatePartialLoader.addPart('corporation');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('shop', {
            parent: 'app',
            url: '/shop',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/master/shop/shop.html',
                    controller: 'ShopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //$translatePartialLoader.addPart('corporation');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShopController', ShopController);

    ShopController.$inject = [];

    function ShopController () {

        var vm = this;

        // 贩卖店列表
        vm.shopList = [];

        // 初始加载数据
        vm.loadData = loadData();

        // 删除指定贩卖店
        vm.remove = remove;

        function loadData() {
            var shop1 = {shopId: '1', shopNm: '販売店１', tel: '99-9999-9999', fax: '99-9999-9999', managerDuty: '', managerNm: ''};
            var shop2 = {shopId: '2', shopNm: '販売店２', tel: '99-9999-9999', fax: '99-9999-9999', managerDuty: '', managerNm: ''};
            vm.shopList.push(shop1);
            vm.shopList.push(shop2);
        }

        function remove(index) {
            vm.shopList.splice(index, 1);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShopSelectDialogController', ShopSelectDialogController);

    ShopSelectDialogController.$inject = ['paginationConstants', 'Outlets', '$uibModalInstance'];

    function ShopSelectDialogController (paginationConstants, Outlets, $uibModalInstance) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 贩卖店列表
        vm.shopList = [];

        // 查询条件
        vm.searchData = {id: "", name: "", person: ""};
        vm.defaultSearchData = {id: "", name: "", person: ""};

        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 选择指定
        vm.select = select;
        // 关闭dialog
        vm.close = close;

        loadData();

        function loadData() {
            Outlets.query({
                page: vm.page - 1,
                id: vm.searchData.id,
                name: vm.searchData.name,
                person: vm.searchData.person}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.shopList = result;
                vm.queryCount = vm.totalItems;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function select(selected) {
            $uibModalInstance.close(selected);
        }

        function close() {
            $uibModalInstance.close("");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('shop.edit', {
            parent: 'shop',
            url: '/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/master/shop/dialog/shop-edit-dialog.html',
                    controller: 'ShopEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md'
                }).result.then(function() {
                    $state.go('shop', null, { reload: true });
                }, function() {
                    $state.go('shop');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ShopEditDialogController', ShopEditDialogController);

    ShopEditDialogController.$inject = ['$uibModalInstance'];

    function ShopEditDialogController ($uibModalInstance) {

        var vm = this;

        // 贩卖店
        vm.shop = {};

        // 初始加载数据
        vm.loadData = loadData();

        // 关闭dialog
        vm.clear = clear;

        function loadData() {
            vm.product = {
                shopId: '',
                shopNm: '',
                tel: '',
                fax: '',
                managerDuty: '',
                managerNm: ''
            };
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('productType', {
            parent: 'app',
            url: '/settings/productType',
            data: {
                pageTitle: 'productType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/master/productType/productType.html',
                    controller: 'ProductTypeController',
                    controllerAs: 'vm'
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Role', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Role, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_License_Product_FullAccess"}, function(result){
	                        	if (!result.flag) {
	                        		$state.go('accessdenied');
	                        	}
	                        });
                        } else {
                            LoginService.open();
                        }
                    });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productType');
                    return $translate.refresh();
                }]
            }
        }).state('productType.edit', {
            parent: 'productType',
            url: '/edit/{id}',
            data: {

            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/master/productType/dialog/productType-edit-dialog.html',
                    controller: 'ProductTypeEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        param: {id: $stateParams.id}
                    }
                }).result.then(function() {
                    $state.go('productType', null, { reload: true });
                }, function() {
                    $state.go('productType');
                });
            }]
        }).state('productType.delete', {
            parent: 'productType',
            url: '/delete/{id}',
            data: {

            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/master/productType/dialog/productType-delete-dialog.html',
                    controller: 'ProductTypeDeleteDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductType', function(ProductType) {
                            return ProductType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('productType', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ProductTypeController', ProductTypeController);

    ProductTypeController.$inject = ['paginationConstants', 'ProductType', 'MessageService', '$rootScope', '$state'];

    function ProductTypeController (paginationConstants, ProductType, MessageService, $rootScope, $state) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 查询条件
        vm.searchData = {"name": "","id": ""};
        vm.defaultSearchData = {"name": "","id": ""};

        // 商品种类列表
        vm.productTypeList = [];

        // 获取数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 初始加载数据
        loadData();
        vm.goEdit = goEdit;
        vm.goDel = goDel;
        vm.goNew = goNew;

        // 删除指定商品种类
        vm.remove = remove;

        function loadData() {
            if($rootScope.page != undefined){
                vm.page = $rootScope.page;
                $rootScope.page = undefined;
            }
            if($rootScope.id != undefined){
                vm.searchData.id = $rootScope.id;
                $rootScope.id = undefined;
            }
            if($rootScope.name != undefined){
                vm.searchData.name = $rootScope.name;
                $rootScope.name = undefined;
            }

            ProductType.query({
                page: vm.page - 1,
                name: vm.searchData.name,
                id: vm.searchData.id}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.productTypeList = result;
                vm.queryCount = vm.totalItems;
                setTimeout(function() {
                    //屏幕高度
                    var height = document.documentElement.clientHeight;
                    //导航部分的高度
                    var navbarHeight = $("#navbarHeight").height();//20
                    //检索部分的高度
                    var searchHeight = $("#searchHeight").height();//15
                    //表头高度
                    var headerHeight = $("#headerHeight").height();//
                    //分页部分高度
                    var pageHeight = $("#pageHeight").height();
                    //copyRight
                    var copyRight = $("#copyRight").height();
                    var tableDivHeight = height-navbarHeight-19-searchHeight-headerHeight-20-pageHeight-10-copyRight-10-40;
                    $("#tableDiv").css("max-height",tableDivHeight);
                }, 20);
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function remove(id) {
            if(confirm('削除してもよろしいですか?')) {
                ProductType.delete({id: id}, function(){
                    search();
                    MessageService.success("productType.message.deleted");
                    $rootScope.$broadcast('messageChanged');
                });
            }
        }

        function goEdit(id) {
            $rootScope.id = vm.searchData.id;
            $rootScope.name = vm.searchData.name;
            $rootScope.page = vm.page;
            $state.go('productType.edit', {id: id});
        }

        function goDel(id) {
            $rootScope.id = vm.searchData.id;
            $rootScope.name = vm.searchData.name;
            $rootScope.page = vm.page;
            $state.go('productType.delete', {id: id});
        }

        function goNew() {
            $rootScope.page = vm.page;
            $state.go('productType.edit');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ProductTypeEditDialogController', ProductTypeEditDialogController);

    ProductTypeEditDialogController.$inject = ['$uibModalInstance', 'Role', 'ProductType', 'param', 'MessageService', '$timeout', '$rootScope'];

    function ProductTypeEditDialogController ($uibModalInstance, Role, ProductType, param, MessageService, $timeout, $rootScope) {

        var vm = this;

        // 商品贩卖类型
        vm.types = [
            {"id": 1, "value": "アカウントライセンス"},
            {"id": 2, "value": "プロダクトライセンス"}
        ];

        // 製品种类
        vm.productType = {id: '', name: '', licenseType: 1, kinouList: "", resultList: ""};

        vm.searchAuthority = searchAuthority;

        vm.functionCheck = functionCheck;

        // 初始加载数据
        vm.loadData = loadData;

        loadData();

        // 关闭dialog
        vm.close = close;

        // 保存数据
        vm.save = save;

        function loadData() {
            if (param.id != null && param.id != '') {
                ProductType.get({id: param.id}, function(result){
                    vm.productType= result;
                   /* vm.productType.name = result.name;
                    vm.productType.licenseType = result.licenseType;
                    vm.productType.kinouList = result.kinouList;*/
                    vm.productType.resultList = result.kinouList;
                    //functionCheck();
                });
            }else {
                getFunction();
                vm.productType.licenseType = 2;
            }
        }

        function close () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.productType.licenseType = 2;
            ProductType.save(vm.productType, function(result){
                MessageService.success("productType.message.saved");
                $uibModalInstance.close(result);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }

        function searchAuthority(){
            /*var container = $('#aDiv');
            var scrollTo = $("input[name='" + vm.authority+ "']");
            if(vm.authority == ""){
                container.animate({
                    scrollTop: 0
                });
            }else{
                container.animate({
                    scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop() - 10
                });
            }*/
            vm.productType.kinouList = vm.productType.resultList;
            console.log(vm.productType.kinouList);
            console.log(vm.productType.resultList);
            if(vm.authority != "" && vm.authority != null){
                angular.forEach(vm.productType.kinouList,function(data,index,array){
                    if(!data.name.match(vm.authority)){
                        data.showFlag = false;
                    }else{
                        data.showFlag = true;
                    }
                });
            }else{
                angular.forEach(vm.productType.kinouList,function(data,index,array){
                    data.showFlag = true;
                });
            }
        }

        function getFunction() {
            Role.getFunction({}, function (data){
                vm.productType.kinouList = data;
                vm.productType.resultList = data;
            });
        }

        function functionCheck (){
            vm.productType.kinouList.sort(function (a,b){
                if(b.checked == a.checked){
                    return a.id - b.id;
                }
                return b.checked - a.checked;
            });
            var container = $('#aDiv');
            var scrollTo = $("input[name='" + vm.authority+ "']");
            container.animate({
                scrollTop: 0
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ProductTypeDeleteDialogController', ProductTypeDeleteDialogController);

    ProductTypeDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'ProductType', 'MessageService', '$timeout', '$rootScope'];

    function ProductTypeDeleteDialogController ($uibModalInstance, entity, ProductType, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.productType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.error = false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProductType.delete({id: id}, function() {
                MessageService.success("productType.message.deleted");
                $uibModalInstance.close(true);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            }, function () {
                vm.error = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('product', {
            parent: 'app',
            url: '/settings/product',
            data: {
                pageTitle: 'product.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/master/product/product.html',
                    controller: 'ProductController',
                    controllerAs: 'vm'
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Role', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Role, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_License_Product_FullAccess"}, function(result){
	                        	if (!result.flag) {
	                        		$state.go('accessdenied');
	                        	}
	                        });
                        } else {
                            LoginService.open();
                        }
                    });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    return $translate.refresh();
                }]
            }
        }).state('product.edit', {
            parent: 'product',
            url: '/edit/{id}',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Principal', '$uibModalStack', function($stateParams, $state, $uibModal, Principal, $uibModalStack) {
                $uibModal.open({
                    templateUrl: 'app/master/product/dialog/product-edit-dialog.html',
                    controller: 'ProductEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        param: {id: $stateParams.id}
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('product');
                });
            }]
        }).state('product.delete', {
            parent: 'product',
            url: '/delete/{id}',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Principal', '$uibModalStack', function($stateParams, $state, $uibModal,Principal,$uibModalStack) {
                $uibModal.open({
                    templateUrl: 'app/master/product/dialog/product-delete-dialog.html',
                    controller: 'ProductDeleteDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id});
                        }],
                        productTypeEntity: ['Product', function(Product) {
                            return Product.getProductType({productId: $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['paginationConstants', 'Product', 'ProductType', 'MessageService', '$rootScope', '$state'];

    function ProductController (paginationConstants, Product, ProductType, MessageService, $rootScope, $state) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 製品列表
        vm.productList = [];
        // 查询条件
        vm.searchData = {"id": "", "name": "", "kind": 0};
        vm.defaultSearchData = {"id": "", "name": "", "kind": 0};
        // 商品种类
        vm.productTypeList = [];

        // 初始加载数据
        vm.loadData = loadData;
        // 清空搜索条件
        vm.clear = clear;
        // 点击查询
        vm.search = search;
        // 删除指定商品
        vm.remove = remove;
        // 获取商品种类列表
        vm.loadKindList = loadKindList;

        loadData();
        loadKindList();
        vm.goEdit = goEdit;
        vm.goDel = goDel;

        function loadData() {
            if($rootScope.page != undefined){
                vm.page = $rootScope.page;
                $rootScope.page = undefined;
            }
            if($rootScope.id != undefined){
                vm.searchData.id = $rootScope.id;
                $rootScope.id = undefined;
            }
            if($rootScope.name != undefined){
                vm.searchData.name = $rootScope.name;
                $rootScope.name = undefined;
            }
            if($rootScope.kind != undefined){
                vm.searchData.kind = $rootScope.kind;
                $rootScope.kind = undefined;
            }
            var kind = 0;
            if (vm.searchData.kind != null && vm.searchData.kind != '') {
                kind = vm.searchData.kind;
            }
            Product.query({
                page: vm.page - 1,
                id: vm.searchData.id,
                name: vm.searchData.name,
                kind: kind}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.productList = result;
                vm.queryCount = vm.totalItems;
                setTimeout(function() {
                    //屏幕高度
                    var height = document.documentElement.clientHeight;
                    //导航部分的高度
                    var navbarHeight = $("#navbarHeight").height();//20
                    //检索部分的高度
                    var searchHeight = $("#searchHeight").height();//15
                    //表头高度
                    var headerHeight = $("#headerHeight").height();//
                    //分页部分高度
                    var pageHeight = $("#pageHeight").height();
                    //copyRight
                    var copyRight = $("#copyRight").height();
                    var tableDivHeight = height-navbarHeight-19-searchHeight-headerHeight-20-pageHeight-10-copyRight-10-40;
                    $("#tableDiv").css("max-height",tableDivHeight);
                }, 20);
            });

        }

        function remove(id) {
            if(confirm('削除してもよろしいですか?')) {
                Product.delete({id: id}, function(){
                    search();
                    MessageService.success("product.message.deleted");
                    $rootScope.$broadcast('messageChanged');
                });
            }
        }

        function loadKindList() {
            // 获取制品种类列表
            ProductType.list(function(result){
                vm.productTypeList = result;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function goEdit(id) {
            $rootScope.id = vm.searchData.id;
            $rootScope.name = vm.searchData.name;
            $rootScope.kind = vm.searchData.kind;
            $rootScope.page = vm.page;
            $state.go('product.edit', {id: id});
        }

        function goDel(id) {
            $rootScope.id = vm.searchData.id;
            $rootScope.name = vm.searchData.name;
            $rootScope.kind = vm.searchData.kind;
            $rootScope.page = vm.page;
            $state.go('product.delete', {id: id});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ProductSelectDialogController', ProductSelectDialogController);

    ProductSelectDialogController.$inject = ['paginationConstants', 'Product', 'ProductType', '$uibModalInstance'];

    function ProductSelectDialogController (paginationConstants, Product, ProductType, $uibModalInstance) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 商品种类
        vm.kindList= ["ケアリス", "あそぶ", "タイムカード", "アナライズ"];
        // 製品列表
        vm.productList = [];
        // 查询条件
        vm.searchData = {"id": "", "name": "", "kind": 0};
        vm.defaultSearchData = {"id": "", "name": "", "kind": 0};
        // 商品种类
        vm.productTypeList = [];

        // 初始加载数据
        vm.loadData = loadData;
        // 清空搜索条件
        vm.clear = clear;
        // 点击查询
        vm.search = search;
        // 删除指定商品
        vm.remove = remove;
        // 获取商品种类列表
        vm.loadKindList = loadKindList;
        // 选择指定
        vm.select = select;
        // 关闭dialog
        vm.close = close;

        loadData();
        loadKindList();

        function loadData() {
            var kind = 0;
            if (vm.searchData.kind != null && vm.searchData.kind != '') {
                kind = vm.searchData.kind;
            }
            Product.queryDialog({
                page: vm.page - 1,
                id: vm.searchData.id,
                name: vm.searchData.name,
                kind: kind}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.productList = result;
                vm.queryCount = vm.totalItems;
            });
        }

        function remove(id) {
            if(confirm('削除してもよろしいですか?')) {
                Product.delete({id: id}, function(){
                    search();
                    MessageService.success("product.message.deleted");
                    $rootScope.$broadcast('messageChanged');
                });
            }
        }

        function loadKindList() {
            // 获取制品种类列表
            ProductType.list(function(result){
                vm.productTypeList = result;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function select(selected) {
            $uibModalInstance.close(selected);
        }

        function close() {
            $uibModalInstance.close("");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ProductEditDialogController', ProductEditDialogController);

    ProductEditDialogController.$inject = ['$uibModalInstance', 'ProductType', 'param', 'Product', '$timeout', 'MessageService', '$rootScope'];

    function ProductEditDialogController ($uibModalInstance, ProductType, param, Product, $timeout, MessageService, $rootScope) {

        var vm = this;

        // 製品
        vm.product = {id: '', productName: '', productKana: '', minCount: 1, productType: ''};
        // ライセンスタイプ
        vm.licenseType = "";
        // ライセンスタイプ
        vm.licenseTypes = [
            {id: 1, name: "アカウントライセンス"},
            {id: 2, name: "プロダクトライセンス"}
        ];
        // 用于保存修改的licenseType
        vm.productTypeObject = {};
        // 最小贩卖数是否可以编辑
        vm.minCountEditDisabled = false;

        // 制品种类列表
        vm.productTypeList = [];

        // 初始加载数据
        vm.loadData = loadData;
        // 根据选择的制品种类，确定license类型，设置最小贩卖数
        vm.showLicenseType = showLicenseType;
        // 修改制品type对应的license type，联动修改
        vm.changeLicenseType = changeLicenseType;

        // 关闭dialog
        vm.close = close;

        // 保存数据
        vm.save = save;

        vm.editFlag = false;

        loadData();

        function loadData() {
            // 获取制品信息
            if (param.id != null && param.id != '') {
                vm.editFlag = true;
                Product.get({id: param.id}, function (result) {
                    vm.product = result;
                    showLicenseType();
                });
            }
            // 获取制品种类列表
            ProductType.list(function(result){
                vm.productTypeList = result;
                if (vm.productTypeList.length > 0) {
                    var product = {id:"",name:""};
                    vm.productTypeList.unshift(product);
                }
                showLicenseType();
            });
        }

        function close () {
            $uibModalInstance.dismiss('cancel');
        }

        function showLicenseType() {
            // 循环制品种类
            for (var i = 0; i < vm.productTypeList.length; i ++) {
                // 判断所选种类和列表中的是否一致
                if (angular.equals(vm.product.productType, vm.productTypeList[i].id)) {
                    for (var j = 0; j < vm.licenseTypes.length; j ++) {
                        if (angular.equals(vm.productTypeList[i].licenseType, vm.licenseTypes[j].id)) {
                            vm.licenseType = vm.licenseTypes[j].id;
                            // 如果是1，那么最小贩卖数可以输入，如果是2，那么最小贩卖数默认为1，并且不可以输入
                            vm.product.minCount = 1;
                            if (angular.equals(vm.licenseTypes[j].id, 1)) {
                                vm.product.minCount = 1;
                                vm.minCountEditDisabled = false;
                            } else {
                                vm.product.minCount = 1;
                                vm.minCountEditDisabled = true;
                            }
                        }
                    }
                }
            }
            vm.productTypeObject = {};
        }

        function changeLicenseType() {
            for (var i = 0; i < vm.productTypeList.length; i ++) {
                if (angular.equals(vm.product.productType, vm.productTypeList[i].id)) {
                    vm.productTypeObject = angular.copy(vm.productTypeList[i]);
                }
            }
            vm.productTypeObject.licenseType = vm.licenseType;
            if (angular.equals(vm.licenseType, 1)) {
                vm.product.minCount = 1;
                vm.minCountEditDisabled = false;
            } else {
                vm.product.minCount = 1;
                vm.minCountEditDisabled = true;
            }
        }

        function save() {
            if (vm.productTypeObject.id != null) {
                ProductType.save(vm.productTypeObject);
            }

            Product.save(vm.product, function(result){
                MessageService.success("product.message.saved");
                $uibModalInstance.close(result);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ProductDeleteDialogController', ProductDeleteDialogController);

    ProductDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'productTypeEntity', 'Product', 'MessageService', '$timeout', '$rootScope'];

    function ProductDeleteDialogController ($uibModalInstance, entity, productTypeEntity, Product, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.product = entity;
        vm.productType = productTypeEntity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.error = false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Product.delete({id: id}, function() {
                MessageService.success("product.message.deleted");
                $uibModalInstance.close(true);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            }, function () {
                vm.error = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('price', {
            parent: 'app',
            url: '/settings/price',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/master/price/price.html',
                    controller: 'PriceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('price');
                    return $translate.refresh();
                }]
            }
        }).state('price.edit', {
            parent: 'price',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/master/price/dialog/price-edit-dialog.html',
                    controller: 'PriceEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        param: {id: $stateParams.id}
                    }
                }).result.then(function() {
                    $state.go('price', null, { reload: true });
                }, function() {
                    $state.go('price');
                });
            }]
        }).state('price.delete', {
            parent: 'price',
            url: '/delete/{id}/{productId}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/master/price/dialog/price-delete-dialog.html',
                    controller: 'PriceDeleteDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Price', function(Price) {
                            return Price.get({id : $stateParams.id});
                        }],
                        productEntity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.productId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('price', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('PriceController', PriceController);

    PriceController.$inject = ['Price', 'paginationConstants', 'MessageService', '$rootScope'];

    function PriceController (Price, paginationConstants, MessageService, $rootScope) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.isOpenDateFrom = false;
        vm.isOpenDateTo = false;
        vm.openCalendar = openCalendar;

        // 查询条件
        vm.searchData = {productId: "", productNm: "", stopFlag: "", dateFrom: "", dateTo: ""};
        vm.defaultSearchData = {productId: "", productNm: "", stopFlag: "", dateFrom: "", dateTo: ""};

        // 是否列表
        vm.whetherList = [{id: 0, value: "販売中"}, {id: 1, value: "販売終了"}];

        // 单价列表
        vm.priceList = [];

        // 初始加载数据
        vm.loadData = loadData;

        // 删除指定单价
        vm.remove = remove;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;

        // 初始自动执行
        loadData();

        function loadData() {
            Price.query({
                page: vm.page - 1,
                productId: vm.searchData.productId,
                productNm: vm.searchData.productNm,
                stopFlag: vm.searchData.stopFlag,
                dateFrom: $('#dateFrom').val(),
                dateTo: $('#dateTo').val()}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.priceList = result;
                vm.queryCount = vm.totalItems;
            });
        }

        function remove(id) {
            if(confirm('削除してもよろしいですか?')) {
                Price.delete({id: id}, function(){
                    search();
                    MessageService.success("price.message.deleted");
                    $rootScope.$broadcast('messageChanged');
                });
            }
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            $('#dateFrom').val("");
            $('#dateTo').val("");
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function openCalendar(i) {
            if (i == 1) {
                vm.isOpenDateFrom = true;
            } else if (i == 2) {
                vm.isOpenDateTo = true;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('PriceEditDialogController', PriceEditDialogController);

    PriceEditDialogController.$inject = ['$uibModalInstance', '$uibModal', 'MessageService', 'Price', 'param', '$timeout', '$rootScope', 'Product'];

    function PriceEditDialogController ($uibModalInstance, $uibModal, MessageService, Price, param, $timeout, $rootScope, Product) {

        var vm = this;

        // 単価
        vm.price = {id: "", productId: "", productNm: "", price: 0,  startDate: null, endDate: null, stopFlag: false};

        vm.isOpen = false;
        vm.openCalendar = openCalendar;

        // 初始加载数据
        vm.loadData = loadData;
        // 关闭dialog
        vm.close = close;
        // 选择制品
        vm.select = select;
        // 清除选择的制品
        vm.clear = clear;
        // 保存数据
        vm.save = save;

        loadData();

        function loadData() {
            // 获取单价信息
            if (param.id != null && param.id != '') {
                Price.get({id: param.id}, function (result) {
                    vm.price.id = result.id;
                    vm.price.productId = result.productId;
                    Product.get({id: result.productId}, function(product) {
                        vm.price.productNm = product.productName;
                    });
                    vm.price.price = result.price;
                    vm.price.startDate = new Date(result.startDate);
                    vm.price.endDate = result.endDate;
                    vm.price.stopFlag = result.stopFlag;
                });
            }
        }

        function close () {
            $uibModalInstance.dismiss('cancel');
        }

        function select() {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/master/product/dialog/product-select-dialog.html',
                controller : 'ProductSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'lg',
                resolve : {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.price.productId = result.id;
                    vm.price.productNm = result.name;
                }
            },function(){
                //MessageService.error("global.error.internalServerError");
            })
        }

        function clear() {
            vm.price.productId = "";
            vm.price.productNm = "";
        }

        function save() {
            var entity = angular.copy(vm.price);
            entity.startDate = $('#startDate').val();
            Price.save(entity, function(result){
                MessageService.success("price.message.saved");
                $uibModalInstance.close(result);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }

        function openCalendar() {
            vm.isOpen = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('PriceDeleteDialogController', PriceDeleteDialogController);

    PriceDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'Price', 'MessageService', '$timeout', '$rootScope', 'productEntity'];

    function PriceDeleteDialogController ($uibModalInstance, entity, Price, MessageService, $timeout, $rootScope, productEntity) {
        var vm = this;

        vm.price = entity;
        vm.product = productEntity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.error = false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Price.delete({id: id}, function() {
                MessageService.success("price.message.deleted");
                $uibModalInstance.close(true);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            }, function () {
                vm.error = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('license', {
            parent: 'app',
            url: '/settings/license',
            data: {
                pageTitle: 'license.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/master/license/license.html',
                    controller: 'LicenseController',
                    controllerAs: 'vm'
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Role', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Role, Kinou) {
                    var top = $uibModalStack.getTop();
                    if (top) {
                        $uibModalStack.dismiss(top.key);
                    }
                    Principal.identity().then(function(account) {
                        if (account != null) {
                            Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_License_License_FullAccess"}, function(result){
                            	if (!result.flag) {
                            		$state.go('accessdenied');
                            	}
                            });
                        } else {
                            LoginService.open();
                        }

                    });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('license');
                    return $translate.refresh();
                }]
            }
        }).state('license.edit', {
            parent: 'license',
            url: '/edit/{id}/{version}',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal','Principal', function($stateParams, $state, $uibModal, Principal) {
                $uibModal.open({
                    templateUrl: 'app/master/license/dialog/license-edit-dialog.html',
                    controller: 'LicenseEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        param: {id: $stateParams.id, version: $stateParams.version}
                    }
                }).result.then(function() {
                    $state.go('license', null, { reload: true });
                }, function() {
                    $state.go('license');
                });
            }]
        }).state('license.delete', {
            parent: 'license',
            url: '/delete/{id}/{version}/{gid}/{productId}/{shopId}',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', function($stateParams, $state, $uibModal, Principal) {
                $uibModal.open({
                    templateUrl: 'app/master/license/dialog/license-delete-dialog.html',
                    controller: 'LicenseDeleteDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LicenseService', function(LicenseService) {
                            return LicenseService.get({id : $stateParams.id});
                        }],
                        groupEntity: ['Houjin', 'Group', function(Houjin, Group) {
                            if ($stateParams.version == 1) {
                                return Houjin.get({id: $stateParams.gid});
                            } else {
                                return Group.get({id: $stateParams.gid});
                            }
                        }],
                        productEntity: ['Product', function(Product) {
                            return Product.get({id: $stateParams.productId});
                        }],
                        shopEntity: ['Outlets', function(Outlets) {
                            return Outlets.get({id: $stateParams.productId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('license', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseController', LicenseController);

    LicenseController.$inject = ['paginationConstants', 'Principal', 'LicenseService', 'MessageService', '$rootScope', '$state'];

    function LicenseController (paginationConstants, Principal, LicenseService, MessageService, $rootScope, $state) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 製品列表
        vm.productList = [];
        // 查询条件
        vm.searchData = {id: "", name: "", productId: "", productNm: "", shopId: "", shopNm: ""};
        vm.defaultSearchData = {id: "", name: "", productId: "", productNm: "", shopId: "", shopNm: ""};

        vm.idText = "法人ID";
        vm.nmText = "法人名";
        vm.idTextTitle = "法人ID";
        vm.nmTextTitle = "法人名";
        vm.addButtonText = "ライセンス(1.0)追加";

        // license列表
        vm.licenseList = [];

        // 初始加载数据
        vm.loadData = loadData;
        vm.changeSearchVersion = changeSearchVersion;
        vm.changeSearchVersionByClickText = changeSearchVersionByClickText;

        // 删除指定license
        vm.remove = remove;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        vm.version = 1;

        loadData();
        vm.goEdit = goEdit;
        vm.goDel = goDel;
        vm.isAdmin = false;
        vm.isPartner = false;
        vm.partnerId = 0;

        function loadData() {
            Principal.identity().then(function(account) {
                if (account != null) {
                    vm.partnerId = account.id;
                    if (account.authorities != null) {
                        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
                            vm.isAdmin = true;
                        }
                        if (account.authorities.indexOf("ROLE_PARTNER") != -1) {
                            vm.isPartner = true;
                        }
                    }
                }
                if($rootScope.searchData != undefined){
                    vm.searchData = $rootScope.searchData;
                    $rootScope.searchData = undefined;
                }
                if($rootScope.version != undefined){
                    vm.version = $rootScope.version;
                    $rootScope.version = undefined;
                }
                if($rootScope.page != undefined){
                    vm.page = $rootScope.page;
                    $rootScope.page = undefined;
                }
                LicenseService.query({
                    page: vm.page - 1,
                    version: vm.version,
                    id: vm.searchData.id,
                    name: vm.searchData.name,
                    productId: vm.searchData.productId,
                    productNm: vm.searchData.productNm,
                    shopId: vm.searchData.shopId,
                    shopNm: vm.searchData.shopNm,
                    isPartner: vm.isPartner,
                    partnerId: vm.partnerId}, function(result, headers) {

                    if (vm.version == 1) {
                        vm.idTextTitle = "法人ID";
                        vm.nmTextTitle = "法人名";
                        vm.idText = "法人ID";
                        vm.nmText = "法人名";
                        vm.addButtonText = "ライセンス(1.0)追加";
                    } else if (vm.version == 2) {
                        vm.idTextTitle = "グループID";
                        vm.nmTextTitle = "グループ名";
                        vm.idText = "グループID";
                        vm.nmText = "グループ名";
                        vm.addButtonText = "ライセンス(2.0)追加";
                    }

                    vm.totalItems = headers('X-Total-Count');
                    vm.licenseList = result;
                    vm.queryCount = vm.totalItems;
                    setTimeout(function() {
                        //屏幕高度
                        var height = document.documentElement.clientHeight;
                        //导航部分的高度
                        var navbarHeight = $("#navbarHeight").height();//20
                        //检索部分的高度
                        var searchHeight = $("#searchHeight").height();//15
                        //表头高度
                        var headerHeight = $("#headerHeight").height();//
                        //分页部分高度
                        var pageHeight = $("#pageHeight").height();
                        //copyRight
                        var copyRight = $("#copyRight").height();
                        var tableDivHeight = height-navbarHeight-19-searchHeight-headerHeight-20-pageHeight-10-copyRight-10-40;
                        $("#tableDiv").css("max-height",tableDivHeight);
                    }, 20);
                });
            });
        }

        function remove(id) {
            if(confirm('削除してもよろしいですか?')) {
                LicenseService.delete({id: id}, function(){
                    loadData();
                    MessageService.success("license.message.deleted");
                    $rootScope.$broadcast('messageChanged');
                });
            }
        }

        // 改变查询条件中的版本
        function changeSearchVersion() {
            $rootScope.version = vm.version;
            vm.searchData = angular.copy(vm.defaultSearchData);
            if (vm.version == 2) {
                vm.idText = "グループID";
                vm.nmText = "グループ名";
                vm.addButtonText = "ライセンス(2.0)追加";
            } else {
                vm.idText = "法人ID";
                vm.nmText = "法人名";
                vm.addButtonText = "ライセンス(1.0)追加";
            }
            search();
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function changeSearchVersionByClickText(version) {
            vm.version = version;
            vm.changeSearchVersion();
        }

        function goEdit(id, version) {
            $rootScope.page = vm.page;
            $rootScope.searchData = vm.searchData;
            $rootScope.version = vm.version;
            $state.go('license.edit', {id: id, version: version});
        }
        function goDel(id, version, gid, productId, shopId) {
            $rootScope.page = vm.page;
            $rootScope.searchData = vm.searchData;
            $rootScope.version = vm.version;
            $state.go('license.delete', {id: id, version: version, gid:gid, productId:productId, shopId:shopId});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseEditDialogController', LicenseEditDialogController);

    LicenseEditDialogController.$inject = ['$uibModalInstance', '$uibModal', 'Kinou', 'MessageService', 'LicenseService', 'param', '$timeout', '$rootScope', 'Price'];

    function LicenseEditDialogController ($uibModalInstance, $uibModal, Kinou, MessageService, LicenseService, param, $timeout, $rootScope, Price) {

        var vm = this;

        // ライセンス
        vm.license = {dbId: '', version: 1, id: '', name: '', productId: '', productNm: '', shopId: '', shopNm: "", startDate: null, endDate: null, licenseCount: 1, price: null, planId: 1, stopFlag: false};
        // 参考价格
        vm.referencePrice = null;
        // 页面表示
        vm.idText = "法人ID";
        vm.nmText = "法人名";

        vm.endDateCheckShow = false;

        vm.isOpen = false;
        vm.openCalendar = openCalendar;

        // 初始加载数据
        vm.loadData = loadData;

        // 关闭dialog
        vm.clear = clear;

        // 根据version改变显示文字
        vm.setVersionShow = setVersionShow;

        // 选择不同的版本时候，页面字段不同名称
        vm.changeVersion = changeVersion;

        // 选择group
        vm.selectGroup = selectGroup;

        // 选择法人
        vm.selectHoujin = selectHoujin;

        // 选择制品
        vm.selectProduct = selectProduct;

        // 选择贩卖店
        vm.selectShop = selectShop;

        // 保存数据
        vm.save = save;

        // 关闭dialog
        vm.close = close;

        vm.editFlag = false;

        vm.keiyakuplanList = [];

        loadData();

        function loadData() {
            if (param.id != null && param.id != '') {
                vm.editFlag = true;
                LicenseService.get({id: param.id}, function (result) {
                    vm.license.dbId = result.dbId;
                    vm.license.version = result.version;
                    vm.license.id = result.id;
                    vm.license.name = result.name;
                    vm.license.productId = result.productId;
                    vm.license.productNm = result.productNm;
                    vm.license.shopId = result.shopId;
                    vm.license.shopNm = result.shopNm;
                    vm.license.startDate = result.startDate != null ? new Date(result.startDate) : null;
                    vm.license.endDate = result.endDate != null ? new Date(result.endDate) : null;
                    vm.license.licenseCount = result.licenseCount;
                    vm.license.price = result.price;
                    vm.license.planId = result.planId;
                    vm.license.stopFlag = result.stopFlag;
                    // 根据产品id获取当前时间内的参考价格
                    Price.getByProductId({productId: result.productId}, function (priceResult) {
                        if (priceResult != null) {
                            vm.referencePrice = priceResult.price;
                        }
                    });
                    setVersionShow();
                });
            } else {
                vm.license.version = param.version;
                setVersionShow();
            }
            Kinou.getKeiyakuplanByLicense({}, function (result) {
                vm.keiyakuplanList = result;
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function setVersionShow() {
            if (vm.license.version == 2) {
                vm.idText = "グループID";
                vm.nmText = "グループ名";
            } else {
                vm.idText = "法人ID";
                vm.nmText = "法人名";
            }
        }

        function changeVersion() {
            setVersionShow();
            vm.license.id = "";
            vm.license.name = "";
        }

        function selectGroup() {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/master/group/dialog/group-select-dialog.html',
                controller : 'GroupSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'lg',
                resolve : {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('group');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.license.id = result.id;
                    vm.license.name = result.name;
                }
            },function(){
                //MessageService.error("global.error.internalServerError");
            })
        }

        function selectHoujin() {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/master/houjin/dialog/houjin-select-dialog.html',
                controller : 'HoujinSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'lg',
                resolve : {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('houjin');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.license.id = result.id;
                    vm.license.name = result.name;
                }
            },function(){
                //MessageService.error("global.error.internalServerError");
            })
        }

        function selectProduct() {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/master/product/dialog/product-select-dialog.html',
                controller : 'ProductSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'lg',
                resolve : {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.license.productId = result.id;
                    vm.license.productNm = result.name;
                    // 根据产品id获取当前时间内的参考价格
                    Price.getByProductId({productId: result.id}, function (priceResult) {
                        if (priceResult != null) {
                            vm.referencePrice = priceResult.price;
                        }
                    });
                }
            },function(){
                //MessageService.error("global.error.internalServerError");
            })
        }

        function selectShop() {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/master/shop/dialog/shop-select-dialog.html',
                controller : 'ShopSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'lg',
                resolve : {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('shop');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.license.shopId = result.id;
                    vm.license.shopNm = result.name;
                }
            },function(){
                //MessageService.error("global.error.internalServerError");
            })
        }

        function save() {

            vm.endDateCheckShow = false;

            if ($('#startDateCheck').is(':hidden') && $('#endDateCheck').is(':hidden')) {
                if ((new Date($('#startDate').val())).getTime() > (new Date($('#endDate').val())).getTime()) {
                    vm.endDateCheckShow = true;
                    return false;
                } else {
                    vm.endDateCheckShow = false;
                }
            }

            var entity = angular.copy(vm.license);
            entity.startDate = $('#startDate').val() == '' ? null : $('#startDate').val();
            entity.endDate = $('#endDate').val() == '' ? null : $('#endDate').val();
            LicenseService.save(entity, function(result){
                MessageService.success("license.message.saved");
                $uibModalInstance.close(result);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }

        function close () {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar(i) {
            if (i == 1) {
                vm.isOpenStartDate = true;
            } else if (i == 2) {
                vm.isOpenEndDate = true;
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseDeleteDialogController', LicenseDeleteDialogController);

    LicenseDeleteDialogController.$inject = ['$uibModalInstance', 'entity', 'groupEntity', 'productEntity', 'shopEntity', 'LicenseService', 'MessageService', '$timeout', '$rootScope', '$stateParams'];

    function LicenseDeleteDialogController ($uibModalInstance, entity, groupEntity, productEntity, shopEntity, LicenseService, MessageService, $timeout, $rootScope, $stateParams) {
        var vm = this;

        vm.version = $stateParams.version;
        vm.license = entity;
        vm.groupEntity = groupEntity;
        vm.productEntity = productEntity;
        vm.shopEntity = shopEntity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.error = false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            LicenseService.delete({id: id}, function() {
                MessageService.success("license.message.deleted");
                $uibModalInstance.close(true);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            }, function () {
                vm.error = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HoujinSelectDialogController', HoujinSelectDialogController);

    HoujinSelectDialogController.$inject = ['paginationConstants', 'Houjin', '$uibModalInstance'];

    function HoujinSelectDialogController (paginationConstants, Houjin, $uibModalInstance) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 法人列表
        vm.houjinList = [];

        // 查询条件
        vm.searchData = {name: "", code: "", jigyoushoId: "", id: ""};
        vm.defaultSearchData = {name: "", code: "", jigyoushoId: "", id: ""};

        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 选择指定
        vm.select = select;
        // 关闭dialog
        vm.close = close;

        loadData();

        function loadData() {
            Houjin.query({
                page: vm.page - 1,
                name: vm.searchData.name,
                code: vm.searchData.code,
                jigyoushoId: vm.searchData.jigyoushoId,
                id: vm.searchData.id}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.houjinList = result;
                vm.queryCount = vm.totalItems;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function select(selected) {
            $uibModalInstance.close(selected);
        }

        function close() {
            $uibModalInstance.close("");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GroupSelectDialogController', GroupSelectDialogController);

    GroupSelectDialogController.$inject = ['paginationConstants', 'Group', '$uibModalInstance'];

    function GroupSelectDialogController (paginationConstants, Group, $uibModalInstance) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // group列表
        vm.groupList = [];

        // 查询条件
        vm.searchData = {id: "", name: ""};
        vm.defaultSearchData = {id: "", name: ""};

        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 选择指定
        vm.select = select;
        // 关闭dialog
        vm.close = close;

        loadData();

        function loadData() {
            Group.queryDialog({
                page: vm.page - 1,
                id: vm.searchData.id,
                name: vm.searchData.name}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.groupList = result;
                vm.queryCount = vm.totalItems;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function select(selected) {
            $uibModalInstance.close(selected);
        }

        function close() {
            $uibModalInstance.close("");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('corporation', {
            parent: 'app',
            url: '/corporation',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/master/corporation/corporation.html',
                    controller: 'CorporationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //$translatePartialLoader.addPart('corporation');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CorporationController', CorporationController);

    CorporationController.$inject = [];

    function CorporationController () {

        var vm = this;

        // 法人列表
        vm.corporationList = [];

        // 初始加载数据
        vm.loadData = loadData();

        function loadData() {
            var corporation1 = {jigyoushoId: "14ad254f", houjinId: "300030", jigyoushoCd: "4580012", jigyoushoNm: "グッドツリー介護事業所"};
            var corporation2 = {jigyoushoId: "19ad254p", houjinId: "400120", jigyoushoCd: "4580012", jigyoushoNm: "ディケアーグッドツリー"};
            vm.corporationList.push(corporation1);
            vm.corporationList.push(corporation2);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ContentValidationController', ContentValidationController);

    ContentValidationController.$inject = ['$uibModalInstance', '$uibModal', 'MessageService', '$timeout', '$rootScope'];

    function ContentValidationController ($uibModalInstance, $uibModal, MessageService, $timeout, $rootScope) {

        var vm = this;

        vm.inquiry = {}

        // 初始加载数据
        vm.loadData = loadData;
        vm.close = close;
        vm.checkList = "";

        loadData();

        function loadData() {
            vm.inquiry = $rootScope.inquiry;
            if($rootScope.inquiry.checkbox1){
                vm.checkList += "居宅介護支援, "
            }
            if($rootScope.inquiry.checkbox2) {
                vm.checkList += "訪問介護, "
            }
            if($rootScope.inquiry.checkbox3) {
                vm.checkList += "訪問入浴介護, "
            }
            if($rootScope.inquiry.checkbox4) {
                vm.checkList += "訪問リハビリ, "
            }
            if($rootScope.inquiry.checkbox5) {
                vm.checkList += "夜間対応型訪問介護, "
            }
            if($rootScope.inquiry.checkbox6) {
                vm.checkList += "通所介護, "
            }
            if($rootScope.inquiry.checkbox7) {
                vm.checkList += "地域密着型通所介護, "
            }
            if($rootScope.inquiry.checkbox8) {
                vm.checkList += "通所リハビリ, "
            }
            if($rootScope.inquiry.checkbox9) {
                vm.checkList += "総合事業, "
            }
            if($rootScope.inquiry.checkbox10) {
                vm.checkList += "認知症対応型通所介護, "
            }
            if($rootScope.inquiry.checkbox11) {
                vm.checkList += "ショートステイ, "
            }
            if($rootScope.inquiry.checkbox12) {
                vm.checkList += "短期入所療養介護, "
            }
            if($rootScope.inquiry.checkbox13) {
                vm.checkList += "小規模多機能型居宅介護, "
            }
            if($rootScope.inquiry.checkbox14) {
                vm.checkList += "看護小規模多機能型居宅介護, "
            }
            if($rootScope.inquiry.checkbox15) {
                vm.checkList += "グループホーム, "
            }
            if($rootScope.inquiry.checkbox16) {
                vm.checkList += "特養, "
            }
            if($rootScope.inquiry.checkbox17) {
                vm.checkList += "老健, "
            }
            if($rootScope.inquiry.checkbox18) {
                vm.checkList += "特定施設入居者生活介護, "
            }
            if($rootScope.inquiry.checkbox19) {
                vm.checkList += "地域密着型特定施設入居者生活介護, "
            }
            if($rootScope.inquiry.checkbox20) {
                vm.checkList += "サ高住（住宅型有料老人ホーム）, "
            }
            if($rootScope.inquiry.checkbox21) {
                vm.checkList += "介護記録（iPadアプリ/ケア樹きろく）, "
            }
            if($rootScope.inquiry.checkbox22) {
                vm.checkList += "ファクタリング, "
            }
            if($rootScope.inquiry.checkbox24) {
                vm.checkList += "ケア樹みえる, "
            }
            if($rootScope.inquiry.checkbox25) {
                vm.checkList += "ケア樹はかる, "
            }
            if($rootScope.inquiry.checkbox26) {
                vm.checkList += "ケア樹あそぶ, "
            }

            if(vm.checkList != ''){
                vm.checkList = vm.checkList.substring(0, vm.checkList.length-2);
            }
        }

        function close(){
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('inquiry', {
            parent: 'app',
            url: '/inquiry',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/master/application/caretreeApplication.html',
                    controller: 'CaretreeApplicationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('caretreeApplication');
                    return $translate.refresh();
                }]
            }
        }).state('inquiry.validation', {
            parent: 'inquiry',
            url: '/show',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/master/application/dialog/contentValidation.html',
                    controller: 'ContentValidationController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('inquiry', null, { reload: true });
                }, function() {
                    $state.go('inquiry');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CaretreeApplicationController', CaretreeApplicationController);

    CaretreeApplicationController.$inject = ['paginationConstants', 'MessageService', '$rootScope', '$state'];

    function CaretreeApplicationController (paginationConstants, MessageService, $rootScope, $state) {

        var vm = this;
        vm.inquiry = {name:'', houjinName:'', jigyoushoName:'', telephoneNumber:''}
        vm.phoneRequiredFlag = false;
        vm.nameRequiredFlag = false;
        vm.save = save;
        vm.loadData = loadData;

        loadData();

        function loadData() {

        }
        function save(){
            if(vm.inquiry.name == ""){
                vm.nameRequiredFlag = true;
            } else {
                vm.nameRequiredFlag = false;
            }
            if(vm.inquiry.telephoneNumber == ""){
                vm.phoneRequiredFlag = true;
            } else {
                vm.phoneRequiredFlag = false;
            }
            if(!vm.nameRequiredFlag && !vm.phoneRequiredFlag){
                $rootScope.inquiry = vm.inquiry;
                $state.go('inquiry.validation');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$uibModal', '$rootScope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService','Pepper', 'SelectedPepper', '$scope', 'MessageService', '$timeout', 'Group', 'SelectedGroup', 'Kinou', 'User'];

    function NavbarController ($uibModal, $rootScope, $state, Auth, Principal, ProfileService, LoginService, Pepper, SelectedPepper,$scope,MessageService, $timeout, Group, SelectedGroup, Kinou, User) {
        var vm = this;
        vm.currentYear = new Date().getFullYear();
        vm.currentMonth = new Date().getMonth()+1;
        vm.pepperList = [];
        vm.pepper = {};
        vm.groupList = [];
        vm.group = {};
        vm.messages = [];

        // account 管理
        vm.showAccount = false;
        // GROUP管理
        vm.showGroup = false;
        //製品管理
        vm.showProduct = false;
        //ライセンス管理
        vm.showLicense = false;
        //ストレージ管理
        vm.showStorage = false;
        //Swagger
        vm.showSwagger = false;
        //ケア樹タイムカード
        vm.showTimecard = false;
        //シフト管理利用者
        vm.showShift = false;
        //訪問打刻
        vm.houmonTimeCard = false;
        //システム
        vm.showSystem = false;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });
        getAccount();

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.showAccount = false;
                //GROUP管理
                vm.showGroup = false;
                //製品管理
                vm.showProduct = false;
                //ライセンス管理
                vm.showLicense = false;
                //ストレージ管理;
                vm.showStorage = false;
                //Swagger
                vm.showSwagger = false;
                //ケア樹タイムカード
                vm.showTimecard = false;
                //シフト管理
                vm.showShift = false;
                //システム
                vm.showSystem = false;

                if (account != null) {
                    if (account.authorities != null) {
                    	// account管理
                    	Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Authentication_access_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showAccount = true;
                        	}
                        });
                        // group管理
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Authentication_Group_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showGroup = true;
                        	}
                        });
                        // 製品管理
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_License_Product_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showProduct = true;
                        	}
                        });
                        //ライセンス管理
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_License_License_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showLicense = true;
                        	}
                        });
                        //ストレージ管理
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_License_Storage_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showStorage = true;
                        	}
                        });
                        //Swagger
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_API_Swagger_FullAccess"}, function(result){
                        	if (result.flag) {
                                vm.showSwagger = true;
                        		vm.showSystem = true;
                        	}
                        });
                        //システム
                        Kinou.isLoginRole({role: "ROLE_ADMIN"}, function(result){
                            if (result.flag) {
                                vm.showSystem = true;
                            }
                        });
                        //ケア樹タイムカード
                        /*Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_TimeCard_AllFunction_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showTimecard = true;
                        	}
                        });*/
                        Kinou.isLoginRole({role: "ROLE_TIMECARD"}, function(result){
                            if (result.flag) {
                                vm.showTimecard = true;
                            }
                        });
                        //シフト管理
                        /*Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Shift_AllFunction_FullAccess"}, function(result){
                            if (result.flag) {
                                vm.showShift = true;
                            }
                        });*/
                        Kinou.isLoginRole({role: "ROLE_SHIFT"}, function(result){
                            if (result.flag) {
                                vm.showShift = true;
                            }
                        });
                        User.queryUserOption({userId: account.id}, function (result) {
                            vm.houmonTimeCard = false;
                            if (result.houmonTimeCard == 1) {
                                vm.houmonTimeCard = true;
                            }
                        });
                    }

                    if (account.login.indexOf(";") != -1) {
                        vm.isOneUser = true;
                        vm.isTwoUser = false;
                    } else {
                        vm.isOneUser = false;
                        vm.isTwoUser = true;
                    }
                }
            });
        }

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.loadPepperList = loadPepperList;
        vm.loadGroupList = loadGroupList;
        vm.changePepper = changePepper;
        vm.changeGroup = changeGroup;
        vm.clearPepper = clearPepper;
        vm.messageShow = messageShow;
        vm.messageAllwaysShow = messageAllwaysShow;

        vm.loadPepperList();
        vm.loadGroupList();

        $scope.$on('pepperUpdate', function() {
            Pepper.query(function(result){
                SelectedPepper.setPepperList(result);
                loadPepperList();
                if (result.length === 0) {
                    SelectedPepper.setCurrent(null);
                } else {
                    if (!checkPepper()) {
                        SelectedPepper.setCurrent(result[0]);
                    }
                }
            });
        });

        $scope.$on('groupUpdate', function() {
            Group.parentGroup({}, function(result){
                SelectedGroup.setGroupList(result);
                loadGroupList();
                if (result.length === 0) {
                    SelectedGroup.setCurrent(null);
                } else {
                    if (!checkGroup()) {
                        SelectedGroup.setCurrent(result[0]);
                    }
                }
            });
        });

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            clearPepper();
            clearGroup();
            vm.messages = [];
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function loadPepperList() {
            //console.log("get pepper list of current login user");
            vm.pepperList = SelectedPepper.pepperList();
            vm.pepper = SelectedPepper.current();
        }

        function changePepper(pepper) {
            if (pepper.id > 0) {
                SelectedPepper.setCurrent(pepper);
                vm.pepper = pepper;
                $rootScope.$broadcast('pepperChanged');
                MessageService.success("global.messages.info.pepperchanged");
            } else {
                MessageService.error("global.error.pepperchangerror");
            }

        }

        function checkPepper() {
            var result = false;
            for (var i = 0; i < vm.pepperList; i ++) {
                if (vm.pepperList[i].id === vm.pepper.id) {
                    result = true;
                }
            }
            return result;
        }

        function clearPepper() {
            vm.pepperList = [];
            vm.pepper = {};
        }

        function loadGroupList() {
            vm.groupList = SelectedGroup.groupList();
            vm.group = SelectedGroup.current();
        }

        function changeGroup(group) {
            SelectedGroup.setCurrent(group);
            //vm.group = group;
            $rootScope.$broadcast('groupChanged');
        }

        $scope.$on('groupChanged', function() {
            vm.group = SelectedGroup.current();
        })

        function checkGroup() {
            var result = false;
            for (var i = 0; i < vm.groupList; i ++) {
                if (vm.groupList[i].id === vm.group.id) {
                    result = true;
                }
            }
            return result;
        }

        function clearGroup() {
            vm.groupList = [];
            vm.group = {};
        }

        $scope.$on('messageChanged', function() {
            messageShow();
            $timeout(function(){$('.message').animate({right: '-260px'})}, 2000);
        });

        $scope.$on('messageShowWithTime', function(second) {
            messageShow();
            if (second > 0) {
                $timeout(function(){$('.message').animate({right: '-260px'})}, second);
            }
        });

        function messageAllwaysShow() {
            messageShow();
        }

        function messageShow() {
            $('.message').animate({right: '0px'});
            if ($rootScope.msgs) {
                vm.messages = JSON.parse($rootScope.msgs);
                $timeout(function(){$('.message_info').scrollTop(9999999999)}, 500);
            } else {
                vm.messages = [];
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('vital', {
            parent: 'kiroku',
            url: '/vital',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.kiroku.vital'
            },
            views: {
                'content@': {
                    templateUrl: 'app/kiroku/vital/vital.html',
                    controller: 'VitalKirokuController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function() {
                    return {riyoushaId:null,jisshiDt:null,jisshiTm:null,taion:null,yuunetsuKbn:null,ketsuatsuUe:null,
                        ketsuatsuShita:null,myakuhaku:null,kokyuu:null,spo:null,huseimyakuKbn:null,taijuu:null,bikou:null};
                },
                // 文字
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vital');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('VitalKiroku', VitalKiroku);

    VitalKiroku.$inject = ['$resource'];

    function VitalKiroku ($resource) {
        var service = $resource('robot/api/kiroku/vital/:id', {}, {
            "query": {
                method: 'GET',
                isArray: true
            },
            "save": {
                method: "POST"
            },
            "delete": {
                method: "DELETE"
            },
            "get": {
                method: "GET"
            }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('VitalKirokuController', VitalKirokuController);

    VitalKirokuController.$inject = ['entity', 'VitalKiroku', '$rootScope','SelectedPepper','MessageService'];

    function VitalKirokuController (entity, VitalKiroku, $rootScope,SelectedPepper,MessageService) {
        var vm = this;

        vm.save = save;
        vm.pepper = SelectedPepper.current();

        vm.vital = entity;

        function onSaveSuccess(result) {
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            if (vm.pepper == null) {
                MessageService.error("ロボットを設定してない,ロボットを選んしてください。");
                return;
            }
            vm.isSaving = true;
            vm.vital.pepperId = vm.pepper.id;
            VitalKiroku.save(vm.vital, onSaveSuccess, onSaveError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('kiroku', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    return $translate.refresh();
                }]
            }
        }).state('home.license', {
            parent: 'home',
            url: 'home/no-license',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/home/dialog/license.html',
                    controller: 'HomeLicenseController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('home', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'Auth', '$rootScope', 'MessageService', 'User', 'Kinou', 'AuthResource', '$uibModal'];

    function HomeController ($scope, Principal, LoginService, $state, Auth, $rootScope, MessageService, User, Kinou, AuthResource, $uibModal) {
        var vm = this;

        vm.currentYear = new Date().getFullYear();
        vm.currentMonth = new Date().getMonth()+1;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.requestResetPassword = requestResetPassword;
        vm.login = login;
        vm.isAdmin = false;
        vm.isUser = false;
        vm.isCaretree = false;
        vm.isPartner = false;
        vm.isDeveloper = false;
        vm.isOneUser = false;
        vm.isTwoUser = false;
        //ケア樹Free
        vm.showCaretreeFree = false;
        //ケア樹あそぶ
        vm.showAsobu = false;
        //ケア樹タイムカード
        vm.showTimecard = false;
        // あそぶ表示かどうか
        vm.showAnalyze = false;
        //訪問打刻
        vm.houmonTimeCard = false;
        
        vm.isOneUser = false;
        vm.isTwoUser = false;
        vm.gtc_caretree2_robot_allfunction_fullaccess = false;
        vm.gtc_caretree2_analyze_function_fullaccess = false;
        vm.gtc_caretree_web_allfunction_fullaccess = false;

        vm.hasCaretreeAccount = false;
        
        vm.checkAccount = checkAccount;
        
        checkAccount();

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        
        vm.gotoRobot = gotoRobot;
        vm.gotoAnalyze = gotoAnalyze;
        vm.gotoCaretreeFree = gotoCaretreeFree;
        vm.timecardClick = timecardClick;
        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.isAdmin = false;
                vm.isUser = false;
                vm.isCaretree = false;
                vm.isPartner = false;
                vm.isDeveloper = false;
                vm.isOneUser = false;
                vm.isTwoUser = false;
                //ケア樹Free
                vm.showCaretreeFree = false;
                //ケア樹わかる
                vm.showAnalyze = false;
                //ケア樹あそぶ
                vm.showAsobu = false;
                //ケア樹タイムカード
                vm.showTimecard = false;
                
                vm.gtc_caretree2_robot_allfunction_fullaccess = false;
                vm.gtc_caretree2_analyze_function_fullaccess = false;
                vm.gtc_caretree_web_allfunction_fullaccess = false;

                if (account != null) {
                    if (account.authorities != null) {
                        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
                            vm.isAdmin = true;
                        }
                        if (account.authorities.indexOf("ROLE_USER") != -1) {
                            vm.isUser = true;
                        }
                        if (account.authorities.indexOf("ROLE_CARETREE") != -1) {
                            vm.isCaretree = true;
                        }
                        if (account.authorities.indexOf("ROLE_PARTNER") != -1) {
                            vm.isPartner = true;
                        }
                        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
                            vm.isDeveloper = true;
                        }
                        //ケア樹Free
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree_WEB_AllFunction_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showCaretreeFree = true;
                        	}
                        });
                        //ケア樹あそぶ
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Robot_AllFunction_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showAsobu = true;
                        	}
                        });
                        //ケア樹わかる
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Analyze_Function_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showAnalyze = true;
                        	}
                        });
                        //ケア樹タイムカード
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_TimeCard_AllFunction_FullAccess"}, function(result){
                        	if (result.flag) {
                        		vm.showTimecard = true;
                        	}
                        });
                    }
                    if (account.functions != null) {
                        for (var i in account.functions) {
                            if (account.functions[i] == 'GTC_CareTree2_Robot_AllFunction_FullAccess') {
                                vm.gtc_caretree2_robot_allfunction_fullaccess = true;
                            }
                            if (account.functions[i] == 'GTC_CareTree2_Analyze_Function_FullAccess') {
                                vm.gtc_caretree2_analyze_function_fullaccess = true;
                            }
                            //ケア樹Free
                            if (account.functions[i] == 'GTC_CareTree_WEB_AllFunction_FullAccess') {
                                vm.gtc_caretree_web_allfunction_fullaccess = true;
                            }
                        }
                    }

                    if (account.login.indexOf(";") != -1) {
                        vm.isOneUser = true;
                        vm.isTwoUser = false;
                    } else {
                        vm.isOneUser = false;
                        vm.isTwoUser = true;
                    }
                    User.queryUserOption({userId: account.id}, function (result) {
                        vm.houmonTimeCard = false;
                        if (result.houmonTimeCard == 1) {
                            vm.houmonTimeCard = true;
                        }
                    });
                }
            });
        }
        function register () {
            $state.go('register');
        }
        function requestResetPassword () {
            $state.go('requestReset');
        }

        function login () {
            var userName = "";
            var password = "";
            var rememberMe = "";
            if($("#login li.active").attr("value") == 1){
                userName = vm.jigyoushoCd + ";" + vm.usernameOne;
                password = vm.passwordOne;
                rememberMe = vm.rememberMeOne;
            }else{
                userName = vm.username;
                password = vm.password
                rememberMe = vm.rememberMe;
            };
            Auth.login({
                username: userName,
                password: password,
                rememberMe: rememberMe
            }).then(function () {
                vm.authenticationError = false;
                //$uibModalInstance.close();
                $state.go('home');
                
                checkAccount();

                $rootScope.$broadcast('authenticationSuccess');
                $rootScope.$broadcast('pepperUpdate');
                $rootScope.$broadcast('groupUpdate');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                MessageService.errorWithSecond("login.messages.error.authentication", 0);
            });
        }
        
        function checkAccount() {
        	AuthResource.hasCaretreeAccount({}, function(data){
        		vm.hasCaretreeAccount = data.result;
        	});
        }
        
        function gotoRobot() {
        	if (vm.gtc_caretree2_robot_allfunction_fullaccess || vm.isAdmin || vm.isDeveloper) {
        		window.open('/#/robot/contents');
        	} else {
        		$uibModal.open({
                    templateUrl: 'app/home/dialog/license.html',
                    controller: 'HomeLicenseController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('home', null, { reload: true });
                }, function() {
                    $state.go('home');
                });
        	}
        }

        function gotoAnalyze() {
            if (vm.gtc_caretree2_analyze_function_fullaccess || vm.isAdmin || vm.isDeveloper) {
                window.open('/#/analyze');
            } else {
                $uibModal.open({
                    templateUrl: 'app/home/dialog/license.html',
                    controller: 'HomeLicenseController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('home', null, { reload: true });
                }, function() {
                    $state.go('home');
                });
            }
        }

        function gotoCaretreeFree(type){
            if (vm.gtc_caretree_web_allfunction_fullaccess || vm.isAdmin || vm.isDeveloper) {
                if(type == 0){
                    window.open('https://goodleaf.jp/');
                }else if(type == 1){
                    window.open('https://caretreesys.net/');
                }
            } else {
                $uibModal.open({
                    templateUrl: 'app/home/dialog/license.html',
                    controller: 'HomeLicenseController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('home', null, { reload: true });
                }, function() {
                    $state.go('home');
                });
            }
        }

        function timecardClick() {
            $state.go('houmonTimecard');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('HomeLicenseController',HomeLicenseController);

    HomeLicenseController.$inject = ['$stateParams', '$state', '$uibModalInstance', 'JhiLanguageService', 'MessageService', '$timeout', '$rootScope','OptionUser','Principal', 'Outlets'];

    function HomeLicenseController ($stateParams, $state, $uibModalInstance, JhiLanguageService, MessageService, $timeout, $rootScope, OptionUser, Principal, Outlets) {
        var vm = this;
        vm.clear = clear;
        vm.goInquiry = goInquiry;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function goInquiry(){
            //window.open('/#/inquiry');
            //$state.go('inquiry');
            $uibModalInstance.dismiss('colse');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('license-user', {
            parent: 'app',
            url: '/settings/license-user',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/customer/license/user/license-user.html',
                    controller: 'LicenseUserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('license');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseUserController', LicenseUserController);

    LicenseUserController.$inject = ['paginationConstants', 'LicenseService', 'MessageService', '$uibModal'];

    function LicenseUserController (paginationConstants, LicenseService, MessageService, $uibModal) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 用户列表
        vm.userList = [];
        // license使用数
        vm.licenseUsedList = [];
        // 查询条件
        vm.searchData = {groupId: "", groupNm: "", loginId: "", name: ""};
        vm.defaultSearchData = {groupId: "", groupNm: "", loginId: "", name: ""};

        vm.noGroup = true;

        // 查询条件选择group
        vm.selectGroup = selectGroup;
        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 编辑用户service
        vm.edit = edit;

        // 加载完成之后自动执行
        loadData();

        function selectGroup() {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/master/group/dialog/group-select-dialog.html',
                controller : 'GroupSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'lg',
                resolve : {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('group');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.searchData.groupId = result.id;
                    vm.searchData.groupNm = result.name;
                    loadData();
                }
            },function(){
                //MessageService.error("global.error.internalServerError");
            })
        }

        function loadData() {
            if (vm.searchData.groupId != '') {
                vm.noGroup = false;
                LicenseService.queryUser({
                    page: vm.page - 1,
                    groupId: vm.searchData.groupId,
                    loginId: vm.searchData.loginId,
                    name: vm.searchData.name}, function(result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.userList = result;
                    vm.queryCount = vm.totalItems;
                });
                LicenseService.userLicenseSum({groupId: vm.searchData.groupId}, function(result){
                    vm.licenseUsedList = result;
                });
            } else {
                vm.noGroup = true;
            }
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.defaultSearchData.groupId = vm.searchData.groupId;
            vm.defaultSearchData.groupNm = vm.searchData.groupNm;
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function edit(model) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/customer/license/user/dialog/license-user-edit-dialog.html',
                controller: 'LicenseUserEditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    param: function(){
                        return model;
                    }
                }
            });
            modalInstance.result.then(function() {
                loadData();
            },function(){
                loadData();
            })
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseUserEditDialogController', LicenseUserEditDialogController);

    LicenseUserEditDialogController.$inject = ['$uibModalInstance', 'MessageService', 'LicenseService', 'param', '$timeout', '$rootScope'];

    function LicenseUserEditDialogController ($uibModalInstance, MessageService, LicenseService, param, $timeout, $rootScope) {

        var vm = this;

        // 基本信息
        vm.info = {groupNm: "", login: "", username: ""};
        // ライセンス
        vm.licenses = [];
        //vm.license = {licenseId: null, productTypeId: null, productTypeNm: "", shopId: null, shopNm: "", productId: null, productNm: "", usedFlg: false};

        vm.endDateCheckShow = false;

        // 初始加载数据
        vm.loadData = loadData;

        // 关闭dialog
        vm.clear = clear;

        // 保存数据
        vm.save = save;

        // 关闭dialog
        vm.close = close;

        // 设置用户的license
        vm.setLicense = setLicense;

        vm.useFlag = false;

        loadData();

        function loadData() {
            if (param.groupId != null && param.groupId != '' && param.userId != null && param.userId != '') {
                // 基本信息的取得
                LicenseService.getUserInfo({groupId: param.groupId, userId: param.userId}, function(result){
                    vm.info = result;
                });
                // 取得购买的license的种别
                LicenseService.getUserLicense({groupId: param.groupId, userId: param.userId}, function(result){
                    vm.licenses = result;
                    vm.useFlag = false;
                });
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            vm.endDateCheckShow = false;

            if ($('#startDateCheck').is(':hidden') && $('#endDateCheck').is(':hidden')) {
                if ((new Date($('#startDate').val())).getTime() > (new Date($('#endDate').val())).getTime()) {
                    vm.endDateCheckShow = true;
                    return false;
                } else {
                    vm.endDateCheckShow = false;
                }
            }

            var entity = angular.copy(vm.license);
            entity.startDate = $('#startDate').val() == '' ? null : $('#startDate').val();
            entity.endDate = $('#endDate').val() == '' ? null : $('#endDate').val();
            LicenseService.save(entity, function(result){
                MessageService.success("license.message.saved");
                $uibModalInstance.close(result);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }

        function close () {
            $uibModalInstance.dismiss('cancel');
        }

        function setLicense(license) {
            vm.useFlag = true;
            license.groupId = param.groupId;
            license.userId = param.userId;
            LicenseService.setUserLicense(license,
                function(){
                    MessageService.success("global.messages.info.update");
                    loadData();
                },
                function(result){
                    license.usedFlg = false;
                    vm.useFlag = false;
                    if (result.status == "406") {
                        alert("ライセンス使用数が最大ので、設定できません。");
                    } else {
                        MessageService.error("global.messages.error.save");
                    }
                }
            );
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseStaffManagerController', LicenseStaffManagerController);

    LicenseStaffManagerController.$inject = ['paginationConstants', 'LicenseService', 'MessageService', 'JigyoushoResourceService', '$uibModal'];

    function LicenseStaffManagerController (paginationConstants, LicenseService, MessageService, JigyoushoResourceService, $uibModal) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 用户列表
        vm.staffList = [];
        // 事业所list
        vm.jigyoushoList = [];
        // serviceType list
        vm.serviceTypeList = [];
        // license使用数
        vm.licenseUsedList = [];
        // 查询条件
        vm.searchData = {jigyoushoId: "", loginId: "", name: ""};
        vm.defaultSearchData = {jigyoushoId: "", loginId: "", name: ""};

        vm.noGroup = true;

        // 查询serviceType
        vm.loadServiceTypeList = loadServiceTypeList;
        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 编辑用户service
        vm.edit = edit;

        // 加载完成之后自动执行
        loadData();
        loadServiceTypeList();

        function loadServiceTypeList() {
            JigyoushoResourceService.serviceTypeList(function(result){
                vm.jigyoushoList = result;
            });
        }

        function loadData() {
            if (vm.searchData.jigyoushoId != '') {
                vm.noJigyousho = false;
                LicenseService.queryStaff({
                    page: vm.page - 1,
                    jigyoushoId: vm.searchData.jigyoushoId,
                    loginId: vm.searchData.loginId,
                    name: vm.searchData.name}, function(result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.staffList = result;
                });
                LicenseService.houjinLicenseSumByJigyousho({jigyoushoId: vm.searchData.jigyoushoId}, function(result){
                    vm.licenseUsedList = result;
                });
            } else {
                vm.noJigyousho = true;
            }

        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            //vm.defaultSearchData.jigyoushoId = vm.searchData.jigyoushoId;
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function edit(model) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/customer/license/staff/dialog/license-staff-edit-dialog.html',
                controller: 'LicenseStaffEditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    param: function(){
                        return model;
                    }
                }
            });
            modalInstance.result.then(function() {
                loadData();
            },function(){
                loadData();
            })
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('license-staff', {
            parent: 'app',
            url: '/settings/license-staff',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/customer/license/staff/license-staff.html',
                    controller: 'LicenseStaffController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('license');
                    return $translate.refresh();
                }]
            }
        }).state('license-staff.edit', {
            parent: 'license-staff',
            url: '/edit/{jigyoushoId}/{staffId}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/customer/license/staff/dialog/license-staff-edit-dialog.html',
                    controller: 'LicenseStaffEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        param: {userId: $stateParams.userId, groupId: $stateParams.groupId}
                    }
                }).result.then(function() {
                    $state.go('license-staff', null, { reload: true });
                }, function() {
                    $state.go('license-staff');
                });
            }]
        }).state('license-staff-manager', {
            parent: 'app',
            url: '/settings/license-staff-manager',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/customer/license/staff/license-staff-manager.html',
                    controller: 'LicenseStaffManagerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('license');
                    return $translate.refresh();
                }]
            }
        }).state('license-staff-manager.edit', {
            parent: 'license-staff-manager',
            url: '/edit/{jigyoushoId}/{staffId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/customer/license/staff/dialog/license-staff-edit-dialog.html',
                    controller: 'LicenseStaffEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        param: {userId: $stateParams.userId, groupId: $stateParams.groupId}
                    }
                }).result.then(function() {
                    $state.go('license-staff', null, { reload: true });
                }, function() {
                    $state.go('license-staff');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseStaffController', LicenseStaffController);

    LicenseStaffController.$inject = ['paginationConstants', 'LicenseService', 'MessageService', 'JigyoushoResourceService', '$uibModal'];

    function LicenseStaffController (paginationConstants, LicenseService, MessageService, JigyoushoResourceService, $uibModal) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 用户列表
        vm.staffList = [];
        // 事业所list
        vm.jigyoushoList = [];
        // license使用数
        vm.licenseUsedList = [];
        // 查询条件
        vm.searchData = {houjinId: "", houjinNm: "", jigyoushoId: "", jigyoushoCd: "", loginId: "", name: ""};
        vm.defaultSearchData = {houjinId: "", houjinNm: "", jigyoushoId: "", jigyoushoCd: "", loginId: "", name: ""};

        vm.noGroup = true;

        // 查询条件选择法人
        vm.selectHoujin = selectHoujin;
        // 查询事业所list
        vm.loadJigyoushoList = loadJigyoushoList;
        // 初始加载数据
        vm.loadData = loadData;
        // 点击查询
        vm.search = search;
        // 清空搜索条件
        vm.clear = clear;
        // 编辑用户service
        vm.edit = edit;

        // 加载完成之后自动执行
        loadData();

        function selectHoujin() {
            var modalInstance = $uibModal.open({
                templateUrl : 'app/master/houjin/dialog/houjin-select-dialog.html',
                controller : 'HoujinSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size : 'lg',
                resolve : {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('houjin');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(function(result) {
                if (result != '') {
                    vm.searchData.houjinId = result.id;
                    vm.searchData.houjinNm = result.name;

                    vm.searchData.jigyoushoId = "";
                    vm.searchData.jigyoushoCd = "";
                    // 根据法人查询出来对应的事业所列表
                    loadJigyoushoList(vm.searchData.houjinId);
                }
            },function(){
                //MessageService.error("global.error.internalServerError");
            })
        }

        function loadJigyoushoList() {
            JigyoushoResourceService.jigyoushoList({houjinId: vm.searchData.houjinId}, function(result){
                vm.jigyoushoList = result;
                if (vm.jigyoushoList.length > 0) {
                    vm.searchData.jigyoushoId = vm.jigyoushoList[0].jigyoushoId;
                }
                loadData();
            });
        }

        function loadData() {
            if (vm.searchData.jigyoushoId != '') {
                vm.noJigyousho = false;
                LicenseService.queryStaff({
                    page: vm.page - 1,
                    jigyoushoId: vm.searchData.jigyoushoId,
                    loginId: vm.searchData.loginId,
                    name: vm.searchData.name}, function(result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.staffList = result;
                    vm.queryCount = vm.totalItems;
                });
            } else {
                vm.noJigyousho = true;
            }
            if (vm.searchData.houjinId != '') {
                LicenseService.houjinLicenseSum({houjinId: vm.searchData.houjinId}, function(result){
                    vm.licenseUsedList = result;
                });
            }
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.defaultSearchData.houjinId = vm.searchData.houjinId;
            vm.defaultSearchData.houjinNm = vm.searchData.houjinNm;
            vm.defaultSearchData.jigyoushoId = vm.searchData.jigyoushoId;
            vm.defaultSearchData.jigyoushoCd = vm.searchData.jigyoushoCd;
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function edit(model) {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/customer/license/staff/dialog/license-staff-edit-dialog.html',
                controller: 'LicenseStaffEditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    param: function(){
                        return model;
                    }
                }
            });
            modalInstance.result.then(function() {
                loadData();
            },function(){
                loadData();
            })
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LicenseStaffEditDialogController', LicenseStaffEditDialogController);

    LicenseStaffEditDialogController.$inject = ['$uibModalInstance', 'MessageService', 'LicenseService', 'param', '$timeout', '$rootScope'];

    function LicenseStaffEditDialogController ($uibModalInstance, MessageService, LicenseService, param, $timeout, $rootScope) {

        var vm = this;

        // 基本信息
        vm.info = {groupNm: "", login: "", username: ""};
        // ライセンス
        vm.licenses = [];
        //vm.license = {licenseId: null, productTypeId: null, productTypeNm: "", shopId: null, shopNm: "", productId: null, productNm: "", usedFlg: false};

        vm.endDateCheckShow = false;

        // 初始加载数据
        vm.loadData = loadData;

        // 关闭dialog
        vm.clear = clear;

        // 保存数据
        vm.save = save;

        // 关闭dialog
        vm.close = close;

        // 设置用户的license
        vm.setLicense = setLicense;

        vm.useFlag = false;

        loadData();

        function loadData() {
            if (param.jigyoushoId != null && param.jigyoushoId != '' && param.staffId != null && param.staffId != '') {
                // 基本信息的取得
                LicenseService.getStaffInfo({jigyoushoId: param.jigyoushoId, staffId: param.staffId}, function(result){
                    vm.info = result;
                });
                // 取得购买的license的种别
                LicenseService.getStaffLicense({jigyoushoId: param.jigyoushoId, staffId: param.staffId}, function(result){
                    vm.licenses = result;
                    vm.useFlag = false;
                });
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {

            vm.endDateCheckShow = false;

            if ($('#startDateCheck').is(':hidden') && $('#endDateCheck').is(':hidden')) {
                if ((new Date($('#startDate').val())).getTime() > (new Date($('#endDate').val())).getTime()) {
                    vm.endDateCheckShow = true;
                    return false;
                } else {
                    vm.endDateCheckShow = false;
                }
            }

            var entity = angular.copy(vm.license);
            entity.startDate = $('#startDate').val() == '' ? null : $('#startDate').val();
            entity.endDate = $('#endDate').val() == '' ? null : $('#endDate').val();
            LicenseService.save(entity, function(result){
                MessageService.success("license.message.saved");
                $uibModalInstance.close(result);
                $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
            });
        }

        function close () {
            $uibModalInstance.dismiss('cancel');
        }

        function setLicense(license) {
            vm.useFlag = true;
            license.jigyoushoId = param.jigyoushoId;
            license.staffId = param.staffId;
            LicenseService.setUserLicense(license,
                function(){
                    MessageService.success("global.messages.info.update");
                    loadData();
                },
                function(result){
                    license.usedFlg = false;
                    vm.useFlag = false;
                    if (result.status == "406") {
                        alert("ライセンス使用数が最大ので、設定できません。");
                    } else {
                        MessageService.error("global.messages.error.save");
                    }
                }
            );
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('staff', {
            parent: 'app',
            url: '/staff',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/corporation/staff/staff.html',
                    controller: 'StaffController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //$translatePartialLoader.addPart('staff');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StaffController', StaffController);

    StaffController.$inject = [];

    function StaffController () {

        var vm = this;

        // スタッフ列表
        vm.staffList = [];

        // 进入页面，加载初始数据
        vm.loadData = loadData();

        // 删除指定staff
        vm.remove = remove;

        function loadData() {
            var staff1 = {loginId: "test1", sei: "泉", mei: "一郎", productNm: "ケアリス", shopNm: "ケア樹", beginDate: "2018/05/16", useStop: true};
            var staff2 = {loginId: "test2", sei: "泉", mei: "二郎", productNm: "ケアリス", shopNm: "ケア樹", beginDate: "2018/05/16", useStop: false};
            vm.staffList.push(staff1);
            vm.staffList.push(staff2);
        }

        function remove(index) {
            vm.staffList.splice(index, 1);
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('staff.edit', {
            parent: 'staff',
            url: '/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/corporation/staff/detail/staff-edit.html',
                    controller: 'StaffEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //$translatePartialLoader.addPart('staff');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('StaffEditController', StaffEditController);

    StaffEditController.$inject = [];

    function StaffEditController () {

        var vm = this;

        // スタッフ
        vm.staff = {};

        // 进入页面，加载初始数据
        vm.loadData = loadData();

        vm.back = back;

        function loadData() {
            vm.staff = {
                jigyoushoCd: "4580012",
                jigyoushoNm: "グッドツリー介護事業所",
                loginId: "",
                password: "",
                sei: "",
                mei: "",
                seiKana: "",
                meiKana: "",
                productId: "",
                productNm: "",
                beginDate: "",
                useStop: true,
                shopId: "",
                shopNm: ""
            }
        }

        function back() {
            history.back();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('timeFormatZenToHan', ['$filter',timeFormatZenToHan]);

    var convert = function(val) {
        if (val === undefined || val === null) {
            return val;
        }
        var hanKatakanaList = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ":");
        var zenKatakanaList = new Array("０", "１", "２", "３", "４", "５", "６", "７", "８", "９", "：");
        //全角数字和冒号转半角
        for (var i = 0; i < val.length; i++) {
            for (var j = 0; j < hanKatakanaList.length; j++) {
                val = val.replace(zenKatakanaList[j], hanKatakanaList[j]);
            }
        }
        if (val.length === 3) {
            if (val.match(/^[0-9]:[0-9]$/)) {
                // 「9:0」 →「09:00」
                val = "0" + val.substring(0, 1) + ":0" + val.substring(2, 3);
            } else if (val.match(/^[0-9][0-9][0-9]$/)) {
                // 「915」 →「09:15」
                val = "0" + val.substring(0, 1) + ":" + val.substring(1, 3);
            }

        } else if (val.length === 4) {
            if (val.match(/^[0-9][0-9][0-9][0-9]$/)) {
                // 「0915」 →「09:15」
                val = val.substring(0, 2) + ":" + val.substring(2, 4);
            } else if (val.match(/^[0-9]:[0-9][0-9]$/)) {
                // 「9:15」 →「09:15」
                val = "0" + val;
            } else if (val.match(/^[0-9][0-9]:[0-9]$/)) {
                // 「09:5」 →「09:05」
                val = val.substring(0, 2) + ":0" + val.substring(3, 4);
            }
        }

        if (val.match(/^[0-2][0-9]:([0-5][0-9])$/)) {
            // （「26:00」→「02:00」）
            var hh = parseInt(val.substring(0, 2), 10);
            if (hh >= 24) {
                hh -= 24;
                if (hh < 10) {
                    hh = "0" + hh;
                }
                val = hh + val.substring(2, 5);
            }
        }
        return val;
    }

    function timeFormatZenToHan ($filter) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, ctrl) {
                    elem.bind("blur",function(){
                        var viewValue = ctrl.$viewValue;
                        viewValue = convert(viewValue);
                        ctrl.$viewValue = viewValue;
                        ctrl.$render();
                        return viewValue;
                    });
            }
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('timeFormatHanToZen', ['$filter',timeFormatHanToZen]);

    var convert = function(val) {
        if (val === undefined || val === null) {
            return val;
        }
        var hanKatakanaList = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ":");
        var zenKatakanaList = new Array("０", "１", "２", "３", "４", "５", "６", "７", "８", "９", "：");
        //半角数字和冒号转全角
        for (var i = 0; i < val.length; i++) {
            for (var j = 0; j < hanKatakanaList.length; j++) {
                val = val.replace(hanKatakanaList[j], zenKatakanaList[j]);
            }
        }
        return val;
     }

    function timeFormatHanToZen ($filter) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, ctrl) {
                    elem.bind("blur",function(){
                        var viewValue = ctrl.$viewValue;
                        viewValue = convert(viewValue);
                        ctrl.$viewValue = viewValue;
                        ctrl.$render();
                        return viewValue;
                    });
            }
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('timeFormat', ['$filter',timeFormat]);

    var convert = function(val) {
        if (val === undefined || val === null) {
            return val;
        }
        if (val.length === 3) {
            if (val.match(/^[0-9]:[0-9]$/)) {
                // 「9:0」 →「09:00」
                val = "0" + val.substring(0, 1) + ":0" + val.substring(2, 3);
            } else if (val.match(/^[0-9][0-9][0-9]$/)) {
                // 「915」 →「09:15」
                val = "0" + val.substring(0, 1) + ":" + val.substring(1, 3);
            }

        } else if (val.length === 4) {
            if (val.match(/^[0-9][0-9][0-9][0-9]$/)) {
                // 「0915」 →「09:15」
                val = val.substring(0, 2) + ":" + val.substring(2, 4);
            } else if (val.match(/^[0-9]:[0-9][0-9]$/)) {
                // 「9:15」 →「09:15」
                val = "0" + val;
            } else if (val.match(/^[0-9][0-9]:[0-9]$/)) {
                // 「09:5」 →「09:05」
                val = val.substring(0, 2) + ":0" + val.substring(3, 4);
            }
        }

        if (val.match(/^[0-2][0-9]:([0-5][0-9])$/)) {
            // （「26:00」→「02:00」）
            var hh = parseInt(val.substring(0, 2), 10);
            if (hh >= 24) {
                hh -= 24;
                if (hh < 10) {
                    hh = "0" + hh;
                }
                val = hh + val.substring(2, 5);
            }
        }
        console.log(val);
        return val;
    }

    function timeFormat ($filter) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, ctrl) {
                    elem.bind("blur",function(){
                        var viewValue = ctrl.$viewValue;
                        viewValue = convert(viewValue);
                        ctrl.$viewValue = viewValue;
                        ctrl.$render();
                        return viewValue;
                    });
            }
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .filter('startsWith50On', startsWith50On);

    function startsWith50On() {
        return startsWith50On;

        function startsWith50On(items, key) {
            var filtered = [];
            var letterMatch = new RegExp('', 'i');
            if (key === 'ｱ') {
                letterMatch = new RegExp('[ｱｲｳｴｵ]', 'i');
            } else if (key === 'ｶ') {
                letterMatch = new RegExp('[ｶｷｸｹｺ]', 'i');
            } else if (key === 'ｻ') {
                letterMatch = new RegExp('[ｻｼｽｾｿ]', 'i');
            } else if (key === 'ﾀ') {
                letterMatch = new RegExp('[ﾀﾁﾂﾃﾄ]', 'i');
            } else if (key === 'ﾅ') {
                letterMatch = new RegExp('[ﾅﾆﾇﾈﾉ]', 'i');
            } else if (key === 'ﾊ') {
                letterMatch = new RegExp('[ﾊﾋﾌﾍﾎ]', 'i');
            } else if (key === 'ﾏ') {
                letterMatch = new RegExp('[ﾏﾐﾑﾒﾓ]', 'i');
            } else if (key === 'ﾔ') {
                letterMatch = new RegExp('[ﾔﾕﾖ]', 'i');
            } else if (key === 'ﾗ') {
                letterMatch = new RegExp('[ﾗﾘﾙﾚﾛ]', 'i');
            } else if (key === 'ﾜ') {
                letterMatch = new RegExp('[ﾜｦﾝ]', 'i');
            }

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (item.seiKana !== null && letterMatch.test(item.seiKana.substring(0, 1))) {
                    filtered.push(item);
                }
            }
            return filtered;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('gatewayApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('numberFormatZenToHan', ['$filter',numberFormatZenToHan]);

    var convert = function(val) {
        if (val === undefined || val === null) {
            return val;
        }
        var hanKatakanaList = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9");
        var zenKatakanaList = new Array("０", "１", "２", "３", "４", "５", "６", "７", "８", "９");
        //全角数字转半角
        for (var i = 0; i < val.length; i++) {
            for (var j = 0; j < hanKatakanaList.length; j++) {
                val = val.replace(zenKatakanaList[j], hanKatakanaList[j]);
            }
        }
        return val;
    }

    function numberFormatZenToHan ($filter) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, ctrl) {
                elem.bind("blur",function(){
                    var viewValue = ctrl.$viewValue;
                    viewValue = convert(viewValue);
                    ctrl.$viewValue = viewValue;
                    ctrl.$render();
                    return viewValue;
                });
            }
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('ngEcharts', ngEcharts);

    function ngEcharts () {
        return {
            link: function(scope,element,attrs,ctrl){
                function refreshChart(){
                    var theme = (scope.config && scope.config.theme)
                        ? scope.config.theme : 'default';
                    var chart = echarts.init(element[0],theme);
                    console.log(chart);
                    if(scope.config && scope.config.dataLoaded === false){
                        chart.showLoading();
                    }

                    if(scope.config && scope.config.dataLoaded){
                        chart.setOption(scope.option);
                        chart.resize();
                        chart.hideLoading();
                    }

                    if(scope.config && scope.config.event){
                        if(angular.isArray(scope.config.event)){
                            angular.forEach(scope.config.event,function(value,key){
                                for(var e in value){
                                    chart.on(e,value[e]);
                                }
                            });
                        }
                    }
                };

                //自定义参数 - config
                // event 定义事件
                // theme 主题名称
                // dataLoaded 数据是否加载

                scope.$watch(
                    function () { return scope.config; },
                    function (value) {if (value) {refreshChart();}},
                    true
                );

                //图表原生option
                scope.$watch(
                    function () { return scope.option; },
                    function (value) {if (value) {refreshChart();}},
                    true
                );
            },
            scope:{
                option:'=ecOption',
                config:'=ecConfig'
            },
            restrict:'EA'
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('kataKana', kataKana);

    function kataKana () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        var hanAlphabetList = new Array("a", "b", "c", "d", "e", "f", "g", "h", "i",
            "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w",
            "x", "y", "z", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K",
            "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y",
            "Z", "!", "\"", "#", "$", "%", "&", "'", "(", ")", "*", "+", ",", "-",
            ".", "/", ":", ";", "<", "=", ">", "?", "@", "[", "\\", "]", "^", "_",
            "`", "{", "|", "}", "~");

         var zenAlphabetList = new Array("ａ", "ｂ", "ｃ", "ｄ", "ｅ", "ｆ", "ｇ", "ｈ", "ｉ",
            "ｊ", "ｋ", "ｌ", "ｍ", "ｎ", "ｏ", "ｐ", "ｑ", "ｒ", "ｓ", "ｔ", "ｕ", "ｖ", "ｗ",
            "ｘ", "ｙ", "ｚ", "Ａ", "Ｂ", "Ｃ", "Ｄ", "Ｅ", "Ｆ", "Ｇ", "Ｈ", "Ｉ", "Ｊ", "Ｋ",
            "Ｌ", "Ｍ", "Ｎ", "Ｏ", "Ｐ", "Ｑ", "Ｒ", "Ｓ", "Ｔ", "Ｕ", "Ｖ", "Ｗ", "Ｘ", "Ｙ",
            "Ｚ", "！", "”", "＃", "＄", "％", "＆", "’", "（", "）", "＊", "＋", "，", "－",
            "．", "／", "：", "；", "＜", "＝", "＞", "？", "＠", "［", "￥", "］", "＾", "＿",
            "｀", "｛", "｜", "｝", "￣");

        var hanKatakanaList = new Array("ｱ", "ｲ", "ｳ", "ｴ", "ｵ", "ｶ", "ｷ", "ｸ", "ｹ",
            "ｺ", "ｻ", "ｼ", "ｽ", "ｾ", "ｿ", "ﾀ", "ﾁ", "ﾂ", "ﾃ", "ﾄ", "ﾅ", "ﾆ", "ﾇ",
            "ﾈ", "ﾉ",

            "ﾊ", "ﾋ", "ﾌ", "ﾍ", "ﾎ", "ﾏ", "ﾐ", "ﾑ", "ﾒ", "ﾓ", "ﾔ", "ﾕ", "ﾖ", "ﾗ",
            "ﾘ", "ﾙ", "ﾚ", "ﾛ", "ﾜ", "ｦ", "ﾝ", "ｶﾞ", "ｷﾞ", "ｸﾞ", "ｹﾞ", "ｺﾞ",

            "ｻﾞ", "ｼﾞ", "ｽﾞ", "ｾﾞ", "ｿﾞ", "ﾀﾞ", "ﾁﾞ", "ﾂﾞ", "ﾃﾞ", "ﾄﾞ", "ﾊﾞ", "ﾋﾞ",
            "ﾌﾞ", "ﾍﾞ", "ﾎﾞ", "ﾊﾟ", "ﾋﾟ", "ﾌﾟ", "ﾍﾟ", "ﾎﾟ",

            "ｧ", "ｨ", "ｩ", "ｪ", "ｫ", "ｬ", "ｭ", "ｮ", "ｯ", "ｰ", "｢", "｣", "0", "1",
            "2", "3", "4", "5", "6", "7", "8", "9", " ");

         var zenKatakanaList = new Array("ア", "イ", "ウ", "エ", "オ", "カ", "キ", "ク", "ケ",
            "コ", "サ", "シ", "ス", "セ", "ソ", "タ", "チ", "ツ", "テ", "ト", "ナ", "ニ", "ヌ",
            "ネ", "ノ",

            "ハ", "ヒ", "フ", "ヘ", "ホ", "マ", "ミ", "ム", "メ", "モ", "ヤ", "ユ", "ヨ", "ラ",
            "リ", "ル", "レ", "ロ", "ワ", "ヲ", "ン", "ガ", "ギ", "グ", "ゲ", "ゴ",

            "ザ", "ジ", "ズ", "ゼ", "ゾ", "ダ", "ヂ", "ヅ", "デ", "ド", "バ", "ビ", "ブ", "ベ",
            "ボ", "パ", "ピ", "プ", "ペ", "ポ",

            "ァ", "ィ", "ゥ", "ェ", "ォ", "ャ", "ュ", "ョ", "ッ", "ー", "「", "」", "０", "１",
            "２", "３", "４", "５", "６", "７", "８", "９", "　");

          var zenHiraganaList = new Array("あ", "い", "う", "え", "お", "か", "き", "く", "け",
            "こ", "さ", "し", "す", "せ", "そ", "た", "ち", "つ", "て", "と", "な", "に", "ぬ",
            "ね", "の",

            "は", "ひ", "ふ", "へ", "ほ", "ま", "み", "む", "め", "も", "や", "ゆ", "よ", "ら",
            "り", "る", "れ", "ろ", "わ", "を", "ん", "が", "ぎ", "ぐ", "げ", "ご",

            "ざ", "じ", "ず", "ぜ", "ぞ", "だ", "ぢ", "づ", "で", "ど", "ば", "び", "ぶ", "べ",
            "ぼ", "ぱ", "ぴ", "ぷ", "ぺ", "ぽ",

            "ぁ", "ぃ", "ぅ", "ぇ", "ぉ", "ゃ", "ゅ", "ょ", "っ", "ー", "「", "」", "０", "１",
            "２", "３", "４", "５", "６", "７", "８", "９", "　");

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }
            element.on('blur',function(){
                ngModel.$setViewValue(convert2Hankaku(ngModel.$modelValue));
                ngModel.$render();
            });
        }

        function convert2Hankaku(src) {
            // ターゲットテキストを1文字ずつ置換
            for (var i = 0; i < src.length; i++) {
                for (var j = 0; j < hanKatakanaList.length; j++) {
                    src = src.replace(zenKatakanaList[j], hanKatakanaList[j]);
                    src = src.replace(zenHiraganaList[j], hanKatakanaList[j]);
                }
                for (var j = 0; j < hanAlphabetList.length; j++) {
                    src = src.replace(zenAlphabetList[j], hanAlphabetList[j]);
                }
            }
            return src;
        }
    }

})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
            '全{{$ctrl.queryCount}}件中　'+
            '{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}件〜'+
            '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}件を表示' +
                    // 'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    // '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    // 'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('gatewayApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('durationFormat', ['moment',durationFormat]);

    function durationFormat (moment) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elem, attrs, ctrl) {
                ctrl.$formatters.push(function(value){
                    if (angular.isUndefined(value) || value === "" || value === null) {
                        return value;
                    }
                    var duration = moment.duration(value);
                    return moment.utc(duration.as('milliseconds')).format("HH:mm");
                });
            }
        };

        return directive;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('TimezoneService', TimezoneService);

    TimezoneService.$inject = ['Enum'];

    function TimezoneService (Enum) {
        var service = {
            getOffset: getOffset
        };

        return service;

        function getOffset (timezone) {
            Enum.getTimeCard2({name:"Timezone"},function(result){
                angular.forEach(result,function(data,index,array){
                    if (data.code === timezone) {
                        console.log(data.name);
                        return data.name;
                    }
                });
            });
            return "+0900";
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .provider('MessageService', MessageService);

    function MessageService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$rootScope', '$translate'];

        function getService ($rootScope, $translate) {

            return {
                success: success,
                error: error,
                errorWithSecond: errorWithSecond,
                warning: warning
            };

            function success(message) {
                var str = [];
                if ($rootScope.msgs) {
                    str = JSON.parse($rootScope.msgs);
                }
                var myDate = new Date();
                str.push({"text": $translate.instant(message), "time": myDate.getHours() + ":" + (myDate.getMinutes() > 9 ? myDate.getMinutes() : "0" + myDate.getMinutes()), "type": "message_success"});
                $rootScope.msgs = JSON.stringify(str);
                $rootScope.$broadcast('messageChanged');
            }

            function error(message) {
                var str = [];
                if ($rootScope.msgs) {
                    str = JSON.parse($rootScope.msgs);
                }
                var myDate = new Date();
                str.push({"text": $translate.instant(message), "time": myDate.getHours() + ":" + (myDate.getMinutes() > 9 ? myDate.getMinutes() : "0" + myDate.getMinutes()), "type": "message_error"});
                $rootScope.msgs = JSON.stringify(str);
                $rootScope.$broadcast('messageChanged');
            }

            function errorWithSecond(message, second) {
                var str = [];
                if ($rootScope.msgs) {
                    str = JSON.parse($rootScope.msgs);
                }
                var myDate = new Date();
                str.push({"text": $translate.instant(message), "time": myDate.getHours() + ":" + (myDate.getMinutes() > 9 ? myDate.getMinutes() : "0" + myDate.getMinutes()), "type": "message_error"});
                $rootScope.msgs = JSON.stringify(str);
                $rootScope.$broadcast('messageShowWithTime', second);
            }

            function warning(message) {
                var str = [];
                if ($rootScope.msgs) {
                    str = JSON.parse($rootScope.msgs);
                }
                var myDate = new Date();
                str.push({"text": $translate.instant(message), "time": myDate.getHours() + ":" + (myDate.getMinutes() > 9 ? myDate.getMinutes() : "0" + myDate.getMinutes()), "type": "message_warning"});
                $rootScope.msgs = JSON.stringify(str);
                $rootScope.$broadcast('messageChanged');
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            var userName = "";
            var password = "";
            var rememberMe = "";
            if($("#login li.active").attr("value") == 1){
                userName = vm.jigyoushoCd + ";" + vm.usernameOne;
                password = vm.passwordOne;
                rememberMe = vm.rememberMeOne;
            }else{
                userName = vm.username;
                password = vm.password
                rememberMe = vm.rememberMe;
            };
            event.preventDefault();
            Auth.login({
                username: userName,
                password: password,
                rememberMe: rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'ua': 'Українська',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'ja',
            'zh-cn'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('checkProductTypeRepeat', checkProductTypeRepeat);

    checkProductTypeRepeat.$inject = ['ProductType', '$q'];

    function checkProductTypeRepeat (ProductType, $q) {

        var directive = {
            restrict: 'AE',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ctrl) {
            ctrl.$asyncValidators.productTypeRepeat = function(modelValue) {
                var d = $q.defer();
                ProductType.checkRepeat({name: modelValue}, function(result){
                    if (result.id == scope.$eval(attrs.checkProductTypeRepeat) || result.id == 0) {
                        d.resolve();
                    } else {
                        d.reject();
                    }
                });
                return d.promise;
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('gatewayApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('gatewayApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('gatewayApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('gatewayApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('gatewayApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "ja"');
                $cookies.putObject(name, 'ja');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('ja');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('gatewayApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('CommentDialogController',CommentDialogController);

    CommentDialogController.$inject = ['$filter', '$uibModalInstance', 'entity', 'Comment', 'MessageService','Jigyousho', '$timeout', '$rootScope', 'Principal'];
    function CommentDialogController ($filter, $uibModalInstance, entity, Comment, MessageService, Jigyousho, $timeout, $rootScope, Principal) {
        var vm = this;
        vm.isOpen = false;
        vm.clear = clear;
        vm.loadComment = loadComment();
        vm.comment = null;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.a = null;
        function openCalendar(){
            vm.isOpen = true;
        }
        function loadComment() {
            if(entity.id != '' || entity.id != null){
                Comment.get({id: entity.id}, function (result) {
                    vm.comment = result;
                    vm.comment.datumDay = new Date($filter('date')(vm.comment.datumDay, "yyyy/MM/dd"));
                });
            }else{
                vm.comment = entity;
                return false;
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            MessageService.success("riyoushaAnalyze.home.updated");
            $uibModalInstance.close(result);
            $timeout(function(){$rootScope.$broadcast('commentUpdate');}, 500);
        }

        function onSaveError () {
            MessageService.error("save_error.home.save_error");
            vm.isSaving = false;
        }

        function save(){
            vm.isSaving = true;
            vm.comment.commentDate = new Date();
            var entity = angular.copy(vm.comment);
            entity.datumDay = $('#datumDay').val() == '' ? null : $('#datumDay').val();

            Comment.update(entity, onSaveSuccess, onSaveError);
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('analyze', {
            parent: 'app',
            url: '/analyze',
            data: {
                pageTitle: 'global.menu.analyze.main'
            },
            views: {
                'content@': {
                    templateUrl: 'app/analyze/riyousha-analyze.html',
                    controller: 'RiyoushaAnalyzeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('riyousha-analyze');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$state', 'LicenseService', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',
                function($state, LicenseService, $uibModal, Principal, $uibModalStack, LoginService, Kinou){
                var top = $uibModalStack.getTop();
                if (top) {
                    $uibModalStack.dismiss(top.key);
                }
                Principal.identity().then(function(account) {
                	if (account != null) {
                        var gtc_caretree2_analyze_function_fullaccess = false;
                        var isAdmin = false;
                        var isDeveloper = false;
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_Analyze_Function_FullAccess"}, function(result){
                        	if (!result.flag) {
                        		$state.go('accessdenied');
                        	} else {
                        		plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_analyze_function_fullaccess);
                        	}
                        });
                	} else {
                		LoginService.open();
                	}
                    
                });
            }]
        })
        .state('analyze.edit',{
            parent: 'analyze',
            url: '/{id}/edit',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analyze/riyousha-analyze-dialog.html',
                    controller: 'CommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sd',
                    resolve: {
                        entity: {id: $stateParams.id}
                    }
                }).result.then(function() {
                    $state.go('analyze', null, { reload: false});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('analyze.loginredash', {
            parent: 'analyze',
            url: '/loginredash"',
            data: {
            },
            views: {
                'content@': {
                    templateUrl: 'app/analyze/login.html',
                    controller: 'RiyoushaAnalyzeController',
                    controllerAs: 'vm'
                }
            },
            onEnter: function () {
            }
        }).state('analyze.redash', {
            parent: 'analyze',
            url: '/redash/{jigyoushoId}/{riyoushaId}/{jisshiDt}/{jisshiDtBefore}',
            data: {
                pageTitle: 'global.menu.analyze.main'
            },
            views: {
                'content@': {
                    templateUrl: 'app/analyze/login.html',
                    controller: 'LoginRedashController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('riyousha-analyze');
                    return $translate.refresh();
                }]
            }
        }).state('analyze.show', {
            parent: 'analyze',
            url: '/photo/{id}/show',
            data: {
                pageTitle: 'global.menu.system.photo'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analyze/photo-show-dialog.html',
                    controller: 'AnalyzePhotoShowDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Uploader', function(Uploader) {
                            return Uploader.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('photo', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('analyzeshow',{
            parent: '',
            url: '/analyzeshow/{riyoushaId}/{jigyoushoId}/{jisshiDt}',
            data: {
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/analyze/analyzeshow.html',
                    controller: 'AnalyzeshowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                analyzeParams: ['$stateParams', function ($stateParams){
                    return $stateParams;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('riyousha-analyze');
                    return $translate.refresh();
                }]
            }
        });
    }
    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_analyze_function_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_Analyze_Function_FullAccess') {
                    gtc_caretree2_analyze_function_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_analyze_function_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RiyoushaAnalyzeController', RiyoushaAnalyzeController);

    RiyoushaAnalyzeController.$inject = ['Principal', '$location','$anchorScroll','ParseLinks','paginationConstants','Uploader','$scope','$timeout','Library','Group','Upload','$filter','Comment','User','MessageService','$rootScope','Analyze','$uibModal', 'Kinou'];
    function RiyoushaAnalyzeController(Principal, $location,$anchorScroll,ParseLinks,paginationConstants,Uploader,$scope,$timeout,Library,Group,Upload,$filter,Comment,User,MessageService,$rootScope,Analyze,$uibModal, Kinou) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.jigyoushoChange = jigyoushoChange;
        vm.change = change;

        var jisshiDtBefore = null;
        var jisshiDtBeforeWeight = null;
        var jisshiDtSixteen = null;
        var jisshiDtSeventeen = null;
        vm.endDate = "";
        vm.userDto = {};
        vm.groupList = [];
        vm.group = {};
        vm.riyoushaList = [];
        vm.riyousha = {};
        vm.jisshiDt = new Date();
        vm.redashUrl = "";
        vm.commentsList = [];
        vm.commentsShowList = [];
        vm.comment = {id:null,riyoushaId:null,jigyoushoId:null,datumDay:null,commentContent:null,userId:null,commentDate:null};
        vm.commentNew = {id:null,riyoushaId:null,jigyoushoId:null,datumDay:null,commentContent:null,userId:null,commentDate:null};
        vm.add = add;
        vm.del = del;
        vm.delete = commentDelete;
        vm.currentYear = new Date().getFullYear();
        vm.currentMonth = new Date().getMonth() + 1;
        vm.photoList = [];
        vm.fileList = [];
        vm.picFile = null;
        vm.file = null;
        vm.rest = rest;
        vm.nextMonth = nextMonth;
        vm.beforeMonth = beforeMonth;
        vm.save = save;
        vm.uploadPic = uploadPic;
        vm.uploadFile = uploadFile;
        vm.loadUrl = loadUrl;
        vm.isMobile = isMobile;
        vm.isOpen = false;
        vm.isMonth == false;
        vm.openCalendar = openCalendar;
        vm.showLoading = false;
        vm.showFlag = false;
        loadAll();
        vm.loginRedash = "";
        vm.links = null;
        vm.totalItems = null;
        vm.page = 1;
        vm.clickTab = clickTab;
        vm.loadPhotos = loadPhotos;
        vm.loadPhotos();
        vm.loadFiles = loadFiles;
        vm.loadFiles();
        vm.delphoto = delphoto;
        vm.delFile = delFile;
        vm.downloadByActiveState = downloadByActiveState;
        vm.downloadByActiveState2 = downloadByActiveState2;
        vm.downloadByTemperature = downloadByTemperature;
        vm.downloadByPulse = downloadByPulse;
        vm.downloadByActivity = downloadByActivity;
        vm.downloadByBloodPressure = downloadByBloodPressure;
        vm.downloadByGetUp = downloadByGetUp;
        vm.downloadBySleep = downloadBySleep;
        vm.downloadBySpo2 = downloadBySpo2;
        vm.downloadByDiet = downloadByDiet;
        vm.downloadByWeight = downloadByWeight;
        vm.showWords = showWords;
        vm.hidenWords = hidenWords;
        vm.base64Img2Blob = base64Img2Blob;
        vm.downloadFile = downloadFile;
        vm.csvDownload = csvDownload;
        vm.changePublishType = changePublishType;
        vm.changePublishTypeByText = changePublishTypeByText;
        vm.changeCommentPublishType = changeCommentPublishType;
        vm.changeCommentPublishTypeByText = changeCommentPublishTypeByText;
        vm.commentDisabled = commentDisabled;
        vm.commentContentChange = commentContentChange;
        vm.show= show;
        vm.download = download;
        vm.commentEdit = commentEdit;
        vm.commentFlag = true;
        vm.isCommentSaving = false;
        vm.isSaving = false;
        vm.isFileSaving = false;
        vm.disabledFlag = false;

        vm.activeStateXList = [];
        //D01起上り
        vm.okiagariYList = [];
        //D02端座位
        vm.tanzaiYList = [];
        //D03離床
        vm.rishouYList = [];
        //D04柵越え
        vm.sakugoeYList = [];
        //D05ずり落ち
        vm.ziriochiYList = [];
        //D06入室
        vm.nyuusituYList = [];
        //D07退室
        vm.taishitsuYList = [];
        //D10動き出し
        vm.tenYList = [];
        //D11入床
        vm.elevenYList = [];
        //D12体動
        vm.twelveYList = [];

        vm.contentActiveState = "実施日,提供時間,起上り,端座位,離床,柵越え,ずり落ち,入室,退室,動き出し,入床,体動" + "\n";
        vm.contentActiveState2 = "実施日,提供時間,右側端,左側端,頭側端,足側端,呼び出し,応答,心拍高,心拍低,呼吸高,呼吸低" + "\n";
        vm.temperatureXList = [];
        vm.temperatureYList = [];
        vm.contentTemperature = "実施日,体温" + "\n";
        vm.pulseXList = [];
        vm.pulseYList = [];
        vm.contentPulse = "実施日,脈拍" + "\n";
        vm.activityXList = [];
        vm.activityNumberYList = [];
        vm.activityActiveYList = [];
        vm.activityExYList = [];
        vm.contentActivity = "実施日,活動量" + "\n";
        vm.bloodPressureXList = [];
        vm.bloodPressureUYList = [];
        vm.bloodPressureLYList = [];
        vm.contentBloodPressure = "実施日,血圧【上】,血圧【下】" + "\n";
        vm.getUpXList = [];
        vm.getUpYList = [];
        vm.contentGetUp = "実施日,起床時間" + "\n";
        vm.sleepXList = [];
        vm.sleepYList = [];
        vm.contentSleep = "実施日,就寝時間" + "\n";
        vm.spo2XList = [];
        vm.spo2YList = [];
        vm.spo2TemperatureList = [];
        vm.contentSpo2 = "実施日,SPO2,体温" + "\n";
        vm.dietList = [];
        vm.dietFrontList = [];
        vm.dietAfterList = [];
        vm.contentDiet = "実施日,食事,水分,排尿,排便,体重"+ "\n";
        vm.weightXList = [];
        vm.weightYList = [];
        vm.contentWeight = "実施日,体重" + "\n";
        vm.number = 0;
        vm.xLength = "75%";
        vm.yLength = "0";
        vm.library = null;
        vm.mobile_flag = isMobile();
        vm.ipadClass= "col-md-4 col-sm-4 col-xs-12 text-center";
        vm.pcClass= "col-md-3 col-sm-4 col-xs-12 text-center";
        vm.jigyoushoIpadClass= "col-md-12";
        vm.jigyoushoPcClass= "col-md-1 text-right";
        vm.jigyoushoPhonClass= "col-md-1";
        vm.riyoushaPcClass= "col-md-3";
        vm.isMobileAndIpad = false;
        vm.isPc = false;
        vm.activeStateFlag = true;
        vm.activeStateFlag2 = true;
        vm.temperatureFlag = true;
        vm.pulseFlag = true;
        vm.activityFlag = true;
        vm.bloodPressureFlag = true;
        vm.getUpFlag = true;
        vm.sleepFlag = true;
        vm.spo2Flag = true;
        vm.weightFlag = true;
        vm.dietFlag = true;
        vm.cFlag = true;
        vm.pFlag = true;
        //ケア樹わかる
        vm.isAdminAnalyzeDate = false;
        vm.isUserAnalyzeDate = false;
        vm.isCaretreeAnalyzeDate = false;
        vm.isPartnerAnalyzeDate = false;
        vm.isDeveloperAnalyzeDate = false;

        if(vm.mobile_flag == 1){
            vm.number = 1;
            vm.xLength = "center";
            vm.yLength = "5%";
        }
        if(vm.mobile_flag == 1 || vm.mobile_flag == 0){
            vm.isMobileAndIpad = true;
        }else{
            vm.isPc = true;
        }

        angular.element(document).ready(function () {
            getData();
        });

        function loadAll() {
            Principal.identity().then(function(account) {
                if (account.functions.indexOf("GTC_CareTree2_Analyze_SwitchingDate_FullAccess") != -1) {
                    vm.disabledFlag = false;
                }else{
                    vm.disabledFlag = true;
                }
                vm.isAdminAnalyzeDate = false;
                vm.isUserAnalyzeDate = false;
                vm.isCaretreeAnalyzeDate = false;
                vm.isPartnerAnalyzeDate = false;
                vm.isDeveloperAnalyzeDate = false;
                if (account != null) {
                    if (account.authorities != null) {
                        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
                            Kinou.getAuthorityFunction({roleName:"ROLE_ADMIN", functionCd:"GTC_CareTree2_Analyze_SwitchingDate_FullAccess"}, function(result){
                                if(result.flag){
                                    vm.isAdminAnalyzeDate = true;
                                }
                            });
                        }
                        if (account.authorities.indexOf("ROLE_USER") != -1) {
                            Kinou.getAuthorityFunction({roleName:"ROLE_USER", functionCd:"GTC_CareTree2_Analyze_SwitchingDate_FullAccess"}, function(result){
                                if(result.flag){
                                    vm.isUserAnalyzeDate = true;
                                }
                            });
                        }
                        if (account.authorities.indexOf("ROLE_CARETREE") != -1) {
                            Kinou.getAuthorityFunction({roleName:"ROLE_CARETREE", functionCd:"GTC_CareTree2_Analyze_SwitchingDate_FullAccess"}, function(result){
                                if(result.flag){
                                    vm.isCaretreeAnalyzeDate = true;
                                }
                            });
                        }
                        if (account.authorities.indexOf("ROLE_PARTNER") != -1) {
                            Kinou.getAuthorityFunction({roleName:"ROLE_PARTNER", functionCd:"GTC_CareTree2_Analyze_SwitchingDate_FullAccess"}, function(result){
                                if(result.flag){
                                    vm.isPartnerAnalyzeDate = true;
                                }
                            });
                        }
                        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
                            Kinou.getAuthorityFunction({roleName:"ROLE_DEVELOPER", functionCd:"GTC_CareTree2_Analyze_SwitchingDate_FullAccess"}, function(result){
                                if(result.flag){
                                    vm.isDeveloperAnalyzeDate = true;
                                }
                            });
                        }
                        console.log(vm.isCaretreeAnalyzeDate);
                    }
                }

            });
            $anchorScroll.yOffset = 30;
            $location.hash('');
            $anchorScroll();
            vm.commentsList.push(vm.comment);
            vm.loadUrl();
            var beforeWeight = angular.copy(vm.jisshiDt);
            beforeWeight.setMonth(beforeWeight.getMonth()-6);
            var yWeight = beforeWeight.getFullYear();
            var mWeight = beforeWeight.getMonth()+1;
            var dWeight = beforeWeight.getDate();
            if(mWeight<10) {
                mWeight="0"+mWeight;
            }
            if(dWeight<10) {
                dWeight="0"+dWeight;
            }
            //jisshiDtBefore = new Date(Date.parse(y + '/' + m + '/' + d));
            jisshiDtBefore = getTargetday(-31,vm.jisshiDt);
            //jisshiDtSixteen = new Date(Date.parse(y + '/' + m + '/' + sixteenDay));
            jisshiDtSixteen = getTargetday(-16,vm.jisshiDt);
            //jisshiDtSeventeen = new Date(Date.parse(y + '/' + m + '/' + seventeenDay));
            jisshiDtSeventeen = getTargetday(-15,vm.jisshiDt);
            jisshiDtBeforeWeight = new Date(Date.parse(yWeight + '/' + mWeight + '/' + dWeight));
            Analyze.getGroups({}, function(result) {
                vm.groupList = result;
                Group.riyoushaList({groupId:vm.group.id},function (result) {
                    vm.riyoushaList = result;
                    Comment.commentList({riyoushaId: vm.riyousha.id,jigyoushoId: vm.group.jigyoushoId,jisshiDt: $filter('date')(vm.jisshiDt, "yyyy-MM-dd"),jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                        vm.commentsShowList = result;
                        vm.commentsList = [];
                        vm.commentNew.commentContent = null;
                        vm.commentsList.push(vm.commentNew);
                    });
                    activeState2(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt);
                    activeState(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt);
                    temperature(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
                    pulse(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
                    activity(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
                    bloodPressure(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
                    getUp(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
                    sleep(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
                    spo2(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
                    diet(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore,1);
                    diet(vm.riyousha.id,vm.group.jigyoushoId,jisshiDtSixteen,jisshiDtBefore,2);
                    diet(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtSeventeen,3);
                    weightweight(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);

                    vm.loadPhotos();
                    vm.loadFiles();
                });
            });
        }
        function delphoto(id) {
            if(confirm("写真を削除してもよろしいでしょうか？")){
                Comment.del({id: id}, onDeleteSuccess, onDeleteError);
            }
        }
        function delFile(id){
            if(confirm("ファイルを削除してもよろしいでしょうか？")){
                Comment.del({id: id}, onDeleteFileSuccess, onDeleteFileError);
            }
        }
        function onDeleteSuccess() {
            MessageService.success("riyoushaAnalyze.home.success");
            vm.loadPhotos();
        }
        function onDeleteError() {
            MessageService.error("riyoushaAnalyze.home.error");
        }
        function onDeleteFileSuccess() {
            MessageService.success("riyoushaAnalyze.home.fileSuccess");
            vm.loadFiles();
        }
        function onDeleteFileError() {
            MessageService.error("riyoushaAnalyze.home.fileError");
        }
        function loadPhotos() {
            formateJisshiDt(vm.jisshiDt);
            Comment.getPhotoList({riyoushaId: vm.riyousha.id,startDt: $filter('date')(jisshiDtBefore, "yyyy-MM-dd HH:mm:ss"),
                endDt: $filter('date')(vm.endDate, "yyyy-MM-dd HH:mm:ss"),groupId: vm.group.id,
                page: vm.page - 1, size: paginationConstants.itemsPerPage}, function(result, headers){
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.photoList = result;
                for(var i = 0; i < vm.photoList.length; i++){
                    getUserName(i);
                }
                vm.pFlag = true;
            },function () {
                vm.pFlag = true;
            });
            Comment.user({}, function (result) {
                vm.userDto = result;
            });
        }
        function loadFiles(){
            formateJisshiDt(vm.jisshiDt);
            Comment.getFileList({riyoushaId: vm.riyousha.id,startDt: $filter('date')(jisshiDtBefore, "yyyy-MM-dd HH:mm:ss"),
                endDt: $filter('date')(vm.endDate, "yyyy-MM-dd HH:mm:ss"),groupId: vm.group.id,
                page: vm.page - 1, size: paginationConstants.itemsPerPage}, function(result, headers){
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.fileList = result;
                for(var i = 0; i < vm.fileList.length; i++){
                    getUserNameByFile(i);
                }
                vm.pFlag = true;
            },function () {
                vm.pFlag = true;
            });
            Comment.user({}, function (result) {
                vm.userDto = result;
            });
        }
        function getUserName(i){
            User.get({login: vm.photoList[i].lastModifiedBy},function (r) {
                vm.photoList[i].lastModifiedBy = r.lastName + " " + r.firstName;
            });
        }
        function getUserNameByFile(i){
            User.get({login: vm.fileList[i].lastModifiedBy},function (r) {
                vm.fileList[i].lastModifiedBy = r.lastName + " " + r.firstName;
            });
        }
        function jigyoushoChange() {
            Group.riyoushaList({groupId:vm.group.id},function (result) {
                vm.riyoushaList = result;
                vm.riyousha = vm.riyoushaList[0];
                change();
            },function(a){
                vm.riyoushaList = [];
            });
        }
        function changePublishTypeByText(photo, type){
            photo.publishType = type;
            changePublishType(photo.id,type);
        }
        function change() {
            vm.temperatureFlag = false;
            vm.pulseFlag = false;
            vm.activityFlag = false;
            vm.bloodPressureFlag = false;
            vm.getUpFlag = false;
            vm.sleepFlag = false;
            vm.spo2Flag = false;
            vm.weightFlag = false;
            vm.dietFlag = false;
            vm.cFlag = false;
            vm.pFlag = false;
            vm.activeStateFlag = false;
            vm.activeStateFlag2 = true;
            var beforeWeight = angular.copy(vm.jisshiDt);
            beforeWeight.setMonth(beforeWeight.getMonth()-6);
            var yWeight = beforeWeight.getFullYear();
            var mWeight = beforeWeight.getMonth()+1;
            var dWeight = beforeWeight.getDate();
            if(mWeight<10) {
                mWeight="0"+mWeight;
            }
            if(dWeight<10) {
                dWeight="0"+dWeight;
            }
            //jisshiDtBefore = new Date(Date.parse(y + '/' + m + '/' + d));
            jisshiDtBefore = getTargetday(-31,vm.jisshiDt);
            //jisshiDtSixteen = new Date(Date.parse(y + '/' + m + '/' + sixteenDay));
            jisshiDtSixteen = getTargetday(-16,vm.jisshiDt);
            //jisshiDtSeventeen = new Date(Date.parse(y + '/' + m + '/' + seventeenDay));
            jisshiDtSeventeen = getTargetday(-15,vm.jisshiDt);
            jisshiDtBeforeWeight = new Date(Date.parse(yWeight + '/' + mWeight + '/' + dWeight));
            if(vm.riyousha == null){
                vm.riyousha = {};
                vm.riyousha.id = 0;
            }
            if(vm.riyousha.id == undefined){
                vm.riyousha.id = 0;
            }
            if(vm.group.jigyoushoId == null){
                vm.group.jigyoushoId = 0;
            }
            Comment.commentList({riyoushaId: vm.riyousha.id,jigyoushoId: vm.group.jigyoushoId,jisshiDt: $filter('date')(vm.jisshiDt, "yyyy-MM-dd"),jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.commentsShowList = result;
                vm.commentsList = [];
                vm.commentNew.commentContent = null;
                vm.commentsList.push(vm.commentNew);
                vm.cFlag = true;
            }, function () {
                vm.cFlag = true;
            });
            activeState2(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt);
            activeState(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt);
            temperature(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
            pulse(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
            activity(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
            bloodPressure(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
            getUp(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
            sleep(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
            spo2(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
            weightweight(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore);
            diet(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore,1);
            diet(vm.riyousha.id,vm.group.jigyoushoId,jisshiDtSixteen,jisshiDtBefore,2);
            diet(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtSeventeen,3);
            vm.loadPhotos();
            vm.loadFiles();
            commentDisabled(vm.group.id,vm.riyousha.id,vm.commentsList[0].commentContent);
        }
        function add(){
            vm.commentsList.push(angular.copy(vm.commentNew));
        }
        function del(index) {
            vm.commentsList.splice(index, 1);
        }
        function rest(){
            analyzeFullAccess(2);
            vm.jisshiDt = new Date();
            change();
        }
        function nextMonth() {
            analyzeFullAccess(2);
            if(!vm.isMonth){
                return false;
            }
            var date = vm.jisshiDt;
            date.setMonth(date.getMonth()+1);
            var y = date.getFullYear();
            var m = date.getMonth()+1;
            var d = date.getDate();
            if(m<10) {
                m="0"+m;
            }
            if(d<10) {
                d="0"+d;
            }
            vm.jisshiDt = new Date(Date.parse(y + '/' + m + '/' + d));
            change();
        }
        function beforeMonth() {
            analyzeFullAccess(2);
            if(!vm.isMonth){
                return false;
            }
            var date = vm.jisshiDt;
            date.setMonth(date.getMonth()-1);
            var y = date.getFullYear();
            var m = date.getMonth()+1;
            var d = date.getDate();
            if(m<10) {
                m="0"+m;
            }
            if(d<10) {
                d="0"+d;
            }
            vm.jisshiDt = new Date(Date.parse(y + '/' + m + '/' + d));
            change();
        }
        function onSaveSuccess () {
            vm.isCommentSaving = false;
            change();
            MessageService.success("riyoushaAnalyze.home.saved");
            $rootScope.$broadcast('messageChanged');
        }
        function onSaveError () {
            vm.isCommentSaving = false;
            MessageService.error("riyoushaAnalyze.home.save_error");
        }
        function commentDelete(id){
            var con=confirm("コメントを削除してもよろしいでしょうか？");
            if (con)
            {
                Comment.delete({id:id},
                    function () {
                        Comment.commentList({riyoushaId: vm.riyousha.id,jigyoushoId: vm.group.jigyoushoId,jisshiDt: $filter('date')(vm.jisshiDt, "yyyy-MM-dd"),jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                            vm.commentsShowList = result;
                        });
                        MessageService.success("riyoushaAnalyze.home.deleted");
                    }, function () {}
                );
            }
            else{
            }
        }
        function save(){
            vm.isCommentSaving = true;
            for(var i = 0; i<vm.commentsList.length; i++){
                vm.commentsList[i].riyoushaId = vm.riyousha.id;
                vm.commentsList[i].jigyoushoId = vm.group.jigyoushoId;
                vm.commentsList[i].commentDate = new Date();
                vm.commentsList[i].datumDay = $('#jisshiDt').val() == '' ? null : $('#jisshiDt').val();
            }

            Comment.save({commentVMList:vm.commentsList}, onSaveSuccess, onSaveError);
            Comment.commentList({riyoushaId: vm.riyousha.id,jigyoushoId: vm.group.jigyoushoId,jisshiDt: $filter('date')(vm.jisshiDt, "yyyy-MM-dd"),jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.commentsShowList = result;
            });
        }
        function uploadPic(){
            vm.isSaving = true;
            var orientation = null;
            var result=vm.picFile.name.split(".");
            var fileType = result[result.length-1];
            if(fileType != "jpg" && fileType != "jpeg" && fileType != "png" && fileType != "gif"){
                alert("画像ではない場合は「ファイル」画面から登録してください。");
                vm.picFile = null;
                vm.isSaving = false;
                return false;
            }
            EXIF.getData(vm.picFile, function() {
                EXIF.getAllTags(vm.picFile);
                orientation = EXIF.getTag(vm.picFile, 'Orientation');
                if(orientation == undefined){
                    orientation = 0;
                }
                Upload.upload({
                    url: 'library/api/analyzeUpload',
                    data: {fileName: vm.picFile.name, file: vm.picFile, photoFlg: 1, adminFlg: false, groupId: vm.group.id, riyoushaId: vm.riyousha.id, uploadDate: new Date(vm.jisshiDt), orientation: orientation}
                }).success(function () {
                    MessageService.success("riyoushaAnalyze.home.photosuccess");
                    vm.loadPhotos();
                    vm.picFile = null;
                    vm.isSaving = false;
                }).error(function () {
                    MessageService.error("riyoushaAnalyze.home.photoerror");
                    vm.isSaving = false;
                });
            });
        }
        function uploadFile(){
            var fileSize = vm.file.size * 0.0009766 * 0.0009766;
            vm.isFileSaving = true;
            var orientation = null;
            var result=vm.file.name.split(".");
            var fileType = result[result.length-1];
            if(fileType == "jpg" || fileType == "jpeg" || fileType == "png" || fileType == "gif"){
                alert("画像は「写真」画面から登録してください。");
                vm.file = null;
                vm.isFileSaving = false;
                return false;
            }

            if(fileSize > 10){
                alert("ファイルサイズが10MBを超えているため登録できません。");
                vm.file = null;
                vm.isFileSaving = false;
                return false;
            }
            EXIF.getData(vm.file, function() {
                EXIF.getAllTags(vm.file);
                orientation = EXIF.getTag(vm.file, 'Orientation');
                if(orientation == undefined){
                    orientation = 0;
                }
                Upload.upload({
                    url: 'library/api/fileUpload',
                    data: {fileName: vm.file.name, file: vm.file, photoFlg: 0, adminFlg: false, groupId: vm.group.id, riyoushaId: vm.riyousha.id, uploadDate: new Date(vm.jisshiDt), orientation: orientation}
                }).success(function () {
                    MessageService.success("riyoushaAnalyze.home.photosuccess");
                    vm.loadFiles();
                    vm.file = null;
                    vm.isFileSaving = false;
                }).error(function () {
                    MessageService.error("riyoushaAnalyze.home.photoerror");
                    vm.isFileSaving = false;
                });
            });
        }
        function loadUrl() {
            Library.url(function(result){
                vm.url = result.url;
            })
        }
        $scope.$on('commentUpdate', function() {
            Comment.commentList({riyoushaId: vm.riyousha.id,jigyoushoId: vm.group.jigyoushoId,jisshiDt: $filter('date')(vm.jisshiDt, "yyyy-MM-dd"),jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.commentsShowList = result;
            });
        });
        function openCalendar(){
            analyzeFullAccess(1);
        }

        function analyzeFullAccess(parameter){
            Principal.identity().then(function(account) {
                if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
                    vm.isAdminAnalyzeDate = true;
                }
                if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
                    vm.isDeveloperAnalyzeDate = true;
                }
                if (account.functions.indexOf("GTC_CareTree2_Analyze_SwitchingDate_FullAccess") != -1 || vm.isAdminAnalyzeDate || vm.isDeveloperAnalyzeDate) {
                    if(parameter == 1){
                        vm.isOpen = true;
                    }else{
                        vm.isMonth = true;
                    }

                }else{
                    if(parameter == 1){
                        vm.isOpen = false;
                    }else{
                        vm.isMonth = false;
                    }
                    $uibModal.open({
                        templateUrl: 'app/home/dialog/license.html',
                        controller: 'HomeLicenseController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function() {
                        $state.go('home', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }
            });

        }

        function downloadByActiveState(){
            var downloadLink = document.getElementById('downloadByActiveState');
            vm.contentActiveState = encodeURIComponent(vm.contentActiveState);
            downloadLink.download = '.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentActiveState;
        }
        function downloadByActiveState2(){
            var downloadLink = document.getElementById('downloadByActiveState2');
            vm.contentActiveState2 = encodeURIComponent(vm.contentActiveState2);
            downloadLink.download = '.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentActiveState2;
        }
        function downloadByTemperature(){
            var downloadLink = document.getElementById('downloadByTemperature');
            vm.contentTemperature = encodeURIComponent(vm.contentTemperature);
            downloadLink.download = '活動状態.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentTemperature;
        }
        function downloadByPulse(){
            var downloadLink = document.getElementById('downloadByPulse');
            vm.contentPulse = encodeURIComponent(vm.contentPulse);
            downloadLink.download = '脈拍.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentPulse;
        }
        function downloadByActivity(){
            var downloadLink = document.getElementById('downloadByActivity');
            vm.contentActivity = encodeURIComponent(vm.contentActivity);
            downloadLink.download = '活動量.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentActivity;
        }
        function downloadByBloodPressure(){
            var downloadLink = document.getElementById('downloadByBloodPressure');
            vm.contentBloodPressure = encodeURIComponent(vm.contentBloodPressure);
            downloadLink.download = '血圧.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentBloodPressure;
        }
        function downloadByGetUp(){
            var downloadLink = document.getElementById('downloadByGetUp');
            vm.contentGetUp = encodeURIComponent(vm.contentGetUp);
            downloadLink.download = '起床.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentGetUp;
        }
        function downloadBySleep(){
            var downloadLink = document.getElementById('downloadBySleep');
            vm.contentSleep = encodeURIComponent(vm.contentSleep);
            downloadLink.download = '就寝.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentSleep;
        }
        function downloadBySpo2(){
            var downloadLink = document.getElementById('downloadBySpo2');
            vm.contentSpo2 = encodeURIComponent(vm.contentSpo2);
            downloadLink.download = 'SPO2.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentSpo2;
        }
        function downloadByDiet(){
            vm.showFlag = true;
            var downloadLink;
            if(vm.isPc){
                downloadLink = document.getElementById('downloadByDiet');
            }else{
                downloadLink = document.getElementById('downloadByDietIpad');
            }
            if(confirm("CSVファイルをダウンロードしますか？")){
                var userAgent = navigator.userAgent;
                if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                    csvDownload('食事/水分/排泄/体重.csv',vm.contentDiet);
                }else{
                    diet(vm.riyousha.id,vm.group.jigyoushoId,vm.jisshiDt,jisshiDtBefore,1);
                    downloadLink.download = '食事/水分/排泄/体重.csv';
                    //downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentDiet;
                    var str =  encodeURIComponent(vm.contentDiet);
                    downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                }

                vm.showFlag = false;
            }else{
                vm.showFlag = false;
                downloadLink.href = "";
            }
        }
        function downloadByWeight(){
            var downloadLink = document.getElementById('downloadByWeight');
            vm.contentWeight = encodeURIComponent(vm.contentWeight);
            downloadLink.download = '体重.csv';
            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentWeight;
        }
        function activeState2(riyoushaId,jigyoushoId,jisshiDt){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            vm.thirteenYList = [];
            vm.fourteenYList = [];
            vm.fifteenYList = [];
            vm.sixteenYList = [];
            vm.seventeenYList = [];
            vm.eighteenYList = [];
            vm.nineteenYList = [];
            vm.twentyYList = [];
            vm.twentyOneYList = [];
            vm.twentyTwoYList = [];
            vm.contentActiveState2 = "実施日,提供時間,右側端,左側端,頭側端,足側端,呼び出し,応答,心拍高,心拍低,呼吸高,呼吸低" + "\n";
            Analyze.getActiveState({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt},
                function(result){
                    //循环24小时
                    for(var i=0;i<result.length;i++){
                        var thirteen = "";
                        var fourteen = "";
                        var fifteen = "";
                        var sixteen = "";
                        var seventeen = "";
                        var eighteen = "";
                        var nineteen = "";
                        var twenty = "";
                        var twentyOne = "";
                        var twentyTwo = "";
                        var D13 = 0;
                        var D14 = 0;
                        var D15 = 0;
                        var D16 = 0;
                        var D17 = 0;
                        var D18 = 0;
                        var D19 = 0;
                        var D20 = 0;
                        var D21 = 0;
                        var D22 = 0;
                        if(result[i].bikou == undefined){
                            vm.thirteenYList.push(0);
                            vm.fourteenYList.push(0);
                            vm.fifteenYList.push(0);
                            vm.sixteenYList.push(0);
                            vm.seventeenYList.push(0);
                            vm.eighteenYList.push(0);
                            vm.nineteenYList.push(0);
                            vm.twentyYList.push(0);
                            vm.twentyOneYList.push(0);
                            vm.twentyTwoYList.push(0);
                        }else{
                            var tmType = result[i].bikou.split(",");
                            //循环同一个小时有多条数据
                            for(var a=0;a<tmType.length;a++){
                                var type = tmType[a].split("回");
                                if(type==''){
                                    vm.thirteenYList.push(0);
                                    vm.fourteenYList.push(0);
                                    vm.fifteenYList.push(0);
                                    vm.sixteenYList.push(0);
                                    vm.seventeenYList.push(0);
                                    vm.eighteenYList.push(0);
                                    vm.nineteenYList.push(0);
                                    vm.twentyYList.push(0);
                                    vm.twentyOneYList.push(0);
                                    vm.twentyTwoYList.push(0);
                                }else{
                                    //循环备考里每一项的值
                                    for(var x=0;x<type.length;x++){
                                        //D13右側端
                                        if(type[x].indexOf("D13") >= 0){
                                            D13 = parseInt(D13) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D14") >= 0){
                                            //D14左側端
                                            D14 = parseInt(D14) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));//0+3
                                        } else if(type[x].indexOf("D15") >= 0){
                                            //D15頭側端
                                            D15 = parseInt(D15) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D16") >= 0){
                                            //D16足側端
                                            D16 = parseInt(D16) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D17") >= 0){
                                            //D17呼び出し
                                            D17 = parseInt(D17) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D18") >= 0){
                                            //D18応答
                                            D18 = parseInt(D18) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D19") >= 0){
                                            //D19心拍高
                                            D19 = parseInt(D19) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D20") >= 0){
                                            //D20心拍低
                                            D20 = parseInt(D20) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D21") >= 0){
                                            //D21呼吸高
                                            D21 = parseInt(D21) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D22") >= 0){
                                            //D22呼吸低
                                            D22 = parseInt(D22) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        }
                                    }
                                }
                            }
                            vm.thirteenYList.push(D13);
                            thirteen = D13;
                            vm.fourteenYList.push(D14);
                            fourteen = D14;
                            vm.fifteenYList.push(D15);
                            fifteen = D15;
                            vm.sixteenYList.push(D16);
                            sixteen = D16;
                            vm.seventeenYList.push(D17);
                            seventeen = D17;
                            vm.eighteenYList.push(D18);
                            eighteen = D18;
                            vm.nineteenYList.push(D19);
                            nineteen = D19;
                            vm.twentyYList.push(D20);
                            twenty = D20;
                            vm.twentyOneYList.push(D21);
                            twentyOne = D21;
                            vm.twentyTwoYList.push(D22);
                            twentyTwo = D22;
                        }
                        var tm = "";
                        var bk = "";
                        if(result[i].kansatsuTm == undefined){
                            tm = "";
                        }else {
                            tm = result[i].kansatsuTm;
                        }
                        if(result[i].bikou == undefined){
                            bk = "";
                        }else{
                            bk = result[i].bikou;
                        }
                        vm.contentActiveState2 += jisshiDt + ',' + tm + "," + thirteen + ","+ fourteen + ","+ fifteen + ","+ sixteen + ","+ seventeen + ","+ eighteen + ","+ nineteen + ","+ twenty + ","+ twentyOne + ","+ twentyTwo + ","+ "\n";
                    }
                    vm.activeStateFlag2 = true;
                },function () {
                    vm.activeStateFlag2 = true;
                });
        }
        function activeState(riyoushaId,jigyoushoId,jisshiDt){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            vm.okiagariYList = [];
            vm.tanzaiYList = [];
            vm.rishouYList = [];
            vm.sakugoeYList = [];
            vm.ziriochiYList = [];
            vm.nyuusituYList = [];
            vm.taishitsuYList = [];
            vm.tenYList = [];
            vm.elevenYList = [];
            vm.twelveYList = [];
            vm.contentActiveState = "実施日,提供時間,起上り,端座位,離床,柵越え,ずり落ち,入室,退室,動き出し,入床,体動" + "\n";
            Analyze.getActiveState({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt},
                function(result){
                    for(var i=0;i<result.length;i++){
                        var one = "";
                        var two = "";
                        var three = "";
                        var four = "";
                        var five = "";
                        var six = "";
                        var seven = "";
                        var ten = "";
                        var eleven = "";
                        var twelve = "";
                        var D01 = 0;
                        var D02 = 0;
                        var D03 = 0;
                        var D04 = 0;
                        var D05 = 0;
                        var D06 = 0;
                        var D07 = 0;
                        var D10 = 0;
                        var D11 = 0;
                        var D12 = 0;

                        if(result[i].bikou == undefined){
                            vm.okiagariYList.push(0);
                            vm.tanzaiYList.push(0);
                            vm.rishouYList.push(0);
                            vm.sakugoeYList.push(0);
                            vm.ziriochiYList.push(0);
                            vm.nyuusituYList.push(0);
                            vm.taishitsuYList.push(0);
                            vm.tenYList.push(0);
                            vm.elevenYList.push(0);
                            vm.twelveYList.push(0);
                        }else{
                            var tmType = result[i].bikou.split(",");
                            for(var a=0;a<tmType.length;a++){
                                var type = tmType[a].split("回");
                                if(type==''){
                                    vm.okiagariYList.push(0);
                                    vm.tanzaiYList.push(0);
                                    vm.rishouYList.push(0);
                                    vm.sakugoeYList.push(0);
                                    vm.ziriochiYList.push(0);
                                    vm.nyuusituYList.push(0);
                                    vm.taishitsuYList.push(0);
                                    vm.tenYList.push(0);
                                    vm.elevenYList.push(0);
                                    vm.twelveYList.push(0);
                                }else{
                                    for(var x=0;x<type.length;x++){
                                        //D01起上り
                                        if(type[x].indexOf("D01") >= 0){
                                            D01 = parseInt(D01) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D02") >= 0){
                                            //D02端座位
                                            D02 = parseInt(D02) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D03") >= 0){
                                            //D03離床
                                            D03 = parseInt(D03) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D04") >= 0){
                                            //D04柵越え
                                            D04 = parseInt(D04) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D05") >= 0){
                                            //D05ずり落ち
                                            D05 = parseInt(D05) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D06") >= 0){
                                            //D06入室
                                            D06 = parseInt(D06) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D07") >= 0){
                                            //D07退室
                                            D07 = parseInt(D07) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D10") >= 0){
                                            //D10動き出し
                                            D10 = parseInt(D10) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D11") >= 0){
                                            //D11入床
                                            D11 = parseInt(D11) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D12") >= 0){
                                            //D12体動
                                            D12 = parseInt(D12) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        }
                                    }
                                }
                            }
                            vm.okiagariYList.push(D01);
                            one = D01;
                            vm.tanzaiYList.push(D02);
                            two = D02;
                            vm.rishouYList.push(D03);
                            three = D03;
                            vm.sakugoeYList.push(D04);
                            four = D04;
                            vm.ziriochiYList.push(D05);
                            five = D05;
                            vm.nyuusituYList.push(D06);
                            six = D06;
                            vm.taishitsuYList.push(D07);
                            seven = D07;
                            vm.tenYList.push(D10);
                            ten = D10;
                            vm.elevenYList.push(D11);
                            eleven = D11;
                            vm.twelveYList.push(D12);
                            twelve = D12;
                        }
                        var tm = "";
                        var bk = "";
                        if(result[i].kansatsuTm == undefined){
                            tm = "";
                        }else {
                            tm = result[i].kansatsuTm;
                        }
                        if(result[i].bikou == undefined){
                            bk = "";
                        }else{
                            bk = result[i].bikou;
                        }
                        vm.contentActiveState += jisshiDt + ',' + tm + "," + one + ","+ two + ","+ three + ","+ four + ","+ five + ","+ six + ","+ seven + ","+ ten + ","+ eleven + ","+ twelve + ","+ "\n";
                    }
                    vm.activeStateFlag = true;
                },function () {
                    vm.activeStateFlag = true;
                });
        }
        function temperature(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getTemperature({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.temperatureXList.length = 0;
                vm.temperatureYList.length = 0;
                vm.contentTemperature = "実施日,体温" + "\n";
                for(var r in result){
                    if(r <= 32){
                        vm.temperatureXList.push(result[r].jisshiDt);
                        vm.temperatureYList.push(result[r].taion);
                        if(result[r].taion == null){
                            result[r].taion = "";
                        }
                        vm.contentTemperature += result[r].jisshiDt + "," + result[r].taion + " \n";
                    }
                }
                vm.temperatureFlag = true;
            }, function(){
                vm.temperatureFlag = true;
            });
        }
        function pulse(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getPulse({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.pulseXList.length = 0;
                vm.pulseYList.length = 0;
                vm.contentPulse = "実施日,脈拍" + "\n";
                for(var r in result){
                    if(r <= 32){
                        vm.pulseXList.push(result[r].jisshiDt);
                        vm.pulseYList.push(result[r].myakuhaku);
                        if(result[r].myakuhaku == null){
                            result[r].myakuhaku = "";
                        }
                        vm.contentPulse += result[r].jisshiDt + "," + result[r].myakuhaku + "\n";
                    }
                }
                vm.pulseFlag = true;
            }, function () {
                vm.pulseFlag = true;
            });
        }
        function activity(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getActivity({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.activityXList.length = 0;
                vm.activityNumberYList.length = 0;
                vm.activityActiveYList.length = 0;
                vm.activityExYList.length = 0;
                vm.contentActivity = "実施日,歩数,アクティブ歩数,Ex" + "\n";
                for(var r in result){
                    if(r <= 32){
                        vm.activityXList.push(result[r].jisshiDt);
                        vm.activityNumberYList.push(result[r].activityNumber);
                        vm.activityActiveYList.push(result[r].active);
                        vm.activityExYList.push(result[r].activityEx);
                        if(result[r].activityNumber == null){
                            result[r].activityNumber = "";
                        }
                        if(result[r].active == null){
                            result[r].active = "";
                        }
                        if(result[r].activityEx == null){
                            result[r].activityEx = "";
                        }
                        vm.contentActivity += result[r].jisshiDt + "," + result[r].activityNumber + "," + result[r].active + "," + result[r].activityEx +"\n";
                    }
                }
                vm.activityFlag = true;
            }, function () {
                vm.activityFlag = true;
            });
        }
        function bloodPressure(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getBloodPressure({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.bloodPressureXList.length = 0;
                vm.bloodPressureUYList.length = 0;
                vm.bloodPressureLYList.length = 0;
                vm.contentBloodPressure = "実施日,血圧【上】,血圧【下】" + "\n";
                for(var r in result){
                    if(r <= 32){
                        vm.bloodPressureXList.push(result[r].jisshiDt);
                        vm.bloodPressureUYList.push(result[r].ketsuatsuUe);
                        vm.bloodPressureLYList.push(result[r].ketsuatsuShita);
                        if(result[r].ketsuatsuUe == null){
                            result[r].ketsuatsuUe = "";
                        }
                        if(result[r].ketsuatsuShita == null){
                            result[r].ketsuatsuShita = "";
                        }
                        vm.contentBloodPressure += result[r].jisshiDt + "," + result[r].ketsuatsuUe + "," + result[r].ketsuatsuShita + "\n";
                    }
                }
                vm.bloodPressureFlag = true;
            }, function () {
                vm.bloodPressureFlag = true;
            });
        }
        function getUp(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getGetUp({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt:jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd"),type:1}, function(result){
                vm.getUpXList.length = 0;
                vm.getUpYList.length = 0;
                vm.contentGetUp = "実施日,起床時間" + "\n";
                for(var r in result){
                    if(r <= 32){
                        vm.getUpXList.push(result[r].jisshiDt);
                        vm.getUpYList.push(result[r].startTime);
                        if(result[r].startTime == null){
                            result[r].startTime = "";
                        }
                        vm.contentGetUp += result[r].jisshiDt + "," + result[r].startTime + "\n";
                    }
                }
                vm.getUpFlag = true;
            }, function () {
                vm.getUpFlag = true;
            });
        }
        function sleep(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getSleep({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd"),type:2}, function(result){
                vm.sleepXList.length = 0;
                vm.sleepYList.length = 0;
                vm.contentSleep = "実施日,就寝時間" + "\n";
                for(var r in result){
                    if(r <= 32){
                        vm.sleepXList.push(result[r].jisshiDt);
                        vm.sleepYList.push(result[r].startTime);
                        if(result[r].startTime == null){
                            result[r].startTime = "";
                        }
                        vm.contentSleep += result[r].jisshiDt + "," + result[r].startTime + "\n";
                    }
                }
                vm.sleepFlag = true;
            }, function () {
                vm.sleepFlag = true;
            });
        }
        function spo2(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getTemperature({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd"),type:2}, function(result){
                vm.spo2XList.length = 0;
                vm.spo2YList.length = 0;
                vm.spo2TemperatureList.length = 0;
                vm.contentSpo2 = "実施日,SPO2,体温" + "\n";
                for(var r in result){
                    if(r <= 32){
                        vm.spo2XList.push(result[r].jisshiDt);
                        vm.spo2YList.push(result[r].spo);
                        vm.spo2TemperatureList.push(result[r].taion);
                        if(result[r].spo == null){
                            result[r].spo = "";
                        }
                        if(result[r].taion == null){
                            result[r].taion = "";
                        }
                        vm.contentSpo2 += result[r].jisshiDt + "," + result[r].spo + "," + result[r].taion + "\n";
                    }
                }
                vm.spo2Flag = true;
            }, function () {
                vm.spo2Flag = true;
            });
        }
        function diet(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore,type){
            Analyze.getDiet({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: $filter('date')(jisshiDt, "yyyy-MM-dd"),jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                if(type == 1){
                    vm.dietList.length = 0;
                    vm.dietList = result;
                    vm.contentDiet = "実施日,食事,水分,排尿,排便,体重"+ "\n";
                    for(var r in result){
                        if(r < 32){
                            if(result[r].shushokuSesshuryo == null){
                                result[r].shushokuSesshuryo = "";
                            }
                            if(result[r].suibunSesshuryo == null){
                                result[r].suibunSesshuryo = "";
                            }
                            if(result[r].nyouCount == null){
                                result[r].nyouCount = "";
                            }
                            if(result[r].benCount == null){
                                result[r].benCount = "";
                            }
                            if(result[r].taijuu == null){
                                result[r].taijuu = "";
                            }
                            vm.contentDiet += result[r].jisshiDt + "," + result[r].shushokuSesshuryo + "," + result[r].suibunSesshuryo + "," + result[r].nyouCount + "," + result[r].benCount + "," + result[r].taijuu + "\n";
                        }
                    }
                }else if(type == 2){
                    vm.dietFrontList.length = 0;
                    vm.dietFrontList = result;
                }else if(type == 3){
                    vm.dietAfterList.length = 0;
                    vm.dietAfterList = result;
                    /*var count = 16-result.length;
                    if(vm.dietAfterList.length < 16){
                        for(var i=0;i<count;i++){
                            var dto ={};
                            vm.dietAfterList.push(dto);
                        }
                    }*/
                }
                vm.dietFlag = true;
            }, function () {
                vm.dietFlag = true;
            });
        }
        function weightweight(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getWeight({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBeforeWeight, "yyyy-MM-dd"),type:2}, function(result){
                vm.weightXList.length = 0;
                vm.weightYList.length = 0;
                vm.contentWeight = "実施日,体重" + "\n";
                for(var r in result){
                    if(r <= 32){
                        vm.weightXList.push(result[r].jisshiDt);
                        vm.weightYList.push(result[r].taijuu);
                        if(result[r].taijuu == null){
                            result[r].taijuu = "";
                        }
                        vm.contentWeight += result[r].jisshiDt + "," + result[r].taijuu + "\n";
                    }
                }
                redashResize();
                //document.getElementById("scrollDiv").scrollLeft=document.getElementById("scrollDiv").scrollWidth;
                document.getElementById("scrollDiv1").scrollLeft=document.getElementById("scrollDiv1").scrollWidth;
                document.getElementById("scrollDiv2").scrollLeft=document.getElementById("scrollDiv2").scrollWidth;
                vm.weightFlag = true;
            }, function () {
                vm.weightFlag = true;
            });
        }

        function showWords() {
            vm.showFlag = true;
        }
        function hidenWords(){
            vm.showFlag = false;
        }
        function base64Img2Blob(code){
            var parts = code.split(';base64,');
            var contentType = parts[0].split(':')[1];
            var raw = window.atob(parts[1]);
            var rawLength = raw.length;
            var uInt8Array = new Uint8Array(rawLength);
            for (var i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], {type: contentType});
        }
        function downloadFile(fileName, content){
            var blob = base64Img2Blob(content);

            if (!!window.ActiveXObject || "ActiveXObject" in window){
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            }else{
                var aLink = document.createElement('a');
                aLink.download = fileName;
                aLink.href = URL.createObjectURL(blob);
                document.body.appendChild(aLink);
                aLink.click();
                document.body.removeChild(aLink);
            }
        }
        function csvDownload(fileName, content){
            var BOM = "\uFEFF";
            var csvData = new Blob([BOM + content], { type: 'text/csv' });
            navigator.msSaveBlob(csvData, fileName);
        }
        function onChangeSuccess() {
            MessageService.success("riyoushaAnalyze.home.changesuccess");
        }
        function onChangeError() {
            MessageService.error("riyoushaAnalyze.home.changeerror");
        }
        function changePublishType(id, type) {
            var data = {};
            data.id = id;
            data.publishType = type;
            Uploader.changePublishType(data, onChangeSuccess, onChangeError);
        }
        function changeCommentPublishType(id, type){
            var data = {};
            data.id = id;
            data.publishType = type;
            Comment.updatePublishType(data, onChangeSuccess, onChangeError);
        }
        function changeCommentPublishTypeByText(cs, type){
            cs.publishType = type;
            changeCommentPublishType(cs.id,type);
        }
        function commentDisabled(groupId,riyoushaId,commentContent){
            if(groupId != null && riyoushaId != null && riyoushaId != 0 && commentContent != null){
                vm.commentFlag = false;
            }else{
                vm.commentFlag = true;
            }
        }
        function commentContentChange(){
            commentDisabled(vm.group.id,vm.riyousha.id,vm.commentsList[0].commentContent);
        }
        function formateJisshiDt(jisshiDt){
            var endDate = angular.copy(jisshiDt);
            var y = endDate.getFullYear();
            var m = endDate.getMonth()+1;
            var d = endDate.getDate();
            if(m<10) {
                m="0"+m;
            }
            if(d<10) {
                d="0"+d;
            }
            var s = y + '-' + m + '-' + d+" "+"23:59:59";
            vm.endDate = new Date(s.substr(0,10)+"T"+s.substr(11,18));
        }

        //判断是iPhone，ipad，pc
        function isMobile() {
            var mobile_flag;
            var is_iPd = navigator.userAgent.match(/(iPad|iPod)/i) != null;
            var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|win ce)/i) != null;
            if(is_iPd){
                mobile_flag = 0;
            }
            if(is_mobi){
                mobile_flag = 1;
            }
            return mobile_flag;
        }
        //图片表示
        function show(id){
            var modalInstance = $uibModal.open({
                templateUrl : 'app/analyze/photo-show-dialog.html',
                controller : 'AnalyzePhotoShowDialogController',
                controllerAs: 'vm',
                size : 'lg',
                resolve : {
                    entity: ['Uploader', function(Uploader) {
                        return Uploader.get({id : id});
                    }]
                }
            });
        }
        //文件下载
        function download(id){
            var aLink = document.createElement('a');
            aLink.href = "/library/api/library/downloadfile/" + id;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink);
        }
        //comment编辑
        function commentEdit(id){
            $uibModal.open({
                templateUrl: 'app/analyze/riyousha-analyze-dialog.html',
                controller: 'CommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'sd',
                resolve: {
                    entity: {id: id}
                }
            }).result.then(function() {
                $state.go('analyze', null, { reload: false});
            }, function() {
                $state.go('^');
            });
        }
        //重新绘制图表
        function redashResize(){
            angular.element(document).ready(function () {
                getData();
            });
        }
        //写真切换到图表
        function clickTab(){
            redashResize();
        }
        function getData(){
            <!--体温-->
            var temperatureChart = echarts.init(document.getElementById('temperature'));
            var temperatureOption = {
                title: {
                    text: '体温'
                },
                grid: {
                  top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('体温.csv',vm.contentTemperature);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByTemperature');
                                            downloadLink.download = '体温.csv';
                                            var str =  encodeURIComponent(vm.contentTemperature);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("temperature").getElementsByTagName("canvas")[0];
                                        downloadFile('体温.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            },
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['体温（℃）']
                },
                xAxis: {
                    type : 'category',
                    boundaryGap : false,
                    axisLabel:{interval:vm.number,rotate:90},
                    data : vm.temperatureXList
                },
                yAxis: {
                    name: '℃',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '30',
                    max: '45'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 45, min: 0, color: 'blue'}
                    ]
                }],
                series: [{
                    name: '体温（℃）',
                    type: 'line',
                    data: vm.temperatureYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }]
            };
            temperatureChart.setOption(temperatureOption);
            <!--脈拍-->
            var pulseChart = echarts.init(document.getElementById('pulse'));
            var pulseOption = {
                title: {
                    text: '脈拍'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        /* saveAsImage : {show: true,title:"ダウンロード"},*/
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv')
                                        var userAgent = navigator.userAgent;{
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('脈拍.csv',vm.contentPulse);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByPulse');
                                            downloadLink.download = '脈拍.csv';
                                            var str =  encodeURIComponent(vm.contentPulse);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("pulse").getElementsByTagName("canvas")[0];
                                        downloadFile('脈拍.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError1");
                                })
                            }
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['脈拍（回/分）']
                },
                xAxis: {
                    type : 'category',
                    boundaryGap : false,
                    axisLabel:{interval:vm.number,rotate:90},
                    data : vm.pulseXList
                },
                yAxis : {
                    name: '回/分',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '180'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 200, min: 0, color: 'blue'}
                    ]
                }],
                series: [{
                    name: '脈拍（回/分）',
                    type: 'line',
                    data: vm.pulseYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }]
            };
            pulseChart.setOption(pulseOption);
            <!--活動量-->
            var activityChart = echarts.init(document.getElementById('activity'));
            var activityOption = {
                color: ['#FF69B4','#7FFF00','#63B8FF'],
                title: {
                    text: '活動量'
                },
                grid: {
                    top:'17%'
                },
                tooltip : {
                    trigger: 'axis'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('活動量.csv',vm.contentActivity);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByActivity');
                                            downloadLink.download = '活動量.csv';
                                            var str =  encodeURIComponent(vm.contentActivity);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("activity").getElementsByTagName("canvas")[0];
                                        downloadFile('活動量.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                legend: {
                    data:['歩数','アクティブ歩数','Ex']
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.activityXList
                    }
                ],
                yAxis : [
                    {
                        name: '歩',
                        type: 'value',
                        axisLabel:{interval:0},
                        min: '0',
                        max: '20000'
                    },
                    {
                        name: 'Ex',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '0',
                        max : '10'
                    }
                ],
                series : [{
                        name:'歩数',
                        type:'line',
                        data:vm.activityNumberYList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    },
                    {
                        name:'アクティブ歩数',
                        type:'line',
                        data:vm.activityActiveYList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    },
                    {
                        name:'Ex',
                        type:'line',
                        yAxisIndex: 1,
                        data:vm.activityExYList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    }]
            };
            activityChart.setOption(activityOption);
            <!--血圧-->
            var pressureChart = echarts.init(document.getElementById('pressure'));
            var pressureOption = {
                color: ["#B22222", "#B22222"],
                title: {
                    text: '血圧'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('血圧.csv',vm.contentBloodPressure);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByBloodPressure');
                                            downloadLink.download = '血圧.csv';
                                            var str =  encodeURIComponent(vm.contentBloodPressure);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("pressure").getElementsByTagName("canvas")[0];
                                        downloadFile('血圧.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                calculable : true,
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['血圧【上】','血圧【下】']
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.bloodPressureXList
                    }
                ],
                yAxis : [
                    {
                        name: 'mmHg',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '0',
                        max : '230'
                    },
                    {
                        name: 'mmHg',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '0',
                        max : '230'
                    }
                ],
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 300, min: 0, color: 'blue'}
                    ]
                },{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 1,
                    pieces: [
                        { max: 300, min: 0, color: 'blue'}
                    ]
                }],
                series : [
                    {
                        name:'血圧【上】',
                        type:'line',
                        data:vm.bloodPressureUYList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    },
                    {
                        name:'血圧【下】',
                        type:'line',
                        symbol: 'emptyTriangle',
                        yAxisIndex: 1,
                        data:vm.bloodPressureLYList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    }
                ]
            };
            pressureChart.setOption(pressureOption);
            <!--起床-->
            var getUpChart = echarts.init(document.getElementById('getUp'));
            var getUpOption = {
                title: {
                    text: '起床'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('起床.csv',vm.contentGetUp);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByGetUp');
                                            downloadLink.download = '起床.csv';
                                            var str =  encodeURIComponent(vm.contentGetUp);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("getUp").getElementsByTagName("canvas")[0];
                                        downloadFile('起床.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['起床']
                },
                xAxis: {
                    type : 'category',
                    boundaryGap : false,
                    axisLabel:{interval:vm.number,rotate:90},
                    data : vm.getUpXList
                },
                yAxis: {
                    name: '時間',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '24'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 24, min: 0, color: 'blue'}
                    ]
                }],
                series : {
                    name:'起床',
                    type:'line',
                    data: vm.getUpYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }
            };
            getUpChart.setOption(getUpOption);
            <!--就寝-->
            var sleepChart = echarts.init(document.getElementById('sleep'));
            var sleepOption = {
                title: {
                    text: '就寝'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('就寝.csv',vm.contentSleep);
                                        }else{
                                            var downloadLink = document.getElementById('downloadBySleep');
                                            downloadLink.download = '就寝.csv';
                                            var str =  encodeURIComponent(vm.contentSleep);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("sleep").getElementsByTagName("canvas")[0];
                                        downloadFile('就寝.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['就寝']
                },
                calculable : true,
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.sleepXList
                    }
                ],
                yAxis : {
                    name: '時間',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '24'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 24, min: 0, color: 'blue'}
                    ]
                }],
                series : {
                    name:'就寝',
                    type:'line',
                    data: vm.sleepYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }
            };
            sleepChart.setOption(sleepOption);
            <!--SPO2-->
            var spo2Chart = echarts.init(document.getElementById('spo2'));
            var spo2Option = {
                color: ["#B22222", "#B22222"],
                title: {
                    text: 'SPO2'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('SPO2.csv',vm.contentSpo2);
                                        }else{
                                            var downloadLink = document.getElementById('downloadBySpo2');
                                            downloadLink.download = 'SPO2.csv';
                                            //downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentSpo2;
                                            var str =  encodeURIComponent(vm.contentSpo2);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("spo2").getElementsByTagName("canvas")[0];
                                        downloadFile('SPO2.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                calculable : true,
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['SPO2','体温']
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.spo2XList
                    }
                ],
                yAxis : [
                    {
                        name: '%',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '0',
                        max : '150'
                    },
                    {
                        name: '℃',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '30',
                        max : '45'
                    }
                ],
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 300, min: 0, color: 'blue'}
                    ]
                },{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 1,
                    pieces: [
                        { max: 300, min: 0, color: 'blue'}
                    ]
                }],
                series : [
                    {
                        name:'SPO2',
                        type:'line',
                        data:vm.spo2YList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    },
                    {
                        name:'体温',
                        type:'line',
                        symbol: 'emptyTriangle',
                        yAxisIndex: 1,
                        data:vm.spo2TemperatureList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    }
                ]
            };
            spo2Chart.setOption(spo2Option);
            <!--体重-->
            var weightChart = echarts.init(document.getElementById('weight'));
            var weightOption = {
                title: {
                    text: '体重'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('体重.csv',vm.contentWeight);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByWeight');
                                            downloadLink.download = '体重.csv';
                                            //downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentWeight;
                                            var str =  encodeURIComponent(vm.contentWeight);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("weight").getElementsByTagName("canvas")[0];
                                        downloadFile('体重.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['体重']
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.weightXList
                    }
                ],
                yAxis : {
                    name: 'kg',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '150'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 200, min: 0, color: 'blue'}
                    ]
                }],
                series : {
                    name:'体重',
                    type:'line',
                    data: vm.weightYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }
            };
            weightChart.setOption(weightOption);
            <!--活動状態-->
            var activeStateChart = echarts.init(document.getElementById('activeState'));
            var activeStateOption = {
                color: ['#FF0000','#0000EE','#00FF00','#4B0082','#436EEE','#FF34B3','#CD919E','#8B2500','#848484','#B8860B'],
                title: {
                    text: '活動状態1'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('活動状態1.csv',vm.contentActiveState);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByActiveState');
                                            downloadLink.download = '活動状態1.csv';
                                            var str =  encodeURIComponent(vm.contentActiveState);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("activeState").getElementsByTagName("canvas")[0];
                                        downloadFile('活動状態1.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: [
                    {data:['起上り','端座位','離床　　','柵越え','ずり落ち']},
                    {
                        top: '20',
                        data:['入室　','退室　','動き出し','入床　','体動　　']
                    }
                ],
                xAxis: {
                    type : 'category',
                    axisLabel:{interval:vm.number,rotate:90},
                    data : ['0時','1時','2時','3時','4時','5時','6時','7時','8時','9時','10時','11時','12時','13時','14時','15時','16時','17時','18時','19時','20時','21時','22時','23時']
                },
                yAxis: {
                    name: '回',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '120'
                },
                series: [
                    {
                        name: '起上り',
                        type: 'bar',barWidth:15,
                        stack: '活動状態',
                        data: vm.okiagariYList
                    },
                    {
                        name: '端座位',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.tanzaiYList
                    },
                    {
                        name: '離床　　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.rishouYList
                    },
                    {
                        name: '柵越え',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.sakugoeYList
                    },
                    {
                        name: 'ずり落ち',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.ziriochiYList
                    },
                    {
                        name: '入室　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.nyuusituYList
                    },
                    {
                        name: '退室　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.taishitsuYList
                    },
                    {
                        name: '動き出し',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.tenYList
                    },
                    {
                        name: '入床　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.elevenYList
                    },
                    {
                        name: '体動　　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.twelveYList
                    }
                ]
            }
            activeStateChart.setOption(activeStateOption);
            <!--活動状態2-->
            var activeStateChart2 = echarts.init(document.getElementById('activeState2'));
            var activeStateOption2 = {
                color: ['#FF0000','#0000EE','#00FF00','#4B0082','#436EEE','#FF34B3','#CD919E','#8B2500','#848484','#B8860B'],
                title: {
                    text: '活動状態2'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('活動状態2.csv',vm.contentActiveState2);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByActiveState2');
                                            downloadLink.download = '活動状態2.csv';
                                            var str =  encodeURIComponent(vm.contentActiveState2);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("activeState2").getElementsByTagName("canvas")[0];
                                        downloadFile('活動状態2.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: [
                    {data:['右側端','左側端','頭側端','足側端','呼び出し']},
                    {
                        top: '20',
                        data:['応答　','心拍高','心拍低','呼吸高','呼吸低　']
                    }
                ],
                xAxis: {
                    type : 'category',
                    axisLabel:{interval:vm.number,rotate:90},
                    data : ['0時','1時','2時','3時','4時','5時','6時','7時','8時','9時','10時','11時','12時','13時','14時','15時','16時','17時','18時','19時','20時','21時','22時','23時']
                },
                yAxis: {
                    name: '回',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '120'
                },
                series: [
                    {
                        name: '右側端',
                        type: 'bar',barWidth:15,
                        stack: '活動状態',
                        data: vm.thirteenYList
                    },
                    {
                        name: '左側端',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.fourteenYList
                    },
                    {
                        name: '頭側端',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.fifteenYList
                    },
                    {
                        name: '足側端',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.sixteenYList
                    },
                    {
                        name: '呼び出し',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.seventeenYList
                    },
                    {
                        name: '応答　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.eighteenYList
                    },
                    {
                        name: '心拍高',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.nineteenYList
                    },
                    {
                        name: '心拍低',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.twentyYList
                    },
                    {
                        name: '呼吸高',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.twentyOneYList
                    },
                    {
                        name: '呼吸低　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.twentyTwoYList
                    }
                ]
            }
            activeStateChart2.setOption(activeStateOption2);
            window.onresize = function (){
                temperatureChart.resize();
                pulseChart.resize();
                activityChart.resize();
                pressureChart.resize();
                getUpChart.resize();
                sleepChart.resize();
                spo2Chart.resize();
                weightChart.resize();
                activeStateChart.resize();
                activeStateChart2.resize();
            };
        }
        //获取选择日期的前多少天
        function getTargetday(num,date){
            var number=null;
            if(num==null||num==0){
                number=0;
            }else{
                number=num;
            }
            var targetday_milliseconds=date.getTime()+1000*60*60*24*number;
            var targetday=new  Date();
            targetday.setTime(targetday_milliseconds);
            var y = targetday.getFullYear();
            var m = targetday.getMonth()+1;
            var d = targetday.getDate();
            targetday = new Date(Date.parse(y + '/' + m + '/' + d));
            return targetday;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AnalyzePhotoShowDialogController', AnalyzePhotoShowDialogController);

    AnalyzePhotoShowDialogController.$inject = ['entity', '$uibModalInstance'];

    function AnalyzePhotoShowDialogController(entity, $uibModalInstance) {
        var vm = this;
        vm.library = entity;

        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LoginRedashController', LoginRedashController);

    LoginRedashController.$inject = ['$stateParams','$scope','Library','Group','Upload','$filter','Comment','MessageService','$rootScope'];

    function LoginRedashController($stateParams,$scope,Library,Group,Upload,$filter,Comment,MessageService,$rootScope) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.reurl = "";

        loadAll();

        function loadAll () {
            vm.reurl = "http://analyze-test.caretree.jp/dashboard/testdashboards?p_jigyoushoId="
                + $stateParams.jigyoushoId + "&p_riyoushaId=" + $stateParams.riyoushaId
                + "&p_jisshiDt=" + $stateParams.jisshiDt + "&p_jisshiDtBefore=" + $stateParams.jisshiDtBefore + "&fullscreen";
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('DownloaddialogController', DownloaddialogController);
    DownloaddialogController.$inject = ['$uibModalInstance', 'Principal', 'Enum', 'Library', 'ParseLinks', 'paginationConstants', '$scope', '$sce'];
    function DownloaddialogController($uibModalInstance, Principal, Enum, Library, ParseLinks, paginationConstants, $scope, $sce) {
        var vm = this;

        $scope.sce = $sce.trustAsResourceUrl;
        vm.close = close;
        vm.imageDownload = imageDownload;
        vm.csvDownload = csvDownload;


        function close() {
            $uibModalInstance.close("");
        }
        function imageDownload(){
            if(confirm("画像をダウンロードしますか？")){
                $uibModalInstance.close("image");
            }
        }
        function csvDownload(){
            if(confirm("CSVファイルをダウンロードしますか？")){
                $uibModalInstance.close("csv");
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AnalyzeshowController', AnalyzeshowController);
    AnalyzeshowController.$inject = ['$stateParams', 'ParseLinks','paginationConstants','Uploader','$scope','$timeout','Library','Group','Upload','$filter','Comment','User','MessageService','$rootScope','Analyze','$uibModal'];
    function AnalyzeshowController($stateParams,ParseLinks,paginationConstants,Uploader,$scope,$timeout,Library,Group,Upload,$filter,Comment,User,MessageService,$rootScope,Analyze,$uibModal) {
        var vm = this;
        vm.riyoushaId = $stateParams.riyoushaId;
        vm.jigyoushoId = $stateParams.jigyoushoId;
        vm.jisshiDt = $stateParams.jisshiDt;
        vm.riyoushaName = "";
        vm.jigyoushoName = "";
        vm.jisshiDtBefore = "";
        var jisshiDtSixteen = null;
        var jisshiDtSeventeen = null;
        vm.formatJisshiDt = "";
        vm.groupId = "1";
        vm.page = 1;
        vm.userDto = {};
        vm.commentsShowList = [];
        vm.comment = {id:null,riyoushaId:null,jigyoushoId:null,datumDay:null,commentContent:null,userId:null,commentDate:null};
        vm.commentNew = {id:null,riyoushaId:null,jigyoushoId:null,datumDay:null,commentContent:null,userId:null,commentDate:null};
        vm.photoList = [];
        vm.fileList = [];
        vm.temperatureXList = [];
        vm.temperatureYList = [];
        vm.contentTemperature = "実施日,体温" + "\n";
        vm.pulseXList = [];
        vm.pulseYList = [];
        vm.contentPulse = "実施日,脈拍" + "\n";
        vm.activityXList = [];
        vm.activityNumberYList = [];
        vm.activityActiveYList = [];
        vm.activityExYList = [];
        vm.contentActivity = "実施日,活動量" + "\n";
        vm.bloodPressureXList = [];
        vm.bloodPressureUYList = [];
        vm.bloodPressureLYList = [];
        vm.contentBloodPressure = "実施日,血圧【上】,血圧【下】" + "\n";
        vm.getUpXList = [];
        vm.getUpYList = [];
        vm.contentGetUp = "実施日,起床時間" + "\n";
        vm.sleepXList = [];
        vm.sleepYList = [];
        vm.contentSleep = "実施日,就寝時間" + "\n";
        vm.spo2XList = [];
        vm.spo2YList = [];
        vm.spo2TemperatureList = [];
        vm.weightXList = [];
        vm.weightYList = [];
        vm.contentWeight = "実施日,体重" + "\n";
        vm.dietList = [];
        vm.dietFrontList = [];
        vm.dietAfterList = [];
        vm.contentDiet = "実施日,食事,水分,排尿,排便,体重"+ "\n";

        vm.loadAll = loadAll;
        vm.base64Img2Blob = base64Img2Blob;
        vm.downloadFile = downloadFile;
        vm.loadPhotos = loadPhotos;
        vm.loadFiles = loadFiles;
        vm.downloadByDiet = downloadByDiet;
        vm.showWords = showWords;
        vm.hidenWords = hidenWords;
        vm.showFlag = false;
        vm.show= show;
        vm.isMobile = isMobile;
        var jisshiDtBeforeWeight = null;
        vm.number = 0;
        vm.xLength = "75%";
        vm.yLength = "0";
        loadAll();
        vm.mobile_flag = isMobile();
        vm.ipadClass= "col-md-4 col-sm-4 col-xs-12 text-center";
        vm.pcClass= "col-md-3 col-sm-4 col-xs-12 text-center";
        vm.jigyoushoIpadClass= "col-md-12";
        vm.jigyoushoPcClass= "col-md-1 text-right";
        vm.riyoushaPcClass= "col-md-3";
        vm.jigyoushoPhonClass= "col-md-1";
        vm.isMobileAndIpad = false;
        vm.isPc = false;
        vm.activeStateFlag = true;
        vm.activeStateFlag2 = true;
        vm.clickTab = clickTab;
        vm.download = download;
        vm.activeStateXList = [];
        //D01起上り
        vm.okiagariYList = [];
        //D02端座位
        vm.tanzaiYList = [];
        //D03離床
        vm.rishouYList = [];
        //D04柵越え
        vm.sakugoeYList = [];
        //D05ずり落ち
        vm.ziriochiYList = [];
        //D06入室
        vm.nyuusituYList = [];
        //D07退室
        vm.taishitsuYList = [];
        //D10動き出し
        vm.tenYList = [];
        //D11入床
        vm.elevenYList = [];
        //D12体動
        vm.twelveYList = [];
        vm.contentActiveState = "実施日,提供時間,起上り,端座位,離床,柵越え,ずり落ち,入室,退室,動き出し,入床,体動" + "\n";
        vm.contentActiveState2 = "実施日,提供時間,右側端,左側端,頭側端,足側端,呼び出し,応答,心拍高,心拍低,呼吸高,呼吸低" + "\n";


        if(vm.mobile_flag){
            vm.number = 1;
            vm.xLength = "center";
            vm.yLength = "5%";
        }
        if(vm.mobile_flag == 1 || vm.mobile_flag == 0){
            vm.isMobileAndIpad = true;
        }else{
            vm.isPc = true;
        }

        angular.element(document).ready(function () {
            getData();
        });

        function loadAll() {
            vm.formatJisshiDt = new Date(vm.jisshiDt.substr(0,10)+"T"+vm.jisshiDt.substr(11,18));
            var beforeWeight = angular.copy(vm.formatJisshiDt);
            beforeWeight.setMonth(beforeWeight.getMonth()-6);
            var yWeight = beforeWeight.getFullYear();
            var mWeight = beforeWeight.getMonth()+1;
            var dWeight = beforeWeight.getDate();
            if(mWeight<10) {
                mWeight="0"+mWeight;
            }
            if(dWeight<10) {
                dWeight="0"+dWeight;
            }
            //vm.jisshiDtBefore = new Date(s.substr(0,10)+"T"+s.substr(11,18));
            vm.jisshiDtBefore = getTargetday(-31,vm.formatJisshiDt);
            //jisshiDtSixteen = new Date(sixteen.substr(0,10)+"T"+sixteen.substr(11,18));
            jisshiDtSixteen = getTargetday(-16,vm.formatJisshiDt);
            //jisshiDtSeventeen = new Date(Date.parse(y + '/' + m + '/' + seventeenDay));
            jisshiDtSeventeen = getTargetday(-15,vm.formatJisshiDt);
            jisshiDtBeforeWeight = new Date(Date.parse(yWeight + '/' + mWeight + '/' + dWeight));
            Comment.commentlistShow({riyoushaId: vm.riyoushaId,jigyoushoId: vm.jigyoushoId,jisshiDt: $filter('date')(vm.jisshiDt, "yyyy-MM-dd"),jisshiDtBefore: $filter('date')(vm.jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.commentsShowList = result;
                vm.commentsList = [];
                vm.commentNew.commentContent = null;
                vm.commentsList.push(vm.commentNew);
            });
            getRiyoushaNameAndJigyoushoId(vm.riyoushaId);
            activeState(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt);
            activeState2(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt);
            temperature(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore);
            pulse(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore);
            activity(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore);
            bloodPressure(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore);
            getUp(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore);
            sleep(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore);
            spo2(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore);
            //diet(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore,1);
            diet(vm.riyoushaId,vm.jigyoushoId,jisshiDtSixteen,vm.jisshiDtBefore,2);
            diet(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,jisshiDtSeventeen,3);
            weightweight(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore);
            loadPhotos();
            loadFiles();
        }
        function getRiyoushaNameAndJigyoushoId(riyoushaId){
            Analyze.getRiyoushaNameAndJigyoushoName({riyoushaId: riyoushaId},function(result){
                vm.riyoushaName = result["RIYOUSHANAME"];
                vm.jigyoushoName= result["JIGYOUSHONAME"];
            });
        }
        function activeState2(riyoushaId,jigyoushoId,jisshiDt){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd").substring(0,10);
            }
            vm.thirteenYList = [];
            vm.fourteenYList = [];
            vm.fifteenYList = [];
            vm.sixteenYList = [];
            vm.seventeenYList = [];
            vm.eighteenYList = [];
            vm.nineteenYList = [];
            vm.twentyYList = [];
            vm.twentyOneYList = [];
            vm.twentyTwoYList = [];
            vm.contentActiveState2 = "実施日,提供時間,右側端,左側端,頭側端,足側端,呼び出し,応答,心拍高,心拍低,呼吸高,呼吸低" + "\n";
            Analyze.getActiveState({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt},
                function(result){
                    //循环24小时
                    for(var i=0;i<result.length;i++){
                        var thirteen = "";
                        var fourteen = "";
                        var fifteen = "";
                        var sixteen = "";
                        var seventeen = "";
                        var eighteen = "";
                        var nineteen = "";
                        var twenty = "";
                        var twentyOne = "";
                        var twentyTwo = "";
                        var D13 = 0;
                        var D14 = 0;
                        var D15 = 0;
                        var D16 = 0;
                        var D17 = 0;
                        var D18 = 0;
                        var D19 = 0;
                        var D20 = 0;
                        var D21 = 0;
                        var D22 = 0;
                        if(result[i].bikou == undefined){
                            vm.thirteenYList.push(0);
                            vm.fourteenYList.push(0);
                            vm.fifteenYList.push(0);
                            vm.sixteenYList.push(0);
                            vm.seventeenYList.push(0);
                            vm.eighteenYList.push(0);
                            vm.nineteenYList.push(0);
                            vm.twentyYList.push(0);
                            vm.twentyOneYList.push(0);
                            vm.twentyTwoYList.push(0);
                        }else{
                            var tmType = result[i].bikou.split(",");
                            //循环同一个小时有多条数据
                            for(var a=0;a<tmType.length;a++){
                                var type = tmType[a].split("回");
                                if(type==''){
                                    vm.thirteenYList.push(0);
                                    vm.fourteenYList.push(0);
                                    vm.fifteenYList.push(0);
                                    vm.sixteenYList.push(0);
                                    vm.seventeenYList.push(0);
                                    vm.eighteenYList.push(0);
                                    vm.nineteenYList.push(0);
                                    vm.twentyYList.push(0);
                                    vm.twentyOneYList.push(0);
                                    vm.twentyTwoYList.push(0);
                                }else{
                                    //循环备考里每一项的值
                                    for(var x=0;x<type.length;x++){
                                        //D13右側端
                                        if(type[x].indexOf("D13") >= 0){
                                            D13 = parseInt(D13) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D14") >= 0){
                                            //D14左側端
                                            D14 = parseInt(D14) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));//0+3
                                        } else if(type[x].indexOf("D15") >= 0){
                                            //D15頭側端
                                            D15 = parseInt(D15) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D16") >= 0){
                                            //D16足側端
                                            D16 = parseInt(D16) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D17") >= 0){
                                            //D17呼び出し
                                            D17 = parseInt(D17) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D18") >= 0){
                                            //D18応答
                                            D18 = parseInt(D18) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D19") >= 0){
                                            //D19心拍高
                                            D19 = parseInt(D19) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D20") >= 0){
                                            //D20心拍低
                                            D20 = parseInt(D20) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D21") >= 0){
                                            //D21呼吸高
                                            D21 = parseInt(D21) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D22") >= 0){
                                            //D22呼吸低
                                            D22 = parseInt(D22) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        }
                                    }
                                }
                            }
                            vm.thirteenYList.push(D13);
                            thirteen = D13;
                            vm.fourteenYList.push(D14);
                            fourteen = D14;
                            vm.fifteenYList.push(D15);
                            fifteen = D15;
                            vm.sixteenYList.push(D16);
                            sixteen = D16;
                            vm.seventeenYList.push(D17);
                            seventeen = D17;
                            vm.eighteenYList.push(D18);
                            eighteen = D18;
                            vm.nineteenYList.push(D19);
                            nineteen = D19;
                            vm.twentyYList.push(D20);
                            twenty = D20;
                            vm.twentyOneYList.push(D21);
                            twentyOne = D21;
                            vm.twentyTwoYList.push(D22);
                            twentyTwo = D22;
                        }
                        var tm = "";
                        var bk = "";
                        if(result[i].kansatsuTm == undefined){
                            tm = "";
                        }else {
                            tm = result[i].kansatsuTm;
                        }
                        if(result[i].bikou == undefined){
                            bk = "";
                        }else{
                            bk = result[i].bikou;
                        }
                        vm.contentActiveState2 += jisshiDt + ',' + tm + "," + thirteen + ","+ fourteen + ","+ fifteen + ","+ sixteen + ","+ seventeen + ","+ eighteen + ","+ nineteen + ","+ twenty + ","+ twentyOne + ","+ twentyTwo + ","+ "\n";
                    }
                    vm.activeStateFlag2 = true;
                },function () {
                    vm.activeStateFlag2 = true;
                });
        }
        function activeState(riyoushaId,jigyoushoId,jisshiDt){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd").substring(0,10);
            }
            vm.okiagariYList = [];
            vm.tanzaiYList = [];
            vm.rishouYList = [];
            vm.sakugoeYList = [];
            vm.ziriochiYList = [];
            vm.nyuusituYList = [];
            vm.taishitsuYList = [];
            vm.tenYList = [];
            vm.elevenYList = [];
            vm.twelveYList = [];
            vm.contentActiveState = "実施日,提供時間,起上り,端座位,離床,柵越え,ずり落ち,入室,退室,動き出し,入床,体動" + "\n";
            Analyze.getActiveState({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt},
                function(result){
                    for(var i=0;i<result.length;i++){
                        var one = "";
                        var two = "";
                        var three = "";
                        var four = "";
                        var five = "";
                        var six = "";
                        var seven = "";
                        var ten = "";
                        var eleven = "";
                        var twelve = "";
                        var D01 = 0;
                        var D02 = 0;
                        var D03 = 0;
                        var D04 = 0;
                        var D05 = 0;
                        var D06 = 0;
                        var D07 = 0;
                        var D10 = 0;
                        var D11 = 0;
                        var D12 = 0;

                        if(result[i].bikou == undefined){
                            vm.okiagariYList.push(0);
                            vm.tanzaiYList.push(0);
                            vm.rishouYList.push(0);
                            vm.sakugoeYList.push(0);
                            vm.ziriochiYList.push(0);
                            vm.nyuusituYList.push(0);
                            vm.taishitsuYList.push(0);
                            vm.tenYList.push(0);
                            vm.elevenYList.push(0);
                            vm.twelveYList.push(0);
                        }else{
                            var tmType = result[i].bikou.split(",");
                            for(var a=0;a<tmType.length;a++){
                                var type = tmType[a].split("回");
                                if(type==''){
                                    vm.okiagariYList.push(0);
                                    vm.tanzaiYList.push(0);
                                    vm.rishouYList.push(0);
                                    vm.sakugoeYList.push(0);
                                    vm.ziriochiYList.push(0);
                                    vm.nyuusituYList.push(0);
                                    vm.taishitsuYList.push(0);
                                    vm.tenYList.push(0);
                                    vm.elevenYList.push(0);
                                    vm.twelveYList.push(0);
                                }else{
                                    for(var x=0;x<type.length;x++){
                                        //D01起上り
                                        if(type[x].indexOf("D01") >= 0){
                                            D01 = parseInt(D01) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D02") >= 0){
                                            //D02端座位
                                            D02 = parseInt(D02) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D03") >= 0){
                                            //D03離床
                                            D03 = parseInt(D03) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D04") >= 0){
                                            //D04柵越え
                                            D04 = parseInt(D04) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D05") >= 0){
                                            //D05ずり落ち
                                            D05 = parseInt(D05) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D06") >= 0){
                                            //D06入室
                                            D06 = parseInt(D06) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if(type[x].indexOf("D07") >= 0){
                                            //D07退室
                                            D07 = parseInt(D07) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D10") >= 0){
                                            //D10動き出し
                                            D10 = parseInt(D10) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D11") >= 0){
                                            //D11入床
                                            D11 = parseInt(D11) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        } else if (type[x].indexOf("D12") >= 0){
                                            //D12体動
                                            D12 = parseInt(D12) + parseInt(type[x].substring(type[x].indexOf('<')+1,type[x].indexOf('>')));
                                        }
                                    }
                                }
                            }
                            vm.okiagariYList.push(D01);
                            one = D01;
                            vm.tanzaiYList.push(D02);
                            two = D02;
                            vm.rishouYList.push(D03);
                            three = D03;
                            vm.sakugoeYList.push(D04);
                            four = D04;
                            vm.ziriochiYList.push(D05);
                            five = D05;
                            vm.nyuusituYList.push(D06);
                            six = D06;
                            vm.taishitsuYList.push(D07);
                            seven = D07;
                            vm.tenYList.push(D10);
                            ten = D10;
                            vm.elevenYList.push(D11);
                            eleven = D11;
                            vm.twelveYList.push(D12);
                            twelve = D12;
                        }
                        var tm = "";
                        var bk = "";
                        if(result[i].kansatsuTm == undefined){
                            tm = "";
                        }else {
                            tm = result[i].kansatsuTm;
                        }
                        if(result[i].bikou == undefined){
                            bk = "";
                        }else{
                            bk = result[i].bikou;
                        }
                        vm.contentActiveState += jisshiDt + ',' + tm + "," + one + ","+ two + ","+ three + ","+ four + ","+ five + ","+ six + ","+ seven + ","+ ten + ","+ eleven + ","+ twelve + ","+ "\n";
                    }
                    vm.activeStateFlag = true;
                },function () {
                    vm.activeStateFlag = true;
                });
        }
        function temperature(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }

            Analyze.getTemperature({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.temperatureXList.length = 0;
                vm.temperatureYList.length = 0;
                vm.contentTemperature = "実施日,体温" + "\n";
                for(var r in result){
                    if(r <= 31){
                        vm.temperatureXList.push(result[r].jisshiDt);
                        vm.temperatureYList.push(result[r].taion);
                        if(result[r].taion == null){
                            result[r].taion = "";
                        }
                        vm.contentTemperature += result[r].jisshiDt + "," + result[r].taion + "\n";
                    }
                }
            });
        }
        function pulse(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getPulse({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.pulseXList.length = 0;
                vm.pulseYList.length = 0;
                vm.contentPulse = "実施日,脈拍" + "\n";
                for(var r in result){
                    if(r <= 31){
                        vm.pulseXList.push(result[r].jisshiDt);
                        vm.pulseYList.push(result[r].myakuhaku);
                        if(result[r].myakuhaku == null){
                            result[r].myakuhaku = "";
                        }
                        vm.contentPulse += result[r].jisshiDt + "," + result[r].myakuhaku + "\n";
                    }
                }
            });
        }
        function activity(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getActivity({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.activityXList.length = 0;
                vm.activityNumberYList.length = 0;
                vm.activityActiveYList.length = 0;
                vm.activityExYList.length = 0;
                vm.contentActivity = "実施日,歩数,アクティブ歩数,Ex" + "\n";
                for(var r in result){
                    if(r <= 31){
                        vm.activityXList.push(result[r].jisshiDt);
                        vm.activityNumberYList.push(result[r].activityNumber);
                        vm.activityActiveYList.push(result[r].active);
                        vm.activityExYList.push(result[r].activityEx);
                        if(result[r].activityNumber == null){
                            result[r].activityNumber = "";
                        }
                        if(result[r].active == null){
                            result[r].active = "";
                        }
                        if(result[r].activityEx == null){
                            result[r].activityEx = "";
                        }
                        vm.contentActivity += result[r].jisshiDt + "," + result[r].activityNumber + "," + result[r].active + "," + result[r].activityEx +"\n";
                    }
                }
            });
        }
        function bloodPressure(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getBloodPressure({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                vm.bloodPressureXList.length = 0;
                vm.bloodPressureUYList.length = 0;
                vm.bloodPressureLYList.length = 0;
                vm.contentBloodPressure = "実施日,血圧【上】,血圧【下】" + "\n";
                for(var r in result){
                    if(r <= 31){
                        vm.bloodPressureXList.push(result[r].jisshiDt);
                        vm.bloodPressureUYList.push(result[r].ketsuatsuUe);
                        vm.bloodPressureLYList.push(result[r].ketsuatsuShita);
                        if(result[r].ketsuatsuUe == null){
                            result[r].ketsuatsuUe = "";
                        }
                        if(result[r].ketsuatsuShita == null){
                            result[r].ketsuatsuShita = "";
                        }
                        vm.contentBloodPressure += result[r].jisshiDt + "," + result[r].ketsuatsuUe + "," + result[r].ketsuatsuShita + "\n";
                    }
                }
            });
        }
        function getUp(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getGetUp({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd"),type:1}, function(result){
                vm.getUpXList.length = 0;
                vm.getUpYList.length = 0;
                vm.contentGetUp = "実施日,起床時間" + "\n";
                for(var r in result){
                    if(r <= 31){
                        vm.getUpXList.push(result[r].jisshiDt);
                        vm.getUpYList.push(result[r].startTime);
                        if(result[r].startTime == null){
                            result[r].startTime = "";
                        }
                        vm.contentGetUp += result[r].jisshiDt + "," + result[r].startTime + "\n";
                    }
                }
            });
        }
        function showWords() {
            vm.showFlag = true;
        }
        function hidenWords(){
            vm.showFlag = false;
        }
        function base64Img2Blob(code){
            var parts = code.split(';base64,');
            var contentType = parts[0].split(':')[1];
            var raw = window.atob(parts[1]);
            var rawLength = raw.length;
            var uInt8Array = new Uint8Array(rawLength);
            for (var i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], {type: contentType});
        }
        function downloadFile(fileName, content){
            var aLink = document.createElement('a');
            var blob = base64Img2Blob(content); //new Blob([content]);
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("click", false, false);//initEvent 不加后两个参数在FF下会报错
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);
            aLink.dispatchEvent(evt);
            aLink.click();
        }
        function sleep(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getSleep({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd"),type:2}, function(result){
                vm.sleepXList.length = 0;
                vm.sleepYList.length = 0;
                vm.contentSleep = "実施日,就寝時間" + "\n";
                for(var r in result){
                    if(r <= 31){
                        vm.sleepXList.push(result[r].jisshiDt);
                        vm.sleepYList.push(result[r].startTime);
                        if(result[r].startTime == null){
                            result[r].startTime = "";
                        }
                        vm.contentSleep += result[r].jisshiDt + "," + result[r].startTime + "\n";
                    }
                }
            });
        }
        function spo2(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getTemperature({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd"),type:2}, function(result){
                vm.spo2XList.length = 0;
                vm.spo2YList.length = 0;
                vm.spo2TemperatureList.length = 0;
                vm.contentSpo2 = "実施日,SPO2,体温" + "\n";
                for(var r in result){
                    if(r <= 31){
                        vm.spo2XList.push(result[r].jisshiDt);
                        vm.spo2YList.push(result[r].spo);
                        vm.spo2TemperatureList.push(result[r].taion);
                        if(result[r].spo == null){
                            result[r].spo = "";
                        }
                        if(result[r].taion == null){
                            result[r].taion = "";
                        }
                        vm.contentSpo2 += result[r].jisshiDt + "," + result[r].spo + "," + result[r].taion + "\n";
                    }
                }
            });
        }
        function weightweight(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore){
            if(jisshiDt != 0){
                jisshiDt = $filter('date')(jisshiDt, "yyyy-MM-dd");
            }
            Analyze.getWeight({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: jisshiDt,jisshiDtBefore: $filter('date')(jisshiDtBeforeWeight, "yyyy-MM-dd"),type:2}, function(result){
                vm.weightXList.length = 0;
                vm.weightYList.length = 0;
                vm.contentWeight = "実施日,体重" + "\n";
                for(var r in result){
                    if(r <= 31){
                        vm.weightXList.push(result[r].jisshiDt);
                        vm.weightYList.push(result[r].taijuu);
                        if(result[r].taijuu == null){
                            result[r].taijuu = "";
                        }
                        vm.contentWeight += result[r].jisshiDt + "," + result[r].taijuu + "\n";
                    }
                }
                redashResize();
                //document.getElementById("scrollDiv").scrollLeft=document.getElementById("scrollDiv").scrollWidth;
                document.getElementById("scrollDiv1").scrollLeft=document.getElementById("scrollDiv1").scrollWidth;
                document.getElementById("scrollDiv2").scrollLeft=document.getElementById("scrollDiv2").scrollWidth;
            });
        }
        function diet(riyoushaId,jigyoushoId,jisshiDt,jisshiDtBefore,type){
            Analyze.getDiet({riyoushaId: riyoushaId,jigyoushoId:jigyoushoId,jisshiDt: $filter('date')(jisshiDt, "yyyy-MM-dd"),jisshiDtBefore: $filter('date')(jisshiDtBefore, "yyyy-MM-dd")}, function(result){
                if(type == 1){
                    vm.dietList.length = 0;
                    vm.dietList = result;
                    vm.contentDiet = "実施日,食事,水分,排尿,排便,体重"+ "\n";
                    for(var r in result){
                        if(r < 31){
                            if(result[r].shushokuSesshuryo == null){
                                result[r].shushokuSesshuryo = "";
                            }
                            if(result[r].suibunSesshuryo == null){
                                result[r].suibunSesshuryo = "";
                            }
                            if(result[r].nyouCount == null){
                                result[r].nyouCount = "";
                            }
                            if(result[r].benCount == null){
                                result[r].benCount = "";
                            }
                            if(result[r].taijuu == null){
                                result[r].taijuu = "";
                            }
                            vm.contentDiet += result[r].jisshiDt + "," + result[r].shushokuSesshuryo + "," + result[r].suibunSesshuryo + "," + result[r].nyouCount + "," + result[r].benCount + "," + result[r].taijuu + "\n";
                        }
                    }
                }else if(type == 2){
                    vm.dietFrontList.length = 0;
                    vm.dietFrontList = result;
                }else if(type == 3){
                    vm.dietAfterList.length = 0;
                    vm.dietAfterList = result;
                    /*var count = 16-result.length;
                    if(vm.dietAfterList.length < 16){
                        for(var i=0;i<count;i++){
                            var dto ={};
                            vm.dietAfterList.push(dto);
                        }
                    }*/
                }

            });
        }
        function loadFiles(){
            Comment.getFileListPublic({riyoushaId: vm.riyoushaId,startDt: $filter('date')(vm.jisshiDtBefore, "yyyy-MM-dd HH:mm:ss"),
                endDt: $filter('date')(vm.jisshiDt, "yyyy-MM-dd HH:mm:ss"),groupId: vm.groupId,
                page: vm.page - 1, size: paginationConstants.itemsPerPage}, function(result, headers){
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.fileList = result;
                for(var i = 0; i < vm.fileList.length; i++){
                    getUserNameBuFile(i);
                }
            });
            Comment.user({}, function (result) {
                vm.userDto = result;
            });
        }

        function loadPhotos() {
            Comment.getPhotoListPublic({riyoushaId: vm.riyoushaId,startDt: $filter('date')(vm.jisshiDtBefore, "yyyy-MM-dd HH:mm:ss"),
                endDt: $filter('date')(vm.jisshiDt, "yyyy-MM-dd HH:mm:ss"),groupId: vm.groupId,
                page: vm.page - 1, size: paginationConstants.itemsPerPage}, function(result, headers){
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.photoList = result;
                for(var i = 0; i < vm.photoList.length; i++){
                    getUserName(i);
                }
            });
            Comment.user({}, function (result) {
                vm.userDto = result;
            });
        }
        function getUserName(i){
            User.get({login: vm.photoList[i].lastModifiedBy},function (r) {
                vm.photoList[i].lastModifiedBy = r.lastName + " " + r.firstName;
            });
        }
        function getUserNameBuFile(i){
            User.get({login: vm.fileList[i].lastModifiedBy},function (r) {
                vm.fileList[i].lastModifiedBy = r.lastName + " " + r.firstName;
            });
        }
        function downloadByDiet(){
            if(confirm("CSVファイルをダウンロードですか？")){
                diet(vm.riyoushaId,vm.jigyoushoId,vm.jisshiDt,vm.jisshiDtBefore);
                var downloadLink = document.getElementById('downloadByDiet');
                downloadLink.download = '食事/排泄/体重.csv';
                downloadLink.href = "data:text/csv;charset=utf-8,\ufeff" + vm.contentDiet;
            }
        }
        function show(id){
            var modalInstance = $uibModal.open({
                templateUrl : 'app/analyze/photo-show-dialog.html',
                controller : 'AnalyzePhotoShowDialogController',
                controllerAs: 'vm',
                size : 'lg',
                resolve : {
                    entity: ['Uploader', function(Uploader) {
                        return Uploader.get({id : id});
                    }]
                }
            });
        }

        function isMobile() {
            var mobile_flag;
            var is_iPd = navigator.userAgent.match(/(iPad|iPod)/i) != null;
            var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|win ce)/i) != null;
            if(is_iPd){
                mobile_flag = 0;
            }
            if(is_mobi){
                mobile_flag = 1;
            }
            return mobile_flag;
        }
        //重新绘制图表
        function redashResize(){
            angular.element(document).ready(function () {
                getData();
            });
        }
        //写真切换到图表
        function clickTab(){
            redashResize();
        }
        function getData(){
            <!--体温-->
            var temperatureChart = echarts.init(document.getElementById('temperature'));
            var temperatureOption = {
                title: {
                    text: '体温'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"}
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['体温（℃）']
                },
                xAxis: {
                    type : 'category',
                    boundaryGap : false,
                    axisLabel:{interval:vm.number,rotate:90},
                    data : vm.temperatureXList
                },
                yAxis: {
                    name: '℃',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '30',
                    max: '45'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 45, min: 0, color: 'blue'}
                    ]
                }],
                series: [{
                    name: '体温（℃）',
                    type: 'line',
                    data: vm.temperatureYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }]
            };
            temperatureChart.setOption(temperatureOption);
            <!--脈拍-->
            var pulseChart = echarts.init(document.getElementById('pulse'));
            var pulseOption = {
                title: {
                    text: '脈拍'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"}
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['脈拍（回/分）']
                },
                xAxis: {
                    type : 'category',
                    boundaryGap : false,
                    axisLabel:{interval:vm.number,rotate:90},
                    data : vm.pulseXList
                },
                yAxis : {
                    name: '回/分',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '180'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 200, min: 0, color: 'blue'}
                    ]
                }],
                series: [{
                    name: '脈拍（回/分）',
                    type: 'line',
                    data: vm.pulseYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }]
            };
            pulseChart.setOption(pulseOption);
            <!--活動量-->
            var activityChart = echarts.init(document.getElementById('activity'));
            var activityOption = {
                color: ['#FF69B4','#7FFF00','#63B8FF'],
                title: {
                    text: '活動量'
                },
                tooltip : {
                    trigger: 'axis'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"}
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                legend: {
                    data:['歩数','アクティブ歩数','Ex']
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.activityXList
                    }
                ],
                yAxis : [
                    {
                        name: '歩',
                        type: 'value',
                        axisLabel:{interval:0},
                        min: '0',
                        max: '20000'
                    },
                    {
                        name: 'Ex',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '0',
                        max : '10'
                    }
                ],
                series : [{
                    name:'歩数',
                    type:'line',
                    data:vm.activityNumberYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                },
                    {
                        name:'アクティブ歩数',
                        type:'line',
                        data:vm.activityActiveYList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    },
                    {
                        name:'Ex',
                        type:'line',
                        yAxisIndex: 1,
                        data:vm.activityExYList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    }]
            };
            activityChart.setOption(activityOption);
            <!--血圧-->
            var pressureChart = echarts.init(document.getElementById('pressure'));
            var pressureOption = {
                color: ["#B22222", "#B22222"],
                title: {
                    text: '血圧'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"}
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                calculable : true,
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['血圧【上】','血圧【下】']
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.bloodPressureXList
                    }
                ],
                yAxis : [
                    {
                        name: 'mmHg',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '0',
                        max : '230'
                    },
                    {
                        name: 'mmHg',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '0',
                        max : '230'
                    }
                ],
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 300, min: 0, color: 'blue'}
                    ]
                },{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 1,
                    pieces: [
                        { max: 300, min: 0, color: 'blue'}
                    ]
                }],
                series : [
                    {
                        name:'血圧【上】',
                        type:'line',
                        data:vm.bloodPressureUYList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    },
                    {
                        name:'血圧【下】',
                        type:'line',
                        symbol: 'emptyTriangle',
                        yAxisIndex: 1,
                        data:vm.bloodPressureLYList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    }
                ]
            };
            pressureChart.setOption(pressureOption);
            <!--起床-->
            var getUpChart = echarts.init(document.getElementById('getUp'));
            var getUpOption = {
                title: {
                    text: '起床'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"}
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['起床']
                },
                xAxis: {
                    type : 'category',
                    boundaryGap : false,
                    axisLabel:{interval:vm.number,rotate:90},
                    data : vm.getUpXList
                },
                yAxis: {
                    name: '時間',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '24'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 24, min: 0, color: 'blue'}
                    ]
                }],
                series : {
                    name:'起床',
                    type:'line',
                    data: vm.getUpYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }
            };
            getUpChart.setOption(getUpOption);
            <!--就寝-->
            var sleepChart = echarts.init(document.getElementById('sleep'));
            var sleepOption = {
                title: {
                    text: '就寝'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"}
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['就寝']
                },
                calculable : true,
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.sleepXList
                    }
                ],
                yAxis : {
                    name: '時間',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '24'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 24, min: 0, color: 'blue'}
                    ]
                }],
                series : {
                    name:'就寝',
                    type:'line',
                    data: vm.sleepYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }
            };
            sleepChart.setOption(sleepOption);
            <!--SPO2-->
            var spo2Chart = echarts.init(document.getElementById('spo2'));
            var spo2Option = {
                color: ["#B22222", "#B22222"],
                title: {
                    text: 'SPO2'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"}
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                calculable : true,
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['SPO2','体温']
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.spo2XList
                    }
                ],
                yAxis : [
                    {
                        name: '%',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '0',
                        max : '150'
                    },
                    {
                        name: '℃',
                        type : 'value',
                        axisLabel:{interval:0},
                        min : '30',
                        max : '45'
                    }
                ],
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 300, min: 0, color: 'blue'}
                    ]
                },{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 1,
                    pieces: [
                        { max: 300, min: 0, color: 'blue'}
                    ]
                }],
                series : [
                    {
                        name:'SPO2',
                        type:'line',
                        data:vm.spo2YList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    },
                    {
                        name:'体温',
                        type:'line',
                        symbol: 'emptyTriangle',
                        yAxisIndex: 1,
                        data:vm.spo2TemperatureList,
                        markPoint : {
                            data : [
                                {type : 'max', name: '最大値'},
                                {type : 'min', name: '最小値'}
                            ]
                        },
                        markLine : {
                            data : [
                                {type : 'average', name: '平均値'}
                            ]
                        }
                    }
                ]
            };
            spo2Chart.setOption(spo2Option);
            <!--体重-->
            var weightChart = echarts.init(document.getElementById('weight'));
            var weightOption = {
                title: {
                    text: '体重'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"}
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    data:['体重']
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        axisLabel:{interval:vm.number,rotate:90},
                        data : vm.weightXList
                    }
                ],
                yAxis : {
                    name: 'kg',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '150'
                },
                visualMap: [{
                    type: 'piecewise',
                    top: 'center',
                    show: false,
                    seriesIndex: 0,
                    pieces: [
                        { max: 200, min: 0, color: 'blue'}
                    ]
                }],
                series : {
                    name:'体重',
                    type:'line',
                    data: vm.weightYList,
                    markPoint : {
                        data : [
                            {type : 'max', name: '最大値'},
                            {type : 'min', name: '最小値'}
                        ]
                    },
                    markLine : {
                        data : [
                            {type : 'average', name: '平均値'}
                        ]
                    }
                }
            };
            weightChart.setOption(weightOption);
            <!--活動状態-->
            var activeStateChart = echarts.init(document.getElementById('activeState'));
            var activeStateOption = {
                color: ['#FF0000','#0000EE','#00FF00','#4B0082','#436EEE','#FF34B3','#CD919E','#8B2500','#848484','#B8860B'],
                title: {
                    text: '活動状態1'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        /*myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('活動状態1.csv',vm.contentActiveState);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByActiveState');
                                            downloadLink.download = '活動状態1.csv';
                                            var str =  encodeURIComponent(vm.contentActiveState);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("activeState").getElementsByTagName("canvas")[0];
                                        downloadFile('活動状態1.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }*/
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: [
                    {data:['起上り','端座位','離床　　','柵越え','ずり落ち']},
                    {
                        top: '20',
                        data:['入室　','退室　','動き出し','入床　','体動　　']
                    }
                ],
                xAxis: {
                    type : 'category',
                    axisLabel:{interval:vm.number,rotate:90},
                    data : ['0時','1時','2時','3時','4時','5時','6時','7時','8時','9時','10時','11時','12時','13時','14時','15時','16時','17時','18時','19時','20時','21時','22時','23時']
                },
                yAxis: {
                    name: '回',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '120'
                },
                series: [
                    {
                        name: '起上り',
                        type: 'bar',barWidth:15,
                        stack: '活動状態',
                        data: vm.okiagariYList
                    },
                    {
                        name: '端座位',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.tanzaiYList
                    },
                    {
                        name: '離床　　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.rishouYList
                    },
                    {
                        name: '柵越え',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.sakugoeYList
                    },
                    {
                        name: 'ずり落ち',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.ziriochiYList
                    },
                    {
                        name: '入室　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.nyuusituYList
                    },
                    {
                        name: '退室　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.taishitsuYList
                    },
                    {
                        name: '動き出し',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.tenYList
                    },
                    {
                        name: '入床　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.elevenYList
                    },
                    {
                        name: '体動　　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.twelveYList
                    }
                ]
            }
            activeStateChart.setOption(activeStateOption);
            <!--活動状態2-->
            var activeStateChart2 = echarts.init(document.getElementById('activeState2'));
            var activeStateOption2 = {
                color: ['#FF0000','#0000EE','#00FF00','#4B0082','#436EEE','#FF34B3','#CD919E','#8B2500','#848484','#B8860B'],
                title: {
                    text: '活動状態2'
                },
                grid: {
                    top:'17%'
                },
                toolbox: {
                    show : true,
                    feature : {
                        mark : {show: true},
                        magicType : {
                            show: true,
                            type: ['line', 'bar'],
                            title: {line:"切替", bar:"切替"}
                        },
                        dataZoom: {
                            show: true,
                            yAxisIndex: 'none',
                            title:{zoom:"部分拡大",back:"戻す"}
                        },
                        restore : {show: true,title:"リセット"},
                        /*myTool: {
                            show: true,
                            title: "ダウンロード",
                            icon: 'path://M502.010485 765.939573c3.773953 3.719718 8.686846 5.573949 13.596669 5.573949 0.075725 0 0.151449-0.010233 0.227174-0.011256 0.329505 0.016373 0.654916 0.050142 0.988514 0.050142 0.706081 0 1.400906-0.042979 2.087545-0.116657 4.352121-0.366344 8.607028-2.190899 11.961426-5.496178l335.053985-330.166675c7.619538-7.509021 7.709589-19.773346 0.200568-27.393907s-19.774369-7.711636-27.39493-0.201591L536.193005 706.304358 536.193005 50.019207c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 657.032164-306.881342-302.44838c-7.618515-7.509021-19.883863-7.419993-27.393907 0.199545-7.509021 7.619538-7.419993 19.884886 0.199545 27.393907L502.010485 765.939573z M867.170139 711.020776c-10.698666 0-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 13.054317-10.620895 23.675212-23.676236 23.675212L205.182103 919.486668c-13.054317 0-23.676236-10.620895-23.676236-23.675212L181.505867 730.391962c0-10.698666-8.67252-19.371186-19.371186-19.371186s-19.371186 8.67252-19.371186 19.371186l0 165.419494c0 34.416857 28.000728 62.416562 62.417585 62.416562l618.941638 0c34.417881 0 62.417585-27.999704 62.417585-62.416562L886.540302 730.391962C886.541325 719.693296 877.868805 711.020776 867.170139 711.020776z',
                            onclick: function(){
                                var modalInstance = $uibModal.open({
                                    templateUrl : 'app/analyze/downloaddialog.html',
                                    controller : 'DownloaddialogController',
                                    controllerAs: 'vm',
                                    size : 'md',
                                    resolve : {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                            $translatePartialLoader.addPart('riyousha-analyze');
                                            return $translate.refresh();
                                        }]
                                    }
                                });
                                modalInstance.result.then(function(result) {
                                    if (result == 'csv') {
                                        var userAgent = navigator.userAgent;
                                        if (!!window.ActiveXObject || "ActiveXObject" in window || userAgent.indexOf("Edge") > -1){
                                            csvDownload('活動状態2.csv',vm.contentActiveState2);
                                        }else{
                                            var downloadLink = document.getElementById('downloadByActiveState2');
                                            downloadLink.download = '活動状態2.csv';
                                            var str =  encodeURIComponent(vm.contentActiveState2);
                                            downloadLink.href = "data:text/csv;charset=utf-8,\ufeff"+str;
                                            downloadLink.click();
                                        }
                                    }
                                    if(result == 'image'){
                                        var canvas = document.getElementById("activeState2").getElementsByTagName("canvas")[0];
                                        downloadFile('活動状態2.png', canvas.toDataURL("image/png"));
                                    }
                                },function(){
                                    MessageService.error("global.error.internalServerError");
                                })
                            }
                        }*/
                    },
                    x: vm.xLength,
                    itemSize:"12",
                    y: vm.yLength
                },
                tooltip : {
                    trigger: 'axis'
                },
                legend: [
                    {data:['右側端','左側端','頭側端','足側端','呼び出し']},
                    {
                        top: '20',
                        data:['応答　','心拍高','心拍低','呼吸高','呼吸低　']
                    }
                ],
                xAxis: {
                    type : 'category',
                    axisLabel:{interval:vm.number,rotate:90},
                    data : ['0時','1時','2時','3時','4時','5時','6時','7時','8時','9時','10時','11時','12時','13時','14時','15時','16時','17時','18時','19時','20時','21時','22時','23時']
                },
                yAxis: {
                    name: '回',
                    type: 'value',
                    axisLabel:{interval:0},
                    min: '0',
                    max: '120'
                },
                series: [
                    {
                        name: '右側端',
                        type: 'bar',barWidth:15,
                        stack: '活動状態',
                        data: vm.thirteenYList
                    },
                    {
                        name: '左側端',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.fourteenYList
                    },
                    {
                        name: '頭側端',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.fifteenYList
                    },
                    {
                        name: '足側端',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.sixteenYList
                    },
                    {
                        name: '呼び出し',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.seventeenYList
                    },
                    {
                        name: '応答　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.eighteenYList
                    },
                    {
                        name: '心拍高',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.nineteenYList
                    },
                    {
                        name: '心拍低',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.twentyYList
                    },
                    {
                        name: '呼吸高',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.twentyOneYList
                    },
                    {
                        name: '呼吸低　',
                        type: 'bar',
                        stack: '活動状態',
                        data: vm.twentyTwoYList
                    }
                ]
            }
            activeStateChart2.setOption(activeStateOption2);

            window.onresize = function (){
                temperatureChart.resize();
                pulseChart.resize();
                activityChart.resize();
                pressureChart.resize();
                getUpChart.resize();
                sleepChart.resize();
                spo2Chart.resize();
                weightChart.resize();
                activeStateChart.resize();
                activeStateChart2.resize();
            };
        }
        //获取选择日期的前多少天
        function getTargetday(num,date){
            var number=null;
            if(num==null||num==0){
                number=0;
            }else{
                number=num;
            }
            var targetday_milliseconds= date.getTime()+1000*60*60*24*number;
            var targetday=new  Date();
            targetday.setTime(targetday_milliseconds);
            var y = targetday.getFullYear();
            var m = targetday.getMonth()+1;
            var d = targetday.getDate();
            targetday = new Date(Date.parse(y + '/' + m + '/' + d));
            return targetday;
        }

        //文件下载
        function download(id){
            var aLink = document.createElement('a');
            aLink.href = "/library/api/library/downloadfile/" + id;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/systerm/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/systerm/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/systerm/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('gatewayApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('GatewayRoutes', GatewayRoutes);

    GatewayRoutes.$inject = ['$resource'];

    function GatewayRoutes ($resource) {
        var service = $resource('api/gateway/routes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gateway', {
            parent: 'admin',
            url: '/gateway',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'gateway.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/gateway/gateway.html',
                    controller: 'GatewayController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gateway');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('GatewayController', GatewayController);

    GatewayController.$inject = ['$filter', '$interval', 'GatewayRoutes'];

    function GatewayController ($filter, $interval, GatewayRoutes) {
        var vm = this;

        vm.gatewayRoutes = null;
        vm.refresh = refresh;
        vm.updatingRoutes = null;

        vm.refresh();

        function refresh () {
            vm.updatingRoutes = true;
            GatewayRoutes.query(function(result) {
                vm.gatewayRoutes = result;
                vm.updatingRoutes = false;
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/systerm/swagger',
            data: {
                //authorities: ['ROLE_ADMIN', 'ROLE_PARTNER'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                        var gtc_caretree2_api_swagger_fullaccess = false;
                        var isAdmin = false;
                        var isDeveloper = false;
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_API_Swagger_FullAccess"}, function(result){
                        	if (!result.flag) {
                        		$state.go('accessdenied');
                        	} else {
                        		plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_api_swagger_fullaccess);
                        	}
                        });
                	} else {
                		LoginService.open();
                	}
                	
                });
            }]
        });
    }

    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_api_swagger_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_API_Swagger_FullAccess') {
                    gtc_caretree2_api_swagger_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_api_swagger_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/systerm/settings',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/systerm/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/account/settings',
            data: {
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
                var top = $uibModalStack.getTop();
                if (top) {
                    $uibModalStack.dismiss(top.key);
                }
                Principal.identity().then(function(account) {
                	if (account != null) {
                		if (account.login.indexOf(";") != -1) {
                    		$state.go('home');
                            $uibModal.open({
                                templateUrl: 'app/home/dialog/license.html',
                                controller: 'HomeLicenseController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg'
                            }).result.then(function() {
                                $state.go('home', null, { reload: true });
                            }, function() {
                                $state.go('home');
                            });
                        }
                	} else {
                		LoginService.open();
                	}
                	
                });
            }]
        }).state('settings.photo', {
            parent: 'settings',
            url: '/photo/{login}',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/settings/setting-photo.html',
                    controller: 'SettingsPhotoController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('settings', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('settings.upload', {
            parent: 'settings',
            url: '/photo/upload/{login}',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/account/settings/setting-upload-photo.html',
                    controller: 'SettingsUploadPhotoController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('settings', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        }).state('settingsToken', {
            parent: 'account',
            url: '/account/settings/{token}',
            data: {
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', 'User', '$translate', '$stateParams', '$localStorage', '$sessionStorage', '$state', '$scope'];

    function SettingsController (Principal, Auth, JhiLanguageService, User, $translate, $stateParams, $localStorage, $sessionStorage, $state, $scope) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.loadPhoto = loadPhoto;
        vm.settingsAccount = null;
        vm.success = null;
        // 是否可以使用タイムカード
        vm.gtc_caretree2_timecard_allfunction_fullaccess = false;

        dologin();

        function dologin() {
        	if ($stateParams.token != undefined && $stateParams.token != '') {
                var settings = {
                    "url": "/api/account",
                    "method": "GET",
                    "headers": {
                        "Authorization": "Bearer " + $stateParams.token
                    },
                    success: function(res){
                        Auth.loginWithToken($stateParams.token);
                        vm.settingsAccount = copyAccount(res);
                        $scope.$apply()
                    },
                    error: function() {
                        $state.go('settings');
                    }
                }
                $.ajax(settings);
        	}
        }

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                seiKana: account.seiKana,
                langKey: account.langKey,
                lastName: account.lastName,
                meiKana: account.meiKana,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
            if (account != null) {
                if (account.functions != null) {
                    for (var i in account.functions) {
                        if (account.functions[i] == 'GTC_CareTree2_TimeCard_AllFunction_FullAccess') {
                            vm.gtc_caretree2_timecard_allfunction_fullaccess = true;
                        }
                    }
                }
            }
            if (vm.gtc_caretree2_timecard_allfunction_fullaccess) {
            	vm.loadPhoto();
            }
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }

        function loadPhoto(){
            var data = {'login':vm.settingsAccount.login};
            User.getPhoto(data,function(result){
                vm.settingsAccount.imageUrl = result[0];
            },function(error){

            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SettingsUploadPhotoController',SettingsUploadPhotoController);

    SettingsUploadPhotoController.$inject = ['$stateParams', '$uibModalInstance', 'entity','Upload','User','MessageService'];

    function SettingsUploadPhotoController ($stateParams, $uibModalInstance, entity,Upload,User,MessageService) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.uploadPic = uploadPic;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function uploadPic() {
            Upload.upload({
                url: 'library/api/upload/file',
                data: {fileName: vm.picFile.name, file: Upload.dataUrltoBlob(vm.croppedDataUrl, vm.picFile.name)}
            }).success(function (library) {
                MessageService.success("photo.message.upload.success");
                vm.picFile = null;
                var data = {'id':vm.user.id,'imageUrl':'/library/api/library/image/'+library.id};
                User.uploadPhoto(data,function(result){
                    MessageService.success("global.messages.info.save");
                    $uibModalInstance.close(result);
                },function(error){
                    MessageService.error("global.error.save");
                });
            }).error(function () {
                MessageService.error("photo.message.upload.error");
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('SettingsPhotoController',SettingsPhotoController);

    SettingsPhotoController.$inject = ['$stateParams', '$uibModalInstance', 'entity','Uploader','User','MessageService'];

    function SettingsPhotoController ($stateParams, $uibModalInstance, entity,Uploader,User,MessageService) {
        var vm = this;

        vm.user = entity;
        vm.photo = null;
        vm.clear = clear;
        vm.save = save;


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            console.log("photo upload success");
            var data = {'id':vm.user.id,'imageUrl':'/library/api/library/image/'+result.id};
            User.uploadPhoto(data,function(result){
                MessageService.success("global.messages.info.save");
                $uibModalInstance.close(result);
            },function(error){
                MessageService.error("global.error.save");
            });
        }

        function onSaveError () {
            vm.isSaving = false;
            MessageService.error("library.message.uploadError");
        }

        function save () {
            vm.isSaving = true;
            var data = {};
            data.file = vm.photo;
            data.fileName = vm.user.login + ".jpg";
            Uploader.upload(data,onSaveSuccess,onSaveError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'Register'];

    function RegisterController ($translate, $timeout, Auth, LoginService, Register) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.exist = false;
        vm.existButton = true;
        vm.existButtonClass = '';
        vm.loginMouseleave = loginMouseleave;


        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }

        function loginMouseleave(){
            if (vm.registerAccount.login != '') {
                Register.query({loginId: vm.registerAccount.login}, function (result) {
                    if (result.id == undefined) {
                        vm.exist = false;
                        vm.existButton = false;
                        vm.existButtonClass = '';
                    } else {
                        vm.exist = true;
                        vm.existButton = true;
                        vm.existButtonClass = 'has-error';
                    }
                });
            } else {
                vm.exist = false;
                vm.existButton = false;
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/account/password',
            data: {
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService) {
            	var top = $uibModalStack.getTop();
                if (top) {
                    $uibModalStack.dismiss(top.key);
                }
                Principal.identity().then(function(account) {
                	if (account != null) {
                		if (account.login.indexOf(";") != -1) {
                    		$state.go('home');
                            $uibModal.open({
                                templateUrl: 'app/home/dialog/license.html',
                                controller: 'HomeLicenseController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg'
                            }).result.then(function() {
                                $state.go('home', null, { reload: true });
                            }, function() {
                                $state.go('home');
                            });
                        }
                	} else {
                		LoginService.open();
                	}

                });
            }]
        }).state('passwordToken', {
            parent: 'account',
            url: '/account/password/{token}',
            data: {
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', '$stateParams', '$localStorage', '$sessionStorage', '$state', 'MessageService', '$scope'];

    function PasswordController (Auth, Principal, $stateParams, $localStorage, $sessionStorage, $state, MessageService, $scope) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.dologin = dologin;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        dologin();

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function dologin() {
        	if ($stateParams.token != undefined && $stateParams.token != '') {
                var settings = {
                    "url": "/api/account",
                    "method": "GET",
                    "headers": {
                        "Authorization": "Bearer " + $stateParams.token
                    },
                    success: function(res){
                        Auth.loginWithToken($stateParams.token);
                        vm.account = res
                        $scope.$apply()
                    },
                    error: function() {
                        $state.go('password');
                    }
                }
                $.ajax(settings);
        	}
        }

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    MessageService.success("password.messages.success");
                    Auth.logout();
                    $state.go('home');
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
    	
        var vm = this;
        
        vm.activateLogout = activateLogout;
        
        activateLogout();
        
        function activateLogout() {
        	vm.isNavbarCollapsed = false;
            Auth.logout();
            vm.pepperList = [];
            vm.pepper = {};
            vm.groupList = [];
            vm.group = {};
            vm.messages = [];
        }

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('gatewayApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/analyze/analyzeshow.html','<style>.iconDiv {\n        height: 130px;\n        line-height: 120px;\n        width: 100%;\n        font-size: 60px;\n    }\n    .iconText {\n        height: 24px;\n        line-height: 24px;\n        width: 100%;\n        word-break: break-all;\n    }\n    .nav-tabs > li > a {\n        color: black;\n    }\n    .nav-tabs > li > a:focus {\n        color: black;\n    }\n    .nav-tabs > li > a:hover {\n        color: black;\n    }\n    .nav-tabs > li.active > a {\n        color: blue;\n    }\n    .nav-tabs > li.active > a:focus {\n        color: blue;\n    }\n    .nav-tabs > li.active > a:hover {\n        color: blue;\n    }</style><div style="padding-top: 80px"><div class="row"><div class="col-md-9 col-sm-12 col-xs-12" ng-show="vm.mobile_flag == 1"><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 60px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.jigyoushoNameShow"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 78%"><h4>{{vm.jigyoushoName}}</h4></div></div><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 60px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.riyoushaNameShow"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 78%"><h4>{{vm.riyoushaName}}</h4></div></div><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 60px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.dateShow"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 78%"><h4>{{vm.formatJisshiDt|date:\'yyyy-MM-dd\'}}</h4></div></div></div><div class="col-md-9 col-sm-12 col-xs-12" ng-show="vm.mobile_flag != 1"><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 60px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.jigyoushoNameShow"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 70%"><h4>{{vm.jigyoushoName}}</h4></div></div><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 60px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.riyoushaNameShow"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 70%"><h4>{{vm.riyoushaName}}</h4></div></div><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 60px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.dateShow"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 70%"><h4>{{vm.formatJisshiDt|date:\'yyyy-MM-dd\'}}</h4></div></div></div><div class="col-md-3 col-sm-12 col-xs-12" style="padding-bottom: 5px; text-align: center"><button type="button" class="btn btn-info" data-translate="riyoushaAnalyze.home.beforeMonth" ng-click="vm.beforeMonth()" disabled="disabled">\u5148\u6708</button> <button type="button" class="btn btn-success" data-translate="riyoushaAnalyze.home.currentMonth" ng-click="vm.rest()" disabled="disabled">\u4ECA\u6708</button> <button type="button" class="btn btn-info" data-translate="riyoushaAnalyze.home.nextMonth" ng-click="vm.nextMonth()" disabled="disabled">\u6765\u6708</button></div></div><div class="row"><div class="panel panel-info col-md-9" style="padding-left: 0px;padding-right: 0px;min-height: 4500px"><uib-tabset active="active" type="tabs"><uib-tab index="0" heading="\u56F3\u8868" ng-click="vm.clickTab();"><!--\u4F53\u6E29--> <a id="downloadByTemperature" download="downlaodf.csv" href="#" ng-click="vm.downloadByTemperature()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="temperature" class="col-md-12" style="width: 100%;height:400px"></div><!--\u8108\u62CD\uFF08\u56DE/\u5206\uFF09--> <a id="downloadByPulse" download="downlaodf.csv" href="#" ng-click="vm.downloadByPulse()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="pulse" class="col-md-12" style="width: 100%;height:400px"></div><!--\u6D3B\u52D5\u91CF--> <a id="downloadByActivity" download="downlaodf.csv" href="#" ng-click="vm.downloadByActivity()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="activity" class="col-md-12" style="width: 100%;height:400px"></div><!--\u8840\u5727--><div id="pressure" class="col-md-12" style="width: 100%;height:400px"></div><a id="downloadByBloodPressure" download="downlaodf.csv" href="#" ng-click="vm.downloadByBloodPressure()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><!--\u8D77\u5E8A--><div id="getUp" class="col-md-12" style="width: 100%;height:400px"></div><a id="downloadByGetUp" download="downlaodf.csv" href="#" ng-click="vm.downloadByGetUp()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><!--\u5C31\u5BDD--><div id="sleep" class="col-md-12" style="width: 100%;height:400px"></div><a id="downloadBySleep" download="downlaodf.csv" href="#" ng-click="vm.downloadBySleep()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><!--SPO2--><div id="spo2" class="col-md-12" style="width: 100%;height:400px"></div><a id="downloadBySpo2" download="downlaodf.csv" href="#" ng-click="vm.downloadBySpo2()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><!--\u4F53\u91CD--><div id="weight" class="col-md-12" style="width: 100%;height:400px"></div><a id="downloadByWeight" download="downlaodf.csv" href="#" ng-click="vm.downloadByWeight()" style="float: right;display: none;width: 50%">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><!--\u6D3B\u52D5\u72B6\u614B--> <a id="downloadByActiveState" download="downlaodf.csv" href="#" ng-click="vm.downloadByActiveState()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="activeState" class="col-md-12" style="width: 100%;height:400px; padding-top:30px"></div><!--\u6D3B\u52D5\u72B6\u614B2--> <a id="downloadByActiveState2" download="downlaodf.csv" href="#" ng-click="vm.downloadByActiveState2()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="activeState2" class="col-md-12" style="width: 100%;height:400px; padding-top:30px"></div><!--\u98DF\u4E8B/\u6C34\u5206/\u6392\u6CC4/\u4F53\u91CD--><div class="tab-pane fade in active" style="height:50%; width:100%;float: left;padding-top:15px"><div style="width:100%;height: 30px"><b style="font-size: 20px; float: left; width: 80%;padding-left: 20px">\u98DF\u4E8B/\u6C34\u5206/\u6392\u6CC4/\u4F53\u91CD</b></div><div style="clear: both;height: 18px; color: #299ec6;font-size: 13px;width:100%"></div><div style="clear: both"></div><div style="padding-left: 10%;width:100%"><div style="width:51px;float: left;display:inline-block" id="titleDiv1"><table border="1" style="word-wrap:break-word;float:right"><tr style="height: 30px"><td align="center">\u5B9F\u65BD\u65E5</td></tr><tr style="height: 30px"><td align="center">\u98DF\u4E8B</td></tr><tr style="height: 30px"><td align="center">\u6C34\u5206</td></tr><tr style="height: 30px"><td align="center">\u6392\u5C3F</td></tr><tr style="height: 30px"><td align="center">\u6392\u4FBF</td></tr><tr style="height: 30px"><td align="center">\u4F53\u91CD</td></tr></table></div><div style="width:84%;float: left;display:inline-block;min-width: 200px;overflow-x: auto" id="scrollDiv1" ;><table border="1" style="word-wrap:break-word;width:100%"><tr style="height: 30px"><td ng-repeat="(0,d) in vm.dietFrontList" align="center"><div>{{d.jisshiDt}}</div></td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,s) in vm.dietFrontList" align="center">{{s.shushokuSesshuryo}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,ss) in vm.dietFrontList" align="center">{{ss.suibunSesshuryo}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,u) in vm.dietFrontList" align="center">{{u.nyouCount}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,de) in vm.dietFrontList" align="center">{{de.benCount}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,t) in vm.dietFrontList" align="center">{{t.taijuu}}</td></tr></table></div></div><div style="clear: both"></div><div style="padding-left: 10%;padding-top:5px;width:100%"><div style="width:51px;float: left;display:inline-block" id="titleDiv2"><table border="1" style="word-wrap:break-word;float:right"><tr style="height: 30px"><td align="center">\u5B9F\u65BD\u65E5</td></tr><tr style="height: 30px"><td align="center">\u98DF\u4E8B</td></tr><tr style="height: 30px"><td align="center">\u6C34\u5206</td></tr><tr style="height: 30px"><td align="center">\u6392\u5C3F</td></tr><tr style="height: 30px"><td align="center">\u6392\u4FBF</td></tr><tr style="height: 30px"><td align="center">\u4F53\u91CD</td></tr></table></div><div style="width:84%;float: left;display:inline-block;min-width: 200px;overflow-x: auto" id="scrollDiv2" ;><table border="1" style="word-wrap:break-word;width:100%"><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,d) in vm.dietAfterList" align="center"><div>{{d.jisshiDt}}</div></td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,s) in vm.dietAfterList" align="center">{{s.shushokuSesshuryo}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,ss) in vm.dietAfterList" align="center">{{ss.suibunSesshuryo}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,u) in vm.dietAfterList" align="center">{{u.nyouCount}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,de) in vm.dietAfterList" align="center">{{de.benCount}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,t) in vm.dietAfterList" align="center">{{t.taijuu}}</td></tr></table></div></div></div></uib-tab><uib-tab index="1" heading="\u5199\u771F" active="tab.active" disable="tab.disabled"><table class="table table-striped"><colgroup><col width="100%"></colgroup><tbody><tr style="height: 50px"><td style="border-top: hidden"><form name="photoForm" role="form"><div class="row" style="margin-top: -3px;margin-left: 1px;padding-right: 2px"><div class="col-md-12" style="text-align: center"><h4 data-translate="riyoushaAnalyze.home.phototitle"></h4></div></div></form></td></tr><tr><td><div class="row" ng-if="vm.photoList.length > 0"><div ng-class="vm.mobile_flag ? vm.ipadClass : vm.pcClass" ng-repeat="photo in vm.photoList" style="height: 310px; margin-bottom: 5px"><div class="row"><div class="col-md-12 text-center" style="height: 200px; line-height: 200px;text-align: center"><img src="data:image/png;base64,{{photo.thumbnail}}" style="max-width: 200px; max-height: 200px" ng-click="vm.show(photo.id)"></div><div ng-bind="photo.fileName" title="{{photo.fileName}}" class="col-md-12 text-center" style="margin-bottom: 3px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis"></div><div class="col-md-12 text-center" style="margin-bottom: 3px">{{photo.lastModifiedBy}}</div><div class="col-md-12 text-center" style="margin-bottom: 3px">{{photo.uploadDate | date:\'yyyy/MM/dd\'}}</div><div class="col-md-12 text-center" style="margin-bottom: 3px"><button class="btn btn-info" data-translate="riyoushaAnalyze.home.show" ng-click="vm.show(photo.id)">Show</button></div></div></div></div><div class="row text-center" ng-if="vm.photoList.length > 0"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPhotos()"></uib-pagination></div><div class="row alert alert-warning top-margin" ng-if="vm.photoList.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></td></tr></tbody></table></uib-tab><uib-tab index="2" heading="\u30D5\u30A1\u30A4\u30EB"><table class="table table-striped"><colgroup><col width="100%"></colgroup><tbody><tr style="height: 50px"><td style="border-top: hidden"><form name="fileForm" role="form"><div class="row" style="margin-top: -3px;margin-left: 1px;padding-right: 2px"><div class="col-md-12" style="text-align: center"><h4 data-translate="riyoushaAnalyze.home.filetitle"></h4></div></div></form></td></tr><tr><td><div class="row" ng-if="vm.fileList.length > 0"><div ng-class="vm.mobile_flag == 0 ? vm.ipadClass : vm.pcClass" ng-repeat="file in vm.fileList" style="height: 310px; margin-bottom: 30px"><div class="row"><div class="glyphicon glyphicon-music iconDiv" ng-if="file.fileType == 3"></div><div class="glyphicon glyphicon-film iconDiv" ng-if="file.fileType == 4"></div><div class="glyphicon glyphicon-link iconDiv" ng-if="file.fileType == 5"></div><div class="glyphicon glyphicon-file iconDiv" ng-if="file.fileType == 6"></div><div ng-bind="file.fileName" title="{{file.fileName}}" class="col-md-12 text-center" style="margin-bottom: 3px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis"></div><div class="col-md-12 text-center" style="margin-bottom: 3px">{{file.lastModifiedBy}}</div><div class="col-md-12 text-center" style="margin-bottom: 3px">{{file.uploadDate | date:\'yyyy/MM/dd\'}}</div><div class="col-md-12 text-center" style="margin-bottom: 3px"><button class="btn btn-info" data-translate="riyoushaAnalyze.home.download" ng-click="vm.download(file.id,file.fileName)">download</button>&nbsp;&nbsp;&nbsp;</div></div></div></div><div class="row text-center" ng-if="vm.fileList.length > 0"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadFiles()"></uib-pagination></div><div class="row alert alert-warning top-margin" ng-if="vm.fileList.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></td></tr></tbody></table></uib-tab></uib-tabset></div><div class="panel panel-info col-md-3" style="padding-left: 0px;padding-right: 0px;min-height: 737px"><form name="editForm" role="form" novalidate><div class="panel-heading" style="height: 41px"><h3 class="panel-title" data-translate="riyoushaAnalyze.home.comments"></h3></div><!--\u30B3\u30E1\u30F3\u30C8--><div class="table-responsive"><table class="table table-striped"><colgroup><col width="90%"><col width="10%"></colgroup><tbody><tr style="height: 53px"><td colspan="2"><div class="row" style="width:100%;margin-left: 0px"><div class="col-md-12 text-right" style="padding-right: 0px"><button class="btn btn-primary ng-scope" ng-click="vm.save()" ng-disabled="editForm.$invalid"><span data-translate="riyoushaAnalyze.home.add"></span></button></div></div></td></tr><tr><td colspan="2"><div class="form-group"><textarea style="height: 110px" type="text" class="form-control" name="commentContent" ng-maxlength="200" ng-required="ct.commentContent == null || ct.commentContent == \'\' " ng-model="ct.commentContent" disabled="disabled"></textarea><div class="has-error small" ng-show="editForm.commentContent.$invalid"><p class="help-block" data-translate="riyoushaAnalyze.home.commentContentRequired" ng-show="editForm.commentContent.$error.required">This field is required.</p><p class="help-block" data-translate="riyoushaAnalyze.home.commentContentLength" ng-show="editForm.commentContent.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div></td></tr><tr ng-repeat="cs in vm.commentsShowList"><td colspan="2"><div style="border: 1px solid #bce8f1;border-radius: 4px;height:auto"><div style="white-space: pre-wrap;word-break:break-all"><b>{{cs.commentContent}}</b></div><div style="text-align: right"><span>{{cs.userName}}</span>&nbsp;&nbsp; <span>{{cs.datumDay|date:\'yyyy/MM/dd\'}}</span></div></div></td></tr></tbody></table></div></form></div></div></div>');
$templateCache.put('app/analyze/downloaddialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="riyoushaAnalyze.home.select"></h4></div><div class="modal-body text-center"><button type="button" class="btn btn-info" data-translate="riyoushaAnalyze.home.image" ng-click="vm.imageDownload()"></button>&nbsp;&nbsp;&nbsp;&nbsp; <button type="button" class="btn btn-info" data-translate="riyoushaAnalyze.home.csv" ng-click="vm.csvDownload()"></button></div>');
$templateCache.put('app/analyze/login.html','<div ng-cloak><head><script>$(function(){\n        document.getElementById("htmlId").style.visibility="hidden";\n\t\tdocument.getElementById("formid").submit();\n\t})</script></head><form style="visibility: hidden" action="http://13.115.173.2/login" id="formid" method="post"><input type="text" name="email" value="develop@goodtree.jp"> <input type="text" name="password" value="11111111"></form></div>');
$templateCache.put('app/analyze/photo-show-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.library.fileName}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row text-center"><img src="data:image/png;base64, {{vm.library.url}}" style="max-height: 80%; max-width: 80%"></div></div>');
$templateCache.put('app/analyze/riyousha-analyze-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="riyoushaAnalyze.home.editDialog">Create or edit a Group</h4></div><jhi-alert-error></jhi-alert-error><div class="modal-body"><div class="form-group"><label class="control-label" data-translate="riyoushaAnalyze.home.date"></label><!--<input type="date" class="form-control" name="datumDay" ng-model="vm.comment.datumDay" />--><p class="input-group"><input type="text" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" ng-model="vm.comment.datumDay" id="datumDay" is-open="vm.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar()"><i class="fa fa-calendar"></i>\u9078\u629E</button></span></p></div><div class="form-group"><label class="control-label" data-translate="riyoushaAnalyze.home.comments">name</label><textarea style="height: 110px" type="text" class="form-control" name="commentContent" ng-maxlength="200" ng-required="vm.comment.commentContent == null || vm.comment.commentContent == \'\' " ng-model="vm.comment.commentContent"></textarea><div class="has-error small" ng-show="editForm.commentContent.$invalid"><p class="help-block" data-translate="riyoushaAnalyze.home.commentContentRequired" ng-show="editForm.commentContent.$error.required">This field is required.</p><p class="help-block" data-translate="riyoushaAnalyze.home.commentContentLength" ng-show="editForm.commentContent.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/analyze/riyousha-analyze.html','<style>.iconDiv {\n        height: 130px;\n        line-height: 120px;\n        width: 100%;\n        font-size: 60px;\n    }\n    .iconText {\n        height: 24px;\n        line-height: 24px;\n        width: 100%;\n        word-break: break-all;\n    }\n    .nav-tabs > li > a {\n        color: black;\n    }\n    .nav-tabs > li > a:focus {\n        color: black;\n    }\n    .nav-tabs > li > a:hover {\n        color: black;\n    }\n    .nav-tabs > li.active > a {\n        color: blue;\n    }\n    .nav-tabs > li.active > a:focus {\n        color: blue;\n    }\n    .nav-tabs > li.active > a:hover {\n        color: blue;\n    }</style><div id="" ui-view><div class="row"><div class="col-md-9 col-sm-12 col-xs-12" ng-show="vm.mobile_flag == 1"><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 56px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.jigyoushoName"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 78%"><select ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" class="form-control" ng-model="vm.group" ng-options="gl.name for gl in vm.groupList" ng-change="vm.jigyoushoChange()"></select></div></div><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 56px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.riyoushaName"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 78%"><select ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" class="form-control" ng-model="vm.riyousha" ng-options="gl.name for gl in vm.riyoushaList" ng-change="vm.change()"></select></div></div><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 56px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.date"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 78%"><p class="input-group"><input style="background-color: white" ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" type="text" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" id="jisshiDt" ng-model="vm.jisshiDt" readonly="readonly" is-open="vm.isOpen" ng-change="vm.change()"> <span class="input-group-btn"><button ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" type="button" class="btn btn-default" ng-click="vm.openCalendar()"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p></div></div></div><div class="col-md-9 col-sm-12 col-xs-12" ng-show="vm.mobile_flag != 1"><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 56px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.jigyoushoName"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 70%"><select ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" class="form-control" ng-model="vm.group" ng-options="gl.name for gl in vm.groupList" ng-change="vm.jigyoushoChange()"></select></div></div><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 56px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.riyoushaName"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px; width: 70%"><select ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" class="form-control" ng-model="vm.riyousha" ng-options="gl.name for gl in vm.riyoushaList" ng-change="vm.change()"></select></div></div><div class="col-md-4 col-sm-12 col-xs-12"><div class="col-md-6 col-sm-4 col-xs-4" style="width: 56px;padding-left: 0px;padding-right: 0px;float: left"><h4 data-translate="riyoushaAnalyze.home.date"></h4></div><div class="col-md-6 col-sm-8 col-xs-8" style="float: left;padding-left: 0px;padding-right: 0px;width: 70%"><p class="input-group"><input ng-if="!vm.disabledFlag" style="background-color: white" ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" type="text" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" id="jisshiDt" ng-model="vm.jisshiDt" is-open="vm.isOpen" readonly="readonly" ng-change="vm.change()"> <input ng-if="vm.disabledFlag" ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" type="text" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" id="jisshiDt" ng-model="vm.jisshiDt" is-open="vm.isOpen" readonly="readonly" ng-change="vm.change()"> <span class="input-group-btn"><button ng-if="vm.isAdminAnalyzeDate || vm.isUserAnalyzeDate || vm.isCaretreeAnalyzeDate || vm.isDeveloperAnalyzeDate || vm.isPartnerAnalyzeDate" ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" type="button" class="btn btn-default" ng-click="vm.openCalendar()"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p></div></div></div><div class="col-md-3 col-sm-12 col-xs-12" style="padding-bottom: 5px; text-align: center"><button ng-if="vm.isAdminAnalyzeDate || vm.isUserAnalyzeDate || vm.isCaretreeAnalyzeDate || vm.isDeveloperAnalyzeDate || vm.isPartnerAnalyzeDate" ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" type="button" class="btn btn-info" data-translate="riyoushaAnalyze.home.beforeMonth" ng-click="vm.beforeMonth()">\u5148\u6708</button> <button ng-if="vm.isAdminAnalyzeDate || vm.isUserAnalyzeDate || vm.isCaretreeAnalyzeDate || vm.isDeveloperAnalyzeDate || vm.isPartnerAnalyzeDate" ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" type="button" class="btn btn-success" data-translate="riyoushaAnalyze.home.currentMonth" ng-click="vm.rest()">\u4ECA\u6708</button> <button ng-if="vm.isAdminAnalyzeDate || vm.isUserAnalyzeDate || vm.isCaretreeAnalyzeDate || vm.isDeveloperAnalyzeDate || vm.isPartnerAnalyzeDate" ng-disabled="!(vm.temperatureFlag && vm.activeStateFlag && vm.activeStateFlag2 && vm.pulseFlag && vm.activityFlag && vm.bloodPressureFlag && vm.getUpFlag && vm.sleepFlag && vm.spo2Flag && vm.weightFlag && vm.dietFlag && vm.cFlag && vm.pFlag)" type="button" class="btn btn-info" data-translate="riyoushaAnalyze.home.nextMonth" ng-click="vm.nextMonth()">\u6765\u6708</button></div></div><div class="row"><div class="panel panel-info col-md-9" style="padding-left: 0px;padding-right: 0px;min-height: 4500px"><uib-tabset active="active" type="tabs"><uib-tab index="0" heading="\u56F3\u8868" ng-click="vm.clickTab();"><!--\u4F53\u6E29--> <a id="downloadByTemperature" download="downlaodf.csv" href="#" ng-click="vm.downloadByTemperature()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="temperature" class="col-md-12" style="width: 100%;height:400px"></div><!--\u8108\u62CD\uFF08\u56DE/\u5206\uFF09--> <a id="downloadByPulse" download="downlaodf.csv" href="#" ng-click="vm.downloadByPulse()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="pulse" class="col-md-12" style="width: 100%;height:400px"></div><!--\u6D3B\u52D5\u91CF--> <a id="downloadByActivity" download="downlaodf.csv" href="#" ng-click="vm.downloadByActivity()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="activity" class="col-md-12" style="width: 100%;height:400px"></div><!--\u8840\u5727--><div id="pressure" class="col-md-12" style="width: 100%;height:400px"></div><a id="downloadByBloodPressure" download="downlaodf.csv" href="#" ng-click="vm.downloadByBloodPressure()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><!--\u8D77\u5E8A--><div id="getUp" class="col-md-12" style="width: 100%;height:400px"></div><a id="downloadByGetUp" download="downlaodf.csv" href="#" ng-click="vm.downloadByGetUp()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><!--\u5C31\u5BDD--><div id="sleep" class="col-md-12" style="width: 100%;height:400px"></div><a id="downloadBySleep" download="downlaodf.csv" href="#" ng-click="vm.downloadBySleep()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><!--SPO2--><div id="spo2" class="col-md-12" style="width: 100%;height:400px"></div><a id="downloadBySpo2" download="downlaodf.csv" href="#" ng-click="vm.downloadBySpo2()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><!--\u4F53\u91CD--><div id="weight" class="col-md-12" style="width: 100%;height:400px"></div><!--\u6D3B\u52D5\u72B6\u614B1--> <a id="downloadByActiveState" download="downlaodf.csv" href="#" ng-click="vm.downloadByActiveState()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="activeState" class="col-md-12" style="width: 100%;height:400px; padding-top:30px"></div><!--\u6D3B\u52D5\u72B6\u614B2--> <a id="downloadByActiveState2" download="downlaodf.csv" href="#" ng-click="vm.downloadByActiveState2()" style="float: right;display: none">CSV\u30D5\u30A1\u30A4\u30EB\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9</a><div id="activeState2" class="col-md-12" style="width: 100%;height:400px; padding-top:30px"></div><!--\u98DF\u4E8B/\u6392\u6CC4/\u4F53\u91CD/\u6C34\u5206--><div class="tab-pane fade in active" style="height:50%; width:100%;float: left;padding-top:15px"><div style="width:100%;height: 30px"><b style="font-size: 20px; float: left; width: 75%;padding-left: 20px">\u98DF\u4E8B/\u6C34\u5206/\u6392\u6CC4/\u4F53\u91CD</b> <a id="downloadByDiet" ng-show="vm.isPc" ng-mouseleave="vm.hidenWords()" ng-mouseover="vm.showWords()" ng-click="vm.downloadByDiet()" style="width: 20%; height:30px; float: left;text-decoration: none;padding-right: 2%" class="download-image"></a> <a id="downloadByDietIpad" ng-show="vm.isMobileAndIpad" ng-click="vm.downloadByDiet()" style="width: 20%; height:30px; float: left;text-decoration: none;padding-right: 2%" class="download-image"></a></div><div style="clear: both;height: 18px; color: #299ec6;font-size: 13px;width:100%"><b style="font-size: 20px; float: left; width: 75%;padding-left: 2%;border: #FFFFFF 1px solid"></b><div style="float: left;width: 20%;text-align: center" ng-show="vm.showFlag">\u30C0\u30A6\u30ED\u30FC\u30C9</div></div><div style="clear: both"></div><div style="padding-left: 10%;width:100%"><div style="width:51px;float: left;display:inline-block" id="titleDiv1"><table border="1" style="word-wrap:break-word;float:right"><tr style="height: 30px"><td align="center">\u5B9F\u65BD\u65E5</td></tr><tr style="height: 30px"><td align="center">\u98DF\u4E8B</td></tr><tr style="height: 30px"><td align="center">\u6C34\u5206</td></tr><tr style="height: 30px"><td align="center">\u6392\u5C3F</td></tr><tr style="height: 30px"><td align="center">\u6392\u4FBF</td></tr><tr style="height: 30px"><td align="center">\u4F53\u91CD</td></tr></table></div><div style="width:84%;float: left;display:inline-block;min-width: 200px;overflow-x: auto" id="scrollDiv1" ;><table border="1" style="word-wrap:break-word;width:100%"><tr style="height: 30px"><td ng-repeat="(0,d) in vm.dietFrontList" align="center"><div>{{d.jisshiDt}}</div></td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,s) in vm.dietFrontList" align="center">{{s.shushokuSesshuryo}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,ss) in vm.dietFrontList" align="center">{{ss.suibunSesshuryo}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,u) in vm.dietFrontList" align="center">{{u.nyouCount}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,de) in vm.dietFrontList" align="center">{{de.benCount}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,t) in vm.dietFrontList" align="center">{{t.taijuu}}</td></tr></table></div></div><div style="clear: both"></div><div style="padding-left: 10%;padding-top:5px;width:100%"><div style="width:51px;float: left;display:inline-block" id="titleDiv2"><table border="1" style="word-wrap:break-word;float:right"><tr style="height: 30px"><td align="center">\u5B9F\u65BD\u65E5</td></tr><tr style="height: 30px"><td align="center">\u98DF\u4E8B</td></tr><tr style="height: 30px"><td align="center">\u6C34\u5206</td></tr><tr style="height: 30px"><td align="center">\u6392\u5C3F</td></tr><tr style="height: 30px"><td align="center">\u6392\u4FBF</td></tr><tr style="height: 30px"><td align="center">\u4F53\u91CD</td></tr></table></div><div style="width:84%;float: left;display:inline-block;min-width: 200px;overflow-x: auto" id="scrollDiv2" ;><table border="1" style="word-wrap:break-word;width:100%"><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,d) in vm.dietAfterList" align="center"><div>{{d.jisshiDt}}</div></td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,s) in vm.dietAfterList" align="center">{{s.shushokuSesshuryo}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,ss) in vm.dietAfterList" align="center">{{ss.suibunSesshuryo}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,u) in vm.dietAfterList" align="center">{{u.nyouCount}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,de) in vm.dietAfterList" align="center">{{de.benCount}}</td></tr><tr style="height: 30px"><td style="width: 6.25%" ng-repeat="(0,t) in vm.dietAfterList" align="center">{{t.taijuu}}</td></tr></table></div></div></div></uib-tab><uib-tab index="1" heading="\u5199\u771F"><table class="table table-striped"><colgroup><col width="100%"></colgroup><tbody><tr style="height: 50px"><td style="border-top: hidden"><form name="photoForm" role="form"><div class="row" style="margin-top: -3px;margin-left: 1px;padding-right: 2px"><div class="col-md-12" style="text-align: left;padding-top: 4px"><div style="float: left"><h4 data-translate="riyoushaAnalyze.home.phototitle"></h4></div><div style="float: right;margin-left: 10px"><button class="btn btn-primary ng-scope" ng-click="vm.uploadPic()" ng-show="!(vm.picFile == null || vm.isSaving || editForm.file.$error.maxSize || editForm.file.$error.pattern)"><span data-translate="riyoushaAnalyze.home.upload">Upload</span></button> <button class="btn" ng-click="vm.uploadPic()" ng-disabled="true" ng-show="vm.picFile == null || vm.isSaving || editForm.file.$error.maxSize || editForm.file.$error.pattern"><span data-translate="riyoushaAnalyze.home.upload">Upload</span></button></div><div style="float: right;padding-top: 7px;margin-left: 10px"><input type="file" style="width:244px" ngf-select ng-model="vm.picFile" accept=".jpg,.jpeg,.png,.gif" name="file"><!-- <div ng-show="photoForm.file.$error" class="has-error small">\n                                                        <p class="help-block" ng-show="photoForm.file.$error.maxSize" data-translate="entity.validation.maxSize" translate-value-max="50MB">This file is too large.</p>\n                                                        <p class="help-block" ng-show="photoForm.file.$error.pattern" data-translate="entity.validation.pattern" >This file\'s pattern is wrong.</p>\n                                                    </div>--></div></div></div></form></td></tr><tr><td><div class="row" ng-if="vm.photoList.length > 0"><div ng-class="vm.mobile_flag == 0 ? vm.ipadClass : vm.pcClass" ng-repeat="photo in vm.photoList" style="height: 310px; margin-bottom: 30px"><div class="row"><div class="col-md-12 text-center" style="height: 200px; line-height: 200px;text-align: center"><img src="data:image/png;base64,{{photo.thumbnail}}" style="max-width: 200px; max-height: 200px" ng-click="vm.show(photo.id)"></div><div class="col-md-12 text-center" ng-bind="photo.fileName" title="{{photo.fileName}}" style="margin-bottom: 3px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis"></div><div class="col-md-12 text-center" style="margin-bottom: 3px">{{photo.lastModifiedBy}}</div><div class="col-md-12 text-center" style="margin-bottom: 3px">{{photo.uploadDate | date:\'yyyy/MM/dd\'}}</div><div class="col-md-12 text-center" style="margin-bottom: 3px"><input type="radio" ng-model="photo.publishType" value="1" style="margin-right: 4px" ng-click="vm.changePublishType(photo.id, 1)"><span data-translate="riyoushaAnalyze.home.public" ng-click="vm.changePublishTypeByText(photo, 1);">Public</span> <input type="radio" ng-model="photo.publishType" value="3" style="margin-right: 4px" ng-click="vm.changePublishType(photo.id, 3)"><span data-translate="riyoushaAnalyze.home.private" ng-click="vm.changePublishTypeByText(photo, 3);">Private</span></div><div class="col-md-12 text-center" style="margin-bottom: 3px"><button class="btn btn-info" data-translate="riyoushaAnalyze.home.show" ng-click="vm.show(photo.id)">Show</button>&nbsp;&nbsp;&nbsp; <button class="btn btn-danger" data-translate="riyoushaAnalyze.home.del" ng-click="vm.delphoto(photo.id)">Delete</button></div></div></div></div><div class="row text-center" ng-if="vm.photoList.length > 0"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPhotos()"></uib-pagination></div><div class="row alert alert-warning top-margin" ng-if="vm.photoList.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></td></tr></tbody></table></uib-tab><uib-tab index="2" heading="\u30D5\u30A1\u30A4\u30EB"><table class="table table-striped"><colgroup><col width="100%"></colgroup><tbody><tr style="height: 50px"><td style="border-top: hidden"><form name="fileForm" role="form"><div class="row" style="margin-top: -3px;margin-left: 1px;padding-right: 2px"><div class="col-md-12" style="text-align: left;padding-top: 4px"><div style="float: left"><h4 data-translate="riyoushaAnalyze.home.filetitle"></h4></div><div style="float: right;margin-left: 10px"><button class="btn btn-primary ng-scope" ng-click="vm.uploadFile()" ng-show="!(vm.file == null || vm.isFileSaving || editForm.file.$error.maxSize || editForm.file.$error.pattern)"><span data-translate="riyoushaAnalyze.home.fileupload">Upload</span></button> <button class="btn" ng-click="vm.uploadFile()" ng-disabled="true" ng-show="vm.file == null || vm.isFileSaving || editForm.file.$error.maxSize || editForm.file.$error.pattern"><span data-translate="riyoushaAnalyze.home.fileupload">Upload</span></button></div><div style="float: right;padding-top: 7px;margin-left: 10px"><input type="file" style="width:244px" ngf-select ng-model="vm.file" name="file"><!--<div ng-show="fileForm.file.$error" class="has-error small">\n                                                    <p class="help-block" ng-show="fileForm.file.$error.maxSize" data-translate="entity.validation.maxSize" translate-value-max="10MB">This file is too large.</p>\n                                                    <p class="help-block" ng-show="fileForm.file.$error.pattern" data-translate="entity.validation.pattern" >This file\'s pattern is wrong.</p>\n                                                </div>--></div></div></div></form></td></tr><tr><td><div class="row" ng-if="vm.fileList.length > 0"><div ng-class="vm.mobile_flag == 0 ? vm.ipadClass : vm.pcClass" ng-repeat="file in vm.fileList" style="height: 310px; margin-bottom: 30px"><div class="row"><div class="glyphicon glyphicon-music iconDiv" ng-if="file.fileType == 3"></div><div class="glyphicon glyphicon-film iconDiv" ng-if="file.fileType == 4"></div><div class="glyphicon glyphicon-link iconDiv" ng-if="file.fileType == 5"></div><div class="glyphicon glyphicon-file iconDiv" ng-if="file.fileType == 6"></div><div class="col-md-12 text-center" ng-bind="file.fileName" title="{{file.fileName}}" style="margin-bottom: 3px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis"></div><div class="col-md-12 text-center" style="margin-bottom: 3px">{{file.lastModifiedBy}}</div><div class="col-md-12 text-center" style="margin-bottom: 3px">{{file.uploadDate | date:\'yyyy/MM/dd\'}}</div><div class="col-md-12 text-center" style="margin-bottom: 3px"><input type="radio" ng-model="file.publishType" value="1" style="margin-right: 4px" ng-click="vm.changePublishType(file.id, 1)"><span data-translate="riyoushaAnalyze.home.public" ng-click="vm.changePublishTypeByText(file, 1);">Public</span> <input type="radio" ng-model="file.publishType" value="3" style="margin-right: 4px" ng-click="vm.changePublishType(file.id, 3)"><span data-translate="riyoushaAnalyze.home.private" ng-click="vm.changePublishTypeByText(file, 3);">Private</span></div><div class="col-md-12 text-center" style="margin-bottom: 3px"><button class="btn btn-info" data-translate="riyoushaAnalyze.home.download" ng-click="vm.download(file.id)">download</button>&nbsp;&nbsp;&nbsp; <button class="btn btn-danger" data-translate="riyoushaAnalyze.home.del" ng-click="vm.delFile(file.id)">Delete</button></div></div></div></div><div class="row text-center" ng-if="vm.fileList.length > 0"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadFiles()"></uib-pagination></div><div class="row alert alert-warning top-margin" ng-if="vm.fileList.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></td></tr></tbody></table></uib-tab></uib-tabset></div><div class="panel panel-info col-md-3" style="padding-left: 0px;padding-right: 0px;min-height: 737px"><form name="editForm" role="form" novalidate><div class="panel-heading" style="height: 41px"><h3 class="panel-title" data-translate="riyoushaAnalyze.home.comments"></h3></div><!--\u30B3\u30E1\u30F3\u30C8--><div class="table-responsive"><table class="table table-striped"><colgroup><col width="90%"><col width="10%"></colgroup><tbody><tr style="height: 53px"><td colspan="2"><div class="row" style="width:100%;margin-left: 0px"><div class="col-md-12 text-right" style="padding-right: 0px"><button class="btn btn-primary ng-scope" ng-click="vm.save()" ng-show="!vm.commentFlag && !vm.isCommentSaving"><span data-translate="riyoushaAnalyze.home.add"></span></button> <button class="btn" ng-click="vm.save()" disabled="disabled" ng-show="vm.commentFlag || vm.isCommentSaving"><span data-translate="riyoushaAnalyze.home.add"></span></button></div></div></td></tr><tr ng-repeat="ct in vm.commentsList"><td colspan="2"><div class="form-group"><textarea style="height: 110px" type="text" class="form-control" name="commentContent" ng-maxlength="200" ng-required="ct.commentContent == null || ct.commentContent == \'\' " ng-model="ct.commentContent" ng-change="vm.commentContentChange()"></textarea><div class="has-error small" ng-show="editForm.commentContent.$invalid"><p class="help-block" data-translate="riyoushaAnalyze.home.commentContentRequired" ng-show="editForm.commentContent.$error.required">This field is required.</p><p class="help-block" data-translate="riyoushaAnalyze.home.commentContentLength" ng-show="editForm.commentContent.$error.maxlength">This field cannot be longer than 200 characters.</p></div></div></td></tr><tr ng-repeat="cs in vm.commentsShowList"><td style="vertical-align: middle" colspan="2"><div style="border: 1px solid #bce8f1;border-radius: 4px;height:auto"><div style="white-space: pre-wrap;word-break:break-all"><b>{{cs.commentContent}}</b></div><div style="text-align: right"><span>{{cs.userName}}</span>&nbsp;&nbsp; <span>{{cs.datumDay|date:\'yyyy/MM/dd\'}}</span></div></div><div style="text-align: right; padding-top: 5px"><div class="btn-group flex-btn-group-container" style="float: right;margin-left: 30px"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.commentEdit(cs.id)"><span class="glyphicon glyphicon-pencil"></span> <span data-translate="entity.action.edit"></span></button> <button type="submit" class="btn btn-danger btn-sm" ng-click="vm.delete(cs.id)"><span class="glyphicon glyphicon-remove-circle"></span> <span data-translate="entity.action.delete"></span></button></div><div style="float: right; padding-top: 3px"><input type="radio" ng-model="cs.publishType" value="1" style="margin-right: 4px" ng-click="vm.changeCommentPublishType(cs.id, 1)"><span data-translate="riyoushaAnalyze.home.public" ng-click="vm.changeCommentPublishTypeByText(cs,1);">Public</span> <input type="radio" ng-model="cs.publishType" value="3" style="margin-right: 4px" ng-click="vm.changeCommentPublishType(cs.id, 3)"><span data-translate="riyoushaAnalyze.home.private" ng-click="vm.changeCommentPublishTypeByText(cs,3);">Private</span></div></div></td><!--<td style="vertical-align: middle">\n                                <div>\n                                    <button type="submit" class="btn btn-primary btn-sm" ng-click="vm.commentEdit(cs.id)" >\n                                        <span class="glyphicon glyphicon-pencil"></span>\n                                        <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span>\n                                    </button>\n                                    <button type="submit" class="btn btn-danger btn-sm" ng-click="vm.delete(cs.id)">\n                                        <span class="glyphicon glyphicon-remove-circle"></span>\n                                        <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span>\n                                    </button>\n                                    <div>\n                                        <input type="radio" ng-model="cs.publishType" value="1" style="margin-right: 4px;" ng-click="vm.changeCommentPublishType(cs.id, 1)"/><span data-translate="riyoushaAnalyze.home.public">Public</span>\n                                    </div>\n                                    <div>\n                                        <input type="radio" ng-model="cs.publishType" value="3" style="margin-right: 4px;" ng-click="vm.changeCommentPublishType(cs.id, 3)"/><span data-translate="riyoushaAnalyze.home.private">Private</span>\n                                    </div>\n                                </div>\n                            </td>--></tr></tbody></table></div></form></div></div></div>');
$templateCache.put('app/home/home.html','<style>.panel{\n        padding-top: 20px;\n        padding-left: 20px;\n        padding-right: 20px;\n        background:white;\n        border: #DDDDDD 1px solid;\n        border-radius:0 0 4px 4px;\n        border-top:none;\n    }</style><div ng-cloak><div ng-switch="vm.isAuthenticated()"><!--<h2 ng-switch-when="false" data-translate="login.titleNew" class="col-md-offset-2">Sign in</h2>--><div ng-switch-when="false" class="row" style="width:80%;margin: 0 auto"><h2 data-translate="login.titleNew" class="col-md-offset-2">Sign in</h2><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><ul id="login" class="nav nav-tabs col-md-8 col-md-offset-2" role="tablist" style="padding-right: 0"><li class="active" value="2" style="width: 50%; text-align: center"><a href="javascript:void(0)" id="twoA" role="tab" data-toggle="tab" data-translate="login.titleTwo" onclick="changColorTwo();" style="font-size: 18px;color:black"></a></li><li value="1" style="width: 50%;text-align: center"><a href="javascript:void(0)" id="oneA" role="tab" data-toggle="tab" data-translate="login.titleOne" onclick="changColorOne();" style="font-size: 18px;color:black;margin-right: 0px"></a></li></ul><!-- \u9009\u9879\u5361\u9762\u677F --><div id="myTabContent" class="tab-content col-md-8 col-md-offset-2" style="padding-left: 0px;padding-right: 0px"><!--\u30B1\u30A2\u6A39\uFF12.\uFF10--><div class="tab-pane active panel" id="two"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'login.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning" style="padding-bottom: 20px"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div><!--\u30B1\u30A2\u6A39\uFF11.\uFF10--><div class="tab-pane panel" id="one"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="jigyoushoCd" data-translate="login.form.jigyoushoCd">Login</label><input type="text" class="form-control" id="jigyoushoCd" placeholder="{{\'login.form.jigyoushoCd.placeholderNew\' | translate}}" ng-model="vm.jigyoushoCd"></div><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username1" placeholder="{{\'login.form.username.placeholder\' | translate}}" ng-model="vm.usernameOne"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password1" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.passwordOne"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe1" ng-model="vm.rememberMeOne" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div><div ng-switch-when="true"><div class="container-fluid home-link"><!--\u30B1\u30A2\u6A39Free--><div class="col-md-4" ng-if="vm.showCaretreeFree && !vm.houmonTimeCard"><div class="home-div" ng-if="ribbonEnv == \'dev\'" ng-click="vm.gotoCaretreeFree(0);"><div class="col-md-12 caretree-free-top"></div><div class="col-md-12"><div class="caretree-free-image"></div></div><div class="col-md-12"><p class="text-center home-info" data-translate="global.home.caretree.info">\u30AF\u30E9\u30A6\u30C9\u578B\u4ECB\u8B77\u8ACB\u6C42\u30BD\u30D5\u30C8</p><p class="text-center text-uppercase"><strong><a target="_blank" href="" data-translate="global.home.caretree.link">\u30B1\u30A2\u6A39Free</a></strong></p></div></div><div class="home-div" ng-if="ribbonEnv != \'dev\'" ng-click="vm.gotoCaretreeFree(1);"><div class="col-md-12 caretree-free-top"></div><div class="col-md-12"><div class="caretree-free-image"></div></div><div class="col-md-12"><p class="text-center home-info" data-translate="global.home.caretree.info">\u30AF\u30E9\u30A6\u30C9\u578B\u4ECB\u8B77\u8ACB\u6C42\u30BD\u30D5\u30C8</p><p class="text-center text-uppercase"><strong><a target="_blank" href="" data-translate="global.home.caretree.link">\u30B1\u30A2\u6A39Free</a></strong></p></div></div></div><!--\u30B1\u30A2\u6A39\u30BF\u30A4\u30E0\u30AB\u30FC\u30C9(BETA\u7248)--><div class="col-md-4" ng-if="vm.showTimecard && !vm.houmonTimeCard"><div class="home-div" id="timecardClickDiv" onclick="timecardClick(event)"><div class="col-md-12 home-top"></div><div class="col-md-12"><div class="dakoku-image"></div></div><div class="col-md-12"><p class="text-center home-info" data-translate="global.home.timecard.info">\u30AF\u30E9\u30A6\u30C9\u578B\u52E4\u6020\u7BA1\u7406\u30BD\u30D5\u30C8</p><div class="text-center text-uppercase home-link dropdown pointer" id="timecardClick" uib-dropdown><a class="dropdown-toggle" uib-dropdown-toggle><strong data-translate="global.home.timecard.link">\u30B1\u30A2\u6A39\u30BF\u30A4\u30E0\u30AB\u30FC\u30C9</strong><span class="home-beta" data-translate="global.home.beta">(beta\u7248)</span></a><ul class="dropdown-menu dakoku-dropdown" id="timecardUl" style="z-index: 999" uib-dropdown-menu><li role="presentation"><a style="text-decoration: underline" ui-sref="timecard" data-translate="global.menu.timecard.timer">\u6253\u523B</a></li><li role="presentation"><a style="text-decoration: underline" ui-sref="timecard-management({currentYear:vm.currentYear,currentMonth:vm.currentMonth})" data-translate="global.menu.timecard.management" has-group-auth="admin">Management</a></li><li role="presentation"><a style="text-decoration: underline" ui-sref="shokushu-management" data-translate="global.menu.timecard.shokushu" has-group-auth="admin">shokushu</a></li><li role="presentation"><a style="text-decoration: underline" ui-sref="group-option" data-translate="global.menu.timecard.option" has-group-auth="admin">Option</a></li><li role="presentation"><a style="text-decoration: underline" ui-sref="option-user" data-translate="global.menu.timecard.optionUser" has-group-auth="admin">OptionUser</a></li></ul></div></div></div></div><div class="col-md-4" ng-if="vm.showTimecard && vm.houmonTimeCard"><div class="home-div" ng-click="vm.timecardClick()"><div class="col-md-12 home-top"></div><div class="col-md-12"><div class="dakoku-image"></div></div><div class="col-md-12"><p class="text-center home-info" data-translate="global.home.timecard.info">\u30AF\u30E9\u30A6\u30C9\u578B\u52E4\u6020\u7BA1\u7406\u30BD\u30D5\u30C8</p></div></div></div><!--\u30B1\u30A2\u6A39\u308F\u304B\u308B--><div class="col-md-4" ng-if="vm.showAnalyze && !vm.houmonTimeCard"><div class="home-div" ng-click="vm.gotoAnalyze();" style="outline: none"><div class="col-md-12 analyze-top"></div><div class="col-md-12"><div class="analyze-image"></div></div><div class="col-md-12"><p class="text-center home-info" data-translate="global.home.analyze.info">\u4ECB\u8B77\u8A18\u9332</p><p class="text-center text-uppercase"><a target="_blank" onclick=""><strong data-translate="global.home.analyze.link">Analyze</strong></a></p></div></div></div><!--\u30DF\u30C3\u30B1\u30EB\u30A2\u30FC\u30C8--><div class="col-md-4" ng-if="!vm.houmonTimeCard"><div class="home-div" onclick="window.open(\'https://www.mikkelart.com/caretree1\')"><div class="col-md-12"></div><div class="col-md-12"><div class="mikkeru-image"></div></div><div class="col-md-12"><p class="text-center home-info" data-translate="global.home.mikkeru.info">\u8A8D\u77E5\u75C7\u4E88\u9632\u30D7\u30ED\u30B0\u30E9\u30E0</p><p class="text-center text-uppercase"><strong><a href="" target="_blank" data-translate="global.home.mikkeru.link">\u30DF\u30C3\u30B1\u30EB\u30A2\u30FC\u30C8</a></strong></p></div></div></div></div></div></div></div><script>$(function(){\n        $("#twoA").css("color","blue");\n    });\n    function changColorTwo(){\n        $(\'#oneA\').parent().removeClass(\'active\');\n        $(\'#twoA\').parent().addClass(\'active\');\n        $(\'#one\').removeClass(\'active\');\n        $(\'#two\').addClass(\'active\');\n        $("#twoA").css("color","blue");\n        $("#oneA").css("color","black");\n    }\n    function changColorOne(){\n        $(\'#twoA\').parent().removeClass(\'active\');\n        $(\'#oneA\').parent().addClass(\'active\');\n        $(\'#two\').removeClass(\'active\');\n        $(\'#one\').addClass(\'active\');\n        $("#oneA").css("color","blue");\n        $("#twoA").css("color","black");\n    }\n    function timecardClick(e) {\n    \tif ($(\'#timecardClick\').hasClass(\'open\')){\n            $(\'#timecardClick\').removeClass(\'open\');\n        } else {\n            $(\'#timecardClick\').addClass(\'open\');\n            var timecardX1 = $(\'#timecardClickDiv\').offset().left;\n            var timecardY1 = $(\'#timecardClickDiv\').offset().top;\n            var top = e.clientY + $(document).scrollTop();\n            var left = e.clientX + $(document).scrollLeft();\n            if (left >= timecardX1 + $(\'#timecardClickDiv\').width() / 2) {\n                left = left - 200;\n            }\n            if (top >= timecardY1 + $(\'#timecardClickDiv\').height() / 2) {\n                top = top - 150;\n            }\n            $(\'#timecardUl\').offset({top: top, left: left});\n\n        }\n    }</script>');
$templateCache.put('app/message/no-license.html','<div ng-cloak><div ng-switch="vm.isAuthenticated()"><div><div class="container-fluid home-link"><div class="col-md-12"><div class="home-div" style="height: 500px"><div class="col-md-4"><div class="col-md-12 caretree-free-top"></div><div class="col-md-12"><div class="caretree-free-image"></div></div><div class="col-md-12"><p class="text-center home-info" data-translate="global.home.caretree.info">\u30AF\u30E9\u30A6\u30C9\u578B\u4ECB\u8B77\u8ACB\u6C42\u30BD\u30D5\u30C8</p><p class="text-center text-uppercase"><strong><a ng-href="{{vm.caretreeLink}}" data-translate="global.home.caretree.link">\u30B1\u30A2\u6A39Free</a></strong></p></div></div><div class="col-md-8"><br><br><h4>\u7533\u3057\u99C5\u3054\u3056\u3044\u307E\u305B\u3093\u3001\u3054\u8CFC\u5165\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u304C</h4><h4>\u78BA\u8A8D\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002</h4><br><h4>\u3054\u8CFC\u5165\u6E08\u306E\u5834\u5408\u306F\u3001\u304A\u624B\u6570\u3067\u3059\u304C</h4><h4>\u5F0A\u793E\u30B5\u30DD\u30FC\u30C8\u307E\u3067\u3054\u9023\u7D61\u4E0B\u3055\u3044\u3002</h4><br><h1 style="color: red">\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u3054\u8CFC\u5165\u306F\u3053\u3061\u3089\u304B\u3089</h1><h1 style="padding-left: 60%; color: skyblue"><a href="/" style="text-decoration: none; color: skyblue">>></a></h1></div></div></div></div></div></div></div>');
$templateCache.put('app/timecard/houmonTimecard.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><table class="table table-bordered table-striped"><colgroup><col style="width:25%"><col style="width:35%"></colgroup><tr><td colspan="2" class="bg-success"><div class="row"><div class="text-center" style="font-size: 2.1em"><strong>\u6253\u523B\u65E5\uFF1A{{vm.currentCalendar}}</strong></div></div><div style="text-align: center"><span class="hour-timer" style="font-size: 55px; font-family: \'Syncopate, sans-serif\'">{{vm.currentClock}}</span></div><!--<div class="row" ng-show="vm.user.passwordRequired">\n                    <div class="col-md-1">\n                    </div>\n                    <div class="col-md-10">\n                        <input type="password" class="form-control" style= "height:80px; font-size:2em;" placeholder="\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044" name="password" ng-model="vm.password">\n                    </div>\n                </div>--><div class="clearfix" style="overflow: auto"><div ng-switch="vm.listup().length > 0"><div class="list-group" ng-switch-when="true" style="height: 20px"><div class="list-group-item" type="button button-info" ng-repeat="timecard in vm.listUpData">{{timecard.name}}<span class="badge pull-right">{{timecard.time| date:\'HH:mm\':vm.groupTimezone}}</span><br></div></div></div></div></td></tr><tr ng-if="vm.group.timecardShiftFlag"><td colspan="2"><div class="col-md-3" ng-repeat="timeZone in vm.timeZoneList"><label style="margin-left:10px; font-size: 25px"><input type="radio" ng-model="vm.timeZone" ng-click="vm.timeZoneClick();" ng-value="timeZone"> {{timeZone.name}}({{timeZone.startTime}}--{{timeZone.endTime}})</label></div><!--<div ng-show="vm.showTimeZoneFlag" class="col-md-12 has-error small">\n                    <p class="help-block" ng-show="vm.showTimeZoneFlag">\n                        \u30B7\u30D5\u30C8\u6642\u9593\u5E2F\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\n                    </p>\n                </div>--></td></tr><tr><td colspan="2"><div class="btn-group btn-group-justified" role="group"><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn btn-success" ng-disabled="!vm.isCheckInEnabled() || vm.isSaving" ng-click="vm.checkIn()"><span style="font-size: 2em">\u51FA\u52E4</span></button></div><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn btn-danger" ng-disabled="!vm.isCheckOutEnabled() || vm.isSaving" ng-click="vm.checkOut()"><span style="font-size: 2em">\u9000\u52E4</span></button></div></div></td></tr><tr><td colspan="2"><div class="btn-group btn-group-justified" role="group"><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn btn-primary" ng-disabled="!vm.isBeOutEnabled() || vm.isSaving" ng-click="vm.goOut()"><span style="font-size: 2em">\u5916\u51FA</span></button></div><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn btn-warning" ng-disabled="!vm.isReEntryEnabled() || vm.isSaving" ng-click="vm.reEntry()"><span style="font-size: 2em">\u518D\u5165</span></button></div></div></td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">Close</span></button></div><div ng-switch="vm.gyou50On" class="clearfix" style="height: 560px; overflow: scroll" ng-show="false"><div ng-switch-when="false"><table class="table table-bordered table-condensed" style="max-height: 200px; overflow-x: auto"><tr ng-repeat="user in vm.userList" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></div><div ng-switch-when="true"><uib-tabset active="active" justified="true"><uib-tab index="0" heading="\u30A2"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF71\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="1" heading="\u30AB"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF76\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="2" heading="\u30B5"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF7B\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="3" heading="\u30BF"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF80\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="4" heading="\u30CA"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF85\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="5" heading="\u30CF"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF8A\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="6" heading="\u30DE"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF8F\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="7" heading="\u30E4"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF94\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="8" heading="\u30E9"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF97\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="9" heading="\u30EF"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF9C\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/timecard/select-duty-occupation.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="timecard.management.selectDutyOccupation"></h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="form-group" style="text-align: center"><select style="width: 500px;float: none;margin-left: auto;margin-right: auto" class="col-md-3 form-control" ng-model="vm.yotei" ng-options="youtei as youtei.nameAndTime for youtei in vm.yoteiList"></select></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-click="vm.save()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/timecard/timecard.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><table class="table table-bordered table-striped"><colgroup><col style="width:25%"><col style="width:35%"><col style="width:40%"></colgroup><tr><td><div ng-switch="vm.isUserSelected()"><div ng-switch-when="true"><div ng-switch="vm.haveUserPhoto()"><div ng-switch-when="true" class="thumbnail" style="border:none"><img class="img-responsive img-thumbnail" src="{{vm.user.imageUrl}}"><div class="caption text-center"><h4><strong>{{vm.user.lastName}} {{vm.user.firstName}} \u69D8</strong></h4></div></div><div ng-switch-when="false" class="thumbnail" style="border:none"><img src="../content/images/no-image-icon.png"><div class="caption text-center"><h4>\u5199\u771F\u304C\u3042\u308A\u307E\u305B\u3093</h4></div></div></div></div><div ng-switch-when="false" class="thumbnail" style="border:none"><img src="../content/images/no-image-icon.png"><div class="caption text-center"><h4>\u30B9\u30BF\u30C3\u30D5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044</h4></div></div><div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div></div></td><td class="bg-success"><div class="row"><div class="text-center" style="font-size: 2.1em"><strong>\u6253\u523B\u65E5\uFF1A{{vm.currentCalendar}}</strong></div></div><hr><div class="clock" style="text-align: center"><span class="hour-timer" style="font-size: 55px; font-family: \'Syncopate, sans-serif\'">{{vm.currentClock}}</span></div><div class="row" ng-show="vm.user.passwordRequired"><div class="col-md-1"></div><div class="col-md-10"><input type="password" class="form-control" style="height:80px; font-size:2em" placeholder="\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044" name="password" ng-model="vm.password"></div></div><hr><div class="clearfix" style="height: 160px;overflow: auto"><div ng-switch="vm.listup().length > 0"><div class="list-group" ng-switch-when="true"><div class="list-group-item" type="button button-info" ng-repeat="timecard in vm.listUpData">{{timecard.name}}<span class="badge pull-right">{{timecard.time| date:\'HH:mm\':vm.groupTimezone}}</span><br></div></div></div></div></td><td rowspan="3"><div class="panel panel-default"><div class="panel-heading clearfix"><h4 class="panel-title pull-left" style="padding-top: 7.5px">{{vm.groupTitle()}}</h4><div class="pull-right" uib-dropdown><button type="button" class="btn btn-warning" uib-dropdown-toggle>\u30B0\u30EB\u30FC\u30D7<span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="split-button"><li role="menuitem" ng-repeat="group in vm.groups track by group.id"><a ng-click="vm.changeGroup(group)">{{group.name}}</a></li></ul></div></div></div><div class="row" style="padding-bottom: 15px"><div class="col-md-6"><input type="checkbox" ng-model="vm.gyou50On"> \u4E94\u5341\u97F3\u691C\u7D22</div><div class="col-md-6" ng-show="vm.totalItems/vm.itemsPerPage > 1"><uib-pagination style="padding: 0; margin: 0; display:inline" class="pull-right pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-click="vm.transition()"></uib-pagination></div></div><div ng-switch="vm.gyou50On" class="clearfix" style="height: 560px; overflow: scroll"><div ng-switch-when="false"><table class="table table-bordered table-condensed" style="max-height: 200px; overflow-x: auto"><tr ng-repeat="user in vm.userList" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></div><div ng-switch-when="true"><uib-tabset active="active" justified="true"><uib-tab index="0" heading="\u30A2"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF71\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="1" heading="\u30AB"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF76\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="2" heading="\u30B5"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF7B\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="3" heading="\u30BF"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF80\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="4" heading="\u30CA"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF85\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="5" heading="\u30CF"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF8A\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="6" heading="\u30DE"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF8F\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="7" heading="\u30E4"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF94\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="8" heading="\u30E9"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF97\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab><uib-tab index="9" heading="\u30EF"><table class="table table-bordered table-condensed" style="margin-top:10px"><tr ng-repeat="user in vm.userList | startsWith50On: \'\uFF9C\'" ng-class="{\'info\': vm.user.id === user.id}" ng-click="vm.changeUser(user)"><td style="height:50px;width: 50px"><img class="img-responsive" style="width:100%" src="{{user.imageUrl}}"></td><td style="vertical-align: middle;font-size: 26px"><span>{{user.lastName}} {{user.firstName}}</span><div class="pull-right" data-translate="timecard.status.{{user.timecards[0][\'workTimeDetail\'][\'status\']}}"></div></td></tr></table></uib-tab></uib-tabset></div></div></td></tr><tr ng-if="vm.group.timecardShiftFlag"><td colspan="2"><div class="col-md-3" ng-repeat="timeZone in vm.timeZoneList"><label style="margin-left:10px"><input type="radio" ng-model="vm.timeZone" ng-click="vm.timeZoneClick();" ng-value="timeZone"> {{timeZone.name}}({{timeZone.startTime}}--{{timeZone.endTime}})</label></div><div ng-show="vm.showTimeZoneFlag" class="col-md-12 has-error small"><p class="help-block" ng-show="vm.showTimeZoneFlag">\u30B7\u30D5\u30C8\u6642\u9593\u5E2F\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044</p></div></td></tr><tr><td colspan="2"><div class="btn-group btn-group-justified" role="group"><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn btn-success" ng-disabled="!vm.isCheckInEnabled() || vm.isSaving" ng-click="vm.checkIn()"><span style="font-size: 2em">\u51FA\u52E4</span></button></div><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn btn-danger" ng-disabled="!vm.isCheckOutEnabled() || vm.isSaving" ng-click="vm.checkOut()"><span style="font-size: 2em">\u9000\u52E4</span></button></div><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn btn-primary" ng-disabled="!vm.isBeOutEnabled() || vm.isSaving" ng-click="vm.goOut()"><span style="font-size: 2em">\u5916\u51FA</span></button></div><div class="btn-group btn-group-lg" role="group"><button type="button" class="btn btn-warning" ng-disabled="!vm.isReEntryEnabled() || vm.isSaving" ng-click="vm.reEntry()"><span style="font-size: 2em">\u518D\u5165</span></button></div></div></td></tr></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">Close</span></button></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="6" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength6">Your password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="6" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength6">Your confirmation password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group" ng-class="vm.existButtonClass"><label class="control-label" for="login" data-translate="global.form.username">Username</label><span style="color: red">*</span> <input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required ng-change="vm.loginMouseleave();" ng-blur="vm.loginMouseleave();"><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div><div ng-show="vm.exist"><p class="help-block" style="color: #a94442" data-translate="register.messages.validate.login.exist"></p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><span style="color: red">*</span> <input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="6" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength6">Your password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><span style="color: red">*</span> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="6" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength6">Your confirmation password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><span style="color: red">*</span> <input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid || vm.existButton" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p></div></div></div>');
$templateCache.put('app/account/settings/setting-photo.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="settings.form.photo">\u5199\u771F\u3092\u53D6\u308B</h4></div><div class="modal-body" style="height: 400px"><jhi-alert-error></jhi-alert-error><div><ng-camera capture-message="Cheeeese!" countdown="3" output-height="400" output-width="300" viewer-height="400" viewer-width="300" crop-height="400" crop-width="300" image-format="jpeg" jpeg-quality="100" action-message="\u5199\u771F\u3092\u53D6\u308B" snapshot="vm.photo" flash-fallback-url="content/flash/webcam.swf" shutter-url="content/flash/shutter.mp3"></ng-camera></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-primary" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/account/settings/setting-upload-photo.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="settings.form.photo">\u5199\u771F\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9</h4></div><div class="modal-body" style="height: 400px"><jhi-alert-error></jhi-alert-error><form name="editForm" role="form"><div class="row" style="margin-bottom: 12px"><div class="col-md-7"><div class="form-group"><button ngf-select ngf-fix-orientation="true" ngf-capture="\'camera\'" ng-model="vm.picFile" accept="image/*" name="file" ngf-validate="{size: {max: \'50MB\'}, pattern: \'.jpg,.jpeg,.png,.gif\'}" ngf-model-invalid="errorFile" style="margin-bottom: 5px">\u753B\u50CF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044</button><div ngf-drop ng-model="vm.picFile" ngf-pattern="image/*" class="cropArea"><img-crop image="vm.picFile | ngfDataUrl" result-image="vm.croppedDataUrl" ng-init="vm.croppedDataUrl=\'\'"></img-crop></div><div ng-show="editForm.file.$error" class="has-error small"><p class="help-block" ng-show="editForm.file.$error.maxSize" data-translate="entity.validation.maxSize" translate-value-max="50MB">This file is too large.</p><p class="help-block" ng-show="editForm.file.$error.pattern" data-translate="entity.validation.pattern">This file\'s pattern is wrong.</p></div></div></div><div class="col-md-5"><span>\u6CE8\uFF1A<br>\u300C\u753B\u50CF\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u300D\u306E\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3068\u4FDD\u5B58\u3055\u308C\u305F\u5199\u771F\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3067\u304D\u307E\u3059\u3002</span></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" class="btn btn-default" ng-disabled="vm.picFile == null || editForm.file.$error.maxSize || editForm.file.$error.pattern" ng-click="vm.uploadPic()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.upload">Upload</span></button></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="seiKana" data-translate="settings.form.seiKana">\u59D3\uFF08\u30AB\u30CA\uFF09</label><input type="text" class="form-control" id="seiKana" kata-kana name="seiKana" placeholder="{{\'settings.form.seiKana.placeholder\' | translate}}" ng-model="vm.settingsAccount.seiKana" ng-maxlength="50" maxlength="50"><div ng-show="form.seiKana.$dirty && form.seiKana.$invalid"><p class="help-block" ng-show="form.seiKana.$error.maxlength" data-translate="settings.messages.validate.seiKana.maxlength">Your sei kana cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="meiKana" data-translate="settings.form.meiKana">\u540D\uFF08\u30AB\u30CA\uFF09</label><input type="text" class="form-control" id="meiKana" kata-kana name="meiKana" placeholder="{{\'settings.form.meiKana.placeholder\' | translate}}" ng-model="vm.settingsAccount.meiKana" ng-maxlength="50" maxlength="50"><div ng-show="form.meiKana.$dirty && form.meiKana.$invalid"><p class="help-block" ng-show="form.meiKana.$error.maxlength" data-translate="settings.messages.validate.meiKana.maxlength">Your mei kana cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group" ng-if="vm.gtc_caretree2_timecard_allfunction_fullaccess"><label data-translate="settings.form.photo">Photo</label><div class="thumbnail"><img src="{{vm.settingsAccount.imageUrl}}"></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button> <button type="submit" ui-sref="settings.upload({login:vm.settingsAccount.login})" class="btn btn-primary" ng-if="vm.gtc_caretree2_timecard_allfunction_fullaccess"><span data-translate="settings.form.upload"></span></button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length === 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length === 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/gateway/gateway.html','<div><h2 data-translate="gateway.title">Gateway</h2><h3 data-translate="gateway.routes.title">Current routes</h3><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()" ng-show="vm.updatingRoutes === false"><span class="glyphicon glyphicon-refresh glyphicon-"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button> <button type="button" class="btn btn-danger" ng-show="vm.updatingRoutes"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button></p><table class="table table-striped table-responsive"><thead><tr><th data-translate="gateway.routes.url">URL</th><th data-translate="gateway.routes.service">Service</th><th data-translate="gateway.routes.servers">Available servers</th></tr></thead><tr ng-repeat="route in vm.gatewayRoutes"><td>{{route.path}}</td><td>{{route.serviceId}}</td><td><div ng-show="{{route.serviceInstances.length === 0}}" class="label label-danger" data-translate="gateway.routes.error">Warning: no server available!</div><table class="table table-responsive"><tr ng-repeat="instance in route.serviceInstances"><td>{{instance.host}}:{{instance.port}}</td><td ng-show="{{instance.instanceInfo.status === \'UP\'}}"><div class="label label-success">{{instance.instanceInfo.status}}</div></td><td ng-hide="{{instance.instanceInfo.status === \'UP\'}}"><div class="label label-danger">{{instance.instanceInfo.status}}</div></td></tr></table></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/components/login/login.html','<style>.panel{\n        padding-top: 20px;\n        padding-left: 20px;\n        padding-right: 20px;\n        background:white;\n        border: #DDDDDD 1px solid;\n        border-radius:0 0 4px 4px;\n        border-top:none;\n    }</style><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h2 class="modal-title" data-translate="login.title">Sign in</h2></div><div class="modal-body"><div class="row"><!--<div class="col-md-4 col-md-offset-4">\n            <h1 data-translate="login.title">Sign in</h1>\n        </div>--><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><ul id="login" class="nav nav-tabs col-md-10 col-md-offset-1" role="tablist" style="padding-right: 0"><li class="active" value="2" style="width: 50%; text-align: center"><a href="#two" id="twoA" role="tab" data-toggle="tab" data-translate="login.titleTwo" style="font-size: 18px;color:black"></a></li><li value="1" style="width: 50%;text-align: center"><a href="#one" id="oneA" role="tab" data-toggle="tab" data-translate="login.titleOne" style="font-size: 18px;color:black;margin-right: 0px"></a></li></ul><!-- \u9009\u9879\u5361\u9762\u677F --><div id="myTabContent" class="tab-content col-md-10 col-md-offset-1" style="padding-left: 0px;padding-right: 0px"><!--\u30B1\u30A2\u6A39\uFF12.\uFF10--><div class="tab-pane active panel" id="two"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'login.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning" style="padding-bottom: 20px"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div><!--\u30B1\u30A2\u6A39\uFF11.\uFF10--><div class="tab-pane panel" id="one"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="jigyoushoCd" data-translate="login.form.jigyoushoCd">Login</label><input type="text" class="form-control" id="jigyoushoCd" placeholder="{{\'login.form.jigyoushoCd.placeholderNew\' | translate}}" ng-model="vm.jigyoushoCd"></div><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username1" placeholder="{{\'login.form.username.placeholder\' | translate}}" ng-model="vm.usernameOne"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password1" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.passwordOne"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe1" ng-model="vm.rememberMeOne" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div></div></div></div></div><script>$(function() {\n        $("#twoA").css("color", "blue");\n        $(\'#login a:first\').tab(\'show\');\n        $(\'#login a\').click(function (e) {\n          e.preventDefault();\n          $(this).tab(\'show\');\n          if ($(this).attr(\'id\') == \'twoA\') {\n        \t  changColorTwo();\n          } else {\n        \t  changColorOne();\n          }\n        });\n    });\n    function changColorTwo(){\n        $("#twoA").css("color","blue");\n        $("#oneA").css("color","black");\n    }\n    function changColorOne(){\n        $("#oneA").css("color","blue");\n        $("#twoA").css("color","black");\n    }</script>');
$templateCache.put('app/corporation/staff/staff.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-6 h2">\u30A2\u30AB\u30A6\u30F3\u30C8\u4E00\u89A7</label><div class="col-md-6 text-right"><button class="btn btn-primary" ui-sref="staff.edit">\u30A2\u30AB\u30A6\u30F3\u30C8\u8FFD\u52A0</button></div></div><div class="form-group"><label class="col-md-1 control-label">LoginID</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u540D\u524D</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u540D\u524D</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u5229\u7528\u505C\u6B62</label><div class="col-md-2 checkbox"><label><input type="checkbox"></label></div></div><div class="form-group"><label class="col-md-1 control-label">\u88FD\u54C1ID</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u88FD\u54C1\u540D</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u8CA9\u58F2\u5E97ID</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u8CA9\u58F2\u5E97\u540D</label><div class="col-md-2"><input type="text" class="form-control"></div></div><div class="form-group"><div class="col-md-12 text-center"><button class="btn btn-primary"><span class="glyphicon glyphicon-search"></span> <span>\u691C\u7D22</span></button> <button class="btn btn-default"><span class="glyphicon glyphicon-refresh"></span> <span>\u30AF\u30EA\u30A2</span></button></div></div></form><hr><table class="table table-striped"><thead><tr><th>LoginID</th><th>\u540D\u524D</th><th>\u88FD\u54C1\u540D</th><th>\u8CA9\u58F2\u5E97\u540D</th><th>\u5229\u7528\u958B\u59CB\u5E74\u6708\u65E5</th><th>\u5229\u7528\u505C\u6B62</th><th></th></tr></thead><tbody><tr ng-repeat="staff in vm.staffList"><td>{{staff.loginId}}</td><td>{{staff.sei}}\u3000{{staff.mei}}</td><td>{{staff.productNm}}</td><td>{{staff.shopNm}}}</td><td>{{staff.beginDate}}</td><td><label ng-if="staff.useStop" class="glyphicon glyphicon-ok"></label><label ng-if="!staff.useStop" class="glyphicon glyphicon-remove"></label></td><td><button class="btn btn-info btn-sm">\u8868\u793A</button> <button class="btn btn-primary btn-sm" ui-sref="staff.edit">\u7DE8\u96C6</button> <button class="btn btn-danger btn-sm" ng-click="vm.remove($index)">\u524A\u9664</button></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-click="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/home/dialog/license.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="" data-translate="global.license.title"></h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div><div class="container-fluid home-link"><div class="col-md-12"><div class="home-div" style="height: 400px"><div class="col-md-4"><div class="col-md-12 caretree-free-top"></div><div class="col-md-12"><div class="caretree-free-image"></div></div><div class="col-md-12" style="padding-left: 0px;padding-right: 0px"><p class="text-center home-info" data-translate="global.home.caretree.info">\u30AF\u30E9\u30A6\u30C9\u578B\u4ECB\u8B77\u8ACB\u6C42\u30BD\u30D5\u30C8</p><p class="text-center text-uppercase"><strong><a ng-href="{{vm.caretreeLink}}" data-translate="global.home.caretree.link">\u30B1\u30A2\u6A39Free</a></strong></p></div></div><div class="col-md-8"><br><br><h4>\u7533\u3057\u99C5\u3054\u3056\u3044\u307E\u305B\u3093\u3001\u3054\u8CFC\u5165\u306E\u30E9\u30A4\u30BB\u30F3\u30B9\u304C</h4><h4>\u78BA\u8A8D\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002</h4><br><h4>\u3054\u8CFC\u5165\u6E08\u306E\u5834\u5408\u306F\u3001\u304A\u624B\u6570\u3067\u3059\u304C</h4><h4>\u5F0A\u793E\u30B5\u30DD\u30FC\u30C8\u307E\u3067\u3054\u9023\u7D61\u4E0B\u3055\u3044\u3002</h4><br><h2 style="color: red" ui-sref="inquiry" ng-click="vm.goInquiry();">\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u3054\u8CFC\u5165\u306F\u3053\u3061\u3089\u304B\u3089</h2><h2 style="padding-left: 80%; color: skyblue"><a href="/" style="text-decoration: none; color: skyblue">>></a></h2></div></div></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button></div>');
$templateCache.put('app/kiroku/vital/vital.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><h4 class="modal-title" id="vitalKirokuLabel" data-translate="vital.home.title">Create a vital kiroku</h4></div><div class="modal-body"><div class="form-group"><label data-translate="vital.title.riyoushaId">\u5229\u7528\u8005ID</label><input type="text" class="form-control" name="riyoushaId" ng-model="vm.vital.riyoushaId" placeholder="60919" ng-required="vm.vital.riyoushaId == null"><div ng-show="editForm.riyoushaID.$invalid"><p class="help-block" ng-show="editForm.riyoushaId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="vital.title.jisshiDt">\u5B9F\u65BD\u65E5</label><input type="text" class="form-control" name="jisshiDt" ng-model="vm.vital.jisshiDt" ng-required="vm.vital.jisshiDt == null" placeholder="2016/08/18"><div ng-show="editForm.jisshiDt.$invalid"><p class="help-block" ng-show="editForm.jisshiDt.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="vital.title.jisshiTm">\u5B9F\u65BD\u6642\u9593</label><input type="text" class="form-control" name="jisshiTm" ng-model="vm.vital.jisshiTm" ng-required="vm.vital.jisshiTm == null" placeholder="11:30"><div ng-show="editForm.jisshiTm.$invalid"><p class="help-block" ng-show="editForm.jisshiTm.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="vital.title.taion">\u4F53\u6E29</label>(\u2103) <input type="text" class="form-control" name="taion" ng-model="vm.vital.taion" placeholder="35.9"></div><div class="form-group"><label data-translate="vital.title.yuunetsuKbn">\u6709\u71B1\u533A\u5206</label><select class="form-control" name="yuunetsuKbn" ng-model="vm.vital.yuunetsuKbn"><option value="1">\u6709</option><option value="0">\u7121</option></select></div><div class="form-group"><label data-translate="vital.title.ketsuatsuUe">\u8840\u5727\uFF08\u4E0A\uFF09</label>(mmHg) <input type="text" class="form-control" name="ketsuatsuUe" ng-model="vm.vital.ketsuatsuUe" placeholder="120"></div><div class="form-group"><label data-translate="vital.title.ketsuatsuShita">\u8840\u5727\uFF08\u4E0B\uFF09</label>(mmHg) <input type="text" class="form-control" name="ketsuatsuShita" ng-model="vm.vital.ketsuatsuShita" placeholder="90"></div><div class="form-group"><label data-translate="vital.title.myakuhaku">\u8108\u62CD</label>(\u56DE/\u5206) <input type="text" class="form-control" name="myakuhaku" ng-model="vm.vital.myakuhaku" placeholder="70"></div><div class="form-group"><label data-translate="vital.title.kokyuu">\u547C\u5438</label>(\u56DE/\u5206) <input type="text" class="form-control" name="kokyuu" ng-model="vm.vital.kokyuu" placeholder="0"></div><div class="form-group"><label data-translate="vital.title.spo">SPO</label>(%) <input type="text" class="form-control" name="spo" ng-model="vm.vital.spo" placeholder="0"></div><div class="form-group"><label data-translate="vital.title.huseimyakuKbn">\u4E0D\u6574\u8108\u533A\u5206</label><select class="form-control" name="huseimyakuKbn" ng-model="vm.vital.huseimyakuKbn"><option value="1">\u6709</option><option value="0">\u7121</option></select></div><div class="form-group"><label data-translate="vital.title.taijuu">\u4F53\u91CD(Kg)</label><input type="text" class="form-control" name="taijuu" ng-model="vm.vital.taijuu" placeholder="61.9"></div><div class="form-group"><label data-translate="vital.title.bikou">\u5099\u8003</label><textarea rows="3" class="form-control" name="bikou" ng-model="vm.vital.bikou"></textarea></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<style type="text/css">.dropdown-submenu {\n        position: relative;\n    }\n    .dropdown-submenu > .dropdown-menu {\n        top: 0;\n        left: 100%;\n        margin-top: -6px;\n        margin-left: -1px;\n        -webkit-border-radius: 0 6px 6px 6px;\n        -moz-border-radius: 0 6px 6px;\n        border-radius: 0 6px 6px 6px;\n    }\n    .dropdown-submenu:hover > .dropdown-menu {\n        display: block;\n    }\n    .dropdown-submenu > a:after {\n        display: block;\n        content: " ";\n        float: right;\n        width: 0;\n        height: 0;\n        border-color: transparent;\n        border-style: solid;\n        border-width: 5px 0 5px 5px;\n        border-left-color: #ccc;\n        margin-top: 5px;\n        margin-right: -10px;\n    }\n    .dropdown-submenu:hover > a:after {\n        border-left-color: #fff;\n    }\n    .dropdown-submenu.pull-left {\n        float: none;\n    }\n    .dropdown-submenu.pull-left > .dropdown-menu {\n        left: -100%;\n        margin-left: 10px;\n        -webkit-border-radius: 6px 0 6px 6px;\n        -moz-border-radius: 6px 0 6px 6px;\n        border-radius: 6px 0 6px 6px;\n    }</style><nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png" alt="logo"> <span data-translate="global.title">Gateway</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><!-- \u30ED\u30B0\u30A4\u30F3\u3057\u306A\u3044\u3000\u30C8\u30C3\u30D7\u753B\u9762 --><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- \u30ED\u30B0\u30A4\u30F3\u3057\u305F\u3000\u30C8\u30C3\u30D7\u753B\u9762 --><li ng-class="{active: vm.$state.includes(\'home\')}" ng-switch-when="true"><a href="#/" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-large"></span>&nbsp; <span class="hidden-sm" data-translate="global.menu.top">Top</span></a></li><!-- \u8A2D\u5B9A\u7BA1\u7406 --><li ng-class="{active: vm.$state.includes(\'token-shop\') || vm.$state.includes(\'user-management\') || vm.$state.includes(\'group-management\')\n                || vm.$state.includes(\'productType\') || vm.$state.includes(\'product\') || vm.$state.includes(\'price\') || vm.$state.includes(\'license\')\n                || vm.$state.includes(\'license-user\') || vm.$state.includes(\'license-staff\') || vm.$state.includes(\'role-management\') || vm.$state.includes(\'function-management\')\n                || vm.$state.includes(\'keiyakuplan-management\')\n                || vm.$state.includes(\'token-edit\') || vm.$state.includes(\'license-shop\') || vm.$state.includes(\'storage-management\')}" uib-dropdown class="dropdown pointer" ng-switch-when="true"><a class="dropdown-toggle" uib-dropdown-toggle id="set"><span><span class="glyphicon glyphicon-wrench"></span> <span class="hidden-sm" data-translate="global.menu.set.main">Set</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu style="width: 235px; right: auto; left: -58px"><!--\u30A2\u30AB\u30A6\u30F3\u30C8\u7BA1\u7406--><li ui-sref-active="active" ng-if="vm.showAccount"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.system.userManagement">User management</span></a></li><!--\u30B0\u30EB\u30FC\u30D7\u7BA1\u7406--><li ui-sref-active="active" ng-if="vm.showGroup"><a ui-sref="group-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.system.groupManagement">Group management</span></a></li><!-- PEPPER-590\u5BFE\u5FDC\u3001\u3072\u3068\u307E\u305A\u3001\u96A0\u3059\u3002 --><!--<li ui-sref-active="active" has-any-authority="ROLE_PARTNER">--><!--<a ui-sref="token-edit" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-gift"></span>&nbsp;--><!--<span data-translate="global.menu.system.tokenManagement">Token management</span>--><!--</a>--><!--</li>--><!--\u30ED\u30FC\u30EB\u7BA1\u7406--><li has-any-authority="ROLE_ADMIN, ROLE_DEVELOPER" ui-sref-active="active"><a ui-sref="role-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.system.roleManagement">Role management</span></a></li><!--\u6A5F\u80FD\u6A29\u9650\u7BA1\u7406--><li has-any-authority="ROLE_ADMIN, ROLE_DEVELOPER" ui-sref-active="active"><a ui-sref="function-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.system.functionManagement">Function management</span></a></li><!--\u6599\u91D1\u30D5\u309A\u30E9\u30F3\u8A2D\u5B9A--><li has-any-authority="ROLE_ADMIN, ROLE_DEVELOPER" ui-sref-active="active"><a ui-sref="keiyakuplan-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.system.keiyakuplanManagement">Keiyakuplan management</span></a></li><!--\u30E9\u30A4\u30BB\u30F3\u30B9\u7BA1\u7406--><li ui-sref-active="active" ng-if="vm.showLicense"><a ui-sref="license" ng-click="vm.collapseNavbar();"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span translate="global.menu.set.license">License</span></a></li><!-- \u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u7BA1\u7406\u3000--><li ui-sref-active="active" ng-if="vm.showStorage"><a ui-sref="storage-management" ng-click="vm.collapseNavbar();"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span translate="global.menu.set.storage-management">\u30B9\u30C8\u30EC\u30FC\u30B8\u7BA1\u7406</span></a></li><!--\u88FD\u54C1\u30BF\u30A4\u30D7\u7BA1\u7406--><li ui-sref-active="active" ng-if="vm.showProduct"><a ui-sref="productType" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-list"></span>&nbsp; <span translate="global.menu.set.productType">Product type</span></a></li><!--\u88FD\u54C1\u7BA1\u7406--><li ui-sref-active="active" ng-if="vm.showProduct"><a ui-sref="product" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-barcode"></span>&nbsp; <span translate="global.menu.set.product">Product</span></a></li></ul></li><!-- \u52E4\u6020\u7BA1\u7406 --><li ng-if="vm.showTimecard" ng-class="{active: vm.$state.includes(\'timecard\') || vm.$state.includes(\'timecard-management\') || vm.$state.includes(\'shokushu-management\')\n                    || vm.$state.includes(\'group-option\') || vm.$state.includes(\'option-user\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="timecard-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.timecard.main">Timecard </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu style="width: 217px;right: auto; left: -50px"><!--\u6253\u523B--><li ui-sref-active="active" ng-show="!vm.houmonTimeCard"><a ui-sref="timecard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.timecard.timer">timecard</span></a></li><!--\u8A2A\u554F\u6253\u523B--><li ui-sref-active="active" ng-show="vm.houmonTimeCard"><a ui-sref="houmonTimecard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.timecard.houmonTimer">houmonTimecard</span></a></li><!--\u52E4\u6020\u7BA1\u7406--><li ui-sref-active="active" has-group-auth="admin"><a ui-sref="timecard-management({currentYear:vm.currentYear,currentMonth:vm.currentMonth})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-qrcode"></span>&nbsp; <span data-translate="global.menu.timecard.management">Management</span></a></li><!--\u8077\u7A2E\u7BA1\u7406--><li ui-sref-active="active" has-group-auth="admin"><a ui-sref="shokushu-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-headphones"></span>&nbsp; <span data-translate="global.menu.timecard.shokushu">shokushu</span></a></li><!--\u30B0\u30EB\u30FC\u30D7\u30AA\u30D7\u30B7\u30E7\u30F3\u8A2D\u5B9A--><li ui-sref-active="active" has-group-auth="admin"><a ui-sref="group-option" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-fire"></span>&nbsp; <span data-translate="global.menu.timecard.option">Option</span></a></li><!--\u30E6\u30FC\u30B6\u30FC\u30AA\u30D7\u30B7\u30E7\u30F3\u8A2D\u5B9A--><li ui-sref-active="active" has-group-auth="admin"><a ui-sref="option-user" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-gift"></span>&nbsp; <span data-translate="global.menu.timecard.optionUser">OptionUser</span></a></li></ul></li><!-- \u30B7\u30D5\u30C8\u7BA1\u7406 --><li ng-if="vm.showShift" ng-class="{active: vm.$state.includes(\'shift-duty\') || vm.$state.includes(\'shift-time\') || vm.$state.includes(\'shift-occupation\')\n                    || vm.$state.includes(\'staff-occupation\') || vm.$state.includes(\'shift-month\') || vm.$state.includes(\'monthshift-time\') }" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="shift-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.system.shift"></span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu style="width: 217px;right: auto; left: -50px"><!--\u30B7\u30D5\u30C8\u52E4\u52D9\u5F62\u614B\u7BA1\u7406--><li ui-sref-active="active" has-group-auth="admin"><a ui-sref="shift-duty" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-stats"></span>&nbsp; <span data-translate="global.menu.timecard.shiftdutyform">ShiftDutyForm</span></a></li><!--\u30B7\u30D5\u30C8\u8077\u7A2E\u7BA1\u7406\u7BA1\u7406--><li ui-sref-active="active" has-group-auth="admin"><a ui-sref="shift-occupation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tags"></span>&nbsp; <span data-translate="global.menu.timecard.shiftoccupation">ShiftOccupation</span></a></li><!--\u30B7\u30D5\u30C8\u52E4\u52D9\u6642\u9593\u5E2F\u7BA1\u7406--><li ui-sref-active="active" has-group-auth="admin"><a ui-sref="shift-time" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-star"></span>&nbsp; <span data-translate="global.menu.timecard.shifttimezone">ShiftTimeZone</span></a></li><li role="separator" class="divider"></li><!--\u6708\u6B21\u52E4\u52D9\u6642\u9593\u5E2F\u7BA1\u7406--><li ui-sref-active="active" has-group-auth="admin"><a ui-sref="monthshift-time" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-star"></span>&nbsp; <span data-translate="global.menu.timecard.monthshifttimezone">ShiftTimeZone</span></a></li><!--\u30B7\u30D5\u30C8\u8077\u54E1\u7BA1\u7406--><li ui-sref-active="active" has-group-auth="admin"><a ui-sref="staff-occupation({currentYear:vm.currentYear,currentMonth:vm.currentMonth})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-th-list"></span>&nbsp; <span data-translate="global.menu.timecard.staffoccupation">StaffOccupation</span></a></li><!--\u6708\u6B21\u30B7\u30D5\u30C8\u8868\u7BA1\u7406--><li ui-sref-active="active"><a ui-sref="shift-month({currentYear:vm.currentYear,currentMonth:vm.currentMonth})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-pencil"></span>&nbsp; <span data-translate="global.menu.timecard.shiftmonth">ShiftMonth</span></a></li></ul></li><!-- \u30B7\u30B9\u30C6\u30E0\u7BA1\u7406 --><li ng-if="vm.showSystem" ng-class="{active: vm.$state.includes(\'docs\') || vm.$state.includes(\'logs\') || vm.$state.includes(\'gateway\')\n                    || vm.$state.includes(\'jhi-metrics\') || vm.$state.includes(\'jhi-health\') || vm.$state.includes(\'audits\') || vm.$state.includes(\'jhi-configuration\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" ui-sref-active="active"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="system-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.system.main">system</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu style="width: 176px;right: auto; left: -12px"><!-- <li class="divider" has-any-authority="ROLE_ADMIN"></li>--><!--API--><li ng-if="vm.showSwagger" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!--\u30ED\u30B0--><li has-authority="ROLE_ADMIN" ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><!--Gateway--><li has-authority="ROLE_ADMIN" ui-sref-active="active"><a ui-sref="gateway" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-road"></span>&nbsp; <span data-translate="global.menu.admin.gateway">Gateway</span></a></li><!--\u30E1\u30C8\u30EA\u30AF\u30B9--><li has-authority="ROLE_ADMIN" ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><!--\u30D8\u30EB\u30B9\u30B9\u30C6\u30FC\u30BF\u30B9--><li has-authority="ROLE_ADMIN" ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><!--\u8A2D\u5B9A--><li has-authority="ROLE_ADMIN" ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><!--\u76E3\u67FB--><li has-authority="ROLE_ADMIN" ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li></ul></li><!-- \u30A2\u30AB\u30A6\u30F3\u30C8\u7BA1\u7406\u6A5F\u80FD\u3000--><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu style="width: 176px;right: auto; left: -12px"><!--\u8A2D\u5B9A--><li ui-sref-active="active" ng-switch-when="true" ng-if="!vm.isOneUser"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><!--\u30D1\u30B9\u30EF\u30FC\u30C9--><li ui-sref-active="active" ng-switch-when="true" ng-if="!vm.isOneUser"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><!--\u30ED\u30B0\u30A2\u30A6\u30C8--><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><!-- \u30E1\u30C3\u30BB\u30FC\u30B8 --><li ui-sref-active="active"><a class="message_open" ng-click="vm.messageAllwaysShow()"><span class="glyphicon glyphicon-envelope"></span></a></li></ul></div></div></nav><div class="message"><div class="message_top"><div class="message_title" data-translate="message">Message</div><div class="message_close" onclick="$(\'.message\').animate({right: \'-260px\'})">&times;</div></div><div class="message_info"><div class="message_content" ng-repeat="msg in vm.messages track by $index"><div class="message_text" ng-class="msg.type">{{msg.text}}</div><div class="message_time">{{msg.time}}</div></div></div></div>');
$templateCache.put('app/master/application/caretreeApplication.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-6 h2" data-translate="caretreeApplication.title">Caretree Application</label></div><div class="form-group" style="margin-bottom: 0px"><div class="col-md-2"></div><label style="text-align: left" class="col-md-10 control-label" data-translate="caretreeApplication.indexOne">Index</label></div><div class="form-group"><div class="col-md-2"></div><label style="text-align: left" class="col-md-10 control-label" data-translate="caretreeApplication.indexTwo">Index</label></div><div class="form-group"><label class="col-md-3 control-label" data-translate="caretreeApplication.item.name">Name</label><div class="col-md-3"><input type="text" class="form-control" name="name" ng-model="vm.inquiry.name"><div class="has-error small" ng-show="vm.nameRequiredFlag"><p class="help-block" data-translate="caretreeApplication.item.nameRequired">This field is required.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="caretreeApplication.item.houjinName">Houjin Name</label><div class="col-md-5"><input type="text" class="form-control" name="houjinName" ng-model="vm.inquiry.houjinName"></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="caretreeApplication.item.jigyoushoName">Jigyousho Name</label><div class="col-md-5"><input type="text" class="form-control" name="jigyoushoName" ng-model="vm.inquiry.jigyoushoName"></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="caretreeApplication.item.telephoneNumber">Telephone Number</label><div class="col-md-3"><input type="text" class="form-control" name="telephoneNumber" ng-model="vm.inquiry.telephoneNumber"><div class="has-error small" ng-show="vm.phoneRequiredFlag"><p class="help-block" data-translate="caretreeApplication.item.phoneRequired">This field is required.</p></div></div><span class="col-md-2 control-label" style="text-align: left">(\u4F8B\uFF1A000-000-0000)</span></div><div class="form-group"><label class="col-md-3 control-label" data-translate="caretreeApplication.item.emailAddress">Email Address</label><div class="col-md-5"><input type="text" class="form-control" name="emailAddress" ng-model="vm.inquiry.emailAddress"></div><span class="col-md-2 control-label" style="text-align: left">(\u4F8B\uFF1Asample@goodtree.jp)</span></div><div class="form-group"><label class="col-md-3 control-label" data-translate="caretreeApplication.item.inquiryContents">Inquiry Contents</label><div class="col-md-7"><textarea style="height: 100px" class="form-control" name="inquiryContents" ng-model="vm.inquiry.inquiryContents"></textarea></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="caretreeApplication.item.hope">Hope</label><div class="col-md-9"><div class="col-md-12 form-group" style="margin-bottom: 0px"><label class="control-label" data-translate="caretreeApplication.item.caretreeFree">Caretree Free</label></div><div class="col-md-12 checkbox"><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox1" type="checkbox" id="checkbox1" name="checkbox1"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox1"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox2" type="checkbox" id="checkbox2" name="checkbox2"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox2"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox3" type="checkbox" id="checkbox3" name="checkbox3"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox3"></span></label></div><div class="col-md-12 checkbox"><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox4" type="checkbox" id="checkbox4" name="checkbox4"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox4"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox5" type="checkbox" id="checkbox5" name="checkbox5"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox5"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox6" type="checkbox" id="checkbox6" name="checkbox6"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox6"></span></label></div><div class="col-md-12 checkbox"><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox7" type="checkbox" id="checkbox7" name="checkbox7"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox7"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox8" type="checkbox" id="checkbox8" name="checkbox8"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox8"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox9" type="checkbox" id="checkbox9" name="checkbox9"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox9"></span></label></div><div class="col-md-12 checkbox"><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox10" type="checkbox" id="checkbox10" name="checkbox10"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox10"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox11" type="checkbox" id="checkbox11" name="checkbox11"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox11"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox12" type="checkbox" id="checkbox12" name="checkbox12"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox12"></span></label></div><div class="col-md-12 checkbox"><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox13" type="checkbox" id="checkbox13" name="checkbox13"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox13"></span></label><label class="col-md-8 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox14" type="checkbox" id="checkbox14" name="checkbox14"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox14"></span></label></div><div class="col-md-12 checkbox"><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox15" type="checkbox" id="checkbox15" name="checkbox15"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox15"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox16" type="checkbox" id="checkbox16" name="checkbox16"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox16"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox17" type="checkbox" id="checkbox17" name="checkbox17"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox17"></span></label></div><div class="col-md-12 checkbox"><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox18" type="checkbox" id="checkbox18" name="checkbox18"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox18"></span></label><label class="col-md-8 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox19" type="checkbox" id="checkbox19" name="checkbox19"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox19"></span></label></div><div class="col-md-12 checkbox"><label class="col-md-12 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox20" type="checkbox" id="checkbox20" name="checkbox20"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox20"></span></label></div><div class="col-md-12 checkbox"><label class="col-md-8 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox21" type="checkbox" id="checkbox21" name="checkbox21"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox21"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox22" type="checkbox" id="checkbox22" name="checkbox22"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox22"></span></label></div><div class="col-md-12 checkbox"><label class="col-md-2 control-label" style="text-align: left;width: 82px"><input ng-model="vm.inquiry.checkbox23" type="checkbox" id="checkbox23" name="checkbox23"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox23"></span></label><div class="col-md-9"><input type="text" class="form-control" name="sonata" ng-model="vm.inquiry.sonata"></div></div><div class="col-md-12 form-group" style="margin-bottom: 0px"><label class="control-label" data-translate="caretreeApplication.item.caretree2">caretree2</label></div><div class="col-md-12 checkbox"><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox24" type="checkbox" id="checkbox24" name="checkbox24"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox24"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox25" type="checkbox" id="checkbox25" name="checkbox25"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox25"></span></label><label class="col-md-4 control-label" style="text-align: left"><input ng-model="vm.inquiry.checkbox26" type="checkbox" id="checkbox26" name="checkbox26"> &nbsp<span style="word-break: break-all" data-translate="caretreeApplication.item.checkbox26"></span></label></div></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary search-button" ng-click="vm.save()"><span data-translate="caretreeApplication.item.save">save</span></button></div></div></form></div>');
$templateCache.put('app/master/corporation/corporation.html','<div><h2>\u6CD5\u4EBA\u4E00\u89A7</h2><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-1 control-label">\u4E8B\u696D\u6240\u540D</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u4E8B\u696D\u6240\u756A\u53F7</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u4E8B\u696D\u6240ID</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u6CD5\u4EBAID</label><div class="col-md-2"><input type="text" class="form-control"></div></div><div class="form-group"><div class="col-md-12 text-center"><button class="btn btn-primary"><span class="glyphicon glyphicon-search"></span> <span>\u691C\u7D22</span></button> <button class="btn btn-default"><span class="glyphicon glyphicon-refresh"></span> <span>\u30AF\u30EA\u30A2</span></button></div></div></form><hr><table class="table table-striped"><thead><tr><th>\u4E8B\u696D\u6240ID</th><th>\u6CD5\u4EBAID</th><th>\u4E8B\u696D\u6240\u756A\u53F7</th><th>\u4E8B\u696D\u6240\u540D</th><th></th></tr></thead><tbody><tr ng-repeat="corporation in vm.corporationList"><td>{{corporation.jigyoushoId}}</td><td>{{corporation.houjinId}}</td><td>{{corporation.jigyoushoCd}}</td><td>{{corporation.jigyoushoNm}}</td><td><button ui-sref="staff.edit" class="btn btn-primary btn-sm">\u30B9\u30BF\u30C3\u30D5\u60C5\u5831\u767B\u9332</button> <button class="btn btn-primary btn-sm">\u4E00\u62EC\u767B\u9332</button></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-click="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/master/license/license.html','<div><form id="searchHeight" class="form-horizontal" role="form"><div class="form-group" style="margin-bottom: 10px"><label class="col-md-6 h2" data-translate="license.title.index" style="margin-top: 0px; margin-bottom: 0px">License</label><div class="col-md-6 text-right button-add" style="margin-top: 0px; margin-bottom: 0px"><button type="button" class="btn btn-primary" ng-click="vm.goEdit(null, vm.version)" ng-bind="vm.addButtonText"></button></div><!--<div ng-if="vm.searchData.version == 2" class="col-md-6 text-right button-add"><button class="btn btn-primary" ui-sref="license.edit({id: null, version: vm.searchData.version})" data-translate="license.button.add2">Add2.0</button></div>--></div><div class="form-group"><label class="col-md-1 control-label searchOne" data-translate="license.version">Version</label><div class="col-md-2"><label class="radio-inline"><input type="radio" ng-model="vm.version" value="2" ng-change="vm.changeSearchVersion()"> <span data-translate="license.two">2.0</span></label><label class="radio-inline"><input type="radio" ng-model="vm.version" value="1" ng-change="vm.changeSearchVersion()"> <span data-translate="license.one">1.0</span></label></div><label class="col-md-2 control-label searchTwo" ng-bind="vm.idText">ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.id"></div><label class="col-md-2 control-label searchTwo" ng-bind="vm.nmText">Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div></div><div class="form-group"><label class="col-md-1 control-label searchOne" data-translate="license.item.productNm">Product Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.productNm"></div><label class="col-md-2 control-label searchTwo" data-translate="license.item.shopNm">Shop Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.shopNm"></div></div><div class="form-group"><div class="col-md-3 text-center"></div><div class="col-md-6 text-center"><button type="submit" class="btn btn-primary search-button" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default clear-button" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div><div class="col-md-3 text-right" style="line-height: 30px;height: 30px"><div style="padding-top: 2px;padding-left: 5px;float: right" data-translate="license.red" style="padding-top: 2px" data-translate="license.red"></div><div style="color: #d43f3a;padding-left: 5px;line-height: 25px;float: right">\u2583</div><div style="padding-top: 2px;padding-left: 5px;float: right" data-translate="license.yellow" style="padding-top: 2px"></div><div style="color: #f0ad4e;padding-left: 2px;line-height: 25px;float: right">\u2583</div></div></div></form><hr style="margin-bottom: 0px;margin-top: 0px"><table id="headerHeight" class="table table-striped table-hover" style="table-layout: fixed; margin-bottom: 0px"><colgroup><col width="13%"><col width="13%"><col width="13%"><!--<col width="8%">--><col width="13%"><col width="8%"><col width="10%"><col width="10%"><col width="12%"><col></colgroup><thead><tr><th ng-bind="vm.idTextTitle">ID</th><th ng-bind="vm.nmTextTitle">Name</th><th data-translate="license.item.productNm">Product Name</th><!--<th data-translate="license.item.shopId">Shop ID</th>--><th data-translate="license.item.shopNm">Shop Name</th><th data-translate="license.item.shopEnd">Shop End</th><th data-translate="license.item.feePlan">Fee Plan</th><th data-translate="license.item.licenseCount" style="text-align: center">License Count</th><th data-translate="license.item.priceNew">Price</th><th></th></tr></thead></table><div style="overflow: auto" id="tableDiv"><table class="table table-striped table-hover" style="table-layout: fixed;margin-bottom: 0px"><colgroup><col width="13%"><col width="13%"><col width="13%"><!--<col width="8%">--><col width="13%"><col width="8%"><col width="10%"><col width="10%"><col width="12%"><col></colgroup><tbody><tr ng-if="license.colorFlag == 3" ng-repeat="license in vm.licenseList" style="background-color: #d43f3a"><td title="{{license.id}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.id}}</td><td title="{{license.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.name}}</td><td title="{{license.productNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.productNm}}</td><!-- <td>{{license.shopId}}</td>--><td title="{{license.shopNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.shopNm}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" ng-show="license.stopFlag"><label class="glyphicon glyphicon-ok"></label></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" ng-show="!license.stopFlag"></td><td title="{{license.planNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.planNm}}</td><td title="{{license.licenseCount}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;text-align: center;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.licenseCount}}</td><td title="{{license.price | currency:\'\xA5\':0}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.price | currency:"\xA5":0}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.goEdit(license.dbId, vm.version)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button> <button ng-click="vm.goDel(license.dbId, vm.version,license.id, license.productId, license.shopId)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.delete">Delete</span></button></div></td></tr><tr ng-if="license.colorFlag == 2" ng-repeat="license in vm.licenseList" style="background-color: #f0ad4e"><td title="{{license.id}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.id}}</td><td title="{{license.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.name}}</td><td title="{{license.productNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.productNm}}</td><!-- <td>{{license.shopId}}</td>--><td title="{{license.shopNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.shopNm}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" ng-show="license.stopFlag"><label class="glyphicon glyphicon-ok"></label></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" ng-show="!license.stopFlag"></td><td title="{{license.planNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.planNm}}</td><td title="{{license.licenseCount}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;text-align: center;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.licenseCount}}</td><td title="{{license.price | currency:\'\xA5\':0}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.price | currency:"\xA5":0}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.goEdit(license.dbId, vm.version)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button> <button ng-click="vm.goDel(license.dbId, vm.version,license.id, license.productId, license.shopId)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.delete">Delete</span></button></div></td></tr><tr ng-if="license.colorFlag == 1" ng-repeat="license in vm.licenseList"><td title="{{license.id}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.id}}</td><td title="{{license.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.name}}</td><td title="{{license.productNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.productNm}}</td><!-- <td>{{license.shopId}}</td>--><td title="{{license.shopNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.shopNm}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" ng-show="license.stopFlag"><label class="glyphicon glyphicon-ok"></label></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" ng-show="!license.stopFlag"></td><td title="{{license.planNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.planNm}}</td><td title="{{license.licenseCount}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;text-align: center;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.licenseCount}}</td><td title="{{license.price | currency:\'\xA5\':0}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{license.price | currency:"\xA5":0}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.goEdit(license.dbId, vm.version)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button> <button ng-click="vm.goDel(license.dbId, vm.version,license.id, license.productId, license.shopId)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.delete">Delete</span></button></div></td></tr></tbody></table></div><div id="pageHeight" class="text-center" ng-if="vm.licenseList.length > 0" style="margin-top: 20px"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()" style="margin-bottom: 10px;margin-top: 10px"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.totalItems == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div>');
$templateCache.put('app/master/price/price.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-6 h2" data-translate="price.title.index">Price</label><div class="col-md-6 text-right button-add"><button type="button" class="btn btn-primary" ui-sref="price.edit" data-translate="price.button.add">Add</button></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="price.item.product-id">Product ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.productId"></div><label class="col-md-1 control-label" data-translate="price.item.product-name">Product Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.productNm"></div><label class="col-md-1 control-label" data-translate="price.item.stop-flag">Sell stop</label><div class="col-md-2"><select class="form-control" ng-model="vm.searchData.stopFlag" ng-options="whether.id as whether.value for whether in vm.whetherList"><option></option></select></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="price.item.start-date">Sell Start Date</label><div class="col-md-2"><p class="input-group"><input type="text" id="dateFrom" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" ng-model="vm.searchData.dateFrom" is-open="vm.isOpenDateFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(1)"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p></div><label class="col-md-1 control-label">\u301C</label><div class="col-md-2"><p class="input-group"><input type="text" id="dateTo" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" ng-model="vm.searchData.dateTo" is-open="vm.isOpenDateTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(2)"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><table class="table table-striped table-hover"><colgroup><col width="10%"><col width="30%"><col width="20%"><col width="20%"><col width="10%"><col></colgroup><thead><tr><th data-translate="price.item.product-id">Product ID</th><th data-translate="price.item.product-name">Product Name</th><th data-translate="price.item.start-date">Sell Start Date</th><th data-translate="price.item.price">Price</th><th data-translate="price.item.stop-flag">Sell Stop</th><th></th></tr></thead><tbody><tr ng-repeat="price in vm.priceList"><td>{{price.productId}}</td><td>{{price.productNm}}</td><td>{{price.startDate | date: \'yyyy/MM/dd\'}}</td><td>{{price.price | currency:"\xA5":0}}</td><td><label ng-if="price.stopFlag" class="glyphicon glyphicon-ok"></label><label ng-if="!price.stopFlag" class="glyphicon glyphicon-remove"></label></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ui-sref="price.edit({id: price.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button> <button type="button" ui-sref="price.delete({id: price.id, productId: price.productId})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.delete">Delete</span></button></div></td></tr></tbody></table><div class="text-center" ng-if="vm.priceList.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div>');
$templateCache.put('app/master/product/product.html','<div><form id="searchHeight" class="form-horizontal" role="form"><div class="form-group" style="margin-bottom: 10px"><label class="col-md-6 h2" data-translate="product.title.index" style="margin-top: 0px; margin-bottom: 0px">Product</label><div class="col-md-6 text-right button-add" style="margin-top: 0px; margin-bottom: 0px"><button type="button" class="btn btn-primary" ng-click="vm.goEdit();" data-translate="product.button.add">Add</button></div></div><div class="form-group"><label class="col-md-1 control-label searchOne" data-translate="product.item.id">ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.id"></div><label class="col-md-2 control-label searchTwo" data-translate="product.item.name">Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div><label class="col-md-2 control-label searchTwo" data-translate="product.item.kind">Kind</label><div class="col-md-2"><select class="form-control" ng-model="vm.searchData.kind" ng-options="kind.id as kind.name for kind in vm.productTypeList"><option></option></select></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary search-button" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default clear-button" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr style="margin-bottom: 0px;margin-top: 0px"><table id="headerHeight" style="table-layout: fixed; margin-bottom: 0px" class="table table-striped table-hover"><colgroup><col width="10%"><col width="40%"><col width="20%"><col width="10%"><col width="10%"><col></colgroup><thead><tr><th data-translate="product.item.id">ID</th><th data-translate="product.item.name">Name</th><th data-translate="product.item.kind">Kind</th><th data-translate="product.item.stopFlag">Stop Flag</th><th data-translate="product.item.price">Price</th><th></th></tr></thead></table><div style="overflow: auto" id="tableDiv"><table class="table table-striped table-hover" style="table-layout: fixed;margin-bottom: 0px"><colgroup><col width="10%"><col width="40%"><col width="20%"><col width="10%"><col width="10%"><col></colgroup><tbody><tr ng-repeat="product in vm.productList"><td title="{{product.id}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{product.id}}</td><td title="{{product.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{product.name}}</td><td title="{{product.kind}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{product.kind}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" ng-show="product.stopFlag"><label class="glyphicon glyphicon-ok"></label></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" ng-show="!product.stopFlag"></td><td title="{{product.price | currency:\'\xA5\':0}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{product.price | currency:"\xA5":0}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.goEdit(product.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button> <button ng-click="vm.goDel(product.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.delete">Delete</span></button></div></td></tr></tbody></table></div><div id="pageHeight" class="text-center" ng-if="vm.productList.length > 0" style="margin-top: 20px"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()" style="margin-bottom: 10px;margin-top: 10px"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.totalItems == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div>');
$templateCache.put('app/master/productType/productType.html','<div><form id="searchHeight" class="form-horizontal" role="form"><div class="form-group" style="margin-bottom: 10px"><label class="col-md-6 h2" data-translate="productType.title.index" style="margin-top: 0px; margin-bottom: 0px">Product Type</label><div class="col-md-6 text-right button-add" style="margin-top: 0px; margin-bottom: 0px"><button type="button" class="btn btn-primary" ng-click="vm.goNew()" data-translate="productType.button.add">Add</button></div></div><div class="form-group"><label style="padding-right: 0px" class="col-md-1 control-label searchOne" data-translate="productType.item.id">Type ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.id"></div><label class="col-md-2 control-label searchTwo" data-translate="productType.item.name">Type Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary search-button" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default clear-button" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr style="margin-bottom: 0px;margin-top: 0px"><table id="headerHeight" class="table table-striped table-hover" style="table-layout: fixed; margin-bottom: 0px"><colgroup><col width="10%"><col width="20%"><col width="15%"><col width="43%"><col width="2%"><col></colgroup><thead><tr><th data-translate="productType.item.id">ID</th><th data-translate="productType.item.name">Name</th><th data-translate="productType.item.type">Type</th><th data-translate="productType.item.functionName">FunctionName</th><th></th><th></th></tr></thead></table><div style="overflow: auto" id="tableDiv"><table class="table table-striped table-hover" style="table-layout: fixed;margin-bottom: 0px"><colgroup><col width="10%"><col width="20%"><col width="15%"><col width="43%"><col width="2%"><col></colgroup><tbody><tr ng-repeat="productType in vm.productTypeList"><td title="{{productType.id}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{productType.id}}</td><td title="{{productType.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{productType.name}}</td><td title="{{productType.licenseType}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{productType.licenseType}}</td><td title="{{productType.kinouListString}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{productType.kinouListString}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.goEdit(productType.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button> <button ng-click="vm.goDel(productType.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.delete">Delete</span></button></div></td></tr></tbody></table></div><div id="pageHeight" class="text-center" ng-if="vm.productTypeList.length > 0" style="margin-top: 20px"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()" style="margin-bottom: 10px;margin-top: 10px"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.totalItems == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div>');
$templateCache.put('app/master/shop/shop.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-6 h2">\u8CA9\u58F2\u5E97\u4E00\u89A7</label><div class="col-md-6 text-right"><button class="btn btn-primary" ui-sref="shop.edit">\u8CA9\u58F2\u5E97\u8FFD\u52A0</button></div></div><div class="form-group"><label class="col-md-1 control-label">\u8CA9\u58F2\u5E97ID</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u8CA9\u58F2\u5E97\u540D</label><div class="col-md-2"><input type="text" class="form-control"></div><label class="col-md-1 control-label">\u62C5\u5F53\u8005\u540D</label><div class="col-md-2"><input type="text" class="form-control"></div></div><div class="form-group"><div class="col-md-12 text-center"><button class="btn btn-primary"><span class="glyphicon glyphicon-search"></span> <span>\u691C\u7D22</span></button> <button class="btn btn-default"><span class="glyphicon glyphicon-refresh"></span> <span>\u30AF\u30EA\u30A2</span></button></div></div></form><hr><table class="table table-striped"><thead><tr><th>\u8CA9\u58F2\u5E97ID</th><th>\u8CA9\u58F2\u5E97\u540D</th><th>TEL</th><th>FAX</th><th>\u62C5\u5F53\u8005\u90E8\u7F72</th><th>\u62C5\u5F53\u8005\u540D</th><th></th></tr></thead><tbody><tr ng-repeat="shop in vm.shopList"><td>{{shop.shopId}}</td><td>{{shop.shopNm}}</td><td>{{shop.tel}}</td><td>{{shop.fax}}</td><td>{{shop.managerDuty}}</td><td>{{shop.managerNm}}</td><td><button ui-sref="shop.edit" class="btn btn-primary btn-sm">\u7DE8\u96C6</button> <button class="btn btn-danger btn-sm" ng-click="vm.remove($index)">\u524A\u9664</button></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-click="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/partner/license/license-shop.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-6 h2" data-translate="license.title.index-shop">License</label></div><div class="form-group"><label class="col-md-1 control-label" data-translate="license.item.productNm">Product Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.productName"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="button" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><!--<h4 data-translate="license.item.total">Total</h4>--><!--<div class="row">--><!--<div class="col-md-2" ng-repeat="licenseUsed in vm.licenseCountList"><b></b> </div>--><!--</div>--><!--<hr>--><div ng-show="vm.noGroup" data-translate="license.text.noGroup"></div><div ng-show="!vm.noGroup"><table class="table table-striped table-hover"><colgroup><col width="40%"><col width="30%"><col width="10%"><col width="10%"><col></colgroup><thead><tr><th data-translate="license.item.user">User</th><th data-translate="license.item.productNm">Product Name</th><th data-translate="license.item.licenseSum">licenseSum</th><th data-translate="license.item.licenseCount">licenseCount</th></tr></thead><tbody><tr ng-repeat="license in vm.licenseList"><td>{{license.name}}</td><td>{{license.productName}}</td><td class="text-right">{{license.usedCount}}</td><td class="text-right">{{license.totalCount}}</td></tr></tbody></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div></div>');
$templateCache.put('app/system/admin-base/admin-base.html','<div><div class="pull-right"><button class="btn btn-sm btn-success pull-right" type="button">\u30ED\u30DC\u30C3\u30C8\u540D\uFF1A <span class="badge">{{vm.pepper.pepperName}}</span></button></div><h2 data-translate="base.home.title">Base</h2><h4 data-translate="base.home.default">Default</h4><form name="editForm" role="form" novalidate><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><colgroup><col width="22%"><col width="22%"><col width="22%"><col width="22%"><col></colgroup><thead><tr><th data-translate="base.title.name">Name</th><th data-translate="base.title.variable">Variable</th><th data-translate="base.title.value">Value</th><th data-translate="base.title.sample">Sample</th><th data-translate="base.title.controller">Controller</th></tr></thead><tbody><tr ng-repeat="ps in vm.datas.pepperSettingList" ng-form="repeatForm"><td><div class="form-group"><input type="text" class="form-control" name="itemName" ng-model="ps.itemName" ng-required="ps.itemName == null || ps.itemName == \'\'" ng-maxlength="100"><div ng-show="repeatForm.itemName.$invalid" class="has-error small"><p class="help-block" ng-show="repeatForm.itemName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="repeatForm.itemName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="variableName" ng-model="ps.variableName" ng-required="ps.variableName == null || ps.variableName == \'\'" ng-maxlength="45" ng-pattern="/^[./<>_A-Za-z0-9]*$/"><div ng-show="repeatForm.variableName.$invalid" class="has-error small"><p class="help-block" ng-show="repeatForm.variableName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="repeatForm.variableName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p><p class="help-block" ng-show="repeatForm.variableName.$error.pattern" data-translate="entity.validation.pattern.num-letter-symbol">This field\'s type is not correct.</p></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="variableValue" ng-model="ps.variableValue" ng-maxlength="100"><div ng-show="repeatForm.variableValue.$invalid" class="has-error small"><p class="help-block" ng-show="repeatForm.variableValue.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="sampleText" ng-model="ps.sampleText" ng-maxlength="100"><div ng-show="repeatForm.sampleText.$invalid" class="has-error small"><p class="help-block" ng-show="repeatForm.sampleText.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.del($index);"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-success" ng-click="vm.add()"><span data-translate="base.btn.defaultAdd">Add</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.save()" ng-disabled="editForm.$invalid || isSaving"><span data-translate="base.btn.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.cancel()"><span data-translate="base.btn.cancel">Cancel</span></button></div></div></form></div>');
$templateCache.put('app/system/admin-daily/admin-daily.html','<div><div class="pull-right"><button class="btn btn-sm btn-success pull-right" type="button">\u30ED\u30DC\u30C3\u30C8\u540D\uFF1A <span class="badge">{{vm.pepper.pepperName}}</span></button></div><h2 data-translate="daily.home.title">Daily</h2><h4 data-translate="daily.home.default">Default</h4><form name="editForm" role="form" novalidate show-validation><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><colgroup><col width="22%"><col width="22%"><col width="15%"><col width="29%"><col></colgroup><thead><tr><th data-translate="daily.title.name">Name</th><th data-translate="daily.title.variable">Variable</th><th data-translate="daily.title.repeat">Value</th><th data-translate="daily.title.sample">Sample</th><th data-translate="daily.title.controller">Controller</th></tr></thead><tbody><tr ng-repeat="ps in vm.datas.pepperSettingList" ng-click="vm.changeDays($index)" ng-form="repeatForm"><td><div class="form-group"><input type="text" class="form-control" name="itemName" ng-model="ps.itemName" ng-required="ps.itemName == null || ps.itemName == \'\'" ng-maxlength="100"><div ng-show="repeatForm.itemName.$invalid" class="has-error small"><p class="help-block" ng-show="repeatForm.itemName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="repeatForm.itemName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><textarea type="text" class="form-control" name="variableName" ng-model="ps.variableName" ng-required="ps.variableName == null || ps.variableName == \'\'" ng-maxlength="45" ng-pattern="/^[./<>_A-Za-z0-9\\n]*$/"></textarea><div ng-show="repeatForm.variableName.$invalid" class="has-error small"><p class="help-block" ng-show="repeatForm.variableName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="repeatForm.variableName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p><p class="help-block" ng-show="repeatForm.variableName.$error.pattern" data-translate="entity.validation.pattern.num-letter-symbol">This field\'s type is not correct.</p></div></div></td><td><div class="form-group"><select class="form-control" ng-options="rp.code as rp.value for rp in vm.repeats" ng-model="ps.repeatType" ng-change="vm.changeDays($index)"></select></div></td><td><div class="form-group"><input type="text" class="form-control" name="sampleText" ng-model="ps.sampleText" ng-maxlength="100"><div ng-show="repeatForm.sampleText.$invalid" class="has-error small"><p class="help-block" ng-show="repeatForm.sampleText.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.del($index)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div><div class="table-responsive" ng-repeat="ps in vm.datas.pepperSettingList" ng-if="vm.index == $index && ps.repeatType == 2"><h4>{{ps.itemName}}</h4><table class="table table-striped" ng-form="monthForm"><colgroup><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col></colgroup><tr><th>1</th><th>2</th><th>3</th><th>4</th><th>5</th><th>6</th><th>7</th></tr><tr><td><input type="text" class="form-control" name="day1" ng-model="ps.pepperSettingMonthly.day1" ng-maxlength="100"><div ng-show="monthForm.day1.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day1.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day2" ng-model="ps.pepperSettingMonthly.day2" ng-maxlength="100"><div ng-show="monthForm.day2.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day2.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day3" ng-model="ps.pepperSettingMonthly.day3" ng-maxlength="100"><div ng-show="monthForm.day3.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day3.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day4" ng-model="ps.pepperSettingMonthly.day4" ng-maxlength="100"><div ng-show="monthForm.day4.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day4.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day5" ng-model="ps.pepperSettingMonthly.day5" ng-maxlength="100"><div ng-show="monthForm.day5.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day5.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day6" ng-model="ps.pepperSettingMonthly.day6" ng-maxlength="100"><div ng-show="monthForm.day6.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day6.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day7" ng-model="ps.pepperSettingMonthly.day7" ng-maxlength="100"><div ng-show="monthForm.day7.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day7.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr><tr><th>8</th><th>9</th><th>10</th><th>11</th><th>12</th><th>13</th><th>14</th></tr><tr><td><input type="text" class="form-control" name="day8" ng-model="ps.pepperSettingMonthly.day8" ng-maxlength="100"><div ng-show="monthForm.day8.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day8.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day9" ng-model="ps.pepperSettingMonthly.day9" ng-maxlength="100"><div ng-show="monthForm.day9.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day9.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day10" ng-model="ps.pepperSettingMonthly.day10" ng-maxlength="100"><div ng-show="monthForm.day10.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day10.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day11" ng-model="ps.pepperSettingMonthly.day11" ng-maxlength="100"><div ng-show="monthForm.day11.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day11.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day12" ng-model="ps.pepperSettingMonthly.day12" ng-maxlength="100"><div ng-show="monthForm.day12.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day12.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day13" ng-model="ps.pepperSettingMonthly.day13" ng-maxlength="100"><div ng-show="monthForm.day13.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day13.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day14" ng-model="ps.pepperSettingMonthly.day14" ng-maxlength="100"><div ng-show="monthForm.day14.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day14.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr><tr><th>15</th><th>16</th><th>17</th><th>18</th><th>19</th><th>20</th><th>21</th></tr><tr><td><input type="text" class="form-control" name="day15" ng-model="ps.pepperSettingMonthly.day15" ng-maxlength="100"><div ng-show="monthForm.day15.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day15.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day16" ng-model="ps.pepperSettingMonthly.day16" ng-maxlength="100"><div ng-show="monthForm.day16.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day16.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day17" ng-model="ps.pepperSettingMonthly.day17" ng-maxlength="100"><div ng-show="monthForm.day17.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day17.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day18" ng-model="ps.pepperSettingMonthly.day18" ng-maxlength="100"><div ng-show="monthForm.day18.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day18.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day19" ng-model="ps.pepperSettingMonthly.day19" ng-maxlength="100"><div ng-show="monthForm.day19.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day19.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day20" ng-model="ps.pepperSettingMonthly.day20" ng-maxlength="100"><div ng-show="monthForm.day20.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day20.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day21" ng-model="ps.pepperSettingMonthly.day21" ng-maxlength="100"><div ng-show="monthForm.day21.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day21.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr><tr><th>22</th><th>23</th><th>24</th><th>25</th><th>26</th><th>27</th><th>28</th></tr><tr><td><input type="text" class="form-control" name="day22" ng-model="ps.pepperSettingMonthly.day22" ng-maxlength="100"><div ng-show="monthForm.day22.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day22.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day23" ng-model="ps.pepperSettingMonthly.day23" ng-maxlength="100"><div ng-show="monthForm.day23.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day23.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day24" ng-model="ps.pepperSettingMonthly.day24" ng-maxlength="100"><div ng-show="monthForm.day24.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day24.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day25" ng-model="ps.pepperSettingMonthly.day25" ng-maxlength="100"><div ng-show="monthForm.day25.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day25.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day26" ng-model="ps.pepperSettingMonthly.day26" ng-maxlength="100"><div ng-show="monthForm.day26.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day26.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day27" ng-model="ps.pepperSettingMonthly.day27" ng-maxlength="100"><div ng-show="monthForm.day27.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day27.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day28" ng-model="ps.pepperSettingMonthly.day28" ng-maxlength="100"><div ng-show="monthForm.day28.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day28.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr><tr><th>29</th><th>30</th><th>31</th><th></th><th></th><th></th><th></th></tr><tr><td><input type="text" class="form-control" name="day29" ng-model="ps.pepperSettingMonthly.day29" ng-maxlength="100"><div ng-show="monthForm.day29.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day29.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day30" ng-model="ps.pepperSettingMonthly.day30" ng-maxlength="100"><div ng-show="monthForm.day30.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day30.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day31" ng-model="ps.pepperSettingMonthly.day31" ng-maxlength="100"><div ng-show="monthForm.day31.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day31.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td></td><td></td><td></td><td></td></tr></table></div><div class="table-responsive" ng-repeat="ps in vm.datas.pepperSettingList" ng-if="vm.index == $index && ps.repeatType == 3"><h4>{{ps.itemName}}</h4><table class="table table-striped" ng-form="weekForm"><colgroup><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col></colgroup><tr><th data-translate="daily.title.sunday">7</th><th data-translate="daily.title.monday">1</th><th data-translate="daily.title.tuesday">2</th><th data-translate="daily.title.wednesday">3</th><th data-translate="daily.title.thursday">4</th><th data-translate="daily.title.friday">5</th><th data-translate="daily.title.saturday">6</th></tr><tr><td><input type="text" class="form-control" name="day1" ng-model="ps.pepperSettingWeekly.day1" ng-maxlength="100"><div ng-show="weekForm.day1.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day1.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day2" ng-model="ps.pepperSettingWeekly.day2" ng-maxlength="100"><div ng-show="weekForm.day2.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day2.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day3" ng-model="ps.pepperSettingWeekly.day3" ng-maxlength="100"><div ng-show="weekForm.day3.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day3.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day4" ng-model="ps.pepperSettingWeekly.day4" ng-maxlength="100"><div ng-show="weekForm.day4.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day4.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day5" ng-model="ps.pepperSettingWeekly.day5" ng-maxlength="100"><div ng-show="weekForm.day5.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day5.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day6" ng-model="ps.pepperSettingWeekly.day6" ng-maxlength="100"><div ng-show="weekForm.day6.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day6.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day7" ng-model="ps.pepperSettingWeekly.day7" ng-maxlength="100"><div ng-show="weekForm.day7.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day7.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr></table></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-success" ng-click="vm.add()"><span data-translate="daily.btn.defaultAdd">Add</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.save()" ng-disabled="editForm.$invalid || isSaving"><span data-translate="daily.btn.save">Save</span></button> <button type="button" class="btn btn-default" ng-click="vm.cancel()"><span data-translate="daily.btn.cancel">Cancel</span></button></div></div></form></div>');
$templateCache.put('app/system/category/category-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.category.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="entity.delete.question">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/category/category-edit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><input type="hidden" class="form-control" name="id" ng-model="vm.category.id" readonly="readonly"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="category.home.editDialogTitle">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="category.edit.name">Category Name</label><input type="text" class="form-control" name="categoryValue" ng-model="vm.category.categoryValue" ng-required="vm.category.categoryValue == null || vm.category.categoryValue == \'\'" ng-maxlength="30"><div ng-show="editForm.categoryValue.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.categoryValue.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.categoryValue.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label data-translate="category.edit.type">Category Type</label><input type="text" class="form-control" name="categoryType" ng-model="vm.category.categoryType" ng-required="vm.category.categoryType == null || vm.category.categoryType == \'\'" ng-maxlength="10" ng-pattern="/^\\d+$/"><div ng-show="editForm.categoryType.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.categoryType.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.categoryType.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 30 characters.</p><p class="help-block" ng-show="editForm.categoryType.$error.pattern" data-translate="entity.validation.pattern.num">The input type is wrong.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/system/category/category.html','<div><h2 data-translate="category.home.title">Category</h2><div class="row"><div class="col-md-4"><button type="button" class="btn btn-primary" ui-sref="new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="category.home.createLabel">Create a new Category</span></button></div></div><div class="table-responsive"><table class="table table-striped"><colgroup><col width="20%"><col width="40%"><col width="20%"><col></colgroup><thead><tr><th data-translate="category.categoryId">Category Id</th><th data-translate="category.categoryValue">Category Value</th><th data-translate="category.categoryType">Category Type</th><th></th></tr></thead><tbody><tr ng-repeat="category in vm.categories track by category.id"><td>{{category.id}}</td><td>{{category.categoryValue}}</td><td>{{category.categoryType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ui-sref="edit({id: category.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="button" ui-sref="delete({id: category.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()"></uib-pagination></div></div>');
$templateCache.put('app/system/function-management/function-management-create.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFunctionLabel" data-translate="functionManagement.home.editLabel" ng-if="vm.kinou.id != \'\'">Edit a Role</h4><h4 class="modal-title" id="myFunctionAdd" data-translate="functionManagement.home.createLabel" ng-if="vm.kinou.id == \'\'">Create a Role</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-2 control-label" data-translate="functionManagement.functionName">Function Name</label><div class="col-md-9"><input type="text" class="form-control" ng-model="vm.kinou.name" name="kinouName" ng-required="vm.kinou.name == \'\'" ng-minlength="1" ng-maxlength="100"><div ng-show="editForm.kinouName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.kinouName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.kinouName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="functionManagement.functionCode">Function Code</label><div class="col-md-9"><input type="text" class="form-control" ng-model="vm.kinou.code" name="functionCode" ng-required="vm.kinou.code == \'\'" ng-minlength="1" ng-maxlength="100"><div ng-show="editForm.functionCode.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.functionCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.functionCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-click="vm.save()" ng-disabled="editForm.$invalid || isSaving || vm.repeatFlg || (!vm.isAdmin && vm.hasAdmin)" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/system/function-management/function-management-delete.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="functionManagement.home.deleteLabel">Confirm delete operation</h4></div><div class="modal-body" style="overflow:hidden; word-wrap:break-word;word-break: break-all"><p data-translate="functionManagement.delete.question" data-translate-values="{kinouName: \'{{vm.kinou.name}}\'}">Are you sure you want to delete this Kinou?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger" ng-click="vm.delete(vm.kinou.id)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/function-management/function-management.html','<style>.contant{\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        width:99%;\n    }</style><div><form id="searchHeight" class="form-horizontal" role="form"><div class="form-group" style="margin-bottom: 10px"><label class="col-md-6 h2" data-translate="functionManagement.home.title" style="margin-top: 0px; margin-bottom: 0px">Kinou</label><div class="col-md-6 text-right button-add" style="margin-top: 0px; margin-bottom: 0px"><button type="button" class="btn btn-primary" ng-click="vm.goNew()" data-translate="functionManagement.home.createLabel">Add</button></div></div><div class="form-group"><label class="col-md-1 control-label" data-translate="functionManagement.functionName">Function Name</label><div class="col-md-4"><div class="input-group"><div class="input-group-addon"><span class="glyphicon glyphicon-search"></span></div><input type="text" class="form-control" ng-model="vm.searchData.kinouName" ng-change="vm.search()"></div></div><label class="col-md-2 control-label" data-translate="functionManagement.functionCode">Function Code</label><div class="col-md-4"><div class="input-group"><div class="input-group-addon"><span class="glyphicon glyphicon-search"></span></div><input type="text" class="form-control" ng-model="vm.searchData.kinouCode" ng-change="vm.search()"></div></div><div class="col-md-1" style="padding-left: 0px"><button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr style="margin-bottom: 0px;margin-top: 0px"><div class="row"><div class="table-responsive"><table id="headerHeight" class="jh-table table table-striped table-hover" style="table-layout: fixed; margin-bottom: 0px"><colgroup><col width="20%"><col width="70%"><col width="10%"><col></colgroup><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th>\u6A5F\u80FD\u6A29\u9650\u540D</th><th>\u6A5F\u80FD\u6A29\u9650\u30B3\u30FC\u30C9</th><th></th></tr></thead></table><div style="overflow: auto" id="tableDiv"><table class="jh-table table table-striped table-hover" style="table-layout: fixed;margin-bottom: 0px"><colgroup><col width="20%"><col width="60%"><col width="20%"><col></colgroup><tbody><tr ng-repeat="kinou in vm.kinouList"><td title="{{kinou.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{kinou.name}}</td><td title="{{kinou.code}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{kinou.code}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="btn-group flex-btn-group-container"><button type="submit" ng-click="vm.goEdit(kinou.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ng-click="vm.goDel(kinou.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div id="pageHeight" class="text-center" ng-if="vm.totalItems > 0" style="margin-top: 20px"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()" style="margin-bottom: 10px;margin-top: 10px"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.totalItems == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div></div></div>');
$templateCache.put('app/system/group-management/group-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.group.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><div class="alert alert-danger ng-scope" ng-if="vm.error"><strong data-translate="groupManagement.deletedError" class="ng-scope"></strong></div><p data-translate="groupManagement.delete.question" data-translate-values="{groupName: \'{{vm.group.name}}\'}">Are you sure you want to delete this Group?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/group-management/group-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="groupManagement.home.createLabel" ng-if="vm.group.id == null">Create a Group</h4><h4 class="modal-title" data-translate="groupManagement.home.editLabel" ng-if="vm.group.id != null">Edit a Group</h4></div><jhi-alert-error></jhi-alert-error><div class="modal-body"><div class="form-group"><label class="control-label" data-translate="groupManagement.name">name</label><input type="text" class="form-control" name="name" ng-model="vm.group.name" ng-required="vm.group.name == null || vm.group.name == \'\'" ng-minlength="1" ng-maxlength="32" ng-change="vm.groupNameCheck();" ng-blur="vm.groupNameCheck();"><div ng-show="editForm.name.$invalid || vm.groupNameExist" class="has-error small"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p><p class="help-block" ng-show="vm.groupNameExist" data-translate="groupManagement.validation.name.exist">Group name exist.</p></div></div><div class="form-group"><label class="control-label" data-translate="groupManagement.timezone" ng-required="vm.group.timezone == null || vm.group.timezone == \'\'">\u30BF\u30A4\u30E0\u30BE\u30FC\u30F3\u8A2D\u5B9A</label><select class="form-control" name="timezone" ng-model="vm.group.timezone"><option value="Asia/Tokyo">Asia/Tokyo\uFF08\u6771\u4EAC\uFF09</option><option value="Asia/Shanghai">Asia/Shanghai\uFF08\u4E0A\u6D77\uFF09</option></select><div ng-show="editForm.timezone.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.timezone.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="groupManagement.parent">Parent group</label><select class="form-control" name="parentId" ng-model="vm.group.parentId" ng-options="pg.id as (pg.name + pg.serviceTypeName) for pg in vm.parentGroup" ng-change="vm.groupNameCheck()"><option ng-if="vm.isAdmin"></option></select></div><div class="form-group"><div><label data-translate="groupManagement.flags">Flags</label></div><div class="col-md-3 control-label checkbox ng-scope" ng-repeat="flags in vm.allGroupFlags" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-top: -5px" title="{{flags.name}}"><label class="ng-binding ng-scope"><input type="checkbox" ng-model="flags.checked" ng-checked="flags.checked">{{flags.name}}</label></div></div><div style="clear: both"></div><div class="form-group" style="margin-top: 10px"><div><label class="control-label">\u30B7\u30D5\u30C8\u7BA1\u7406</label></div><div class="col-md-3 control-label radio ng-scope"><label class="ng-binding ng-scope"><input type="radio" name="timecardShiftFlag" ng-model="vm.group.timecardShiftFlag" value="1">\u6709\u52B9</label><label class="ng-binding ng-scope" style="margin-left: 10px"><input type="radio" name="timecardShiftFlag" ng-model="vm.group.timecardShiftFlag" value="0">\u7121\u52B9</label></div></div><div style="clear: both"></div><div class="form-group"><label class="control-label" data-translate="groupManagement.jigyoushoCd">jigyoushoCd</label><input type="text" class="form-control" name="jigyoushoCd" ng-model="vm.group.jigyoushoCd" ng-maxlength="10"><div ng-show="editForm.jigyoushoCd.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.jigyoushoCd.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="groupManagement.caretreeId">caretreeId</label><input type="text" class="form-control" name="caretreeId" ng-model="vm.group.caretreeId" ng-maxlength="30"><div ng-show="editForm.caretreeId.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.caretreeId.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="30">This field cannot be longer than 30 characters.</p></div></div><div class="form-group"><label data-translate="groupManagement.caretreePw">caretreePw</label><input type="password" class="form-control" name="caretreePw" ng-model="vm.group.caretreePw" ng-maxlength="32"><div ng-show="editForm.caretreePw.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.caretreePw.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label data-translate="groupManagement.selectService">serviceType</label><div class="input-group"><select class="form-control" name="serviceType" ng-model="vm.group.serviceType" ng-change="vm.serviceTypeChanged()" ng-options="service.serviceType as service.serviceNm for service in vm.group.serviceList"><option value=""></option></select><span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.loadAllServiceTypes()" ng-disabled="editForm.jigyoushoCd.$invalid || editForm.caretreeId.$invalid || editForm.caretreePw.$invalid"><span class="glyphicon glyphicon-search"></span>&nbsp;<span data-translate="groupManagement.selectService">Select</span></button></span></div></div><div class="form-group" ng-show="vm.group.jigyoushoId.length > 0"><label data-translate="groupManagement.jigyoushoId">jigyoushoId</label><div class="input-group"><label>{{vm.group.jigyoushoId}}[loginID:{{vm.group.caretreeStaffId}}]</label></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving || vm.groupNameExist" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/system/group-management/group-management.html','<div><form id="searchHeight" class="form-horizontal" role="form"><div class="form-group" style="margin-bottom: 10px"><label style="margin-top: 0px; margin-bottom: 0px" class="col-md-6 h2" data-translate="groupManagement.home.title">Groups</label><div style="margin-top: 0px; margin-bottom: 0px" class="col-md-6 text-right button-add"><button type="button" class="btn btn-primary" ng-click="vm.goNew()" data-translate="groupManagement.home.createLabel">Create Group</button></div></div><div class="form-group"><label class="col-md-1 control-label searchOne" data-translate="groupManagement.name">Group Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div><label class="col-md-2 control-label searchTwo" data-translate="groupManagement.jigyoushoCd">Jigyousho Code</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.jigyoushoCd"></div><label class="col-md-2 control-label searchTwo" data-translate="groupManagement.serviceType">Service Type</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.serviceType"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary search-button" ng-click="vm.search()" style="width: 100px;height: 40px"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default clear-button" ng-click="vm.clear()" style="margin-left: 30px;width: 100px;height: 40px"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr style="margin-bottom: 0px;margin-top: 0px"><div class="row"><div class="col-md-12"><div class="table-responsive"><table id="headerHeight" class="jh-table table table-striped table-hover" style="table-layout: fixed; margin-bottom: 0px"><colgroup><col width="30%"><col width="30%"><col width="30%"><col></colgroup><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="groupManagement.name">Group Name</span></th><!--<th><span data-translate="groupManagement.timezone">Time Zone</span></th>--><th><span data-translate="groupManagement.jigyoushoCd">Jigyousho CD</span></th><th><span data-translate="groupManagement.serviceType">Service Type</span></th><th></th></tr></thead></table><div style="overflow: auto" id="tableDiv"><table style="table-layout: fixed;margin-bottom: 0px" class="jh-table table table-striped table-hover"><colgroup><col width="30%"><col width="30%"><col width="30%"><col></colgroup><tbody><tr ng-repeat="group in vm.groups track by group.id"><td title="{{group.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{group.name}}</td><!--<td>{{group.timezone}}</td>--><td title="{{group.jigyoushoCd}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{group.jigyoushoCd}}</td><td title="{{group.serviceTypeName}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{group.serviceTypeName}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.goEdit(group.id)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="button" ng-click="vm.goDel(group.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div></div><!--<div class="table-responsive" ng-if="vm.groups.length > 0">\n        <table class="table table-striped table-hover table-bordered">\n            <thead>\n            <tr>\n                <th data-translate="groupManagement.name">Group Name</th>\n                <th data-translate="groupManagement.timezone">Time Zone</th>\n                <th data-translate="groupManagement.caretreeId">Caretree ID</th>\n                <th data-translate="groupManagement.caretreePw">Caretree PW</th>\n                <th data-translate="groupManagement.jigyoushoCd">Jigyousho CD</th>\n                <th data-translate="groupManagement.serviceType">Service Type</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="group in vm.groups track by group.id">\n                <td>{{group.name}}</td>\n                <td>{{group.timezone}}</td>\n                <td>{{group.caretreeId}}</td>\n                <td>*********</td>\n                <td>{{group.jigyoushoCd}}</td>\n                <td>{{group.serviceTypeName}}</td>\n                <td class="text-right">\n                    <div class="btn-group flex-btn-group-container">\n                        <button type="submit"\n                                ui-sref="group-management.edit({id:group.id})"\n                                class="btn btn-primary btn-sm">\n                            <span class="glyphicon glyphicon-pencil"></span>\n                            <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span>\n                        </button>\n                        <button type="submit"\n                                ui-sref="group-management.delete({id:group.id})"\n                                class="btn btn-danger btn-sm">\n                            <span class="glyphicon glyphicon-remove-circle"></span>\n                            <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>--><div id="pageHeight" class="text-center" ng-if="vm.groups.length > 0" style="margin-top: 20px"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()" style="margin-bottom: 10px;margin-top: 10px"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.groups.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div>');
$templateCache.put('app/system/keiyakuplan-management/keiyakuplan-management-planset.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="keiyakuplanLabel" data-translate="keiyakuplanManagement.home.planSetButton">Keiyaku Plan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><form class="form-horizontal" role="form" name="editForm"><table class="table table-striped table-hover table-dialog"><thead><tr><th width="50%">\u6599\u91D1\u30D5\u309A\u30E9\u30F3</th><th width="50%">\u5229\u7528\u5236\u9650\u9078\u629E</th></tr><tr ng-repeat="keiyakuplan in vm.keiyakuplanList"><td width="50%">{{keiyakuplan.planNm}}</td><td width="50%"><select class="form-control" ng-model="keiyakuplan.permission" ng-options="permission.code as permission.name for permission in vm.permissionList"></select></td></tr></thead></table></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-click="vm.save()" ng-disabled="editForm.$invalid || isSaving || vm.repeatFlg || (!vm.isAdmin && vm.hasAdmin)" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/system/keiyakuplan-management/keiyakuplan-management.html','<div><form id="searchHeight" class="form-horizontal" role="form"><div class="form-group" style="margin-bottom: 10px"><label class="col-md-6 h2" data-translate="keiyakuplanManagement.home.title" style="margin-top: 0px; margin-bottom: 0px">Keiyakuplan</label></div><div class="form-group"><label class="col-md-1 control-label" data-translate="keiyakuplanManagement.home.keiyakuplanName">Keiyakuplan Name</label><div class="col-md-4"><div class="input-group"><div class="input-group-addon"><span class="glyphicon glyphicon-search"></span></div><input type="text" class="form-control" ng-model="vm.searchData.keiyakuplanName" ng-change="vm.search()"></div></div><!--<div class="col-md-1"></div>--><label class="col-md-2 control-label" data-translate="keiyakuplanManagement.home.keiyakuplanCode">Keiyakuplan Code</label><div class="col-md-4"><div class="input-group"><div class="input-group-addon"><span class="glyphicon glyphicon-search"></span></div><input type="text" class="form-control" ng-model="vm.searchData.keiyakuplanCode" ng-change="vm.search()"></div></div><div class="col-md-1" style="padding-left: 0px"><button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr style="margin-bottom: 0px;margin-top: 0px"><div class="row"><div class="table-responsive"><table id="headerHeight" style="table-layout: fixed; margin-bottom: 0px" class="jh-table table table-striped table-hover"><colgroup><col width="20%"><col width="26%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"></colgroup><thead><tr><th></th><th style="text-align: right">\u4E00\u62EC</th><th><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="vm.yikuoShow11">\u25EF</span> <span ng-show="vm.yikuoShow12">\xD7</span> <span ng-show="vm.yikuoShow13">\u2610</span> <span ng-show="vm.yikuoShow14">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{vm.yikuoShow11 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.yikuoaClick1(1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{vm.yikuoShow12 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.yikuoaClick1(2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{vm.yikuoShow13 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.yikuoaClick1(3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{vm.yikuoShow14 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.yikuoaClick1(4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></th><th><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="vm.yikuoShow21">\u25EF</span> <span ng-show="vm.yikuoShow22">\xD7</span> <span ng-show="vm.yikuoShow23">\u2610</span> <span ng-show="vm.yikuoShow24">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{vm.yikuoShow21 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.yikuoaClick2(1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{vm.yikuoShow22 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.yikuoaClick2(2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{vm.yikuoShow23 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.yikuoaClick2(3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{vm.yikuoShow24 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.yikuoaClick2(4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></th><th><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="vm.yikuoShow31">\u25EF</span> <span ng-show="vm.yikuoShow32">\xD7</span> <span ng-show="vm.yikuoShow33">\u2610</span> <span ng-show="vm.yikuoShow34">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{vm.yikuoShow31 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.yikuoaClick3(1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{vm.yikuoShow32 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.yikuoaClick3(2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{vm.yikuoShow33 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.yikuoaClick3(3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{vm.yikuoShow34 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.yikuoaClick3(4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></th><th><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="vm.yikuoShow41">\u25EF</span> <span ng-show="vm.yikuoShow42">\xD7</span> <span ng-show="vm.yikuoShow43">\u2610</span> <span ng-show="vm.yikuoShow44">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{vm.yikuoShow41 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.yikuoaClick4(1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{vm.yikuoShow42 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.yikuoaClick4(2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{vm.yikuoShow43 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.yikuoaClick4(3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{vm.yikuoShow44 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.yikuoaClick4(4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></th><th><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="vm.yikuoShow51">\u25EF</span> <span ng-show="vm.yikuoShow52">\xD7</span> <span ng-show="vm.yikuoShow53">\u2610</span> <span ng-show="vm.yikuoShow54">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{vm.yikuoShow51 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.yikuoaClick5(1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{vm.yikuoShow52 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.yikuoaClick5(2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{vm.yikuoShow53 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.yikuoaClick5(3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{vm.yikuoShow54 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.yikuoaClick5(4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></th><th><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="vm.yikuoShow61">\u25EF</span> <span ng-show="vm.yikuoShow62">\xD7</span> <span ng-show="vm.yikuoShow63">\u2610</span> <span ng-show="vm.yikuoShow64">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{vm.yikuoShow61 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.yikuoaClick6(1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{vm.yikuoShow62 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.yikuoaClick6(2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{vm.yikuoShow63 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.yikuoaClick6(3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{vm.yikuoShow64 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.yikuoaClick6(4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></th><th><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="vm.yikuoShow71">\u25EF</span> <span ng-show="vm.yikuoShow72">\xD7</span> <span ng-show="vm.yikuoShow73">\u2610</span> <span ng-show="vm.yikuoShow74">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{vm.yikuoShow71 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.yikuoaClick7(1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{vm.yikuoShow72 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.yikuoaClick7(2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{vm.yikuoShow73 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.yikuoaClick7(3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{vm.yikuoShow74 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.yikuoaClick7(4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></th><th><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="vm.yikuoShow81">\u25EF</span> <span ng-show="vm.yikuoShow82">\xD7</span> <span ng-show="vm.yikuoShow83">\u2610</span> <span ng-show="vm.yikuoShow84">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{vm.yikuoShow81 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.yikuoaClick8(1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{vm.yikuoShow82 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.yikuoaClick8(2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{vm.yikuoShow83 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.yikuoaClick8(3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{vm.yikuoShow84 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.yikuoaClick8(4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></th><th><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="vm.yikuoShow91">\u25EF</span> <span ng-show="vm.yikuoShow92">\xD7</span> <span ng-show="vm.yikuoShow93">\u2610</span> <span ng-show="vm.yikuoShow94">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{vm.yikuoShow91 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.yikuoaClick9(1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{vm.yikuoShow92 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.yikuoaClick9(2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{vm.yikuoShow93 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.yikuoaClick9(3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{vm.yikuoShow94 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.yikuoaClick9(4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></th></tr><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th>\u6A5F\u80FD\u6A29\u9650\u540D</th><th>\u6A5F\u80FD\u6A29\u9650\u30B3\u30FC\u30C9</th><th>\u672A\u7533\u8ACB</th><th>\u7121\u6599</th><th>\u4F53\u9A13</th><th>\u6599\u91D1\uFF11</th><th>\u6599\u91D1\uFF12</th><th>\u6599\u91D1\uFF13</th><th>\u6599\u91D1\uFF14</th><th>\u6599\u91D1\uFF15</th><th>\u7279\u6A29</th></tr></thead></table><div style="overflow: auto" id="tableDiv"><table class="jh-table table table-striped table-hover" style="table-layout: fixed;margin-bottom: 0px"><colgroup><col width="20%"><col width="26%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"><col width="6%"></colgroup><tbody><tr ng-repeat="kinou in vm.kinouList"><td title="{{kinou.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;word-break: break-all;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{kinou.name}}</td><td title="{{kinou.code}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{kinou.code}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="kinou.show11">\u25EF</span> <span ng-show="kinou.show12">\xD7</span> <span ng-show="kinou.show13">\u2610</span> <span ng-show="kinou.show14">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{kinou.show11 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.aClick1(kinou,1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{kinou.show12 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.aClick1(kinou,2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{kinou.show13 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.aClick1(kinou,3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{kinou.show14 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.aClick1(kinou,4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="kinou.show21">\u25EF</span> <span ng-show="kinou.show22">\xD7</span> <span ng-show="kinou.show23">\u2610</span> <span ng-show="kinou.show24">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{kinou.show21 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.aClick2(kinou,1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{kinou.show22 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.aClick2(kinou,2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{kinou.show23 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.aClick2(kinou,3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{kinou.show24 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.aClick2(kinou,4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="kinou.show31">\u25EF</span> <span ng-show="kinou.show32">\xD7</span> <span ng-show="kinou.show33">\u2610</span> <span ng-show="kinou.show34">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{kinou.show31 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.aClick3(kinou,1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{kinou.show32 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.aClick3(kinou,2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{kinou.show33 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.aClick3(kinou,3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{kinou.show34 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.aClick3(kinou,4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="kinou.show41">\u25EF</span> <span ng-show="kinou.show42">\xD7</span> <span ng-show="kinou.show43">\u2610</span> <span ng-show="kinou.show44">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{kinou.show41 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.aClick4(kinou,1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{kinou.show42 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.aClick4(kinou,2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{kinou.show43 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.aClick4(kinou,3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{kinou.show44 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.aClick4(kinou,4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="kinou.show51">\u25EF</span> <span ng-show="kinou.show52">\xD7</span> <span ng-show="kinou.show53">\u2610</span> <span ng-show="kinou.show54">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{kinou.show51 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.aClick5(kinou,1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{kinou.show52 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.aClick5(kinou,2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{kinou.show53 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.aClick5(kinou,3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{kinou.show54 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.aClick5(kinou,4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="kinou.show61">\u25EF</span> <span ng-show="kinou.show62">\xD7</span> <span ng-show="kinou.show63">\u2610</span> <span ng-show="kinou.show64">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{kinou.show61 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.aClick6(kinou,1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{kinou.show62 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.aClick6(kinou,2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{kinou.show63 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.aClick6(kinou,3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{kinou.show64 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.aClick6(kinou,4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="kinou.show71">\u25EF</span> <span ng-show="kinou.show72">\xD7</span> <span ng-show="kinou.show73">\u2610</span> <span ng-show="kinou.show74">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{kinou.show71 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.aClick7(kinou,1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{kinou.show72 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.aClick7(kinou,2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{kinou.show73 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.aClick7(kinou,3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{kinou.show74 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.aClick7(kinou,4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px"><span ng-show="kinou.show81">\u25EF</span> <span ng-show="kinou.show82">\xD7</span> <span ng-show="kinou.show83">\u2610</span> <span ng-show="kinou.show84">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{kinou.show81 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.aClick8(kinou,1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{kinou.show82 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.aClick8(kinou,2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{kinou.show83 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.aClick8(kinou,3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{kinou.show84 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.aClick8(kinou,4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="dropdown"><button type="button" class="btn dropdown-toggle" data-toggle="dropdown" style="background-color: #fff;border: 1px solid #ccc;width:60px;width:60px"><span ng-show="kinou.show91">\u25EF</span> <span ng-show="kinou.show92">\xD7</span> <span ng-show="kinou.show93">\u2610</span> <span ng-show="kinou.show94">\u2206</span> <span class="caret" style="margin-left: 10px"></span></button><ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="dropdownMenu1"><li role="presentation" class="{{kinou.show91 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="1" ng-click="vm.aClick9(kinou,1);">\u25EF(\u5236\u9650\u306A\u3057)</a></li><li role="presentation" class="{{kinou.show92 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="2" ng-click="vm.aClick9(kinou,2);">\xD7(\u5229\u7528\u4E0D\u53EF)</a></li><li role="presentation" class="{{kinou.show93 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="3" ng-click="vm.aClick9(kinou,3);">\u2610(\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF\u5236\u9650)</a></li><li role="presentation" class="{{kinou.show94 == true ? \'bgblue\' : \'\'}}"><a role="menuitem" tabindex="4" ng-click="vm.aClick9(kinou,4);">\u2206(\u304A\u8A66\u3057\u671F\u9593\u5236\u9650)</a></li></ul></div></td></tr></tbody></table></div><div id="pageHeight" class="text-center" ng-if="vm.totalItems > 0" style="margin-top: 20px"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()" style="margin-bottom: 10px;margin-top: 10px"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.totalItems == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div></div></div>');
$templateCache.put('app/system/robot-management/robot-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pepper.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><lable data-translate="robotManagement.delete.mark">{{vm.groupName}}<lable data-translate="robotManagement.delete.questionNew" data-translate-values="{pepperName: \'{{vm.pepper.pepperName}}\'}">Are you sure you want to delete this User?</lable></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/robot-management/robot-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="robotManagement.home.createTitle" ng-if="vm.pepper.id == \'\' || vm.pepper.id == null">Create or edit a User</h4><h4 class="modal-title" data-translate="robotManagement.home.updateTitle" ng-if="vm.pepper.id != \'\' && vm.pepper.id != null">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="robotManagement.name">name</label><input type="text" class="form-control" name="name" ng-model="vm.pepper.pepperName" ng-required="vm.pepper.pepperName == null || vm.pepper.pepperName == \'\'" ng-maxlength="32"><div ng-show="editForm.name.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="32">This field cannot be longer than 32 characters.</p></div></div><div class="form-group"><label data-translate="robotManagement.groups">groups</label><div class="col-md-12" style="padding-left: 0px; padding-right: 0px"><input type="text" class="form-control" name="groupNm" ng-model="vm.groupNm" ng-change="vm.inputGroupNm()"><ul class="dropdown-menu" uib-dropdown-menu style="display: block;margin-left:12px; margin-right:12px" ng-show="vm.groupSelectListShowFlg"><li ng-repeat="pg in vm.groups" ng-show="pg.showFlg" ng-click="vm.clickGroupListClick(pg)"><a>{{pg.name}}{{pg.serviceTypeName}}</a></li></ul></div><input type="hidden" name="groupId" ng-model="vm.pepper.groupId" ng-required="vm.pepper.groupId == null || vm.pepper.groupId == \'\'"><div ng-show="editForm.groupId.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.groupId.$error.required" data-translate="entity.validation.selected">This field is required.</p></div></div><div style="clear:both"></div><div class="form-group" ng-show="vm.pepper.jigyoushoId.length > 0"><label data-translate="robotManagement.jigyoushoId">jigyoushoId</label><div class="input-group"><label>{{vm.pepper.jigyoushoId}}[loginID:{{vm.pepper.caretreeStaffId}}]</label></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/system/robot-management/robot-management.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-6 h2" data-translate="robotManagement.home.titleManage">Robots</label><div class="col-md-6 text-right button-add"><button type="button" class="btn btn-primary" ui-sref="robot-management.new" data-translate="robotManagement.home.createLabel">Create</button></div></div><div class="form-group"><label class="col-md-1 control-label" data-translate="robotManagement.name">RobotManagement Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.pepperName"></div><label class="col-md-2 control-label" data-translate="robotManagement.groups">Groups</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.selectGroupNm" ng-change="vm.inputGroupNm()"><ul class="dropdown-menu" uib-dropdown-menu style="display: block;margin-left:12px; margin-right:12px" ng-show="vm.groupSelectListShowFlg"><li ng-repeat="pg in vm.parentGroup" ng-show="pg.showFlg" ng-click="vm.clickGroupListClick(pg)"><a>{{pg.name}}{{pg.serviceTypeName}}</a></li></ul></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary search-button" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default clear-button" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="jh-table table table-striped table-hover"><colgroup><col width="40%"><col width="40%"><col></colgroup><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span data-translate="robotManagement.name">Robot Name</span></th><th><span data-translate="robotManagement.groups">Group Name</span></th><th></th></tr><tbody><tr ng-repeat="pepper in vm.peppers track by pepper.id"><td>{{pepper.pepperName}}</td><td>{{pepper.groupName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="robot-management.edit({id:pepper.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="robot-management.delete({id:pepper.id,groupNm:pepper.groupName})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></thead></table></div></div></div><div class="text-center" ng-if="vm.peppers.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.peppers.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div><!--<div>\n    <div class="table-responsive">\n        <table class="table table-striped table-hover table-bordered" ng-if="vm.peppers.length > 0">\n            <thead>\n            <tr>\n                <th data-translate="robotManagement.name">Robot Name</th>\n                <th data-translate="robotManagement.groups">Group Name</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat="pepper in vm.peppers track by pepper.id">\n                <td>{{pepper.pepperName}}</td>\n                <td>\n                <div>\n                    <span>{{pepper.groupName}}</span>\n                </td>\n                <td class="text-right">\n                    <div class="btn-group flex-btn-group-container">\n                        <button type="submit"\n                                ui-sref="robot-management.edit({id:pepper.id})"\n                                class="btn btn-primary btn-sm">\n                            <span class="glyphicon glyphicon-pencil"></span>\n                            <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span>\n                        </button>\n                        <button type="submit"\n                                ui-sref="robot-management.delete({id:pepper.id})"\n                                class="btn btn-danger btn-sm">\n                            <span class="glyphicon glyphicon-remove-circle"></span>\n                            <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n        <div class="alert alert-warning top-margin" ng-if="vm.peppers.length == 0">\n            <strong data-translate="global.messages.info.noData">There is no data!</strong>\n        </div>\n    </div>\n</div>-->');
$templateCache.put('app/system/role-management/role-management-create.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRoleLabel" data-translate="roleManagement.home.editLabel" ng-if="vm.role.code != \'\'">Edit a Role</h4><h4 class="modal-title" id="myRoleLabelAdd" data-translate="roleManagement.home.createLabel" ng-if="vm.role.code == \'\'">Create a Role</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="col-md-3 control-label" data-translate="roleManagement.roleName">Role Name</label><div class="col-md-8"><input type="text" class="form-control" ng-model="vm.role.name" name="nameDetail" ng-required="vm.role.nameDetail == null" ng-minlength="1" ng-maxlength="100"><div ng-show="editForm.nameDetail.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.nameDetail.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nameDetail.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="roleManagement.roleCode">Role Code</label><div class="col-md-8"><input type="text" class="form-control" ng-model="vm.role.code" name="roleCode" ng-required="vm.role.roleCode == null" ng-minlength="1" ng-maxlength="100"><div ng-show="editForm.roleCode.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.roleCode.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.roleCode.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="roleManagement.authority">Role Name</label><div class="col-md-8"><div class="input-group"><div class="input-group-addon"><span class="glyphicon glyphicon-search"></span></div><input type="text" class="form-control" ng-model="vm.authority" ng-change="vm.searchAuthority()"></div></div><!--<div class="col-md-2">\n                <button type="button" class="btn btn-primary" ng-click="vm.searchAuthority()">\n                    <span class="glyphicon glyphicon-search"></span>\n                    <span data-translate="global.button.search">Search</span>\n                </button>\n            </div>--></div><div class="form-group"><label class="col-md-3 control-label" data-translate="roleManagement.authoritySelect">Role Name</label><div class="col-md-6" id="aDiv" style="border: 1px solid black; width: 568px;height: 200px;margin-left: 15px;overflow: auto;font-size: 16px"><div class="checkbox" ng-repeat="fun in vm.role.kinouList" ng-show="fun.showFlag"><label><input ng-model="fun.checked" ng-checked="{{fun.checked}}" type="checkbox" id="{{fun.id}}" name="{{fun.name}}">&nbsp; <span style="word-break: break-all">{{fun.name}}</span></label></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-click="vm.save()" ng-disabled="editForm.$invalid || isSaving || vm.repeatFlg || (!vm.isAdmin && vm.hasAdmin)" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/system/role-management/role-management-delete.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="roleManagement.delete">Confirm delete operation</h4></div><div class="modal-body" style="overflow:hidden; word-wrap:break-word;word-break: break-all"><p data-translate="roleManagement.deleteRole.question" data-translate-values="{roleName: \'{{vm.role.name}}\'}">Are you sure you want to delete this Role?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger" ng-click="vm.delete(vm.role.code)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/role-management/role-management-show.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabelAdd" data-translate="roleManagement.home.showLabel" ng-if="vm.user.id == null">Create a User</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="form-group"><label class="col-md-3 control-label" data-translate="roleManagement.roleName">Role Name</label><div class="col-md-6"><p class="form-control-static ng-binding">{{vm.role.name}}</p></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="roleManagement.roleCode">Role Code</label><div class="col-md-6"><p class="form-control-static ng-binding">{{vm.role.code}}</p></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="roleManagement.authoritySelect">Role Name</label><div class="col-md-6" style="border: 1px solid black; width: 418px;height: 200px;margin-left: 15px;overflow: auto"><div ng-repeat="fun in vm.role.kinouList" ng-show="fun.checked">{{$index + 1}}&nbsp;{{fun.name}}<!--<p class="form-control-static ng-binding" style="padding-top: 1px;padding-bottom: 1px; height: 17px;">{{$index + 1}}&nbsp;{{fun.name}}</p>--></div></div></div></form></div><div class="modal-footer"><button type="submit" ng-click="vm.clear()" ng-disabled="editForm.$invalid || isSaving || vm.repeatFlg || (!vm.isAdmin && vm.hasAdmin)" class="btn btn-primary"><span data-translate="entity.action.close">Save</span></button></div>');
$templateCache.put('app/system/role-management/role-management.html','<style>.contant{\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        width:99%;\n    }</style><div><form id="searchHeight" class="form-horizontal" role="form"><div class="form-group" style="margin-bottom: 10px"><label class="col-md-6 h2" data-translate="roleManagement.home.title" style="margin-top: 0px; margin-bottom: 0px">Role</label><div class="col-md-6 text-right button-add" style="margin-top: 0px; margin-bottom: 0px"><button type="button" class="btn btn-primary" ng-click="vm.goNew()" data-translate="roleManagement.home.createLabel">Add</button></div></div><div class="form-group"><label class="col-md-1 control-label" data-translate="roleManagement.roleName">Role Name</label><div class="col-md-4"><div class="input-group"><div class="input-group-addon"><span class="glyphicon glyphicon-search"></span></div><input type="text" class="form-control" ng-model="vm.searchData.roleName" ng-change="vm.search()"></div></div><!--<div class="col-md-1"></div>--><label class="col-md-2 control-label" data-translate="roleManagement.roleCode">Role Code</label><div class="col-md-4"><div class="input-group"><div class="input-group-addon"><span class="glyphicon glyphicon-search"></span></div><input type="text" class="form-control" ng-model="vm.searchData.roleCode" ng-change="vm.search()"></div></div><div class="col-md-1" style="padding-left: 0px"><button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr style="margin-bottom: 0px;margin-top: 0px"><div class="row"><div class="table-responsive"><table id="headerHeight" class="jh-table table table-striped table-hover" style="table-layout: fixed; margin-bottom: 0px"><colgroup><col width="20%"><col width="20%"><col width="43%"><col width="2%"><col width="15%"></colgroup><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th>\u30ED\u30FC\u30EB\u540D</th><th>\u30ED\u30FC\u30EB\u30B3\u30FC\u30C9</th><th>\u6A5F\u80FD\u6A29\u9650\u540D</th><th></th><th></th></tr></thead></table><div style="overflow: auto" id="tableDiv"><table class="jh-table table table-striped table-hover" style="table-layout: fixed;margin-bottom: 0px"><colgroup><col width="20%"><col width="20%"><col width="43%"><col width="2%"><col width="15%"></colgroup><tbody><tr ng-repeat="role in vm.role"><td title="{{role.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{role.name}}</td><td title="{{role.code}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{role.code}}</td><td title="{{role.kinouListString}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{role.kinouListString}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="role-management.show({code:role.code})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button ng-disabled="{{role.system}}" type="submit" ng-click="vm.goEdit(role.code)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button ng-disabled="{{role.system}}" type="submit" ng-click="vm.goDel(role.code, role.name)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div id="pageHeight" class="text-center" ng-if="vm.totalItems > 0" style="margin-top: 20px"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()" style="margin-bottom: 10px;margin-top: 10px"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.totalItems == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div></div></div>');
$templateCache.put('app/system/script/script.html','<div><div class="row"><div class="col-md-4"><h3 class="" data-translate="script.home.title">Script</h3></div><div class="col-md-3"></div><div class="col-md-5"><!--<button class="btn btn-sm btn-success pull-right" type="button" ng-if="vm.pepper != null">\n                \u30ED\u30DC\u30C3\u30C8\u540D\uFF1A <span class="badge">{{vm.pepper.pepperName}}</span>\n            </button>--><div class="col-md-3"></div><label class="col-md-3 control-label" data-translate="script.home.pepperchange" style="padding-top: 7px; text-align: right">Pepperchange</label><div class="col-md-6"><select class="form-control" ng-options="pepper.id as pepper.pepperName for pepper in vm.pepperList" ng-model="vm.selectPepper" ng-change="vm.changePepper(vm.pepperList)" style="width: 220px"><!-- <option ng-repeat="pp in vm.pepperList" value="{{pp.id}}">{{pp.pepperName}}</option>--></select></div></div></div><div class="alert alert-warning" ng-if="vm.pepper == null"><strong data-translate="global.messages.info.noPepper">There is no pepper!</strong></div><div class="row"><div class="col-md-12"><div class="btn-group"><button type="button" class="btn btn-info" ui-sref="base" ng-disabled="vm.pepper == null"><span class="glyphicon glyphicon-list"></span> <span class="hidden-xs hidden-sm" data-translate="script.home.base">Base</span></button></div><div class="btn-group"><button type="button" class="btn btn-info" ui-sref="daily" ng-disabled="vm.pepper == null"><span class="glyphicon glyphicon-repeat"></span> <span class="hidden-xs hidden-sm" data-translate="script.home.daily">Daily</span></button></div><div class="btn-group"><button type="button" class="btn btn-info" ui-sref="schedule" ng-disabled="vm.pepper == null"><span class="glyphicon glyphicon-calendar"></span> <span class="hidden-xs hidden-sm" data-translate="script.home.schedule">Schedule</span></button></div><div class="btn-group"><button type="button" class="btn btn-info" ui-sref="library"><span class="glyphicon glyphicon-file"></span> <span class="hidden-xs hidden-sm" data-translate="script.home.library">Library</span></button></div><div class="btn-group"><button type="button" class="btn btn-info" ui-sref="photo"><span class="glyphicon glyphicon-picture"></span> <span class="hidden-xs hidden-sm" data-translate="script.home.photo">Photo</span></button></div></div></div><hr><div class="row"><div class="col-md-3"><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title" data-translate="script.contents.collections">Collections</h3></div><div class="panel-body"><div class="panel panel-default noborder"><div class="panel-heading" data-translate="script.contents.type">Type</div><div class="panel-body no-padding-left"><div class="list-group"><a class="list-group-item" ng-repeat="types in vm.scriptTypes" ng-click="vm.changeType(types.code)" ng-class="{active : types.code == vm.selectedType}" ng-hide="vm.isAdmin && types.code == 1">\uFF5C\u30FC{{types.name}}</a></div></div></div><div class="panel panel-default noborder"><div class="panel-heading" data-translate="script.contents.category">Category</div><div class="panel-body no-padding-left"><div class="list-group"><a class="list-group-item" ng-repeat="category in vm.categories" ng-click="vm.changeCategory(category.id)" ng-class="{active : category.id == vm.selectedCategory}" ng-if="vm.isAdmin || (!vm.isAdmin && category.categoryType < 9)">\uFF5C\u30FC{{category.categoryValue}}</a></div></div></div></div></div></div><div class="col-md-9"><div class="row"><div class="col-md-8"><div class="btn-group" uib-dropdown><button id="split-button" type="button" class="btn btn-info" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm" data-translate="script.contents.new">New</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li><a ui-sref="conversation({id: 0, type: 1})" data-translate="script.contents.text">Text</a></li><li><a ui-sref="conversation({id: 0, type: 4})" data-translate="script.contents.speech">Speech</a></li><li><a ng-click="vm.edit(0, 2)" data-translate="script.contents.music">Music</a></li><li><a ng-click="vm.edit(0, 3)" data-translate="script.contents.movie">Movie</a></li></ul></div><div class="btn-group"><button type="button" class="btn btn-info" ng-click="vm.copy()" ng-disabled="vm.selectedScriptId.length == 0"><span class="glyphicon glyphicon-copy"></span> <span class="hidden-xs hidden-sm" data-translate="script.contents.copy">Copy</span></button></div><div class="btn-group"><button type="button" class="btn btn-info" ng-click="vm.goEdit()" ng-if="vm.selectedType == 2" ng-disabled="vm.selectedScriptId.length != 1"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="script.contents.edit">Edit</span></button></div><div class="btn-group"><button type="button" class="btn btn-info" ng-click="vm.del()" ng-if="vm.selectedType == 2" ng-disabled="vm.selectedScriptId.length == 0"><span class="glyphicon glyphicon-remove"></span> <span class="hidden-xs hidden-sm" data-translate="script.contents.delete">Delete/span></span></button></div></div></div><div class="panel panel-success top-margin" ng-if="vm.scriptList.length > 0"><table class="table table-striped table-hover table-bordered"><colgroup><col width="3%"><col width="8%"><col width="19%"><col width="10%"><col width="13%"><col width="19%"><col width="14%"><col width="4%"><col width="10%"></colgroup><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th></th><th jh-sort-by="id" class="text-center"><span data-translate="script.contents.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="title" class="text-center"><span data-translate="script.contents.contents">Contents</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="scriptType" class="text-center"><span data-translate="script.contents.type">Type</span><span class="glyphicon glyphicon-sort"></span></th><th class="text-center" data-translate="script.contents.category">Category</th><th class="text-center" data-translate="script.contents.comment">Comment</th><th jh-sort-by="createdBy" class="text-center"><span data-translate="script.contents.createUser">Create User</span><span class="glyphicon glyphicon-sort"></span></th><th class="text-center" data-translate="script.contents.order">order</th><th class="text-center" data-translate="script.contents.collection">Collection</th></tr><tr ng-repeat="script in vm.scriptList"><td><input type="checkbox" ng-click="vm.selectScript(script.id)"></td><td class="text-center">{{script.id}}</td><td style="word-break: break-all"><a href="" ng-click="vm.goShow(script.id,script.scriptType);">{{script.title}}</a></td><td class="text-center">{{script.scriptTypeName}}</td><td class="text-center">{{script.categoryName}}</td><td style="word-break: break-all">{{script.comment}}</td><td class="text-center" style="word-break: break-all"><span ng-repeat="ul in vm.userList | filter:{login:script.createUser}:true">{{ul.lastName}}\u3000{{ul.firstName}}</span></td><td align="center"><select style="width: 64px" ng-change="vm.changeSort(script.sort,script.id);" class="form-control" ng-model="script.sort"><option value=""></option><option ng-repeat="pg in vm.CountList" value="{{pg}}" ng-selected="script.sort == pg">{{pg}}</option></select></td><td class="text-center"><div ng-if="vm.selectedType != 3"><button type="button" data-translate="script.contents.out" ng-disabled="vm.pepper == null" class="btn btn-warning" ng-disabled="vm.isSaving" ng-show="(vm.collections|filter:{scriptId: script.id}:true).length > 0" ng-click="vm.addFavorite({scriptId:script.id})"></button> <button type="button" data-translate="script.contents.in" ng-disabled="vm.pepper == null" class="btn btn-primary" ng-disabled="vm.isSaving" ng-hide="(vm.collections|filter:{scriptId: script.id}:true).length > 0" ng-click="vm.delFavorite({scriptId:script.id})"></button></div><div ng-if="vm.selectedType == 3"><button type="button" data-translate="script.contents.out" ng-disabled="vm.pepper == null" class="btn btn-warning" ng-disabled="vm.isSaving" ng-show="(vm.collections|filter:{scriptId: script.id}:true).length > 0" ng-click="vm.delFavorite({scriptId:script.id})"></button> <button type="button" data-translate="script.contents.in" ng-disabled="vm.pepper == null" class="btn btn-primary" ng-disabled="vm.isSaving" ng-hide="(vm.collections|filter:{scriptId: script.id}:true).length > 0" ng-click="vm.addFavorite({scriptId:script.id})"></button></div></td></tr></table></div><div class="text-center" ng-if="vm.scriptList.length > 0"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.scriptList.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div></div></div>');
$templateCache.put('app/system/storage-management/storage-management-confirm-dialog.html','<form><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><!--<h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4>--></div><div class="modal-body"><div style="text-align: center">\u304A\u7533\u8FBC\u307F\u3044\u305F\u3060\u304D\u8AA0\u306B\u3042\u308A\u304C\u3068\u3046\u3054\u3056\u3044\u307E\u3059\u3002</div><div style="text-align: center;padding-top: 15px">\u30D7\u30E9\u30F3\u5909\u66F4\u3057\u307E\u3057\u305F\u3002</div><div style="text-align: center; padding-top: 15px">\u5BB9\u91CF\u7BA1\u7406\u753B\u9762\u3067\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">Cancel</span></button></div></form>');
$templateCache.put('app/system/storage-management/storage-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><div class="alert alert-danger ng-scope" ng-if="vm.error"><strong data-translate="storageManagement.home.nonExistent" class="ng-scope"></strong></div><p data-translate="storageManagement.home.deleteMessage" data-translate-values="{year: \'{{vm.year}}\', date: \'{{vm.date}}\'}"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/storage-management/storage-management-mail-dialog.html','<form name="mailForm" ng-submit="vm.confirmExecute()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="storageManagement.home.sendMail">Confirm sendMail operation</h4></div><div class="modal-body" ng-show="vm.alertMailFlg == \'true\'"><p data-translate="storageManagement.home.stopSendMailMessage"></p></div><div class="modal-body" ng-show="vm.alertMailFlg == \'false\'"><p data-translate="storageManagement.home.sendMailMessage"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span data-translate="storageManagement.home.send">send</span></button></div></form>');
$templateCache.put('app/system/storage-management/storage-management-plan-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><div class="alert alert-danger ng-scope" ng-if="vm.error"><strong data-translate="storageManagement.home.nonExistent" class="ng-scope"></strong></div><p data-translate="storageManagement.home.planMessage"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">close</span></button></div></form>');
$templateCache.put('app/system/storage-management/storage-management-plan-same-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><div class="alert alert-danger ng-scope" ng-if="vm.error"><strong data-translate="storageManagement.home.nonExistent" class="ng-scope"></strong></div><p data-translate="storageManagement.home.planSameMessage"></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.close">close</span></button></div></form>');
$templateCache.put('app/system/storage-management/storage-management-rule-dialog.html','<form name="mailForm" ng-submit="vm.confirmExecute()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="storageManagement.home.rule">rule</h4></div><div class="modal-body"><iframe src="https://caretree.jp/mobile/wp-content/uploads/2019/10/caretree_licence_20191024.pdf" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="600px;" scrolling="auto" target="_top"></iframe></div><div style="text-align: center" class="checkbox"><label class="ng-binding ng-scope"><input type="checkbox" ng-model="vm.checked">\u30B1\u30A2\u6A39\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u898F\u7D04\u306B\u540C\u610F\u3057\u307E\u3059</label></div><div class="modal-footer" style="text-align: center"><button ng-disabled="!vm.checked" type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.goConfirm()"><span data-translate="storageManagement.home.plan">plan</span></button></div></form>');
$templateCache.put('app/system/storage-management/storage-management.html','<div><form id="searchHeight" class="form-horizontal" role="form"><div class="form-group" style="margin-bottom: 10px"><label style="margin-top: 0px; margin-bottom: 0px" class="col-md-6 h2" data-translate="storageManagement.home.title">\u30B9\u30C8\u30EC\u30FC\u30B8\u7BA1\u7406</label></div></form><hr style="margin-bottom: 0px;margin-top: 0px"><div class="row"><div style="float: left;width: 50%; padding-bottom: 30px"><div style="text-align: right;width: 80%"><label class="col-md-12 h3" data-translate="storageManagement.home.total">Storage</label></div><div id="storage" style="width:100%;height:400px;float: left"></div><div style="width: 70%;float: left; text-align: right; border-right: #bbbbbb 1px solid"><span style="color: #337ab7" class="col-md-12 h3">{{vm.used}}&nbsp;GB</span></div><div style="width: 30%;float: left"><span class="col-md-12 h3">{{vm.totalSize}}&nbsp;GB</span></div><div style="width: 70%;float: left; text-align: right; border-right: #bbbbbb 1px solid"><span class="col-md-12 h3">{{vm.percent}}&nbsp;\u4F7F\u7528\u6E08</span></div><div style="width: 30%;float: left"><label class="col-md-12 h3" data-translate="storageManagement.home.totalTitleStorage">totalTitleStorage</label></div></div><div style="float: left;width: 50%; text-align: left"><table><colgroup><col width="35%"><col width="65%"></colgroup><tr><td><label class="col-md-12 h3" data-translate="storageManagement.home.storageCapacity">storageCapacity</label></td><td><label class="col-md-12 h3" data-translate="storageManagement.home.proportion">proportion</label></td></tr><tr><td><label class="col-md-12 h3" data-translate="storageManagement.home.houjin">houjin</label></td><td><span style="padding-left: 15px;font-weight:bold">{{vm.used}}GB&nbsp;|&nbsp;{{vm.totalSize}}GB</span></td></tr><tr ng-repeat="jigyousho in vm.jigyoushoStorageList"><td><span style="padding-left: 15px">{{jigyousho.jigyoushoNm}}</span></td><td><span style="padding-left: 15px;font-weight:bold">{{jigyousho.used}}GB&nbsp;|&nbsp;\u30FC</span></td></tr><tr><td><label class="col-md-12 h3" data-translate="storageManagement.home.empty">empty</label></td><td><span style="padding-left: 15px;font-weight:bold">{{vm.surplus}}GB\u3067\u3059\u3002</span></td></tr><tr><td colspan="2"><label class="col-md-12 h3" data-translate="storageManagement.home.delete">delete</label></td></tr><tr><td style="padding-left: 15px"><button ng-click="vm.doDeleteOneYear(1);" type="button" class="btn btn-warning" data-translate="storageManagement.home.oneDelete">oneDelete</button></td></tr><tr><td style="padding-left: 15px;padding-top: 15px"><button ng-click="vm.doDeleteOneYear(3);" type="button" class="btn btn-warning" data-translate="storageManagement.home.threeDelete">oneDelete</button></td></tr><tr><td colspan="2" style="padding-left: 15px;padding-top: 15px" class="col-md-3 control-label checkbox ng-scope"><label class="ng-binding ng-scope"><input type="checkbox" ng-model="vm.alertMailFlg" ng-click="vm.storageCheck();">\u5199\u771F\u5BB9\u91CF\u8D85\u904E\u81EA\u52D5\u30E1\u30FC\u30EB\u901A\u77E5\u505C\u6B62</label></td></tr></table></div><div class="col-md-12"><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-11" style="padding-left: 0px"><strong class="h3" data-translate="storageManagement.home.priceTitle">priceTitle</strong></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-2 ow-pt-title"><div>Free</div><div class="ow-pt-subtitle">\u7D04500\u679A(0.5GB)</div></div><div class="col-md-2 ow-pt-title"><div>Lite</div><div class="ow-pt-subtitle">\u7D045,000\u679A(5GB)</div></div><div class="col-md-2 ow-pt-title"><div>Standard</div><div class="ow-pt-subtitle">\u7D0425,000\u679A(25GB)</div></div><div class="col-md-2 ow-pt-title"><div>Professional</div><div class="ow-pt-subtitle">\u7D04125,000\u679A(125GB)</div></div><div class="col-md-2 ow-pt-title"><div>Premium</div><div class="ow-pt-subtitle">\u7D04625,000\u679A(625GB)</div></div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-2 ow-pt-details"><div class="ow-pt-price">0</div><div class="ow-pt-per">\u5186/\u6708(\u7A0E\u629C)</div></div><div class="col-md-2 ow-pt-details"><div class="ow-pt-price">2,000</div><div class="ow-pt-per">\u5186/\u6708(\u7A0E\u629C)</div></div><div class="col-md-2 ow-pt-details"><div class="ow-pt-price">5,000</div><div class="ow-pt-per">\u5186/\u6708(\u7A0E\u629C)</div></div><div class="col-md-2 ow-pt-details"><div class="ow-pt-price">7,000</div><div class="ow-pt-per">\u5186/\u6708(\u7A0E\u629C)</div></div><div class="col-md-2 ow-pt-details"><div class="ow-pt-price">10,000</div><div class="ow-pt-per">\u5186/\u6708(\u7A0E\u629C)</div></div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-2 price-detail-1"><div class="price-detail">\u301C\u7D04500\u679A\u306E\u5199\u771F\u3092\u767B\u9332\u30FB\u5171\u6709\u3067\u304D\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-2"><div class="price-detail">\u301C\u7D045,000\u679A\u306E\u5199\u771F\u3092\u767B\u9332\u30FB\u5171\u6709\u3067\u304D\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-1"><div class="price-detail">\u301C\u7D0425,000\u679A\u306E\u5199\u771F\u3092\u767B\u9332\u30FB\u5171\u6709\u3067\u304D\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-2"><div class="price-detail">\u301C\u7D04125,000\u679A\u306E\u5199\u771F\u3092\u767B\u9332\u30FB\u5171\u6709\u30FB\u4FDD\u7BA1\u3067\u304D\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-1"><div class="price-detail">\u301C\u7D04625,000\u679A\u306E\u5199\u771F\u3092\u767B\u9332\u30FB\u5171\u6709\u30FB\u4FDD\u7BA1\u3067\u304D\u307E\u3059\u3002</div></div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-2 price-detail-3"><div class="price-detail">\u6642\u3005\u5229\u7528\u8005\u69D8\u306E\u72B6\u614B\u3092\u5199\u771F\u3092\u8A18\u9332\u3057\u305F\u3044\u5834\u5408\u306B\u3054\u5229\u7528\u3044\u305F\u3060\u3051\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-4"><div class="price-detail">\u5229\u7528\u8005\u657020\u4EBA\u4EE5\u4E0B\u306E\u5C0F\u898F\u6A21\u4E8B\u696D\u8005\u69D8\u306B\u304A\u3059\u3059\u3081\u3057\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-3"><div class="price-detail">\u5229\u7528\u8005\u657021\u301C99\u4EBA\u306E\u4E2D\u898F\u6A21\u4E8B\u696D\u8005\u69D8\u306B\u304A\u3059\u3059\u3081\u3057\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-4"><div class="price-detail">\u5229\u7528\u8005\u6570100\u4EBA\u4EE5\u4E0A\u306E\u5927\u898F\u6A21\u4E8B\u696D\u8005\u69D8\u306B\u304A\u3059\u3059\u3081\u3057\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-3"><div class="price-detail">\u4ECB\u8B77\u8A18\u9332\u3068\u4E00\u7DD2\u306B5\u5E74\u9593\u4FDD\u7BA1\u3057\u3066\u3082\u5341\u5206\u306A\u5BB9\u91CF\u3067\u3059\u3002</div></div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-2 price-detail-1"><div class="price-detail">\u4ECB\u8B77\u8A18\u9332\u3068\u540C\u6642\u306B\u5199\u771F\u3067\u5171\u6709\u3059\u308B\u3068\u3001\u60C5\u5831\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u304C\u697D\u306B\u306A\u308A\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-2"><div class="price-detail">\u6BCE\u65E5\u4ECB\u8B77\u8A18\u9332\u3068\u540C\u6642\u306B\u5199\u771F\u3092\u64AE\u3063\u3066\u3001\u3059\u3050\u306B\u60C5\u5831\u5171\u6709\u3067\u304D\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-1"><div class="price-detail">1\u4EBA1\u4EBA\u306E\u5229\u7528\u8005\u69D8\u306E\u72B6\u614B\u3068\u7B11\u9854\u3092\u3001\u5199\u771F\u3067\u8A18\u9332\u3057\u3001\u30B9\u30E0\u30FC\u30BA\u306B\u60C5\u5831\u5171\u6709\u3067\u304D\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-2"><div class="price-detail">\u4ECB\u8B77\u8A18\u9332\u3068\u540C\u6642\u306B\u5199\u771F\u3067\u5171\u6709\u3059\u308B\u3068\u3001\u60C5\u5831\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u304C\u697D\u306B\u306A\u308A\u307E\u3059\u3002</div></div><div class="col-md-2 price-detail-1"><div class="price-detail">\u4ECB\u8B77\u8A18\u9332\u3068\u5199\u771F\u3067\u304D\u3061\u3093\u3068\u30A8\u30D3\u30C7\u30F3\u30B9\u3068\u53D6\u3063\u3066\u3044\u308B\u306E\u306F\u3001\u3084\u306F\u308A\u5B89\u5FC3\uFF01</div></div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-2" style="text-align: center;padding-top: 20px;padding-bottom: 20px"><button ng-click="vm.goRule(0);" type="button" style="color: white;background-color: OliveDrab; width: 100px" class="btn btn-primary" data-translate="storageManagement.home.select">select</button></div><div class="col-md-2" style="text-align: center;padding-top: 20px;padding-bottom: 20px"><button ng-click="vm.goRule(1);" type="button" style="color: white;background-color: OliveDrab; width: 100px" class="btn btn-primary" data-translate="storageManagement.home.select">select</button></div><div class="col-md-2" style="text-align: center;padding-top: 20px;padding-bottom: 20px"><button ng-click="vm.goRule(2);" type="button" style="color: white;background-color: OliveDrab; width: 100px" class="btn btn-primary" data-translate="storageManagement.home.select">select</button></div><div class="col-md-2" style="text-align: center;padding-top: 20px;padding-bottom: 20px"><button ng-click="vm.goRule(3);" type="button" style="color: white;background-color: OliveDrab; width: 100px" class="btn btn-primary" data-translate="storageManagement.home.select">select</button></div><div class="col-md-2" style="text-align: center;padding-top: 20px;padding-bottom: 20px"><button ng-click="vm.goRule(4);" type="button" style="color: white;background-color: OliveDrab; width: 100px" class="btn btn-primary" data-translate="storageManagement.home.select">select</button></div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-10">\u203B \u4E8B\u696D\u6240\u756A\u53F7\u6BCE\u306E\u6599\u91D1\u3068\u306A\u308A\u307E\u3059\u3002\u6CD5\u4EBA\u3068\u306E\u5951\u7D04\u306B\u306A\u308B\u305F\u3081\u3001\u540C\u3058\u6CD5\u4EBA\u306B\u5C5E\u3057\u3066\u3044\u308B\u8907\u6570\u306E\u4E8B\u696D\u6240\u9593\u306F\u3001\u30B9\u30C8\u30EC\u30FC\u30B8\u5909\u66F4\u5BB9\u91CF\u3092\u5171\u7528\u3067\u304D\u307E\u3059\u3002</div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-10">\u4F8B\uFF09\u6CD5\u4EBAX\u306E\u4E0B\u306B3\u3064\u306E\u4E8B\u696D\u6240A,B,C\u304C\u3042\u308A\u3001Lite\u30D7\u30E9\u30F3\u30923\u3064\u5951\u7D04\u3057\u3066\u3044\u307E\u3059\u3002\u4E8B\u696D\u6240A\u306F8GB\u3001\u4E8B\u696D\u6240B\u306F2GB\u3001\u4E8B\u696D\u6240C\u306F3GB\u5229\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u3001\u5408\u8A08\u5229\u7528\u91CF13GB\u306F\u6CD5\u4EBA\u5168\u4F53\u306E\u30B9</div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-10">\u306E\u30B9\u30C8\u30EC\u30FC\u30B8\u5BB9\u91CF15GB\u3092\u8D85\u3048\u3066\u3044\u306A\u3044\u305F\u3081\u3001Lite\u30D7\u30E9\u30F3\u306E\u307E\u307E\u5229\u7528\u53EF\u80FD\u3067\u3059\u3002</div><div class="col-md-1"></div></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-10">\u203B \u30B1\u30A2\u6A39\u5199\u771F\u7BA1\u7406\u6A5F\u80FD\u306F\u300C\u5199\u771F\u5171\u6709\u300D\u3092\u76EE\u7684\u3068\u3059\u308B\u6A5F\u80FD\u3067\u3059\u3002\u5199\u771F\u4FDD\u7BA1\u3092\u3059\u308B\u305F\u3081\u306B\u3001\u5225\u9014\u5199\u771F\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u5F0A\u793E\u306F\u5199\u771F\u30D5\u30A1\u30A4\u30EB\u4FDD\u7BA1\u306B\u95A2\u3059\u308B\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002</div><div class="col-md-1"></div></div><div class="col-md-12" style="height: 15px"></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-10">\u3054\u5E0C\u671B\u306B\u6DFB\u3046\u30D7\u30E9\u30F3\u304C\u3054\u3056\u3044\u307E\u3057\u305F\u3089\u3001\u6700\u65B0\u7248\u306E\u300C\u30B1\u30A2\u6A39\u30B5\u30FC\u30D3\u30B9\u5229\u7528\u898F\u7D04\u300D\u3092\u3054\u78BA\u8A8D\u306E\u4E0A\u3001\u304A\u7533\u3057\u8FBC\u307F\u304F\u3060\u3055\u3044\u3002</div><div class="col-md-1"></div></div><div class="col-md-12" style="height: 15px"></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-10">\u203B\u5BB9\u91CF\u8FFD\u52A0\u304C\u6B63\u5E38\u306B\u7D42\u4E86\u5F8C\u3001\u65B0\u30D7\u30E9\u30F3\u306F\u3059\u3050\u306B\u3054\u5229\u7528\u3067\u304D\u307E\u3059\u3002\u6599\u91D1\u306E\u5FB4\u53CE\u306F\u7FCC\u6708\u306B\u306A\u308A\u307E\u3059\u304C\u3001\u5229\u7528\u6599\u91D1\u306E\u8A73\u7D30\u306F\u4E0A\u8A18\u306E\u5229\u7528\u898F\u7D04\u306B\u8A18\u8F09\u3057\u3066\u304A\u308A\u307E\u3059\u3002</div><div class="col-md-1"></div></div><div class="col-md-12" style="height: 15px"></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-10">\u3054\u4E0D\u660E\u306A\u70B9\u306A\u3069\u304C\u3054\u3056\u3044\u307E\u3057\u305F\u3089\u3001\u30B3\u30E1\u30F3\u30C8\u6B04\u3078\u304A\u6C17\u8EFD\u306B\u3054\u8A18\u5165\u304F\u3060\u3055\u3044\u3002</div><div class="col-md-1"></div></div><div class="col-md-12" style="height: 15px"></div><div class="col-md-12"><div class="col-md-1"></div><div class="col-md-10" style="color: red">\u203B Free\u30D7\u30E9\u30F3(0\u5186/\u6708)\u306E\u5834\u5408\u306F\u3001\u8FFD\u52A0\u8CBB\u7528\u767A\u751F\u3057\u307E\u305B\u3093\u306E\u3067\u3001\u7533\u8FBC\u307F\u9802\u304B\u306A\u304F\u3066\u3082\u3054\u5229\u7528\u3067\u304D\u307E\u3059\u3002</div><div class="col-md-1"></div></div><div class="col-md-12" style="height: 15px"></div><div class="col-md-12" style="padding-bottom: 20px"><div class="col-md-1"></div><div class="col-md-10"><button type="button" ng-click="vm.serviceTerms();" style="color: white;background-color: OliveDrab; width: 200px" class="btn btn-primary" data-translate="storageManagement.home.serviceTerms">serviceTerms</button></div><div class="col-md-1"></div></div></div></div></div>');
$templateCache.put('app/system/token-management/token-edit.html','<div><h4 data-translate="token.text.create">Create</h4><form class="form-horizontal" role="form" name="editForm"><div class="col-md-12 form-group"><div class="col-md-9" style="margin-left: 10px"><div class="col-md-12 form-group"><label class="col-md-4 control-label" data-translate="token.item.appName">App name</label><div class="col-md-8"><input class="form-control" type="text" name="appName" ng-model="vm.token.appName" required ng-maxlength="100"><div ng-show="editForm.appName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.appName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.appName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="col-md-12 form-group"><label class="col-md-4 control-label" data-translate="token.item.endDate">End date</label><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" id="endDate" name="endDate" enable-time="false" datetime-picker="yyyy/MM/dd" ng-model="vm.token.endDate" is-open="vm.isOpen" ng-pattern="/^[1-9][0-9][0-9][0-9]/((0[1-9])|(1[0-2]))/((0[1-9])|([1-2][0-9])|(3[0-1]))$/"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar()"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p><div ng-show="editForm.endDate.$invalid" class="has-error small"><p class="help-block" data-translate="entity.validation.dateformat">This field must be date format.</p></div></div></div></div><div class="col-md-2"><button type="button" class="btn btn-success col-md-12" style="height: 80px" ng-click="vm.save()" ng-disabled="editForm.$invalid" data-translate="global.button.publish">Publish</button></div></div></form><div style="clear: both"></div><h4 data-translate="token.text.list">List</h4><form class="form-horizontal" role="form"><input type="text" id="copyText" style="display: none"><div class="form-group" ng-if="vm.tokenList.length == 0"><div class="col-md-12" data-translate="token.text.noData"></div></div><div class="form-group" style="padding-left: 16px; padding-right: 16px" ng-if="vm.tokenList.length > 0"><div class="col-md-12 form-group" ng-repeat="token in vm.tokenList"><div class="col-md-9" style="border: solid 1px; margin-left: 10px; padding-top: 6px; padding-bottom: 6px"><div class="row" style="padding: 6px"><div class="col-md-4 text-right" data-translate="token.item.appName">App name</div><div class="col-md-8" ng-bind="token.appName"></div></div><div class="row" style="padding: 6px"><div class="col-md-4 text-right" data-translate="token.item.token">Token</div><div class="col-md-8" ng-bind="token.token" title="{{token.token}}" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis"></div></div><div class="row" style="padding: 6px"><div class="col-md-4 text-right" data-translate="token.item.endDate">End date</div><div class="col-md-8" ng-bind="token.endDate"></div></div></div><div class="col-md-2"><button type="button" class="btn btn-primary col-md-12" ng-click="vm.edit($index)" data-translate="global.button.edit">Edit</button> <button type="button" class="btn btn-success col-md-12" style="margin-top: 2px; margin-bottom: 2px" ng-click="vm.copy(token.token)" data-translate="token.button.copy">Copy</button> <button type="button" class="btn btn-danger col-md-12" ui-sref="token-delete({id: token.id})" data-translate="global.button.delete">Delete</button></div></div></div></form></div>');
$templateCache.put('app/system/token-management/token-shop.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-6 h2" data-translate="token.title.shop-index">Shop List</label></div><div class="form-group"><label class="col-md-2 control-label" data-translate="token.item.shopNm">Shop Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.shopNm"></div><label class="col-md-2 control-label" data-translate="token.item.tel">Tel</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.tel"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><table class="table table-striped table-hover"><colgroup><col width="20%"><col width="15%"><col width="15%"><col width="20%"><col width="20%"><col></colgroup><thead><tr><th data-translate="token.item.shopNm">Shop Name</th><th data-translate="token.item.tel">TEL</th><th data-translate="token.item.fax">FAX</th><th data-translate="token.item.branch">Branch</th><th data-translate="token.item.person">Person</th><th></th></tr></thead><tbody><tr ng-repeat="shop in vm.shopList"><td>{{shop.shopNm}}</td><td>{{shop.tel}}</td><td>{{shop.fax}}</td><td>{{shop.branch}}</td><td>{{shop.person}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ui-sref="token-shop.edit({id: shop.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button></div></td></tr></tbody></table><div class="text-center" ng-if="vm.shopList.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div>');
$templateCache.put('app/system/user-management/user-management-add-all-dialog.html','<div class="modal-body" ng-if="!vm.errorShow && vm.staffList.length > 0"><div class="form-group"><p class="text-center" data-translate="userManagement.addAll.info1"></p><p class="text-center" data-translate="userManagement.addAll.info2"></p><p class="text-center" data-translate="userManagement.addAll.info3"></p></div><div class="form-group"><table class="table table-striped table-hover table-bordered"><colgroup><col width="5%"><col width="12%"><col width="12%"><col width="17%"><col width="23%"><col width="12%"><col></colgroup><tr><th class="text-center"><input type="checkbox" ng-model="vm.checkAll" ng-click="vm.checkAllFun()"></th><th class="text-center" data-translate="userManagement.addAll.lastName"></th><th class="text-center" data-translate="userManagement.addAll.firstName"></th><th class="text-center" data-translate="userManagement.addAll.type"></th><th class="text-center" data-translate="userManagement.addAll.loginId"></th><th class="text-center" data-translate="userManagement.addAll.password"></th><th class="text-center" data-translate="userManagement.addAll.mail"></th></tr><tr ng-repeat="staff in vm.staffList"><td class="text-center"><input type="checkbox" ng-model="staff.checked" ng-click="vm.check($index)"></td><td class="text-center">{{staff.lastName}}</td><td class="text-center">{{staff.firstName}}</td><td class="text-center">{{staff.duty}}</td><td class="text-center">{{staff.loginId}}</td><td class="text-center">****</td><td class="text-center">{{staff.mail}}</td></tr></table></div><div class="form-group text-center"><button type="submit" class="btn btn-primary" data-translate="userManagement.addAll.btnSave" ng-click="vm.save()" ng-disabled="vm.noChecked"></button> <button type="button" class="btn btn-primary" data-translate="userManagement.addAll.btnCancel" ng-click="vm.cancel()"></button></div></div><div class="modal-body" ng-if="!vm.errorShow && vm.staffList.length == 0"><div class="form-group"><p class="text-center" data-translate="userManagement.addAll.errorNoData"></p></div><div class="form-group text-center"><button class="btn btn-primary" data-translate="userManagement.addAll.btnClose" ng-click="vm.cancel()"></button></div></div><div class="modal-body" ng-if="vm.errorShow"><div class="form-group"><p class="text-center" data-translate="userManagement.addAll.errorInfo"></p></div><div class="form-group"><table class="table table-striped table-hover table-bordered"><colgroup><col width="10%"><col width="10%"><col width="17%"><col width="20%"><col width="14%"><col></colgroup><tr><th class="text-center" data-translate="userManagement.addAll.lastName"></th><th class="text-center" data-translate="userManagement.addAll.firstName"></th><th class="text-center" data-translate="userManagement.addAll.type"></th><th class="text-center" data-translate="userManagement.addAll.loginId"></th><th class="text-center" data-translate="userManagement.addAll.mail"></th><th class="text-center" data-translate="userManagement.addAll.reason"></th></tr><tr ng-repeat="staff in vm.errorList"><td class="text-center">{{staff.lastName}}</td><td class="text-center">{{staff.firstName}}</td><td class="text-center">{{staff.duty}}</td><td class="text-center">{{staff.loginId}}</td><td class="text-center">{{staff.mail}}</td><td style="color: red; font-size: 85%"><span ng-if="staff.reason == 1" data-translate="userManagement.addAll.errorLoginId"></span> <span ng-if="staff.reason == 2" data-translate="userManagement.addAll.errorStaffId"></span> <span ng-if="staff.reason == 3" data-translate="userManagement.addAll.errorEmail"></span> <span ng-if="staff.reason != 1 && staff.reason != 2 && staff.reason != 3" data-translate="userManagement.addAll.errorOther"></span></td></tr></table></div><div class="form-group text-center"><button class="btn btn-primary" data-translate="userManagement.addAll.btnClose" ng-click="vm.cancel()"></button></div></div>');
$templateCache.put('app/system/user-management/user-management-createtoken.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="userManagement.token.title">userManagement show</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><input type="text" id="copyText" style="display: none"><div class="form-group"><div class="col-md-8" style="border: 1px solid black;width: 60%; height: 200px;margin-left: 50px"><label class="col-md-2 control-label" data-translate="userManagement.token.name" style="padding-left: 0px;padding-top:10px">Login</label><div class="col-md-2" style="overflow: auto; height: 200px;width: 80%;padding-top:10px;word-wrap:break-word;word-break:break-all">{{vm.token}}</div></div><div class="col-md-4"><div class="col-md-12" style="margin-top: 20px;padding-left: 0px;text-align: center" ng-show="vm.token == null"><button type="button" class="btn btn-primary" ng-click="vm.save()" style="width: 200px" data-translate="userManagement.token.createToken">createToken</button></div><div class="col-md-12" style="margin-top: 20px;padding-left: 0px;text-align: center" ng-show="vm.token != null"><button type="button" class="btn btn-primary" ng-click="vm.update()" style="width: 200px" data-translate="userManagement.token.createTokenAgain">createTokenAgain</button></div><div class="col-md-12" style="margin-top: 20px;padding-left: 0px;text-align: center" ng-show="vm.token == null"><button type="button" disabled="true" class="btn btn-success" ng-click="vm.copyToken(vm.token)" style="width: 200px" data-translate="userManagement.token.copyToken">copyToken</button></div><div class="col-md-12" style="margin-top: 20px;padding-left: 0px;text-align: center" ng-show="vm.token != null"><button type="button" class="btn btn-success" ng-click="vm.copyToken(vm.token)" style="width: 200px" data-translate="userManagement.token.copyToken">copyToken</button></div><div class="col-md-12" style="margin-top: 20px;padding-left: 0px;text-align: center" ng-show="vm.token == null"><button type="button" disabled="true" class="btn btn-danger" ng-click="vm.deleteToken(vm.token)" style="width: 200px" data-translate="userManagement.token.deleteToken">deleteToken</button></div><div class="col-md-12" style="margin-top: 20px;padding-left: 0px;text-align: center" ng-show="vm.token != null"><button type="button" class="btn btn-danger" ng-click="vm.deleteToken(vm.token)" style="width: 200px" data-translate="userManagement.token.deleteToken">deleteToken</button></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.close()" data-translate="entity.action.close">close</button></div>');
$templateCache.put('app/system/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/user-management/user-management-detail.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="userManagement.home.showLabel">userManagement show</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="form-group"><label class="col-md-3 control-label" data-translate="userManagement.login">Login</label><div class="col-md-9"><p class="form-control-static" ng-bind="vm.user.login"></p></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="userManagement.lastName">Last Name</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.user.lastName"></p></div><label class="col-md-3 control-label" data-translate="userManagement.firstName">First Name</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.user.firstName"></p></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="userManagement.seiKana">Sei Kana</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.user.seiKana"></p></div><label class="col-md-3 control-label" data-translate="userManagement.meiKana">Mei Kana</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.user.meiKana"></p></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="userManagement.email">Email</label><div class="col-md-9"><p class="form-control-static" ng-bind="vm.user.email"></p></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="userManagement.profiles">Profiles</label><div class="col-md-9" style="padding-top: 8px"><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities track by authority.name"><span>{{authority.nameDetail}}</span></li></ul></div><!--<div ng-if="vm.outletsShow">\n                <dt><span data-translate="userManagement.outlets.name">Shop name</span></dt>\n                <dd>{{vm.outlets.name}}</dd>\n                <dt><span data-translate="userManagement.outlets.tel">Shop telephone</span></dt>\n                <dd>{{vm.outlets.tel}}</dd>\n                <dt><span data-translate="userManagement.outlets.fax">Shop fax</span></dt>\n                <dd>{{vm.outlets.fax}}</dd>\n                <dt><span data-translate="userManagement.outlets.branch">Shop branch</span></dt>\n                <dd>{{vm.outlets.branch}}</dd>\n                <dt><span data-translate="userManagement.outlets.person">Shop person</span></dt>\n                <dd>{{vm.outlets.person}}</dd>\n            </div>--></div><div class="form-group"><label class="col-md-3 control-label" data-translate="userManagement.groupAuth">Group Auth</label><div class="col-md-9" style="padding-top: 8px"><ul class="list-unstyled"><li ng-repeat="group in vm.user.groupAuthes"><span>{{group.groupName}} \u306E {{group.groupAuth|translate}}</span></li></ul></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="userManagement.comment">Comment</label><div class="col-md-9"><p class="form-control-static" ng-bind="vm.user.comment"></p></div></div></form><!--\n    <button type="submit"\n            ui-sref="user-management"\n            class="btn btn-info">\n        <span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span>\n    </button>--></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.close()" data-translate="entity.action.close">close</button></div>');
$templateCache.put('app/system/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel" ng-if="vm.user.id != null">Edit a User</h4><h4 class="modal-title" id="myUserLabelAdd" data-translate="userManagement.home.createLabel" ng-if="vm.user.id == null">Create a User</h4></div><div class="modal-body"><!--<jhi-alert-error></jhi-alert-error>--><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" ng-change="vm.loginMouseleave();" ng-blur="vm.loginMouseleave();"><div ng-show="editForm.login.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.login.$error.pattern" data-translate="entity.validation.pattern.num-letter-symbol">This field\'s type is not correct.</p></div><div ng-show="vm.exist"><p class="help-block" style="color: #a94442;font-size: 85%" data-translate="userManagement.validation.loginExist"></p></div></div><div class="form-group" ng-if="vm.user.id == null || vm.user.id == \'\' "><label class="control-label" data-translate="userManagement.password">Password</label><input type="text" class="form-control" ng-model="vm.password" ng-maxlength="50" ng-minlength="6" name="password" required><div ng-show="editForm.password.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength6">Your password is required to be at least 6 characters.</p><p class="help-block" ng-show="editForm.password.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.password.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6"><div class="form-group"><label data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label data-translate="userManagement.seiKana">Sei Kana</label><input type="text" class="form-control" kata-kana name="seiKana" ng-model="vm.user.seiKana" ng-maxlength="50"><div ng-show="editForm.seiKana.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.seiKana.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="col-md-6"><div class="form-group"><label data-translate="userManagement.meiKana">Mei Kana</label><input type="text" class="form-control" kata-kana name="meiKana" ng-model="vm.user.meiKana" ng-maxlength="50"><div ng-show="editForm.meiKana.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.meiKana.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" ng-maxlength="100" ng-change="vm.emailMouseleave()" ng-blur="vm.emailMouseleave()"><div ng-show="editForm.email.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div><div ng-show="vm.existEmail"><p class="help-block" style="color: #a94442;font-size: 85%" data-translate="userManagement.validation.emailExist"></p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label><!--<label for="created" class="col-md-9">--><!--<input type="checkbox" id="created" ng-model="vm.user.created">--><!--<span data-translate="userManagement.created">Created</span>--><!--</label>--></div><!--<div class="form-group">\n            <label data-translate="userManagement.langKey">Lang Key</label>\n            <select class="form-control" name="langKey" ng-model="vm.user.langKey"\n                    ng-options="language as language for language in vm.languages track by language">\n            </select>\n        </div>--><div class="form-group"><div><label data-translate="userManagement.profiles">Profiles</label></div><!--<label style="margin-right: 40px;" class="ng-binding ng-scope">\n                <input type="checkbox" ng-model="vm.user.authorities" ng-checked="vm.user.authorities == \'ROLE_ADMIN\'" ng-click="vm.changeAu(\'ROLE_ADMIN\', $event)" >{{\'ROLE_ADMIN\' | translate}}\n            </label>--><div class="col-md-3 control-label checkbox ng-scope" ng-repeat="role in vm.user.roleList" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;margin-top: -5px" title="{{role.nameDetail}}"><label class="ng-binding ng-scope"><input type="checkbox" ng-disabled="role.disabled" ng-model="role.checked" ng-checked="role.checked" ng-click="vm.changeAu(role.name,role.checked, $event)">{{role.nameDetail}}</label></div></div><div style="clear: both"></div><div has-authority="ROLE_ADMIN" ng-if="vm.showShop"><div class="form-group"><label data-translate="userManagement.outlets.name">Shop name</label><input type="text" class="form-control" name="slName" ng-model="vm.outlets.name" ng-maxlength="100"><div ng-show="editForm.slName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.slName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.outlets.tel">Shop telephone</label><input type="tel" class="form-control" name="slTel" ng-model="vm.outlets.tel" ng-maxlength="10" ng-pattern="/\\d{10}/"><div ng-show="editForm.slTel.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.slTel.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p><p class="help-block" ng-show="editForm.slTel.$error.pattern" data-translate="entity.validation.tel">This field must be TEL type.</p></div></div><div class="form-group"><label data-translate="userManagement.outlets.fax">Shop fax</label><input type="tel" class="form-control" name="slFax" ng-model="vm.outlets.fax" ng-maxlength="10" ng-pattern="/\\d{10}/"><div ng-show="editForm.slFax.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.slFax.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p><p class="help-block" ng-show="editForm.slFax.$error.pattern" data-translate="entity.validation.fax">This field must be FAX type.</p></div></div><div class="form-group"><label data-translate="userManagement.outlets.branch">Shop branch</label><input type="text" class="form-control" name="slBranch" ng-model="vm.outlets.branch" ng-maxlength="20"><div ng-show="editForm.slBranch.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.slBranch.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.outlets.person">Shop person</label><input type="text" class="form-control" name="slPerson" ng-model="vm.outlets.person" ng-maxlength="20"><div ng-show="editForm.slPerson.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.slPerson.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div></div><div class="form-group"><label data-translate="userManagement.groups">Groups</label><button type="button" class="btn btn-default right" data-dismiss="modal" ng-click="vm.addGroup()" data-translate="entity.action.add">Add</button><div class="row" style="margin-top: 6px" ng-repeat="ga in vm.user.groupAuthes" ng-if="vm.getGroupShow(ga.groupId)"><div class="col-md-6"><select class="form-control" name="group" ng-model="ga.groupId" ng-change="vm.changeGroup($index)" ng-options="group.id as (group.name + group.serviceTypeName) for group in vm.groups"></select></div><div class="col-md-4"><select class="form-control" ng-model="ga.groupAuth" ng-change="vm.changeAuth()" ng-if="ga.groupId != null" ng-options="groupAuth | translate for groupAuth in vm.auths"></select></div><div class="col-md-2"><button type="button" class="btn btn-danger" data-translate="entity.action.delete" ng-click="vm.delGroup($index)">Delete</button></div></div><div ng-show="vm.repeatFlg" class="has-error small"><p class="help-block" data-translate="userManagement.error.repeat">Groups are repeated;</p></div><div ng-show="vm.parentErrorFlg" class="has-error small"><p class="help-block" data-translate="userManagement.error.parentErrorFlg">Groups are repeated;</p></div></div><div class="form-group" has-any-authority="ROLE_TIMECARD"><label class="control-label" data-translate="userManagement.hourSalary">Salary</label><input type="number" class="form-control" name="hourSalary" ng-model="vm.user.option.hourSalary"><div ng-show="editForm.hourSalary.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.hourSalary.$error" data-translate="global.messages.validate.hourSalary.invalid">Your Salary is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.comment">Comment</label><textarea class="form-control" ng-model="vm.user.comment"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving || vm.repeatFlg || (!vm.isAdmin && vm.hasAdmin) || vm.existButton || vm.existEmailButton || vm.parentErrorFlg" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/system/user-management/user-management-update-all.html','<div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><h4><span data-translate="userManagement.updateAll.title"></span></h4><div class="row" style="margin-bottom: 15px" ng-switch="vm.saved"><div class="col-md-12" ng-switch-when="true"><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button><div class="pull-right"><button type="button" class="btn btn-danger pull-right" ng-click="vm.print()">\u5370\u5237</button></div></div><div class="col-md-12" ng-switch-when="false"><button type="button" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button><div class="pull-right"><button type="submit" class="btn btn-success" data-translate="entity.action.save" ng-click="vm.save()" ng-disabled="vm.saveFlag">\u4FDD\u5B58</button></div></div></div><div ng-switch="vm.saved"><div ng-switch-when="false"><table class="table table-bordered table-striped table-condensed table-hover"><colgroup><col width="10%"><col width="20%"><col width="15%"></colgroup><thead><tr><td class="text-center">ID</td><td class="text-center">\u540D \u524D</td><td class="text-center">\u30D1\u30B9\u30EF\u30FC\u30C9</td></tr></thead><tr ng-repeat="user in vm.users"><td class="text-left" style="vertical-align: middle"><span>{{user.id}}</span></td><td class="text-left" style="vertical-align: middle"><span>{{user.lastName}} {{user.firstName}}</span></td><td class="text-center"><input type="text" ng-model="user.password" ng-change="vm.changePw(user)"><div ng-show="user.errorFlag" class="has-error small"><p class="help-block" ng-show="user.minFlag" data-translate="global.messages.validate.newpassword.minlength6">Your password is required to be at least 6 characters.</p><p class="help-block" ng-show="user.maxFlag" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="user.requiredFlag" data-translate="global.messages.validate.newpassword.password">Your password is required.</p></div></td></tr></table></div><div ng-switch-when="true"><div class="text-center"><span>\u4E00\u62EC\u8A2D\u5B9A\u3057\u307E\u3057\u305F\u3002<br></span><span>\u8A2D\u5B9A\u3057\u305F\u60C5\u5831\u3092\u5370\u5237\u3057\u307E\u3059\u304B\uFF1F<br></span><span>\uFF08\u5370\u5237\u306F\uFF11\u56DE\u306E\u307F\uFF09</span></div><table class="table table-bordered table-striped table-condensed"><colgroup><col width="10%"><col width="20%"><col width="15%"></colgroup><tr><td class="text-center">ID</td><td class="text-center">\u540D \u524D</td><td class="text-center">\u30D1\u30B9\u30EF\u30FC\u30C9</td></tr><tr ng-repeat="user in vm.printData"><td class="text-left" style="vertical-align: middle"><span>{{user.id}}</span></td><td class="text-left" style="vertical-align: middle"><span>{{user.name}}</span></td><td class="text-center"><span>{{user.password}}</span></td></tr></table></div></div></div>');
$templateCache.put('app/system/user-management/user-management.html','<div><form id="searchHeight" class="form-horizontal" role="form"><div class="form-group" style="margin-bottom: 10px"><label style="margin-top: 0px; margin-bottom: 0px" class="col-md-6 h2" data-translate="userManagement.home.title">Users</label><div style="margin-top: 0px; margin-bottom: 0px" class="col-md-6 text-right button-add" ng-if="vm.version == 2"><button type="button" ng-click="vm.gotoUpdateAll()" class="btn btn-primary" data-translate="userManagement.home.updateAll" has-group-auth="admin"></button> <button type="button" class="btn btn-primary" ng-click="vm.goNew()" data-translate="userManagement.home.createLabel">Add</button></div></div><div ng-if="vm.version == 2" class="form-group"><label class="col-md-1 control-label searchOne" data-translate="userManagement.login">Login ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.loginId"></div><label class="col-md-2 control-label searchTwo" data-translate="userManagement.name">Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div><label class="col-md-2 control-label searchTwo" data-translate="userManagement.mailAddress">Mail Address</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.mailAddress"></div></div><div ng-if="vm.version == 2" class="form-group"><label class="col-md-1 control-label searchOne" data-translate="userManagement.groups">Groups</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.selectGroupNm" ng-change="vm.inputGroupNm()"><ul class="dropdown-menu" uib-dropdown-menu style="display: block;margin-left:12px; margin-right:12px" ng-show="vm.groupSelectListShowFlg"><li ng-repeat="pg in vm.parentGroup" ng-show="pg.showFlg" ng-click="vm.clickGroupListClick(pg)"><a>{{pg.name}}{{pg.serviceTypeName}}</a></li></ul></div><label has-any-authority="ROLE_ADMIN" class="col-md-2 control-label searchTwo" data-translate="userManagement.authorities">Authorities</label><div has-any-authority="ROLE_ADMIN" class="col-md-2"><select class="form-control" ng-change="vm.changeauthorities()" ng-model="vm.searchData.authorities" ng-options="sa.name as sa.nameDetail for sa in vm.systemAuthorities"></select></div><label has-any-authority="ROLE_ADMIN" class="col-md-2 control-label searchTwo" data-translate="userManagement.version">Version</label><div has-any-authority="ROLE_ADMIN" class="col-md-2"><label class="radio-inline"><input type="radio" ng-model="vm.version" name="version" value="2" ng-change="vm.changeVersion(2)"><span data-translate="userManagement.two">2.0</span></label><label class="radio-inline"><input type="radio" ng-model="vm.version" name="version" value="1" ng-change="vm.changeVersion(1)"><span data-translate="userManagement.one">1.0</span></label></div></div><div ng-if="vm.version == 2" class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary search-button" ng-click="vm.search()" style="width: 100px;height: 40px"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default clear-button" ng-click="vm.clear()" style="margin-left: 30px;width: 100px;height: 40px"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div><div ng-if="vm.version == 1" class="form-group"><label class="col-md-1 control-label searchOne" data-translate="userManagement.staff.name">Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.staff.name"></div><label class="col-md-2 control-label searchTwo" data-translate="userManagement.staff.staffId">Staff ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.staff.id"></div><label class="col-md-2 control-label searchTwo" data-translate="userManagement.staff.login">Login</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.staff.login"></div></div><div ng-if="vm.version == 1" class="form-group"><label class="col-md-1 control-label searchOne" data-translate="userManagement.staff.houjinNm">Staff Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.staff.houjinNm"></div><label class="col-md-2 control-label searchTwo" data-translate="userManagement.staff.jigyoushoNm">Jigyousho Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.staff.jigyoushoNm"></div><label has-any-authority="ROLE_ADMIN" class="col-md-2 control-label searchTwo" data-translate="userManagement.version">Version</label><div has-any-authority="ROLE_ADMIN" class="col-md-2"><label class="radio-inline"><input type="radio" ng-model="vm.version" name="version" value="2" ng-change="vm.changeVersion(2)"><span data-translate="userManagement.two">2.0</span></label><label class="radio-inline"><input type="radio" ng-model="vm.version" name="version" value="1" ng-change="vm.changeVersion(1)"><span data-translate="userManagement.one">1.0</span></label></div></div><div ng-if="vm.version == 1" class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary search-button" ng-click="vm.changeVersion(1)" style="width: 100px;height: 40px"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default clear-button" ng-click="vm.clearStaff()" style="margin-left: 30px;width: 100px;height: 40px"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr style="margin-bottom: 0px;margin-top: 0px"><div class="row"><div ng-class="{true:\'col-md-10\',false:\'col-md-12\'}[vm.selectedUser.length > 0]"><div class="table-responsive"><table id="headerHeight2" class="jh-table table table-striped table-hover" ng-if="vm.version == 2" style="table-layout: fixed;margin-bottom: 0px"><colgroup><col width="4%"><col width="4%"><col width="11%"><col width="15%"><col width="8%"><col width="10%"><col width="23%"><col width="25%"></colgroup><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.loadAll()"><th><span>\u9078\u629E</span></th><th jh-sort-by="mu.id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mu.login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mu.last_name"><span data-translate="userManagement.name">name</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mu.activated"><span data-translate="userManagement.activat">activat</span><span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th><span data-translate="userManagement.groupAuth">GroupAuth</span></th><th></th></tr></thead></table><div style="overflow: auto" id="tableDiv2"><table style="table-layout: fixed;margin-bottom: 0px" class="jh-table table table-striped table-hover" ng-if="vm.version == 2"><colgroup><col width="4%"><col width="4%"><col width="11%"><col width="15%"><col width="8%"><col width="10%"><col width="23%"><col width="25%"></colgroup><tbody><tr ng-repeat="user in vm.users track by user.id"><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><input type="checkbox" name="selectedUser" ng-checked="vm.isChecked(user)" ng-click="vm.select(user)" ng-disabled="user.hasAdmin && !vm.isAdmin"></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><a ui-sref="user-management.show({login:user.login})">{{user.id}}</a></td><td title="{{user.login}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{user.login}}</td><td title="{{user.lastName}} {{user.firstName}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{user.lastName}} {{user.firstName}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><span ng-show="user.activated" data-translate="userManagement.activatedShow">activated</span> <span ng-show="!user.activated" data-translate="userManagement.deactivatedShow">deactivated</span></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div ng-repeat="authority in user.authorities track by authority.name" style="color: #fff;text-overflow: ellipsis;overflow: hidden;white-space: nowrap"><span class="label label-info" title="{{authority.nameDetail}}">{{authority.nameDetail}}</span></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}"><div ng-repeat="group in user.groupAuthes" style="color: #fff;text-overflow: ellipsis;overflow: hidden;white-space: nowrap"><span title="{{group.groupName}}\u3000\u306E\u3000{{group.groupAuth|translate}}" class="label label-info">{{group.groupName}}\u3000\u306E\u3000{{group.groupAuth|translate}}</span></div></td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management.show({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ng-click="vm.goEdit(user.login)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ng-click="vm.goDel(user.login)" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login || (user.hasAdmin && !vm.isAdmin)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button>&nbsp; <button type="submit" ng-disabled="user.tokenFlag" ui-sref="user-management.createToken({login:user.login})" class="btn btn-warning btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="userManagement.home.token"></span></button></div></td></tr></tbody></table></div><table id="headerHeight1" class="jh-table table table-striped table-hover" ng-if="vm.version == 1" style="table-layout: fixed;margin-bottom: 0px"><colgroup><col width="12%"><col width="12%"><col width="12%"><col width="12%"><col width="12%"><col width="20%"><col width="20%"></colgroup><thead><tr><th data-translate="userManagement.staff.name"></th><th data-translate="userManagement.staff.shokushu"></th><th data-translate="userManagement.staff.staffId"></th><th data-translate="userManagement.staff.login"></th><th data-translate="userManagement.staff.houjinNm"></th><th data-translate="userManagement.staff.jigyoushoNm"></th><th></th></tr></thead></table><div style="overflow: auto" id="tableDiv1"><table class="jh-table table table-striped table-hover" ng-if="vm.version == 1" style="table-layout: fixed;margin-bottom: 0px"><colgroup><col width="12%"><col width="12%"><col width="12%"><col width="12%"><col width="12%"><col width="20%"><col width="20%"></colgroup><tbody><tr ng-repeat="staff in vm.staffList"><td title="{{staff.name}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{staff.name}}</td><td title="{{staff.shokushu}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{staff.shokushu}}</td><td title="{{staff.staffId}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{staff.staffId}}</td><td title="{{staff.login}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{staff.login}}</td><td title="{{staff.houjinNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{staff.houjinNm}}</td><td title="{{staff.jigyoushoNm}}" style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}">{{staff.jigyoushoNm}}</td><td style="border-top:{{$index == 0 ? \'0px\' : \'1px solid #ddd\'}}" class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ui-sref="user-management.createToken({jigyoushoCd: staff.jigyoushoCd, login:staff.login})" class="btn btn-warning btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="userManagement.home.token"></span></button></div></td></tr></tbody></table></div><div id="pageHeight" style="margin-top: 20px" class="text-center" ng-if="vm.totalItems > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination style="margin-bottom: 10px;margin-top: 10px" class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.changePage()"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.totalItems == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div></div><div ng-class="{true:\'col-md-2\',false:\'hidden\'}[vm.selectedUser.length > 0]"><ul class="list-inline"><li ng-repeat="user in vm.selectedUser" style="width:130px;margin-top: 10px"><span class="glyphicon glyphicon-user"></span> <span style="font-size:18px">{{user.userName}}</span></li></ul></div></div></div>');
$templateCache.put('app/system/variable/variable.html','<div><h2 translate="variable.home.title">Variable</h2><div class="row"><div class="col-md-8"><label translate="variable.home.select">Select</label><div class="btn-group" uib-dropdown><button id="split-button" type="button" class="btn btn-info" uib-dropdown-toggle><span class="hidden-xs hidden-sm">{{vm.itemType.name}}</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li ng-repeat="vs in vm.variables"><a ng-click="vm.changeType(vs.code)">{{vs.name}}</a></li></ul></div></div><div class="col-md-4 text-right"><button class="btn btn-primary" ui-sref="variable.new({itemType: vm.itemType.code})"><span class="glyphicon glyphicon-flash"></span> <span translate="variable.home.create">Create a new Variable</span></button></div></div><div class="table-responsive"><table class="table table-striped" ng-if="vm.itemType.code != \'3\'"><colgroup><col width="40%"><col width="50%"><col width="10%"></colgroup><thead><tr><th translate="variable.title.itemCode">Variable Code</th><th translate="variable.title.itemValue">Variable Value</th><th translate="variable.title.controller"></th></tr></thead><tbody><tr ng-repeat="variable in vm.variableList"><td>{{variable.itemCode}}</td><td>{{variable.itemValue}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ui-sref="variable.edit({id: variable.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button> <button type="button" ui-sref="variable.delete({id: variable.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete">Delete</span></button></div></td></tr></tbody></table><table class="table table-striped" ng-if="vm.itemType.code == \'3\'"><colgroup><col width="20%"><col width="30%"><col width="40%"><col width="10%"></colgroup><thead><tr><th translate="variable.title.itemCode">Variable Code</th><th translate="variable.title.itemValue">Variable Value</th><th translate="variable.title.thumb">Thumbnail</th><th translate="variable.title.controller">Controller</th></tr></thead><tbody><tr ng-repeat="variable in vm.variableList"><td>{{variable.itemCode}}</td><td>{{variable.itemValue}}</td><td><img style="max-width: 100%; max-height: 160px" ng-src="{{vm.url}}/library/api/library/file/name/{{variable.id}}/2" onerror="this.remove()" ui-sref="variable.edit({id: variable.id})"></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="variable.edit({id: variable.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button> <button type="submit" ui-sref="variable.delete({id: variable.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete">Delete</span></button></div></td></tr></tbody></table></div><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadVariableList()"></uib-pagination></div></div>');
$templateCache.put('app/timecard/group-option/group-option.html','<div ng-cloak><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><h4>\u30B0\u30EB\u30FC\u30D7\u30AA\u30D7\u30B7\u30E7\u30F3\u8A2D\u5B9A</h4><div class="row" style="margin-bottom: 15px"><div class="col-md-3"></div><div class="col-md-9"><div class="pull-right"><button type="button" class="btn btn-success" data-translate="entity.action.save" ng-click="vm.save()" ng-disabled="detail.$invalid">\u4FDD\u5B58</button></div></div></div><hr><form name="editForm" role="form" novalidate ng-submit="vm.save()" style="margin-top:20px"><table class="table table-bordered table-striped table-condensed"><colgroup><col width="8%"><col width="8%"><col width="8%"><col width="10%"><col width="10%"><col width="10%"></colgroup><tr><td class="text-center">\u30B0\u30EB\u30FC\u30D7\u540D</td><td class="text-center">\u30B0\u30EB\u30FC\u30D7\u30B3\u30FC\u30C9</td><td class="text-center">\u6253\u523B\u3059\u308B\u6642\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u8981\u6C42</td><td class="text-center">\u6253\u523B\u6642\u9593\u306E\u4E38\u3081\u51E6\u7406</td><td class="text-center">\u4F11\u61A9\u6642\u9593\u8A08\u7B97</td><td class="text-center">\u52E4\u52D9\u5831\u544A\u66F8\u540D</td></tr><tr ng-repeat="groupOption in vm.groupOptions"><td class="text-left" style="vertical-align: middle"><span>{{groupOption.groupName}}</span></td><td class="text-center"><input type="text" class="form-control" ng-model="groupOption.groupCode"></td><td class="text-left"><label style="margin-left:5px"><input type="radio" ng-model="groupOption.passwordRequired" ng-value="true"> \u3059\u308B</label><label style="margin-left:5px"><input type="radio" ng-model="groupOption.passwordRequired" ng-value="false"> \u3057\u306A\u3044</label></td><td class="text-left"><label style="margin-left:5px"><input type="radio" ng-model="groupOption.timeRound" ng-value="0"> \u306A\u3057</label><label style="margin-left:5px"><input type="radio" ng-model="groupOption.timeRound" ng-value="5"> 5\u5206\u5358\u4F4D</label><label style="margin-left:5px"><input type="radio" ng-model="groupOption.timeRound" ng-value="10"> 10\u5206\u5358\u4F4D</label><label style="margin-left:5px"><input type="radio" ng-model="groupOption.timeRound" ng-value="30"> 30\u5206\u5358\u4F4D</label></td><td class="text-left"><label style="margin-left:5px"><input type="radio" ng-model="groupOption.restTime" ng-value="1"> \u81EA\u52D5\u8A08\u7B97</label><label style="margin-left:5px"><input type="radio" ng-model="groupOption.restTime" ng-value="2">\u5916\u51FA\u30FB\u518D\u5165\u3092\u57FA\u3044\u3066\u8A08\u7B97</label></td><td class="text-left"><input type="text" class="form-control" ng-model="groupOption.reportName"></td></tr></table></form></div>');
$templateCache.put('app/timecard/monthshift-time/monthshift-time-detail.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><h4>\u30B7\u30D5\u30C8\u52E4\u52D9\u6642\u9593\u5E2F\u7BA1\u7406</h4><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-3"><button type="button" class="btn btn-success" data-translate="shifttime.currentMonth" ng-click="vm.rest()">\u4ECA\u6708</button> <button type="button" class="btn btn-info" data-translate="shifttime.beforeMonth" ng-click="vm.beforeMonth()"></button> <button type="button" class="btn btn-info" data-translate="shifttime.nextMonth" ng-click="vm.nextMonth()"></button> <span style="margin-left:20px" class="text-primary"><strong>{{vm.currentYear}}\u5E74{{vm.currentMonth}}\u6708</strong></span></div><div class="col-md-4" style="text-align: center"><label style="margin-top:5px"><input type="radio" ng-model="vm.state" ng-value="1" ng-change="vm.changeState();"> \u6709\u52B9\u306E\u307F</label><label style="margin-left:10px;margin-top:5px"><input type="radio" ng-model="vm.state" ng-value="0" ng-change="vm.changeState();"> \u5168\u8868\u793A</label></div><div class="col-md-2"><div class="pull-right"><button type="submit" class="btn btn-success" data-translate="entity.action.save" ng-disabled="vm.timeType || editForm.$invalid || vm.codeSaveFlag || vm.nameSaveFlag" ng-show="!vm.selectGroupFlag">\u4FDD\u5B58</button> <button ng-show="!vm.parentFlag" type="button" class="btn btn-danger" data-translate="entity.action.reloadHoujinTimeZone" ng-click="vm.reloadHoujinTimeZone()" ng-disabled="detail.$invalid">\u30B7\u30D5\u30C8\u6642\u9593\u5E2F\u518D\u53D6\u5F97</button></div></div></div><div ng-show="vm.timeZoneIsNullFlag"><font color="red">\u6CE8\uFF1A\u672C\u90E8\u30B7\u30D5\u30C8\u6642\u9593\u5E2F\u8A2D\u5B9A\u3092\u8AAD\u307F\u8FBC\u307F\u3057\u307E\u3057\u305F\u3001\u8A72\u5F53\u4E8B\u696D\u6240\u306E\u6642\u9593\u5E2F\u3092\u8A2D\u5B9A\u3057\u3066\u304B\u3089\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002</font></div><table class="table table-bordered table-striped table-condensed"><colgroup><col width="10%"><col width="10%"><col width="15%"><col width="10%"><col width="10%"><col width="10%"></colgroup><tr><td class="text-center">\u6642\u9593\u5E2F\u30B3\u30FC\u30C9</td><td class="text-center">\u6642\u9593\u5E2F\u540D</td><td class="text-center">\u6642\u9593\u5E2F</td><td class="text-center">\u4F11\u61A9\u6642\u9593</td><td class="text-center">\u6709\u52B9</td><td class="text-center" ng-show="!vm.selectGroupFlag"></td></tr><tr ng-repeat="shiftTimeZone in vm.resultList" style="height: 42px" ng-class="!shiftTimeZone.state ? \'grey\' : \'\'"><td class="text-left" style="vertical-align: middle"><input ng-show="!shiftTimeZone.showFlag" type="text" class="form-control" ng-model="shiftTimeZone.code" ng-change="vm.codeUniqueCheck(shiftTimeZone, $index)"> <span ng-show="shiftTimeZone.showFlag">{{shiftTimeZone.code}}</span><div ng-show="shiftTimeZone.codeRequiredFlag || shiftTimeZone.codeMaxlengthFlag" class="has-error small"><p class="help-block" ng-show="shiftTimeZone.codeRequiredFlag" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="shiftTimeZone.codeMaxlengthFlag" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div><div ng-show="shiftTimeZone.codeSingleFlag"><font color="#a94442" style="font-size: 85%">\u8BE5\u5F53\u6642\u9593\u5E2F\u30B3\u30FC\u30C9\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059</font></div></td><td class="text-left" style="vertical-align: middle"><input ng-show="!shiftTimeZone.showFlag" type="text" class="form-control" ng-model="shiftTimeZone.name" ng-change="vm.nameUniqueCheck(shiftTimeZone, $index)"> <span ng-show="shiftTimeZone.showFlag">{{shiftTimeZone.name}}</span><div ng-show="shiftTimeZone.nameRequiredFlag || shiftTimeZone.nameMaxlengthFlag" class="has-error small"><p class="help-block" ng-show="shiftTimeZone.nameRequiredFlag" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="shiftTimeZone.nameMaxlengthFlag" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div><div ng-show="shiftTimeZone.nameSingleFlag"><font color="#a94442" style="font-size: 85%">\u8BE5\u5F53\u6642\u9593\u5E2F\u540D\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059</font></div></td><td class="text-left" style="vertical-align: middle"><div class="input-group" style="float: left;width: 150px" ng-show="!shiftTimeZone.showFlag"><span class="input-group-addon"><i class="glyphicon glyphicon-time"></i> </span><input class="form-control" placeholder="_ _:_ _" maxlength="5" id="startTime{{$index}}" time-format-zen-to-han ng-class="{\'time-format-error\': shiftTimeZone.startTimeError}" ng-model="shiftTimeZone.startTime" ng-blur="vm.startTimeUpdate(shiftTimeZone, $index, vm.resultList)"></div><div ng-show="shiftTimeZone.showFlag" style="float: left"><span>{{shiftTimeZone.startTime}}</span></div><div style="float: left">&nbsp;&nbsp;~&nbsp;&nbsp;</div><div class="input-group" style="float: left;width: 150px" ng-show="!shiftTimeZone.showFlag"><span class="input-group-addon"><i class="glyphicon glyphicon-time"></i> </span><input class="form-control" placeholder="_ _:_ _" maxlength="5" id="endTime{{$index}}" time-format-zen-to-han ng-class="{\'time-format-error\': shiftTimeZone.endTimeError}" ng-model="shiftTimeZone.endTime" ng-blur="vm.endTimeUpdate(shiftTimeZone, $index, vm.resultList)"></div><div ng-show="shiftTimeZone.showFlag" style="float: left"><span>{{shiftTimeZone.endTime}}</span></div><div ng-show="shiftTimeZone.showFlag" style="float: left; padding-left: 10px"><span>({{shiftTimeZone.differenceTime}})</span></div></td><td class="text-left" style="vertical-align: middle"><input name="restTime{{$index}}" number-format-zen-to-han ng-show="!shiftTimeZone.showFlag" id="restTime{{$index}}" type="text" maxlength="6" placeholder="{{\'shifttime.form.restTime\' | translate}}" ng-model="shiftTimeZone.restTime" ng-class="{\'time-format-error\': shiftTimeZone.restTimeError}" ng-blur="vm.restTimeUpdate(shiftTimeZone, $index, vm.resultList)"> <span ng-show="shiftTimeZone.showFlag">{{shiftTimeZone.restTime}}</span></td><td class="text-center" style="vertical-align: middle"><label style="margin-top:5px"><input type="radio" ng-model="shiftTimeZone.state" ng-value="1"> \u6709\u52B9</label><label style="margin-left:10px;margin-top:5px"><input type="radio" ng-model="shiftTimeZone.state" ng-value="0"> \u7121\u52B9</label></td><td ng-show="!vm.selectGroupFlag" class="text-center"><button type="button" ng-show="shiftTimeZone.id != null && shiftTimeZone.showFlag" ng-click="vm.goEdit(shiftTimeZone)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="button" ng-show="shiftTimeZone.id != null && !shiftTimeZone.showFlag" ng-click="vm.goCancel(shiftTimeZone, $index)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.cancel"></span></button> <button type="button" ng-click="vm.goAdd($index)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.addRow"></span></button> <button ng-show="shiftTimeZone.id == null" type="button" ng-click="vm.goDel($index)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.deleteRow"></span></button></td></tr></table></div><style type="text/css">.grey{\n            background-color: #BEBEBE !important;\n        }</style></form>');
$templateCache.put('app/timecard/option-user/option-user-detail.html','<div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><h4>\u30E6\u30FC\u30B6\u30FC\u30AA\u30D7\u30B7\u30E7\u30F3\u8A2D\u5B9A</h4><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-9"><div class="pull-right"><button type="button" class="btn btn-success" data-translate="entity.action.save" ng-click="vm.save()" ng-disabled="detail.$invalid">\u4FDD\u5B58</button></div></div></div><table class="table table-bordered table-striped table-condensed"><colgroup><col width="10%"><col width="10%"><col width="10%"><col width="10%"><col width="10%"><col width="10%"><col width="10%"><col width="10%"><col width="10%"></colgroup><tr><td class="text-center">\u540D \u524D</td><td class="text-center">\u5F93\u696D\u54E1\u30B3\u30FC\u30C9</td><td class="text-center">\u7D66\u4E0E\u533A\u5206</td><td class="text-center">\u6642\u7D66\u984D</td><td class="text-center">\u696D\u52D9\u624B\u5F53</td><td class="text-center">\u901A\u52E4\u624B\u5F53</td><td class="text-center">\u6253\u523B\u5BFE\u8C61\u5916</td><td class="text-center">\u8A2A\u554F\u6253\u523B</td><td class="text-center">\u8077\u7A2E</td></tr><tr ng-repeat="user in vm.resultList"><td class="text-left" style="vertical-align: middle"><span>{{user.lastName}} {{user.firstName}}</span></td><td class="text-left" style="vertical-align: middle"><input type="text" class="form-control" ng-model="user.option.staffCode"></td><td class="text-left" style="vertical-align: middle"><select class="form-control" name="salaryType" ng-model="user.option.salaryType" ng-options="type.id as type.name for type in vm.salaryTypeList"></select></td><td class="text-center"><div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-yen"></i> </span><input type="text" class="form-control" ng-model="user.option.hourSalary"></div></td><td class="text-center"><div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-yen"></i> </span><input type="text" class="form-control" ng-model="user.option.extraPay"></div></td><td class="text-center"><div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-yen"></i> </span><input type="text" class="form-control" ng-model="user.option.busFee"></div></td><td class="text-center"><input type="checkbox" ng-model="user.option.noTimecard"></td><td class="text-center"><input type="checkbox" ng-model="user.option.houmonTimeCard"></td><td class="text-center"><select class="form-control" name="shikaku" ng-model="user.option.shokushuId"><option ng-repeat="shokushu in vm.shokushuList" value="{{shokushu.id}}">{{shokushu.shokushuName}}</option></select></td></tr></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-click="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/timecard/shift-duty/shift-duty-detail.html','<div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><h4>\u30B7\u30D5\u30C8\u52E4\u52D9\u5F62\u614B\u7BA1\u7406</h4><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-7" style="text-align: center"><label style="margin-top:5px"><input type="radio" ng-model="vm.state" ng-value="1" ng-change="vm.changeState()"> \u6709\u52B9\u306E\u307F</label><label style="margin-left:10px;margin-top:5px"><input type="radio" ng-model="vm.state" ng-value="0" ng-change="vm.changeState()"> \u5168\u8868\u793A</label></div><div class="col-md-2" ng-show="vm.parentFlag"><div class="pull-right"><button type="button" class="btn btn-success" data-translate="entity.action.save" ng-click="vm.save()" ng-disabled="vm.codeSaveFlag || vm.nameSaveFlag">\u4FDD\u5B58</button></div></div></div><table class="table table-bordered table-striped table-condensed" ng-show="vm.parentFlag"><colgroup><col width="15%"><col width="15%"><col width="10%"><col width="10%"></colgroup><tr><td class="text-center">\u52E4\u52D9\u5F62\u614B\u30B3\u30FC\u30C9</td><td class="text-center">\u52E4\u52D9\u5F62\u614B\u540D</td><td class="text-center">\u6709\u52B9</td><td class="text-center"></td></tr><tr ng-repeat="shiftDuty in vm.resultList" ng-class="!shiftDuty.state ? \'grey\' : \'\'"><td class="text-left" style="vertical-align: middle"><input ng-show="!shiftDuty.showFlag" type="text" class="form-control" ng-model="shiftDuty.code" ng-change="vm.codeUniqueCheck(shiftDuty, $index)"> <span ng-show="shiftDuty.showFlag">{{shiftDuty.code}}</span><div ng-show="shiftDuty.codeRequiredFlag || shiftDuty.codeMaxlengthFlag" class="has-error small"><p class="help-block" ng-show="shiftDuty.codeRequiredFlag" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="shiftDuty.codeMaxlengthFlag" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div><div ng-show="shiftDuty.codeSingleFlag"><font color="#a94442" style="font-size: 85%">\u8BE5\u5F53\u52E4\u52D9\u5F62\u614B\u30B3\u30FC\u30C9\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059</font></div></td><td class="text-left" style="vertical-align: middle"><input ng-show="!shiftDuty.showFlag" type="text" class="form-control" ng-model="shiftDuty.name" ng-change="vm.nameUniqueCheck(shiftDuty, $index)"> <span ng-show="shiftDuty.showFlag">{{shiftDuty.name}}</span><div ng-show="shiftDuty.nameRequiredFlag || shiftDuty.nameMaxlengthFlag" class="has-error small"><p class="help-block" ng-show="shiftDuty.nameRequiredFlag" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="shiftDuty.nameMaxlengthFlag" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div><div ng-show="shiftDuty.nameSingleFlag"><font color="#a94442" style="font-size: 85%">\u8BE5\u5F53\u52E4\u52D9\u5F62\u614B\u540D\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059</font></div></td><td class="text-center" style="vertical-align: middle"><label style="margin-top:5px"><input type="radio" ng-model="shiftDuty.state" ng-value="1" ng-disabled="shiftDuty.showFlag"> \u6709\u52B9</label><label style="margin-left:10px;margin-top:5px"><input type="radio" ng-model="shiftDuty.state" ng-value="0" ng-disabled="shiftDuty.showFlag"> \u7121\u52B9</label></td><td class="text-center"><button type="submit" ng-show="shiftDuty.id != null && shiftDuty.showFlag" ng-click="vm.goEdit(shiftDuty)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ng-show="shiftDuty.id != null && !shiftDuty.showFlag" ng-click="vm.goCancel(shiftDuty, $index)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.cancel"></span></button> <button type="submit" ng-click="vm.goAdd($index)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.addRow"></span></button> <button type="submit" ng-show="shiftDuty.id == null" ng-click="vm.goDel($index)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.deleteRow"></span></button>&nbsp;</td></tr></table><table class="table table-bordered table-striped table-condensed" ng-show="!vm.parentFlag"><colgroup><col width="15%"><col width="15%"></colgroup><tr><td class="text-center">\u52E4\u52D9\u5F62\u614B\u30B3\u30FC\u30C9</td><td class="text-center">\u52E4\u52D9\u5F62\u614B\u540D</td></tr><tr ng-repeat="shiftDuty in vm.resultList" style="height: 42px" ng-class="!shiftDuty.state ? \'grey\' : \'\'"><td class="text-left" style="vertical-align: middle"><span>{{shiftDuty.code}}</span></td><td class="text-left" style="vertical-align: middle"><span>{{shiftDuty.name}}</span></td></tr></table></div><style type="text/css">.grey{\n        background-color: #BEBEBE !important;\n    }</style>');
$templateCache.put('app/timecard/shift-month/shift-month-detail.html','<div id="titleDiv"><div style="position:fixed;top:75px;right:{{vm.messageWidth}}px;width:400px;overflow: hidden"><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert></div><h4>\u6708\u6B21\u30B7\u30D5\u30C8\u8868\u7BA1\u7406</h4><!--group\u7BA1\u7406\u8005--><div ng-show="vm.adminFlg" class="table-responsive" style="overflow-x: hidden"><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-1" style="text-align: right;padding-top: 5px"><span><strong>\u8077\u7A2E</strong></span></div><div class="col-md-1"><select class="col-md-2 form-control" ng-model="vm.occupationId" ng-change="vm.changeOccupation()"><option value="0">\u3059\u3079\u3066</option><option ng-repeat="pg in vm.occupationList" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-3"><button type="button" class="btn btn-success" data-translate="shiftmonth.management.currentMonth" ng-click="vm.rest()">\u4ECA\u6708</button> <button type="button" class="btn btn-info" data-translate="shiftmonth.management.beforeMonth" ng-click="vm.beforeMonth()"></button> <button type="button" class="btn btn-info" data-translate="shiftmonth.management.nextMonth" ng-click="vm.nextMonth()"></button> <span style="margin-left:20px" class="text-primary"><strong>{{vm.currentYear}}\u5E74{{vm.currentMonth}}\u6708</strong></span></div><div class="col-md-2"><label style="margin-left:10px"><input type="radio" ng-model="vm.type" ng-value="0" ng-click="vm.colorChange();"> \u4E88\u5B9A\u8A2D\u5B9A</label>&nbsp;&nbsp;<label style="margin-left:10px"><input type="radio" ng-model="vm.type" ng-value="1" ng-click="vm.colorChange();"> \u5B9F\u7E3E\u8A2D\u5B9A</label></div><div class="col-md-2" style="text-align: right"><button type="button" class="btn btn-success" data-translate="entity.action.save" ng-click="vm.save()">\u4FDD\u5B58</button><!-- <button type="button" ng-show="vm.confirmShowFlag == 0 || vm.confirmShowFlag == 2" class="btn btn-success" data-translate="shiftmonth.management.confirm" ng-click="vm.confirmClick()">\u78BA\u5B9A\u51E6\u7406</button>\n                <button type="button" ng-show="vm.confirmShowFlag == 1" class="btn btn-success" data-translate="shiftmonth.management.cancel" ng-click="vm.cancelClick()">\u78BA\u5B9A\u89E3\u9664</button>--> <button type="button" class="btn btn-danger" download-file="/timecard/export/shiftMonth/{{vm.groupId}}/{{vm.currentYear}}/{{vm.currentMonth}}/{{vm.groupName}}/{{vm.exportHoujinFlag}}/{{vm.childrenGroupList}}" down-file-type="xlsx">\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8</button><!--<button type="button" class="btn btn-success"  ng-click="vm.updateDate()" >\u66F4\u65B0\u6570\u636E</button>--></div></div><div class="row"><div class="col-md-9" id="timeZoneHeight"><div style="padding-left: 0px"><label>\u52E4\u52D9\u6642\u9593\u5E2F\u9078\u629E</label></div><div style="padding-left: 0px; margin-left: 0px" class="col-md-3" ng-repeat="timeZone in vm.timeZoneList"><label><input type="radio" ng-disabled="!timeZone.state" ng-model="vm.timeZone" ng-value="timeZone"> {{timeZone.name}}({{timeZone.startTime}}--{{timeZone.endTime}})</label></div></div><div style="margin-bottom: 15px" class="col-md-3"><textarea style="width: 100%; height: {{vm.commentHeight}}px" maxlength="1000" ng-model="vm.comment"></textarea></div></div><div ng-show="vm.queryCount == 0"><font color="red">\u6CE8\uFF1A\u30B7\u30D5\u30C8\u8077\u54E1\u7BA1\u7406\u753B\u9762\u306B\u8077\u54E1\u60C5\u5831\u3092\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002</font></div></div><!--\u666E\u901A\u7528\u6237--><div ng-show="!vm.adminFlg" class="table-responsive" style="overflow-x: hidden"><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-3"><button type="button" class="btn btn-success" data-translate="shiftmonth.management.currentMonth" ng-click="vm.rest()">\u4ECA\u6708</button> <button type="button" class="btn btn-info" data-translate="shiftmonth.management.beforeMonth" ng-click="vm.beforeMonth()"></button> <button type="button" class="btn btn-info" data-translate="shiftmonth.management.nextMonth" ng-click="vm.nextMonth()"></button> <span style="margin-left:20px" class="text-primary"><strong>{{vm.currentYear}}\u5E74{{vm.currentMonth}}\u6708</strong></span></div></div></div></div><div ng-show="vm.adminFlg" style="display:inline-block;overflow-x: auto; width: 100%"><div><table class="table-bordered table-condensed" style="table-layout:fixed; width: {{vm.tableWidth}}px"><thead><tr style="height: 32px"><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; width: 100px" id="column1">\u8077\u7A2E</td><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; width: 100px">\u52E4\u52D9\u5F62\u614B</td><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; width: 120px">\u6C0F\u540D</td><td class="text-center calendar-header" rowspan="3" style="width: 40px"></td><td class="text-center calendar-header" ng-dblclick="vm.weekClick($index);" colspan="{{$index == 4 ? vm.surplusDays : 7}}" ng-repeat="w in vm.weekdays">{{w.week}}</td><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; white-space: nowrap;width: 50px">{{vm.weekCount}}\u9031\u306E<br>\u5408\u8A08</td><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; white-space: nowrap;width: 75px">{{vm.weekCount}}\u9031\u5E73\u5747<br>\u306E<br>\u52E4\u52D9\u6642\u9593</td><td ng-show="vm.timeZoneList.length > 0" class="text-center calendar-header" colspan="{{vm.timeZoneList.length}}" rowspan="2"></td></tr><tr style="height: 32px"><td ng-dblclick="vm.columnClick($index + 1);" class="text-center calendar-header" ng-repeat="day in vm.calendar.days" style="width:45px">{{day.label}}</td></tr><tr style="height: 32px"><td class="text-center calendar-header" ng-repeat="day in vm.calendar.days" ng-class="{\'sunday\':day.youbi == \'\u65E5\',\'saturday\':day.youbi == \'\u571F\'}">({{day.youbi}})</td><td class="text-center calendar-header" style="white-space: nowrap;width: 45px" ng-repeat="timeZone in vm.timeZoneList" ng-value="timeZone.id">{{timeZone.name}}</td></tr></thead></table></div><div style="height: {{vm.tableHeight}}px; width: {{vm.divWidth}}px;overflow-y: auto;min-height: 280px"><table class="table table-bordered table-striped table-condensed" style="table-layout:fixed; width: {{vm.tableWidth}}px"><tbody ng-repeat="monthShift in vm.userStaffOccupation"><tr id="yoteiRowHeight{{$index}}" style="height: {{monthShift.rowHeight}}px"><td class="text-center" rowspan="2" style="vertical-align: middle; background-color:white; width: 100px">{{monthShift.occupationName}}</td><td class="text-center" rowspan="2" style="vertical-align: middle; background-color:white; width: 100px">{{monthShift.dutyName}}</td><td class="text-center" rowspan="2" style="vertical-align: middle; background-color:white; width: 120px">{{monthShift.userName}}</td><td class="text-center" ng-dblclick="vm.yoteiRowClick(monthShift);" style="height: 32px;white-space: nowrap;background-color:white;vertical-align: middle; width: 40px">\u4E88\u5B9A</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 1);" ng-mousedown="vm.yoteiMousedown($index+1, 1, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 1);" ng-click="vm.yoteiDayClick(monthShift, 1);" style="background-color: {{monthShift.monthShiftYotei.color1}}; white-space: nowrap; vertical-align: middle; width: 44px">{{monthShift.monthShiftYotei.timeZoneName1}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 2);" ng-mousedown="vm.yoteiMousedown($index+1, 2, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 2);" ng-click="vm.yoteiDayClick(monthShift, 2);" style="background-color: {{monthShift.monthShiftYotei.color2}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName2}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 3);" ng-mousedown="vm.yoteiMousedown($index+1, 3, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 3);" ng-click="vm.yoteiDayClick(monthShift, 3);" style="background-color: {{monthShift.monthShiftYotei.color3}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName3}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 4);" ng-mousedown="vm.yoteiMousedown($index+1, 4, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 4);" ng-click="vm.yoteiDayClick(monthShift, 4);" style="background-color: {{monthShift.monthShiftYotei.color4}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName4}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 5);" ng-mousedown="vm.yoteiMousedown($index+1, 5, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 5);" ng-click="vm.yoteiDayClick(monthShift, 5);" style="background-color: {{monthShift.monthShiftYotei.color5}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName5}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 6);" ng-mousedown="vm.yoteiMousedown($index+1, 6, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 6);" ng-click="vm.yoteiDayClick(monthShift, 6);" style="background-color: {{monthShift.monthShiftYotei.color6}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName6}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 7);" ng-mousedown="vm.yoteiMousedown($index+1, 7, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 7);" ng-click="vm.yoteiDayClick(monthShift, 7);" style="background-color: {{monthShift.monthShiftYotei.color7}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName7}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 8);" ng-mousedown="vm.yoteiMousedown($index+1, 8, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 8);" ng-click="vm.yoteiDayClick(monthShift, 8);" style="background-color: {{monthShift.monthShiftYotei.color8}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName8}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 9);" ng-mousedown="vm.yoteiMousedown($index+1, 9, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 9);" ng-click="vm.yoteiDayClick(monthShift, 9);" style="background-color: {{monthShift.monthShiftYotei.color9}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName9}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 10);" ng-mousedown="vm.yoteiMousedown($index+1, 10, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 10);" ng-click="vm.yoteiDayClick(monthShift, 10);" style="background-color: {{monthShift.monthShiftYotei.color10}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName10}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 11);" ng-mousedown="vm.yoteiMousedown($index+1, 11, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 11);" ng-click="vm.yoteiDayClick(monthShift, 11);" style="background-color: {{monthShift.monthShiftYotei.color11}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName11}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 12);" ng-mousedown="vm.yoteiMousedown($index+1, 12, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 12);" ng-click="vm.yoteiDayClick(monthShift, 12);" style="background-color: {{monthShift.monthShiftYotei.color12}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName12}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 13);" ng-mousedown="vm.yoteiMousedown($index+1, 13, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 13);" ng-click="vm.yoteiDayClick(monthShift, 13);" style="background-color: {{monthShift.monthShiftYotei.color13}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName13}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 14);" ng-mousedown="vm.yoteiMousedown($index+1, 14, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 14);" ng-click="vm.yoteiDayClick(monthShift, 14);" style="background-color: {{monthShift.monthShiftYotei.color14}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName14}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 15);" ng-mousedown="vm.yoteiMousedown($index+1, 15, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 15);" ng-click="vm.yoteiDayClick(monthShift, 15);" style="background-color: {{monthShift.monthShiftYotei.color15}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName15}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 16);" ng-mousedown="vm.yoteiMousedown($index+1, 16, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 16);" ng-click="vm.yoteiDayClick(monthShift, 16);" style="background-color: {{monthShift.monthShiftYotei.color16}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName16}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 17);" ng-mousedown="vm.yoteiMousedown($index+1, 17, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 17);" ng-click="vm.yoteiDayClick(monthShift, 17);" style="background-color: {{monthShift.monthShiftYotei.color17}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName17}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 18);" ng-mousedown="vm.yoteiMousedown($index+1, 18, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 18);" ng-click="vm.yoteiDayClick(monthShift, 18);" style="background-color: {{monthShift.monthShiftYotei.color18}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName18}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 19);" ng-mousedown="vm.yoteiMousedown($index+1, 19, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 19);" ng-click="vm.yoteiDayClick(monthShift, 19);" style="background-color: {{monthShift.monthShiftYotei.color19}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName19}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 20);" ng-mousedown="vm.yoteiMousedown($index+1, 20, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 20);" ng-click="vm.yoteiDayClick(monthShift, 20);" style="background-color: {{monthShift.monthShiftYotei.color20}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName20}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 21);" ng-mousedown="vm.yoteiMousedown($index+1, 21, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 21);" ng-click="vm.yoteiDayClick(monthShift, 21);" style="background-color: {{monthShift.monthShiftYotei.color21}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName21}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 22);" ng-mousedown="vm.yoteiMousedown($index+1, 22, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 22);" ng-click="vm.yoteiDayClick(monthShift, 22);" style="background-color: {{monthShift.monthShiftYotei.color22}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName22}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 23);" ng-mousedown="vm.yoteiMousedown($index+1, 23, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 23);" ng-click="vm.yoteiDayClick(monthShift, 23);" style="background-color: {{monthShift.monthShiftYotei.color23}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName23}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 24);" ng-mousedown="vm.yoteiMousedown($index+1, 24, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 24);" ng-click="vm.yoteiDayClick(monthShift, 24);" style="background-color: {{monthShift.monthShiftYotei.color24}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName24}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 25);" ng-mousedown="vm.yoteiMousedown($index+1, 25, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 25);" ng-click="vm.yoteiDayClick(monthShift, 25);" style="background-color: {{monthShift.monthShiftYotei.color25}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName25}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 26);" ng-mousedown="vm.yoteiMousedown($index+1, 26, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 26);" ng-click="vm.yoteiDayClick(monthShift, 26);" style="background-color: {{monthShift.monthShiftYotei.color26}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName26}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 27);" ng-mousedown="vm.yoteiMousedown($index+1, 27, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 27);" ng-click="vm.yoteiDayClick(monthShift, 27);" style="background-color: {{monthShift.monthShiftYotei.color27}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName27}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 28);" ng-mousedown="vm.yoteiMousedown($index+1, 28, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 28);" ng-click="vm.yoteiDayClick(monthShift, 28);" style="background-color: {{monthShift.monthShiftYotei.color28}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName28}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 29);" ng-mousedown="vm.yoteiMousedown($index+1, 29, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 29);" ng-click="vm.yoteiDayClick(monthShift, 29);" style="background-color: {{monthShift.monthShiftYotei.color29}}; white-space: nowrap; vertical-align: middle; width: 45px" ng-show="vm.day29ShowFlag || vm.day30ShowFlag || vm.day31ShowFlag">{{monthShift.monthShiftYotei.timeZoneName29}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 30);" ng-mousedown="vm.yoteiMousedown($index+1, 30, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 30);" ng-click="vm.yoteiDayClick(monthShift, 30);" style="background-color: {{monthShift.monthShiftYotei.color30}}; white-space: nowrap; vertical-align: middle; width: 45px" ng-show="vm.day30ShowFlag || vm.day31ShowFlag">{{monthShift.monthShiftYotei.timeZoneName30}}</td><td class="text-center" ng-dblclick="vm.yoteiDayClick(monthShift, 31);" ng-mousedown="vm.yoteiMousedown($index+1, 31, e);" ng-mousemove="vm.yoteiMousemove(monthShift, $index+1, 31);" ng-click="vm.yoteiDayClick(monthShift, 31);" style="background-color: {{monthShift.monthShiftYotei.color31}}; white-space: nowrap; vertical-align: middle; width: 45px" ng-show="vm.day31ShowFlag">{{monthShift.monthShiftYotei.timeZoneName31}}</td><td class="text-center" style="background-color:white; width: 50px;vertical-align: middle; color: {{monthShift.monthShiftYotei.countColor}}">{{monthShift.monthShiftYotei.total}}</td><td class="text-center" style="background-color:white; width: 75px;vertical-align: middle; color: {{monthShift.monthShiftYotei.averageColor}}">{{monthShift.monthShiftYotei.avgTime}}</td><td class="text-center" style="background-color:white; width: 45px;vertical-align: middle" ng-repeat="timeZone in monthShift.monthShiftYotei.timeZoneCountDTO" ng-value="timeZone">{{timeZone.timeZoneCount}}</td></tr><tr id="jissekiRowHeight{{$index}}" style="height: {{monthShift.rowHeight}}px"><td class="text-center" ng-dblclick="vm.jissekiRowClick(monthShift);" style="height: 32px;white-space: nowrap;background-color:white;vertical-align: middle">\u5B9F\u7E3E</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 1, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 1);" ng-click="vm.jissekiDayClick(monthShift, 1);" style="color: {{monthShift.monthShiftJisseki.fontColor1}}; background-color: {{monthShift.monthShiftJisseki.color1}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day1Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName1}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 2, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 2);" ng-click="vm.jissekiDayClick(monthShift, 2);" style="color: {{monthShift.monthShiftJisseki.fontColor2}}; background-color: {{monthShift.monthShiftJisseki.color2}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day2Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName2}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 3, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 3);" ng-click="vm.jissekiDayClick(monthShift, 3);" style="color: {{monthShift.monthShiftJisseki.fontColor3}}; background-color: {{monthShift.monthShiftJisseki.color3}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day3Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName3}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 4, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 4);" ng-click="vm.jissekiDayClick(monthShift, 4);" style="color: {{monthShift.monthShiftJisseki.fontColor4}}; background-color: {{monthShift.monthShiftJisseki.color4}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day4Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName4}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 5, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 5);" ng-click="vm.jissekiDayClick(monthShift, 5);" style="color: {{monthShift.monthShiftJisseki.fontColor5}}; background-color: {{monthShift.monthShiftJisseki.color5}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day5Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName5}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 6, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 6);" ng-click="vm.jissekiDayClick(monthShift, 6);" style="color: {{monthShift.monthShiftJisseki.fontColor6}}; background-color: {{monthShift.monthShiftJisseki.color6}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day6Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName6}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 7, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 7);" ng-click="vm.jissekiDayClick(monthShift, 7);" style="color: {{monthShift.monthShiftJisseki.fontColor7}}; background-color: {{monthShift.monthShiftJisseki.color7}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day7Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName7}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 8, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 8);" ng-click="vm.jissekiDayClick(monthShift, 8);" style="color: {{monthShift.monthShiftJisseki.fontColor8}}; background-color: {{monthShift.monthShiftJisseki.color8}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day8Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName8}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 9, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 9);" ng-click="vm.jissekiDayClick(monthShift, 9);" style="color: {{monthShift.monthShiftJisseki.fontColor9}}; background-color: {{monthShift.monthShiftJisseki.color9}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day9Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName9}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 10, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 10);" ng-click="vm.jissekiDayClick(monthShift, 10);" style="color: {{monthShift.monthShiftJisseki.fontColor10}}; background-color: {{monthShift.monthShiftJisseki.color10}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day10Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName10}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 11, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 11);" ng-click="vm.jissekiDayClick(monthShift, 11);" style="color: {{monthShift.monthShiftJisseki.fontColor11}}; background-color: {{monthShift.monthShiftJisseki.color11}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day11Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName11}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 12, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 12);" ng-click="vm.jissekiDayClick(monthShift, 12);" style="color: {{monthShift.monthShiftJisseki.fontColor12}}; background-color: {{monthShift.monthShiftJisseki.color12}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day12Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName12}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 13, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 13);" ng-click="vm.jissekiDayClick(monthShift, 13);" style="color: {{monthShift.monthShiftJisseki.fontColor13}}; background-color: {{monthShift.monthShiftJisseki.color13}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day13Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName13}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 14, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 14);" ng-click="vm.jissekiDayClick(monthShift, 14);" style="color: {{monthShift.monthShiftJisseki.fontColor14}}; background-color: {{monthShift.monthShiftJisseki.color14}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day14Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName14}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 15, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 15);" ng-click="vm.jissekiDayClick(monthShift, 15);" style="color: {{monthShift.monthShiftJisseki.fontColor15}}; background-color: {{monthShift.monthShiftJisseki.color15}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day15Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName15}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 16, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 16);" ng-click="vm.jissekiDayClick(monthShift, 16);" style="color: {{monthShift.monthShiftJisseki.fontColor16}}; background-color: {{monthShift.monthShiftJisseki.color16}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day16Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName16}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 17, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 17);" ng-click="vm.jissekiDayClick(monthShift, 17);" style="color: {{monthShift.monthShiftJisseki.fontColor17}}; background-color: {{monthShift.monthShiftJisseki.color17}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day17Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName17}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 18, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 18);" ng-click="vm.jissekiDayClick(monthShift, 18);" style="color: {{monthShift.monthShiftJisseki.fontColor18}}; background-color: {{monthShift.monthShiftJisseki.color18}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day18Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName18}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 19, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 19);" ng-click="vm.jissekiDayClick(monthShift, 19);" style="color: {{monthShift.monthShiftJisseki.fontColor19}}; background-color: {{monthShift.monthShiftJisseki.color19}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day19Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName19}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 20, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 20);" ng-click="vm.jissekiDayClick(monthShift, 20);" style="color: {{monthShift.monthShiftJisseki.fontColor20}}; background-color: {{monthShift.monthShiftJisseki.color20}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day20Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName20}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 21, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 21);" ng-click="vm.jissekiDayClick(monthShift, 21);" style="color: {{monthShift.monthShiftJisseki.fontColor21}}; background-color: {{monthShift.monthShiftJisseki.color21}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day21Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName21}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 22, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 22);" ng-click="vm.jissekiDayClick(monthShift, 22);" style="color: {{monthShift.monthShiftJisseki.fontColor22}}; background-color: {{monthShift.monthShiftJisseki.color22}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day22Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName22}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 23, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 23);" ng-click="vm.jissekiDayClick(monthShift, 23);" style="color: {{monthShift.monthShiftJisseki.fontColor23}}; background-color: {{monthShift.monthShiftJisseki.color23}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day23Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName23}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 24, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 24);" ng-click="vm.jissekiDayClick(monthShift, 24);" style="color: {{monthShift.monthShiftJisseki.fontColor24}}; background-color: {{monthShift.monthShiftJisseki.color24}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day24Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName24}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 25, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 25);" ng-click="vm.jissekiDayClick(monthShift, 25);" style="color: {{monthShift.monthShiftJisseki.fontColor25}}; background-color: {{monthShift.monthShiftJisseki.color25}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day25Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName25}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 26, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 26);" ng-click="vm.jissekiDayClick(monthShift, 26);" style="color: {{monthShift.monthShiftJisseki.fontColor26}}; background-color: {{monthShift.monthShiftJisseki.color26}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day26Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName26}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 27, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 27);" ng-click="vm.jissekiDayClick(monthShift, 27);" style="color: {{monthShift.monthShiftJisseki.fontColor27}}; background-color: {{monthShift.monthShiftJisseki.color27}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day27Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName27}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 28, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 28);" ng-click="vm.jissekiDayClick(monthShift, 28);" style="color: {{monthShift.monthShiftJisseki.fontColor28}}; background-color: {{monthShift.monthShiftJisseki.color28}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day28Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName28}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 29, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 29);" ng-click="vm.jissekiDayClick(monthShift, 29);" style="color: {{monthShift.monthShiftJisseki.fontColor29}}; background-color: {{monthShift.monthShiftJisseki.color29}}; white-space: nowrap; vertical-align: middle" ng-show="vm.day29ShowFlag || vm.day30ShowFlag || vm.day31ShowFlag" title="{{monthShift.monthShiftJisseki.day29Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName29}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 30, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 30);" ng-click="vm.jissekiDayClick(monthShift, 30);" style="color: {{monthShift.monthShiftJisseki.fontColor30}}; background-color: {{monthShift.monthShiftJisseki.color30}}; white-space: nowrap; vertical-align: middle" ng-show="vm.day30ShowFlag || vm.day31ShowFlag" title="{{monthShift.monthShiftJisseki.day30Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName30}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 31, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 31);" ng-click="vm.jissekiDayClick(monthShift, 31);" style="color: {{monthShift.monthShiftJisseki.fontColor31}}; background-color: {{monthShift.monthShiftJisseki.color31}}; white-space: nowrap; vertical-align: middle" ng-show="vm.day31ShowFlag" title="{{monthShift.monthShiftJisseki.day31Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName31}}</td><td class="text-center" style="background-color:white; vertical-align: middle; color: {{monthShift.monthShiftJisseki.countColor}}">{{monthShift.monthShiftJisseki.total}}</td><td class="text-center" style="background-color:white; vertical-align: middle; color: {{monthShift.monthShiftJisseki.averageColor}}">{{monthShift.monthShiftJisseki.avgTime}}</td><td class="text-center" style="background-color:white; vertical-align: middle; color: {{timeZone.fontColor}}" ng-repeat="timeZone in monthShift.monthShiftJisseki.timeZoneCountDTO" ng-value="timeZone">{{timeZone.timeZoneCount}}</td></tr></tbody></table></div></div><div ng-show="!vm.adminFlg" style="display:inline-block;overflow-x: auto; width: 100%"><div><table class="table-bordered table-condensed" style="table-layout:fixed; width: {{vm.tableWidth}}px"><thead><tr style="height: 32px"><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; width: 100px" id="column1">\u8077\u7A2E</td><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; width: 100px">\u52E4\u52D9\u5F62\u614B</td><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; width: 120px">\u6C0F\u540D</td><td class="text-center calendar-header" rowspan="3" style="width: 40px"></td><td class="text-center calendar-header" colspan="{{$index == 4 ? vm.surplusDays : 7}}" ng-repeat="w in vm.weekdays">{{w.week}}</td><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; white-space: nowrap;width: 50px">{{vm.weekCount}}\u9031\u306E<br>\u5408\u8A08</td><td class="text-center calendar-header" rowspan="3" style="vertical-align: middle; white-space: nowrap;width: 75px">{{vm.weekCount}}\u9031\u5E73\u5747<br>\u306E<br>\u52E4\u52D9\u6642\u9593</td><td ng-show="vm.timeZoneList.length > 0" class="text-center calendar-header" colspan="{{vm.timeZoneList.length}}" rowspan="2"></td></tr><tr style="height: 32px"><td class="text-center calendar-header" ng-repeat="day in vm.calendar.days" style="width:45px">{{day.label}}</td></tr><tr style="height: 32px"><td class="text-center calendar-header" ng-repeat="day in vm.calendar.days" ng-class="{\'sunday\':day.youbi == \'\u65E5\',\'saturday\':day.youbi == \'\u571F\'}">({{day.youbi}})</td><td class="text-center calendar-header" style="white-space: nowrap;width: 45px" ng-repeat="timeZone in vm.timeZoneList" ng-value="timeZone.id">{{timeZone.name}}</td></tr></thead></table></div><div style="height: {{vm.tableHeight}}px; width: {{vm.divWidth}}px;overflow-y: auto;min-height: 280px"><table class="table table-bordered table-striped table-condensed" style="table-layout:fixed; width: {{vm.tableWidth}}px"><tbody ng-repeat="monthShift in vm.userStaffOccupation"><tr id="yoteiRowHeight{{$index}}" style="height: {{monthShift.rowHeight}}px"><td class="text-center" rowspan="2" style="vertical-align: middle; background-color:white; width: 100px">{{monthShift.occupationName}}</td><td class="text-center" rowspan="2" style="vertical-align: middle; background-color:white; width: 100px">{{monthShift.dutyName}}</td><td class="text-center" rowspan="2" style="vertical-align: middle; background-color:white; width: 120px">{{monthShift.userName}}</td><td class="text-center" style="height: 32px;white-space: nowrap;background-color:white;vertical-align: middle; width: 40px">\u4E88\u5B9A</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color1}}; white-space: nowrap; vertical-align: middle; width: 44px">{{monthShift.monthShiftYotei.timeZoneName1}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color2}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName2}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color3}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName3}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color4}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName4}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color5}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName5}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color6}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName6}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color7}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName7}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color8}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName8}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color9}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName9}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color10}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName10}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color11}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName11}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color12}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName12}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color13}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName13}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color14}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName14}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color15}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName15}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color16}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName16}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color17}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName17}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color18}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName18}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color19}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName19}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color20}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName20}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color21}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName21}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color22}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName22}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color23}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName23}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color24}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName24}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color25}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName25}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color26}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName26}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color27}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName27}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color28}}; white-space: nowrap; vertical-align: middle; width: 45px">{{monthShift.monthShiftYotei.timeZoneName28}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color29}}; white-space: nowrap; vertical-align: middle; width: 45px" ng-show="vm.day29ShowFlag || vm.day30ShowFlag || vm.day31ShowFlag">{{monthShift.monthShiftYotei.timeZoneName29}}</td><td class="text-center" ng-click="vm.yoteiDayClick(monthShift, 30);" style="background-color: {{monthShift.monthShiftYotei.color30}}; white-space: nowrap; vertical-align: middle; width: 45px" ng-show="vm.day30ShowFlag || vm.day31ShowFlag">{{monthShift.monthShiftYotei.timeZoneName30}}</td><td class="text-center" style="background-color: {{monthShift.monthShiftYotei.color31}}; white-space: nowrap; vertical-align: middle; width: 45px" ng-show="vm.day31ShowFlag">{{monthShift.monthShiftYotei.timeZoneName31}}</td><td class="text-center" style="background-color:white; width: 50px;vertical-align: middle; color: {{monthShift.monthShiftYotei.countColor}}">{{monthShift.monthShiftYotei.total}}</td><td class="text-center" style="background-color:white; width: 75px;vertical-align: middle; color: {{monthShift.monthShiftYotei.averageColor}}">{{monthShift.monthShiftYotei.avgTime}}</td><td class="text-center" style="background-color:white; width: 45px;vertical-align: middle" ng-repeat="timeZone in monthShift.monthShiftYotei.timeZoneCountDTO" ng-value="timeZone">{{timeZone.timeZoneCount}}</td></tr><tr id="jissekiRowHeight{{$index}}" style="height: {{monthShift.rowHeight}}px"><td class="text-center" ng-dblclick="vm.jissekiRowClick(monthShift);" style="height: 32px;white-space: nowrap;background-color:white;vertical-align: middle">\u5B9F\u7E3E</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 1, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 1);" ng-click="vm.jissekiDayClick(monthShift, 1);" style="color: {{monthShift.monthShiftJisseki.fontColor1}}; background-color: {{monthShift.monthShiftJisseki.color1}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day1Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName1}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 2, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 2);" ng-click="vm.jissekiDayClick(monthShift, 2);" style="color: {{monthShift.monthShiftJisseki.fontColor2}}; background-color: {{monthShift.monthShiftJisseki.color2}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day2Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName2}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 3, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 3);" ng-click="vm.jissekiDayClick(monthShift, 3);" style="color: {{monthShift.monthShiftJisseki.fontColor3}}; background-color: {{monthShift.monthShiftJisseki.color3}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day3Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName3}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 4, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 4);" ng-click="vm.jissekiDayClick(monthShift, 4);" style="color: {{monthShift.monthShiftJisseki.fontColor4}}; background-color: {{monthShift.monthShiftJisseki.color4}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day4Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName4}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 5, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 5);" ng-click="vm.jissekiDayClick(monthShift, 5);" style="color: {{monthShift.monthShiftJisseki.fontColor5}}; background-color: {{monthShift.monthShiftJisseki.color5}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day5Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName5}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 6, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 6);" ng-click="vm.jissekiDayClick(monthShift, 6);" style="color: {{monthShift.monthShiftJisseki.fontColor6}}; background-color: {{monthShift.monthShiftJisseki.color6}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day6Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName6}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 7, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 7);" ng-click="vm.jissekiDayClick(monthShift, 7);" style="color: {{monthShift.monthShiftJisseki.fontColor7}}; background-color: {{monthShift.monthShiftJisseki.color7}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day7Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName7}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 8, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 8);" ng-click="vm.jissekiDayClick(monthShift, 8);" style="color: {{monthShift.monthShiftJisseki.fontColor8}}; background-color: {{monthShift.monthShiftJisseki.color8}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day8Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName8}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 9, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 9);" ng-click="vm.jissekiDayClick(monthShift, 9);" style="color: {{monthShift.monthShiftJisseki.fontColor9}}; background-color: {{monthShift.monthShiftJisseki.color9}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day9Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName9}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 10, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 10);" ng-click="vm.jissekiDayClick(monthShift, 10);" style="color: {{monthShift.monthShiftJisseki.fontColor10}}; background-color: {{monthShift.monthShiftJisseki.color10}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day10Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName10}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 11, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 11);" ng-click="vm.jissekiDayClick(monthShift, 11);" style="color: {{monthShift.monthShiftJisseki.fontColor11}}; background-color: {{monthShift.monthShiftJisseki.color11}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day11Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName11}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 12, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 12);" ng-click="vm.jissekiDayClick(monthShift, 12);" style="color: {{monthShift.monthShiftJisseki.fontColor12}}; background-color: {{monthShift.monthShiftJisseki.color12}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day12Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName12}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 13, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 13);" ng-click="vm.jissekiDayClick(monthShift, 13);" style="color: {{monthShift.monthShiftJisseki.fontColor13}}; background-color: {{monthShift.monthShiftJisseki.color13}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day13Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName13}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 14, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 14);" ng-click="vm.jissekiDayClick(monthShift, 14);" style="color: {{monthShift.monthShiftJisseki.fontColor14}}; background-color: {{monthShift.monthShiftJisseki.color14}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day14Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName14}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 15, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 15);" ng-click="vm.jissekiDayClick(monthShift, 15);" style="color: {{monthShift.monthShiftJisseki.fontColor15}}; background-color: {{monthShift.monthShiftJisseki.color15}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day15Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName15}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 16, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 16);" ng-click="vm.jissekiDayClick(monthShift, 16);" style="color: {{monthShift.monthShiftJisseki.fontColor16}}; background-color: {{monthShift.monthShiftJisseki.color16}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day16Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName16}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 17, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 17);" ng-click="vm.jissekiDayClick(monthShift, 17);" style="color: {{monthShift.monthShiftJisseki.fontColor17}}; background-color: {{monthShift.monthShiftJisseki.color17}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day17Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName17}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 18, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 18);" ng-click="vm.jissekiDayClick(monthShift, 18);" style="color: {{monthShift.monthShiftJisseki.fontColor18}}; background-color: {{monthShift.monthShiftJisseki.color18}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day18Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName18}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 19, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 19);" ng-click="vm.jissekiDayClick(monthShift, 19);" style="color: {{monthShift.monthShiftJisseki.fontColor19}}; background-color: {{monthShift.monthShiftJisseki.color19}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day19Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName19}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 20, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 20);" ng-click="vm.jissekiDayClick(monthShift, 20);" style="color: {{monthShift.monthShiftJisseki.fontColor20}}; background-color: {{monthShift.monthShiftJisseki.color20}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day20Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName20}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 21, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 21);" ng-click="vm.jissekiDayClick(monthShift, 21);" style="color: {{monthShift.monthShiftJisseki.fontColor21}}; background-color: {{monthShift.monthShiftJisseki.color21}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day21Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName21}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 22, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 22);" ng-click="vm.jissekiDayClick(monthShift, 22);" style="color: {{monthShift.monthShiftJisseki.fontColor22}}; background-color: {{monthShift.monthShiftJisseki.color22}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day22Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName22}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 23, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 23);" ng-click="vm.jissekiDayClick(monthShift, 23);" style="color: {{monthShift.monthShiftJisseki.fontColor23}}; background-color: {{monthShift.monthShiftJisseki.color23}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day23Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName23}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 24, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 24);" ng-click="vm.jissekiDayClick(monthShift, 24);" style="color: {{monthShift.monthShiftJisseki.fontColor24}}; background-color: {{monthShift.monthShiftJisseki.color24}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day24Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName24}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 25, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 25);" ng-click="vm.jissekiDayClick(monthShift, 25);" style="color: {{monthShift.monthShiftJisseki.fontColor25}}; background-color: {{monthShift.monthShiftJisseki.color25}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day25Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName25}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 26, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 26);" ng-click="vm.jissekiDayClick(monthShift, 26);" style="color: {{monthShift.monthShiftJisseki.fontColor26}}; background-color: {{monthShift.monthShiftJisseki.color26}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day26Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName26}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 27, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 27);" ng-click="vm.jissekiDayClick(monthShift, 27);" style="color: {{monthShift.monthShiftJisseki.fontColor27}}; background-color: {{monthShift.monthShiftJisseki.color27}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day27Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName27}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 28, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 28);" ng-click="vm.jissekiDayClick(monthShift, 28);" style="color: {{monthShift.monthShiftJisseki.fontColor28}}; background-color: {{monthShift.monthShiftJisseki.color28}}; white-space: nowrap; vertical-align: middle" title="{{monthShift.monthShiftJisseki.day28Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName28}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 29, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 29);" ng-click="vm.jissekiDayClick(monthShift, 29);" style="color: {{monthShift.monthShiftJisseki.fontColor29}}; background-color: {{monthShift.monthShiftJisseki.color29}}; white-space: nowrap; vertical-align: middle" ng-show="vm.day29ShowFlag || vm.day30ShowFlag || vm.day31ShowFlag" title="{{monthShift.monthShiftJisseki.day29Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName29}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 30, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 30);" ng-click="vm.jissekiDayClick(monthShift, 30);" style="color: {{monthShift.monthShiftJisseki.fontColor30}}; background-color: {{monthShift.monthShiftJisseki.color30}}; white-space: nowrap; vertical-align: middle" ng-show="vm.day30ShowFlag || vm.day31ShowFlag" title="{{monthShift.monthShiftJisseki.day30Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName30}}</td><td class="text-center" ng-mousedown="vm.jissekiMousedown($index+1, 31, e);" ng-mousemove="vm.jissekiMousemove(monthShift, $index+1, 31);" ng-click="vm.jissekiDayClick(monthShift, 31);" style="color: {{monthShift.monthShiftJisseki.fontColor31}}; background-color: {{monthShift.monthShiftJisseki.color31}}; white-space: nowrap; vertical-align: middle" ng-show="vm.day31ShowFlag" title="{{monthShift.monthShiftJisseki.day31Timecard}}">{{monthShift.monthShiftJisseki.timeZoneName31}}</td><td class="text-center" style="background-color:white; vertical-align: middle; color: {{monthShift.monthShiftJisseki.countColor}}">{{monthShift.monthShiftJisseki.total}}</td><td class="text-center" style="background-color:white; vertical-align: middle; color: {{monthShift.monthShiftJisseki.averageColor}}">{{monthShift.monthShiftJisseki.avgTime}}</td><td class="text-center" style="background-color:white; vertical-align: middle; color: {{timeZone.fontColor}}" ng-repeat="timeZone in monthShift.monthShiftJisseki.timeZoneCountDTO" ng-value="timeZone">{{timeZone.timeZoneCount}}</td></tr></tbody></table></div></div><div class="text-center" ng-show="vm.queryCount > 0" id="bottomDiv"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-click="vm.transition()"></uib-pagination></div><div class="text-center" ng-show="vm.queryCount == 0" style="padding-top: 10px; padding-bottom: 10px">\u8A72\u5F53\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093</div>');
$templateCache.put('app/timecard/shift-occupation/shift-occupation-detail.html','<div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><h4>\u30B7\u30D5\u30C8\u8077\u7A2E\u7BA1\u7406</h4><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-7" style="text-align: center"><label style="margin-top:5px"><input type="radio" ng-model="vm.state" ng-value="1" ng-change="vm.changeState();"> \u6709\u52B9\u306E\u307F</label><label style="margin-left:10px;margin-top:5px"><input type="radio" ng-model="vm.state" ng-value="0" ng-change="vm.changeState();"> \u5168\u8868\u793A</label></div><div class="col-md-2" ng-show="vm.parentFlag"><div class="pull-right"><button type="button" class="btn btn-success" data-translate="entity.action.save" ng-click="vm.save()" ng-disabled="vm.codeSaveFlag || vm.nameSaveFlag">\u4FDD\u5B58</button></div></div></div><table class="table table-bordered table-striped table-condensed" ng-show="vm.parentFlag"><colgroup><col width="15%"><col width="15%"><col width="10%"><col width="10%"></colgroup><tr><td class="text-center">\u8077\u7A2E\u30B3\u30FC\u30C9</td><td class="text-center">\u8077\u7A2E\u540D</td><td class="text-center">\u6709\u52B9</td><td class="text-center"></td></tr><tr ng-repeat="shiftOccupation in vm.resultList" ng-class="!shiftOccupation.state ? \'grey\' : \'\'"><td class="text-left" style="vertical-align: middle"><input ng-show="!shiftOccupation.showFlag" type="text" class="form-control" ng-model="shiftOccupation.code" ng-change="vm.codeUniqueCheck(shiftOccupation, $index)"> <span ng-show="shiftOccupation.showFlag">{{shiftOccupation.code}}</span><div ng-show="shiftOccupation.codeRequiredFlag || shiftOccupation.codeMaxlengthFlag" class="has-error small"><p class="help-block" ng-show="shiftOccupation.codeRequiredFlag" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="shiftOccupation.codeMaxlengthFlag" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div><div ng-show="shiftOccupation.codeSingleFlag"><font color="#a94442" style="font-size: 85%">\u8BE5\u5F53\u8077\u7A2E\u30B3\u30FC\u30C9\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059</font></div></td><td class="text-left" style="vertical-align: middle"><input ng-show="!shiftOccupation.showFlag" type="text" class="form-control" ng-model="shiftOccupation.name" ng-change="vm.nameUniqueCheck(shiftOccupation, $index)"> <span ng-show="shiftOccupation.showFlag">{{shiftOccupation.name}}</span><div ng-show="shiftOccupation.nameRequiredFlag || shiftOccupation.nameMaxlengthFlag" class="has-error small"><p class="help-block" ng-show="shiftOccupation.nameRequiredFlag" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="shiftOccupation.nameMaxlengthFlag" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div><div ng-show="shiftOccupation.nameSingleFlag"><font color="#a94442" style="font-size: 85%">\u8BE5\u5F53\u8077\u7A2E\u540D\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059</font></div></td><td class="text-center" style="vertical-align: middle"><label style="margin-top:5px"><input type="radio" ng-model="shiftOccupation.state" ng-value="1" ng-disabled="shiftOccupation.showFlag"> \u6709\u52B9</label><label style="margin-left:10px;margin-top:5px"><input type="radio" ng-model="shiftOccupation.state" ng-value="0" ng-disabled="shiftOccupation.showFlag"> \u7121\u52B9</label></td><td class="text-center"><button type="submit" ng-show="shiftOccupation.id != null && shiftOccupation.showFlag" ng-click="vm.goEdit(shiftOccupation)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ng-show="shiftOccupation.id != null && !shiftOccupation.showFlag" ng-click="vm.goCancel(shiftOccupation, $index)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.cancel"></span></button> <button type="submit" ng-click="vm.goAdd($index)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.addRow"></span></button> <button type="submit" ng-show="shiftOccupation.id == null" ng-click="vm.goDel($index)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.deleteRow"></span></button>&nbsp;</td></tr></table><table class="table table-bordered table-striped table-condensed" ng-show="!vm.parentFlag"><colgroup><col width="15%"><col width="15%"></colgroup><tr><td class="text-center">\u8077\u7A2E\u30B3\u30FC\u30C9</td><td class="text-center">\u8077\u7A2E\u540D</td></tr><tr ng-repeat="shiftOccupation in vm.resultList" style="height: 42px" ng-class="!shiftOccupation.state ? \'grey\' : \'\'"><td class="text-left" style="vertical-align: middle"><span>{{shiftOccupation.code}}</span></td><td class="text-left" style="vertical-align: middle"><span>{{shiftOccupation.name}}</span></td></tr></table></div><style type="text/css">.grey{\n        background-color: #BEBEBE !important;\n    }</style>');
$templateCache.put('app/timecard/shift-time/shift-time-detail.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><h4>\u30B7\u30D5\u30C8\u52E4\u52D9\u6642\u9593\u5E2F\u7BA1\u7406</h4><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-7" style="text-align: center"><label style="margin-top:5px"><input type="radio" ng-model="vm.state" ng-value="1" ng-change="vm.changeState();"> \u6709\u52B9\u306E\u307F</label><label style="margin-left:10px;margin-top:5px"><input type="radio" ng-model="vm.state" ng-value="0" ng-change="vm.changeState();"> \u5168\u8868\u793A</label></div><div class="col-md-2"><div class="pull-right"><button type="submit" class="btn btn-success" data-translate="entity.action.save" ng-disabled="vm.timeType || editForm.$invalid || vm.codeSaveFlag || vm.nameSaveFlag" ng-show="!vm.selectGroupFlag">\u4FDD\u5B58</button> <button ng-show="!vm.parentFlag" type="button" class="btn btn-danger" data-translate="entity.action.reloadHoujinTimeZone" ng-click="vm.reloadHoujinTimeZone()" ng-disabled="detail.$invalid">\u30B7\u30D5\u30C8\u6642\u9593\u5E2F\u518D\u53D6\u5F97</button></div></div></div><div ng-show="vm.timeZoneIsNullFlag"><font color="red">\u6CE8\uFF1A\u672C\u90E8\u30B7\u30D5\u30C8\u6642\u9593\u5E2F\u8A2D\u5B9A\u3092\u8AAD\u307F\u8FBC\u307F\u3057\u307E\u3057\u305F\u3001\u8A72\u5F53\u4E8B\u696D\u6240\u306E\u6642\u9593\u5E2F\u3092\u8A2D\u5B9A\u3057\u3066\u304B\u3089\u4FDD\u5B58\u3057\u3066\u304F\u3060\u3055\u3044\u3002</font></div><table class="table table-bordered table-striped table-condensed"><colgroup><col width="10%"><col width="10%"><col width="15%"><col width="10%"><col width="10%"><col width="10%"></colgroup><tr><td class="text-center">\u6642\u9593\u5E2F\u30B3\u30FC\u30C9</td><td class="text-center">\u6642\u9593\u5E2F\u540D</td><td class="text-center">\u6642\u9593\u5E2F</td><td class="text-center">\u4F11\u61A9\u6642\u9593</td><td class="text-center">\u6709\u52B9</td><td class="text-center" ng-show="!vm.selectGroupFlag"></td></tr><tr ng-repeat="shiftTimeZone in vm.resultList" style="height: 42px" ng-class="!shiftTimeZone.state ? \'grey\' : \'\'"><td class="text-left" style="vertical-align: middle"><input ng-show="!shiftTimeZone.showFlag" type="text" class="form-control" ng-model="shiftTimeZone.code" ng-change="vm.codeUniqueCheck(shiftTimeZone, $index)"> <span ng-show="shiftTimeZone.showFlag">{{shiftTimeZone.code}}</span><div ng-show="shiftTimeZone.codeRequiredFlag || shiftTimeZone.codeMaxlengthFlag" class="has-error small"><p class="help-block" ng-show="shiftTimeZone.codeRequiredFlag" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="shiftTimeZone.codeMaxlengthFlag" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div><div ng-show="shiftTimeZone.codeSingleFlag"><font color="#a94442" style="font-size: 85%">\u8BE5\u5F53\u6642\u9593\u5E2F\u30B3\u30FC\u30C9\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059</font></div></td><td class="text-left" style="vertical-align: middle"><input ng-show="!shiftTimeZone.showFlag" type="text" class="form-control" ng-model="shiftTimeZone.name" ng-change="vm.nameUniqueCheck(shiftTimeZone, $index)"> <span ng-show="shiftTimeZone.showFlag">{{shiftTimeZone.name}}</span><div ng-show="shiftTimeZone.nameRequiredFlag || shiftTimeZone.nameMaxlengthFlag" class="has-error small"><p class="help-block" ng-show="shiftTimeZone.nameRequiredFlag" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="shiftTimeZone.nameMaxlengthFlag" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div><div ng-show="shiftTimeZone.nameSingleFlag"><font color="#a94442" style="font-size: 85%">\u8BE5\u5F53\u6642\u9593\u5E2F\u540D\u306F\u65E2\u306B\u5B58\u5728\u3057\u307E\u3059</font></div></td><td class="text-left" style="vertical-align: middle"><div class="input-group" style="float: left;width: 150px" ng-show="!shiftTimeZone.showFlag"><span class="input-group-addon"><i class="glyphicon glyphicon-time"></i> </span><input class="form-control" placeholder="_ _:_ _" maxlength="5" id="startTime{{$index}}" time-format-zen-to-han ng-class="{\'time-format-error\': shiftTimeZone.startTimeError}" ng-model="shiftTimeZone.startTime" ng-blur="vm.startTimeUpdate(shiftTimeZone, $index, vm.resultList)"></div><div ng-show="shiftTimeZone.showFlag" style="float: left"><span>{{shiftTimeZone.startTime}}</span></div><div style="float: left">&nbsp;&nbsp;~&nbsp;&nbsp;</div><div class="input-group" style="float: left;width: 150px" ng-show="!shiftTimeZone.showFlag"><span class="input-group-addon"><i class="glyphicon glyphicon-time"></i> </span><input class="form-control" placeholder="_ _:_ _" maxlength="5" id="endTime{{$index}}" time-format-zen-to-han ng-class="{\'time-format-error\': shiftTimeZone.endTimeError}" ng-model="shiftTimeZone.endTime" ng-blur="vm.endTimeUpdate(shiftTimeZone, $index, vm.resultList)"></div><div ng-show="shiftTimeZone.showFlag" style="float: left"><span>{{shiftTimeZone.endTime}}</span></div><div ng-show="shiftTimeZone.showFlag" style="float: left; padding-left: 10px"><span>({{shiftTimeZone.differenceTime}})</span></div></td><td class="text-left" style="vertical-align: middle"><input name="restTime{{$index}}" number-format-zen-to-han ng-show="!shiftTimeZone.showFlag" id="restTime{{$index}}" type="text" maxlength="6" placeholder="{{\'shifttime.form.restTime\' | translate}}" ng-model="shiftTimeZone.restTime" ng-class="{\'time-format-error\': shiftTimeZone.restTimeError}" ng-blur="vm.restTimeUpdate(shiftTimeZone, $index, vm.resultList)"> <span ng-show="shiftTimeZone.showFlag">{{shiftTimeZone.restTime}}</span></td><td class="text-center" style="vertical-align: middle"><label style="margin-top:5px"><input type="radio" ng-model="shiftTimeZone.state" ng-value="1"> \u6709\u52B9</label><label style="margin-left:10px;margin-top:5px"><input type="radio" ng-model="shiftTimeZone.state" ng-value="0"> \u7121\u52B9</label></td><td ng-show="!vm.selectGroupFlag" class="text-center"><button type="button" ng-show="shiftTimeZone.id != null && shiftTimeZone.showFlag" ng-click="vm.goEdit(shiftTimeZone)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="button" ng-show="shiftTimeZone.id != null && !shiftTimeZone.showFlag" ng-click="vm.goCancel(shiftTimeZone, $index)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.cancel"></span></button> <button type="button" ng-click="vm.goAdd($index)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.addRow"></span></button> <button ng-show="shiftTimeZone.id == null" type="button" ng-click="vm.goDel($index)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.deleteRow"></span></button></td></tr></table></div><style type="text/css">.grey{\n            background-color: #BEBEBE !important;\n        }</style></form>');
$templateCache.put('app/timecard/shokushu-management/shokushu-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="shokushuManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this shokushu?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/timecard/shokushu-management/shokushu-management-detail.html','<div><h2><span data-translate="shokushuManagement.detail.title">\u8077\u7A2E</span></h2><dl class="dl-horizontal"><dt><span>ID</span></dt><dd><span>{{vm.shokushu.id}}</span></dd><dt><span>\u8077\u7A2E\u30B3\u30FC\u30C9</span></dt><dd>{{vm.shokushu.shokushuCd}}</dd><dt><span>\u8077\u7A2E\u540D</span></dt><dd>{{vm.shokushu.shokushuName}}</dd><dt><span>\u770B\u8B77\u8077\u54E1/\u4ECB\u8B77\u8077\u54E1</span></dt><dd ng-switch="vm.shokushu.type"><span ng-switch-when="1">\u770B\u8B77\u8077\u54E1</span> <span ng-switch-when="2">\u4ECB\u8B77\u8077\u54E1</span></dd><dt><span>\u30B0\u30EB\u30FC\u30D7\u540D</span></dt><dd>{{vm.groups.name}}</dd></dl><button type="submit" ui-sref="shokushu-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/timecard/shokushu-management/shokushu-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myShokushuLabel" data-translate="shokushuManagement.home.createOrEditLabel">Create or edit a Shokushu</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.shokushu.id" readonly="readonly"></div><div class="form-group"><label class="control-label">\u30B0\u30EB\u30FC\u30D7</label><!--<select class="form-control" name="groupId" ng-model="vm.shokushu.groupId" ng-required="vm.shokushu.groupId == null">--><!--<option ng-repeat="pg in vm.groups" value="{{pg.id}}">{{pg.name}}</option>--><!--</select>--><select class="form-control" ng-disabled="vm.shokushu.id != null" name="groupId" ng-model="vm.shokushu.groupId" ng-required="vm.shokushu.groupId == null" ng-options="pg.id as pg.name for pg in vm.groups"></select><div ng-show="editForm.groupId.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.groupId.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label">\u8077\u7A2E\u30B3\u30FC\u30C9</label><input type="text" class="form-control" name="shokushuCd" ng-model="vm.shokushu.shokushuCd" ng-required="vm.shokushu.shokushuCd == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[0-9]*$/"><div ng-show="editForm.shokushuCd.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.shokushuCd.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.shokushuCd.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.shokushuCd.$error.pattern" data-translate="entity.validation.pattern.num-letter-symbol">This field\'s type is not correct.</p></div></div><div class="form-group"><label class="control-label">\u8077\u7A2E\u540D</label><input type="text" class="form-control" name="shokushuName" ng-required="vm.shokushu.shokushuName == null" ng-minlength="1" ng-maxlength="50" ng-model="vm.shokushu.shokushuName" ng-maxlength="50"><div ng-show="editForm.shokushuName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.shokushuName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.shokushuName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>\u7A2E\u5225</label><!--<select class="form-control" name="type" ng-model="vm.shokushu.type"--><!--ng-options="type.code as type.name for type in vm.enumShokushuType track by type.code">--><!--</select>--><select class="form-control" name="type" ng-model="vm.shokushu.type" ng-options="type.code as type.name for type in vm.enumShokushuType"></select></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving || vm.repeatFlg" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/timecard/shokushu-management/shokushu-management-import.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myShokushuLabel">\u30B1\u30A2\u6A39\u8077\u7A2E\u60C5\u5831\u8AAD\u307F\u8FBC\u3080</h4></div><div class="modal-body"><div ng-show="vm.shokushuList !== null"><p>"\u30B1\u30A2\u6A39\u304B\u3089\u4EE5\u4E0B\u306E\u8077\u7A2E\u60C5\u5831\u3092\u53D6\u5F97\u3057\u307E\u3057\u305F\u3002"</p><p>"\u53D6\u5F97\u3057\u305F\u8077\u7A2E\u60C5\u5831\u3092\u4E00\u62EC\u8FFD\u52A0\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3057\u3087\u3046\u304B?"</p><p>(\u3059\u3067\u306B\u767B\u9332\u3057\u305F\u8077\u7A2E\u60C5\u5831\u3092\u4E0A\u66F8\u304D\u3057\u307E\u3059)"</p></div><jhi-alert-error></jhi-alert-error><table class="jh-table table table-striped"><tr><th>\u8077\u7A2E\u30B3\u30FC\u30C9</th><th>\u8077\u7A2E\u540D</th><th>\u7A2E\u5225</th></tr><tr ng-repeat="shokushu in vm.shokushuList"><td>{{shokushu.shokushuCd}}</td><td>{{shokushu.shokushuName}}</td><td>{{shokushu.typeName}}</td></tr></table><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/timecard/shokushu-management/shokushu-management.html','<div><h4 data-translate="shokushuManagement.home.title">\u8077\u7A2E\u7BA1\u7406</h4><div class="row"><div class="col-md-4"><select class="form-control" ng-model="vm.selectGroup" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-3"><button type="button" class="btn btn-primary" ui-sref="shokushu-management.import({id:vm.selectGroup})"><span class="glyphicon glyphicon-import"></span><span>\u30B1\u30A2\u6A39\u304B\u3089\u8AAD\u307F\u8FBC\u3080</span></button></div><div class="col-md-5"><button class="btn btn-primary pull-right" ui-sref="shokushu-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="shokushuManagement.home.createLabel">Create a new Shokushu</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="shokushuCd"><span>\u8077\u7A2E\u30B3\u30FC\u30C9</span> <span class="glyphicon glyphicon-sort"></span></th><th>\u8077\u7A2E\u540D</th><th></th></tr></thead><tbody><tr ng-repeat="shokushu in vm.shokushus track by shokushu.id"><td><a ui-sref="shokushu-management-detail({id:shokushu.id})">{{shokushu.id}}</a></td><td>{{shokushu.shokushuCd}}</td><td>{{shokushu.shokushuName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="shokushu-management-detail({id:shokushu.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="shokushu-management.edit({id:shokushu.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="shokushu-management.delete({id:shokushu.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-click="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/timecard/staff-occupation/staff-occupation-detail.html','<div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><h4>\u30B7\u30D5\u30C8\u8077\u54E1\u7BA1\u7406</h4><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-5"><button type="button" class="btn btn-success" data-translate="staffoccupation.management.currentMonth" ng-click="vm.rest()">\u4ECA\u6708</button> <button type="button" class="btn btn-info" data-translate="staffoccupation.management.beforeMonth" ng-click="vm.beforeMonth()"></button> <button type="button" class="btn btn-info" data-translate="staffoccupation.management.nextMonth" ng-click="vm.nextMonth()"></button> <span style="margin-left:20px" class="text-primary"><strong>{{vm.currentYear}}\u5E74{{vm.currentMonth}}\u6708</strong></span></div><div class="col-md-4"><div class="pull-right"><!--<button type="button" class="btn btn-danger" data-translate="entity.action.reloadUser" ng-click="vm.reloadStaff()"\n                        ng-disabled="detail.$invalid">\u30B9\u30BF\u30C3\u30D5\u518D\u8AAD\u307F\u8FBC\u307F</button>--> <button type="button" class="btn btn-success" data-translate="entity.action.save" ng-click="vm.save()" ng-disabled="detail.$invalid">\u4FDD\u5B58</button> <button type="button" class="btn btn-danger" data-translate="entity.action.staffSingeAdd" ng-click="vm.staffSingeAdd()" ng-disabled="detail.$invalid">\u30B9\u30BF\u30C3\u30D5\u500B\u5225\u8FFD\u52A0</button></div></div></div><div ng-show="vm.staffIsNullFlag"><font color="red">\u6CE8\uFF1A\u4FDD\u5B58\u30DC\u30BF\u30F3\u3092\u62BC\u3059\u3068\u8A72\u5F53\u30B7\u30D5\u30C8\u8077\u54E1\u3092\u4FDD\u5B58\u3057\u307E\u3059\u3002</font></div><table class="table table-bordered table-striped table-condensed" ng-show="vm.userType"><colgroup><col width="15%"><col width="15%"><col width="15%"><col width="15%"></colgroup><tr><td class="text-center">\u6C0F\u540D</td><td class="text-center">\u8077\u7A2E</td><td class="text-center">\u52E4\u52D9\u5F62\u614B</td><td class="text-center"></td></tr><tr ng-repeat="user in vm.userList | limitTo: vm.pageNumber:vm.startNumber" ng-show="!user.deleteFlag"><td ng-show="user.firstFlag" class="text-left" style="vertical-align: middle" rowspan="{{user.rowspan}}"><span ng-show="user.firstFlag">{{user.userName}}</span></td><td class="text-left" style="vertical-align: middle; background-color: {{user.occupationDeletedFlag ? \'#d0d0d0\': \'\'}}"><span ng-show="!user.showFlag">{{user.occupationName}}</span><select ng-show="user.showFlag" ng-change="vm.changeSelect();" class="col-md-3 form-control" ng-model="user.occupationId" ng-options="occupation.id as occupation.name for occupation in vm.occupationList"></select><div ng-show="user.occupationRequiredFlag" class="has-error small"><p class="help-block" ng-show="user.occupationRequiredFlag" data-translate="entity.validation.required">This field is required.</p></div></td><td class="text-left" style="vertical-align: middle;  background-color: {{user.dutyDeletedFlag ? \'#d0d0d0\': \'\'}}"><span ng-show="!user.showFlag">{{user.dutyName}}</span><select ng-show="user.showFlag" ng-change="vm.changeSelect();" class="col-md-3 form-control" ng-model="user.dutyId" ng-options="duty.id as duty.name for duty in vm.dutyList"></select><div ng-show="user.dutyRequiredFlag" class="has-error small"><p class="help-block" ng-show="user.dutyRequiredFlag" data-translate="entity.validation.required">This field is required.</p></div></td><td class="text-center"><button type="submit" ng-show="user.id != null && !user.showFlag" ng-click="vm.goEdit(user)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ng-show="user.id != null && user.showFlag" ng-click="vm.goCancel(user)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.cancel"></span></button> <button type="submit" ng-click="vm.goAdd($index, user)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.addRow"></span></button> <button type="submit" ng-click="vm.goDel($index, user)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.deleteRow"></span></button>&nbsp;</td></tr></table><table class="table table-bordered table-striped table-condensed" ng-show="!vm.userType"><colgroup><col width="15%"><col width="15%"><col width="15%"><col width="15%"></colgroup><tr><td class="text-center">\u6C0F\u540D</td><td class="text-center">\u8077\u7A2E</td><td class="text-center">\u52E4\u52D9\u5F62\u614B</td><td class="text-center"></td></tr><tr ng-repeat="user in vm.userList" ng-show="!user.deleteFlag"><td ng-show="user.firstFlag" class="text-left" style="vertical-align: middle" rowspan="{{user.rowspan}}"><span ng-show="user.firstFlag">{{user.userName}}</span></td><td class="text-left" style="vertical-align: middle; background-color: {{user.occupationDeletedFlag ? \'#d0d0d0\': \'\'}}"><span ng-show="!user.showFlag">{{user.occupationName}}</span><select ng-show="user.showFlag" ng-change="vm.changeSelect();" class="col-md-3 form-control" ng-model="user.occupationId" ng-options="occupation.id as occupation.name for occupation in vm.occupationList"></select><div ng-show="user.occupationRequiredFlag" class="has-error small"><p class="help-block" ng-show="user.occupationRequiredFlag" data-translate="entity.validation.required">This field is required.</p></div></td><td class="text-left" style="vertical-align: middle;  background-color: {{user.dutyDeletedFlag ? \'#d0d0d0\': \'\'}}"><span ng-show="!user.showFlag">{{user.dutyName}}</span><select ng-show="user.showFlag" ng-change="vm.changeSelect();" class="col-md-3 form-control" ng-model="user.dutyId" ng-options="duty.id as duty.name for duty in vm.dutyList"></select><div ng-show="user.dutyRequiredFlag" class="has-error small"><p class="help-block" ng-show="user.dutyRequiredFlag" data-translate="entity.validation.required">This field is required.</p></div></td><td class="text-center"><button type="submit" ng-show="user.id != null && !user.showFlag" ng-click="vm.goEdit(user)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ng-show="user.id != null && user.showFlag" ng-click="vm.goCancel(user)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.cancel"></span></button> <button type="submit" ng-click="vm.goAdd($index, user)" class="btn btn-primary btn-sm" ng-disabled="user.hasAdmin && !vm.isAdmin"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.addRow"></span></button> <button type="submit" ng-click="vm.goDel($index, user)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.deleteRow"></span></button>&nbsp;</td></tr></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-click="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/timecard/staff-occupation/staff-single-add.html','<form name="editForm" role="form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="staffoccupation.staffsingleadd">Select User</h4></div><div class="modal-body"><table class="table table-bordered table-striped table-condensed"><colgroup><col width="20%"><col width="5%"></colgroup><tr><td class="text-center">\u6C0F\u540D</td><td class="text-center"></td></tr><tr ng-repeat="user in vm.userlist"><td style="vertical-align: middle"><span>{{user.lastName}}&nbsp;{{user.firstName}}</span></td><td class="text-center"><button type="submit" ng-click="vm.addUser(user)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.add"></span></button></td></tr></table></div></form>');
$templateCache.put('app/timecard/timecard-management/timecard-management-detail.html','<div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><button type="button" class="btn btn-success" data-translate="timecard.management.currentMonth" ng-click="vm.rest()">\u4ECA\u6708</button> <button type="button" class="btn btn-info" data-translate="timecard.management.beforeMonth" ng-click="vm.beforeMonth()"></button> <button type="button" class="btn btn-info" data-translate="timecard.management.nextMonth" ng-click="vm.nextMonth()"></button> <span style="margin-left:20px" class="text-primary"><strong>{{vm.currentYear}}\u5E74{{vm.currentMonth}}\u6708</strong></span></div><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-6"><div class="pull-right"><button type="button" ui-sref="timecard-management({currentYear:vm.currentYear,currentMonth:vm.currentMonth,groupId:vm.groupId, retiredFlg:vm.retiredFlg})" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" class="btn btn-success" data-translate="timecard.management.saveHistory" ng-click="vm.saveHistory()" ng-disabled="detail.$invalid">\u4FDD\u5B58</button></div></div></div><uib-tabset active="active"><uib-tab index="0" heading="\u6708\u9593\u52E4\u52D9\u8A73\u7D30\uFF08{{vm.currentYear}}/{{vm.currentMonth}}\uFF09"><ng-form name="detai"><div class="row" style="margin-top: 10px;margin-left: 5px"><p>\u6CE8\uFF1A\u6642\u9593\u306E\u5165\u529B\u306F\u300008:30 \u6216\u3044\u306F 0800\u3000\u3088\u3046\u306A\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\uFF08\u5F62\u5F0F\u9593\u9055\u3044\u5834\u5408\u306F\u6587\u5B57\u8272\u304C<span class="time-format-error">\u8D64</span>\u306B\u306A\u308A\u307E\u3059\uFF09\u3002</p><p>\u51FA\u52E4\u3001\u9000\u52E4\u6642\u9593\u306F30\u5206\u5358\u4F4D\u3067\u4E38\u3081\u51E6\u7406\u3092\u3057\u3066\u3044\u307E\u3059\u304C\u3001\u5B9F\u6642\u523B\u306F\u5B9F\u969B\u306B\u6253\u523B\u6642\u9593\u306A\u306E\u3067\u3001\u4E38\u3081\u51E6\u7406\u3092\u3057\u3066\u306A\u3044\u3067\u3059\u3002</p></div><div class="row" style="margin-top:10px"><div class="col-md-9"><table class="table table-bordered table-condensed" ng-if="vm.data.detail.length > 0 && vm.userTimecardList.length > 0"><colgroup><col width="8%"><col width="5%"><col width="10%"><col width="10%"><col width="10%"><col width="5%"><col width="10%"><col width="10%"><col width="5%"><col width="7%"></colgroup><tr><td class="text-center">\u30B9\u30BF\u30C3\u30D5\u540D</td><td colspan="2" class="bg-info text-center">{{vm.userName}}</td><td>{{vm.data.wareki}}</td><td class="bg-info">{{vm.currentMonth}}</td><td class="text-center">\u6708\u5206</td><td></td><td class="text-center">\u6642\u7D66\u984D/\u696D\u52D9\u624B\u5F53-></td><td class="bg-warning">{{vm.data.salary}}</td><td class="bg-warning">{{vm.data.extraPay}}</td></tr><tr><td class="text-center">\u533A\u5206</td><td class="text-center">\u65E5\u4ED8</td><td class="text-center">\u51FA\u52E4\u6642\u9593</td><td class="text-center">\u9000\u793E\u6642\u9593</td><td class="text-center">\u4F11\u61A9\u6642\u9593</td><td class="text-center">\u6642\u9593\u6570</td><td class="text-center">\u4EA4\u901A\u8CBB</td><td class="text-center">\u6642\u9593\u6570(\u6DF1\u591C)</td><td colspan="2" class="text-center">\u5B9F\u6642\u523B\uFF08\u6253\u523B\u6642\u523B\uFF09</td></tr><tr ng-repeat="detail in vm.data.detail" ng-class="{\'background_sunday_thin\':detail.workTimeDetail.sunday,\'background_saturday_thin\':detail.workTimeDetail.saturday}" ng-form="detailForm"><td>\u6A19\u6E96</td><td>{{detail.day|date:\'d\'}}\u65E5</td><td><div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-time"></i> </span><input class="form-control" placeholder="_ _:_ _" ng-disabled="vm.deletedFlg" maxlength="5" id="startTime{{$index}}" name="startTime" time-format-zen-to-han ng-class="{\'time-format-error\': detail.workTimeDetail.startTimeError,\'time-empty-error\': detail.workTimeDetail.startTimeEmptyError}" ng-init="vm.initStartTime(detail.workTimeDetail)" ng-model="detail.workTimeDetail.startTimeStr" ng-blur="vm.StartTimeUpdate(detail.day,detail.workTimeDetail, $index)"></div></td><td><div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-time"></i> </span><input class="form-control" placeholder="_ _:_ _" ng-disabled="vm.deletedFlg" maxlength="5" id="endTime{{$index}}" name="endTime" time-format-zen-to-han ng-class="{\'time-format-error\': detail.workTimeDetail.endTimeError,\'time-empty-error\': detail.workTimeDetail.endTimeEmptyError}" ng-init="vm.initEndTime(detail.workTimeDetail)" ng-model="detail.workTimeDetail.endTimeStr" ng-blur="vm.EndTimeUpdate(detail.day,detail.workTimeDetail, $index)"></div></td><td><div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-time"></i> </span><input class="form-control" placeholder="_ _:_ _" ng-disabled="vm.deletedFlg" name="restTime" id="restTime{{$index}}" maxlength="5" time-format-zen-to-han ng-class="{\'time-format-error\': detail.workTimeDetail.restTimeError}" ng-init="vm.initRestTime(detail.workTimeDetail)" ng-model="detail.workTimeDetail.restTime" ng-blur="vm.RestimeUpdate(detail.day,detail.workTimeDetail, $index)"></div></td><td style="vertical-align: middle"><span>{{vm.format(detail.workTimeDetail.workTime)}}</span></td><td ng-switch="detail.workTimeDetail.startTime.length > 0"><div class="input-group" ng-switch-when="true"><span class="input-group-addon"><i class="glyphicon glyphicon-yen"></i> </span><input type="text" ng-disabled="vm.deletedFlg" class="form-control" ng-model="detail.workTimeDetail.busFee" ng-blur="vm.reCalculate()"></div></td><td style="vertical-align: middle" ng-switch="detail.workTimeDetail.midNight" ng-class="{true:\'midnight\'}[detail.workTimeDetail.midNight]"><span ng-switch-when="true">{{vm.format(detail.workTimeDetail.midNightTime)}}</span></td><td colspan="2"><span>{{detail.rawData[0].inTime| date:\'HH:mm\':vm.timezone}}<span ng-if="detail.rawData[0].inTime != null">\uFF5E</span>{{detail.rawData[0].outTime| date:\'HH:mm\':vm.timezone}}</span></td></tr><tr><td colspan="5" class="text-right">\u5408\u8A08</td><td>{{vm.salary.workHourStr}}</td><td>{{vm.salary.busFee}}</td><td>{{vm.salary.midNightTimeHourStr}}</td></tr></table><div class="row" style="margin-top: 10px;margin-left: 5px" ng-if="vm.data.detail.length == 0 || vm.userTimecardList.length == 0"><p><span class="time-format-error">\u8A72\u5F53\u30E6\u30FC\u30B6\u30FC\u304C{{vm.currentYear}}\u5E74{{vm.currentMonth}}\u6708\u306E\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093\u3002</span></p></div></div><div class="col-md-3"><ul class="list-inline"><li ng-repeat="user in vm.userTimecardList" ng-click="vm.changeUser(user.id,user.userName,user.deleted)" ng-class="{\'bg-info\' : vm.userId == user.id}" style="width:130px;margin-top: 10px"><span class="glyphicon glyphicon-user"></span> <span style="font-size:18px" ng-style="user.deleted && {\'background-color\': \'#9d9d9d\'}">{{user.userName}}</span></li></ul></div></div><div class="row" style="margin-top:10px" ng-if="vm.data.detail.length > 0 && vm.userTimecardList.length > 0"><div class="col-md-6"><table class="table table-bordered table-condensed"><colgroup><col width="10%"><col width="10%"><col width="10%"><col width="10%"><col width="10%"><col width="10%"></colgroup><tr><th colspan="6">\u7D66\u4E0E\u8A08\u7B97</th></tr><tr><td>\u6C0F\u540D</td><td colspan="5">{{vm.userName}}</td></tr><tr><td>\u57FA\u672C\u7D66</td><td colspan="5">{{vm.salary.hourSalary}}</td></tr><tr><td>\u51FA\u52E4\u65E5\u6570</td><td colspan="5">{{vm.salary.days}}</td></tr><tr><td>\u51FA\u52E4\u6642\u9593</td><td>{{vm.salary.workHourStr}}<span class="hide">[{{vm.salary.workHours}}/{{vm.salary.midNightTimeHours}}]</span></td><td>\u666E\u901A\u6B8B\u696D</td><td>{{vm.salary.overtime}}</td><td>\u6DF1\u591C\u6B8B\u696D</td><td>{{vm.salary.overtimeNight}}</td></tr><tr><td>\u696D\u52D9\u624B\u5F53</td><td colspan="5">{{vm.salary.extraSalary}}</td></tr><tr><td>\u6DF1\u591C\u624B\u5F53</td><td colspan="5">{{vm.salary.nightSalary}}</td></tr><tr><td>\u624B\u5F53\u984D\u5408\u8A08</td><td colspan="5">{{vm.salary.extraSalary + vm.salary.nightSalary}}</td></tr><tr><td>\u4EA4\u901A\u8CBB</td><td colspan="5">{{vm.salary.busFee}}</td></tr><tr><td>\u652F\u6255\u5408\u8A08</td><td colspan="5">{{vm.salary.totalSalary}}</td></tr></table></div></div></ng-form></uib-tab></uib-tabset></div>');
$templateCache.put('app/timecard/timecard-management/timecard-management.html','<div ng-cloak><div class="table-responsive"><div class="row" style="margin-bottom: 15px"><div class="col-md-3"><select class="col-md-3 form-control" ng-model="vm.groupId" ng-change="vm.changeGroup()"><option ng-repeat="pg in vm.parentGroup" value="{{pg.id}}">{{pg.name}}</option></select></div><div class="col-md-5"><button type="button" class="btn btn-success" data-translate="timecard.management.currentMonth" ng-click="vm.rest()">\u4ECA\u6708</button> <button type="button" class="btn btn-info" data-translate="timecard.management.beforeMonth" ng-click="vm.beforeMonth()"></button> <button type="button" class="btn btn-info" data-translate="timecard.management.nextMonth" ng-click="vm.nextMonth()"></button> <span style="margin-left:20px" class="text-primary"><strong>{{vm.currentYear}}\u5E74{{vm.currentMonth}}\u6708</strong></span> <span style="padding-left: 50px; font-size: 16px" data-translate="timecard.management.retired"></span> <input type="checkbox" ng-model="vm.retiredFlg" ng-click="vm.retired()"></div><div class="col-md-4" ng-if="vm.reportFlag"><button type="button" class="btn btn-danger pull-right" download-file="/timecard/export/{{vm.groupId}}/{{vm.currentYear}}/{{vm.currentMonth}}/{{vm.retiredFlg === true}}" down-file-type="xlsx">\u52E4\u52D9\u8A73\u7D30\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8</button> <button type="button" class="btn btn-danger pull-right" style="margin-right: 10px" download-file="/timecard/export/salary/{{vm.groupId}}/{{vm.currentYear}}/{{vm.currentMonth}}/{{vm.retiredFlg === true}}" down-file-type="xlsx">\u7D66\u4E0E\u8A73\u7D30\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8</button></div><div class="col-md-4" ng-if="!vm.reportFlag"><button disabled="disabled" type="button" class="btn btn-danger pull-right" download-file="/timecard/export/{{vm.groupId}}/{{vm.currentYear}}/{{vm.currentMonth}}" down-file-type="xlsx">\u52E4\u52D9\u8A73\u7D30\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8</button> <button disabled="disabled" type="button" class="btn btn-danger pull-right" style="margin-right: 10px" download-file="/timecard/export/salary/{{vm.groupId}}/{{vm.currentYear}}/{{vm.currentMonth}}" down-file-type="xlsx">\u7D66\u4E0E\u8A73\u7D30\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8</button></div></div><table class="table table-bordered table-striped table-condensed"><thead><tr><td class="text-center"><span style="vertical-align:middle; width: 30px">\u540D \u524D</span></td><td class="text-center calendar-header" ng-repeat="day in vm.calendar.days" ng-class="{\'sunday\':day.sunday,\'saturday\':day.saturday}">{{day.label}}<br>({{day.youbi}})</td></tr></thead><tbody ng-repeat="user in vm.userTimecardList"><tr style="height: 30px"><td rowspan="2" class="text-left" style="vertical-align: middle" ng-style="user.deleted && {\'background-color\':\'#eee\'}"><a ui-sref="timecard-management-detail({currentYear:vm.currentYear,currentMonth:vm.currentMonth,groupId:vm.groupId,userId:user.id,userName:user.userName,retiredFlg:vm.retiredFlg, deletedFlg:user.deleted})"><span>{{user.userName}}</span></a></td><td class="text-center" ng-repeat="timecard in user.timecards track by timecard.day" ng-class="{\'background_sunday_thin\':timecard.workTimeDetail.sunday,\'background_saturday_thin\':timecard.workTimeDetail.saturday}"><span>{{timecard.workTimeDetail.startTime | date:"HH:mm":vm.timezone}}</span></td></tr><tr style="height: 30px"><td class="text-center" ng-repeat="timecard in user.timecards track by timecard.day" ng-class="{\'background_sunday_thin\':timecard.workTimeDetail.sunday,\'background_saturday_thin\':timecard.workTimeDetail.saturday}"><span>{{timecard.workTimeDetail.endTime | date:"HH:mm":vm.timezone}}</span></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-click="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/corporation/staff/detail/staff-edit.html','<div><h2 class="modal-title">\u30A2\u30AB\u30A6\u30F3\u30C8</h2><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-2 control-label">\u4E8B\u696D\u6240CD</label><div class="col-md-4"><p class="form-control-static">{{vm.staff.jigyoushoCd}}</p></div><label class="col-md-2 control-label">\u4E8B\u696D\u6240\u540D</label><div class="col-md-4"><p class="form-control-static">{{vm.staff.jigyoushoNm}}</p></div></div><div class="form-group"><label class="col-md-2 control-label">LoginID</label><div class="col-md-4"><input type="text" class="form-control"></div><label class="col-md-2 control-label">Password</label><div class="col-md-4"><input type="text" class="form-control"></div></div><div class="form-group"><label class="col-md-2 control-label">\u59D3</label><div class="col-md-4"><input type="text" class="form-control"></div><label class="col-md-2 control-label">\u540D</label><div class="col-md-4"><input type="text" class="form-control"></div></div><div class="form-group"><label class="col-md-2 control-label">\u59D3\u30AB\u30CA</label><div class="col-md-4"><input type="text" class="form-control"></div><label class="col-md-2 control-label">\u540D\u30AB\u30CA</label><div class="col-md-4"><input type="text" class="form-control"></div></div><div class="form-group"><label class="col-md-2 control-label">\u88FD\u54C1ID</label><div class="col-md-4"><input type="text" class="form-control"></div><label class="col-md-2 control-label">\u88FD\u54C1\u540D</label><div class="col-md-4"><p class="form-control-static"></p></div></div><div class="form-group"><label class="col-md-2 control-label">\u5229\u7528\u958B\u59CB\u5E74\u6708\u65E5</label><div class="col-md-4"><input type="text" class="form-control"></div><label class="col-md-2 control-label">\u5229\u7528\u505C\u6B62FLG</label><div class="col-md-4 checkbox"><label><input type="checkbox" ng-model="vm.staff.useStop"></label></div></div><div class="form-group"><label class="col-md-2 control-label">\u8CA9\u58F2\u5E97ID</label><div class="col-md-4"><input type="text" class="form-control"></div><label class="col-md-2 control-label">\u8CA9\u58F2\u5E97\u540D</label><div class="col-md-4"><p class="form-control-static"></p></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="button" class="btn btn-primary" ng-click="vm.back()">\u30C7\u30FC\u30BF\u4F5C\u6210</button> <button type="button" class="btn btn-default" ng-click="vm.back()">\u623B\u308B</button></div></div></form></div>');
$templateCache.put('app/customer/license/staff/license-staff-manager.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-6 h2" data-translate="license.title.index">License</label></div><div class="form-group"><label class="col-md-1 control-label" data-translate="license.item.jigyousho">Jigyousho</label><div class="col-md-2 text-right"><select class="form-control" ng-model="vm.searchData.jigyoushoId" ng-change="vm.loadData()"><option ng-repeat="jigyousho in vm.jigyoushoList" value="{{jigyousho.jigyoushoId}}">{{jigyousho.jigyoushoCd}} {{jigyousho.jigyoushoNm}}</option></select></div><label class="col-md-1 control-label" data-translate="license.item.login">User Login ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.loginId"></div><label class="col-md-1 control-label" data-translate="license.item.name">User Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="button" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><h4 data-translate="license.item.licenseSum">License sum</h4><div class="row"><div class="col-md-2" ng-repeat="licenseUsed in vm.licenseUsedList"><b>{{licenseUsed.productNm}}:</b> {{licenseUsed.used}}/{{licenseUsed.total}}</div></div><hr><div ng-show="vm.noJigyousho" data-translate="license.text.noJigyousho"></div><div ng-show="!vm.noJigyousho"><table class="table table-striped"><colgroup><col width="30%"><col width="30%"><col width="30%"><col></colgroup><thead><tr><th data-translate="license.item.login">Login</th><th data-translate="license.item.name">Name</th><th data-translate="license.item.service">Service</th><th></th></tr></thead><tbody><tr ng-repeat="staff in vm.staffList"><td>{{staff.login}}</td><td>{{staff.name}}</td><td><p style="background-color: {{$index % 2 == 0 ? \'#d9edf7\' : \'#fcf8e3\'}}" ng-repeat="license in staff.licenseDTOList">{{license.productNm}}</p></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.edit({staffId: staff.id, jigyoushoId: vm.searchData.jigyoushoId, houjinId: vm.searchData.houjinId})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button></div></td></tr></tbody></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div></div>');
$templateCache.put('app/customer/license/staff/license-staff.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-6 h2" data-translate="license.title.index-staff">License</label></div><div class="form-group"><div class="col-md-1 text-right"><button type="button" class="btn btn-primary" ng-click="vm.selectHoujin()" data-translate="license.button.select-houjin">Select Houjin</button></div><div class="col-md-2 text-left" style="padding-top: 7px" ng-bind="vm.searchData.houjinNm"></div><label class="col-md-1 control-label" data-translate="license.item.jigyousho">Jigyousho</label><div class="col-md-2 text-right"><select class="form-control" ng-model="vm.searchData.jigyoushoId" ng-change="vm.loadData()"><option ng-repeat="jigyousho in vm.jigyoushoList" value="{{jigyousho.jigyoushoId}}">{{jigyousho.jigyoushoCd}} {{jigyousho.jigyoushoNm}}</option></select></div><label class="col-md-1 control-label" data-translate="license.item.login">User Login ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.loginId"></div><label class="col-md-1 control-label" data-translate="license.item.name">User Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="button" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><h4 data-translate="license.item.licenseSum">License sum</h4><div class="row"><div class="col-md-2" ng-repeat="licenseUsed in vm.licenseUsedList"><b>{{licenseUsed.productNm}}:</b> {{licenseUsed.used}}/{{licenseUsed.total}}</div></div><hr><div ng-show="vm.noJigyousho" data-translate="license.text.noJigyousho"></div><div ng-show="!vm.noJigyousho"><table class="table table-striped table-hover"><colgroup><col width="30%"><col width="30%"><col width="30%"><col></colgroup><thead><tr><th data-translate="license.item.login">Login</th><th data-translate="license.item.name">Name</th><th data-translate="license.item.service">Service</th><th></th></tr></thead><tbody><tr ng-repeat="staff in vm.staffList"><td>{{staff.login}}</td><td>{{staff.name}}</td><td><p style="background-color: {{$index % 2 == 0 ? \'#d9edf7\' : \'#fcf8e3\'}}" ng-repeat="license in staff.licenseDTOList">{{license.productNm}}</p></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.edit({staffId: staff.id, jigyoushoId: vm.searchData.jigyoushoId, houjinId: vm.searchData.houjinId})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button></div></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div></div>');
$templateCache.put('app/customer/license/user/license-user.html','<div><form class="form-horizontal" role="form"><div class="form-group"><label has-authority="ROLE_ADMIN" class="col-md-6 h2" data-translate="license.title.index-user">License</label><label has-authority="ROLE_USER" class="col-md-6 h2" data-translate="license.title.index">License</label></div><div class="form-group"><div class="col-md-2 text-right"><button type="button" class="btn btn-primary" ng-click="vm.selectGroup()" data-translate="license.button.select-group">Select Group</button></div><div class="col-md-2 text-left" style="padding-top: 7px" ng-bind="vm.searchData.groupNm"></div><label class="col-md-1 control-label" data-translate="license.item.login">User Login ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.loginId"></div><label class="col-md-1 control-label" data-translate="license.item.name">User Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="button" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><h4 data-translate="license.item.licenseSum">License sum</h4><div class="row"><div class="col-md-2" ng-repeat="licenseUsed in vm.licenseUsedList"><b>{{licenseUsed.productNm}}:</b> {{licenseUsed.used}}/{{licenseUsed.total}}</div></div><hr><div ng-show="vm.noGroup" data-translate="license.text.noGroup"></div><div ng-show="!vm.noGroup"><table class="table table-striped table-hover"><colgroup><col width="30%"><col width="30%"><col width="30%"><col></colgroup><thead><tr><th data-translate="license.item.login">Login</th><th data-translate="license.item.name">Name</th><th data-translate="license.item.service">Service</th></tr></thead><tbody><tr ng-repeat="user in vm.userList"><td>{{user.login}}</td><td>{{user.name}}</td><td><p style="background-color: {{$index % 2 == 0 ? \'#d9edf7\' : \'#fcf8e3\'}}" ng-repeat="license in user.licenseDTOList">{{license.productNm}}</p></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.edit({userId: user.id, groupId: vm.searchData.groupId})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="global.button.edit">Edit</span></button></div></td></tr></tbody></table><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div></div>');
$templateCache.put('app/master/application/dialog/contentValidation.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="caretreeApplication.validation.title">title</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="form-group" style="margin-bottom: 0px"><div class="col-md-3"></div><label style="text-align: left" class="col-md-9 control-label" data-translate="caretreeApplication.validation.index">Index</label></div><div class="form-group"><div class="col-md-3"></div><label style="text-align: left" class="col-md-9 control-label" data-translate="caretreeApplication.validation.indexOne">Index</label></div><div class="form-group"><label class="col-md-4 control-label" data-translate="caretreeApplication.validation.name">Name</label><div class="col-md-7"><p class="form-control-static" ng-bind="vm.inquiry.name"></p></div><div class="col-md-1"></div></div><div class="form-group"><label class="col-md-4 control-label" data-translate="caretreeApplication.item.houjinName">Houjin Name</label><div class="col-md-7"><p class="form-control-static" ng-bind="vm.inquiry.houjinName"></p></div><div class="col-md-1"></div></div><div class="form-group"><label class="col-md-4 control-label" data-translate="caretreeApplication.item.jigyoushoName">Jigyousho Name</label><div class="col-md-7"><p class="form-control-static" ng-bind="vm.inquiry.jigyoushoName"></p></div><div class="col-md-1"></div></div><div class="form-group"><label class="col-md-4 control-label" data-translate="caretreeApplication.validation.telephoneNumber">Telephone Number</label><div class="col-md-7"><p class="form-control-static" ng-bind="vm.inquiry.telephoneNumber"></p></div><div class="col-md-1"></div></div><div class="form-group"><label class="col-md-4 control-label" data-translate="caretreeApplication.item.emailAddress">Email Address</label><div class="col-md-7"><p class="form-control-static" ng-bind="vm.inquiry.emailAddress"></p></div><div class="col-md-1"></div></div><div class="form-group"><label class="col-md-4 control-label" data-translate="caretreeApplication.item.inquiryContents">Inquiry Contents</label><div class="col-md-7" style="word-break: break-all"><p class="form-control-static" ng-bind="vm.inquiry.inquiryContents"></p></div><div class="col-md-1"></div></div><div class="form-group"><label class="col-md-4 control-label" data-translate="caretreeApplication.validation.hope">Hope</label><div class="col-md-7"><p class="form-control-static" ng-bind="vm.checkList"></p></div><div class="col-md-1"></div></div><div class="form-group"><label class="col-md-4 control-label" data-translate="caretreeApplication.validation.sonata">Sonata</label><div class="col-md-7" style="word-break: break-all"><p class="form-control-static" ng-bind="vm.inquiry.sonata"></p></div><div class="col-md-1"></div></div></form></div><div class="modal-footer"><button style="width: 133px" type="button" class="btn btn-default search-button" ng-click="vm.close()" data-translate="caretreeApplication.button.cancel">Cancel</button> <button type="button" class="btn btn-primary search-button" ng-click="vm.save()" data-translate="caretreeApplication.button.sendEmail">Save</button></div>');
$templateCache.put('app/master/group/dialog/group-select-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="group.title.index">Group</h4></div><div class="modal-body"><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-2 control-label" data-translate="group.item.id">ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.id"></div><label class="col-md-2 control-label" data-translate="group.item.name">Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><table class="table table-striped table-hover table-dialog"><thead><tr><th width="20%" data-translate="group.item.id">ID</th><th width="70%" data-translate="group.item.name">Name</th><th></th></tr></thead><tbody><tr ng-repeat="group in vm.groupList"><td width="20%">{{group.id}}</td><td width="70%">{{group.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.select(group)" class="btn btn-primary btn-sm" data-translate="global.button.select">Select</button></div></td></tr></tbody></table><div class="text-center" ng-if="vm.groupList.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div>');
$templateCache.put('app/master/houjin/dialog/houjin-select-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="houjin.title.index">Houjin</h4></div><div class="modal-body"><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-2 control-label" data-translate="houjin.item.name">Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div><label class="col-md-2 control-label" data-translate="houjin.item.code">Code</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.code"></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="houjin.item.jigyoushoId">Jigyousho ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.jigyoushoId"></div><label class="col-md-2 control-label" data-translate="houjin.item.id">ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.id"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><table class="table table-striped table-hover table-dialog"><thead><tr><th width="20%" data-translate="houjin.item.id">ID</th><th width="20%" data-translate="houjin.item.code">Code</th><th width="30%" data-translate="houjin.item.name">Name</th><th width="20%" data-translate="houjin.item.jigyoushoId">Jigyousho ID</th><th></th></tr></thead><tbody><tr ng-repeat="houjin in vm.houjinList"><td width="20%">{{houjin.id}}</td><td width="20%">{{houjin.code}}</td><td width="30%">{{houjin.name}}</td><td width="20%">{{houjin.jigyoushoId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.select(houjin)" class="btn btn-primary btn-sm" data-translate="global.button.select">Select</button></div></td></tr></tbody></table><div class="text-center" ng-if="vm.houjinList.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div>');
$templateCache.put('app/master/license/dialog/license-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.license.dbId)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="license.deleteMessage">Confirm delete operation</h4></div><div class="modal-body" style="overflow:hidden; word-wrap:break-word;word-break: break-all"><jhi-alert-error></jhi-alert-error><p ng-if="vm.version == 1" data-translate="license.delete.question1" translate-values="{gid: \'{{vm.license.id}}\', gname: \'{{vm.groupEntity.houjinNm}}\', productName: \'{{vm.productEntity.productName}}\', shopName: \'{{vm.license.shopNm}}\', licenseCount: \'{{vm.license.licenseCount}}\', price: \'{{vm.license.price | currency:\'\xA5\':0}}\'}">Are you sure you want to delete this license?</p><p ng-if="vm.version == 2" data-translate="license.delete.question2" translate-values="{gid: \'{{vm.license.id}}\', gname: \'{{vm.groupEntity.name}}\', productName: \'{{vm.productEntity.productName}}\', shopName: \'{{vm.license.shopNm}}\', licenseCount: \'{{vm.license.licenseCount}}\', price: \'{{vm.license.price | currency:\'\xA5\':0}}\'}">Are you sure you want to delete this license?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/master/license/dialog/license-edit-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="license.title.add" ng-if="!vm.editFlag">License</h4><h4 class="modal-title" data-translate="license.title.edit" ng-if="vm.editFlag">License</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><!--<div class="form-group">--><!--<div class="col-md-2"></div>--><!--<div class="col-md-10 checkbox">--><!--<label><input type="radio" ng-model="vm.license.version" value="1" ng-change="vm.changeVersion()" ></label>--><!--<label>1.0</label>--><!--<label><input type="radio"  ng-model="vm.license.version" value="2" ng-change="vm.changeVersion()"></label>--><!--<label>2.0</label>--><!--</div>--><!--</div>--><div class="form-group"><label class="col-md-2 control-label" ng-bind="vm.idText">ID</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.license.id"></p><input type="hidden" name="id" ng-model="vm.license.id" required></div><label class="col-md-2 control-label" ng-bind="vm.nmText">Name</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.license.name"></p></div><div class="col-md-2 text-right"><button ng-if="vm.license.version == 1" type="button" class="btn btn-primary form-control" ng-click="vm.selectHoujin()" data-translate="license.button.select-houjin">Select Buyer</button> <button ng-if="vm.license.version == 2" type="button" class="btn btn-primary form-control" ng-click="vm.selectGroup()" data-translate="license.button.select-group">Select Buyer</button></div><div class="col-md-10"><div ng-show="editForm.id.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.id.$error.required" data-translate="entity.validation.selected">This field must be selected.</p></div></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="license.item.productId">Product ID</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.license.productId"></p><input type="hidden" name="productId" ng-model="vm.license.productId" required></div><label class="col-md-2 control-label" data-translate="license.item.productNm">Product Name</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.license.productNm"></p></div><div class="col-md-2 text-right"><button type="button" class="btn btn-primary form-control" ng-click="vm.selectProduct()" data-translate="license.button.select-product">Select Product</button></div><div class="col-md-10"><div ng-show="editForm.productId.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.productId.$error.required" data-translate="entity.validation.selected">This field must be selected.</p></div></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="license.item.shopId">Shop ID</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.license.shopId"></p><input type="hidden" name="shopId" ng-model="vm.license.shopId" required></div><label class="col-md-2 control-label" data-translate="license.item.shopNm">Shop Name</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.license.shopNm"></p></div><div class="col-md-2 text-right"><button type="button" class="btn btn-primary form-control" ng-click="vm.selectShop()" data-translate="license.button.select-shop">Select Shop</button></div><div class="col-md-10"><div ng-show="editForm.shopId.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.shopId.$error.required" data-translate="entity.validation.selected">This field must be selected.</p></div></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="license.item.startDate">Start Date</label><div class="col-md-3"><p class="input-group"><input type="text" id="startDate" name="startDate" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" ng-model="vm.license.startDate" is-open="vm.isOpenStartDate" required ng-pattern="/^(\\d{1,4})(-|\\/)(\\d{1,2})\\2(\\d{1,2})$/"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(1)"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p><div ng-show="editForm.startDate.$invalid" class="has-error small" id="startDateCheck"><p class="help-block" ng-show="editForm.startDate.$error.required" data-translate="entity.validation.selected">This field must be selected.</p><p class="help-block" ng-show="editForm.startDate.$error.pattern" data-translate="entity.validation.date">This field should be a date.</p></div></div><label class="col-md-2 control-label" data-translate="license.item.endDate">End Date</label><div class="col-md-3"><p class="input-group"><input type="text" id="endDate" name="endDate" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" ng-model="vm.license.endDate" is-open="vm.isOpenEndDate" ng-pattern="/^(\\d{1,4})(-|\\/)(\\d{1,2})\\2(\\d{1,2})$/"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(2)"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p><div ng-show="editForm.endDate.$invalid" class="has-error small" id="endDateCheck"><p class="help-block" ng-show="editForm.endDate.$error.pattern" data-translate="entity.validation.date">This field should be a date.</p></div><div ng-show="vm.endDateCheckShow" class="has-error small"><p class="help-block" data-translate="entity.validation.endDateCompare">End date should after start date.</p></div></div></div><!--<div class="form-group">\n            <div class="col-md-2"></div>\n            <label class="col-md-2 control-label" data-translate="license.item.endDate">End Date</label>\n            <div class="col-md-4">\n                <p class="input-group">\n                    <input type="text" id="endDate" name="endDate" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" ng-model="vm.license.endDate" is-open="vm.isOpenEndDate"\n                           ng-pattern="/^(\\d{1,4})(-|\\/)(\\d{1,2})\\2(\\d{1,2})$/" />\n                    <span class="input-group-btn">\n                        <button type="button" class="btn btn-default" ng-click="vm.openCalendar(2)"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button>\n                    </span>\n                </p>\n                <div ng-show="editForm.endDate.$invalid" class="has-error small" id="endDateCheck">\n                    <p class="help-block" ng-show="editForm.endDate.$error.pattern" data-translate="entity.validation.date">\n                        This field should be a date.\n                    </p>\n                </div>\n                <div ng-show="vm.endDateCheckShow" class="has-error small">\n                    <p class="help-block" data-translate="entity.validation.endDateCompare">\n                        End date should after start date.\n                    </p>\n                </div>\n            </div>\n        </div>--><div class="form-group"><label class="col-md-2 control-label" data-translate="license.item.licenseCount">Count</label><div class="col-md-3"><input type="number" name="licenseCount" class="form-control" ng-model="vm.license.licenseCount" required ng-pattern="/^[1-9]\\d*$|0$/" ng-maxlength="9"><div ng-show="editForm.licenseCount.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.licenseCount.$error.required" data-translate="entity.validation.selected">This field must be selected.</p><p class="help-block" ng-show="editForm.licenseCount.$error.pattern || editForm.licenseCount.$error.number" data-translate="entity.validation.pattern.num">This field should be a number.</p><p class="help-block" ng-show="editForm.licenseCount.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="9">This field cannot be longer than 9 characters.</p></div></div><label class="col-md-2 control-label" data-translate="license.item.priceNew">priceNew</label><div class="col-md-3"><input type="text" name="price" class="form-control" ng-model="vm.license.price" placeholder="{{vm.referencePrice}}" required ng-pattern="/^[1-9]\\d*$|0$/" format-price ng-maxlength="12"><div ng-show="editForm.price.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.price.$error.required" data-translate="entity.validation.selected">This field must be selected.</p><p class="help-block" ng-show="editForm.price.$error.pattern || editForm.price.$error.number" data-translate="entity.validation.pattern.num">This field should be a number.</p><p class="help-block" ng-show="editForm.price.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div></div><!--<div class="form-group">\n            <label class="col-md-2 control-label" data-translate="license.item.price">Price</label>\n            <div class="col-md-4">\n                <input type="text" name="price" class="form-control" ng-model="vm.license.price" placeholder="{{vm.referencePrice}}"\n                       required ng-pattern="/^[1-9]\\d*$|0$/" format-price>\n                <div ng-show="editForm.price.$invalid" class="has-error small">\n                    <p class="help-block" ng-show="editForm.price.$error.required" data-translate="entity.validation.selected">\n                        This field must be selected.\n                    </p>\n                    <p class="help-block" ng-show="editForm.price.$error.pattern || editForm.price.$error.number" data-translate="entity.validation.pattern.num">\n                        This field should be a number.\n                    </p>\n                </div>\n            </div>\n        </div>--><div class="form-group"><label class="col-md-2 control-label" data-translate="license.item.feePlanSelect">Fee Plan Select</label><div class="col-md-3"><select ng-model="vm.license.planId" ng-options="keiyakuplan.planId as keiyakuplan.planNm for keiyakuplan in vm.keiyakuplanList" class="form-control ng-pristine ng-untouched ng-valid ng-not-empty"></select></div><div class="col-md-2"></div><div class="col-md-3 checkbox" ng-if="vm.editFlag"><label class="ng-binding ng-scope"><input type="checkbox" ng-model="vm.license.stopFlag">{{\'stopFlag\' | translate}}</label></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.close()" data-translate="global.button.cancel">Cancel</button> <button type="button" class="btn btn-primary" ng-click="vm.save()" ng-disabled="editForm.$invalid" data-translate="global.button.save">Save</button></div>');
$templateCache.put('app/master/price/dialog/price-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.price.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="price.delete.question" translate-values="{productId: \'{{vm.product.id}}\', name: \'{{vm.product.productName}}\', date: \'{{vm.price.startDate | date: \'yyyy/MM/dd\'}}\', price: \'{{vm.price.price}}\'}">Are you sure you want to delete this price?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/master/price/dialog/price-edit-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="price.title.add" ng-if="vm.price.id == null || vm.price.id == \'\'">Price Add</h4><h4 class="modal-title" data-translate="price.title.edit" ng-if="vm.price.id != null && vm.price.id != \'\'">Price Edit</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="form-group"><label class="col-md-3 control-label" data-translate="price.item.product">Price</label><div class="col-md-9"><button type="button" class="btn btn-primary" ng-click="vm.select()" data-translate="global.button.select">Select</button> <button type="button" class="btn btn-default" ng-click="vm.clear()" data-translate="global.button.clear">Clear</button></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="price.item.product-id">Product ID</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.price.productId"></p><input type="hidden" name="product" ng-model="vm.price.productId" required></div><label class="col-md-3 control-label" data-translate="price.item.product-name">Product Name</label><div class="col-md-3"><p class="form-control-static" ng-bind="vm.price.productNm"></p></div><div class="col-md-3"></div><div class="col-md-9"><div ng-show="editForm.product.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.product.$error.required" data-translate="entity.validation.selected">This field must be selected.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="price.item.price">Price</label><div class="col-md-6"><input type="text" name="price" class="form-control" ng-model="vm.price.price" required ng-pattern="/^[1-9]\\d*$|0$/" ng-maxlength="10" format-price><div ng-show="editForm.price.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.price.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.price.$error.pattern || editForm.price.$error.number" data-translate="entity.validation.pattern.num">This field should be a number.</p><p class="help-block" ng-show="editForm.price.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10">This field cannot be longer than 10 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="price.item.start-date">Start date</label><div class="col-md-6"><p class="input-group"><input type="text" id="startDate" name="startDate" class="form-control" enable-time="false" datetime-picker="yyyy/MM/dd" ng-model="vm.price.startDate" is-open="vm.isOpen" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar()"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p><div ng-show="editForm.startDate.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.startDate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="price.item.stop-flag">Stop flag</label><div class="col-md-3 checkbox"><label><input type="checkbox" ng-model="vm.price.stopFlag"></label></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.close()" data-translate="global.button.cancel">Cancel</button> <button type="button" class="btn btn-primary" ng-click="vm.save()" ng-disabled="editForm.$invalid" data-translate="global.button.save">Save</button></div>');
$templateCache.put('app/master/product/dialog/product-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.product.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="product.deleteMessage">Confirm delete operation</h4></div><div class="modal-body" style="overflow:hidden; word-wrap:break-word;word-break: break-all"><jhi-alert-error></jhi-alert-error><p data-translate="product.delete.question" translate-values="{id: \'{{vm.product.id}}\', name: \'{{vm.product.productName}}\', type: \'{{vm.productType.name}}\'}">Are you sure you want to delete this product?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/master/product/dialog/product-edit-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="product.title.add" ng-if="vm.product.id == null || vm.product.id == \'\'">Product Add</h4><h4 class="modal-title" data-translate="product.title.edit" ng-if="vm.product.id != null && vm.product.id != \'\'">Product Edit</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="form-group" ng-if="vm.product.id != null && vm.product.id != \'\'"><label class="col-md-3 control-label" data-translate="product.item.id">ID</label><div class="col-md-8 control-label"><span class="pull-left" ng-bind="vm.product.id"></span></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="product.item.name">Name</label><div class="col-md-8"><input type="text" class="form-control" name="productName" ng-model="vm.product.productName" required ng-maxlength="20"><div ng-show="editForm.productName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.productName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.productName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="product.item.kana">Kana</label><div class="col-md-8"><input type="text" class="form-control" name="productKana" ng-model="vm.product.productKana" ng-maxlength="50"><div ng-show="editForm.productKana.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.productKana.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="product.item.kind">Kind</label><div class="col-md-8"><select class="form-control" ng-model="vm.product.productType" name="productType" ng-change="vm.showLicenseType()" required ng-options="productType.id as productType.name for productType in vm.productTypeList"></select><div ng-show="editForm.productType.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.productType.$error.required" data-translate="entity.validation.selected">This field is required.</p></div></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="product.item.price">Price</label><div class="col-md-8"><input ng-pattern="/^[1-9]\\d*$|0$/" format-price type="text" class="form-control" name="price" ng-model="vm.product.price" required ng-maxlength="12"><div ng-show="editForm.price.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.price.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.price.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="12">This field cannot be longer than 12 characters.</p></div></div></div><div class="form-group"><div class="col-md-3 control-label"></div><div class="col-md-8 checkbox" ng-if="vm.editFlag"><label class="ng-binding ng-scope"><input type="checkbox" ng-model="vm.product.stopFlag">{{\'stopFlag\' | translate}}</label></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.close()" data-translate="global.button.cancel">Cancel</button> <button type="button" class="btn btn-primary" ng-click="vm.save()" ng-disabled="editForm.$invalid" data-translate="global.button.save">Save</button></div>');
$templateCache.put('app/master/product/dialog/product-select-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="product.title.dialog">Product</h4></div><div class="modal-body"><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-1 control-label" data-translate="product.item.id">ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.id"></div><label class="col-md-1 control-label" data-translate="product.item.name">Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div><label class="col-md-2 control-label" data-translate="product.item.kind">Kind</label><div class="col-md-2"><select class="form-control" ng-model="vm.searchData.kind" ng-options="kind.id as kind.name for kind in vm.productTypeList"><option></option></select></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><table class="table table-striped table-hover table-dialog"><thead><tr style=""><th width="10%" data-translate="product.item.id">ID</th><th width="40%" data-translate="product.item.name">Name</th><th width="30%" data-translate="product.item.kind">Kind</th><th width="10%" data-translate="product.item.count">Min count</th><th></th></tr></thead><tbody><tr ng-repeat="product in vm.productList"><td width="10%">{{product.id}}</td><td width="40%">{{product.name}}</td><td width="30%">{{product.kind}}</td><td width="10%" class="text-right">{{product.minCount}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.select(product)" class="btn btn-primary btn-sm" data-translate="global.button.select">Select</button></div></td></tr></tbody></table><div class="text-center" ng-if="vm.productList.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div>');
$templateCache.put('app/master/productType/dialog/productType-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.productType.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body" style="overflow:hidden; word-wrap:break-word;word-break: break-all"><div class="alert alert-danger ng-scope" ng-if="vm.error"><strong data-translate="productType.delete.deletedError" class="ng-scope"></strong></div><jhi-alert-error></jhi-alert-error><p data-translate="productType.delete.question" translate-values="{id: \'{{vm.productType.id}}\', name: \'{{vm.productType.name}}\'}">Are you sure you want to delete this product type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/master/productType/dialog/productType-edit-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="productType.title.add" ng-if="vm.productType.id == null || vm.productType.id == \'\'">Product type Add</h4><h4 class="modal-title" data-translate="productType.title.edit" ng-if="vm.productType.id != null && vm.productType.id != \'\'">Product type edit</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="form-group" ng-if="vm.productType.id != null && vm.productType.id != \'\'"><label class="col-md-3 control-label" data-translate="productType.item.id">ID</label><div class="col-md-8 control-label"><span class="pull-left" ng-bind="vm.productType.id"></span></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="productType.item.name">Name</label><div class="col-md-8"><input type="text" class="form-control" name="name" ng-model="vm.productType.name" required ng-maxlength="50" check-product-type-repeat="vm.productType.id"><div ng-show="editForm.name.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.name.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.name.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p><p class="help-block" ng-show="editForm.name.$error.productTypeRepeat" data-translate="entity.validation.exited">This field have exited.</p></div></div><div class="col-md-1"></div></div><!--<div class="form-group">\n            <label class="col-md-3 control-label" data-translate="productType.item.type">Type</label>\n            <div class="col-md-8">\n               &lt;!&ndash; <select class="form-control" ng-model="vm.productType.licenseType" ng-options="type.id as type.value for type in vm.types">\n                </select>&ndash;&gt;\n                <label style="margin-top:5px;">\n                    <input type="radio" ng-model="vm.productType.licenseType"  ng-value="2">\u30D7\u30ED\u30C0\u30AF\u30C8\u30E9\u30A4\u30BB\u30F3\u30B9\n                </label>\n                <label style="margin-left:10px;margin-top:5px;">\n                    <input type="radio" ng-model="vm.productType.licenseType"  ng-value="1">\u30A2\u30AB\u30A6\u30F3\u30C8\u30E9\u30A4\u30BB\u30F3\u30B9\n                </label>\n            </div>\n            <div class="col-md-1"></div>\n        </div>--><div class="form-group"><label class="col-md-3 control-label" data-translate="productType.item.authority">Authority</label><div class="col-md-8"><div class="input-group"><div class="input-group-addon"><span class="glyphicon glyphicon-search"></span></div><input type="text" class="form-control" ng-model="vm.authority" ng-change="vm.searchAuthority()"></div></div><div class="col-md-1"></div></div><div class="form-group"><label class="col-md-3 control-label" data-translate="productType.item.authoritySelect">Authority Name</label><div class="col-md-6" id="aDiv" style="border: 1px solid black; width: 568px;height: 200px;margin-left: 15px;font-size: 16px;overflow: auto"><div class="checkbox" ng-repeat="fun in vm.productType.kinouList" ng-show="fun.showFlag"><label><input ng-model="fun.checked" ng-checked="fun.checked" type="checkbox" id="{{fun.id}}" name="{{fun.name}}"> &nbsp<span style="word-break: break-all">{{fun.name}}</span></label></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.close()" data-translate="global.button.cancel">Cancel</button> <button type="button" class="btn btn-primary" ng-click="vm.save()" ng-disabled="editForm.$invalid" data-translate="global.button.save">Save</button></div>');
$templateCache.put('app/master/shop/dialog/shop-edit-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">\u8CA9\u58F2\u5E97\u30DE\u30B9\u30BF\u30FC\u4F5C\u6210</h4></div><div class="modal-body"><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-4 control-label">\u8CA9\u58F2\u5E97ID</label><div class="col-md-8"><input type="text" class="form-control"></div></div><div class="form-group"><label class="col-md-4 control-label">\u8CA9\u58F2\u5E97\u540D</label><div class="col-md-8"><input type="text" class="form-control"></div></div><div class="form-group"><label class="col-md-4 control-label">TEL</label><div class="col-md-8"><input type="text" class="form-control"></div></div><div class="form-group"><label class="col-md-4 control-label">FAX</label><div class="col-md-8"><input type="text" class="form-control"></div></div><div class="form-group"><label class="col-md-4 control-label">\u62C5\u5F53\u8005\u90E8\u7F72</label><div class="col-md-8"><input type="text" class="form-control"></div></div><div class="form-group"><label class="col-md-4 control-label">\u62C5\u5F53\u8005\u540D</label><div class="col-md-8"><input type="text" class="form-control"></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.clear()">\u30C7\u30FC\u30BF\u4F5C\u6210</button> <button type="button" class="btn btn-default" ng-click="vm.clear()">\u623B\u308B</button></div>');
$templateCache.put('app/master/shop/dialog/shop-select-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="shop.title.index">Shop</h4></div><div class="modal-body"><form class="form-horizontal" role="form"><div class="form-group"><label class="col-md-2 control-label" data-translate="shop.item.id">ID</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.id"></div><label class="col-md-2 control-label" data-translate="shop.item.name">Name</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.name"></div><label class="col-md-2 control-label" data-translate="shop.item.person">Person</label><div class="col-md-2"><input type="text" class="form-control" ng-model="vm.searchData.person"></div></div><div class="form-group"><div class="col-md-12 text-center"><button type="submit" class="btn btn-primary" ng-click="vm.search()"><span class="glyphicon glyphicon-search"></span> <span data-translate="global.button.search">Search</span></button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-refresh"></span> <span data-translate="global.button.clear">Clear</span></button></div></div></form><hr><table class="table table-striped table-hover table-dialog"><thead><tr><th data-translate="shop.item.id">ID</th><th data-translate="shop.item.name">Name</th><th data-translate="shop.item.tel">Tel</th><th data-translate="shop.item.fax">Fax</th><th data-translate="shop.item.branch">Branch</th><th data-translate="shop.item.person">Person</th><th></th></tr></thead><tbody><tr ng-repeat="shop in vm.shopList"><td>{{shop.id}}</td><td>{{shop.name}}</td><td>{{shop.tel}}</td><td>{{shop.fax}}</td><td>{{shop.branch}}</td><td>{{shop.person}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button ng-click="vm.select(shop)" class="btn btn-primary btn-sm" data-translate="global.button.select">Select</button></div></td></tr></tbody></table><div class="text-center" ng-if="vm.shopList.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadData()"></uib-pagination></div></div>');
$templateCache.put('app/system/riyousha/qrcode/qrcode-detail.html','<meta charset="utf-8"><style media="print">@page {\n        size: auto;\n        margin: 0mm;\n    }</style><div><h2><span data-translate="riyousha.detail.title">User</span></h2><div class="form-group"><input style="margin-right: 4px" type="checkbox" ng-change="vm.reload()" ng-model="vm.before"> <span data-translate="riyousha.detail.before" ng-click="vm.beforeClick()"></span></div><jhi-alert-error></jhi-alert-error><div class="row" style="margin-bottom: 12px"><div class="col-md-12" ng-show="vm.showButtonFlag"><div class="text-center"><button type="button" ui-sref="qrcode" class="btn btn-success"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" class="btn btn-danger" onclick="printRiyousha();"><span class="glyphicon glyphicon-print"><span data-translate="riyousha.qrcode.print">Print</span></span></button> <button type="button" class="btn btn-danger" onclick="printAllRiyousha();"><span class="glyphicon glyphicon-print"><span data-translate="riyousha.qrcode.allRiyoushoPrint">Print</span></span></button></div></div></div><div class="row"><div style="width: 760px; height:1016px;margin: 0 auto"><div class="row" style="padding-left: 7%;padding-top: 55px" ng-show="vm.showButtonFlag"><h4><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h4><h4><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h4></div><div style="float: left; width: 25%; text-align: center" ng-repeat="riyousha in vm.riyoushaList"><div><img src="data:image/png;base64,{{riyousha.qrcode}}" style="height: 145px;width: 145px"></div><div class="text-center">{{riyousha.sei}}{{riyousha.mei}}</div></div></div></div><div class="row" style="margin-top: 12px"><div class="col-md-12" ng-show="vm.showButtonFlag"><div class="text-center"><button type="button" ui-sref="qrcode" class="btn btn-success"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" class="btn btn-danger" onclick="printRiyousha();"><span class="glyphicon glyphicon-print"><span data-translate="riyousha.qrcode.print">Print</span></span></button> <button type="button" class="btn btn-danger" onclick="printAllRiyousha();"><span class="glyphicon glyphicon-print"><span data-translate="riyousha.qrcode.allRiyoushoPrint">Print</span></span></button></div></div></div><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.load()"></uib-pagination></div></div><div id="allRiyoushaSafrai" style="display: none"><div ng-repeat="r in vm.riyoushaAllList" ng-if="($index%20==0 || $index==0) && $index/20+1 != vm.pageCount" style="clear: both; page-break-after: always"><div style="clear: both; height: 5px"></div><div class="row" style="padding-left: 5%;clear: both" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top:1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center; padding-top: -10px" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="resultAll in vm.riyoushaAllList"><div><img src="data:image/png;base64,{{resultAll.qrcode}}" style="height: 140px;width: 140px"></div><div class="text-center">{{resultAll.sei}}{{resultAll.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 10px">{{$parent.$index/20+1}}/{{vm.pageCount}}</div></div><div ng-repeat="r in vm.riyoushaAllList" ng-if="$index/20+1 == vm.pageCount"><div class="row" style="padding-left: 5%;clear: both" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top:1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center; padding-top: -10px" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="resultAll in vm.riyoushaAllList"><div><img src="data:image/png;base64,{{resultAll.qrcode}}" style="height: 140px;width: 140px"></div><div class="text-center">{{resultAll.sei}}{{resultAll.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 10px">{{$parent.$index/20+1}}/{{vm.pageCount}}</div></div></div><div id="riyoushaSafari" style="display: none"><div ng-repeat="r in vm.riyoushaList" ng-if="$index%20==0 || $index==0" style="clear: both"><div style="clear: both; height: 5px"></div><div class="row" style="padding-left: 5%;clear: both" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top: 1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center;padding-top: -10px" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="riyousha in vm.riyoushaList"><div><img src="data:image/png;base64,{{riyousha.qrcode}}" style="height: 140px;width: 140px"></div><div class="text-center">{{riyousha.sei}}{{riyousha.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 10px">{{vm.page}}/{{vm.pageCount}}</div></div></div><div id="allRiyoushaChrome" style="display: none"><div ng-repeat="r in vm.riyoushaAllList" ng-if="$index%20==0 || $index==0" style="clear: both; page-break-after: always"><div style="clear: both; height: 5px"></div><div class="row" style="padding-left: 5%;clear: both" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top:1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center; padding-top: -4px" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="resultAll in vm.riyoushaAllList"><div><img src="data:image/png;base64,{{resultAll.qrcode}}" style="height: 145px;width: 145px"></div><div class="text-center">{{resultAll.sei}}{{resultAll.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 30px">{{$parent.$index/20+1}}/{{vm.pageCount}}</div></div></div><div id="riyoushaChrome" style="display: none"><div ng-repeat="r in vm.riyoushaList" ng-if="$index%20==0 || $index==0" style="clear: both"><div style="clear: both; height: 5px"></div><div class="row" style="padding-left: 5%;clear: both" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top: 1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center;padding-top: -4px" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="riyousha in vm.riyoushaList"><div><img src="data:image/png;base64,{{riyousha.qrcode}}" style="height: 145px;width: 145px"></div><div class="text-center">{{riyousha.sei}}{{riyousha.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 30px">{{vm.page}}/{{vm.pageCount}}</div></div></div><div id="allRiyoushaFirefox" style="display: none"><div ng-repeat="r in vm.riyoushaAllList" ng-if="($index%20==0 || $index==0) && $index/20+1 != vm.pageCount" style="clear: both; page-break-after: always"><div style="clear: both; height: 5px"></div><div class="row" style="padding-left: 5%;clear: both" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top: 1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center; padding-top: -4px" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="resultAll in vm.riyoushaAllList"><div><img src="data:image/png;base64,{{resultAll.qrcode}}" style="height: 145px;width: 145px"></div><div class="text-center">{{resultAll.sei}}{{resultAll.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 30px">{{$parent.$index/20+1}}/{{vm.pageCount}}</div></div><div ng-repeat="r in vm.riyoushaAllList" ng-if="$index/20+1 == vm.pageCount"><div style="clear: both; height: 5px"></div><div class="row" style="padding-left: 5%;clear: both" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top: 1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center; padding-top: -4px" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="resultAll in vm.riyoushaAllList"><div><img src="data:image/png;base64,{{resultAll.qrcode}}" style="height: 145px;width: 145px"></div><div class="text-center">{{resultAll.sei}}{{resultAll.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 30px">{{$parent.$index/20+1}}/{{vm.pageCount}}</div></div></div><div id="riyoushaFirefox" style="display: none"><div ng-repeat="r in vm.riyoushaList" ng-if="$index%20==0 || $index==0" style="clear: both"><div style="clear: both; height: 5px"></div><div class="row" style="padding-left: 5%;clear: both" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top: 1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center;padding-top: -6px" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="riyousha in vm.riyoushaList"><div><img src="data:image/png;base64,{{riyousha.qrcode}}" style="height: 145px;width: 145px"></div><div class="text-center">{{riyousha.sei}}{{riyousha.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 30px">{{vm.page}}/{{vm.pageCount}}</div></div></div><div id="allRiyoushaIe" style="display: none"><div ng-repeat="r in vm.riyoushaAllList" ng-if="$index%20==0 || $index==0" style="clear: both; page-break-after: always"><div style="clear: both; height: 5px"></div><div class="row" style="padding-left: 5%;clear: both;padding-top: 40px" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top:1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="resultAll in vm.riyoushaAllList"><div><img src="data:image/png;base64,{{resultAll.qrcode}}" style="height: 145px;width: 145px"></div><div class="text-center">{{resultAll.sei}}{{resultAll.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 30px">{{$parent.$index/20+1}}/{{vm.pageCount}}</div></div></div><div id="riyoushaIe" style="display: none"><div ng-repeat="r in vm.riyoushaList" ng-if="$index%20==0 || $index==0" style="clear: both"><div style="clear: both; height: 5px"></div><div class="row" style="padding-left: 5%;clear: both;padding-top: 40px" ng-if="$parent.$index == 0 || $parent.$index%20==0"><h2 style="margin-bottom:1px"><span data-translate="riyousha.detail.groupName">groupName</span>{{vm.riyoushaList[0].groupName}}<br></h2><h2 style="margin-top: 1px"><span data-translate="riyousha.detail.jigyoushoCd">jigyoushoCd</span>{{vm.riyoushaList[0].jigyoushoCd}}<br></h2></div><div style="float: left; width: 25%; text-align: center" ng-if="$parent.$index<=$index && $index<$parent.$index+20" ng-repeat="riyousha in vm.riyoushaList"><div><img src="data:image/png;base64,{{riyousha.qrcode}}" style="height: 145px;width: 145px"></div><div class="text-center">{{riyousha.sei}}{{riyousha.mei}}</div></div><div style="clear: both;text-align: center;padding-top: 30px">{{vm.page}}/{{vm.pageCount}}</div></div></div><script type="text/javascript">function  printAllRiyousha(){\n        var explorer = window.navigator.userAgent ;\n        var el = "";\n        var u = window.navigator.userAgent.toLocaleLowerCase(),\n        ie11 = /(trident)\\/([\\d.]+)/,\n        b = u.match(ie11);\n\n        if(explorer.indexOf("Safari") >= 0 && explorer.indexOf("Chrome") < 0) {\n            el = document.getElementById("allRiyoushaSafrai");\n        }else if(explorer.indexOf("Chrome") >= 0){\n            el = document.getElementById("allRiyoushaChrome");\n        }else if(explorer.indexOf("Firefox") >= 0) {\n            el = document.getElementById("allRiyoushaFirefox");\n        }else if(explorer.indexOf("MSIE") >= 0 || b){\n            el = document.getElementById("allRiyoushaIe");\n        }\n\n        iframe = document.createElement(\'IFRAME\');\n        var doc = null;\n        iframe.setAttribute("id", "print-iframe");\n        document.body.appendChild(iframe);\n        doc = iframe.contentWindow.document;\n        doc.write(\'<div>\' + el.innerHTML + \'</div>\');\n        doc.close();\n        iframe.contentWindow.focus();\n        if(explorer.indexOf("MSIE") >= 0 || b){\n            iframe.contentDocument.body.insertAdjacentHTML(\'beforeend\', \'<div id ="iePrint" onclick ="window.focus(); window.print();"></div>\');\n            setTimeout(function(){\n                var printButton = iframe.contentDocument.getElementById(\'iePrint\');\n                printButton.click();\n                document.body.removeChild(iframe);\n            },1000);\n        }else{\n            iframe.contentWindow.print();\n            setTimeout(function(){\n                document.body.removeChild(iframe);\n            },1000);\n        }\n    }\n    function printRiyousha(){\n        var explorer = window.navigator.userAgent;\n        var el = "";\n        var u = window.navigator.userAgent.toLocaleLowerCase(),\n        ie11 = /(trident)\\/([\\d.]+)/,\n        b = u.match(ie11);\n        if(explorer.indexOf("Safari") >= 0 && explorer.indexOf("Chrome") < 0) {\n            el = document.getElementById("riyoushaSafari");\n        }else if(explorer.indexOf("Chrome") >= 0){\n            el = document.getElementById("riyoushaChrome");\n        }else if(explorer.indexOf("Firefox") >= 0){\n            el = document.getElementById("riyoushaFirefox");\n        }else if(explorer.indexOf("MSIE") >= 0 || b){\n            el = document.getElementById("riyoushaIe");\n        }\n        iframe = document.createElement(\'IFRAME\');\n        var doc = null;\n        iframe.setAttribute("id", "print-iframe");\n        document.body.appendChild(iframe);\n        doc = iframe.contentWindow.document;\n        doc.write(\'<div>\' + el.innerHTML + \'</div>\');\n        doc.close();\n        iframe.contentWindow.focus();\n        if(explorer.indexOf("MSIE") >= 0 || b){\n            iframe.contentDocument.body.insertAdjacentHTML(\'beforeend\', \'<div id ="iePrint" onclick ="window.focus(); window.print();"></div>\');\n            setTimeout(function(){\n                var printButton = iframe.contentDocument.getElementById(\'iePrint\');\n                printButton.click();\n                document.body.removeChild(iframe);\n            },1000);\n        }else{\n            iframe.contentWindow.print();\n            setTimeout(function(){\n                document.body.removeChild(iframe);\n            },1000);\n        }\n    }</script>');
$templateCache.put('app/system/riyousha/qrcode/qrcode.html','<div><h2 data-translate="riyousha.home.title">Robots</h2><div class="row"></div><hr><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="jh-table table table-striped table-hover"><colgroup><col width="30%"><col width="30%"><col width="30%"><col></colgroup><thead><tr><th><span data-translate="robot.name">ID</span></th><th><span data-translate="robot.jigyoushoCd">jigyoushoCd</span></th><th><span data-translate="robot.serviceType">serviceType</span></th><!--<th data-translate="robot.jigyoushoId">Jigyousho ID</th>--><th></th></tr></thead><tbody><tr ng-repeat="group in vm.groups track by group.id"><td>{{group.name}}</td>{{group.id}}<!--<td>{{group.jigyoushoId}}</td>--><td>{{group.jigyoushoCd}}</td><td><span ng-repeat="type in vm.serviceTypeList | filter:{code:group.serviceType}:true">{{type.name }}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-click="vm.qrCodeShow(group.id);" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="riyousha.qrcode.view"></span></button></div></td></tr></tbody></table></div></div></div><div class="text-center" ng-if="vm.groups.length > 0"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadAll()"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.groups.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div>');
$templateCache.put('app/system/script/base/base.html','<div><div class="pull-right"><button class="btn btn-success" type="button">\u30DA\u30C3\u30D1\u30FC\u540D <span class="badge">{{vm.pepper.pepperName}}</span></button></div><h2 data-translate="base.home.title">Base</h2><form name="editForm" role="form" novalidate><h4 data-translate="base.home.default">Default</h4><div class="row"><div class="col-md-12"><div class="btn-group" uib-dropdown ng-if="vm.systemSetting.length > 0"><button type="button" class="btn btn-info" uib-dropdown-toggle><span class="hidden-xs hidden-sm" data-translate="base.btn.copy">Copy from system.</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li ng-repeat="ss in vm.systemSetting track by $index"><a ng-click="vm.copy($index)">{{ss.pepperName}}</a></li></ul></div></div></div><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><colgroup><col width="22%"><col width="22%"><col width="22%"><col width="22%"><col></colgroup><thead><tr><th data-translate="base.title.name">Name</th><th data-translate="base.title.variable">Variable</th><th data-translate="base.title.value">Value</th><th data-translate="base.title.sample">Sample</th><th data-translate="base.title.controller">Controller</th></tr></thead><tbody><tr ng-repeat="ps in vm.datas.pepperSettingList track by $index" ng-form="defaultRepeatForm" ng-if="ps.variableType == 1"><td><div class="form-group"><input type="text" class="form-control" name="itemName" ng-model="ps.itemName" ng-required="ps.itemName == null || ps.itemName == \'\'" ng-maxlength="100"><div ng-show="defaultRepeatForm.itemName.$invalid" class="has-error small"><p class="help-block" ng-show="defaultRepeatForm.itemName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="defaultRepeatForm.itemName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="variableName" ng-model="ps.variableName" ng-required="ps.variableName == null || ps.variableName == \'\'" ng-maxlength="45" ng-pattern="/^[./<>_A-Za-z0-9]*$/"><div ng-show="defaultRepeatForm.variableName.$invalid" class="has-error small"><p class="help-block" ng-show="defaultRepeatForm.variableName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="defaultRepeatForm.variableName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p><p class="help-block" ng-show="defaultRepeatForm.variableName.$error.pattern" data-translate="entity.validation.pattern.num-letter-symbol">This field\'s type is not correct.</p></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="variableValue" ng-model="ps.variableValue" ng-maxlength="100"><div ng-show="defaultRepeatForm.variableValue.$invalid" class="has-error small"><p class="help-block" ng-show="defaultRepeatForm.variableValue.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="sampleText" ng-model="ps.sampleText" ng-maxlength="100"><div ng-show="defaultRepeatForm.sampleText.$invalid" class="has-error small"><p class="help-block" ng-show="defaultRepeatForm.sampleText.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.del($index)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div><h4 data-translate="base.home.custom">Custom</h4><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><colgroup><col width="22%"><col width="22%"><col width="22%"><col width="22%"><col></colgroup><thead><tr><th data-translate="base.title.name">Name</th><th data-translate="base.title.variable">Variable</th><th data-translate="base.title.value">Value</th><th data-translate="base.title.sample">Sample</th><th data-translate="base.title.controller">Controller</th></tr></thead><tbody><tr ng-repeat="ps in vm.datas.pepperSettingList track by $index" ng-form="customRepeatForm" ng-if="ps.variableType == 2"><td><div class="form-group"><input type="text" class="form-control" name="itemName" ng-model="ps.itemName" ng-required="ps.itemName == null || ps.itemName == \'\'" ng-maxlength="100"><div ng-show="customRepeatForm.itemName.$invalid" class="has-error small"><p class="help-block" ng-show="customRepeatForm.itemName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="customRepeatForm.itemName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="variableName" ng-model="ps.variableName" ng-required="ps.variableName == null || ps.variableName == \'\'" ng-maxlength="45" ng-pattern="/^[./<>_A-Za-z0-9]*$/"><div ng-show="customRepeatForm.variableName.$invalid" class="has-error small"><p class="help-block" ng-show="customRepeatForm.variableName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="customRepeatForm.variableName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p><p class="help-block" ng-show="customRepeatForm.variableName.$error.pattern" data-translate="entity.validation.pattern.num-letter-symbol">This field\'s type is not correct.</p></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="variableValue" ng-model="ps.variableValue" ng-maxlength="100"><div ng-show="customRepeatForm.variableValue.$invalid" class="has-error small"><p class="help-block" ng-show="customRepeatForm.variableValue.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="sampleText" ng-model="ps.sampleText" ng-maxlength="100"><div ng-show="customRepeatForm.sampleText.$invalid" class="has-error small"><p class="help-block" ng-show="customRepeatForm.sampleText.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><button class="btn btn-danger btn-sm" ng-click="vm.del($index)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-success" ng-click="vm.add()"><span data-translate="base.btn.customAdd">Add</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.save()" ng-disabled="editForm.$invalid || isSaving"><span data-translate="base.btn.save">Save</span></button> <button type="button" class="btn btn-default" ui-sref="script"><span data-translate="base.btn.back">Back</span></button></div></div></form></div>');
$templateCache.put('app/system/script/conversation/conversation.html','<form id="editForm" name="editForm" role="form" novalidate><div><h2 data-translate="script.conversation.header.conversation" ng-if="vm.type == 1">Conversation</h2><h2 data-translate="script.conversation.header.speech" ng-if="vm.type == 4">Speech</h2><div class="alert alert-success" ng-if="vm.success"><strong data-translate="script.message.saveSuccess">Save success!</strong></div><div class="form-group"><audio id="audio" src=""></audio><div class="row"><div class="col-md-6"><div class="form-group"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.id">Id</label></div><div class="col-md-4"><label class="form-control-static">{{vm.script.id}}</label></div><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.title">Title</label></div><div class="col-md-4"><div class="form-group"><input type="text" class="form-control" name="title" ng-model="vm.script.title" ng-required="vm.script.title == null || vm.script.title == \'\'" ng-maxlength="45"><div ng-show="editForm.title.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p></div></div></div></div></div><div class="form-group"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.comment">Comment</label></div><div class="col-md-10"><div class="form-group"><input type="text" class="form-control" name="comment" ng-model="vm.script.comment" ng-maxlength="50"><div ng-show="editForm.comment.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div></div></div><div class="col-md-4"><div class="form-group"><div class="col-md-6 text-right"><label class="form-control-static" data-translate="script.conversation.category">Category</label></div><div class="col-md-6"><div class="form-group"><select class="form-control" name="categories" multiple="multiple" ng-model="vm.script.categories" style="height: 90px" ng-options="category.categoryValue for category in vm.categories" ng-required="vm.script.categories == null || vm.script.categories.length == 0"></select><div ng-show="editForm.categories.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.categories.$error.required" data-translate="entity.validation.selected">This field is required.</p></div></div></div></div></div><div class="col-md-2"><div class="form-group"><div class="row" style="margin-bottom: 12px"><div class="col-md-6 text-right"><label class="form-control-static" data-translate="script.conversation.publish">Publish</label></div><div class="col-md-6"><label style="margin-top: 6px"><input type="checkbox" ng-model="vm.script.publishType"></label></div></div></div></div></div></div><div data-as-sortable data-ng-model="vm.script.scriptItems"><div class="form-group" data-ng-repeat="si in vm.script.scriptItems" ng-form="scriptItemsForm" data-as-sortable-item><div class="row bg-white{{$index % 2}}" data-as-sortable-item-handle><div class="col-md-1"><div class="form-group"><div class="row"><div class="col-md-12 text-center">{{si.label}}</div></div></div><div class="form-group"><div class="row"><div class="col-md-12 text-center"><buttom class="btn btn-danger" data-translate="script.conversation.delete" ng-click="vm.delLabel($index)">Delete</buttom></div></div></div></div><div class="col-md-8"><div class="form-group" ng-repeat="ids in si.scriptItemDetails" ng-form="scriptItemDetailsForm"><div class="row"><div ng-if="ids.detailType == 1"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.text{{si.labelType}}">Text</label></div><div class="col-md-9"><div class="row"><div class="col-md-9"><div class="form-group"><input type="text" class="form-control" name="text" ng-model="ids.text" ng-maxlength="100" no-drag><div ng-show="scriptItemDetailsForm.text.$invalid" class="has-error small"><p class="help-block" ng-show="scriptItemDetailsForm.text.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 45 characters.</p></div></div></div><div class="col-md-3"><select class="form-control" ng-model="ids.nextLabel"><option value="">GoTo</option><option ng-repeat="gt in vm.script.scriptItems" value="{{gt.label}}">{{gt.label}}</option><option value="end">end</option></select></div></div></div><div class="col-md-1"><button type="button" class="btn btn-success glyphicon glyphicon-plus" ng-click="vm.addDetail($parent.$parent.$index, \'\')"></button></div></div><div ng-if="ids.detailType != 1"><div class="col-md-2"><select class="form-control" ng-model="ids.detailType" ng-if="si.labelType == 1"><option ng-repeat="dts in vm.scriptDetailType" value="{{dts.code}}" ng-if="dts.code != 1 && dts.code != 30 && ((si.scriptItemDetails | filter: {detailType: dts.code.toString()}: true).length == 0 || ids.detailType == dts.code.toString())">{{dts.name}}</option></select><select class="form-control" ng-model="ids.detailType" ng-if="si.labelType == 2"><option ng-repeat="dts in vm.scriptDetailType" value="{{dts.code}}" ng-if="dts.code != 1 && ((si.scriptItemDetails | filter: {detailType: dts.code.toString()}: true).length == 0 || ids.detailType == dts.code.toString() || dts.code == 30)">{{dts.name}}</option></select></div><div class="col-md-9"><div ng-if="ids.detailType == 5"><div class="row"><div class="col-md-10"><div class="form-group"><input type="text" class="form-control" name="text" ng-model="ids.text" ng-maxlength="100" no-drag><div ng-show="scriptItemDetailsForm.text.$invalid" class="has-error small"><p class="help-block" ng-show="scriptItemDetailsForm.text.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 45 characters.</p></div></div></div><div class="col-md-2"><select class="form-control" ng-model="ids.font" ng-options="vs.itemCode as vs.itemValue for vs in vm.variables | filter: {itemType: \'2\'}"></select></div></div></div><div ng-if="ids.detailType == 10"><div class="row"><div class="col-md-10"><p class="form-control-static" ng-repeat="ls in vm.libraries | filter: {fileType: \'2\'}" ng-if="ids.contentId == ls.id">{{ls.fileName}}</p><p class="form-control-static" title="{{ids.text}}" style="overflow: hidden; text-overflow: ellipsis" ng-if="ids.text != \'\'">{{ids.text}}</p></div><div class="col-md-2"><button class="btn btn-default btn-sm" ng-click="vm.choose($parent.$parent.$parent.$parent.$index, $index, 2, 10)" data-translate="script.conversation.select">Select</button></div></div></div><div ng-if="ids.detailType == 15"><select class="form-control" ng-model="ids.contentId" ng-change="vm.preViewShow($parent.$parent.$parent.$index, $index, 15)" ng-options="vs.id as vs.itemValue for vs in vm.variables | filter: {itemType: \'3\'}"></select></div><div ng-if="ids.detailType == 20"><div class="row"><div class="col-md-10"><p class="form-control-static" ng-repeat="ls in vm.libraries | filter: {fileType: \'3\'}" ng-if="ids.contentId == ls.id">{{ls.fileName}}</p><p class="form-control-static" title="{{ids.text}}" style="overflow: hidden; text-overflow: ellipsis" ng-if="ids.text != \'\'">{{ids.text}}</p></div><div class="col-md-2"><button class="btn btn-default btn-sm" ng-click="vm.choose($parent.$parent.$parent.$parent.$index, $index, 3, 20)" data-translate="script.conversation.select">Select</button></div></div></div><div ng-if="ids.detailType == 25"><div class="row"><div class="col-md-5"><select class="form-control" ng-model="ids.contentId" ng-options="vs.id as vs.itemValue for vs in vm.variables | filter: {itemType: \'1\'}"></select></div><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.variable">Variable</label></div><div class="col-md-5"><div class="form-group"><input type="text" name="text" class="form-control" ng-model="ids.text" ng-maxlength="100" no-drag><div ng-show="scriptItemDetailsForm.text.$invalid" class="has-error small"><p class="help-block" ng-show="scriptItemDetailsForm.text.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 45 characters.</p></div></div></div></div></div><div ng-if="ids.detailType == 30"><div class="row"><div class="col-md-3 text-right"><label class="form-control-static" data-translate="script.conversation.keyword">KeyWord</label></div><div class="col-md-6"><div class="form-group"><input type="text" name="text" class="form-control" ng-model="ids.text" ng-maxlength="100" no-drag><div ng-show="scriptItemDetailsForm.text.$invalid" class="has-error small"><p class="help-block" ng-show="scriptItemDetailsForm.text.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 45 characters.</p></div></div></div><div class="col-md-3"><select class="form-control" ng-model="ids.nextLabel"><option value="">GoTo</option><option ng-repeat="gt in vm.script.scriptItems" value="{{gt.label}}">{{gt.label}}</option><option value="end">end</option></select></div></div></div></div><div class="col-md-1"><button type="button" class="btn btn-danger glyphicon glyphicon-minus" ng-click="vm.delDetail($parent.$parent.$index, $index)"></button></div></div></div></div></div><div class="col-md-3"><div class="row" ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 20"><audio controls="controls" class="audio{{$parent.$parent.$index}}" ng-src="{{sce(si.music)}}" style="width: 100%"></audio></div><div class="row" style="height: 100px; background-repeat: no-repeat; background-size: contain; background-position:center; background-image: url({{si.background}})"><div ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 5" class="text-center" style="height: 80px;  word-break: break-all; word-wrap: break-word; overflow: hidden; padding-top: 20px; font-size: {{ids.font / 8 == 0 ? 14 : ids.font / 8}}px">{{ids.text}}</div></div><div class="row text-center" ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 15" style="height: 100px; line-height: 100px"><img ng-src="{{vm.url}}/library/api/library/file/name/{{v.id}}/1" onerror="this.remove()" style="width: 100%; height: 100%" ng-if="ids.contentId == v.id" ng-repeat="v in vm.variables | filter: {itemType: \'3\'}"></div></div></div></div></div><div class="form-group"><label data-translate="script.conversation.script">Script</label><textarea class="form-control" rows="10" ng-model="vm.script.plainScript"></textarea></div><div class="row"><div class="col-md-12"><div class="btn-group" uib-dropdown ng-if="vm.type == 4"><button type="button" class="btn btn-success" data-translate="script.conversation.add" uib-dropdown-toggle>Add</button><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li><a ng-click="vm.addLabel(1)" data-translate="script.conversation.answer">Answer</a></li><li><a ng-click="vm.addLabel(2)" data-translate="script.conversation.question">Question</a></li></ul></div><button type="button" ng-if="vm.type == 4" class="btn btn-warning" data-translate="script.conversation.plainScript" ng-disabled="editForm.$invalid || isSaving" ng-click="vm.save(true)">Script</button> <button type="submit" class="btn btn-primary" data-translate="script.conversation.save" ng-disabled="editForm.$invalid || isSaving" ng-click="vm.save(false)">Save</button> <button type="button" class="btn btn-default" data-translate="script.conversation.cancel" ng-click="vm.back()">Cancel</button></div></div></div></form>');
$templateCache.put('app/system/script/conversation/showConversation.html','<form id="editForm" name="editForm" role="form" novalidate><div><h2 data-translate="script.conversation.header.conversationShow" ng-if="vm.type == 1">Conversation</h2><h2 data-translate="script.conversation.header.speechShow" ng-if="vm.type == 4">Speech</h2><div class="form-group"><audio id="audio" src=""></audio><div class="row"><div class="col-md-6"><div class="form-group"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.id">Id</label></div><div class="col-md-4"><label class="form-control-static">{{vm.script.id}}</label></div><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.title">Title</label></div><div class="col-md-4"><div class="form-group"><input type="text" class="form-control" name="title" ng-model="vm.script.title" ng-disabled="true" style="background: white"></div></div></div></div><div class="form-group"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.comment">Comment</label></div><div class="col-md-10"><div class="form-group"><input type="text" class="form-control" name="comment" ng-model="vm.script.comment" ng-maxlength="50" ng-disabled="true" style="background: white"></div></div></div></div></div><div class="col-md-4"><div class="form-group"><div class="col-md-6 text-right"><label class="form-control-static" data-translate="script.conversation.category">Category</label></div><div class="col-md-6"><div class="form-group"><select class="form-control" name="categories" multiple="multiple" ng-model="vm.script.categories" style="height: 90px;background: white" ng-options="category.categoryValue for category in vm.categories" ng-disabled="true"></select></div></div></div></div><div class="col-md-2"><div class="form-group"><div class="row" style="margin-bottom: 12px"><div class="col-md-6 text-right"><label class="form-control-static" data-translate="script.conversation.publish">Publish</label></div><div class="col-md-6"><label style="margin-top: 6px"><input type="checkbox" ng-model="vm.script.publishType" ng-disabled="true" style="background: white"></label></div></div></div></div></div></div><div data-as-sortable data-ng-model="vm.script.scriptItems"><div class="form-group" data-ng-repeat="si in vm.script.scriptItems" ng-form="scriptItemsForm" data-as-sortable-item><div class="row bg-white{{$index % 2}}" data-as-sortable-item-handle><div class="col-md-1"><div class="form-group"><div class="row"><div class="col-md-12 text-center">{{si.label}}</div></div></div></div><div class="col-md-8"><div class="form-group" ng-repeat="ids in si.scriptItemDetails" ng-form="scriptItemDetailsForm"><div class="row"><div ng-if="ids.detailType == 1"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.text{{si.labelType}}">Text</label></div><div class="col-md-9"><div class="row"><div class="col-md-9"><div class="form-group"><input type="text" class="form-control" name="text" ng-model="ids.text" no-drag ng-disabled="true" style="background: white"></div></div><div class="col-md-3"><select class="form-control" ng-model="ids.nextLabel" ng-disabled="true" style="background: white"><option value="">GoTo</option><option ng-repeat="gt in vm.script.scriptItems" value="{{gt.label}}">{{gt.label}}</option><option value="end">end</option></select></div></div></div></div><div ng-if="ids.detailType != 1"><div class="col-md-2"><select class="form-control" ng-model="ids.detailType" ng-if="si.labelType == 1" ng-disabled="true" style="background: white"><option ng-repeat="dts in vm.scriptDetailType" value="{{dts.code}}" ng-if="dts.code != 1 && dts.code != 30 && ((si.scriptItemDetails | filter: {detailType: dts.code.toString()}: true).length == 0 || ids.detailType == dts.code.toString())">{{dts.name}}</option></select><select class="form-control" ng-model="ids.detailType" ng-if="si.labelType == 2" ng-disabled="true" style="background: white"><option ng-repeat="dts in vm.scriptDetailType" value="{{dts.code}}" ng-if="dts.code != 1 && ((si.scriptItemDetails | filter: {detailType: dts.code.toString()}: true).length == 0 || ids.detailType == dts.code.toString() || dts.code == 30)">{{dts.name}}</option></select></div><div class="col-md-9"><div ng-if="ids.detailType == 5"><div class="row"><div class="col-md-10"><div class="form-group"><input type="text" class="form-control" name="text" ng-model="ids.text" no-drag ng-disabled="true" style="background: white"></div></div><div class="col-md-2"><select class="form-control" ng-model="ids.font" style="background: white" ng-options="vs.itemCode as vs.itemValue for vs in vm.variables | filter: {itemType: \'2\'}" ng-disabled="true"></select></div></div></div><div ng-if="ids.detailType == 10"><div class="row"><div class="col-md-10"><p class="form-control-static" ng-repeat="ls in vm.libraries | filter: {fileType: \'2\'}" ng-if="ids.contentId == ls.id">{{ls.fileName}}</p><p class="form-control-static" title="{{ids.text}}" style="overflow: hidden; text-overflow: ellipsis" ng-if="ids.text != \'\'">{{ids.text}}</p></div></div></div><div ng-if="ids.detailType == 15"><select class="form-control" ng-model="ids.contentId" ng-disabled="true" style="background: white" ng-options="vs.id as vs.itemValue for vs in vm.variables | filter: {itemType: \'3\'}"></select></div><div ng-if="ids.detailType == 20"><div class="row"><div class="col-md-10"><p class="form-control-static" ng-repeat="ls in vm.libraries | filter: {fileType: \'3\'}" ng-if="ids.contentId == ls.id">{{ls.fileName}}</p><p class="form-control-static" title="{{ids.text}}" style="overflow: hidden; text-overflow: ellipsis" ng-if="ids.text != \'\'">{{ids.text}}</p></div></div></div><div ng-if="ids.detailType == 25"><div class="row"><div class="col-md-5"><select class="form-control" ng-model="ids.contentId" ng-disabled="true" style="background: white" ng-options="vs.id as vs.itemValue for vs in vm.variables | filter: {itemType: \'1\'}"></select></div><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.variable">Variable</label></div><div class="col-md-5"><div class="form-group"><input type="text" name="text" class="form-control" ng-model="ids.text" no-drag ng-disabled="true" style="background: white"></div></div></div></div><div ng-if="ids.detailType == 30"><div class="row"><div class="col-md-3 text-right"><label class="form-control-static" data-translate="script.conversation.keyword">KeyWord</label></div><div class="col-md-6"><div class="form-group"><input type="text" name="text" class="form-control" ng-model="ids.text" no-drag ng-disabled="true" style="background: white"></div></div><div class="col-md-3"><select class="form-control" ng-model="ids.nextLabel" ng-disabled="true" style="background: white"><option value="">GoTo</option><option ng-repeat="gt in vm.script.scriptItems" value="{{gt.label}}">{{gt.label}}</option><option value="end">end</option></select></div></div></div></div></div></div></div></div><div class="col-md-3"><div class="row" ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 20"><audio controls="controls" class="audio{{$parent.$parent.$index}}" ng-src="{{sce(si.music)}}" style="width: 100%"></audio></div><div class="row" style="height: 100px; background-repeat: no-repeat; background-size: contain; background-position:center; background-image: url({{si.background}})"><div ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 5" class="text-center" style="height: 80px;  word-break: break-all; word-wrap: break-word; overflow: hidden; padding-top: 20px; font-size: {{ids.font / 8 == 0 ? 14 : ids.font / 8}}px">{{ids.text}}</div></div><div class="row text-center" ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 15" style="height: 100px; line-height: 100px"><img ng-src="{{vm.url}}/library/api/library/file/name/{{v.id}}/1" onerror="this.remove()" style="width: 100%; height: 100%" ng-if="ids.contentId == v.id" ng-repeat="v in vm.variables | filter: {itemType: \'3\'}"></div></div></div></div></div><div class="form-group"><label data-translate="script.conversation.script">Script</label><textarea class="form-control" rows="10" ng-model="vm.script.plainScript" ng-disabled="true" style="background: white"></textarea></div><div class="row"><div class="col-md-12"><button class="btn btn-default" data-translate="script.conversation.back" ng-click="vm.back()">Cancel</button></div></div></div></form>');
$templateCache.put('app/system/script/daily/daily.html','<div><div class="pull-right"><button class="btn btn-success" type="button">\u30DA\u30C3\u30D1\u30FC\u540D <span class="badge">{{vm.pepper.pepperName}}</span></button></div><h2 data-translate="daily.home.title">Daily</h2><form name="editForm" role="form" novalidate><h4 data-translate="daily.home.default">Default</h4><div class="row"><div class="col-md-12"><div class="btn-group" uib-dropdown ng-if="vm.systemSetting.length > 0"><button type="button" class="btn btn-info" uib-dropdown-toggle><span class="hidden-xs hidden-sm" data-translate="daily.btn.copy">Copy from system.</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li ng-repeat="ss in vm.systemSetting track by $index"><a ng-click="vm.copy($index)">{{ss.pepperName}}</a></li></ul></div></div></div><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><colgroup><col width="22%"><col width="22%"><col width="15%"><col width="29%"><col></colgroup><thead><tr><th data-translate="daily.title.name">Name</th><th data-translate="daily.title.variable">Variable</th><th data-translate="daily.title.repeat">Value</th><th data-translate="daily.title.sample">Sample</th><th data-translate="daily.title.controller">Controller</th></tr></thead><tbody><tr ng-repeat="ps in vm.datas.pepperSettingList" ng-click="vm.changeDays($index)" ng-if="ps.variableType == 3" ng-form="defaultRepeatForm"><td><div class="form-group"><input type="text" class="form-control" name="itemName" ng-model="ps.itemName" ng-required="ps.itemName == null || ps.itemName == \'\'" ng-maxlength="100"><div ng-show="defaultRepeatForm.itemName.$invalid" class="has-error small"><p class="help-block" ng-show="defaultRepeatForm.itemName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="defaultRepeatForm.itemName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><textarea type="text" class="form-control" name="variableName" ng-model="ps.variableName" ng-required="ps.variableName == null || ps.variableName == \'\'" ng-maxlength="45" ng-pattern="/^[./<>_A-Za-z0-9\\n]*$/"></textarea><div ng-show="defaultRepeatForm.variableName.$invalid" class="has-error small"><p class="help-block" ng-show="defaultRepeatForm.variableName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="defaultRepeatForm.variableName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p><p class="help-block" ng-show="defaultRepeatForm.variableName.$error.pattern" data-translate="entity.validation.pattern.num-letter-symbol">This field\'s type is not correct.</p></div></div></td><td><div class="form-group"><select class="form-control" ng-options="rp.code as rp.value for rp in vm.repeats" ng-model="ps.repeatType" ng-change="vm.changeDays($index)"></select></div></td><td><div class="form-group"><input type="text" class="form-control" name="sampleText" ng-model="ps.sampleText" ng-maxlength="100"><div ng-show="defaultRepeatForm.sampleText.$invalid" class="has-error small"><p class="help-block" ng-show="defaultRepeatForm.sampleText.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.del($index)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div><h4 data-translate="daily.home.custom">Custom</h4><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><colgroup><col width="22%"><col width="22%"><col width="15%"><col width="29%"><col></colgroup><thead><tr><th data-translate="daily.title.name">Name</th><th data-translate="daily.title.variable">Variable</th><th data-translate="daily.title.repeat">Value</th><th data-translate="daily.title.sample">Sample</th><th data-translate="daily.title.controller">Controller</th></tr></thead><tbody><tr ng-repeat="ps in vm.datas.pepperSettingList" ng-click="vm.changeDays($index)" ng-if="ps.variableType == 4" ng-form="customRepeatForm"><td><div class="form-group"><input type="text" class="form-control" name="itemName" ng-model="ps.itemName" ng-required="ps.itemName == null || ps.itemName == \'\'" ng-maxlength="100"><div ng-show="customRepeatForm.itemName.$invalid" class="has-error small"><p class="help-block" ng-show="customRepeatForm.itemName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="customRepeatForm.itemName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><textarea type="text" class="form-control" name="variableName" ng-model="ps.variableName" ng-required="ps.variableName == null || ps.variableName == \'\'" ng-maxlength="45" ng-pattern="/^[./<>_A-Za-z0-9\\n]*$/"></textarea><div ng-show="customRepeatForm.variableName.$invalid" class="has-error small"><p class="help-block" ng-show="customRepeatForm.variableName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="customRepeatForm.variableName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p><p class="help-block" ng-show="customRepeatForm.variableName.$error.pattern" data-translate="entity.validation.pattern.num-letter-symbol">This field\'s type is not correct.</p></div></div></td><td><div class="form-group"><select class="form-control" ng-options="rp.code as rp.value for rp in vm.repeats" ng-model="ps.repeatType" ng-change="vm.changeDays($index)"></select></div></td><td><div class="form-group"><input type="text" class="form-control" name="sampleText" ng-model="ps.sampleText" ng-maxlength="100"><div ng-show="customRepeatForm.sampleText.$invalid" class="has-error small"><p class="help-block" ng-show="customRepeatForm.sampleText.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.del($index)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div><div class="table-responsive" ng-repeat="ps in vm.datas.pepperSettingList" ng-if="vm.index == $index && ps.repeatType == 2"><h4>{{ps.itemName}}</h4><table class="table table-striped" ng-form="monthForm"><colgroup><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col></colgroup><tr><th>1</th><th>2</th><th>3</th><th>4</th><th>5</th><th>6</th><th>7</th></tr><tr><td><input type="text" class="form-control" name="day1" ng-model="ps.pepperSettingMonthly.day1" ng-maxlength="100"><div ng-show="monthForm.day1.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day1.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day2" ng-model="ps.pepperSettingMonthly.day2" ng-maxlength="100"><div ng-show="monthForm.day2.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day2.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day3" ng-model="ps.pepperSettingMonthly.day3" ng-maxlength="100"><div ng-show="monthForm.day3.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day3.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day4" ng-model="ps.pepperSettingMonthly.day4" ng-maxlength="100"><div ng-show="monthForm.day4.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day4.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day5" ng-model="ps.pepperSettingMonthly.day5" ng-maxlength="100"><div ng-show="monthForm.day5.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day5.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day6" ng-model="ps.pepperSettingMonthly.day6" ng-maxlength="100"><div ng-show="monthForm.day6.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day6.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day7" ng-model="ps.pepperSettingMonthly.day7" ng-maxlength="100"><div ng-show="monthForm.day7.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day7.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr><tr><th>8</th><th>9</th><th>10</th><th>11</th><th>12</th><th>13</th><th>14</th></tr><tr><td><input type="text" class="form-control" name="day8" ng-model="ps.pepperSettingMonthly.day8" ng-maxlength="100"><div ng-show="monthForm.day8.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day8.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day9" ng-model="ps.pepperSettingMonthly.day9" ng-maxlength="100"><div ng-show="monthForm.day9.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day9.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day10" ng-model="ps.pepperSettingMonthly.day10" ng-maxlength="100"><div ng-show="monthForm.day10.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day10.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day11" ng-model="ps.pepperSettingMonthly.day11" ng-maxlength="100"><div ng-show="monthForm.day11.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day11.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day12" ng-model="ps.pepperSettingMonthly.day12" ng-maxlength="100"><div ng-show="monthForm.day12.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day12.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day13" ng-model="ps.pepperSettingMonthly.day13" ng-maxlength="100"><div ng-show="monthForm.day13.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day13.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day14" ng-model="ps.pepperSettingMonthly.day14" ng-maxlength="100"><div ng-show="monthForm.day14.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day14.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr><tr><th>15</th><th>16</th><th>17</th><th>18</th><th>19</th><th>20</th><th>21</th></tr><tr><td><input type="text" class="form-control" name="day15" ng-model="ps.pepperSettingMonthly.day15" ng-maxlength="100"><div ng-show="monthForm.day15.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day15.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day16" ng-model="ps.pepperSettingMonthly.day16" ng-maxlength="100"><div ng-show="monthForm.day16.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day16.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day17" ng-model="ps.pepperSettingMonthly.day17" ng-maxlength="100"><div ng-show="monthForm.day17.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day17.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day18" ng-model="ps.pepperSettingMonthly.day18" ng-maxlength="100"><div ng-show="monthForm.day18.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day18.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day19" ng-model="ps.pepperSettingMonthly.day19" ng-maxlength="100"><div ng-show="monthForm.day19.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day19.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day20" ng-model="ps.pepperSettingMonthly.day20" ng-maxlength="100"><div ng-show="monthForm.day20.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day20.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day21" ng-model="ps.pepperSettingMonthly.day21" ng-maxlength="100"><div ng-show="monthForm.day21.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day21.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr><tr><th>22</th><th>23</th><th>24</th><th>25</th><th>26</th><th>27</th><th>28</th></tr><tr><td><input type="text" class="form-control" name="day22" ng-model="ps.pepperSettingMonthly.day22" ng-maxlength="100"><div ng-show="monthForm.day22.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day22.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day23" ng-model="ps.pepperSettingMonthly.day23" ng-maxlength="100"><div ng-show="monthForm.day23.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day23.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day24" ng-model="ps.pepperSettingMonthly.day24" ng-maxlength="100"><div ng-show="monthForm.day24.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day24.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day25" ng-model="ps.pepperSettingMonthly.day25" ng-maxlength="100"><div ng-show="monthForm.day25.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day25.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day26" ng-model="ps.pepperSettingMonthly.day26" ng-maxlength="100"><div ng-show="monthForm.day26.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day26.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day27" ng-model="ps.pepperSettingMonthly.day27" ng-maxlength="100"><div ng-show="monthForm.day27.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day27.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day28" ng-model="ps.pepperSettingMonthly.day28" ng-maxlength="100"><div ng-show="monthForm.day28.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day28.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr><tr><th>29</th><th>30</th><th>31</th><th></th><th></th><th></th><th></th></tr><tr><td><input type="text" class="form-control" name="day29" ng-model="ps.pepperSettingMonthly.day29" ng-maxlength="100"><div ng-show="monthForm.day29.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day29.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day30" ng-model="ps.pepperSettingMonthly.day30" ng-maxlength="100"><div ng-show="monthForm.day30.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day30.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day31" ng-model="ps.pepperSettingMonthly.day31" ng-maxlength="100"><div ng-show="monthForm.day31.$invalid" class="has-error small"><p class="help-block" ng-show="monthForm.day31.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td></td><td></td><td></td><td></td></tr></table></div><div class="table-responsive" ng-repeat="ps in vm.datas.pepperSettingList" ng-if="vm.index == $index && ps.repeatType == 3"><h4>{{ps.itemName}}</h4><table class="table table-striped" ng-form="weekForm"><colgroup><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col width="14%"><col></colgroup><tr><th data-translate="daily.title.sunday">7</th><th data-translate="daily.title.monday">1</th><th data-translate="daily.title.tuesday">2</th><th data-translate="daily.title.wednesday">3</th><th data-translate="daily.title.thursday">4</th><th data-translate="daily.title.friday">5</th><th data-translate="daily.title.saturday">6</th></tr><tr><td><input type="text" class="form-control" name="day1" ng-model="ps.pepperSettingWeekly.day1" ng-maxlength="100"><div ng-show="weekForm.day1.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day1.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day2" ng-model="ps.pepperSettingWeekly.day2" ng-maxlength="100"><div ng-show="weekForm.day2.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day2.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day3" ng-model="ps.pepperSettingWeekly.day3" ng-maxlength="100"><div ng-show="weekForm.day3.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day3.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day4" ng-model="ps.pepperSettingWeekly.day4" ng-maxlength="100"><div ng-show="weekForm.day4.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day4.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day5" ng-model="ps.pepperSettingWeekly.day5" ng-maxlength="100"><div ng-show="weekForm.day5.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day5.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day6" ng-model="ps.pepperSettingWeekly.day6" ng-maxlength="100"><div ng-show="weekForm.day6.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day6.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td><td><input type="text" class="form-control" name="day7" ng-model="ps.pepperSettingWeekly.day7" ng-maxlength="100"><div ng-show="weekForm.day7.$invalid" class="has-error small"><p class="help-block" ng-show="weekForm.day7.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></td></tr></table></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-success" ng-click="vm.add()"><span data-translate="daily.btn.customAdd">Add</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.save()" ng-disabled="editForm.$invalid || isSaving"><span data-translate="daily.btn.save">Save</span></button> <button type="button" class="btn btn-default" ui-sref="script"><span data-translate="daily.btn.back">Back</span></button></div></div></form></div>');
$templateCache.put('app/system/script/library/library.html','<style>.iconDiv {\n        height: 130px;\n        line-height: 120px;\n        width: 100%;\n        font-size: 60px;\n    }\n    .iconText {\n        height: 24px;\n        line-height: 24px;\n        width: 100%;\n        word-break: break-all;\n    }</style><div><h2 data-translate="library.home.title">Library</h2><div class="row"><div class="col-md-3"><div class="panel panel-info"><div class="panel-body"><div class="panel panel-default noborder"><div class="panel-heading" data-translate="library.home.belong">Belong</div><div class="panel-body no-padding-left"><div class="list-group"><a class="list-group-item" ng-repeat="belong in vm.belong" ng-click="vm.changeBelong(belong.code)" ng-class="{active : belong.code == vm.selectedBelong}" ng-hide="vm.isAdmin && belong.code == 1">\uFF5C\u30FC{{belong.name}}</a></div></div></div><div class="panel panel-default noborder"><div class="panel-heading" data-translate="library.home.type">Type</div><div class="panel-body no-padding-left"><div class="list-group"><a class="list-group-item" ng-repeat="type in vm.types" ng-click="vm.changeType(type.code)" ng-if="type.code != 7" ng-class="{active : type.code == vm.selectedType}">\uFF5C\u30FC{{type.name}}</a></div></div></div></div></div></div><div class="col-md-9"><div class="form-group"><div class="row"><div class="col-md-12"><div class="btn-group" uib-dropdown><button type="button" class="btn btn-success" uib-dropdown-toggle><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs hidden-sm" data-translate="library.btn.new">New</span> <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu"><li><a ng-click="vm.jump(1, 0)" data-translate="library.btn.upload">Upload</a></li><li><a ng-click="vm.jump(2, 0)" data-translate="library.btn.addUrl">Url</a></li></ul></div><div class="btn-group"><button type="button" class="btn btn-primary" ng-click="vm.edit()" ng-if="vm.selectedBelong == 2"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="library.btn.edit">Edit</span></button></div><div class="btn-group"><button type="button" class="btn btn-danger" ng-click="vm.delLibraries()" ng-if="vm.selectedBelong == 2"><span class="glyphicon glyphicon-remove"></span> <span class="hidden-xs hidden-sm" data-translate="library.btn.del">Delete</span></button></div><div class="btn-group"><button type="button" class="btn btn-default" ui-sref="script"><span class="glyphicon glyphicon-chevron-left"></span> <span class="hidden-xs hidden-sm" data-translate="library.btn.back">Back</span></button></div></div></div></div><div class="form-group" ng-if="vm.libraryList.length > 0"><div class="col-md-3" ng-repeat="library in vm.libraryList"><div class="form-group"><div class="row"><div class="col-md-12 text-center" style="height: 160px" ng-click="vm.goEdit(library.id)" ng-if="vm.selectedBelong == 2"><div class="iconDiv" ng-if="library.fileType == 2"><img ng-src="data:image/png;base64, {{library.thumbnail}}" style="max-width: 100%; max-height: 120px" ng-if="library.uploadFlg"> <img ng-src="{{library.url}}" style="max-width: 100%; max-height: 100%" ng-if="!library.uploadFlg"></div><div class="glyphicon glyphicon-music iconDiv" ng-if="library.fileType == 3"></div><div class="glyphicon glyphicon-film iconDiv" ng-if="library.fileType == 4"></div><div class="glyphicon glyphicon-link iconDiv" ng-if="library.fileType == 5"></div><div class="glyphicon glyphicon-file iconDiv" ng-if="library.fileType == 6"></div><div class="iconText">{{library.fileName}}</div></div><div class="col-md-12 text-center" style="height: 160px" ng-if="vm.selectedBelong != 2"><div class="iconDiv" ng-if="library.fileType == 2"><img ng-src="data:image/png;base64, {{library.thumbnail}}" style="max-width: 100%; max-height: 120px" ng-if="library.uploadFlg"> <img ng-src="{{library.url}}" style="max-width: 100%; max-height: 100%" ng-if="!library.uploadFlg"></div><div class="glyphicon glyphicon-music iconDiv" ng-if="library.fileType == 3"></div><div class="glyphicon glyphicon-film iconDiv" ng-if="library.fileType == 4"></div><div class="glyphicon glyphicon-link iconDiv" ng-if="library.fileType == 5"></div><div class="glyphicon glyphicon-file iconDiv" ng-if="library.fileType == 6"></div><div class="iconText">{{library.fileName}}</div></div></div></div><div class="form-group" ng-if="vm.selectedBelong == 2"><div class="row"><div class="col-md-6" style="padding-right: 6px"><select class="form-control" ng-model="library.publishType" ng-options="pt.code as pt.name for pt in vm.publishTypes" ng-change="vm.changePublishType($index)"></select></div><div class="col-md-6"><button type="button" class="btn btn-default" style="width: 100%" ng-click="vm.selectLibrary(library.id)"><input type="checkbox" id="checkbox{{library.id}}" ng-click="vm.selectLibrary(library.id)" style="cursor: pointer"> <span class="hidden-xs hidden-sm" data-translate="library.btn.select">Select</span></button></div></div></div><!--<div class="form-group">--><!--<div class="row">--><!--<div class="col-md-6">--><!--<button class="btn btn-default glyphicon glyphicon-share" style="width: 100%;" ng-click="vm.copyToClipboard(library.url)" ng-if="library.publishType != 3" data-translate="library.btn.url">URL</button>--><!--</div>--><!--<div class="col-md-6">--><!--<button type="button" class="btn btn-default" style="width: 100%;" ng-click="vm.selectLibrary(library.id)" ng-if="vm.selectedBelong == 2">--><!--<input type="checkbox" id="checkbox{{library.id}}" ng-click="vm.selectLibrary(library.id)" style="cursor: pointer;"/>--><!--<span class="hidden-xs hidden-sm" data-translate="library.btn.select">Select</span>--><!--</button>--><!--</div>--><!--</div>--><!--</div>--></div></div><div class="form-group" ng-if="vm.libraryList.length > 0"><div class="col-md-12 text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadLibraries()"></uib-pagination></div></div><div class="alert alert-warning top-margin" ng-if="vm.libraryList.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div></div></div><div style="width: 0px; height: 0px; position: fixed; left: 0px; top: 0px"><textarea type="text" style="width: 1px; height: 1px; border: 0px; margin: 0px; padding: 0px; display: none" id="copyUrl"></div>');
$templateCache.put('app/system/script/media/media.html','<form id="editForm" name="editForm" role="form" novalidate><div><h2 ng-if="vm.type == 2" data-translate="script.media.music.header">Header</h2><h2 ng-if="vm.type == 3" data-translate="script.media.movie.header">Header</h2><div class="alert alert-success" ng-if="vm.success"><strong data-translate="script.message.saveSuccess">Save success!</strong></div><div class="form-group"><div class="row"><div class="col-md-7"><div class="form-group"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.media.music.id" ng-if="vm.type == 2">Id</label><label class="form-control-static" data-translate="script.media.movie.id" ng-if="vm.type == 3">Id</label></div><div class="col-md-2"><label class="form-control-static">{{vm.script.id}}</label></div><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.media.title">Title</label></div><div class="col-md-2"><div class="form-group"><input type="text" class="form-control" name="title" ng-model="vm.script.title" ng-required="vm.script.title == null || vm.script.title == \'\'" ng-maxlength="45"><div ng-show="editForm.title.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.title.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.title.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p></div></div></div><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.media.music.library" ng-if="vm.type == 2">Library</label><label class="form-control-static" data-translate="script.media.movie.library" ng-if="vm.type == 3">Library</label></div><div class="col-md-2"><div class="form-group"><select class="form-control" ng-model="vm.script.library" ng-if="vm.type == 2" ng-change="vm.setMedia()" ng-options="ls.fileName for ls in vm.libraries | filter: {fileType: \'3\'}"><option value=""></option></select><select class="form-control" ng-model="vm.script.library" ng-if="vm.type == 3" ng-change="vm.setMedia()" ng-options="ls.fileName for ls in vm.movieLit"><option value=""></option></select><div ng-show="editForm.media.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.media.$error.required" data-translate="entity.validation.selected">This field is required.</p></div></div></div></div></div><div class="form-group"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.comment">Comment</label></div><div class="col-md-10"><div class="form-group"><input type="text" class="form-control" name="comment" ng-model="vm.script.comment" ng-maxlength="50"><div ng-show="editForm.comment.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div></div></div></div></div><div class="col-md-3"><div class="form-group"><div class="col-md-6 text-right"><label class="form-control-static" data-translate="script.conversation.category">Category</label></div><div class="col-md-6"><div class="form-group"><select class="form-control" name="categories" multiple="multiple" ng-model="vm.script.categories" style="height: 90px" ng-options="category.categoryValue for category in vm.categories" ng-required="vm.script.categories == null || vm.script.categories.length == 0"></select><div ng-show="editForm.categories.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.categories.$error.required" data-translate="entity.validation.selected">This field is required.</p></div></div></div></div></div><div class="col-md-2"><div class="form-group"><div class="row"><div class="col-md-5 text-right"><label class="form-control-static" data-translate="script.media.rhythm">Rhythm</label></div><div class="col-md-7"><select class="form-control" ng-model="vm.script.rhythmObj" ng-options="vs.itemValue for vs in vm.variables | filter: {itemType: 4}"><option></option></select></div></div></div><div class="form-group"><div class="row"><div class="col-md-5 text-right"><label class="form-control-static" data-translate="script.conversation.publish">Publish</label></div><div class="col-md-7"><label style="margin-top: 6px"><input type="checkbox" ng-model="vm.script.publishType"></label></div></div></div></div></div></div><div class="form-group"><div class="row" ng-if="vm.libraryUrl != null"><div class="col-md-7 text-right"><audio id="audio" controls="controls" ng-src="{{sce(vm.libraryUrl)}}" ng-if="vm.type == 2"></audio><video id="video" controls="controls" ng-src="{{sce(vm.libraryUrl)}}" ng-if="vm.type == 3 && vm.script.library.fileType == 4" style="width: 350px; height: 200px"></video></div><div class="col-md-5"><button type="button" class="btn btn-default" data-translate="script.media.record" ng-click="vm.record()" ng-if="vm.type == 2">Record</button> <button type="button" class="btn btn-default" data-translate="script.media.record" ng-click="vm.record()" ng-if="vm.type == 3 && vm.script.library.fileType == 4" style="margin-top: 160px">Record</button></div></div><div class="row"><div class="col-md-12 text-center"><iframe width="560" height="315" ng-src="{{sce(vm.libraryUrl)}}" frameborder="0" allowfullscreen ng-if="vm.type == 3 && vm.script.library.fileType == 5"></iframe></div></div></div><div data-as-sortable data-ng-model="vm.script.scriptItems"><div class="form-group" data-ng-repeat="si in vm.script.scriptItems" ng-form="scriptItemsForm" data-as-sortable-item><div class="row bg-white{{$index % 2}}" data-as-sortable-item-handle><div class="col-md-1"><div class="form-group"><div class="row"><div class="col-md-12"><div class="form-group"><input type="text" name="label" class="form-control" ng-model="si.label" ng-required="si.label == \'\' || si.label == null" ng-pattern="/^([0-9]+):([0-9]+)$/" no-drag><div ng-show="scriptItemsForm.label.$invalid" class="has-error small"><p class="help-block" ng-show="scriptItemsForm.label.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="scriptItemsForm.label.$error.pattern" data-translate="entity.validation.pattern.time">This field\'s form is correct.</p></div></div></div></div></div><div class="form-group"><div class="row"><div class="col-md-12 text-center"><buttom class="btn btn-danger" data-translate="script.conversation.delete" ng-click="vm.delLabel($index)">Delete</buttom></div></div></div></div><div class="col-md-8"><div class="form-group" ng-repeat="ids in si.scriptItemDetails" ng-form="scriptItemDetailsForm"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.media.lyric" ng-if="ids.detailType == 5">Lyric</label><select class="form-control" ng-model="ids.detailType" ng-if="ids.detailType != 5"><option ng-repeat="dts in vm.scriptDetailType" value="{{dts.code}}" ng-if="(si.scriptItemDetails | filter: {detailType: dts.code.toString()}: true).length == 0 || ids.detailType == dts.code.toString()">{{dts.name}}</option></select></div><div class="col-md-9"><div ng-if="ids.detailType == 1" class="form-group"><input type="text" name="text" class="form-control" ng-model="ids.text" ng-maxlength="100" no-drag><div ng-show="scriptItemDetailsForm.text.$invalid" class="has-error small"><p class="help-block" ng-show="scriptItemDetailsForm.text.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 45 characters.</p></div></div><div ng-if="ids.detailType == 5"><div class="row"><div class="col-md-10"><div class="form-group"><input type="text" class="form-control" name="text" ng-model="ids.text" ng-maxlength="100" no-drag><div ng-show="scriptItemDetailsForm.text.$invalid" class="has-error small"><p class="help-block" ng-show="scriptItemDetailsForm.text.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 45 characters.</p></div></div></div><div class="col-md-2"><select class="form-control" ng-model="ids.font" ng-options="vs.itemCode as vs.itemValue for vs in vm.variables | filter: {itemType: \'2\'}"></select></div></div></div><div ng-if="ids.detailType == 10"><div class="row"><div class="col-md-10"><p class="form-control-static" ng-repeat="ls in vm.libraries | filter: {fileType: \'2\'}" ng-if="ids.contentId == ls.id">{{ls.fileName}}</p><p class="form-control-static" title="{{ids.text}}" style="overflow: hidden; text-overflow: ellipsis" ng-if="ids.text != \'\'">{{ids.text}}</p></div><div class="col-md-2"><button type="button" class="btn btn-default btn-sm" ng-click="vm.choose($parent.$parent.$parent.$index, $index, 2, 10)" data-translate="script.conversation.select">Select</button></div></div></div><div ng-if="ids.detailType == 15"><select class="form-control" ng-model="ids.contentId" ng-change="vm.preViewShow($parent.$parent.$index, $index, 15)" ng-options="vs.id as vs.itemValue for vs in vm.variables | filter: {itemType: \'3\'}"></select></div></div><div class="col-md-1"><button type="button" class="btn btn-danger glyphicon glyphicon-minus" ng-click="vm.delDetail($parent.$parent.$index, $index)" ng-if="ids.detailType != 5"></button> <button type="button" class="btn btn-success glyphicon glyphicon-plus" ng-click="vm.addDetail($parent.$parent.$index, \'\')" ng-if="ids.detailType == 5"></button></div></div></div></div><div class="col-md-3"><div class="row" style="height: 100px; background-size: 100% 100%; background-repeat: no-repeat; background-size: contain; background-position:center; background-image: url({{si.background}})"><div ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 5" class="text-center" style="height: 80px;  word-break: break-all; word-wrap: break-word; overflow: hidden; padding-top: 20px; font-size: {{ids.font / 8 == 0 ? 14 : ids.font / 8}}px">{{ids.text}}</div></div><div class="row text-center" ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 15" style="height: 100px; line-height: 100px"><img ng-src="{{vm.url}}/library/api/library/file/name/{{v.id}}/1" onerror="this.remove()" style="width: 100%; height: 100%" ng-if="ids.contentId == v.id" ng-repeat="v in vm.variables | filter: {itemType: \'3\'}"></div></div></div></div></div><div class="form-group"><label translate="script.conversation.script">Script</label><textarea class="form-control" rows="10" ng-model="vm.script.plainScript"></textarea></div><div class="form-group"><div class="row"><div class="col-md-12"><button type="button" class="btn btn-success" data-translate="script.conversation.add" ng-click="vm.addLabel()">Add</button> <button type="button" class="btn btn-warning" data-translate="script.conversation.plainScript" ng-disabled="editForm.$invalid || isSaving" ng-click="vm.save(true)">Script</button> <button type="submit" class="btn btn-primary" data-translate="script.conversation.save" ng-disabled="editForm.$invalid || isSaving" ng-click="vm.save(false)">Save</button> <button type="button" class="btn btn-default" data-translate="script.conversation.cancel" ng-click="vm.back()">Cancel</button></div></div></div></div><input type="hidden" name="media" ng-model="vm.media" style="width: 1px; height: 1px; border: 0px; padding: 0px" ng-required="vm.media == null"></form>');
$templateCache.put('app/system/script/media/showMedia.html','<form id="editForm" name="editForm" role="form" novalidate><div><h2 ng-if="vm.type == 2" data-translate="script.media.music.showHeader">Header</h2><h2 ng-if="vm.type == 3" data-translate="script.media.movie.showHeader">Header</h2><div class="form-group"><div class="row"><div class="col-md-7"><div class="form-group"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.media.music.id" ng-if="vm.type == 2">Id</label><label class="form-control-static" data-translate="script.media.movie.id" ng-if="vm.type == 3">Id</label></div><div class="col-md-2"><label class="form-control-static">{{vm.script.id}}</label></div><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.media.title">Title</label></div><div class="col-md-2"><div class="form-group"><input type="text" class="form-control" name="title" ng-model="vm.script.title" ng-disabled="true" style="background: white"></div></div><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.media.music.library" ng-if="vm.type == 2">Library</label><label class="form-control-static" data-translate="script.media.movie.library" ng-if="vm.type == 3">Library</label></div><div class="col-md-2"><div class="form-group"><select class="form-control" ng-model="vm.script.library" ng-if="vm.type == 2" ng-options="ls.fileName for ls in vm.libraries | filter: {fileType: \'3\'}" ng-disabled="true" style="background: white"><option value=""></option></select><select class="form-control" ng-model="vm.script.library" ng-if="vm.type == 3" ng-options="ls.fileName for ls in vm.movieLit" ng-disabled="true" style="background: white"><option value=""></option></select></div></div></div></div><div class="form-group"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.conversation.comment">Comment</label></div><div class="col-md-10"><div class="form-group"><input type="text" class="form-control" name="comment" ng-model="vm.script.comment" ng-disabled="true" style="background: white"></div></div></div></div></div><div class="col-md-3"><div class="form-group"><div class="col-md-6 text-right"><label class="form-control-static" data-translate="script.conversation.category">Category</label></div><div class="col-md-6"><div class="form-group"><select class="form-control" name="categories" multiple="multiple" ng-model="vm.script.categories" style="height: 90px;background: white" ng-options="category.categoryValue for category in vm.categories" ng-disabled="true"></select></div></div></div></div><div class="col-md-2"><div class="form-group"><div class="row"><div class="col-md-5 text-right"><label class="form-control-static" data-translate="script.media.rhythm">Rhythm</label></div><div class="col-md-7"><select class="form-control" ng-model="vm.script.rhythmObj" ng-options="vs.itemValue for vs in vm.variables | filter: {itemType: 4}" ng-disabled="true" style="background: white"><option></option></select></div></div></div><div class="form-group"><div class="row"><div class="col-md-5 text-right"><label class="form-control-static" data-translate="script.conversation.publish">Publish</label></div><div class="col-md-7"><label style="margin-top: 6px"><input type="checkbox" ng-model="vm.script.publishType" ng-disabled="true" style="background: white"></label></div></div></div></div></div></div><div class="form-group"><div class="row" ng-if="vm.libraryUrl != null"><div class="col-md-7 text-right"><audio id="audio" controls="controls" ng-src="{{sce(vm.libraryUrl)}}" ng-if="vm.type == 2"></audio><video id="video" controls="controls" ng-src="{{sce(vm.libraryUrl)}}" ng-if="vm.type == 3 && vm.script.library.fileType == 4" style="width: 350px; height: 200px"></video></div></div><div class="row"><div class="col-md-12 text-center"><iframe width="560" height="315" ng-src="{{sce(vm.libraryUrl)}}" frameborder="0" allowfullscreen ng-if="vm.type == 3 && vm.script.library.fileType == 5"></iframe></div></div></div><div data-as-sortable data-ng-model="vm.script.scriptItems"><div class="form-group" data-ng-repeat="si in vm.script.scriptItems" ng-form="scriptItemsForm" data-as-sortable-item><div class="row bg-white{{$index % 2}}" data-as-sortable-item-handle><div class="col-md-1"><div class="form-group"><div class="row"><div class="col-md-12"><div class="form-group"><input type="text" name="label" class="form-control" ng-model="si.label" no-drag ng-disabled="true" style="background: white"></div></div></div></div></div><div class="col-md-8"><div class="form-group" ng-repeat="ids in si.scriptItemDetails" ng-form="scriptItemDetailsForm"><div class="row"><div class="col-md-2 text-right"><label class="form-control-static" data-translate="script.media.lyric" ng-if="ids.detailType == 5">Lyric</label><select class="form-control" ng-model="ids.detailType" ng-if="ids.detailType != 5" ng-disabled="true" style="background: white"><option ng-repeat="dts in vm.scriptDetailType" value="{{dts.code}}" ng-if="(si.scriptItemDetails | filter: {detailType: dts.code.toString()}: true).length == 0 || ids.detailType == dts.code.toString()">{{dts.name}}</option></select></div><div class="col-md-9"><div ng-if="ids.detailType == 1" class="form-group"><input type="text" name="text" class="form-control" ng-model="ids.text" no-drag ng-disabled="true" style="background: white"></div><div ng-if="ids.detailType == 5"><div class="row"><div class="col-md-10"><div class="form-group"><input type="text" class="form-control" name="text" ng-model="ids.text" no-drag ng-disabled="true" style="background: white"></div></div><div class="col-md-2"><select class="form-control" ng-model="ids.font" style="background: white" ng-options="vs.itemCode as vs.itemValue for vs in vm.variables | filter: {itemType: \'2\'}" ng-disabled="true"></select></div></div></div><div ng-if="ids.detailType == 10"><div class="row"><div class="col-md-10"><p class="form-control-static" ng-repeat="ls in vm.libraries | filter: {fileType: \'2\'}" ng-if="ids.contentId == ls.id">{{ls.fileName}}</p><p class="form-control-static" title="{{ids.text}}" style="overflow: hidden; text-overflow: ellipsis" ng-if="ids.text != \'\'">{{ids.text}}</p></div></div></div><div ng-if="ids.detailType == 15"><select class="form-control" ng-model="ids.contentId" ng-disabled="true" style="background: white" ng-options="vs.id as vs.itemValue for vs in vm.variables | filter: {itemType: \'3\'}"></select></div></div></div></div></div><div class="col-md-3"><div class="row" style="height: 100px; background-size: 100% 100%; background-repeat: no-repeat; background-size: contain; background-position:center; background-image: url({{si.background}})"><div ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 5" class="text-center" style="height: 80px;  word-break: break-all; word-wrap: break-word; overflow: hidden; padding-top: 20px; font-size: {{ids.font / 8 == 0 ? 14 : ids.font / 8}}px">{{ids.text}}</div></div><div class="row text-center" ng-repeat="ids in si.scriptItemDetails" ng-if="ids.detailType == 15" style="height: 100px; line-height: 100px"><img ng-src="{{vm.url}}/library/api/library/file/name/{{v.id}}/1" onerror="this.remove()" style="width: 100%; height: 100%" ng-if="ids.contentId == v.id" ng-repeat="v in vm.variables | filter: {itemType: \'3\'}"></div></div></div></div></div><div class="form-group"><label translate="script.conversation.script">Script</label><textarea class="form-control" rows="10" ng-model="vm.script.plainScript" ng-disabled="true" style="background: white"></textarea></div><div class="form-group"><div class="row"><div class="col-md-12"><button class="btn btn-default" data-translate="script.conversation.back" ng-click="vm.back()">Cancel</button></div></div></div></div><input type="hidden" name="media" ng-model="vm.media" style="width: 1px; height: 1px; border: 0px; padding: 0px" ng-required="vm.media == null"></form>');
$templateCache.put('app/system/script/photo/photo-show-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.library.fileName}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row text-center"><img src="data:image/png;base64, {{vm.library.url}}" style="max-height: 80%; max-width: 80%"></div></div>');
$templateCache.put('app/system/script/photo/photo.html','<div><h2 data-translate="photo.title">Photo</h2><form name="editForm" role="form"><div class="row" style="margin-bottom: 12px"><div class="col-md-5"><div class="form-group"><input type="file" ngf-select ng-model="vm.picFile" accept="image/*" name="file" ngf-validate="{size: {max: \'50MB\'}, pattern: \'.jpg,.jepg,.png,.gif\'}" ngf-model-invalid="errorFile"><div ng-show="editForm.file.$error" class="has-error small"><p class="help-block" ng-show="editForm.file.$error.maxSize" data-translate="entity.validation.maxSize" translate-value-max="50MB">This file is too large.</p><p class="help-block" ng-show="editForm.file.$error.pattern" data-translate="entity.validation.pattern">This file\'s pattern is wrong.</p></div></div></div><div class="col-md-2 text-right"><label class="form-control-static" data-translate="photo.groups">Group ID</label></div><div class="col-md-3"><select class="form-control" ng-model="vm.groupId" ng-options="group.groupId as group.groupName for group in vm.groups"></select><div ng-show="vm.groupId == \'\' || vm.groupId == null || vm.groups.length == 0" class="has-error small"><p class="help-block" data-translate="entity.validation.selected">Need Selected</p></div></div><div class="col-md-2"><button type="submit" class="btn btn-info" ng-click="vm.uploadPic()" ng-disabled="vm.picFile == null || editForm.file.$error.maxSize || editForm.file.$error.pattern || vm.groupId == null || vm.groupId == \'\'"><span class="glyphicon glyphicon-cloud-upload"></span> <span class="hidden-xs hidden-sm" data-translate="photo.btn.upload">Upload</span></button> <button type="button" class="btn btn-default" ui-sref="script"><span class="glyphicon glyphicon-chevron-left"></span> <span class="hidden-xs hidden-sm" data-translate="photo.btn.back">Back</span></button></div></div></form><div class="row" ng-if="vm.photoList.length > 0"><div class="col-md-3" ng-repeat="photo in vm.photoList"><div class="form-group"><div class="row"><div class="col-md-12 text-center" style="height: 200px; margin-bottom: 4px; line-height: 200px"><img src="data:image/png;base64,{{photo.thumbnail}}" style="max-width: 200px; max-height: 200px"></div><div class="col-md-6 text-right" style="margin-bottom: 4px"><input type="radio" ng-model="photo.publishType" value="1" style="margin-right: 4px" ng-click="vm.changePublishType(photo.id, 1)"><span data-translate="photo.span.public">Public</span></div><div class="col-md-6 text-left" style="margin-bottom: 4px"><input type="radio" ng-model="photo.publishType" value="3" style="margin-right: 4px" ng-click="vm.changePublishType(photo.id, 3)"><span data-translate="photo.span.private">Private</span></div><div class="col-md-6 text-right"><button type="button" class="btn btn-info" data-translate="photo.btn.show" ui-sref="photo.show({id: photo.id})">Show</button></div><div class="col-md-6 text-left"><button type="button" class="btn btn-danger" data-translate="photo.btn.del" ng-click="vm.del(photo.id)">Delete</button></div></div></div></div></div><div class="text-center" ng-if="vm.photoList.length > 0"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPhotos()"></uib-pagination></div><div class="alert alert-warning top-margin" ng-if="vm.photoList.length == 0"><strong data-translate="global.messages.info.noData">There is no data!</strong></div></div>');
$templateCache.put('app/system/script/schedule/schedule.html','<div><div class="pull-right"><button class="btn btn-success" type="button">\u30DA\u30C3\u30D1\u30FC\u540D <span class="badge">{{vm.pepper.pepperName}}</span></button></div><h2 data-translate="schedule.home.title">Schedule</h2><form name="editForm" role="form" novalidate><div class="row"><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><colgroup><col width="10%"><col width="15%"><col width="30%"><col width="25%"><col width="10%"><col width="10%"></colgroup><thead><tr><th data-translate="schedule.title.time">Time</th><th data-translate="schedule.title.item">Item</th><th data-translate="schedule.title.sample">Sample</th><th data-translate="schedule.title.script">Script</th><th data-translate="schedule.title.repeat">Repeat</th><th data-translate="schedule.title.controller">Controller</th></tr></thead><tbody><tr ng-repeat="sl in vm.datas.scheduleList" ng-click="vm.selectSchedule($index)" ng-form="repeatForm"><td><div class="form-group"><input type="text" class="form-control" name="itemName" ng-model="sl.exeTime" ng-required="sl.exeTime == null || sl.exeTime == \'\'" ng-pattern="/^([01]\\d|2[0-3])\\:([0-5]\\d)$/"><div ng-show="repeatForm.itemName.$invalid" class="has-error small"><p class="help-block" ng-show="repeatForm.itemName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="repeatForm.itemName.$error.pattern" data-translate="entity.validation.time">This field\'s format is incorrect.</p></div></div></td><td><div class="form-inline"><div class="form-group"><select class="form-control" ng-options="it.code as it.name for it in vm.itemTypes" ng-model="sl.itemType"></select></div></div></td><td><div class="form-group"><input type="text" class="form-control" name="comment" ng-model="sl.comment" ng-maxlength="100"><div ng-show="repeatForm.comment.$invalid" class="has-error small"><p class="help-block" ng-show="repeatForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></td><td><div class="form-group"><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.scriptId" ng-if="sl.itemType == 2"></select></div></td><td><div class="form-group"><select class="form-control" ng-options="rp.code as rp.value for rp in vm.repeats" ng-model="sl.repeatType" ng-if="sl.itemType == 3"></select></div></td><td><div class="form-group"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.del($index)"><span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div><h4 ng-repeat="sl in vm.datas.scheduleList" ng-if="sl.itemType == 3 && sl.repeatType != 1 && $index == vm.index">{{vm.dayTitle}}</h4><div class="row" ng-repeat="sl in vm.datas.scheduleList" ng-if="sl.itemType == 3 && sl.repeatType != 1 && $index == vm.index"><div class="col-md-12"><div class="table-responsive" ng-if="sl.repeatType == 2"><table class="table table-striped"><tr><td>1</td><td>2</td><td>3</td><td>4</td><td>5</td><td>6</td><td>7</td></tr><tr><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day1"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day2"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day3"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day4"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day5"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day6"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day7"><option></option></select></td></tr><tr><td>8</td><td>9</td><td>10</td><td>11</td><td>12</td><td>13</td><td>14</td></tr><tr><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day8"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day9"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day10"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day11"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day12"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day13"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day14"><option></option></select></td></tr><tr><td>15</td><td>16</td><td>17</td><td>18</td><td>19</td><td>20</td><td>21</td></tr><tr><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day15"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day16"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day17"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day18"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day19"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day20"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day21"><option></option></select></td></tr><tr><td>22</td><td>23</td><td>24</td><td>25</td><td>26</td><td>27</td><td>28</td></tr><tr><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day22"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day23"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day24"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day25"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day26"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day27"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day28"><option></option></select></td></tr><tr><td>29</td><td>30</td><td>31</td><td></td><td></td><td></td><td></td></tr><tr><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day29"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day30"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleMonthly.day31"><option></option></select></td><td></td><td></td><td></td><td></td></tr></table></div><div class="table-responsive" ng-if="sl.repeatType == 3"><table class="table table-striped"><tr><td data-translate="schedule.week.sun">SUN</td><td data-translate="schedule.week.mon">MON</td><td data-translate="schedule.week.tue">TUE</td><td data-translate="schedule.week.wed">WED</td><td data-translate="schedule.week.thu">THU</td><td data-translate="schedule.week.fri">FRI</td><td data-translate="schedule.week.sat">SAT</td></tr><tr><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleWeekly.day1"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleWeekly.day2"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleWeekly.day3"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleWeekly.day4"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleWeekly.day5"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleWeekly.day6"><option></option></select></td><td><select class="form-control" ng-options="cn.scriptId as cn.scriptTitle for cn in vm.collections" ng-model="sl.pepperScheduleWeekly.day7"><option></option></select></td></tr></table></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-success" ng-click="vm.add()"><span data-translate="schedule.btn.add">Add</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.save()" ng-disabled="editForm.$invalid || isSaving"><span data-translate="schedule.btn.save">Save</span></button> <button type="button" class="btn btn-default" ui-sref="script"><span data-translate="schedule.btn.back">Back</span></button></div></div></form></div>');
$templateCache.put('app/system/token-management/dialog/token-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.token.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div data-translate="token.delete.appName" translate-values="{appName: \'{{vm.token.appName}}\'}"></div><div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis" title="{{vm.token.token}}" data-translate="token.delete.token" translate-values="{token: \'{{vm.token.token}}\'}"></div><div data-translate="token.delete.endDate" translate-values="{endDate: \'{{vm.token.endDate | date: \'yyyy/MM/dd\'}}\'}"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/token-management/dialog/token-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="token.title.index">Token</h4></div><div class="modal-body"><h4 data-translate="token.text.create">Create</h4><form class="form-horizontal" role="form" name="editForm"><div class="col-md-12 form-group"><div class="col-md-9" style="margin-left: 10px"><div class="col-md-12 form-group"><label class="col-md-4 control-label" data-translate="token.item.appName">App name</label><div class="col-md-8"><input class="form-control" type="text" name="appName" ng-model="vm.token.appName" required ng-maxlength="100"><div ng-show="editForm.appName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.appName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.appName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="col-md-12 form-group"><label class="col-md-4 control-label" data-translate="token.item.endDate">End date</label><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" id="endDate" name="endDate" enable-time="false" datetime-picker="yyyy/MM/dd" ng-model="vm.token.endDate" is-open="vm.isOpen" ng-pattern="/^[1-9][0-9][0-9][0-9]/((0[1-9])|(1[0-2]))/((0[1-9])|([1-2][0-9])|(3[0-1]))$/"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar()"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p><div ng-show="editForm.endDate.$invalid" class="has-error small"><p class="help-block" data-translate="entity.validation.dateformat">This field must be date format.</p></div></div></div></div><div class="col-md-2"><button type="button" class="btn btn-success col-md-12" style="height: 80px;width: 200px" ng-click="vm.save()" ng-disabled="editForm.$invalid" data-translate="global.button.publish">Publish</button></div></div></form><div style="clear: both"></div><h4 data-translate="token.text.list">List</h4><form class="form-horizontal" role="form"><input type="text" id="copyText" style="display: none"><div class="form-group" ng-if="vm.tokenList.length == 0"><div class="col-md-12" data-translate="token.text.noData"></div></div><div class="form-group" style="padding-left: 16px; padding-right: 16px" ng-if="vm.tokenList.length > 0"><div class="col-md-12 form-group" ng-repeat="token in vm.tokenList"><div class="col-md-9" style="border: solid 1px; margin-left: 10px; padding-top: 6px; padding-bottom: 6px"><div class="row" style="padding: 6px"><div class="col-md-4 text-right" data-translate="token.item.appName">App name</div><div class="col-md-8" ng-bind="token.appName"></div></div><div class="row" style="padding: 6px"><div class="col-md-4 text-right" data-translate="token.item.token">Token</div><div class="col-md-8" ng-bind="token.token" title="{{token.token}}" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis"></div></div><div class="row" style="padding: 6px"><div class="col-md-4 text-right" data-translate="token.item.endDate">End date</div><div class="col-md-8" ng-bind="token.endDate"></div></div></div><div class="col-md-2"><button type="button" class="btn btn-primary col-md-12" ng-click="vm.edit($index)" style="width: 200px" data-translate="global.button.edit">Edit</button> <button type="button" class="btn btn-success col-md-12" style="margin-top: 2px; margin-bottom: 2px; width: 200px" ng-click="vm.copy(token.token)" data-translate="token.button.copy">Copy</button> <button type="button" class="btn btn-danger col-md-12" ng-click="vm.del($index)" style="width: 200px" data-translate="global.button.delete">Delete</button></div></div></div></form></div>');
$templateCache.put('app/system/token-management/dialog/token-edit-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="token.title.edit">Token Edit</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="row form-group"><div class="col-md-12 form-group"><label class="col-md-4 control-label" data-translate="token.item.appName">App name</label><div class="col-md-8 control-label" style="text-align: left" ng-bind="vm.token.appName"></div></div><div class="col-md-12 form-group"><label class="col-md-4 control-label" data-translate="token.item.token">Token</label><div class="col-md-8 control-label" ng-bind="vm.token.token" title="{{vm.token.token}}" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left"></div></div><div class="col-md-12 form-group"><label class="col-md-4 control-label" data-translate="token.item.endDate">End date</label><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" id="endEditDate" name="endDate" enable-time="false" data-date="{{vm.token.endDate}}" datetime-picker="yyyy/MM/dd" ng-model="vm.token.endDate" is-open="vm.isOpen" ng-pattern="/^[1-9][0-9][0-9][0-9]/((0[1-9])|(1[0-2]))/((0[1-9])|([1-2][0-9])|(3[0-1]))$/" ng-value="vm.token.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar()"><i class="fa fa-calendar"></i><span class="glyphicon glyphicon-calendar"></span></button></span></p><div ng-show="editForm.endDate.$invalid" class="has-error small"><p class="help-block" data-translate="entity.validation.dateformat">This field must be date format.</p></div></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-primary" ng-click="vm.save()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div>');
$templateCache.put('app/system/user-management/dialog/delete-token-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><div>\u30C8\u30FC\u30AF\u30F3\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear();"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger" ng-click="vm.confirmDelete();"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/variable/detail/variable-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.variable.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="entity.delete.question">Are you sure you want to delete this Variable?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/system/variable/detail/variable-edit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><input type="hidden" class="form-control" name="id" ng-model="vm.variable.id" readonly="readonly"> <input type="hidden" class="form-control" name="id" ng-model="vm.variable.itemType" readonly="readonly"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" translate="variable.home.editDialogTitle">Create or edit a Variable</h4></div>{{vm.id}}<div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="variable.edit.code">Variable code</label><input type="text" class="form-control" name="itemCode" ng-model="vm.variable.itemCode" ng-required="vm.variable.itemCode == null || vm.variable.itemCode == \'\'" ng-maxlength="100"><div ng-show="editForm.itemCode.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.itemCode.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.itemCode.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label translate="variable.edit.value">Variable value</label><input type="text" class="form-control" name="itemValue" ng-model="vm.variable.itemValue" ng-required="vm.variable.itemValue == null || vm.variable.itemValue == \'\'" ng-maxlength="100"><div ng-show="editForm.itemValue.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.itemValue.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.itemValue.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group" ng-if="vm.variable.itemType == 3"><label translate="variable.edit.picture">Picture</label><input type="file" ngf-select ng-model="vm.picFile" accept="image/*" name="file" ngf-validate="{size: {max: \'50MB\'}, pattern: \'.gif\'}" ngf-model-invalid="errorFile"><div ng-show="editForm.file.$error" class="has-error small"><p class="help-block" ng-show="editForm.file.$error.maxSize" data-translate="entity.validation.maxSize" translate-value-max="50MB">This file is too large.</p><p class="help-block" ng-show="editForm.file.$error.pattern" data-translate="entity.validation.pattern">This file\'s pattern is wrong.</p></div></div><div class="form-group" ng-if="vm.variable.id != null && !vm.delFlg && vm.variable.itemType == 3" id="img"><div class="col-md-10"><img style="max-width: 100%" ng-src="{{vm.url}}/library/api/library/file/name/{{vm.variable.id}}/1" onerror="document.getElementById(\'img\').remove()"></div><div class="col-md-2"><button type="button" class="btn btn-danger" ng-click="vm.del()"><span translate="variable.edit.del">Del</span></button></div></div></div><div class="row"></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/customer/license/staff/dialog/license-staff-edit-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="license.title.assign">License assign</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="form-group"><label class="col-md-2 control-label" data-translate="license.item.jigyoushoCd">Jigyousho code</label><div class="col-md-3" style="padding-top: 7px" ng-bind="vm.info.jigyoushoCd"></div><label class="col-md-2 control-label" data-translate="license.item.jigyoushoNm">Jigyousho name</label><div class="col-md-25" style="padding-top: 7px" ng-bind="vm.info.jigyoushoNm"></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="license.item.login">Login</label><div class="col-md-3" style="padding-top: 7px" ng-bind="vm.info.login"></div><label class="col-md-2 control-label" data-translate="license.item.name">User name</label><div class="col-md-5" style="padding-top: 7px" ng-bind="vm.info.username"></div></div><hr><h4 data-translate="license.item.license">Licenses</h4><table class="table table-striped table-hover"><thead><tr><th data-translate="license.item.shopNm">Shop name</th><th data-translate="license.item.productNm">Product name</th><th data-translate="license.item.usedFlg">Used</th></tr></thead><tbody><tr ng-repeat="license in vm.licenses"><td>{{license.shopNm}}</td><td>{{license.productNm}}</td><td><input type="checkbox" ng-model="license.usedFlg" ng-disabled="vm.useFlag" ng-click="vm.setLicense(license)"></td></tr></tbody></table></form></div>');
$templateCache.put('app/customer/license/user/dialog/license-user-edit-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="license.title.assign">License assign</h4></div><div class="modal-body"><form class="form-horizontal" role="form" name="editForm"><div class="form-group"><label class="col-md-2 control-label" data-translate="license.item.groupNm">Group name</label><div class="col-md-2" style="padding-top: 7px" ng-bind="vm.info.groupNm"></div></div><div class="form-group"><label class="col-md-2 control-label" data-translate="license.item.login">Login</label><div class="col-md-3" style="padding-top: 7px" ng-bind="vm.info.login"></div><label class="col-md-2 control-label" data-translate="license.item.name">User name</label><div class="col-md-5" style="padding-top: 7px" ng-bind="vm.info.username"></div></div><hr><h4 data-translate="license.item.license">Licenses</h4><table class="table table-striped table-hover"><thead><tr><th data-translate="license.item.shopNm">Shop name</th><th data-translate="license.item.productNm">Product name</th><th data-translate="license.item.usedFlg">Used</th><th></th></tr></thead><tbody><tr ng-repeat="license in vm.licenses"><td>{{license.shopNm}}</td><td>{{license.productNm}}</td><td><input type="checkbox" ng-model="license.usedFlg" ng-disabled="vm.useFlag" ng-click="vm.setLicense(license)"></td></tr></tbody></table></form></div>');
$templateCache.put('app/system/script/library/choose/choose.html','<style>.iconDiv {\n        height: 120px;\n        line-height: 120px;\n        width: 100%;\n        font-size: 60px;\n    }\n    .iconText {\n        height: 40px;\n        line-height: 40px;\n        width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }</style><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="library.dialog.choose.title">Select library</h4></div><div class="modal-body" ng-form="form"><div class="row"><div class="col-md-4"><div class="panel panel-info"><div class="panel-body"><div class="panel panel-default noborder"><div class="panel-heading" data-translate="library.dialog.choose.from">From</div><div class="panel-body no-padding-left"><div class="list-group"><a class="list-group-item" ng-repeat="belong in vm.belong" ng-click="vm.changeBelong(belong.code)" ng-class="{active : belong.code == vm.selectedBelong && !vm.formUrlFlg}" ng-hide="vm.isAdmin && belong.code == 1">\uFF5C\u30FC{{belong.name}}</a></div></div><div class="panel-body no-padding-left"><div class="list-group"><a class="list-group-item" ng-click="vm.setFromUrl()" ng-class="{active : vm.formUrlFlg}" data-translate="library.dialog.choose.url">URL</a></div></div></div></div></div></div><div class="col-md-8" ng-if="!vm.formUrlFlg"><div class="form-group"><div class="col-md-3" ng-repeat="library in vm.libraryList" ng-if="vm.selectedType == 2" ng-click="vm.selectedLibrary({value: library.id, type: 1})"><div class="form-group"><div class="row"><div class="col-md-12 text-center" style="height: 160px"><div class="iconDiv"><img ng-src="data:image/png;base64, {{library.thumbnail}}" style="max-width: 100%; max-height: 100%" ng-if="library.uploadFlg"> <img ng-src="{{library.url}}" style="max-width: 100%; max-height: 100%" ng-if="!library.uploadFlg"></div><div class="iconText" title="{{library.fileName}}">{{library.fileName}}</div></div></div></div></div><div class="form-group" ng-if="vm.selectedType == 3"><div class="row" ng-repeat="library in vm.libraryList"><div class="col-md-4"><p class="form-control-static">{{library.fileName}}</p></div><div class="col-md-6"><audio controls="controls" style="width: 100%" ng-src="{{sce(library.url)}}" ng-if="library.uploadFlg == 0"><audio controls="controls" style="width: 100%" ng-src="{{sce(\'/library/api/library/file/\' + library.id)}}" ng-if="library.uploadFlg == 1"></div><div class="col-md-2"><button type="button" class="btn btn-default btn-sm" ng-click="vm.selectedLibrary({value: library.id, type: 1})" data-translate="library.dialog.choose.select">Select</button></div></div></div></div><div class="form-group"><div class="col-md-12 text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadLibraries()"></uib-pagination></div></div></div><div class="col-md-8" ng-if="vm.formUrlFlg"><div class="form-group"><div class="row"><div class="col-md-12" data-translate="library.dialog.choose.urlMessage">Message</div></div></div><div class="form-group"><div class="row"><div class="col-md-12"><div class="form-group"><input type="text" name="url" class="form-control" ng-model="vm.url" ng-maxlength="100"><div ng-show="form.url.$invalid" class="has-error small"><p class="help-block" ng-show="form.url.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></div></div><div class="form-group"><div class="row"><div class="col-md-12 text-center"><button type="submit" class="btn btn-success" ng-click="vm.selectedLibrary({value: vm.url, type: 2})" data-translate="library.dialog.choose.yes">Yes</button></div></div></div></div></div></div>');
$templateCache.put('app/system/script/library/edit/library-edit.html','<form name="editForm" role="form" ng-submit="vm.save()" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="library.dialog.edit.title">Edit library</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group text-center"><img ng-src="{{vm.library.url}}" style="max-width: 100%; max-height: 200px" ng-if="vm.library.fileType == 2 && vm.library.uploadFlg == 0"> <img ng-src="data:image/png;base64, {{vm.library.baseCode}}" style="max-width: 100%; max-height: 200px" ng-if="vm.library.fileType == 2 && vm.library.uploadFlg == 1"><audio controls="controls" style="width: 100%" ng-src="{{sce(\'/library/api/library/file/\' + vm.library.id)}}" ng-if="vm.library.fileType == 3 && vm.library.uploadFlg == 1"><audio controls="controls" style="width: 100%" ng-src="{{sce(vm.library.url)}}" ng-if="vm.library.fileType == 3 && vm.library.uploadFlg == 0"><video controls="controls" style="max-width: 100%; max-height: 200px" ng-src="{{sce(\'/library/api/library/file/\' + vm.library.id)}}" ng-if="vm.library.fileType == 4 && vm.library.uploadFlg == 1"><video controls="controls" style="max-width: 100%; max-height: 200px" ng-src="{{sce(vm.library.url)}}" ng-if="vm.library.fileType == 4 && vm.library.uploadFlg == 0"><iframe width="560" height="315" ng-src="{{sce(vm.library.url)}}" frameborder="0" allowfullscreen ng-if="vm.library.fileType == 5"></iframe></div><div class="form-group"><label class="control-label" data-translate="library.home.groups">Group ID</label><select class="form-control" name="groupId" ng-model="vm.library.groupId" ng-options="group.groupId as group.groupName for group in vm.groups" ng-required="vm.library.groupId == \'\' || vm.library.groupId == null"></select><div ng-show="editForm.groupId.$invalid || vm.groups.length == 0" class="has-error small"><p class="help-block" ng-show="editForm.groupId.$error.required || vm.groups.length == 0" data-translate="entity.validation.selected">Need Selected</p></div></div><div class="form-group"><label class="control-label" data-translate="library.dialog.edit.fileName">File Name</label><input type="text" class="form-control" name="fileName" ng-model="vm.library.fileName" ng-required="vm.library.fileName == \'\' || vm.library.fileName == null" ng-maxlength="45"><div ng-show="editForm.fileName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.fileName.$error.required" data-translate="entity.validation.required"></p><p class="help-block" ng-show="editForm.fileName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p></div></div><div class="form-group" ng-if="vm.library.uploadFlg == 0"><label class="control-label" data-translate="library.dialog.edit.url">URL</label><input type="text" class="form-control" name="url" ng-model="vm.library.url" ng-required="vm.library.url == \'\' || vm.library.url == null" ng-maxlength="200"><div ng-show="editForm.url.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.url.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.url.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="library.dialog.url.comment">Comment</label><input type="text" class="form-control" name="comment" ng-model="vm.library.comment" ng-maxlength="45"><div ng-show="editForm.comment.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="library.dialog.edit.updateUser">Upload User</label><div class="form-control">{{vm.library.updateUser}}</div></div><div class="form-group"><label class="control-label" data-translate="library.dialog.edit.updateDate">Upload Date</label><div class="form-control">{{vm.library.updateDate}}</div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving || vm.groups.length == 0" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/system/script/library/upload/library-upload.html','<form name="uploadForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="library.dialog.upload.title">Create library by upload</h4></div><div class="row" style="margin: 10px"><div class="form-group"><div class="col-md-3 text-right"><label class="form-control-static" data-translate="library.home.groups">Group ID</label></div><div class="col-md-9"><select class="form-control" name="groupId" ng-model="vm.groupId" ng-options="group.groupId as group.groupName for group in vm.groups" ng-required="vm.groupId == \'\' || vm.groupId == null"></select><div ng-show="uploadForm.groupId.$invalid" class="has-error small"><p class="help-block" ng-show="uploadForm.groupId.$error.required" data-translate="entity.validation.selected">Need Selected</p></div></div></div></div><div class="form-group" style="margin: 10px" ng-show="vm.groupId != null && vm.groupId != \'\'"><div ngf-drop ngf-select ng-model="vm.files" class="drop-box" style="line-height: 20px; padding-top: 30px" ngf-drag-over-class="dragover" ngf-multiple="true" ngf-allow-dir="true" data-translate="library.dialog.upload.drop">Drop here.</div></div><div class="form-group" style="margin: 10px" ng-repeat="file in vm.totalFiles"><div class="row"><div class="col-md-4 text-right">{{file.fileName}}</div><div class="col-md-8"><span class="progressBar" ng-show="file.progress >= 0"><div class="bg-info" style="width:{{file.progress}}%" ng-bind="file.progress + \'%\'"></div></span></div></div></div></form>');
$templateCache.put('app/system/script/library/url/library-url.html','<form name="editForm" role="form" ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()">&times;</button><h4 class="modal-title" data-translate="library.dialog.url.title">Create library by url</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="library.home.groups">Group ID</label><select class="form-control" name="groupId" ng-model="vm.library.groupId" ng-required="vm.library.groupId == \'\' || vm.library.groupId == null"><option value=""></option><option ng-repeat="group in vm.groups" value="{{group.groupId}}" ng-selected="vm.library.groupId == group.groupId">{{group.groupName}}</option></select><div ng-show="editForm.groupId.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.groupId.$error.required" data-translate="entity.validation.selected">Need Selected</p></div></div><div class="form-group"><label class="control-label" data-translate="library.dialog.url.fileName">File Name</label><input type="text" class="form-control" name="fileName" ng-model="vm.library.fileName" ng-required="vm.library.fileName == \'\' || vm.library.fileName == null" ng-maxlength="45"><div ng-show="editForm.fileName.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.fileName.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fileName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">This field cannot be longer than 45 characters.</p></div></div><div class="form-group" ng-if="vm.library.id == \'\' || vm.library.id == null"><label class="control-label" data-translate="library.dialog.url.link">URL</label><input type="text" class="form-control" name="url" ng-model="vm.library.url" ng-required="vm.library.url == \'\' || vm.library.url == null" ng-maxlength="200"><div ng-show="editForm.url.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.url.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.url.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="library.dialog.url.comment">URL</label><input type="text" class="form-control" name="comment" ng-model="vm.library.comment" ng-maxlength="45"><div ng-show="editForm.comment.$invalid" class="has-error small"><p class="help-block" ng-show="editForm.comment.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="45">his field cannot be longer than 45 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.close()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');}]);})();